// @generated by tools/codegen from packages/i18n/{en,pt-BR}.json — do not edit by hand.

export type Locale = "en" | "pt-BR";
export const locales = ["en","pt-BR"] as const satisfies readonly Locale[];
export const defaultLocale: Locale = "en";

export type NoParams = Record<never, never>;
/**
 * A literal-only message (plain string), or a message pre-parsed by @formatjs/icu-messageformat-parser (an ICU AST for
 * intl-messageformat), so the runtime never parses ICU text.
 */
export type CompiledMessage = string | readonly object[];

/** Parameters per message key. */
export interface MessageParams {
  "app.name": NoParams;
  "common.cancel": NoParams;
  "common.save": NoParams;
  "common.delete": NoParams;
  "common.edit": NoParams;
  "common.close": NoParams;
  "common.loading": NoParams;
  "common.retry": NoParams;
  "primitive.badge.unread": { count: number };
  "primitive.iconButton.badgeCount": { count: number; label: string };
  "primitive.iconButton.badgeDot": { label: string };
  "primitive.chip.remove": { label: string };
  "primitive.select.placeholder": NoParams;
  "primitive.listRow.expand": NoParams;
  "primitive.listRow.collapse": NoParams;
  "usageMeter.value": { used: string; limit: string };
  "usageMeter.almostFull": NoParams;
  "usageMeter.full": NoParams;
  "usageMeter.noLimit": NoParams;
  "usageMeter.noLimitDetail": { detail: string };
  "editor.todo.done": NoParams;
  "shell.search.placeholder": NoParams;
  "shell.omnibox.placeholder": NoParams;
  "shell.newTab": NoParams;
  "shell.closeTab": NoParams;
  "shell.splitRight": NoParams;
  "shell.back": NoParams;
  "shell.forward": NoParams;
  "shell.toggleSidebar": NoParams;
  "shell.tabs.count": { count: number };
  "shell.views": NoParams;
  "shell.view.chat": NoParams;
  "shell.view.email": NoParams;
  "shell.view.docs": NoParams;
  "nav.home": NoParams;
  "tabTitle.channel": { name: string };
  "tabTitle.dm": { name: string };
  "nav.inbox": NoParams;
  "nav.projects": NoParams;
  "nav.agents": NoParams;
  "nav.channels": NoParams;
  "nav.directMessages": NoParams;
  "channel.composer.placeholder": { channel: string };
  "channel.composer.placeholderDm": { name: string };
  "channel.newDivider": NoParams;
  "channel.newMessages": { count: number };
  "channel.members": { count: number };
  "channel.empty.title": { channel: string };
  "channel.empty.body": NoParams;
  "message.edited": NoParams;
  "message.deleted": NoParams;
  "message.unsupportedContent": NoParams;
  "message.replies": { count: number };
  "message.addReaction": NoParams;
  "message.reply": NoParams;
  "message.more": NoParams;
  "reaction.added": { emoji: string };
  "reaction.removed": { emoji: string };
  "reaction.who.you": { emoji: string };
  "reaction.who.youAndOne": { name: string; emoji: string };
  "reaction.who.youAndMany": { count: number; name: string; emoji: string };
  "reaction.who.one": { name: string; emoji: string };
  "reaction.who.two": { a: string; b: string; emoji: string };
  "reaction.who.many": { count: number; a: string; b: string; emoji: string };
  "reaction.who.count": { count: number; emoji: string };
  "typing.one": { name: string };
  "typing.two": { a: string; b: string };
  "typing.many": NoParams;
  "agent.state.idle": NoParams;
  "agent.state.working": NoParams;
  "agent.state.waiting": NoParams;
  "agent.state.error": NoParams;
  "agent.state.offline": NoParams;
  "agent.status": { name: string; state: string };
  "agent.badge": NoParams;
  "message.appBadge": NoParams;
  "time.today": NoParams;
  "time.yesterday": NoParams;
  "time.justNow": NoParams;
  "auth.signIn": NoParams;
  "auth.email": NoParams;
  "auth.sendCode": NoParams;
  "nav.starred": NoParams;
  "nav.activity": NoParams;
  "nav.unreads": NoParams;
  "nav.search": NoParams;
  "shell.newTabInSplit": NoParams;
  "shell.openInNewTab": NoParams;
  "shell.closePane": NoParams;
  "shell.pinTab": NoParams;
  "shell.unpinTab": NoParams;
  "shell.omnibox.channels": NoParams;
  "shell.omnibox.people": NoParams;
  "shell.omnibox.agents": NoParams;
  "shell.omnibox.commands": NoParams;
  "shell.omnibox.noResults": NoParams;
  "shell.omnibox.hint": NoParams;
  "shell.tabs.search": NoParams;
  "shell.tabs.searchPlaceholder": NoParams;
  "shell.tabs.open": NoParams;
  "shell.tabs.pinned": NoParams;
  "shell.tabs.ungrouped": NoParams;
  "shell.tab.duplicate": NoParams;
  "shell.tab.closeOthers": NoParams;
  "shell.tab.closeRight": NoParams;
  "shell.tab.closeSelected": { count: number };
  "shell.tab.moveToWindow": NoParams;
  "shell.tab.copyLink": NoParams;
  "shell.tab.addToNewGroup": NoParams;
  "shell.tab.addToGroup": NoParams;
  "shell.tab.removeFromGroup": NoParams;
  "shell.tab.reopenClosed": NoParams;
  "shell.split.separate": NoParams;
  "shell.split.swap": NoParams;
  "shell.split.close": NoParams;
  "shell.split.closeSide": { title: string };
  "shell.split.moveToNewTab": NoParams;
  "shell.split.dropHint": NoParams;
  "shell.group.namePlaceholder": NoParams;
  "shell.group.unnamed": NoParams;
  "shell.group.edit": NoParams;
  "shell.group.collapse": NoParams;
  "shell.group.expand": NoParams;
  "shell.group.newTab": NoParams;
  "shell.group.ungroup": NoParams;
  "shell.group.close": NoParams;
  "agent.statusLine.working": { name: string };
  "agent.statusLine.activity": { name: string; activity: string };
  "agent.statusLine.waiting": { name: string };
  "agent.statusLine.error": { name: string };
  "agent.sponsor": { name: string };
  "agent.runtime.hosted": NoParams;
  "agent.runtime.external": NoParams;
  "agent.message": NoParams;
  "agents.title": NoParams;
  "agents.subtitle": NoParams;
  "agents.empty": NoParams;
  "agent.create.title": NoParams;
  "agent.create.name": NoParams;
  "agent.create.description": NoParams;
  "agent.create.runtime": NoParams;
  "agent.create.submit": NoParams;
  "agent.create.tokenNotice": NoParams;
  "guest.badge": NoParams;
  "guest.badgeOrg": { org: string };
  "channel.externalBanner": NoParams;
  "channel.externalBannerOrgs": { orgs: string };
  "channel.huddle": NoParams;
  "channel.settings": NoParams;
  "channel.loadingOlder": NoParams;
  "channel.newMessagesJump": { count: number };
  "composer.mention": NoParams;
  "composer.attach": NoParams;
  "composer.emoji": NoParams;
  "composer.format": NoParams;
  "composer.format.bold": NoParams;
  "composer.format.italic": NoParams;
  "composer.format.strike": NoParams;
  "composer.format.link": NoParams;
  "composer.format.orderedList": NoParams;
  "composer.format.bulletList": NoParams;
  "composer.format.quote": NoParams;
  "composer.format.code": NoParams;
  "composer.format.codeBlock": NoParams;
  "composer.format.show": NoParams;
  "composer.format.hide": NoParams;
  "composer.send": NoParams;
  "composer.placeholderThread": NoParams;
  "composer.autocomplete.people": NoParams;
  "composer.autocomplete.channels": NoParams;
  "composer.autocomplete.emoji": NoParams;
  "composer.autocomplete.commands": NoParams;
  "composer.autocomplete.empty": { query: string };
  "composer.autocomplete.none": NoParams;
  "composer.broadcast.here": NoParams;
  "composer.broadcast.channel": NoParams;
  "composer.broadcast.everyone": NoParams;
  "composer.command.remind.description": NoParams;
  "composer.command.remind.usage": NoParams;
  "composer.command.status.description": NoParams;
  "composer.command.status.usage": NoParams;
  "composer.command.invite.description": NoParams;
  "composer.command.invite.usage": NoParams;
  "composer.command.mute.description": NoParams;
  "composer.command.mute.usage": NoParams;
  "composer.command.task.description": NoParams;
  "composer.command.task.usage": NoParams;
  "composer.command.page.description": NoParams;
  "composer.command.page.usage": NoParams;
  "composer.command.huddle.description": NoParams;
  "message.sending": NoParams;
  "message.failed": NoParams;
  "message.retry": NoParams;
  "message.discard": NoParams;
  "message.viewThread": NoParams;
  "message.lastReply": { time: string };
  "message.repliedToThread": { preview: string };
  "message.repliedToThreadNoPreview": NoParams;
  "thread.title": NoParams;
  "thread.in": { channel: string };
  "thread.inDm": { name: string };
  "thread.alsoSendChannel": { channel: string };
  "thread.alsoSendDm": NoParams;
  "thread.alsoSentChannel": { channel: string };
  "thread.alsoSentDm": NoParams;
  "home.greeting": { workspace: string };
  "home.subtitle": NoParams;
  "home.channels": NoParams;
  "home.directMessages": NoParams;
  "home.agents": NoParams;
  "home.unread": { count: number };
  "home.allCaughtUp": NoParams;
  "home.greetingMorning": { name: string };
  "home.greetingAfternoon": { name: string };
  "home.greetingEvening": { name: string };
  "home.unreads": NoParams;
  "home.today": NoParams;
  "home.tomorrow": NoParams;
  "home.noMoreEvents": NoParams;
  "home.now": NoParams;
  "home.join": NoParams;
  "home.openCalendar": NoParams;
  "home.email": NoParams;
  "home.openMail": NoParams;
  "home.needsReply": NoParams;
  "home.moreFaces": { count: string };
  "home.briefing.needsYou": { count: number };
  "home.briefing.live": { title: string };
  "home.briefing.startsIn": { title: string; minutes: string };
  "home.briefing.nextAt": { title: string; time: string };
  "home.briefing.chat": NoParams;
  "home.briefing.work": NoParams;
  "home.briefing.reply": NoParams;
  "home.briefing.respond": NoParams;
  "home.briefing.review": NoParams;
  "home.briefing.noMeetings": NoParams;
  "home.briefing.caughtUpTitle": NoParams;
  "home.briefing.caughtUpBody": NoParams;
  "home.briefing.nothingNeedsYou": NoParams;
  "home.briefing.invitedBy": { name: string };
  "home.briefing.waitingApproval": NoParams;
  "home.briefing.more": { count: string };
  "search.title": NoParams;
  "search.placeholder": NoParams;
  "search.comingSoon": NoParams;
  "search.hint": NoParams;
  "search.empty": { query: string };
  "search.error": NoParams;
  "search.unresolved": { filters: string };
  "search.inThread": NoParams;
  "search.resultCount": { count: number };
  "search.suggest.filters": NoParams;
  "search.suggest.people": NoParams;
  "search.suggest.conversations": NoParams;
  "search.suggest.values": NoParams;
  "search.suggest.exclude": NoParams;
  "search.filter.from": NoParams;
  "search.filter.in": NoParams;
  "search.filter.with": NoParams;
  "search.filter.has": NoParams;
  "search.filter.is": NoParams;
  "search.filter.before": NoParams;
  "search.filter.after": NoParams;
  "search.filter.on": NoParams;
  "search.filter.during": NoParams;
  "search.filter.notFrom": NoParams;
  "search.filter.notIn": NoParams;
  "search.filter.notWith": NoParams;
  "search.filter.notHas": NoParams;
  "search.value.link": NoParams;
  "search.value.file": NoParams;
  "search.value.pin": NoParams;
  "search.value.reaction": NoParams;
  "search.value.thread": NoParams;
  "search.value.today": NoParams;
  "search.value.yesterday": NoParams;
  "search.value.thisMonth": NoParams;
  "search.value.lastMonth": NoParams;
  "search.value.thisYear": NoParams;
  "search.value.lastYear": NoParams;
  "search.value.saved": NoParams;
  "search.value.pickDate": NoParams;
  "search.value.pickMonth": NoParams;
  "search.date.title": NoParams;
  "search.date.on": NoParams;
  "search.date.before": NoParams;
  "search.date.after": NoParams;
  "search.date.during": NoParams;
  "search.date.wholeMonth": NoParams;
  "search.date.apply": NoParams;
  "message.copyLink": NoParams;
  "message.linkCopied": NoParams;
  "message.code.copy": NoParams;
  "message.code.copied": NoParams;
  "message.pin": NoParams;
  "message.unpin": NoParams;
  "message.pinnedBy": { name: string };
  "message.markUnread": NoParams;
  "message.share": NoParams;
  "message.shared.dm": NoParams;
  "message.shared.someone": NoParams;
  "message.shared.postedIn": { where: string; when: string };
  "message.shared.view": NoParams;
  "share.title": NoParams;
  "share.to": NoParams;
  "share.search": NoParams;
  "share.comment": NoParams;
  "share.send": NoParams;
  "share.failed": NoParams;
  "share.empty": NoParams;
  "share.done": NoParams;
  "beta.banner.title": NoParams;
  "beta.banner.message": NoParams;
  "beta.banner.messageShort": NoParams;
  "beta.banner.whatsNew": NoParams;
  "beta.banner.feedback": NoParams;
  "beta.banner.dismiss": NoParams;
  "beta.label": NoParams;
  "beta.label.open": NoParams;
  "bookmarks.add": NoParams;
  "bookmarks.edit": NoParams;
  "bookmarks.remove": NoParams;
  "bookmarks.link": NoParams;
  "bookmarks.name": NoParams;
  "bookmarks.namePlaceholder": NoParams;
  "bookmarks.save": NoParams;
  "bookmarks.badUrl": NoParams;
  "bookmarks.failed": NoParams;
  "bookmarks.bar": NoParams;
  "bookmarks.more": NoParams;
  "bookmarks.addLink": NoParams;
  "bookmarks.addFolder": NoParams;
  "bookmarks.editFolder": NoParams;
  "bookmarks.addFile": NoParams;
  "bookmarks.addPage": NoParams;
  "bookmarks.folderName": NoParams;
  "bookmarks.nameNeeded": NoParams;
  "bookmarks.searchFiles": NoParams;
  "bookmarks.searchPages": NoParams;
  "bookmarks.noFiles": NoParams;
  "bookmarks.noPages": NoParams;
  "bookmarks.pickFailed": NoParams;
  "bookmarks.moveTo": { folder: string };
  "bookmarks.moveOut": NoParams;
  "bookmarks.emptyFolder": NoParams;
  "bookmarks.removeFolder": NoParams;
  "bookmarks.addToFolder": NoParams;
  "bookmarks.moveLeft": NoParams;
  "bookmarks.moveRight": NoParams;
  "bookmarks.reorder": NoParams;
  "channel.pins.open": NoParams;
  "channel.pins.title": NoParams;
  "channel.pins.empty": NoParams;
  "channel.pins.error": NoParams;
  "channel.pins.jump": NoParams;
  "activity.title": NoParams;
  "activity.empty": NoParams;
  "activity.memberJoined": { name: string; domain: string };
  "activity.memberJoined.someone": { domain: string };
  "activity.adminEmpty": NoParams;
  "activity.failed": NoParams;
  "activity.retry": NoParams;
  "activity.mention": { name: string; channel: string };
  "activity.mention.someone": { channel: string };
  "activity.broadcast": { name: string; range: string; channel: string };
  "activity.broadcast.someone": { range: string; channel: string };
  "activity.threadReply": { name: string; channel: string };
  "activity.threadReply.dm": { name: string };
  "activity.threadReply.others": { count: number; name: string; channel: string };
  "activity.threadReply.others.dm": { count: number; name: string };
  "activity.reaction": { name: string; emoji: string };
  "activity.reaction.others": { count: number; name: string; emoji: string };
  "activity.channelAdded": { name: string; channel: string };
  "activity.channelAdded.someone": { channel: string };
  "activity.filter.all": NoParams;
  "activity.filter.mentions": NoParams;
  "activity.filter.threads": NoParams;
  "activity.filter.reactions": NoParams;
  "activity.filters": NoParams;
  "activity.markAllRead": NoParams;
  "activity.unread": NoParams;
  "activity.filteredEmpty": NoParams;
  "activity.reminder": NoParams;
  "activity.eventReminder": NoParams;
  "activity.eventInvited": { name: string };
  "activity.eventInvited.someone": NoParams;
  "activity.eventChanged": { name: string };
  "activity.eventChanged.someone": NoParams;
  "activity.eventCancelled": { name: string };
  "activity.eventCancelled.someone": NoParams;
  "nav.later": NoParams;
  "later.title": NoParams;
  "later.tabs": NoParams;
  "later.tab.inProgress": NoParams;
  "later.tab.archived": NoParams;
  "later.tab.completed": NoParams;
  "later.empty.inProgress": NoParams;
  "later.empty.archived": NoParams;
  "later.empty.completed": NoParams;
  "later.complete": NoParams;
  "later.moveToInProgress": NoParams;
  "later.archive": NoParams;
  "later.remove": NoParams;
  "later.more": NoParams;
  "later.remind": NoParams;
  "later.reminder.clear": NoParams;
  "later.due": { time: string };
  "later.overdue": { time: string };
  "later.textReminder": NoParams;
  "later.repeats": NoParams;
  "later.stopRepeat": NoParams;
  "later.fromPerson": { name: string };
  "later.forConversation": { conversation: string };
  "later.messageGone": NoParams;
  "later.failed": NoParams;
  "later.retry": NoParams;
  "later.saved": NoParams;
  "later.removed": NoParams;
  "later.completed": NoParams;
  "message.saveForLater": NoParams;
  "message.removeFromLater": NoParams;
  "message.remindMe": NoParams;
  "remind.title": NoParams;
  "remind.preset.in20m": NoParams;
  "remind.preset.in1h": NoParams;
  "remind.preset.in3h": NoParams;
  "remind.preset.tomorrow": NoParams;
  "remind.preset.nextWeek": NoParams;
  "remind.custom": NoParams;
  "remind.date": NoParams;
  "remind.time": NoParams;
  "remind.set": NoParams;
  "remind.done": { when: string };
  "remind.failed": NoParams;
  "composer.remind.done": { text: string; when: string };
  "composer.remind.doneFor": { who: string; text: string; when: string };
  "composer.remind.doneRepeat": { who: string; text: string; when: string };
  "composer.remind.you": NoParams;
  "composer.remind.usage": NoParams;
  "composer.remind.target": NoParams;
  "composer.remind.past": NoParams;
  "composer.remind.failed": NoParams;
  "nav.scheduled": NoParams;
  "schedule.title": NoParams;
  "schedule.menu": NoParams;
  "schedule.tomorrow": { time: string };
  "schedule.monday": { time: string };
  "schedule.custom": NoParams;
  "schedule.set": NoParams;
  "schedule.done": { when: string };
  "schedule.past": NoParams;
  "schedule.tooFar": NoParams;
  "schedule.failed": NoParams;
  "scheduled.bar": { count: number };
  "scheduled.seeAll": NoParams;
  "scheduled.title": NoParams;
  "scheduled.empty": NoParams;
  "nav.drafts": NoParams;
  "drafts.title": NoParams;
  "drafts.tab.drafts": NoParams;
  "drafts.tab.scheduled": NoParams;
  "drafts.tab.sent": NoParams;
  "drafts.empty": NoParams;
  "drafts.sentEmpty": NoParams;
  "drafts.failed": NoParams;
  "drafts.sentFailed": NoParams;
  "drafts.delete": NoParams;
  "drafts.inThread": { conversation: string };
  "drafts.empty.title": NoParams;
  "drafts.sentEmpty.title": NoParams;
  "drafts.scheduledEmpty.title": NoParams;
  "drafts.scheduledEmpty.body": NoParams;
  "drafts.edit": NoParams;
  "drafts.open": NoParams;
  "drafts.deleteConfirm.title": NoParams;
  "drafts.deleteConfirm.body": NoParams;
  "scheduled.sendsAt": { when: string };
  "scheduled.notSent": NoParams;
  "scheduled.inThread": NoParams;
  "scheduled.edit": NoParams;
  "scheduled.reschedule": NoParams;
  "scheduled.sendNow": NoParams;
  "scheduled.cancel": NoParams;
  "scheduled.save": NoParams;
  "scheduled.failed": NoParams;
  "scheduled.more": NoParams;
  "scheduled.files": { count: number };
  "shortcuts.title": NoParams;
  "shortcuts.omnibox": NoParams;
  "shortcuts.prev": NoParams;
  "shortcuts.next": NoParams;
  "shortcuts.prevUnread": NoParams;
  "shortcuts.nextUnread": NoParams;
  "shortcuts.markRead": NoParams;
  "shortcuts.allUnreads": NoParams;
  "shortcuts.editLast": NoParams;
  "shortcuts.newTab": NoParams;
  "shortcuts.closeTab": NoParams;
  "shortcuts.tabSearch": NoParams;
  "shortcuts.split": NoParams;
  "shortcuts.swapSplit": NoParams;
  "shortcuts.back": NoParams;
  "shortcuts.forward": NoParams;
  "shortcuts.sidebar": NoParams;
  "shortcuts.views": NoParams;
  "shortcuts.help": NoParams;
  "shortcuts.mail.title": NoParams;
  "shortcuts.mail.compose": NoParams;
  "shortcuts.mail.search": NoParams;
  "shortcuts.mail.next": NoParams;
  "shortcuts.mail.prev": NoParams;
  "shortcuts.mail.open": NoParams;
  "shortcuts.mail.archive": NoParams;
  "shortcuts.mail.trash": NoParams;
  "shortcuts.mail.spam": NoParams;
  "shortcuts.mail.star": NoParams;
  "shortcuts.mail.priority": NoParams;
  "shortcuts.mail.notPriority": NoParams;
  "shortcuts.mail.select": NoParams;
  "shortcuts.mail.markRead": NoParams;
  "shortcuts.mail.markUnread": NoParams;
  "shortcuts.mail.reply": NoParams;
  "shortcuts.mail.replyAll": NoParams;
  "shortcuts.mail.forward": NoParams;
  "unreads.empty": NoParams;
  "unreads.markAllRead": NoParams;
  "unreads.markRead": NoParams;
  "unreads.more": { count: number };
  "unreads.new": { count: number };
  "unreads.mentions": { count: number };
  "huddle.title": NoParams;
  "huddle.comingSoon": NoParams;
  "huddle.join": NoParams;
  "huddle.joinHuddle": NoParams;
  "huddle.inHuddle": NoParams;
  "huddle.start": NoParams;
  "huddle.leave": NoParams;
  "huddle.mute": NoParams;
  "huddle.unmute": NoParams;
  "huddle.videoOn": NoParams;
  "huddle.videoOff": NoParams;
  "huddle.shareScreen": NoParams;
  "huddle.stopSharing": NoParams;
  "huddle.raiseHand": NoParams;
  "huddle.lowerHand": NoParams;
  "huddle.react": NoParams;
  "huddle.effects": NoParams;
  "huddle.effects.emoji": NoParams;
  "huddle.effects.themes": NoParams;
  "huddle.theme.none": NoParams;
  "huddle.theme.sunrise": NoParams;
  "huddle.theme.ocean": NoParams;
  "huddle.theme.forest": NoParams;
  "huddle.theme.galaxy": NoParams;
  "huddle.theme.party": NoParams;
  "huddle.settings": NoParams;
  "huddle.openWindow": NoParams;
  "huddle.openInBrowser": NoParams;
  "huddle.browserOnly": NoParams;
  "huddle.status.joining": NoParams;
  "huddle.status.connecting": NoParams;
  "huddle.status.reconnecting": NoParams;
  "huddle.status.leaving": NoParams;
  "huddle.participants": { count: number };
  "huddle.youName": { name: string };
  "huddle.sharingScreen": { name: string };
  "huddle.youAreSharing": NoParams;
  "huddle.handRaised": NoParams;
  "huddle.muted": NoParams;
  "huddle.mediaUnavailable": NoParams;
  "huddle.waiting": NoParams;
  "huddle.invite.open": NoParams;
  "huddle.invite.title": NoParams;
  "huddle.invite.search": NoParams;
  "huddle.invite.ring": { count: number };
  "huddle.invite.none": NoParams;
  "huddle.invite.empty": NoParams;
  "huddle.invite.loadFailed": NoParams;
  "huddle.invite.failed": NoParams;
  "huddle.invite.rang": { count: number };
  "huddle.declined": { name: string };
  "huddle.recording.you": NoParams;
  "huddle.recording.other": { name: string };
  "huddle.recording.start": NoParams;
  "huddle.recording.stop": NoParams;
  "huddle.recording.indicator": NoParams;
  "huddle.recording.consent": NoParams;
  "huddle.recording.saving": NoParams;
  "huddle.recording.saved": NoParams;
  "huddle.transcript.on": NoParams;
  "huddle.transcript.about": NoParams;
  "huddle.transcript.title": NoParams;
  "huddle.transcript.body": NoParams;
  "huddle.transcript.admin": NoParams;
  "huddle.transcript.muted": NoParams;
  "huddle.transcript.notice": NoParams;
  "huddle.recording.consentLink": NoParams;
  "huddle.recording.savedLink": NoParams;
  "huddle.recording.failed": NoParams;
  "huddle.recording.unsupported": NoParams;
  "huddle.captions.on": NoParams;
  "huddle.captions.off": NoParams;
  "huddle.captions.label": NoParams;
  "huddle.captions.unsupported": NoParams;
  "huddle.captions.listening": NoParams;
  "huddle.captions.note.device": NoParams;
  "huddle.captions.note.preparing": { percent: string };
  "huddle.captions.note.notDownloaded": NoParams;
  "huddle.captions.note.unsupported": NoParams;
  "huddle.captions.note.language": NoParams;
  "huddle.captions.note.lowStorage": { size: string };
  "huddle.captions.note.failed": NoParams;
  "huddle.captions.note.off": NoParams;
  "huddle.captions.note.none": NoParams;
  "huddle.draw.start": NoParams;
  "huddle.draw.stop": NoParams;
  "huddle.draw.pen": NoParams;
  "huddle.draw.eraser": NoParams;
  "huddle.recap.title": NoParams;
  "huddle.recap.live": NoParams;
  "huddle.recap.short": NoParams;
  "huddle.recap.minutes": { minutes: string };
  "huddle.recap.hours": { hours: string; minutes: string };
  "huddle.recap.notes": NoParams;
  "huddle.recap.summary": NoParams;
  "huddle.recap.actionItems": NoParams;
  "huddle.recap.decisions": NoParams;
  "huddle.recap.transcript": NoParams;
  "huddle.recap.showTranscript": NoParams;
  "huddle.recap.hideTranscript": NoParams;
  "huddle.recap.notesPending": NoParams;
  "huddle.recap.aiNotice": NoParams;
  "huddle.recap.noTranscript": NoParams;
  "huddle.missed.title": NoParams;
  "huddle.missed.caller": { name: string };
  "huddle.missed.callBack": NoParams;
  "huddle.incoming.label": NoParams;
  "huddle.incoming.join": NoParams;
  "huddle.incoming.decline": NoParams;
  "huddle.ring.micOn": NoParams;
  "huddle.ring.micOff": NoParams;
  "huddle.ring.cameraOn": NoParams;
  "huddle.ring.cameraOff": NoParams;
  "huddle.ring.declineWithMessage": NoParams;
  "huddle.ring.close": NoParams;
  "huddle.ring.windowLabel": { workspace: string };
  "huddle.ring.windowTitle": NoParams;
  "thread.follow.on": NoParams;
  "thread.follow.off": NoParams;
  "thread.follow.following": NoParams;
  "thread.follow.notFollowing": NoParams;
  "richtext.privateChannel": NoParams;
  "huddle.idle.title": NoParams;
  "huddle.idle.body": NoParams;
  "huddle.idle.linkBody": NoParams;
  "huddle.idle.active": { name: string };
  "huddle.summary.justYou": NoParams;
  "huddle.summary.count": { count: number };
  "huddle.summary.one": { name: string };
  "huddle.summary.two": { a: string; b: string };
  "huddle.summary.many": { a: string; count: string };
  "huddle.error.forbidden": NoParams;
  "huddle.error.notFound": NoParams;
  "huddle.error.network": NoParams;
  "huddle.error.ended": NoParams;
  "huddle.error.micDenied": NoParams;
  "huddle.error.cameraDenied": NoParams;
  "huddle.error.micDeniedApp": NoParams;
  "huddle.error.cameraDeniedApp": NoParams;
  "huddle.error.screenDenied": NoParams;
  "huddle.error.media": NoParams;
  "huddle.settings.audio": NoParams;
  "huddle.settings.video": NoParams;
  "huddle.settings.microphone": NoParams;
  "huddle.settings.speaker": NoParams;
  "huddle.settings.camera": NoParams;
  "huddle.settings.noDevices": NoParams;
  "huddle.settings.inputLevel": NoParams;
  "huddle.settings.testSpeaker": NoParams;
  "huddle.settings.noiseSuppression": NoParams;
  "huddle.settings.noise.off": NoParams;
  "huddle.settings.noise.standard": NoParams;
  "huddle.settings.noise.strong": NoParams;
  "huddle.settings.noise.hint": NoParams;
  "huddle.settings.echoCancellation": NoParams;
  "huddle.settings.autoGain": NoParams;
  "huddle.settings.background": NoParams;
  "huddle.settings.uploadBackground": NoParams;
  "huddle.settings.mirror": NoParams;
  "huddle.settings.joining": NoParams;
  "huddle.settings.joinMicOff": NoParams;
  "huddle.settings.joinCameraOff": NoParams;
  "huddle.settings.captions": NoParams;
  "huddle.settings.captionsOnDevice": NoParams;
  "huddle.settings.captionsOnDevice.hint": NoParams;
  "huddle.settings.speechModel": NoParams;
  "huddle.settings.speechModel.system": NoParams;
  "huddle.settings.speechModel.downloading": { percent: string };
  "huddle.settings.speechModel.web": { size: string };
  "huddle.settings.speechModel.android": { size: string };
  "huddle.settings.speechModel.ready": { size: string };
  "huddle.settings.captionsDeviceOnly": NoParams;
  "huddle.settings.cameraOff": NoParams;
  "huddle.settings.previewCamera": NoParams;
  "huddle.settings.effectsUnsupported": NoParams;
  "huddle.background.none": NoParams;
  "huddle.background.blurLight": NoParams;
  "huddle.background.blurStrong": NoParams;
  "huddle.background.image.dusk": NoParams;
  "huddle.background.image.paper": NoParams;
  "huddle.background.image.studio": NoParams;
  "huddle.background.custom": NoParams;
  "huddle.device.microphone": { n: string };
  "huddle.device.camera": { n: string };
  "huddle.device.speaker": { n: string };
  "huddle.lobby.one": { name: string };
  "huddle.lobby.many": { name: string; count: string };
  "huddle.lobby.admit": NoParams;
  "huddle.lobby.deny": NoParams;
  "huddle.lobby.admitAll": NoParams;
  "huddle.external": NoParams;
  "huddle.moderate.mute": NoParams;
  "huddle.moderate.remove": NoParams;
  "huddle.moderate.end": NoParams;
  "huddle.moderate.more": NoParams;
  "huddle.share.link": NoParams;
  "huddle.share.copy": NoParams;
  "huddle.share.copied": NoParams;
  "huddle.meeting.lock": NoParams;
  "huddle.meeting.unlock": NoParams;
  "huddle.meeting.openToAll": NoParams;
  "huddle.meeting.locked": NoParams;
  "huddle.chat.title": NoParams;
  "huddle.chat.open": NoParams;
  "huddle.chat.placeholder": NoParams;
  "huddle.chat.empty": NoParams;
  "huddle.chat.send": NoParams;
  "meeting.new.title": NoParams;
  "meeting.new.name": NoParams;
  "meeting.new.namePlaceholder": NoParams;
  "meeting.new.conversation": NoParams;
  "meeting.new.noConversation": NoParams;
  "meeting.new.now": NoParams;
  "meeting.new.later": NoParams;
  "meeting.new.time": NoParams;
  "meeting.new.create": NoParams;
  "meeting.new.ready": NoParams;
  "meeting.new.start": NoParams;
  "meeting.new.error": NoParams;
  "meeting.page.hostedBy": { name: string };
  "meeting.page.huddleWith": { name: string };
  "meeting.page.scheduled": { time: string };
  "meeting.page.live": NoParams;
  "meeting.page.yourName": NoParams;
  "meeting.page.namePlaceholder": NoParams;
  "meeting.page.join": NoParams;
  "meeting.page.askToJoin": NoParams;
  "meeting.page.joiningAs": { name: string };
  "meeting.page.waiting": NoParams;
  "meeting.page.denied": NoParams;
  "meeting.page.removed": NoParams;
  "meeting.page.ended": NoParams;
  "meeting.page.left": NoParams;
  "meeting.page.rejoin": NoParams;
  "meeting.page.unavailable": NoParams;
  "meeting.page.locked": NoParams;
  "meeting.page.challengeFailed": NoParams;
  "meeting.page.openInApp": NoParams;
  "meeting.page.noApp": NoParams;
  "meeting.page.downloadApp": NoParams;
  "meeting.page.choice.app": NoParams;
  "meeting.page.choice.browser": NoParams;
  "meeting.page.choice.store.appStore": NoParams;
  "meeting.page.choice.store.testflight": NoParams;
  "meeting.page.choice.store.play": NoParams;
  "meeting.page.choice.store.apk": NoParams;
  "meeting.page.choice.getTitle": NoParams;
  "meeting.page.choice.getBody": NoParams;
  "meeting.page.choice.get.appStore": NoParams;
  "meeting.page.choice.get.testflight": NoParams;
  "meeting.page.choice.get.play": NoParams;
  "meeting.page.choice.get.apk": NoParams;
  "meeting.page.choice.haveIt": NoParams;
  "meeting.page.choice.openApp": NoParams;
  "meeting.page.privacy": NoParams;
  "meeting.page.error": NoParams;
  "page.comingSoon": NoParams;
  "auth.title": NoParams;
  "auth.subtitle": NoParams;
  "auth.name": NoParams;
  "auth.continue": NoParams;
  "auth.signingIn": NoParams;
  "auth.error": NoParams;
  "auth.mock": NoParams;
  "auth.signOut": NoParams;
  "profile.language": NoParams;
  "profile.theme": NoParams;
  "profile.theme.system": NoParams;
  "profile.theme.light": NoParams;
  "profile.theme.dark": NoParams;
  "connection.reconnecting": NoParams;
  "offline.banner": NoParams;
  "offline.bannerNoCache": NoParams;
  "offline.bannerQueued": { count: number };
  "offline.sending": { count: number };
  "message.queued": NoParams;
  "invite.guest.title": NoParams;
  "invite.guest.action": NoParams;
  "invite.guest.email": NoParams;
  "invite.guest.name": NoParams;
  "invite.guest.organization": NoParams;
  "invite.guest.channels": NoParams;
  "invite.guest.expiry": NoParams;
  "invite.guest.expiry.never": NoParams;
  "invite.guest.expiry.days": { count: number };
  "invite.guest.submit": NoParams;
  "invite.guest.sent": { email: string };
  "invite.guest.notice": NoParams;
  "channel.create": NoParams;
  "channelMembers.search": NoParams;
  "channelMembers.add": NoParams;
  "channelMembers.addSearch": NoParams;
  "channelMembers.addSubmit": { count: number };
  "channelMembers.addNone": NoParams;
  "channelMembers.remove": NoParams;
  "channelMembers.you": NoParams;
  "channelMembers.role.owner": NoParams;
  "channelMembers.role.admin": NoParams;
  "channelMembers.role.guest": NoParams;
  "channelMembers.sponsor": { name: string };
  "channelMembers.empty": NoParams;
  "channelMembers.everyone": NoParams;
  "channelMembers.offline": NoParams;
  "channelMembers.failed": NoParams;
  "channelMembers.addFailed": NoParams;
  "channelMembers.removeFailed": { name: string };
  "sidebar.folder.name": { name: string };
  "sidebar.folder.new": NoParams;
  "sidebar.folder.createSubmit": NoParams;
  "sidebar.folder.edit": NoParams;
  "sidebar.folder.nameLabel": NoParams;
  "sidebar.folder.namePlaceholder": NoParams;
  "sidebar.folder.nameRequired": NoParams;
  "sidebar.folder.nameTooLong": { max: number };
  "sidebar.folder.look": NoParams;
  "sidebar.folder.emojiSearch": NoParams;
  "sidebar.folder.useIcon": NoParams;
  "sidebar.folder.options": NoParams;
  "sidebar.folder.delete": NoParams;
  "sidebar.folder.moveUp": NoParams;
  "sidebar.folder.moveDown": NoParams;
  "sidebar.folder.empty": NoParams;
  "sidebar.row.move": NoParams;
  "sidebar.move.title": { name: string };
  "sidebar.move.newFolder": NoParams;
  "sidebar.move.toTree": NoParams;
  "channels.name.required": NoParams;
  "channels.name.tooLong": { max: number };
  "channels.name.taken": { name: string };
  "channels.name.willBe": { name: string };
  "channels.create.title": NoParams;
  "channels.create.name": NoParams;
  "channels.create.namePlaceholder": NoParams;
  "channels.create.description": NoParams;
  "channels.create.descriptionPlaceholder": NoParams;
  "channels.create.private": NoParams;
  "channels.create.privateHint": NoParams;
  "channels.create.publicHint": NoParams;
  "channels.create.members": NoParams;
  "channels.create.removeMember": { name: string };
  "channels.create.membersSearch": NoParams;
  "channels.create.membersNone": NoParams;
  "channels.create.submit": NoParams;
  "channels.create.forbidden": NoParams;
  "channels.browse.title": NoParams;
  "channels.browse.search": NoParams;
  "channels.browse.filter.all": NoParams;
  "channels.browse.filter.joined": NoParams;
  "channels.browse.filter.other": NoParams;
  "channels.browse.filter.archived": NoParams;
  "channels.browse.empty": NoParams;
  "channels.browse.joined": NoParams;
  "channels.browse.join": NoParams;
  "channels.browse.leave": NoParams;
  "channels.join.prompt": { channel: string };
  "channels.join.button": NoParams;
  "channels.join.failed": NoParams;
  "channels.join.offline": NoParams;
  "channels.leave.failed": NoParams;
  "channels.archived.banner": NoParams;
  "channels.settings.topic": NoParams;
  "channels.settings.topicPlaceholder": NoParams;
  "channels.settings.notifications": NoParams;
  "channels.settings.mute": NoParams;
  "channels.settings.notify.default": NoParams;
  "channels.settings.notify.all": NoParams;
  "channels.settings.notify.mentions": NoParams;
  "channels.settings.notify.none": NoParams;
  "channels.settings.notify.set.default": NoParams;
  "channels.settings.notify.set.all": NoParams;
  "channels.settings.notify.set.mentions": NoParams;
  "channels.settings.notify.set.none": NoParams;
  "channels.settings.muted": NoParams;
  "channels.settings.unmuted": NoParams;
  "channels.settings.makePrivate": NoParams;
  "channels.settings.makePublic": NoParams;
  "channels.settings.makePrivateHint": NoParams;
  "channels.settings.makePublicHint": NoParams;
  "channels.settings.archive": NoParams;
  "channels.settings.unarchive": NoParams;
  "channels.settings.archiveHint": NoParams;
  "channels.settings.leave": NoParams;
  "channels.details.about": NoParams;
  "channels.details.members": NoParams;
  "channels.details.settings": NoParams;
  "channels.settings.created": NoParams;
  "channels.settings.createdBy": { name: string; date: string };
  "channels.settings.saved": NoParams;
  "channels.settings.failed": NoParams;
  "sidebar.channels.add": NoParams;
  "sidebar.row.star": NoParams;
  "sidebar.row.unstar": NoParams;
  "sidebar.row.mute": NoParams;
  "sidebar.row.unmute": NoParams;
  "sidebar.row.leave": NoParams;
  "common.error": NoParams;
  "language.en": NoParams;
  "language.ptBR": NoParams;
  "desktopAuth.title": NoParams;
  "desktopAuth.signedInAs": { name: string; email: string };
  "desktopAuth.device": { device: string };
  "desktopAuth.open": NoParams;
  "desktopAuth.switchAccount": NoParams;
  "desktopAuth.redirected": NoParams;
  "desktopAuth.redirectedBody": NoParams;
  "desktopAuth.copyCode": NoParams;
  "desktopAuth.copied": NoParams;
  "desktopAuth.invalid": NoParams;
  "desktopAuth.invalidBody": NoParams;
  "desktopAuth.offline": NoParams;
  "desktopAuth.failed": NoParams;
  "auth.google": NoParams;
  "auth.apple": NoParams;
  "auth.error.apple": NoParams;
  "auth.or": NoParams;
  "auth.emailPlaceholder": NoParams;
  "auth.emailCode.send": NoParams;
  "auth.code.title": NoParams;
  "auth.code.sentTo": { email: string };
  "auth.code.label": NoParams;
  "auth.code.submit": NoParams;
  "auth.code.resend": NoParams;
  "auth.code.changeEmail": NoParams;
  "auth.dev.title": NoParams;
  "auth.dev.hint": NoParams;
  "auth.error.network": NoParams;
  "auth.error.invalid": NoParams;
  "auth.error.invalidEmail": NoParams;
  "auth.error.invalidCode": NoParams;
  "auth.error.rateLimited": NoParams;
  "auth.error.unavailable": NoParams;
  "auth.error.google": NoParams;
  "auth.methods.failed": NoParams;
  "auth.browser.body": NoParams;
  "auth.browser.start": NoParams;
  "auth.browser.waiting": NoParams;
  "auth.browser.waitingBody": NoParams;
  "auth.browser.retry": NoParams;
  "auth.browser.paste": NoParams;
  "auth.browser.pasteLabel": NoParams;
  "auth.browser.pastePlaceholder": NoParams;
  "auth.error.cancelled": NoParams;
  "auth.error.signInExpired": NoParams;
  "auth.error.codeRejected": NoParams;
  "auth.error.browser": NoParams;
  "auth.signedInAs": { email: string };
  "auth.switchAccount": NoParams;
  "workspace.loading": NoParams;
  "workspace.loadingStuck.title": NoParams;
  "workspace.loadingStuck.body": NoParams;
  "workspace.create.title": NoParams;
  "workspace.create.subtitle": NoParams;
  "workspace.create.name": NoParams;
  "workspace.create.placeholder": NoParams;
  "workspace.create.url": { url: string };
  "workspace.create.submit": NoParams;
  "workspace.create.error": NoParams;
  "workspace.create.rateLimited": NoParams;
  "workspace.create.offline": NoParams;
  "workspace.switcher.create": NoParams;
  "workspace.switcher.invite": NoParams;
  "workspace.switcher.join": { name: string };
  "workspace.join.title": NoParams;
  "workspace.join.subtitle": NoParams;
  "workspace.join.domain": { domain: string };
  "workspace.join.members": { count: number };
  "workspace.join.action": NoParams;
  "workspace.join.error": NoParams;
  "workspace.join.offline": NoParams;
  "workspace.join.orCreate": NoParams;
  "invite.people.title": { workspace: string };
  "invite.people.link": NoParams;
  "invite.people.linkHint": NoParams;
  "invite.people.createLink": NoParams;
  "invite.people.copy": NoParams;
  "invite.people.copied": NoParams;
  "invite.people.emails": NoParams;
  "invite.people.emailsPlaceholder": NoParams;
  "invite.people.asAdmins": NoParams;
  "invite.people.send": NoParams;
  "invite.people.sent": { count: number };
  "invite.people.notEmailed": NoParams;
  "invite.people.invalid": { list: string };
  "invite.people.overLimit": NoParams;
  "invite.people.done": NoParams;
  "invite.people.skip": NoParams;
  "invite.accept.title": { inviter: string; workspace: string };
  "invite.accept.titleAnonymous": { workspace: string };
  "invite.accept.subtitle": NoParams;
  "invite.accept.join": { workspace: string };
  "invite.accept.signInToJoin": NoParams;
  "invite.accept.invalid": NoParams;
  "invite.accept.invalidBody": NoParams;
  "invite.accept.emailMismatch": NoParams;
  "invite.accept.offline": NoParams;
  "invite.accept.continue": NoParams;
  "invite.guest.link": { email: string };
  "update.available": NoParams;
  "update.ready": { version: string };
  "update.reload": NoParams;
  "update.restart": NoParams;
  "update.check": NoParams;
  "update.checkPlain": NoParams;
  "update.downloadingMenu": { version: string };
  "update.restartToUpdate": NoParams;
  "update.reloadToUpdate": NoParams;
  "update.checking": NoParams;
  "update.upToDate": NoParams;
  "update.upToDateVersion": { version: string };
  "update.checkedJustNow": NoParams;
  "update.autoNote": NoParams;
  "update.webLatest": { commit: string };
  "update.checkAgain": NoParams;
  "update.availableVersion": { version: string };
  "update.downloadingPercent": { percent: string };
  "update.downloadingPlain": NoParams;
  "update.readyVersion": { version: string };
  "update.readyNote": NoParams;
  "update.webReadyTitle": NoParams;
  "update.webReadyNote": NoParams;
  "update.errorCheck": NoParams;
  "update.errorDownload": NoParams;
  "update.errorInstall": NoParams;
  "update.errorHint": NoParams;
  "update.tryAgain": NoParams;
  "update.updatedTo": { version: string };
  "update.whatsNew": NoParams;
  "toast.region": NoParams;
  "update.later": NoParams;
  "update.download": NoParams;
  "update.apkBody": NoParams;
  "update.apkNotifyBody": NoParams;
  "update.checkedAt": { time: string };
  "update.opensStoreIos": NoParams;
  "update.opensStorePlay": NoParams;
  "about.title": NoParams;
  "about.section": NoParams;
  "about.versionLine": { version: string; channel: string };
  "about.version": NoParams;
  "about.channel": NoParams;
  "about.channel.stable": NoParams;
  "about.channel.testflight": NoParams;
  "about.channel.direct": NoParams;
  "about.channel.dev": NoParams;
  "about.desktopApp": NoParams;
  "about.webApp": NoParams;
  "about.server": NoParams;
  "about.copy": NoParams;
  "about.copied": NoParams;
  "about.licenses": NoParams;
  "notification.reply": NoParams;
  "notification.markRead": NoParams;
  "notification.you": NoParams;
  "notification.newMessage": NoParams;
  "notification.channel.mail": NoParams;
  "notification.channel.mailDescription": NoParams;
  "notification.channel.reminders": NoParams;
  "notification.channel.remindersDescription": NoParams;
  "notification.channel.workspace": NoParams;
  "notification.channel.workspaceDescription": NoParams;
  "common.dismiss": NoParams;
  "db.untitled": NoParams;
  "db.new": NoParams;
  "db.search.placeholder": NoParams;
  "db.toolbar.filter": NoParams;
  "db.toolbar.sort": NoParams;
  "db.toolbar.group": NoParams;
  "db.toolbar.properties": NoParams;
  "db.toolbar.search": NoParams;
  "db.view.add": NoParams;
  "db.view.rename": NoParams;
  "db.view.duplicate": NoParams;
  "db.view.delete": NoParams;
  "db.view.name": NoParams;
  "db.view.copyName": { name: string };
  "db.view.options": NoParams;
  "db.layout.board": NoParams;
  "db.layout.table": NoParams;
  "db.layout.list": NoParams;
  "db.layout.calendar": NoParams;
  "db.layout.sheet": NoParams;
  "db.sheet.nameBox": NoParams;
  "db.sheet.formulaBar": NoParams;
  "db.sheet.entryRow": NoParams;
  "db.sheet.summary": NoParams;
  "db.sheet.rows": { count: number };
  "db.sheet.summaryRows": { count: number };
  "db.sheet.stat.label": NoParams;
  "db.sheet.stat.sum": NoParams;
  "db.sheet.stat.average": NoParams;
  "db.sheet.stat.min": NoParams;
  "db.sheet.stat.max": NoParams;
  "db.sheet.stat.count": NoParams;
  "db.sheet.columnFormula": { name: string };
  "db.sheet.editProperty": NoParams;
  "db.sheet.computed": NoParams;
  "db.sheet.functions": NoParams;
  "db.sheet.freeze": NoParams;
  "db.sheet.freeze.headerOnly": NoParams;
  "db.sheet.freeze.rows": { count: number };
  "db.sheet.freeze.noColumns": NoParams;
  "db.sheet.freeze.columns": { count: number };
  "db.sheet.freeze.upToRow": { row: string };
  "db.sheet.freeze.upToColumn": { column: string };
  "db.sheet.sortRange": NoParams;
  "db.sheet.sortAsc": NoParams;
  "db.sheet.sortDesc": NoParams;
  "db.sheet.sorted": { name: string };
  "db.sheet.sortFailed": NoParams;
  "db.sheet.undo": NoParams;
  "db.sheet.insert": NoParams;
  "db.sheet.insertAbove": NoParams;
  "db.sheet.insertBelow": NoParams;
  "db.sheet.addSummary": NoParams;
  "db.sheet.insertSummaryAbove": NoParams;
  "db.sheet.insertSummaryBelow": NoParams;
  "db.sheet.moveUp": NoParams;
  "db.sheet.moveDown": NoParams;
  "db.sheet.deleteSummary": NoParams;
  "db.sheet.deleteRow": NoParams;
  "db.sheet.openRow": NoParams;
  "db.sheet.cut": NoParams;
  "db.sheet.copy": NoParams;
  "db.sheet.paste": NoParams;
  "db.sheet.fillDown": NoParams;
  "db.sheet.fillRight": NoParams;
  "db.sheet.clear": NoParams;
  "db.sheet.typeMismatch": { name: string; text: string };
  "db.sheet.changeType": NoParams;
  "db.sheet.tooMany": { max: string; count: string };
  "db.sheet.clipboardFailed": NoParams;
  "db.sheet.fill": NoParams;
  "db.sheet.freezeHere": NoParams;
  "db.sheet.unfreeze": NoParams;
  "db.sheet.placeholder": NoParams;
  "db.sheet.notEditable": { name: string };
  "db.sheet.saveFailed": NoParams;
  "db.layout.label": NoParams;
  "db.filter.add": NoParams;
  "db.filter.empty": NoParams;
  "db.filter.and": NoParams;
  "db.filter.or": NoParams;
  "db.filter.where": NoParams;
  "db.filter.remove": NoParams;
  "db.filter.value": NoParams;
  "db.filter.checked": NoParams;
  "db.filter.unchecked": NoParams;
  "db.op.eq": NoParams;
  "db.op.neq": NoParams;
  "db.op.contains": NoParams;
  "db.op.notContains": NoParams;
  "db.op.startsWith": NoParams;
  "db.op.endsWith": NoParams;
  "db.op.isEmpty": NoParams;
  "db.op.isNotEmpty": NoParams;
  "db.op.gt": NoParams;
  "db.op.gte": NoParams;
  "db.op.lt": NoParams;
  "db.op.lte": NoParams;
  "db.op.before": NoParams;
  "db.op.after": NoParams;
  "db.op.onOrBefore": NoParams;
  "db.op.onOrAfter": NoParams;
  "db.op.pastWeek": NoParams;
  "db.op.nextWeek": NoParams;
  "db.op.hasAny": NoParams;
  "db.op.hasAll": NoParams;
  "db.op.hasNone": NoParams;
  "db.op.isMe": NoParams;
  "db.sort.add": NoParams;
  "db.sort.empty": NoParams;
  "db.sort.asc": NoParams;
  "db.sort.desc": NoParams;
  "db.sort.remove": NoParams;
  "db.group.by": NoParams;
  "db.group.noGrouping": NoParams;
  "db.group.none": { property: string };
  "db.group.checked": NoParams;
  "db.group.unchecked": NoParams;
  "db.group.hide": NoParams;
  "db.group.show": NoParams;
  "db.group.hidden": NoParams;
  "db.props.shown": NoParams;
  "db.props.hidden": NoParams;
  "db.props.show": NoParams;
  "db.props.hide": NoParams;
  "db.props.moveUp": NoParams;
  "db.props.moveDown": NoParams;
  "db.property.add": NoParams;
  "db.property.name": NoParams;
  "db.property.type": NoParams;
  "db.property.edit": NoParams;
  "db.property.delete": NoParams;
  "db.property.options": NoParams;
  "db.property.addOption": NoParams;
  "db.property.optionName": NoParams;
  "db.property.numberFormat": NoParams;
  "db.property.relationTarget": NoParams;
  "db.property.create": NoParams;
  "db.numberFormat.number": NoParams;
  "db.numberFormat.percent": NoParams;
  "db.numberFormat.currency": NoParams;
  "db.type.title": NoParams;
  "db.type.text": NoParams;
  "db.type.number": NoParams;
  "db.type.select": NoParams;
  "db.type.multiSelect": NoParams;
  "db.type.status": NoParams;
  "db.type.date": NoParams;
  "db.type.person": NoParams;
  "db.type.checkbox": NoParams;
  "db.type.url": NoParams;
  "db.type.email": NoParams;
  "db.type.files": NoParams;
  "db.type.relation": NoParams;
  "db.type.contact": NoParams;
  "db.contact.empty": NoParams;
  "db.contact.count": { count: number };
  "db.contact.search": NoParams;
  "db.contact.recentEmails": NoParams;
  "db.type.createdTime": NoParams;
  "db.type.createdBy": NoParams;
  "db.type.editedTime": NoParams;
  "db.type.editedBy": NoParams;
  "db.type.formula": NoParams;
  "db.type.rollup": NoParams;
  "db.calc.calculate": NoParams;
  "db.calc.none": NoParams;
  "db.calc.countAll": NoParams;
  "db.calc.countValues": NoParams;
  "db.calc.countUnique": NoParams;
  "db.calc.countEmpty": NoParams;
  "db.calc.countNotEmpty": NoParams;
  "db.calc.percentEmpty": NoParams;
  "db.calc.percentNotEmpty": NoParams;
  "db.calc.sum": NoParams;
  "db.calc.average": NoParams;
  "db.calc.median": NoParams;
  "db.calc.min": NoParams;
  "db.calc.max": NoParams;
  "db.calc.range": NoParams;
  "db.calc.earliest": NoParams;
  "db.calc.latest": NoParams;
  "db.calc.dateRange": NoParams;
  "db.calc.checked": NoParams;
  "db.calc.unchecked": NoParams;
  "db.calc.percentChecked": NoParams;
  "db.calc.percentUnchecked": NoParams;
  "db.calc.days": { count: number };
  "db.formula.edit": NoParams;
  "db.formula.placeholder": NoParams;
  "db.formula.properties": NoParams;
  "db.formula.functions": NoParams;
  "db.formula.format": NoParams;
  "db.formula.format.auto": NoParams;
  "db.formula.format.number": NoParams;
  "db.formula.format.percent": NoParams;
  "db.formula.format.currency": NoParams;
  "db.formula.format.date": NoParams;
  "db.formula.preview": { row: string };
  "db.formula.empty": NoParams;
  "db.formula.searchFunctions": NoParams;
  "db.formula.examples": NoParams;
  "db.formula.done": NoParams;
  "db.formula.cancel": NoParams;
  "db.formula.column": { name: string; letter: string };
  "db.formula.noFunctions": NoParams;
  "db.formula.offline": NoParams;
  "db.formula.hint": NoParams;
  "db.formula.fn.if": NoParams;
  "db.formula.fn.ifs": NoParams;
  "db.formula.fn.and": NoParams;
  "db.formula.fn.or": NoParams;
  "db.formula.fn.not": NoParams;
  "db.formula.fn.sum": NoParams;
  "db.formula.fn.average": NoParams;
  "db.formula.fn.min": NoParams;
  "db.formula.fn.max": NoParams;
  "db.formula.fn.round": NoParams;
  "db.formula.fn.abs": NoParams;
  "db.formula.fn.count": NoParams;
  "db.formula.fn.counta": NoParams;
  "db.formula.fn.concat": NoParams;
  "db.formula.fn.textjoin": NoParams;
  "db.formula.fn.left": NoParams;
  "db.formula.fn.right": NoParams;
  "db.formula.fn.mid": NoParams;
  "db.formula.fn.len": NoParams;
  "db.formula.fn.upper": NoParams;
  "db.formula.fn.lower": NoParams;
  "db.formula.fn.trim": NoParams;
  "db.formula.fn.substitute": NoParams;
  "db.formula.fn.text": NoParams;
  "db.formula.fn.today": NoParams;
  "db.formula.fn.now": NoParams;
  "db.formula.fn.date": NoParams;
  "db.formula.fn.edate": NoParams;
  "db.formula.fn.datedif": NoParams;
  "db.formula.fn.year": NoParams;
  "db.formula.fn.month": NoParams;
  "db.formula.fn.day": NoParams;
  "db.formula.fn.switch": NoParams;
  "db.formula.fn.iferror": NoParams;
  "db.formula.fn.isblank": NoParams;
  "db.formula.fn.xlookup": NoParams;
  "db.formula.fn.sumif": NoParams;
  "db.formula.fn.countif": NoParams;
  "db.formula.fn.median": NoParams;
  "db.rollup.relation": NoParams;
  "db.rollup.property": NoParams;
  "db.rollup.calculate": NoParams;
  "db.rollup.showOriginal": NoParams;
  "db.rollup.noRelation": NoParams;
  "db.view.showRowNumbers": NoParams;
  "db.statusGroup.todo": NoParams;
  "db.statusGroup.inProgress": NoParams;
  "db.statusGroup.complete": NoParams;
  "db.status.notStarted": NoParams;
  "db.status.inProgress": NoParams;
  "db.status.done": NoParams;
  "db.color.default": NoParams;
  "db.color.gray": NoParams;
  "db.color.brown": NoParams;
  "db.color.orange": NoParams;
  "db.color.yellow": NoParams;
  "db.color.green": NoParams;
  "db.color.blue": NoParams;
  "db.color.purple": NoParams;
  "db.color.pink": NoParams;
  "db.color.red": NoParams;
  "db.option.search": NoParams;
  "db.option.create": { name: string };
  "db.option.delete": NoParams;
  "db.option.color": NoParams;
  "db.person.search": NoParams;
  "db.relation.search": NoParams;
  "db.relation.empty": NoParams;
  "db.relation.count": { count: number };
  "db.files.comingSoon": NoParams;
  "db.files.count": { count: number };
  "db.date.end": NoParams;
  "db.date.clear": NoParams;
  "db.value.empty": NoParams;
  "db.row.open": NoParams;
  "db.row.openAsPage": NoParams;
  "db.row.peek": NoParams;
  "db.row.delete": NoParams;
  "db.row.pending": NoParams;
  "db.pending": { count: number };
  "db.empty.title": NoParams;
  "db.empty.body": NoParams;
  "db.empty.filtered": NoParams;
  "db.error.title": NoParams;
  "db.error.notFound": NoParams;
  "db.calendar.prev": NoParams;
  "db.calendar.next": NoParams;
  "db.calendar.today": NoParams;
  "db.calendar.more": { count: string };
  "db.calendar.by": NoParams;
  "db.calendar.noDate": NoParams;
  "db.calendar.undated": NoParams;
  "db.calendar.newOn": { date: string };
  "db.board.noGroup": NoParams;
  "db.board.count": { count: number };
  "db.icon.change": NoParams;
  "db.title.placeholder": NoParams;
  "docs.section.favorites": NoParams;
  "docs.section.workspace": NoParams;
  "docs.section.private": NoParams;
  "docs.newPage": NoParams;
  "docs.addPage": NoParams;
  "docs.template.page": NoParams;
  "docs.template.database": NoParams;
  "docs.template.projects": NoParams;
  "docs.template.meetingNotes": NoParams;
  "docs.template.wiki": NoParams;
  "docs.menu.newSubpage": NoParams;
  "docs.menu.rename": NoParams;
  "docs.menu.addFavorite": NoParams;
  "docs.menu.removeFavorite": NoParams;
  "docs.menu.trash": NoParams;
  "docs.menu.more": NoParams;
  "docs.menu.moveToPrivate": NoParams;
  "docs.menu.moveToWorkspace": NoParams;
  "docs.row.expand": NoParams;
  "docs.row.collapse": NoParams;
  "docs.rename.title": NoParams;
  "docs.rename.placeholder": NoParams;
  "docs.empty": NoParams;
  "docs.trashed": NoParams;
  "docs.undo": NoParams;
  "docs.createFailed": NoParams;
  "page.untitled": NoParams;
  "page.titlePlaceholder": NoParams;
  "page.notFound.title": NoParams;
  "page.notFound.body": NoParams;
  "page.offlineUnavailable": NoParams;
  "page.addIcon": NoParams;
  "page.changeIcon": NoParams;
  "page.removeIcon": NoParams;
  "page.sync.offline": NoParams;
  "page.sync.connecting": NoParams;
  "page.sync.saving": NoParams;
  "page.sync.saved": NoParams;
  "page.readOnly": NoParams;
  "page.presence": { count: number };
  "page.edited": { time: string };
  "editor.placeholder": NoParams;
  "editor.placeholder.heading1": NoParams;
  "editor.placeholder.heading2": NoParams;
  "editor.placeholder.heading3": NoParams;
  "editor.placeholder.list": NoParams;
  "editor.placeholder.todo": NoParams;
  "editor.placeholder.toggle": NoParams;
  "editor.placeholder.quote": NoParams;
  "editor.placeholder.callout": NoParams;
  "editor.placeholder.code": NoParams;
  "editor.block.paragraph": NoParams;
  "editor.block.heading1": NoParams;
  "editor.block.heading2": NoParams;
  "editor.block.heading3": NoParams;
  "editor.block.bulleted": NoParams;
  "editor.block.numbered": NoParams;
  "editor.block.todo": NoParams;
  "editor.block.toggle": NoParams;
  "editor.block.quote": NoParams;
  "editor.block.callout": NoParams;
  "editor.block.code": NoParams;
  "editor.block.divider": NoParams;
  "editor.block.image": NoParams;
  "editor.block.file": NoParams;
  "editor.block.childPage": NoParams;
  "editor.block.linkToPage": NoParams;
  "editor.block.childDatabase": NoParams;
  "editor.slash.title": NoParams;
  "editor.slash.empty": NoParams;
  "editor.turnInto": NoParams;
  "editor.blockActions": NoParams;
  "editor.addBelow": NoParams;
  "editor.toggle.open": NoParams;
  "editor.toggle.close": NoParams;
  "editor.toggle.empty": NoParams;
  "editor.todo.check": NoParams;
  "editor.image.empty": NoParams;
  "editor.file.empty": NoParams;
  "editor.upload.comingSoon": NoParams;
  "editor.linkToPage.choose": NoParams;
  "editor.linkToPage.search": NoParams;
  "editor.missingPage": NoParams;
  "editor.link.placeholder": NoParams;
  "editor.link.apply": NoParams;
  "editor.link.remove": NoParams;
  "editor.link.title": NoParams;
  "editor.mention.people": NoParams;
  "editor.mention.pages": NoParams;
  "editor.mention.dates": NoParams;
  "editor.mention.today": NoParams;
  "editor.mention.tomorrow": NoParams;
  "editor.mention.empty": NoParams;
  "editor.selection": { count: number };
  "editor.format.bold": NoParams;
  "editor.format.italic": NoParams;
  "editor.format.strike": NoParams;
  "editor.format.code": NoParams;
  "editor.format.link": NoParams;
  "projects.title": NoParams;
  "projects.subtitle": NoParams;
  "projects.new": NoParams;
  "projects.empty.title": NoParams;
  "projects.empty.body": NoParams;
  "projects.open": NoParams;
  "home.recentDocs": NoParams;
  "shell.omnibox.pages": NoParams;
  "consent.analytics.title": NoParams;
  "consent.analytics.message": NoParams;
  "consent.analytics.messageSettings": NoParams;
  "consent.analytics.messageApp": NoParams;
  "consent.analytics.accept": NoParams;
  "consent.analytics.decline": NoParams;
  "profile.analytics": NoParams;
  "profile.notifications.enable": NoParams;
  "profile.notifications.on": NoParams;
  "profile.notifications.enabling": NoParams;
  "profile.notifications.retry": NoParams;
  "profile.notifications.blocked": NoParams;
  "notifications.offer.title": NoParams;
  "notifications.offer.body": NoParams;
  "notifications.offer.enable": NoParams;
  "notifications.offer.dismiss": NoParams;
  "notifications.enabled.title": NoParams;
  "notifications.enabled.body": NoParams;
  "notifications.web.offBody": NoParams;
  "notifications.web.turnOn": NoParams;
  "notifications.web.blockedBody": NoParams;
  "notifications.blocked.title.macos": NoParams;
  "notifications.blocked.title.windows": NoParams;
  "notifications.blocked.body": NoParams;
  "notifications.blocked.open.macos": NoParams;
  "notifications.blocked.open.windows": NoParams;
  "notifications.blocked.dismiss": NoParams;
  "notifications.quiet.title": NoParams;
  "notifications.quiet.body": NoParams;
  "settings.notifications.bannersOff": NoParams;
  "settings.notifications.quietHelp": NoParams;
  "settings.notifications.focusHelp": NoParams;
  "settings.notifications.os.macos": NoParams;
  "settings.notifications.os.windows": NoParams;
  "settings.notifications.offInOs.macos": NoParams;
  "settings.notifications.offInOs.windows": NoParams;
  "settings.notifications.osHelp.macos": NoParams;
  "settings.notifications.osHelp.windows": NoParams;
  "settings.notifications.test": NoParams;
  "settings.notifications.test.body": NoParams;
  "settings.notifications.test.button": NoParams;
  "notifications.test.title": NoParams;
  "notifications.test.body": NoParams;
  "notifications.ring.tabTitle": { name: string };
  "files.drop.title": { channel: string };
  "files.drop.titleDm": { name: string };
  "files.drop.titleThread": NoParams;
  "files.drop.subtitle": { max: string };
  "files.attach.remove": { name: string };
  "files.attach.tooMany": { max: string };
  "files.attach.tooBig": { name: string };
  "files.attach.duplicate": { name: string };
  "files.upload.queued": NoParams;
  "files.upload.progress": { percent: string };
  "files.upload.failed": NoParams;
  "files.upload.retry": NoParams;
  "files.upload.done": NoParams;
  "message.uploading": { percent: string };
  "files.download": NoParams;
  "files.copyLink": NoParams;
  "files.linkCopied": NoParams;
  "files.details": NoParams;
  "files.more": { count: string };
  "files.play": { name: string };
  "files.open": { name: string };
  "files.viewer.prev": NoParams;
  "files.viewer.next": NoParams;
  "files.viewer.counter": { index: string; total: string };
  "files.viewer.zoomIn": NoParams;
  "files.viewer.zoomOut": NoParams;
  "files.viewer.fit": NoParams;
  "files.noPreview": NoParams;
  "files.reason.pending": NoParams;
  "files.reason.notInChannel": { channel: string };
  "files.reason.notInChannelJoin": { channel: string };
  "files.reason.notInConversation": NoParams;
  "files.reason.guestNoDownload": NoParams;
  "files.reason.agentNoDownload": NoParams;
  "files.reason.previewBlocked": NoParams;
  "files.reason.expired": NoParams;
  "files.page.title": NoParams;
  "files.page.size": NoParams;
  "files.page.type": NoParams;
  "files.page.sharedBy": NoParams;
  "files.page.when": NoParams;
  "files.page.where": NoParams;
  "files.page.whereDm": { names: string };
  "files.page.wherePage": { title: string };
  "files.page.notShared": NoParams;
  "files.page.access": NoParams;
  "files.page.you": NoParams;
  "files.page.view": NoParams;
  "files.page.allowed": NoParams;
  "files.page.join": { channel: string };
  "files.page.openConversation": NoParams;
  "files.page.notFound.title": NoParams;
  "files.page.notFound.body": NoParams;
  "files.page.signIn.title": NoParams;
  "files.page.signIn.body": NoParams;
  "files.audience.publicChannel": { channel: string };
  "files.audience.privateChannel": { channel: string };
  "files.audience.dm": { names: string };
  "files.audience.page": { title: string };
  "files.audience.onlyYou": NoParams;
  "files.audience.guests": { count: number };
  "files.audience.guestsNoDownload": { count: number };
  "files.audience.guestsMixed": { without: string; count: string };
  "files.kind.image": NoParams;
  "files.kind.video": NoParams;
  "files.kind.audio": NoParams;
  "files.kind.pdf": NoParams;
  "files.kind.document": NoParams;
  "files.kind.spreadsheet": NoParams;
  "files.kind.presentation": NoParams;
  "files.kind.archive": NoParams;
  "files.kind.code": NoParams;
  "files.kind.text": NoParams;
  "files.kind.executable": NoParams;
  "files.kind.other": NoParams;
  "files.audience.memberCount": { count: number };
  "files.page.whereChannel": { channel: string };
  "files.audience.workspace": NoParams;
  "stickers.create.nameRequired": NoParams;
  "stickers.create.nameTooLong": { max: string };
  "stickers.pack.nameRequired": NoParams;
  "stickers.pack.nameTooLong": { max: string };
  "stickers.create.badType": NoParams;
  "stickers.create.tooBig": { max: string };
  "stickers.create.tooLarge": { max: string };
  "stickers.create.unreadable": NoParams;
  "stickers.picker.results": NoParams;
  "stickers.picker.recent": NoParams;
  "stickers.notice.offline": NoParams;
  "stickers.notice.failed": NoParams;
  "stickers.notice.forbidden": NoParams;
  "picker.title": NoParams;
  "picker.tab.emoji": NoParams;
  "picker.tab.stickers": NoParams;
  "picker.tab.gifs": NoParams;
  "picker.emoji.search": NoParams;
  "picker.emoji.frequent": NoParams;
  "picker.emoji.skinTone": NoParams;
  "picker.stickers.search": NoParams;
  "picker.stickers.create": NoParams;
  "picker.stickers.add": NoParams;
  "picker.stickers.manage": NoParams;
  "picker.stickers.empty": NoParams;
  "picker.stickers.emptyBody": NoParams;
  "picker.stickers.noResults": { query: string };
  "picker.gifs.search": NoParams;
  "picker.gifs.poweredBy": NoParams;
  "picker.gifs.trending": NoParams;
  "picker.gifs.unavailable": NoParams;
  "picker.gifs.unavailableBody": NoParams;
  "picker.gifs.empty": { query: string };
  "picker.gifs.error.network": NoParams;
  "picker.gifs.error.rateLimited": NoParams;
  "picker.gifs.error.server": NoParams;
  "picker.gifs.loadingMore": NoParams;
  "message.sticker": { name: string };
  "message.gif": { title: string };
  "message.gifVia": NoParams;
  "message.openPack": NoParams;
  "message.edit": NoParams;
  "message.editSave": NoParams;
  "message.editCancel": NoParams;
  "message.editHint": NoParams;
  "message.editEmpty": NoParams;
  "message.delete": NoParams;
  "message.deleteConfirm.title": NoParams;
  "message.deleteConfirm.body": NoParams;
  "message.deleteConfirm.others": { name: string };
  "message.deleteConfirm.files": { count: number };
  "message.deleteConfirm.replies": NoParams;
  "message.deleteConfirm.confirm": NoParams;
  "message.deleteConfirm.cancel": NoParams;
  "broadcast.confirm.title": { count: number };
  "broadcast.confirm.channel": { range: string };
  "broadcast.confirm.here": NoParams;
  "broadcast.confirm.zones": { count: number };
  "broadcast.confirm.send": NoParams;
  "files.saveAsSticker": NoParams;
  "stickers.pack.count": { count: number };
  "stickers.pack.workspace": NoParams;
  "stickers.pack.personal": { name: string };
  "stickers.pack.add": NoParams;
  "stickers.pack.added": NoParams;
  "stickers.pack.remove": NoParams;
  "stickers.pack.delete": NoParams;
  "stickers.pack.makeWorkspace": NoParams;
  "stickers.pack.makePersonal": NoParams;
  "stickers.pack.addSticker": NoParams;
  "stickers.pack.notFound": NoParams;
  "stickers.pack.empty": NoParams;
  "stickers.sticker.delete": NoParams;
  "stickers.manage.title": NoParams;
  "stickers.manage.mine": NoParams;
  "stickers.manage.browse": NoParams;
  "stickers.manage.moveUp": NoParams;
  "stickers.manage.moveDown": NoParams;
  "stickers.manage.add": NoParams;
  "stickers.manage.remove": NoParams;
  "stickers.manage.open": { name: string };
  "stickers.manage.emptyMine": NoParams;
  "stickers.manage.settings": NoParams;
  "stickers.settings.creators": NoParams;
  "stickers.settings.creators.everyone": NoParams;
  "stickers.settings.creators.admins": NoParams;
  "stickers.settings.gifsEnabled": NoParams;
  "stickers.settings.rating": NoParams;
  "stickers.settings.rating.high": NoParams;
  "stickers.settings.rating.medium": NoParams;
  "stickers.settings.rating.low": NoParams;
  "stickers.settings.rating.off": NoParams;
  "stickers.settings.guests": NoParams;
  "stickers.create.title": NoParams;
  "stickers.create.pick": NoParams;
  "stickers.create.pickHint": NoParams;
  "stickers.create.pastePlaceholder": NoParams;
  "stickers.create.reading": NoParams;
  "stickers.create.crop": NoParams;
  "stickers.create.animatedNote": NoParams;
  "stickers.create.removeBackground": NoParams;
  "stickers.create.name": NoParams;
  "stickers.create.namePlaceholder": NoParams;
  "stickers.create.keywords": NoParams;
  "stickers.create.keywordsPlaceholder": NoParams;
  "stickers.create.pack": NoParams;
  "stickers.create.newPack": NoParams;
  "stickers.create.newPackName": NoParams;
  "stickers.create.newPackWorkspace": NoParams;
  "stickers.create.save": NoParams;
  "stickers.create.saving": NoParams;
  "stickers.create.notAllowed": NoParams;
  "stickers.create.change": NoParams;
  "files.page.whereSticker": NoParams;
  "settings.title": NoParams;
  "settings.about.speechCredit": NoParams;
  "settings.comingSoon": NoParams;
  "roles.owner": NoParams;
  "roles.admin": NoParams;
  "roles.member": NoParams;
  "roles.guest": NoParams;
  "roles.primaryOwner": NoParams;
  "roles.problem.forbidden": NoParams;
  "roles.problem.ownersOnly": NoParams;
  "roles.problem.primaryOwner": NoParams;
  "roles.problem.primaryOnly": NoParams;
  "roles.problem.lastOwner": NoParams;
  "roles.problem.agent": NoParams;
  "roles.problem.deactivated": NoParams;
  "roles.problem.unchanged": NoParams;
  "roles.problem.self": NoParams;
  "roles.problem.ineligible": NoParams;
  "profile.error.displayNameRequired": NoParams;
  "profile.error.tooLong": { max: string };
  "profile.error.phone": NoParams;
  "profile.error.timezone": NoParams;
  "profile.status.preset.meeting": NoParams;
  "profile.status.preset.commuting": NoParams;
  "profile.status.preset.sick": NoParams;
  "profile.status.preset.vacation": NoParams;
  "profile.status.preset.remote": NoParams;
  "profile.status.clear.never": NoParams;
  "profile.status.clear.halfHour": NoParams;
  "profile.status.clear.hour": NoParams;
  "profile.status.clear.fourHours": NoParams;
  "profile.status.clear.today": NoParams;
  "profile.status.clear.week": NoParams;
  "profile.time.ahead": { span: string };
  "profile.time.behind": { span: string };
  "settings.nav.profile": NoParams;
  "settings.nav.preferences": NoParams;
  "settings.nav.notifications": NoParams;
  "settings.nav.account": NoParams;
  "settings.nav.workspace": NoParams;
  "settings.nav.members": NoParams;
  "settings.nav.invitations": NoParams;
  "settings.nav.guests": NoParams;
  "settings.nav.integrations": NoParams;
  "settings.nav.security": NoParams;
  "settings.nav.data": NoParams;
  "settings.nav.stickers": NoParams;
  "settings.group.you": NoParams;
  "settings.group.workspace": NoParams;
  "settings.menu.profile": NoParams;
  "settings.menu.workspace": NoParams;
  "settings.adminOnly": NoParams;
  "settings.save": NoParams;
  "settings.saving": NoParams;
  "settings.saved": NoParams;
  "settings.unsaved": NoParams;
  "settings.discard": NoParams;
  "settings.failed": NoParams;
  "settings.offlineQueued": NoParams;
  "settings.offline": NoParams;
  "settings.loadFailed": NoParams;
  "settings.comingSoonBadge": NoParams;
  "settings.integrations.body": NoParams;
  "integrations.webhooks.title": NoParams;
  "integrations.webhooks.body": NoParams;
  "integrations.webhooks.empty": NoParams;
  "integrations.webhook.add": NoParams;
  "integrations.webhook.edit": NoParams;
  "integrations.webhook.create": NoParams;
  "integrations.webhook.name": NoParams;
  "integrations.webhook.namePlaceholder": NoParams;
  "integrations.webhook.channel": NoParams;
  "integrations.webhook.nameEmpty": NoParams;
  "integrations.webhook.nameTooLong": NoParams;
  "integrations.webhook.pickChannel": NoParams;
  "integrations.webhook.saveFailed": NoParams;
  "integrations.webhook.failed": NoParams;
  "integrations.webhook.meta": { conversation: string; name: string };
  "integrations.webhook.hidden": NoParams;
  "integrations.webhook.lastUsed": { when: string };
  "integrations.webhook.more": NoParams;
  "integrations.webhook.regenerate": NoParams;
  "integrations.webhook.remove": NoParams;
  "integrations.webhook.removeTitle": NoParams;
  "integrations.webhook.removeBody": { name: string };
  "integrations.webhook.urlTitle": NoParams;
  "integrations.webhook.urlBody": NoParams;
  "integrations.webhook.url": NoParams;
  "integrations.webhook.copy": NoParams;
  "integrations.webhook.copied": NoParams;
  "integrations.webhook.done": NoParams;
  "integrations.agents.title": NoParams;
  "integrations.agents.body": NoParams;
  "integrations.agents.empty": NoParams;
  "integrations.agent.hosted": NoParams;
  "integrations.agent.external": NoParams;
  "integrations.agent.sponsor": { name: string };
  "settings.security.body": NoParams;
  "settings.data.body": NoParams;
  "settings.stickers.body": NoParams;
  "settings.stickers.open": NoParams;
  "settings.stickers.unavailable": NoParams;
  "settings.preferences.appearance": NoParams;
  "settings.preferences.privacy": NoParams;
  "settings.preferences.analytics.onByDefault": NoParams;
  "settings.preferences.analytics.body": NoParams;
  "settings.notifications.device": NoParams;
  "settings.notifications.unsupported": NoParams;
  "settings.notifications.disable": NoParams;
  "settings.notifications.sound": NoParams;
  "settings.notifications.sound.toggle": NoParams;
  "settings.notifications.sound.body": NoParams;
  "settings.notifications.sound.preview": NoParams;
  "settings.notifyKinds.title": NoParams;
  "settings.notifyKinds.desc": { workspace: string };
  "settings.notifyKinds.footer": NoParams;
  "settings.notifyKinds.group.messages": NoParams;
  "settings.notifyKinds.group.calls": NoParams;
  "settings.notifyKinds.group.workspace": NoParams;
  "settings.notifyKinds.dm": NoParams;
  "settings.notifyKinds.group": NoParams;
  "settings.notifyKinds.mention": NoParams;
  "settings.notifyKinds.mention.help": NoParams;
  "settings.notifyKinds.broadcast": NoParams;
  "settings.notifyKinds.thread": NoParams;
  "settings.notifyKinds.thread.help": NoParams;
  "settings.notifyKinds.channel": NoParams;
  "settings.notifyKinds.channel.help": NoParams;
  "settings.notifyKinds.huddle": NoParams;
  "settings.notifyKinds.huddle.help": NoParams;
  "settings.notifyKinds.eventInvite": NoParams;
  "settings.notifyKinds.eventReminder": NoParams;
  "settings.notifyKinds.eventReminder.help": NoParams;
  "settings.notifyKinds.later": NoParams;
  "settings.notifyKinds.memberJoined": NoParams;
  "settings.notifyKinds.memberJoined.help": NoParams;
  "settings.notifications.sound.knock": NoParams;
  "settings.notifications.sound.pop": NoParams;
  "settings.notifications.sound.chime": NoParams;
  "settings.notifications.sound.ding": NoParams;
  "settings.notifications.sound.pluck": NoParams;
  "settings.notifications.dnd": NoParams;
  "settings.notifications.dnd.body": NoParams;
  "settings.notifications.dnd.min30": NoParams;
  "settings.notifications.dnd.hour1": NoParams;
  "settings.notifications.dnd.hour2": NoParams;
  "settings.notifications.dnd.tomorrow": NoParams;
  "settings.notifications.dnd.custom": NoParams;
  "settings.notifications.dnd.customLabel": NoParams;
  "settings.notifications.dnd.customSave": NoParams;
  "settings.notifications.dnd.until": { time: string };
  "settings.notifications.dnd.resume": NoParams;
  "settings.notifications.dnd.schedule": NoParams;
  "settings.notifications.dnd.schedule.toggle": NoParams;
  "settings.notifications.dnd.schedule.body": { zone: string };
  "settings.notifications.dnd.from": NoParams;
  "settings.notifications.dnd.to": NoParams;
  "settings.notifications.dnd.days": NoParams;
  "settings.notifications.dnd.day.sun": NoParams;
  "settings.notifications.dnd.day.mon": NoParams;
  "settings.notifications.dnd.day.tue": NoParams;
  "settings.notifications.dnd.day.wed": NoParams;
  "settings.notifications.dnd.day.thu": NoParams;
  "settings.notifications.dnd.day.fri": NoParams;
  "settings.notifications.dnd.day.sat": NoParams;
  "settings.notifications.dnd.failed": NoParams;
  "dnd.paused": NoParams;
  "profile.section.photo": NoParams;
  "profile.photo.upload": NoParams;
  "profile.photo.change": NoParams;
  "profile.photo.remove": NoParams;
  "profile.photo.crop": NoParams;
  "profile.photo.cropTitle": NoParams;
  "profile.photo.use": NoParams;
  "profile.photo.uploading": { percent: string };
  "profile.photo.hint": NoParams;
  "profile.photo.failed": NoParams;
  "profile.photo.unreadable": NoParams;
  "profile.section.about": NoParams;
  "profile.displayName": NoParams;
  "profile.displayName.hint": NoParams;
  "profile.fullName": NoParams;
  "profile.title": NoParams;
  "profile.title.placeholder": NoParams;
  "profile.pronouns": NoParams;
  "profile.pronouns.placeholder": NoParams;
  "profile.phone": NoParams;
  "profile.phone.visible": NoParams;
  "profile.phone.privateHint": NoParams;
  "profile.phone.publicHint": NoParams;
  "profile.timezone": NoParams;
  "profile.timezone.search": NoParams;
  "profile.timezone.useDevice": { zone: string };
  "profile.timezone.none": NoParams;
  "profile.timezone.localTime": { time: string };
  "profile.language.hint": NoParams;
  "profile.section.status": NoParams;
  "profile.status.placeholder": NoParams;
  "profile.status.emoji": NoParams;
  "profile.status.clearAfter": NoParams;
  "profile.status.save": NoParams;
  "profile.status.clear": NoParams;
  "profile.status.until": { time: string };
  "profile.status.saved": NoParams;
  "status.until.time": { time: string };
  "status.until.tomorrow": NoParams;
  "status.until.weekday.sun": NoParams;
  "status.until.weekday.mon": NoParams;
  "status.until.weekday.tue": NoParams;
  "status.until.weekday.wed": NoParams;
  "status.until.weekday.thu": NoParams;
  "status.until.weekday.fri": NoParams;
  "status.until.weekday.sat": NoParams;
  "status.until.month.jan": { day: string };
  "status.until.month.feb": { day: string };
  "status.until.month.mar": { day: string };
  "status.until.month.apr": { day: string };
  "status.until.month.may": { day: string };
  "status.until.month.jun": { day: string };
  "status.until.month.jul": { day: string };
  "status.until.month.aug": { day: string };
  "status.until.month.sep": { day: string };
  "status.until.month.oct": { day: string };
  "status.until.month.nov": { day: string };
  "status.until.month.dec": { day: string };
  "status.until.date": { date: string };
  "status.untilInline.time": { time: string };
  "status.untilInline.tomorrow": NoParams;
  "status.untilInline.weekday.sun": NoParams;
  "status.untilInline.weekday.mon": NoParams;
  "status.untilInline.weekday.tue": NoParams;
  "status.untilInline.weekday.wed": NoParams;
  "status.untilInline.weekday.thu": NoParams;
  "status.untilInline.weekday.fri": NoParams;
  "status.untilInline.weekday.sat": NoParams;
  "status.untilInline.month.jan": { day: string };
  "status.untilInline.month.feb": { day: string };
  "status.untilInline.month.mar": { day: string };
  "status.untilInline.month.apr": { day: string };
  "status.untilInline.month.may": { day: string };
  "status.untilInline.month.jun": { day: string };
  "status.untilInline.month.jul": { day: string };
  "status.untilInline.month.aug": { day: string };
  "status.untilInline.month.sep": { day: string };
  "status.untilInline.month.oct": { day: string };
  "status.untilInline.month.nov": { day: string };
  "status.untilInline.month.dec": { day: string };
  "status.untilInline.date": { date: string };
  "status.a11y": { text: string };
  "status.a11y.emojiOnly": NoParams;
  "account.email": NoParams;
  "account.email.hint": NoParams;
  "account.methods": NoParams;
  "account.method.email": NoParams;
  "account.method.google": NoParams;
  "account.method.apple": NoParams;
  "account.method.connected": NoParams;
  "account.method.notConnected": NoParams;
  "account.method.googleHint": { email: string };
  "account.sessions": NoParams;
  "account.sessions.current": NoParams;
  "account.sessions.lastActive": { time: string };
  "account.sessions.browser": NoParams;
  "account.sessions.revokeOthers": NoParams;
  "account.sessions.revoked": { count: number };
  "account.sessions.none": NoParams;
  "account.sessions.moved": NoParams;
  "account.sessions.open": NoParams;
  "security.sessions.title": NoParams;
  "security.sessions.body": NoParams;
  "security.sessions.app": { os: string };
  "security.sessions.appUnknown": NoParams;
  "security.sessions.desktop": NoParams;
  "security.sessions.browserOn": { browser: string; os: string };
  "security.sessions.unknown": NoParams;
  "security.sessions.signedIn": { time: string };
  "security.sessions.activity": { active: string; signedIn: string };
  "security.sessions.signOut": NoParams;
  "security.sessions.revokedOne": NoParams;
  "security.sessions.confirmTitle": NoParams;
  "security.sessions.confirmBody": { count: number };
  "security.workspace.title": NoParams;
  "security.workspace.body": { name: string };
  "security.workspace.invites": NoParams;
  "security.workspace.invitesBody": NoParams;
  "security.workspace.guests": NoParams;
  "security.workspace.guestsBody": NoParams;
  "security.workspace.domains": NoParams;
  "security.workspace.domainsOff": NoParams;
  "security.workspace.domainsOn": { domains: string };
  "security.workspace.manage": NoParams;
  "appPasswords.title": NoParams;
  "appPasswords.body": { name: string };
  "appPasswords.add": NoParams;
  "appPasswords.add.profile": NoParams;
  "appPasswords.add.profileHelp": NoParams;
  "appPasswords.add.mail": NoParams;
  "appPasswords.add.mailHelp": NoParams;
  "appPasswords.add.calendar": NoParams;
  "appPasswords.add.calendarHelp": NoParams;
  "appPasswords.name.titleProfile": NoParams;
  "appPasswords.name.titleMail": NoParams;
  "appPasswords.name.titleCalendar": NoParams;
  "appPasswords.name.body": NoParams;
  "appPasswords.name.label": NoParams;
  "appPasswords.name.helper": NoParams;
  "appPasswords.name.defaultProfile": NoParams;
  "appPasswords.name.defaultMail": NoParams;
  "appPasswords.name.defaultCalendar": NoParams;
  "appPasswords.create": NoParams;
  "appPasswords.made.title": { name: string };
  "appPasswords.made.password": NoParams;
  "appPasswords.made.once": NoParams;
  "appPasswords.made.user": NoParams;
  "appPasswords.made.userCaption": NoParams;
  "appPasswords.made.servers": NoParams;
  "appPasswords.made.serversCaption": NoParams;
  "appPasswords.done": NoParams;
  "appPasswords.unnamed": NoParams;
  "appPasswords.unnamedNote": NoParams;
  "appPasswords.created": { time: string };
  "appPasswords.lastUsed": { time: string };
  "appPasswords.neverUsed": NoParams;
  "appPasswords.stale": NoParams;
  "appPasswords.revoke": NoParams;
  "appPasswords.revokeAll": NoParams;
  "appPasswords.footer": NoParams;
  "appPasswords.confirmOneTitle": { name: string };
  "appPasswords.confirmOneTitleUnnamed": NoParams;
  "appPasswords.confirmOneBody": NoParams;
  "appPasswords.confirmAllTitle": { count: number };
  "appPasswords.confirmAllBody": { name: string };
  "appPasswords.revokedOne": { name: string };
  "appPasswords.revokedUnnamed": NoParams;
  "appPasswords.revokedAll": { count: number };
  "appPasswords.profileDownloaded": NoParams;
  "appPasswords.empty.title": NoParams;
  "appPasswords.empty.body": NoParams;
  "appPasswords.limit": { count: string };
  "appPasswords.nearLimit": { count: string; limit: string };
  "appPasswords.count": { count: number };
  "appPasswords.manage": NoParams;
  "mail.apps.deviceName": NoParams;
  "mail.apps.appName": NoParams;
  "mail.apps.profileNote": NoParams;
  "data.export.title": NoParams;
  "data.export.body": NoParams;
  "data.export.action": NoParams;
  "data.export.readyTitle": NoParams;
  "data.export.readyMeta": { time: string; size: string };
  "data.export.download": NoParams;
  "data.export.refreshLink": NoParams;
  "data.export.nextAt": { time: string };
  "data.export.kept": NoParams;
  "data.export.ready": NoParams;
  "data.export.tooSoon": NoParams;
  "data.export.failed": NoParams;
  "data.workspace.title": { name: string };
  "data.workspace.body": NoParams;
  "data.workspace.action": NoParams;
  "data.delete.body": NoParams;
  "data.delete.action": NoParams;
  "account.delete.title": NoParams;
  "account.delete.body": NoParams;
  "account.delete.action": NoParams;
  "account.delete.blocked": NoParams;
  "account.delete.blockedPrimary": { name: string };
  "account.delete.blockedLast": { name: string };
  "account.delete.confirmTitle": NoParams;
  "account.delete.typeEmail": { email: string };
  "account.delete.confirm": NoParams;
  "account.delete.failed": NoParams;
  "account.delete.mismatch": NoParams;
  "account.delete.ownership": NoParams;
  "signInMethods.title": NoParams;
  "signInMethods.body": NoParams;
  "signInMethods.apple": NoParams;
  "signInMethods.google": NoParams;
  "signInMethods.email": NoParams;
  "signInMethods.privateRelay": NoParams;
  "signInMethods.noEmail": NoParams;
  "signInMethods.onlyMethod": NoParams;
  "signInMethods.remove": NoParams;
  "signInMethods.remove.apple": NoParams;
  "signInMethods.remove.google": NoParams;
  "signInMethods.remove.body": NoParams;
  "signInMethods.removed.apple": NoParams;
  "signInMethods.removed.google": NoParams;
  "signInMethods.linked.apple": NoParams;
  "signInMethods.linked.google": NoParams;
  "signInMethods.addTitle": NoParams;
  "signInMethods.addEmail": NoParams;
  "signInMethods.addEmail.body": NoParams;
  "signInMethods.addEmail.send": NoParams;
  "signInMethods.addEmail.codeBody": { email: string };
  "signInMethods.addEmail.verify": NoParams;
  "signInMethods.emailAdded": { email: string };
  "signInMethods.usePhoto": NoParams;
  "signInMethods.photoUsed": NoParams;
  "signInMethods.inBrowser": NoParams;
  "signInMethods.manageInBrowser": NoParams;
  "signInMethods.loadFailed": NoParams;
  "signInMethods.error.otherAccount": NoParams;
  "signInMethods.error.alreadyLinked": NoParams;
  "signInMethods.error.lastMethod": NoParams;
  "signInMethods.error.signInAgain": NoParams;
  "signInMethods.error.emailInUse": NoParams;
  "signInMethods.error.cancelled": NoParams;
  "signInMethods.error.failed": NoParams;
  "auth.passkey.signIn": NoParams;
  "auth.password.use": NoParams;
  "auth.password.title": NoParams;
  "auth.password.label": NoParams;
  "auth.password.show": NoParams;
  "auth.password.hide": NoParams;
  "auth.password.forgot": NoParams;
  "auth.password.useCode": NoParams;
  "auth.error.wrongPassword": NoParams;
  "auth.error.locked": { minutes: string };
  "auth.password.lockedHint": NoParams;
  "auth.twoStep.title": NoParams;
  "auth.twoStep.body": NoParams;
  "auth.twoStep.codeLabel": NoParams;
  "auth.twoStep.digit": { n: string };
  "auth.twoStep.trust": NoParams;
  "auth.twoStep.trustHint": NoParams;
  "auth.twoStep.submit": NoParams;
  "auth.twoStep.verifying": NoParams;
  "auth.twoStep.useBackup": NoParams;
  "auth.twoStep.useApp": NoParams;
  "auth.twoStep.backupTitle": NoParams;
  "auth.twoStep.backupBody": NoParams;
  "auth.twoStep.backupLabel": NoParams;
  "auth.twoStep.lostAccess": NoParams;
  "auth.error.twoStepCode": NoParams;
  "auth.error.backupCode": NoParams;
  "auth.reset.title": NoParams;
  "auth.reset.codeLabel": NoParams;
  "auth.reset.back": NoParams;
  "auth.reset.newTitle": NoParams;
  "auth.reset.for": { email: string };
  "auth.reset.newLabel": NoParams;
  "auth.reset.hint.length": NoParams;
  "auth.reset.hint.common": NoParams;
  "auth.reset.hint.email": NoParams;
  "auth.reset.strength": { level: string };
  "auth.reset.strength.weak": NoParams;
  "auth.reset.strength.fair": NoParams;
  "auth.reset.strength.strong": NoParams;
  "auth.reset.signOutOthers": NoParams;
  "auth.reset.signOutHint": NoParams;
  "auth.reset.save": NoParams;
  "auth.reset.doneTitle": NoParams;
  "auth.reset.doneBody": { email: string };
  "auth.reset.doneBodyKept": { email: string };
  "auth.reset.done": NoParams;
  "auth.error.passwordShort": NoParams;
  "auth.error.passwordCommon": NoParams;
  "auth.error.passwordEmail": NoParams;
  "auth.error.passwordLeaked": NoParams;
  "auth.error.passwordLong": NoParams;
  "auth.passkey.waiting": NoParams;
  "auth.passkey.waitingBody": NoParams;
  "auth.passkey.cancelledTitle": NoParams;
  "auth.error.passkeyCancelled": NoParams;
  "auth.passkey.notFoundTitle": NoParams;
  "auth.signup.title": NoParams;
  "auth.signup.name": NoParams;
  "auth.signup.email": NoParams;
  "auth.signup.have": NoParams;
  "auth.signup.signIn": NoParams;
  "auth.signup.newTo": NoParams;
  "auth.signup.create": NoParams;
  "auth.signup.codeLabel": NoParams;
  "auth.signup.codeSentTo": { email: string };
  "auth.signup.resend": NoParams;
  "auth.signup.secureTitle": NoParams;
  "auth.signup.secureBody": NoParams;
  "auth.signup.addPasskey": NoParams;
  "auth.signup.recommended": NoParams;
  "auth.signup.passkeyBody": NoParams;
  "auth.signup.setPassword": NoParams;
  "auth.signup.passwordBody": NoParams;
  "auth.signup.skip": NoParams;
  "auth.signup.existsTitle": NoParams;
  "auth.signup.existsBody": { email: string };
  "auth.signup.signInInstead": NoParams;
  "auth.error.passkeyNotFound": NoParams;
  "security.emails.title": NoParams;
  "security.emails.add": NoParams;
  "security.emails.foot": NoParams;
  "security.emails.primary": NoParams;
  "security.emails.verified": NoParams;
  "security.emails.pending": NoParams;
  "security.emails.primaryHint": NoParams;
  "security.emails.secondaryHint": NoParams;
  "security.emails.makePrimary": NoParams;
  "security.emails.enterCode": NoParams;
  "security.emails.remove": NoParams;
  "security.emails.addBody": NoParams;
  "security.emails.removeConfirm": { email: string };
  "security.emails.removeBody": NoParams;
  "security.password.title": NoParams;
  "security.password.set": NoParams;
  "security.password.change": NoParams;
  "security.password.remove": NoParams;
  "security.password.none": NoParams;
  "security.password.isSet": NoParams;
  "security.password.current": NoParams;
  "security.password.removeBody": NoParams;
  "security.passkeys.title": NoParams;
  "security.passkeys.body": NoParams;
  "security.passkeys.add": NoParams;
  "security.passkeys.rename": NoParams;
  "security.passkeys.delete": NoParams;
  "security.passkeys.unnamed": NoParams;
  "security.passkeys.lastUsed": { time: string };
  "security.passkeys.added": { time: string };
  "security.passkeys.deleteConfirm": NoParams;
  "security.passkeys.deleteBody": NoParams;
  "security.passkeys.name": NoParams;
  "security.passkeys.cancelled": NoParams;
  "security.twoStep.title": NoParams;
  "security.twoStep.off": NoParams;
  "security.twoStep.on": NoParams;
  "security.twoStep.app": NoParams;
  "security.twoStep.turnOn": NoParams;
  "security.twoStep.setupTitle": NoParams;
  "security.twoStep.setupBody": NoParams;
  "security.twoStep.openApp": NoParams;
  "security.twoStep.copyKey": NoParams;
  "security.twoStep.keyCopied": NoParams;
  "security.twoStep.key": NoParams;
  "security.twoStep.backupTitle": NoParams;
  "security.twoStep.backupBody": NoParams;
  "security.twoStep.copyCodes": NoParams;
  "security.twoStep.codesCopied": NoParams;
  "security.twoStep.shareCodes": NoParams;
  "security.twoStep.done": NoParams;
  "security.twoStep.remaining": { count: number };
  "security.twoStep.regenerate": NoParams;
  "security.twoStep.regenerateBody": NoParams;
  "security.twoStep.turnOff": NoParams;
  "security.twoStep.turnOffBody": NoParams;
  "security.stepUp.title": NoParams;
  "security.stepUp.passwordBody": NoParams;
  "security.stepUp.codeBody": { email: string };
  "security.stepUp.code": NoParams;
  "security.sessions.activityAt": { city: string; active: string };
  "security.error.wrongPassword": NoParams;
  "security.twoStep.turnedOn": NoParams;
  "security.emails.codeTitle": NoParams;
  "security.passkeys.unavailable": NoParams;
  "workspace.settings.general": NoParams;
  "workspace.settings.name": NoParams;
  "workspace.settings.nameRequired": NoParams;
  "workspace.settings.slug": NoParams;
  "workspace.settings.slugHint": NoParams;
  "workspace.settings.slugWarning": { slug: string };
  "workspace.settings.slugInvalid": NoParams;
  "workspace.settings.slugReserved": NoParams;
  "workspace.settings.slugTaken": NoParams;
  "workspace.settings.icon": NoParams;
  "workspace.settings.icon.upload": NoParams;
  "workspace.settings.icon.remove": NoParams;
  "workspace.settings.icon.cropTitle": NoParams;
  "workspace.settings.defaultLanguage": NoParams;
  "workspace.settings.defaultLanguageHint": NoParams;
  "workspace.settings.primaryOwnerHint": { name: string };
  "workspace.settings.domains": NoParams;
  "workspace.settings.domainsHint": NoParams;
  "workspace.settings.domainsEmpty": NoParams;
  "workspace.settings.domainsReadOnly": NoParams;
  "workspace.settings.domainLabel": NoParams;
  "workspace.settings.domainPlaceholder": NoParams;
  "workspace.settings.domainAdd": NoParams;
  "workspace.settings.domainRemove": { domain: string };
  "workspace.settings.domainInvalid": NoParams;
  "workspace.settings.domainPublic": { domain: string };
  "workspace.settings.domainDuplicate": NoParams;
  "workspace.settings.domainLimit": { count: string };
  "workspace.settings.danger": NoParams;
  "workspace.settings.delete": NoParams;
  "workspace.settings.deleteBody": NoParams;
  "members.search": NoParams;
  "members.filter.all": NoParams;
  "members.filter.active": NoParams;
  "members.filter.invited": NoParams;
  "members.filter.deactivated": NoParams;
  "members.filter.admins": NoParams;
  "members.filter.guests": NoParams;
  "members.filter.agents": NoParams;
  "members.kind.human": NoParams;
  "members.kind.agent": NoParams;
  "members.status.active": NoParams;
  "members.status.deactivated": NoParams;
  "members.status.invited": NoParams;
  "members.you": NoParams;
  "members.empty": NoParams;
  "members.actions": { name: string };
  "members.role.change": { name: string };
  "members.action.deactivate": NoParams;
  "members.action.reactivate": NoParams;
  "members.action.editScope": NoParams;
  "members.action.transfer": NoParams;
  "members.action.revoke": NoParams;
  "members.action.resend": NoParams;
  "members.confirm.go": NoParams;
  "members.confirm.deactivate.title": { name: string };
  "members.confirm.deactivate.body": NoParams;
  "members.confirm.role.title": { name: string; role: string };
  "members.confirm.role.owner": NoParams;
  "members.confirm.role.clearsRestriction": { name: string };
  "members.confirm.transfer.title": { name: string };
  "members.confirm.transfer.body": NoParams;
  "members.confirm.revoke.title": { email: string };
  "members.confirm.revokeLink.title": NoParams;
  "members.confirm.revoke.body": NoParams;
  "members.notice.deactivated": { name: string };
  "members.notice.reactivated": { name: string };
  "members.notice.transferred": { name: string };
  "members.notice.scopeSaved": { name: string };
  "members.notice.revoked": NoParams;
  "members.notice.resent": NoParams;
  "members.notice.newLink": NoParams;
  "members.notice.failed": NoParams;
  "members.sponsor": { name: string };
  "members.accessEnds": { date: string };
  "members.accessEnded": NoParams;
  "members.noEnd": NoParams;
  "invites.pending": NoParams;
  "invites.none": NoParams;
  "invites.link": NoParams;
  "invites.uses": { count: number };
  "invites.expires": { date: string };
  "invites.onlyYours": NoParams;
  "guests.title": NoParams;
  "guests.none": NoParams;
  "guests.agentsNone": NoParams;
  "scope.title": { name: string };
  "scope.makeGuestTitle": { name: string };
  "scope.makeGuestBody": NoParams;
  "scope.sponsor": NoParams;
  "scope.organization": NoParams;
  "scope.expiry": NoParams;
  "scope.expiry.keep": { date: string };
  "scope.expiry.never": NoParams;
  "scope.expiry.days": { count: number };
  "scope.can": NoParams;
  "scope.can.createChannels": NoParams;
  "scope.can.invite": NoParams;
  "scope.can.search": NoParams;
  "scope.can.downloadFiles": NoParams;
  "scope.can.joinHuddles": NoParams;
  "scope.can.mentionBroadcast": NoParams;
  "scope.can.seeEmails": NoParams;
  "scope.dm": NoParams;
  "scope.dm.anyone": NoParams;
  "scope.dm.sharedChannels": NoParams;
  "scope.dm.sponsorOnly": NoParams;
  "scope.dm.none": NoParams;
  "scope.directory": NoParams;
  "scope.directory.all": NoParams;
  "scope.directory.shared": NoParams;
  "scope.save": NoParams;
  "scope.makeGuest": NoParams;
  "profileCard.message": NoParams;
  "profileCard.localTime": { time: string };
  "profileCard.editProfile": NoParams;
  "profileCard.title": { name: string };
  "members.notice.nowOwner": { name: string };
  "members.notice.nowAdmin": { name: string };
  "members.notice.nowMember": { name: string };
  "members.notice.nowGuest": { name: string };
  "handle.problem.tooShort": NoParams;
  "handle.problem.tooLong": NoParams;
  "handle.problem.characters": NoParams;
  "handle.problem.edges": NoParams;
  "handle.problem.reserved": NoParams;
  "handle.problem.taken": NoParams;
  "profile.handle": NoParams;
  "profile.handle.hint": { handle: string };
  "profile.handle.checking": NoParams;
  "profile.handle.available": { handle: string };
  "profile.handle.try": NoParams;
  "profile.avatar.change": NoParams;
  "profile.avatar.title": NoParams;
  "profile.avatar.photo": NoParams;
  "profile.avatar.initials": NoParams;
  "profile.avatar.emoji": NoParams;
  "profile.avatar.color": NoParams;
  "profile.avatar.colorOption": { n: string };
  "profile.avatar.pickEmoji": NoParams;
  "profile.avatar.use": NoParams;
  "profile.avatar.saved": NoParams;
  "profile.copyLink": NoParams;
  "profile.linkCopied": NoParams;
  "sharing.share": NoParams;
  "sharing.dialog.title": NoParams;
  "sharing.level.full": NoParams;
  "sharing.level.edit": NoParams;
  "sharing.level.comment": NoParams;
  "sharing.level.view": NoParams;
  "sharing.level.full.description": NoParams;
  "sharing.level.edit.description": NoParams;
  "sharing.level.comment.description": NoParams;
  "sharing.level.view.description": NoParams;
  "sharing.general.title": NoParams;
  "sharing.general.invitedOnly": NoParams;
  "sharing.general.everyone": { workspace: string };
  "sharing.general.noAccess": NoParams;
  "sharing.general.invitedOnly.description": NoParams;
  "sharing.general.everyone.description": { workspace: string };
  "sharing.general.privateShared": NoParams;
  "sharing.source.owner": NoParams;
  "sharing.source.admin": NoParams;
  "sharing.source.creator": NoParams;
  "sharing.source.inherited": { page: string };
  "sharing.source.inheritedUntitled": NoParams;
  "sharing.publish.off": NoParams;
  "sharing.publish.adminsOnly": NoParams;
  "sharing.indicator.public": NoParams;
  "sharing.indicator.workspace": NoParams;
  "sharing.indicator.private": NoParams;
  "sharing.indicator.sharedWith": { count: number };
  "sharing.expiry.never": NoParams;
  "sharing.expiry.days": { count: number };
  "sharing.expiry.on": { date: string };
  "sharing.invite.placeholder": NoParams;
  "sharing.invite.button": NoParams;
  "sharing.invite.asGuest": NoParams;
  "sharing.invite.guestNote": { email: string };
  "sharing.invite.guestExpiry": NoParams;
  "sharing.invite.hasAccess": NoParams;
  "sharing.invite.noMatches": NoParams;
  "sharing.invite.sent": NoParams;
  "sharing.invite.guestLink": NoParams;
  "sharing.people.title": NoParams;
  "sharing.people.you": { name: string };
  "sharing.people.guest": NoParams;
  "sharing.people.agent": NoParams;
  "sharing.people.remove": NoParams;
  "sharing.people.change": { name: string };
  "sharing.comment.note": NoParams;
  "sharing.publish.title": NoParams;
  "sharing.publish.description": NoParams;
  "sharing.publish.toggle": NoParams;
  "sharing.publish.link": NoParams;
  "sharing.publish.copy": NoParams;
  "sharing.publish.open": NoParams;
  "sharing.publish.indexing": NoParams;
  "sharing.publish.duplicate": NoParams;
  "sharing.publish.subpages": NoParams;
  "sharing.publish.expiry": NoParams;
  "sharing.publish.revokeNote": NoParams;
  "sharing.publish.needsFull": NoParams;
  "sharing.copyLink": NoParams;
  "sharing.copied": NoParams;
  "sharing.error.lastFullAccess": NoParams;
  "sharing.error.generic": NoParams;
  "sharing.error.alreadyMember": NoParams;
  "sharing.loading": NoParams;
  "sharing.settings.title": NoParams;
  "sharing.settings.description": NoParams;
  "sharing.settings.publicPages": NoParams;
  "sharing.settings.publicFiles": NoParams;
  "sharing.settings.editorsCanShare": NoParams;
  "sharing.settings.policy.members": NoParams;
  "sharing.settings.policy.admins": NoParams;
  "sharing.settings.policy.off": NoParams;
  "sharing.settings.offNote": NoParams;
  "sharing.settings.saved": NoParams;
  "sharing.settings.publicFilesHint": NoParams;
  "sharing.settings.filesOff.title": NoParams;
  "sharing.settings.filesOff.body": NoParams;
  "sharing.settings.filesOff.confirm": NoParams;
  "sharing.settings.publicFilesActive": { count: number };
  "sharing.settings.filesOff.bodyCount": { count: number };
  "page.menu.more": NoParams;
  "page.menu.copyLink": NoParams;
  "page.menu.moveTo": NoParams;
  "page.menu.lock": NoParams;
  "page.menu.unlock": NoParams;
  "page.menu.export": NoParams;
  "page.menu.trash": NoParams;
  "page.favorite.add": NoParams;
  "page.favorite.remove": NoParams;
  "page.locked": NoParams;
  "page.lockedNote": NoParams;
  "page.moveTo.title": NoParams;
  "page.moveTo.search": NoParams;
  "page.moveTo.workspace": NoParams;
  "page.moveTo.private": NoParams;
  "docs.section.shared": NoParams;
  "docs.badge.public": NoParams;
  "docs.badge.shared": NoParams;
  "docs.badge.restricted": NoParams;
  "publicPage.notFound.title": NoParams;
  "publicPage.notFound.body": NoParams;
  "publicPage.footer": NoParams;
  "publicPage.duplicate": NoParams;
  "publicPage.duplicateNote": NoParams;
  "publicPage.someone": NoParams;
  "publicPage.unavailableBlock": NoParams;
  "publicPage.rateLimited": NoParams;
  "publicDrive.signIn": NoParams;
  "publicDrive.footer": NoParams;
  "publicDrive.sharedBy": { owner: string };
  "publicDrive.itemCount": { count: number };
  "publicDrive.notFound.title": NoParams;
  "publicDrive.notFound.body": NoParams;
  "publicDrive.empty": NoParams;
  "publicDrive.path": NoParams;
  "publicDrive.openInBundle": NoParams;
  "publicDrive.signInNeeded": NoParams;
  "publicDrive.downloadName": { name: string };
  "publicDrive.back": NoParams;
  "publicDrive.report.open": NoParams;
  "publicDrive.report.title": NoParams;
  "publicDrive.report.body": NoParams;
  "publicDrive.report.reason": NoParams;
  "publicDrive.report.reasonPlaceholder": NoParams;
  "publicDrive.report.reason.spam": NoParams;
  "publicDrive.report.reason.malware": NoParams;
  "publicDrive.report.reason.phishing": NoParams;
  "publicDrive.report.reason.sexual": NoParams;
  "publicDrive.report.reason.violence": NoParams;
  "publicDrive.report.reason.hate": NoParams;
  "publicDrive.report.reason.harassment": NoParams;
  "publicDrive.report.reason.copyright": NoParams;
  "publicDrive.report.reason.personalInfo": NoParams;
  "publicDrive.report.reason.other": NoParams;
  "publicDrive.report.note": NoParams;
  "publicDrive.report.notePlaceholder": NoParams;
  "publicDrive.report.submit": NoParams;
  "publicDrive.report.sent": NoParams;
  "publicDrive.report.done": NoParams;
  "publicDrive.report.failed": NoParams;
  "files.share": NoParams;
  "files.share.title": NoParams;
  "files.share.to": NoParams;
  "files.share.pick": NoParams;
  "files.share.message": NoParams;
  "files.share.send": NoParams;
  "files.share.sent": { name: string };
  "files.share.noDownload": NoParams;
  "files.share.publicLink": NoParams;
  "files.share.publicLink.description": NoParams;
  "files.share.publicLink.create": NoParams;
  "files.share.publicLink.revoke": NoParams;
  "files.share.publicLink.copy": NoParams;
  "files.share.publicLink.adminsOnly": NoParams;
  "files.share.publicLink.off": NoParams;
  "files.share.access": NoParams;
  "files.share.error": NoParams;
  "files.access.anyone": NoParams;
  "files.access.anyoneHint": NoParams;
  "files.access.anyoneOff": NoParams;
  "files.access.anyoneAdmins": NoParams;
  "files.access.workspaceHint": NoParams;
  "files.access.anyoneMembers": { workspace: string; role: string };
  "files.openWith": NoParams;
  "files.opening": { name: string };
  "files.noApp": { name: string };
  "templates.title": NoParams;
  "templates.open": NoParams;
  "templates.browse": NoParams;
  "templates.newFromTemplate": NoParams;
  "templates.search": NoParams;
  "templates.filter.all": NoParams;
  "templates.filter.saved": NoParams;
  "templates.category.projects": NoParams;
  "templates.category.meetings": NoParams;
  "templates.category.knowledge": NoParams;
  "templates.category.personal": NoParams;
  "templates.category.business": NoParams;
  "templates.section.saved": NoParams;
  "templates.results": NoParams;
  "templates.empty": { query: string };
  "templates.use": NoParams;
  "templates.destination": NoParams;
  "templates.destination.workspace": NoParams;
  "templates.destination.private": NoParams;
  "templates.destination.inside": { title: string };
  "templates.startEmpty": NoParams;
  "templates.startEmpty.hint": NoParams;
  "templates.scope.builtin": NoParams;
  "templates.scope.workspace": NoParams;
  "templates.scope.personal": NoParams;
  "templates.preview.rows": { count: number };
  "templates.preview.views": NoParams;
  "templates.preview.properties": NoParams;
  "templates.preview.rowTemplates": NoParams;
  "templates.preview.creates": NoParams;
  "templates.preview.none": NoParams;
  "templates.edit": NoParams;
  "templates.rename": NoParams;
  "templates.delete": NoParams;
  "templates.delete.confirm": { name: string };
  "templates.loadFailed": NoParams;
  "templates.useFailed": NoParams;
  "templates.save.title": NoParams;
  "templates.save.name": NoParams;
  "templates.save.description": NoParams;
  "templates.save.category": NoParams;
  "templates.save.scope": NoParams;
  "templates.save.scope.workspace": NoParams;
  "templates.save.scope.personal": NoParams;
  "templates.save.includeRows": NoParams;
  "templates.save.submit": NoParams;
  "templates.save.saved": { name: string };
  "templates.save.failed": NoParams;
  "templates.save.workspaceAdminsOnly": NoParams;
  "templates.settings.creators": NoParams;
  "templates.settings.admins": NoParams;
  "templates.settings.members": NoParams;
  "templates.editing.banner": { name: string };
  "templates.editing.rowBanner": { name: string };
  "templates.editing.readOnly": NoParams;
  "templates.editing.done": NoParams;
  "templates.duplicate": NoParams;
  "templates.duplicateFailed": NoParams;
  "templates.saveAs": NoParams;
  "templates.rowTemplates.menu": NoParams;
  "templates.rowTemplates.newOptions": NoParams;
  "templates.rowTemplates.empty": NoParams;
  "templates.rowTemplates.new": NoParams;
  "templates.rowTemplates.fromRow": NoParams;
  "templates.rowTemplates.default": NoParams;
  "templates.rowTemplates.setDefault": NoParams;
  "templates.rowTemplates.clearDefault": NoParams;
  "templates.rowTemplates.edit": NoParams;
  "templates.rowTemplates.delete": NoParams;
  "templates.rowTemplates.untitled": NoParams;
  "templates.rowTemplates.newName": NoParams;
  "templates.rowTemplates.defaults": NoParams;
  "templates.rowTemplates.defaults.hint": NoParams;
  "templates.rowTemplates.name": NoParams;
  "templates.rowTemplates.clear": NoParams;
  "templates.rowTemplates.failed": NoParams;
  "legal.agreement": { terms: string; privacy: string };
  "legal.terms": NoParams;
  "legal.privacy": NoParams;
  "legal.title": NoParams;
  "summary.title": NoParams;
  "summary.aiLabel": NoParams;
  "summary.updated.justNow": NoParams;
  "summary.updated.minutes": { count: number };
  "summary.updated.hours": { count: number };
  "summary.updated.days": { count: number };
  "summary.empty": NoParams;
  "summary.summarize": NoParams;
  "summary.refresh": NoParams;
  "summary.loading": NoParams;
  "summary.failed": NoParams;
  "summary.stale": NoParams;
  "summary.collapse": NoParams;
  "summary.expand": NoParams;
  "workspace.settings.aiSummaries": NoParams;
  "workspace.settings.aiSummariesHint": NoParams;
  "workspace.settings.unfurls": NoParams;
  "workspace.settings.unfurlsHint": NoParams;
  "workspace.settings.mailSentWith": NoParams;
  "workspace.settings.mailSentWithHint": { workspace: string };
  "settings.nav.import": NoParams;
  "import.title": NoParams;
  "import.body": NoParams;
  "import.source": NoParams;
  "import.via": NoParams;
  "import.via.file": NoParams;
  "import.via.token": NoParams;
  "import.slack.file.step1": NoParams;
  "import.slack.file.step2": NoParams;
  "import.slack.file.step3": NoParams;
  "import.slack.token.step1": NoParams;
  "import.slack.token.step2": NoParams;
  "import.slack.token.step3": NoParams;
  "import.notion.file.step1": NoParams;
  "import.notion.file.step2": NoParams;
  "import.notion.file.step3": NoParams;
  "import.notion.token.step1": NoParams;
  "import.notion.token.step2": NoParams;
  "import.notion.token.step3": NoParams;
  "import.slack.token.createApp": NoParams;
  "import.notion.token.open": NoParams;
  "import.slack.token.label": NoParams;
  "import.notion.token.label": NoParams;
  "import.token.kept": NoParams;
  "import.connect": NoParams;
  "import.drop.slack": NoParams;
  "import.drop.notion": NoParams;
  "import.drop.hint": NoParams;
  "import.uploading": { name: string };
  "import.uploadProgress": NoParams;
  "import.cancel": NoParams;
  "import.recent": NoParams;
  "import.recent.empty": NoParams;
  "import.open": NoParams;
  "import.status.scanning": NoParams;
  "import.status.review": NoParams;
  "import.status.importing": NoParams;
  "import.status.done": NoParams;
  "import.status.failed": NoParams;
  "import.status.cancelled": NoParams;
  "import.phase.reading": NoParams;
  "import.phase.sorting": NoParams;
  "import.phase.listing": NoParams;
  "import.phase.channels": NoParams;
  "import.phase.messages": NoParams;
  "import.phase.files": NoParams;
  "import.phase.pages": NoParams;
  "import.phase.finishing": NoParams;
  "import.job.slack": { label: string };
  "import.job.notion": { label: string };
  "import.back": NoParams;
  "import.stop": NoParams;
  "import.running.note": NoParams;
  "import.discard": NoParams;
  "import.start": NoParams;
  "import.done.title": NoParams;
  "import.done.body": NoParams;
  "import.failed.title": NoParams;
  "import.failed.body": NoParams;
  "import.cancelled": NoParams;
  "import.openPages": NoParams;
  "import.result.channels": { count: number };
  "import.result.messages": { count: number };
  "import.result.files": { count: number };
  "import.result.pages": { count: number };
  "import.result.databases": { count: number };
  "import.result.rows": { count: number };
  "import.result.skipped": { count: number };
  "import.trash.button": NoParams;
  "import.trash.title": { what: string };
  "import.trash.and": { first: string; second: string };
  "import.trash.body": { rows: string; files: string };
  "import.trash.kept": { count: number };
  "import.trash.nothing": NoParams;
  "import.trash.failed": NoParams;
  "import.delete.button": NoParams;
  "import.delete.title": { what: string };
  "import.delete.body": { rows: string; files: string };
  "import.delete.nothing": NoParams;
  "import.delete.failed": NoParams;
  "import.source.googleDrive": NoParams;
  "import.source.googleDriveHint": NoParams;
  "import.drive.title": NoParams;
  "import.drive.heading": { domain: string };
  "import.drive.managersOnly": NoParams;
  "import.drive.noGoogle": NoParams;
  "import.drive.connect.title": NoParams;
  "import.drive.connect.body": NoParams;
  "import.drive.connect.button": NoParams;
  "import.drive.connect.how": NoParams;
  "import.drive.connected": { date: string; people: string };
  "import.drive.mailSettings": NoParams;
  "import.drive.scope.title": NoParams;
  "import.drive.scope.body": NoParams;
  "import.drive.scope.step1": NoParams;
  "import.drive.scope.step2": { clientId: string };
  "import.drive.scope.step2Own": NoParams;
  "import.drive.scope.step3": NoParams;
  "import.drive.scope.clientId": NoParams;
  "import.drive.scope.scope": NoParams;
  "import.drive.scope.all": NoParams;
  "import.drive.scope.allHint": NoParams;
  "import.drive.scope.copy": NoParams;
  "import.drive.scope.copyAll": NoParams;
  "import.drive.scope.copied": NoParams;
  "import.drive.scope.check": NoParams;
  "import.drive.scope.checked": { time: string };
  "import.drive.ready.title": { domain: string };
  "import.drive.ready.body": NoParams;
  "import.drive.ready.button": NoParams;
  "import.drive.scan.title": NoParams;
  "import.drive.scan.body": NoParams;
  "import.drive.scan.cancel": NoParams;
  "import.drive.review.read": { time: string; people: string; drives: string };
  "import.drive.review.total": { size: string };
  "import.drive.review.from": { people: string; drives: string };
  "import.drive.review.thisImport": { size: string };
  "import.drive.review.left": { size: string };
  "import.drive.review.over": { size: string };
  "import.drive.review.manageStorage": NoParams;
  "import.drive.review.sharedSizes": NoParams;
  "import.drive.review.people": NoParams;
  "import.drive.review.peopleHint": NoParams;
  "import.drive.review.peoplePicked": { picked: string; members: string };
  "import.drive.review.account": NoParams;
  "import.drive.review.inBundle": NoParams;
  "import.drive.review.size": NoParams;
  "import.drive.review.notInBundle": NoParams;
  "import.drive.review.inviteFirst": NoParams;
  "import.drive.review.invite": NoParams;
  "import.drive.review.include": { name: string };
  "import.drive.review.all": NoParams;
  "import.drive.review.none": NoParams;
  "import.drive.review.sharedDrives": NoParams;
  "import.drive.review.sharedDrivesHint": NoParams;
  "import.drive.review.members": { count: number };
  "import.drive.review.cantRead": NoParams;
  "import.drive.review.noSharedDrives": NoParams;
  "import.drive.review.filesTitle": NoParams;
  "import.drive.review.files1": NoParams;
  "import.drive.review.files2": NoParams;
  "import.drive.review.files3": NoParams;
  "import.drive.review.files4": NoParams;
  "import.drive.review.files5": { domain: string };
  "import.drive.review.files6": NoParams;
  "import.drive.review.sharingTitle": NoParams;
  "import.drive.review.sharing1": NoParams;
  "import.drive.review.sharing2": { domain: string };
  "import.drive.review.sharing3": NoParams;
  "import.drive.review.sharing4": NoParams;
  "import.drive.review.footer": { size: string };
  "import.drive.review.discard": NoParams;
  "import.drive.review.readAgain": NoParams;
  "import.drive.review.start": NoParams;
  "import.drive.run.title": { percent: string };
  "import.drive.run.listing": NoParams;
  "import.drive.run.counts": { done: string; total: string; size: string };
  "import.drive.run.countsUnknown": { done: string; size: string };
  "import.drive.run.cancel": NoParams;
  "import.drive.run.body": NoParams;
  "import.drive.run.units": NoParams;
  "import.drive.run.sharedDrive": NoParams;
  "import.drive.unit.waiting": NoParams;
  "import.drive.unit.listing": NoParams;
  "import.drive.unit.copying": { done: string; total: string };
  "import.drive.unit.done": { items: string };
  "import.drive.unit.attention": NoParams;
  "import.drive.run.problems": { count: number };
  "import.drive.run.seeAll": NoParams;
  "import.drive.problem.tooBig": NoParams;
  "import.drive.problem.notCopyable": NoParams;
  "import.drive.problem.exportFailed": NoParams;
  "import.drive.problem.refused": NoParams;
  "import.drive.problem.gone": NoParams;
  "import.drive.problem.shortcutTarget": NoParams;
  "import.drive.problem.folderMissing": NoParams;
  "import.drive.problem.storageFull": NoParams;
  "import.drive.problem.failed": NoParams;
  "import.drive.problem.open": NoParams;
  "import.drive.problems.title": NoParams;
  "import.drive.problems.body": { count: number };
  "import.drive.problems.all": NoParams;
  "import.drive.problems.csv": NoParams;
  "import.drive.problems.tryAgain": NoParams;
  "import.drive.problems.tryAgainHint": NoParams;
  "import.drive.problems.empty": NoParams;
  "import.drive.problems.truncated": { count: string };
  "import.drive.done.title": NoParams;
  "import.drive.done.attention": NoParams;
  "import.drive.done.cancelled": NoParams;
  "import.drive.done.failed": NoParams;
  "import.drive.done.summary": { files: string; folders: string; size: string };
  "import.drive.review.outsideCount": { count: number };
  "import.drive.count.people": { count: number };
  "import.drive.count.sharedDrives": { count: number };
  "import.drive.count.files": { count: number };
  "import.drive.count.folders": { count: number };
  "import.drive.count.items": { count: number };
  "import.drive.done.sharedDrives": { count: number };
  "import.drive.done.notCopied": { count: number };
  "import.drive.done.storageFull": { count: number };
  "import.drive.done.openFiles": NoParams;
  "import.drive.done.again": NoParams;
  "import.drive.done.againHint": NoParams;
  "import.drive.done.undoTitle": NoParams;
  "import.drive.done.undoBody": NoParams;
  "import.drive.trash.body": NoParams;
  "import.drive.trash.kept": { count: number };
  "import.drive.delete.body": NoParams;
  "import.drive.undo.trashing": { done: string; total: string };
  "import.drive.undo.deleting": { done: string; total: string };
  "import.drive.undo.trashed": NoParams;
  "import.drive.undo.deleted": NoParams;
  "import.drive.undo.stopped": { done: string; total: string };
  "import.drive.banner": { percent: string };
  "import.drive.banner.open": NoParams;
  "import.timeline.driveUnit": { name: string };
  "import.timeline.driveUnitDone": { name: string; files: string; folders: string };
  "import.timeline.driveUnitAttention": { name: string; message: string };
  "import.timeline.driveShortcuts": { count: string };
  "import.undo.trashing": { done: string; total: string };
  "import.undo.trashed": NoParams;
  "import.undo.deleting": { done: string; total: string };
  "import.undo.deleted": NoParams;
  "import.undo.failed": { done: string; total: string };
  "import.slack.summary": { channels: string; dms: string; matched: string; invite: string; guest: string; deactivated: string };
  "import.slack.publicOnly": NoParams;
  "import.slack.copyFiles": NoParams;
  "import.slack.people": NoParams;
  "import.slack.people.body": NoParams;
  "import.slack.nameOnly": NoParams;
  "import.slack.matchFor": { name: string };
  "import.slack.deactivated": NoParams;
  "import.slack.channels": NoParams;
  "import.slack.channels.body": NoParams;
  "import.slack.include": { name: string };
  "import.slack.rename": { name: string };
  "import.slack.merges": NoParams;
  "import.slack.archived": NoParams;
  "import.slack.duplicateNames": { names: string };
  "import.slack.dms": NoParams;
  "import.slack.dms.body": NoParams;
  "import.slack.allDms": { count: number };
  "import.notion.summary": { pages: string; databases: string };
  "import.notion.ai.title": NoParams;
  "import.notion.ai.body": NoParams;
  "import.notion.ai.unavailable": NoParams;
  "import.notion.ai.failed": NoParams;
  "import.notion.sectionName": NoParams;
  "import.notion.shared": NoParams;
  "import.notion.private": NoParams;
  "import.notion.visibility": NoParams;
  "import.notion.removeSection": NoParams;
  "import.notion.emptySection": NoParams;
  "import.notion.topLevel": NoParams;
  "import.notion.topLevel.body": NoParams;
  "import.notion.addSection": NoParams;
  "import.notion.newSection": NoParams;
  "import.notion.untitledSection": NoParams;
  "import.notion.nameSections": NoParams;
  "import.notion.untitled": NoParams;
  "import.notion.renamed": { title: string };
  "import.notion.rows": { count: number };
  "import.notion.subpages": { count: number };
  "import.notion.view": { name: string };
  "import.notion.moveTo": { name: string };
  "import.notion.layout.table": NoParams;
  "import.notion.layout.board": NoParams;
  "import.notion.layout.list": NoParams;
  "import.notion.layout.calendar": NoParams;
  "import.notion.layout.sheet": NoParams;
  "import.slackApp.title": NoParams;
  "import.slackApp.body": NoParams;
  "import.slackApp.step1": NoParams;
  "import.slackApp.step2": NoParams;
  "import.slackApp.clientId": NoParams;
  "import.slackApp.clientSecret": NoParams;
  "import.slackApp.save": NoParams;
  "import.slackApp.connected": { clientId: string };
  "import.slackApp.saved": NoParams;
  "import.slackApp.failed": NoParams;
  "import.sync.title": NoParams;
  "import.sync.body": NoParams;
  "import.sync.toggle": NoParams;
  "import.sync.tokenNote": NoParams;
  "import.sync.tokenLabel": NoParams;
  "import.sync.turnOn": NoParams;
  "import.sync.never": NoParams;
  "import.sync.running": NoParams;
  "import.sync.last": { count: number; time: string };
  "import.sync.lastFailed": { time: string; error: string };
  "import.sync.paused": NoParams;
  "import.sync.now": NoParams;
  "import.sync.finish": NoParams;
  "import.sync.finishNote": NoParams;
  "import.sync.finished": NoParams;
  "import.sync.failed": NoParams;
  "import.sync.badToken": NoParams;
  "import.personal.title": NoParams;
  "import.personal.body": NoParams;
  "import.personal.connect": NoParams;
  "import.personal.notConfigured": NoParams;
  "import.personal.connectFailed": NoParams;
  "import.personal.guests": NoParams;
  "import.personal.summary": { dms: string; channels: string };
  "import.destination.title": NoParams;
  "import.destination.body": NoParams;
  "import.destination.new": NoParams;
  "import.destination.name": NoParams;
  "import.destination.create": NoParams;
  "import.destination.cancel": NoParams;
  "import.destination.failed": NoParams;
  "import.notion.reviewTitle": NoParams;
  "import.notion.reviewBody": NoParams;
  "import.notion.workspace": NoParams;
  "import.notion.sees": { pages: string; databases: string };
  "import.notion.readAgain": NoParams;
  "import.notion.missingPages": NoParams;
  "import.notion.what": NoParams;
  "import.notion.what.body": NoParams;
  "import.notion.databases": NoParams;
  "import.notion.page": NoParams;
  "import.notion.leftOut": NoParams;
  "import.notion.moveToNew": NoParams;
  "import.notion.willImport": { picked: string; total: string };
  "import.notion.importCount": { count: number };
  "import.notion.selectAll": NoParams;
  "import.notion.picked": { picked: string; total: string };
  "import.notion.pages": NoParams;
  "import.notion.noSection": NoParams;
  "import.notion.noSection.body": NoParams;
  "import.notion.database": NoParams;
  "import.notion.showAs": { layout: string };
  "import.notion.moveToNone": NoParams;
  "import.notion.moveToSection": { section: string };
  "import.notion.options": { name: string };
  "import.notion.nothingPicked": NoParams;
  "import.managersOnly": NoParams;
  "import.notZip": NoParams;
  "import.busy": NoParams;
  "import.uploadFailed": NoParams;
  "import.startFailed": NoParams;
  "import.loadFailed": NoParams;
  "import.cancelFailed": NoParams;
  "import.chooseFile": NoParams;
  "nav.mail": NoParams;
  "nav.docs": NoParams;
  "nav.files": NoParams;
  "nav.contacts": NoParams;
  "settings.nav.mail": NoParams;
  "mail.title": NoParams;
  "mail.tab.email": NoParams;
  "mail.tab.clients": NoParams;
  "mail.tab.team": NoParams;
  "mail.tab.promotions": NoParams;
  "mail.tab.updates": NoParams;
  "mail.tab.new": { count: string };
  "mail.updating": NoParams;
  "mail.updated.justNow": NoParams;
  "mail.updated.minutes": { count: string };
  "mail.updated.hours": { count: string };
  "mail.updated.days": { count: string };
  "mail.tab.priority": NoParams;
  "mail.action.markPriority": NoParams;
  "mail.action.notPriority": NoParams;
  "mail.priority.waiting": NoParams;
  "mail.priority.waitingOn": { name: string };
  "mail.priority.starred": NoParams;
  "mail.priority.marked": NoParams;
  "mail.priority.sender": { name: string };
  "mail.priority.reminder": { count: number };
  "mail.priority.marker": { reason: string };
  "mail.priority.unmarkHint": { name: string };
  "mail.priority.markHint": { name: string };
  "mail.priority.footer": NoParams;
  "mail.empty.priority.title": NoParams;
  "mail.empty.priority.body": NoParams;
  "mail.empty.priority.goTab": { tab: string };
  "mail.folder.inbox": NoParams;
  "mail.folder.sent": NoParams;
  "mail.folder.archive": NoParams;
  "mail.folder.trash": NoParams;
  "mail.folder.spam": NoParams;
  "mail.search.all": NoParams;
  "mail.search.filter.mailbox": NoParams;
  "mail.search.value.mailbox": NoParams;
  "mail.filter.title": NoParams;
  "mail.filter.mailbox": NoParams;
  "mail.filter.allMailboxes": NoParams;
  "mail.filter.myMailboxes": NoParams;
  "mail.filter.groups": NoParams;
  "mail.filter.groupRow": { address: string };
  "mail.filter.showOnly": NoParams;
  "mail.filter.unread": NoParams;
  "mail.filter.starred": NoParams;
  "mail.filter.attachment": NoParams;
  "mail.filter.from": NoParams;
  "mail.filter.fromPlaceholder": NoParams;
  "mail.filter.date": NoParams;
  "mail.filter.date.today": NoParams;
  "mail.filter.date.week": NoParams;
  "mail.filter.date.month": NoParams;
  "mail.filter.label": NoParams;
  "mail.filter.anyone": NoParams;
  "mail.filter.anyTime": NoParams;
  "mail.filter.any": NoParams;
  "mail.filter.apply": NoParams;
  "mail.filter.clear": NoParams;
  "mail.filter.clearAll": NoParams;
  "mail.filter.empty": NoParams;
  "mail.filter.show": { count: number };
  "mail.filter.showMore": { count: string };
  "mail.recent.title": NoParams;
  "mail.recent.clear": NoParams;
  "mail.recent.remove": NoParams;
  "mail.recent.empty": NoParams;
  "mail.recent.filterBy": NoParams;
  "mail.recent.close": NoParams;
  "mail.recent.swipeHint": NoParams;
  "mail.search.placeholder": NoParams;
  "mail.search.filter.from": NoParams;
  "mail.search.filter.to": NoParams;
  "mail.search.filter.domain": NoParams;
  "mail.search.filter.in": NoParams;
  "mail.search.filter.has": NoParams;
  "mail.search.filter.is": NoParams;
  "mail.search.filter.before": NoParams;
  "mail.search.filter.after": NoParams;
  "mail.search.filter.or": NoParams;
  "mail.search.value.domain": NoParams;
  "mail.search.value.folder": NoParams;
  "mail.search.value.label": NoParams;
  "mail.search.value.attachment": NoParams;
  "mail.search.value.unread": NoParams;
  "mail.search.value.read": NoParams;
  "mail.search.value.starred": NoParams;
  "mail.search.suggest.people": NoParams;
  "mail.search.suggest.domains": NoParams;
  "mail.search.suggest.folders": NoParams;
  "mail.search.mode.like": NoParams;
  "mail.search.mode.exact": NoParams;
  "mail.search.mode.exclude": NoParams;
  "mail.search.chip.remove": { filter: string };
  "mail.search.chip.or": NoParams;
  "mail.compose": NoParams;
  "mail.empty.tab": { tab: string };
  "mail.empty.folder": NoParams;
  "mail.empty.search": { query: string };
  "mail.noMailbox.title": NoParams;
  "mail.noMailbox.body": NoParams;
  "mail.noMailbox.adminBody": NoParams;
  "mail.noMailbox.setup": NoParams;
  "mail.loadFailed": NoParams;
  "mail.thread.textFailed": NoParams;
  "mail.retry": NoParams;
  "mail.loadMore": NoParams;
  "mail.action.reply": NoParams;
  "mail.action.replyAll": NoParams;
  "mail.action.replyAllShort": NoParams;
  "mail.action.forward": NoParams;
  "mail.action.archive": NoParams;
  "mail.action.trash": NoParams;
  "mail.action.spam": NoParams;
  "mail.action.notSpam": NoParams;
  "mail.action.moveToInbox": NoParams;
  "mail.action.markRead": NoParams;
  "mail.action.markUnread": NoParams;
  "mail.action.star": NoParams;
  "mail.action.unstar": NoParams;
  "mail.action.moveToTab": NoParams;
  "mail.action.loadImages": NoParams;
  "mail.imagesBlocked": NoParams;
  "mail.view.original": NoParams;
  "mail.view.reading": NoParams;
  "mail.view.setting.title": NoParams;
  "mail.view.setting.original": NoParams;
  "mail.view.setting.originalHelp": NoParams;
  "mail.view.setting.reading": NoParams;
  "mail.view.setting.readingHelp": NoParams;
  "mail.view.setting.help": NoParams;
  "mail.warning.suspicious": NoParams;
  "mail.code.label": NoParams;
  "mail.code.from": { sender: string; time: string };
  "mail.code.copy": NoParams;
  "mail.code.copied": NoParams;
  "mail.code.copiedToast": NoParams;
  "mail.code.copyNamed": { code: string };
  "mail.code.spam": { sender: string };
  "mail.code.unverified": NoParams;
  "home.briefing.codes": { count: number };
  "home.briefing.copy": NoParams;
  "mail.needsReply": NoParams;
  "mail.auth.pass": NoParams;
  "mail.auth.fail": NoParams;
  "mail.to": { names: string };
  "mail.me": NoParams;
  "mail.attachment.cancel": { name: string };
  "mail.attachment.failedNamed": { name: string };
  "mail.attachment.offlineNamed": { name: string };
  "mail.attachment.saved": { name: string };
  "mail.attachment.saveFailed": { name: string };
  "mail.attachment.downloading": { name: string };
  "mail.attachment.opening": { name: string };
  "mail.attachment.openNamed": { name: string };
  "mail.attachment.downloadNamed": { name: string };
  "mail.attachment.savedToDownloads": { name: string };
  "mail.attachment.showInFolder": NoParams;
  "mail.attachment.offline": NoParams;
  "mail.attachment.failed": NoParams;
  "mail.attachment.open": NoParams;
  "mail.attachment.share": NoParams;
  "mail.attachment.saveToFiles": NoParams;
  "mail.attachments": { count: number };
  "mail.status.queued": NoParams;
  "mail.status.failed": NoParams;
  "mail.status.bounced": NoParams;
  "mail.compose.new": NoParams;
  "mail.compose.assist": NoParams;
  "mail.compose.assistFailed": NoParams;
  "mail.compose.assisting": NoParams;
  "mail.compose.linkAddress": NoParams;
  "mail.compose.linkApply": NoParams;
  "mail.compose.linkRemove": NoParams;
  "mail.compose.formatting": NoParams;
  "mail.compose.minimize": NoParams;
  "mail.compose.restore": NoParams;
  "mail.compose.expand": NoParams;
  "mail.compose.collapse": NoParams;
  "mail.compose.from": NoParams;
  "mail.compose.to": NoParams;
  "mail.compose.recipient.edit": { name: string };
  "mail.compose.recipient.removeInvalid": { name: string };
  "mail.compose.cc": NoParams;
  "mail.compose.bcc": NoParams;
  "mail.compose.subject": NoParams;
  "mail.compose.body": NoParams;
  "mail.compose.attach": NoParams;
  "mail.compose.send": NoParams;
  "mail.compose.toLabel": NoParams;
  "mail.compose.subjectLabel": NoParams;
  "mail.compose.saySomething": NoParams;
  "mail.compose.noSignature": NoParams;
  "mail.compose.signatureOptions": NoParams;
  "mail.compose.signatureEdit": NoParams;
  "mail.compose.signatureRemove": NoParams;
  "mail.compose.sentWithRemove": NoParams;
  "mail.compose.sentWithAdd": NoParams;
  "mail.compose.formatDone": NoParams;
  "mail.compose.translate": NoParams;
  "mail.compose.textStyle": NoParams;
  "mail.compose.templates": NoParams;
  "mail.compose.saveTemplate": NoParams;
  "mail.compose.remind": NoParams;
  "mail.compose.remindOff": NoParams;
  "mail.compose.remindAt": { time: string };
  "mail.compose.addContact": NoParams;
  "mail.compose.findContact": NoParams;
  "mail.compose.ai": NoParams;
  "mail.compose.ai.draft": NoParams;
  "mail.compose.ai.ask": NoParams;
  "mail.compose.ai.askPlaceholder": NoParams;
  "mail.compose.ai.rewrite": NoParams;
  "mail.compose.ai.shorten": NoParams;
  "mail.compose.ai.lengthen": NoParams;
  "mail.compose.ai.formal": NoParams;
  "mail.compose.ai.friendly": NoParams;
  "mail.compose.ai.fix": NoParams;
  "mail.compose.ccBcc": NoParams;
  "mail.compose.editRecipients": NoParams;
  "mail.compose.recipientsSummary": { name: string; count: string };
  "mail.compose.saveDraft": NoParams;
  "mail.compose.deleteDraft": NoParams;
  "mail.compose.templatesEmpty": NoParams;
  "mail.compose.templateName": NoParams;
  "mail.compose.deleteTemplate": NoParams;
  "mail.compose.sendLater": NoParams;
  "mail.compose.more": NoParams;
  "mail.compose.useSignatureOf": { address: string };
  "mail.compose.saveSignature": NoParams;
  "mail.compose.discard": NoParams;
  "mail.compose.sent": NoParams;
  "mail.compose.invalidRecipients": { count: number };
  "mail.compose.noRecipients": NoParams;
  "mail.compose.noReply": { address: string };
  "mail.compose.offline": NoParams;
  "mail.compose.failed": NoParams;
  "mail.compose.failedNetwork": NoParams;
  "mail.compose.failedLimit": NoParams;
  "mail.compose.failedGone": NoParams;
  "mail.compose.failedForbidden": NoParams;
  "mail.compose.failedRefused": NoParams;
  "mail.compose.failedStorage": NoParams;
  "mail.compose.failedBilling": NoParams;
  "mail.compose.failedDomain": NoParams;
  "mail.compose.tooManyRecipients": { max: string };
  "mail.compose.tooLong": NoParams;
  "mail.compose.sendingNotSetUp": { domain: string };
  "mail.contacts.title": NoParams;
  "mail.contacts.filter.all": NoParams;
  "mail.contacts.filter.email": NoParams;
  "mail.contacts.filter.client": NoParams;
  "mail.contacts.filter.team": NoParams;
  "mail.contacts.search": NoParams;
  "mail.contacts.add": NoParams;
  "mail.contacts.name": NoParams;
  "mail.contacts.email": NoParams;
  "mail.contacts.org": NoParams;
  "mail.contacts.kind": NoParams;
  "mail.contacts.markClient": NoParams;
  "mail.contacts.markTeam": NoParams;
  "mail.contacts.markEmail": NoParams;
  "mail.contacts.remove": NoParams;
  "mail.contacts.sendMail": NoParams;
  "mail.contacts.empty": NoParams;
  "mail.contacts.messages": { count: number };
  "mail.contacts.invalidEmail": NoParams;
  "mail.contacts.addFailed": NoParams;
  "mail.contacts.member": NoParams;
  "mail.people.copyEmail": NoParams;
  "mail.people.kind.client": NoParams;
  "mail.people.copied": NoParams;
  "mail.people.notContact": NoParams;
  "mail.people.projects": NoParams;
  "mail.people.addToProject": NoParams;
  "mail.people.addToProjectTitle": { name: string };
  "mail.people.findProject": NoParams;
  "mail.people.noProjects": NoParams;
  "mail.people.noProjectsFor": NoParams;
  "mail.people.projectFailed": NoParams;
  "mail.people.newEmail": NoParams;
  "mail.people.openContact": NoParams;
  "mail.people.addContact": NoParams;
  "mail.people.addClient": NoParams;
  "mail.people.message": NoParams;
  "mail.people.viewProfile": NoParams;
  "mail.people.recentWith": { name: string };
  "mail.people.recent": NoParams;
  "mail.people.seeAllInMail": NoParams;
  "mail.people.noRecent": NoParams;
  "mail.people.selectContact": NoParams;
  "mail.people.copyShort": NoParams;
  "mail.people.emailShort": NoParams;
  "mail.people.contactShort": NoParams;
  "mail.people.card": { name: string };
  "mail.people.removeFromProject": { project: string };
  "mail.settings.title": NoParams;
  "mail.settings.domains": NoParams;
  "mail.settings.domainsHelp": NoParams;
  "mail.settings.addDomain": NoParams;
  "mail.settings.domainPlaceholder": NoParams;
  "mail.settings.check": NoParams;
  "mail.settings.remove": NoParams;
  "mail.settings.removeConfirm": { domain: string };
  "mail.settings.status.pending": NoParams;
  "mail.settings.status.verified": NoParams;
  "mail.settings.status.failed": NoParams;
  "mail.settings.status.paused": NoParams;
  "mail.settings.canReceive": NoParams;
  "mail.settings.canSend": NoParams;
  "mail.settings.status.ownedGoogle": NoParams;
  "mail.settings.status.ownedElsewhere": NoParams;
  "mail.settings.receivesViaImport": NoParams;
  "mail.settings.sendingNotSetUp": NoParams;
  "mail.settings.keptElsewhereHelp": NoParams;
  "mail.settings.domainInUse": { count: number };
  "mail.settings.record.type": NoParams;
  "mail.settings.record.name": NoParams;
  "mail.settings.record.value": NoParams;
  "mail.settings.record.priority": NoParams;
  "mail.settings.record.ok": NoParams;
  "mail.settings.record.missing": NoParams;
  "mail.settings.record.mismatch": NoParams;
  "mail.settings.record.unchecked": NoParams;
  "mail.settings.record.optional": NoParams;
  "mail.settings.record.srv": { port: string; weight: string };
  "mail.settings.record.verification.pending": NoParams;
  "mail.settings.record.verification.restarted": NoParams;
  "mail.settings.record.verification.failed": NoParams;
  "mail.settings.dkimNote.pending": NoParams;
  "mail.settings.dkimNote.restarted": NoParams;
  "mail.settings.dkimNote.failed": NoParams;
  "mail.settings.mailFromNote.pending": NoParams;
  "mail.settings.mailFromNote.restarted": NoParams;
  "mail.settings.mailFromNote.failed": NoParams;
  "mail.settings.record.copy": NoParams;
  "mail.settings.purpose.verify": NoParams;
  "mail.settings.purpose.mx": NoParams;
  "mail.settings.purpose.spf": NoParams;
  "mail.settings.purpose.dkim": NoParams;
  "mail.settings.purpose.returnPath": NoParams;
  "mail.settings.purpose.dmarc": NoParams;
  "mail.settings.purpose.mtaSts": NoParams;
  "mail.settings.purpose.clientSetup": NoParams;
  "mail.settings.purpose.bimi": NoParams;
  "mail.settings.purpose.mailFrom": NoParams;
  "mail.settings.bimi": NoParams;
  "mail.settings.bimi.help": NoParams;
  "mail.settings.bimi.needsDmarc": NoParams;
  "mail.settings.bimi.upload": NoParams;
  "mail.settings.bimi.replace": NoParams;
  "mail.settings.bimi.remove": NoParams;
  "mail.settings.dmarc": NoParams;
  "mail.settings.dmarc.none": NoParams;
  "mail.settings.dmarc.quarantine": NoParams;
  "mail.settings.dmarc.reject": NoParams;
  "mail.settings.mailboxes": NoParams;
  "mail.settings.newMailbox": NoParams;
  "mail.settings.noMailboxYet": { domain: string };
  "mail.settings.createMine": { address: string };
  "mail.settings.tabs": NoParams;
  "mail.settings.tab.domains": NoParams;
  "mail.settings.tab.people": NoParams;
  "mail.settings.people": NoParams;
  "mail.settings.people.help": NoParams;
  "mail.settings.people.noMailbox": NoParams;
  "mail.settings.people.create": NoParams;
  "mail.settings.routing": NoParams;
  "mail.settings.aliases": NoParams;
  "mail.settings.aliasPlaceholder": { domain: string };
  "mail.settings.forwardTo": NoParams;
  "mail.settings.forwardPlaceholder": NoParams;
  "mail.settings.keepCopy": NoParams;
  "mail.settings.routingSave": NoParams;
  "mail.settings.add": NoParams;
  "mail.settings.aliasOf": NoParams;
  "mail.settings.aliasOf.none": NoParams;
  "mail.settings.aliasOfHelp": { domain: string };
  "mail.settings.sendPaused.bounces": NoParams;
  "mail.settings.sendPaused.complaints": NoParams;
  "mail.settings.sendPaused.resume": NoParams;
  "mail.settings.records.allFound": { count: string };
  "mail.settings.records.toggle": NoParams;
  "mail.settings.mailboxesFor": NoParams;
  "mail.settings.mailboxesForHelp": NoParams;
  "mail.settings.mailboxesFor.me": NoParams;
  "mail.settings.mailboxesFor.everyone": NoParams;
  "mail.settings.mailboxesFor.none": NoParams;
  "mail.settings.mailboxAddress": NoParams;
  "mail.settings.mailboxName": NoParams;
  "mail.settings.mailboxKind.personal": NoParams;
  "mail.settings.mailboxKind.shared": NoParams;
  "mail.settings.mailboxMembers": NoParams;
  "mail.settings.deleteMailbox": NoParams;
  "mail.settings.domainNotReady": NoParams;
  "mail.settings.invalidDomain": NoParams;
  "mail.settings.invalidLocalPart": NoParams;
  "mail.settings.failed": NoParams;
  "mail.back": NoParams;
  "mail.more": NoParams;
  "mail.undo.archived": { count: number };
  "mail.undo.trashed": { count: number };
  "mail.undo.spam": { count: number };
  "mail.undo.inbox": { count: number };
  "mail.undo.priority": { count: number };
  "mail.undo.priority.sender": { name: string };
  "mail.undo.notPriority": { count: number };
  "mail.undo.notPriority.sender": { name: string };
  "mail.select": { subject: string };
  "mail.selectAll": NoParams;
  "mail.selectedCount": { count: string };
  "mail.clearSelection": NoParams;
  "mail.folder.starred": NoParams;
  "mail.folder.snoozed": NoParams;
  "mail.folder.scheduled": NoParams;
  "mail.folder.drafts": NoParams;
  "mail.labels": NoParams;
  "mail.label.new": NoParams;
  "mail.label.namePlaceholder": NoParams;
  "mail.action.snooze": NoParams;
  "mail.action.unsnooze": NoParams;
  "mail.action.labelAs": { label: string };
  "mail.action.cancelSend": NoParams;
  "mail.snooze.option": { option: string; time: string };
  "mail.time.laterToday": NoParams;
  "mail.time.tomorrowMorning": NoParams;
  "mail.time.tomorrowAfternoon": NoParams;
  "mail.time.thisWeekend": NoParams;
  "mail.time.nextWeek": NoParams;
  "mail.time.mondayMorning": NoParams;
  "mail.snoozedUntil": { time: string };
  "mail.scheduledFor": { time: string };
  "mail.compose.schedule": NoParams;
  "mail.compose.saved": NoParams;
  "mail.compose.replyKind": { kind: string };
  "mail.compose.removeQuote": NoParams;
  "mail.compose.saveFailed": NoParams;
  "mail.compose.undo": NoParams;
  "mail.compose.scheduled": { time: string };
  "mail.drafts.empty": NoParams;
  "mail.draft.label": NoParams;
  "mail.draft.discard": NoParams;
  "mail.reader.empty": NoParams;
  "mail.reader.emptyHelp": NoParams;
  "mail.showMessages": { count: number };
  "mail.reply.kind": { kind: string };
  "mail.reply.editRecipients": NoParams;
  "mail.reply.editSubject": NoParams;
  "mail.reply.popOut": NoParams;
  "mail.reply.popped": NoParams;
  "mail.reply.showHere": NoParams;
  "mail.reply.moveBack": NoParams;
  "mail.reply.sendKey": { mod: string };
  "mail.olderMessages": { count: number };
  "mail.showQuoted": NoParams;
  "mail.folders": NoParams;
  "mail.mailboxes": NoParams;
  "mail.tabs": NoParams;
  "mail.noSubject": NoParams;
  "mail.compose.removeAttachment": NoParams;
  "mail.settings.adminsOnly": NoParams;
  "mail.signature.title": NoParams;
  "mail.signature.help": NoParams;
  "mail.signature.mailbox": NoParams;
  "mail.signature.editor": NoParams;
  "mail.signature.placeholder": NoParams;
  "mail.signature.onNew": NoParams;
  "mail.signature.onReply": NoParams;
  "mail.signature.sentWith": NoParams;
  "mail.signature.sentWithHint": NoParams;
  "mail.signature.sentWithShared": NoParams;
  "mail.signature.sentWithLocked": { workspace: string };
  "mail.signature.sentWithPreview": NoParams;
  "mail.sentWith.title": NoParams;
  "mail.sentWith.admins": NoParams;
  "mail.sentWith.line": NoParams;
  "mail.signature.save": NoParams;
  "mail.signature.saved": NoParams;
  "mail.signature.saveFailed": NoParams;
  "mail.signature.offline": NoParams;
  "mail.signature.noMailbox": NoParams;
  "mail.apps.title": NoParams;
  "mail.apps.help": NoParams;
  "mail.apps.create": NoParams;
  "mail.apps.failed": NoParams;
  "mail.apps.profile": NoParams;
  "mail.apps.password": NoParams;
  "mail.apps.apple.title": NoParams;
  "mail.apps.apple.help": NoParams;
  "mail.apps.apple.install": NoParams;
  "mail.apps.other.title": NoParams;
  "mail.apps.other.help": NoParams;
  "mail.apps.once": NoParams;
  "mail.apps.perDevice": NoParams;
  "mail.apps.server.title": NoParams;
  "mail.apps.server.help": NoParams;
  "mail.apps.server.imap": NoParams;
  "mail.apps.server.imapPort": NoParams;
  "mail.apps.server.smtp": NoParams;
  "mail.apps.server.smtpPort": NoParams;
  "mail.apps.server.dav": NoParams;
  "mail.apps.server.davPort": NoParams;
  "mail.apps.server.user": NoParams;
  "mail.apps.server.userMine": NoParams;
  "mail.apps.server.userShared": NoParams;
  "mail.apps.server.password": NoParams;
  "mail.apps.server.passwordValue": NoParams;
  "mail.apps.copy": NoParams;
  "mail.settings.record.copied": NoParams;
  "docs.title": NoParams;
  "docs.filter.all": NoParams;
  "docs.filter.recent": NoParams;
  "docs.filter.mine": NoParams;
  "docs.filter.favorites": NoParams;
  "docs.filter.databases": NoParams;
  "docs.search": NoParams;
  "docs.new": NoParams;
  "docs.edited": { when: string };
  "nav.calendar": NoParams;
  "calendar.title": NoParams;
  "calendar.today": NoParams;
  "calendar.view.day": NoParams;
  "calendar.view.week": NoParams;
  "calendar.view.month": NoParams;
  "calendar.prev": NoParams;
  "calendar.next": NoParams;
  "calendar.allDay": NoParams;
  "calendar.new": NoParams;
  "calendar.scope.this": NoParams;
  "calendar.scope.following": NoParams;
  "calendar.scope.all": NoParams;
  "calendar.scope.editTitle": NoParams;
  "calendar.scope.rsvpTitle": NoParams;
  "calendar.phone.title": NoParams;
  "calendar.phone.intro": NoParams;
  "calendar.phone.subscribe": NoParams;
  "calendar.phone.subscribeHelp": NoParams;
  "calendar.phone.copy": NoParams;
  "calendar.phone.copied": NoParams;
  "calendar.phone.open": NoParams;
  "calendar.phone.reset": NoParams;
  "calendar.phone.secret": NoParams;
  "calendar.phone.dav": NoParams;
  "calendar.phone.davHelp": NoParams;
  "calendar.phone.davCreate": NoParams;
  "calendar.phone.davOff": NoParams;
  "calendar.phone.davServer": NoParams;
  "calendar.phone.davUser": NoParams;
  "calendar.phone.davPassword": NoParams;
  "calendar.phone.davOnce": NoParams;
  "calendar.phone.device": NoParams;
  "calendar.phone.deviceHint": { workspace: string };
  "calendar.phone.deviceDenied": NoParams;
  "calendar.more": { count: string };
  "calendar.moreActions": NoParams;
  "calendar.booking.title": NoParams;
  "calendar.booking.copyLink": NoParams;
  "calendar.booking.linkCopied": NoParams;
  "calendar.booking.share": NoParams;
  "calendar.booking.open": NoParams;
  "calendar.booking.pause": NoParams;
  "calendar.booking.resume": NoParams;
  "calendar.booking.paused": NoParams;
  "calendar.booking.empty": NoParams;
  "calendar.booking.emptyHint": NoParams;
  "calendar.booking.footer": NoParams;
  "calendar.booking.loadFailed": NoParams;
  "calendar.booking.updateFailed": NoParams;
  "calendar.booking.bookedVia": { page: string };
  "calendar.booking.minutes": { minutes: string };
  "calendar.booking.hours": { hours: string };
  "calendar.booking.hoursMinutes": { hours: string; minutes: string };
  "calendar.booking.location.bundleMeeting": NoParams;
  "calendar.booking.location.inPerson": NoParams;
  "calendar.booking.location.phone": NoParams;
  "calendar.showAsFree": NoParams;
  "calendar.event.title": NoParams;
  "calendar.event.when": NoParams;
  "calendar.event.starts": NoParams;
  "calendar.event.ends": NoParams;
  "calendar.event.location": NoParams;
  "calendar.event.description": NoParams;
  "calendar.event.guests": NoParams;
  "calendar.event.guestsHelp": NoParams;
  "calendar.event.huddleHelp": NoParams;
  "calendar.event.outsideGuests": NoParams;
  "calendar.event.guestsPlaceholder": NoParams;
  "calendar.event.optional": NoParams;
  "calendar.event.organizer": NoParams;
  "calendar.event.huddle": NoParams;
  "calendar.event.joinHuddle": NoParams;
  "calendar.event.visibility.attendees": NoParams;
  "calendar.event.visibility.workspace": NoParams;
  "calendar.event.inviteFrom": NoParams;
  "calendar.event.reminder": NoParams;
  "calendar.event.reminderMinutes": { count: number };
  "calendar.reminder.none": NoParams;
  "calendar.reminder.atStart": NoParams;
  "calendar.reminder.hours": { count: number };
  "calendar.reminder.days": { count: number };
  "calendar.reminder.sameDayAt": { time: string };
  "calendar.reminder.daysBeforeAt": { count: number; time: string };
  "calendar.reminder.email": NoParams;
  "calendar.reminder.title": NoParams;
  "calendar.event.save": NoParams;
  "calendar.event.delete": NoParams;
  "calendar.event.deleteOccurrence": NoParams;
  "calendar.event.deleteFollowing": NoParams;
  "calendar.event.deleteSeries": NoParams;
  "calendar.event.edit": NoParams;
  "calendar.repeat": NoParams;
  "calendar.repeat.none": NoParams;
  "calendar.repeat.daily": NoParams;
  "calendar.repeat.weekly": NoParams;
  "calendar.repeat.weekdays": NoParams;
  "calendar.repeat.monthly": NoParams;
  "calendar.repeat.yearly": NoParams;
  "calendar.rsvp.question": NoParams;
  "calendar.rsvp.accepted": NoParams;
  "calendar.rsvp.declined": NoParams;
  "calendar.rsvp.tentative": NoParams;
  "calendar.rsvp.needsAction": NoParams;
  "calendar.guests.summary": { count: number };
  "calendar.empty": NoParams;
  "calendar.loadFailed": NoParams;
  "calendar.error.noTitle": NoParams;
  "calendar.error.endBeforeStart": NoParams;
  "calendar.error.saveFailed": NoParams;
  "calendar.event.imported": NoParams;
  "calendar.event.joinMeet": NoParams;
  "calendar.event.joinVideo": NoParams;
  "calendar.mine": NoParams;
  "calendar.fromGoogle": NoParams;
  "calendar.googleSync": NoParams;
  "calendar.repeat.custom": NoParams;
  "calendar.repeat.customTitle": NoParams;
  "calendar.repeat.every": NoParams;
  "calendar.repeat.every.daily": { count: number };
  "calendar.repeat.every.weekly": { count: number };
  "calendar.repeat.every.weeklyOn": { count: number; days: string };
  "calendar.repeat.every.monthly": { count: number };
  "calendar.repeat.every.yearly": { count: number };
  "calendar.repeat.until": { date: string };
  "calendar.repeat.times": { count: number };
  "calendar.repeat.unit.daily": NoParams;
  "calendar.repeat.units.daily": NoParams;
  "calendar.repeat.unit.weekly": NoParams;
  "calendar.repeat.units.weekly": NoParams;
  "calendar.repeat.unit.monthly": NoParams;
  "calendar.repeat.units.monthly": NoParams;
  "calendar.repeat.unit.yearly": NoParams;
  "calendar.repeat.units.yearly": NoParams;
  "calendar.repeat.on": NoParams;
  "calendar.repeat.ends": NoParams;
  "calendar.repeat.endsNever": NoParams;
  "calendar.repeat.endsOn": NoParams;
  "calendar.repeat.endsAfter": NoParams;
  "calendar.repeat.occurrence": NoParams;
  "calendar.repeat.occurrences": NoParams;
  "calendar.event.timeZone": NoParams;
  "calendar.event.timeZoneHelp": NoParams;
  "calendar.event.markOptional": NoParams;
  "calendar.event.markRequired": NoParams;
  "calendar.event.you": { name: string };
  "calendar.meetSwap.joinLine": NoParams;
  "calendar.meetSwap.inviteNote": NoParams;
  "calendar.meetSwap.answerKept": NoParams;
  "calendar.meetSwap.oldLink": NoParams;
  "calendar.meetSwap.lockedByAdmin": { workspace: string };
  "calendar.meetSwap.activityTitle": NoParams;
  "calendar.meetSwap.activityBody": { count: number };
  "calendar.meetSwap.skip.googleScope": NoParams;
  "calendar.meetSwap.skip.googleError": NoParams;
  "calendar.meetSwap.skip.notOrganizer": NoParams;
  "calendar.meetSwap.skip.noMeet": NoParams;
  "calendar.meetSwap.skip.ended": NoParams;
  "calendar.meetSwap.skip.gone": NoParams;
  "calendar.meetSwap.skip.noMailbox": NoParams;
  "calendar.meetSwap.skip.mailError": NoParams;
  "calendar.meetSwap.prompt.title": NoParams;
  "calendar.meetSwap.prompt.body": NoParams;
  "calendar.meetSwap.prompt.justThis": NoParams;
  "calendar.meetSwap.prompt.justThisHint": NoParams;
  "calendar.meetSwap.prompt.upcoming": NoParams;
  "calendar.meetSwap.prompt.upcomingCount": { count: number };
  "calendar.meetSwap.prompt.always": NoParams;
  "calendar.meetSwap.prompt.alwaysShort": NoParams;
  "calendar.meetSwap.prompt.move": NoParams;
  "calendar.meetSwap.prompt.notNow": NoParams;
  "calendar.meetSwap.useBundle": NoParams;
  "calendar.meetSwap.confirm.title": { count: number };
  "calendar.meetSwap.confirm.body": { count: number };
  "calendar.meetSwap.confirm.notify": NoParams;
  "calendar.meetSwap.confirm.silent": NoParams;
  "calendar.meetSwap.moved": { count: number };
  "calendar.meetSwap.undo": NoParams;
  "calendar.meetSwap.settings.section": NoParams;
  "calendar.meetSwap.settings.toggle": NoParams;
  "calendar.meetSwap.settings.toggleHint": NoParams;
  "calendar.meetSwap.settings.moving": { count: number };
  "calendar.meetSwap.settings.progress": { done: string; total: string };
  "calendar.meetSwap.settings.progressHint": NoParams;
  "calendar.meetSwap.settings.restore": NoParams;
  "calendar.meetSwap.settings.restoreHint": NoParams;
  "calendar.meetSwap.settings.restoreAction": NoParams;
  "calendar.meetSwap.settings.restoreConfirm": NoParams;
  "calendar.meetSwap.settings.skipped": { count: number };
  "calendar.meetSwap.policy.title": NoParams;
  "calendar.meetSwap.policy.member": NoParams;
  "calendar.meetSwap.policy.memberHint": NoParams;
  "calendar.meetSwap.policy.bundle": NoParams;
  "calendar.meetSwap.policy.bundleHint": NoParams;
  "calendar.meetSwap.policy.moving": NoParams;
  "calendar.meetSwap.policy.progress": { people: string; peopleTotal: string; done: string; total: string };
  "calendar.meetSwap.policy.progressHint": NoParams;
  "calendar.meetSwap.policy.pause": NoParams;
  "calendar.meetSwap.policy.resume": NoParams;
  "calendar.meetSwap.policy.restoreAll": NoParams;
  "calendar.meetSwap.policy.restoreAllHint": NoParams;
  "calendar.meetSwap.policy.confirmTitle": { workspace: string };
  "calendar.meetSwap.policy.confirmBody": NoParams;
  "calendar.meetSwap.policy.moveAndEmail": NoParams;
  "calendar.meetSwap.policy.moveSilent": NoParams;
  "calendar.meetSwap.policy.newOnly": NoParams;
  "calendar.rsvp.failed": NoParams;
  "calendar.loading": NoParams;
  "calendar.bookingPages.title": NoParams;
  "calendar.bookingPages.empty": NoParams;
  "calendar.bookingPages.emptyHint": NoParams;
  "calendar.bookingPages.loadFailed": NoParams;
  "calendar.bookingPages.updateFailed": NoParams;
  "calendar.bookingPages.copyLink": NoParams;
  "calendar.bookingPages.linkCopied": NoParams;
  "calendar.bookingPages.share": NoParams;
  "calendar.bookingPages.shareNamed": { title: string };
  "calendar.bookingPages.moreNamed": { title: string };
  "calendar.bookingPages.open": NoParams;
  "calendar.bookingPages.pause": NoParams;
  "calendar.bookingPages.resume": NoParams;
  "calendar.bookingPages.paused": NoParams;
  "calendar.bookingPages.minutes": { minutes: string };
  "calendar.bookingPages.location.bundleMeeting": NoParams;
  "calendar.bookingPages.location.inPerson": NoParams;
  "calendar.bookingPages.location.phone": NoParams;
  "calendar.event.bookedVia": { title: string };
  "calendar.event.showAsFree": NoParams;
  "calendar.moreOptions": NoParams;
  "import.timeline.title": NoParams;
  "import.timeline.started": { source: string };
  "import.timeline.people": { count: number };
  "import.timeline.conversations": { channels: string; dms: string };
  "import.timeline.pages": { pages: string; databases: string };
  "import.timeline.sorting": NoParams;
  "import.timeline.sorted": { count: number };
  "import.timeline.sortSkipped": NoParams;
  "import.timeline.review": NoParams;
  "import.timeline.importing": NoParams;
  "import.timeline.channel": { name: string };
  "import.timeline.history": { name: string; count: string };
  "import.timeline.files": { name: string; count: string };
  "import.timeline.channelDone": { name: string; count: string };
  "import.timeline.page": { title: string };
  "import.timeline.database": { title: string };
  "import.timeline.rows": { title: string; count: string };
  "import.timeline.canvas": { title: string };
  "import.timeline.filesRepaired": { count: number };
  "import.slack.repairLinks": NoParams;
  "import.slack.repairLinks.note": NoParams;
  "import.timeline.repairing": { count: number };
  "import.timeline.renamed": { count: number };
  "import.timeline.fileNotFound": { name: string };
  "import.timeline.fileNoAccess": { name: string };
  "import.timeline.fileTooBig": { name: string };
  "import.timeline.canvasUnreadable": { name: string };
  "import.timeline.fileFailed": { name: string };
  "import.repairTitle": NoParams;
  "import.timeline.rateLimited": { seconds: string };
  "import.timeline.retrying": { attempt: string; message: string };
  "import.timeline.done": NoParams;
  "import.timeline.failed": { message: string };
  "import.timeline.cancelled": NoParams;
  "import.slack.person.invite": NoParams;
  "import.slack.person.guest": { org: string };
  "import.slack.person.otherCompany": NoParams;
  "import.slack.person.deactivated": NoParams;
  "import.slack.inviteAll": NoParams;
  "import.slack.external": { org: string };
  "import.slack.apps": NoParams;
  "import.slack.apps.body": NoParams;
  "import.slack.allApps": { count: number };
  "import.timeline.invited": { count: number };
  "import.timeline.guests": { count: number };
  "import.timeline.deactivatedPeople": { count: number };
  "import.rescan": NoParams;
  "import.rescanFailed": NoParams;
  "import.slack.sendInvites": NoParams;
  "import.slack.sendInvites.off": NoParams;
  "import.slack.restrictExternal": NoParams;
  "newMessage.title": NoParams;
  "newMessage.to": NoParams;
  "newMessage.toPlaceholder": NoParams;
  "newMessage.limit": { max: string };
  "newMessage.existing": { name: string };
  "newMessage.start": { name: string };
  "newMessage.open": NoParams;
  "newMessage.recent": NoParams;
  "newMessage.noConversations": NoParams;
  "newMessage.failed": NoParams;
  "newMessage.offline": NoParams;
  "sidebar.moreConversations": { count: number };
  "dm.close": NoParams;
  "dm.addPeople": NoParams;
  "dm.addPeopleHint": NoParams;
  "dm.convert": NoParams;
  "dm.convertHint": NoParams;
  "dm.convertName": NoParams;
  "dm.convertAction": NoParams;
  "mail.notify.title": NoParams;
  "mail.notify.enabled": NoParams;
  "mail.notify.priority": NoParams;
  "mail.notify.priorityHelp": NoParams;
  "mail.notify.tabsAlso": NoParams;
  "mail.notify.tabs": NoParams;
  "mail.notify.uncategorized": NoParams;
  "mail.notify.help": NoParams;
  "mail.settings.provider": { name: string };
  "mail.settings.providerUnknown": NoParams;
  "mail.settings.openDns": NoParams;
  "mail.settings.zoneFile": NoParams;
  "mail.settings.zoneFile.help": NoParams;
  "mail.settings.zoneFile.cloudflare": NoParams;
  "mail.settings.zoneFile.other": { name: string };
  "mail.sync.title": NoParams;
  "mail.sync.help": NoParams;
  "mail.sync.connectGoogle": NoParams;
  "mail.sync.addImap": NoParams;
  "mail.sync.noMailboxes": NoParams;
  "mail.sync.connect": NoParams;
  "mail.sync.google.title": NoParams;
  "mail.sync.google.step1": NoParams;
  "mail.sync.google.step2": NoParams;
  "mail.sync.google.scopes": NoParams;
  "mail.sync.google.copyScopes": NoParams;
  "mail.sync.google.step3": NoParams;
  "mail.sync.google.bundleClient": { clientId: string };
  "mail.sync.google.copyClientId": NoParams;
  "mail.sync.google.adminEmail": NoParams;
  "mail.sync.google.key": NoParams;
  "mail.sync.google.keyHelp": NoParams;
  "mail.sync.google.keyOptional": NoParams;
  "mail.sync.google.users": { count: number };
  "mail.sync.google.dontImport": NoParams;
  "mail.sync.google.mailboxFor": { email: string };
  "mail.sync.imap.title": NoParams;
  "mail.sync.imap.into": NoParams;
  "mail.sync.imap.username": NoParams;
  "mail.sync.imap.password": NoParams;
  "mail.sync.imap.passwordHelp": NoParams;
  "mail.sync.imap.appPassword": { url: string };
  "mail.sync.imap.host": NoParams;
  "mail.sync.imap.port": NoParams;
  "mail.sync.imap.security": NoParams;
  "mail.sync.imap.security.tls": NoParams;
  "mail.sync.imap.security.starttls": NoParams;
  "mail.sync.imap.security.none": NoParams;
  "mail.sync.imap.folders": NoParams;
  "mail.sync.imap.folder": { path: string; count: string };
  "mail.sync.imap.check": NoParams;
  "mail.sync.imap.start": NoParams;
  "mail.sync.imap.newPassword": NoParams;
  "mail.sync.imap.updatePassword": NoParams;
  "mail.sync.phase.connecting": NoParams;
  "mail.sync.phase.listing": NoParams;
  "mail.sync.phase.importing": NoParams;
  "mail.sync.phase.syncing": NoParams;
  "mail.sync.phase.paused": NoParams;
  "mail.sync.phase.error": NoParams;
  "mail.sync.into": { address: string };
  "mail.sync.finding": NoParams;
  "mail.sync.counting": { total: number };
  "mail.sync.counts": { done: string; total: string; duplicates: string; failed: string };
  "mail.sync.accountCounts": { done: string; total: string };
  "mail.sync.lastSync": { time: string };
  "mail.sync.pause": NoParams;
  "mail.sync.resume": NoParams;
  "mail.sync.remove": NoParams;
  "mail.sync.removeConfirm": NoParams;
  "mail.sync.refused": { detail: string };
  "mail.sync.forbidden": NoParams;
  "mail.sync.failed": NoParams;
  "mail.sync.google.reviewTitle": NoParams;
  "mail.sync.google.reviewHelp": NoParams;
  "mail.sync.google.newMailbox": { address: string };
  "mail.sync.google.newMailboxHelp": NoParams;
  "mail.sync.google.start": { count: number };
  "mail.sync.phase.review": NoParams;
  "composer.command.appUsage": { usage: string };
  "composer.appCommand.failed": { command: string };
  "workflow.run.failed": { name: string };
  "workflow.menu.title": NoParams;
  "workflow.menu.empty": NoParams;
  "workflow.menu.badge": NoParams;
  "composer.appAction.failed": NoParams;
  "composer.appCommand.running": { command: string };
  "message.ephemeral.onlyYou": NoParams;
  "message.ephemeral.dismiss": NoParams;
  "appModal.error.required": NoParams;
  "appModal.error.tooShort": { count: number };
  "appModal.error.tooLong": { count: number };
  "appModal.error.tooMany": { count: number };
  "appModal.appError": { text: string };
  "appModal.unreachable": NoParams;
  "appModal.cancel": NoParams;
  "appModal.submit": NoParams;
  "appModal.back": NoParams;
  "appModal.optional": NoParams;
  "blockKit.select.placeholder": NoParams;
  "blockKit.multiSelect.placeholder": NoParams;
  "blockKit.users.placeholder": NoParams;
  "blockKit.multiUsers.placeholder": NoParams;
  "blockKit.conversations.placeholder": NoParams;
  "blockKit.channels.placeholder": NoParams;
  "blockKit.date.placeholder": NoParams;
  "blockKit.time.placeholder": NoParams;
  "blockKit.overflow.label": NoParams;
  "blockKit.search": NoParams;
  "blockKit.remove": { name: string };
  "blockKit.selected": { count: number };
  "integrations.apps.title": NoParams;
  "integrations.apps.body": NoParams;
  "integrations.apps.empty": NoParams;
  "integrations.apps.adminsOnly": NoParams;
  "integrations.app.create": NoParams;
  "integrations.app.edit": NoParams;
  "integrations.app.save": NoParams;
  "integrations.app.cancel": NoParams;
  "integrations.app.name": NoParams;
  "integrations.app.namePlaceholder": NoParams;
  "integrations.app.description": NoParams;
  "integrations.app.scopes": NoParams;
  "integrations.app.redirectUrls": NoParams;
  "integrations.app.redirectUrlsHelp": NoParams;
  "integrations.app.interactivityUrl": NoParams;
  "integrations.app.interactivityHelp": NoParams;
  "integrations.app.commands": NoParams;
  "integrations.app.addCommand": NoParams;
  "integrations.app.removeCommand": NoParams;
  "integrations.app.command": NoParams;
  "integrations.app.commandUrl": NoParams;
  "integrations.app.commandDescription": NoParams;
  "integrations.app.commandHint": NoParams;
  "integrations.app.nameEmpty": NoParams;
  "integrations.app.commandInvalid": { command: string };
  "integrations.app.commandReserved": { command: string };
  "integrations.app.commandTaken": { command: string };
  "integrations.app.commandIncomplete": NoParams;
  "integrations.app.urlInvalid": NoParams;
  "integrations.app.saveFailed": NoParams;
  "integrations.app.failed": NoParams;
  "integrations.app.external": NoParams;
  "integrations.app.meta": { scopes: string; commands: string };
  "integrations.app.commandCount": { count: number };
  "integrations.app.scopeCount": { count: number };
  "integrations.app.more": NoParams;
  "integrations.app.showSigningSecret": NoParams;
  "integrations.app.rotateBotToken": NoParams;
  "integrations.app.rotateClientSecret": NoParams;
  "integrations.app.rotateSigningSecret": NoParams;
  "integrations.app.remove": NoParams;
  "integrations.app.removeTitle": NoParams;
  "integrations.app.removeBody": { name: string };
  "integrations.app.credentialsTitle": NoParams;
  "integrations.app.credentialsBody": NoParams;
  "integrations.app.secretTitle": NoParams;
  "integrations.app.secretBody": NoParams;
  "integrations.app.signingTitle": NoParams;
  "integrations.app.signingBody": NoParams;
  "integrations.app.botToken": NoParams;
  "integrations.app.clientId": NoParams;
  "integrations.app.clientSecret": NoParams;
  "integrations.app.signingSecret": NoParams;
  "integrations.app.copy": NoParams;
  "integrations.app.copied": NoParams;
  "integrations.app.done": NoParams;
  "integrations.scope.chatWrite": NoParams;
  "integrations.scope.channelsRead": NoParams;
  "integrations.scope.channelsHistory": NoParams;
  "integrations.scope.usersRead": NoParams;
  "integrations.scope.reactionsWrite": NoParams;
  "integrations.scope.commands": NoParams;
  "integrations.outgoing.title": NoParams;
  "integrations.outgoing.body": NoParams;
  "integrations.outgoing.empty": NoParams;
  "integrations.outgoing.add": NoParams;
  "integrations.outgoing.edit": NoParams;
  "integrations.outgoing.channels": NoParams;
  "integrations.outgoing.channelsHelp": NoParams;
  "integrations.outgoing.triggerWords": NoParams;
  "integrations.outgoing.triggerHelp": NoParams;
  "integrations.outgoing.url": NoParams;
  "integrations.outgoing.needsChannelOrTrigger": NoParams;
  "integrations.outgoing.meta": { where: string; url: string };
  "integrations.outgoing.allPublic": NoParams;
  "integrations.outgoing.triggers": { words: string };
  "integrations.outgoing.lastError": { error: string };
  "integrations.outgoing.signingSecret": NoParams;
  "integrations.outgoing.regenerate": NoParams;
  "integrations.outgoing.removeTitle": NoParams;
  "integrations.outgoing.removeBody": { name: string };
  "oauth.title": { app: string };
  "oauth.madeBy": { workspace: string };
  "oauth.workspace": NoParams;
  "oauth.scopesTitle": NoParams;
  "oauth.noScopes": NoParams;
  "oauth.allow": NoParams;
  "oauth.cancel": NoParams;
  "oauth.noWorkspaces": NoParams;
  "oauth.failed": NoParams;
  "oauth.approveFailed": NoParams;
  "oauth.loading": NoParams;
  "settings.nav.userGroups": NoParams;
  "userGroups.problem.nameMissing": NoParams;
  "userGroups.problem.nameTooLong": NoParams;
  "userGroups.problem.descriptionTooLong": NoParams;
  "userGroups.problem.handleTaken": NoParams;
  "userGroups.failed": NoParams;
  "userGroups.intro": NoParams;
  "userGroups.create": NoParams;
  "userGroups.edit": NoParams;
  "userGroups.tab.active": NoParams;
  "userGroups.tab.disabled": NoParams;
  "userGroups.search": NoParams;
  "userGroups.empty": NoParams;
  "userGroups.emptyDisabled": NoParams;
  "userGroups.emptySearch": NoParams;
  "userGroups.memberCount": { count: number };
  "userGroups.field.name": NoParams;
  "userGroups.field.namePlaceholder": NoParams;
  "userGroups.field.handle": NoParams;
  "userGroups.field.handleHelp": NoParams;
  "userGroups.field.description": NoParams;
  "userGroups.field.members": NoParams;
  "userGroups.field.membersSearch": NoParams;
  "userGroups.field.channels": NoParams;
  "userGroups.field.channelsHelp": NoParams;
  "userGroups.disable": NoParams;
  "userGroups.enable": NoParams;
  "userGroups.disabledBadge": NoParams;
  "userGroups.mine": NoParams;
  "userGroups.policy.label": NoParams;
  "userGroups.policy.everyone": NoParams;
  "userGroups.policy.admins": NoParams;
  "userGroups.card.members": NoParams;
  "userGroups.card.channels": NoParams;
  "userGroups.card.join": { count: number };
  "userGroups.card.disabled": NoParams;
  "userGroups.card.noMembers": NoParams;
  "userGroups.unknown": NoParams;
  "composer.group.members": { count: number };
  "profile.userGroups": NoParams;
  "userGroups.actions": { name: string };
  "userGroups.field.channelsSearch": NoParams;
  "userGroups.field.noMatches": NoParams;
  "userGroups.cardTitle": { name: string };
  "message.unfurl.remove": NoParams;
  "message.unfurl.label": { title: string };
  "message.unfurl.play": { title: string };
  "blockKit.typeMore": { count: number };
  "blockKit.searchFailed": NoParams;
  "blockKit.noMatches": NoParams;
  "blockKit.showMore": NoParams;
  "appHome.tab": NoParams;
  "appHome.messages": NoParams;
  "appHome.empty": { app: string };
  "appHome.loading": NoParams;
  "integrations.app.optionsUrl": NoParams;
  "integrations.app.optionsHelp": NoParams;
  "integrations.app.eventsUrl": NoParams;
  "integrations.app.eventsHelp": NoParams;
  "integrations.scope.groupsRead": NoParams;
  "integrations.scope.groupsHistory": NoParams;
  "integrations.scope.imHistory": NoParams;
  "integrations.scope.mpimHistory": NoParams;
  "integrations.scope.appMentionsRead": NoParams;
  "integrations.scope.reactionsRead": NoParams;
  "integrations.app.events": NoParams;
  "integrations.app.eventsSubscribeHelp": NoParams;
  "integrations.app.eventsNeedUrl": NoParams;
  "integrations.app.eventsUrlFailed": NoParams;
  "integrations.app.eventsLoopWarning": NoParams;
  "integrations.app.workflowSteps": NoParams;
  "integrations.app.workflowStepsHelp": NoParams;
  "integrations.app.addStep": NoParams;
  "integrations.app.removeStep": NoParams;
  "integrations.app.stepCallbackId": NoParams;
  "integrations.app.stepTitle": NoParams;
  "integrations.app.stepDescription": NoParams;
  "integrations.app.stepInputs": NoParams;
  "integrations.app.stepOutputs": NoParams;
  "integrations.app.addStepInput": NoParams;
  "integrations.app.addStepOutput": NoParams;
  "integrations.app.stepParamName": NoParams;
  "integrations.app.stepParamLabel": NoParams;
  "integrations.app.stepParamType": NoParams;
  "integrations.app.stepParamRequired": NoParams;
  "integrations.app.removeParam": NoParams;
  "integrations.app.stepIncomplete": NoParams;
  "integrations.app.stepDuplicate": { callbackId: string };
  "integrations.app.stepDuplicateParam": { callbackId: string; name: string };
  "integrations.event.messageChannels": NoParams;
  "integrations.event.messageGroups": NoParams;
  "integrations.event.messageIm": NoParams;
  "integrations.event.messageMpim": NoParams;
  "integrations.event.appMention": NoParams;
  "integrations.event.reactionAdded": NoParams;
  "integrations.event.reactionRemoved": NoParams;
  "integrations.event.memberJoinedChannel": NoParams;
  "integrations.event.memberLeftChannel": NoParams;
  "integrations.event.channelCreated": NoParams;
  "integrations.event.channelRename": NoParams;
  "nav.workflows": NoParams;
  "workflow.builder.title": NoParams;
  "workflow.list.title": NoParams;
  "workflow.list.body": NoParams;
  "workflow.list.new": NoParams;
  "workflow.list.error": NoParams;
  "workflow.list.empty.title": NoParams;
  "workflow.list.empty.body": NoParams;
  "workflow.list.empty.cantCreate": NoParams;
  "workflow.list.edited": { when: string };
  "workflow.status.published": NoParams;
  "workflow.status.changed": NoParams;
  "workflow.status.draft": NoParams;
  "workflow.creators.title": NoParams;
  "workflow.creators.everyone": NoParams;
  "workflow.creators.admins": NoParams;
  "workflow.editor.untitled": NoParams;
  "workflow.editor.back": NoParams;
  "workflow.tab.build": NoParams;
  "workflow.tab.activity": NoParams;
  "workflow.action.save": NoParams;
  "workflow.action.test": NoParams;
  "workflow.action.publish": NoParams;
  "workflow.action.publishChanges": NoParams;
  "workflow.action.unpublish": NoParams;
  "workflow.details.icon": NoParams;
  "workflow.details.icon.remove": NoParams;
  "workflow.details.name": NoParams;
  "workflow.details.name.placeholder": NoParams;
  "workflow.details.description": NoParams;
  "workflow.section.trigger": NoParams;
  "workflow.section.steps": NoParams;
  "workflow.steps.empty": NoParams;
  "workflow.steps.add": NoParams;
  "workflow.trigger.label": NoParams;
  "workflow.trigger.link": NoParams;
  "workflow.trigger.memberJoined": NoParams;
  "workflow.trigger.reaction": NoParams;
  "workflow.trigger.schedule": NoParams;
  "workflow.trigger.webhook": NoParams;
  "workflow.trigger.link.help": NoParams;
  "workflow.trigger.memberJoined.help": NoParams;
  "workflow.trigger.reaction.help": NoParams;
  "workflow.trigger.schedule.help": NoParams;
  "workflow.trigger.webhook.help": NoParams;
  "workflow.trigger.channel": NoParams;
  "workflow.trigger.emoji": NoParams;
  "workflow.trigger.emoji.help": NoParams;
  "workflow.channel.choose": NoParams;
  "workflow.person.choose": NoParams;
  "workflow.variable.choose": NoParams;
  "workflow.variable.insert": NoParams;
  "workflow.schedule.date": NoParams;
  "workflow.schedule.time": NoParams;
  "workflow.schedule.zone": NoParams;
  "workflow.schedule.repeat": NoParams;
  "workflow.schedule.repeat.none": NoParams;
  "workflow.schedule.repeat.daily": NoParams;
  "workflow.schedule.repeat.weekdays": NoParams;
  "workflow.schedule.repeat.weekly": NoParams;
  "workflow.schedule.repeat.monthly": NoParams;
  "workflow.schedule.days": NoParams;
  "workflow.webhook.variables": NoParams;
  "workflow.webhook.key": NoParams;
  "workflow.webhook.type": NoParams;
  "workflow.webhook.add": NoParams;
  "workflow.webhook.remove": NoParams;
  "workflow.webhook.once": NoParams;
  "workflow.webhook.done": NoParams;
  "workflow.webhook.copy": NoParams;
  "workflow.webhook.hidden": NoParams;
  "workflow.webhook.regenerate": NoParams;
  "workflow.varType.text": NoParams;
  "workflow.varType.number": NoParams;
  "workflow.varType.user": NoParams;
  "workflow.varType.channel": NoParams;
  "workflow.varType.message": NoParams;
  "workflow.varType.date": NoParams;
  "workflow.varType.time": NoParams;
  "workflow.varType.page": NoParams;
  "workflow.varType.row": NoParams;
  "workflow.step.sendMessage": NoParams;
  "workflow.step.form": NoParams;
  "workflow.step.addReaction": NoParams;
  "workflow.step.createPage": NoParams;
  "workflow.step.createRow": NoParams;
  "workflow.step.addToChannel": NoParams;
  "workflow.step.delay": NoParams;
  "workflow.step.appStep": NoParams;
  "workflow.step.moveUp": NoParams;
  "workflow.step.moveDown": NoParams;
  "workflow.step.delete": NoParams;
  "workflow.step.edit": NoParams;
  "workflow.step.done": NoParams;
  "workflow.step.incomplete": NoParams;
  "workflow.message.to": NoParams;
  "workflow.message.to.runner": NoParams;
  "workflow.message.to.channel": NoParams;
  "workflow.message.to.user": NoParams;
  "workflow.message.to.variable": NoParams;
  "workflow.message.text": NoParams;
  "workflow.message.placeholder": NoParams;
  "workflow.form.title": NoParams;
  "workflow.form.submit": NoParams;
  "workflow.form.question": NoParams;
  "workflow.form.fieldLabel": NoParams;
  "workflow.form.fieldKind": NoParams;
  "workflow.form.kind.text": NoParams;
  "workflow.form.kind.paragraph": NoParams;
  "workflow.form.kind.number": NoParams;
  "workflow.form.kind.select": NoParams;
  "workflow.form.kind.user": NoParams;
  "workflow.form.kind.channel": NoParams;
  "workflow.form.kind.date": NoParams;
  "workflow.form.required": NoParams;
  "workflow.form.fieldId": { id: string };
  "workflow.form.option": { n: string };
  "workflow.form.options": NoParams;
  "workflow.form.options.help": NoParams;
  "workflow.form.addField": NoParams;
  "workflow.form.removeField": NoParams;
  "workflow.reaction.message": NoParams;
  "workflow.reaction.emoji": NoParams;
  "workflow.page.title": NoParams;
  "workflow.page.text": NoParams;
  "workflow.row.database": NoParams;
  "workflow.row.choose": NoParams;
  "workflow.row.title": NoParams;
  "workflow.row.untitled": NoParams;
  "workflow.addToChannel.channel": NoParams;
  "workflow.addToChannel.user": NoParams;
  "workflow.delay.count": NoParams;
  "workflow.delay.unit": NoParams;
  "workflow.delay.minutes": NoParams;
  "workflow.delay.hours": NoParams;
  "workflow.delay.days": NoParams;
  "workflow.app.title": NoParams;
  "workflow.app.appId": NoParams;
  "workflow.app.callbackId": NoParams;
  "workflow.app.inputs": NoParams;
  "workflow.app.inputName": NoParams;
  "workflow.app.inputValue": NoParams;
  "workflow.app.addInput": NoParams;
  "workflow.app.outputs": NoParams;
  "workflow.app.outputName": NoParams;
  "workflow.app.outputType": NoParams;
  "workflow.app.addOutput": NoParams;
  "workflow.app.remove": NoParams;
  "workflow.app.chooseApp": NoParams;
  "workflow.app.chooseAppPlaceholder": NoParams;
  "workflow.app.chooseStep": NoParams;
  "workflow.app.chooseStepPlaceholder": NoParams;
  "workflow.app.noApps": NoParams;
  "workflow.app.noInputs": NoParams;
  "workflow.app.inputRequired": { label: string };
  "workflow.app.outputsHelp": NoParams;
  "workflow.app.issue.appMissing": NoParams;
  "workflow.app.issue.stepMissing": NoParams;
  "workflow.app.issue.requiredInput": { field: string };
  "workflow.condition.add": NoParams;
  "workflow.condition.title": NoParams;
  "workflow.condition.summary": NoParams;
  "workflow.condition.remove": NoParams;
  "workflow.condition.value": NoParams;
  "workflow.condition.op": NoParams;
  "workflow.condition.compare": NoParams;
  "workflow.condition.op.is": NoParams;
  "workflow.condition.op.isNot": NoParams;
  "workflow.condition.op.contains": NoParams;
  "workflow.condition.op.isEmpty": NoParams;
  "workflow.condition.op.isNotEmpty": NoParams;
  "workflow.condition.op.greaterThan": NoParams;
  "workflow.condition.op.lessThan": NoParams;
  "workflow.var.trigger.user": NoParams;
  "workflow.var.trigger.joined": NoParams;
  "workflow.var.trigger.reactor": NoParams;
  "workflow.var.trigger.channel": NoParams;
  "workflow.var.trigger.message": NoParams;
  "workflow.var.trigger.messageText": NoParams;
  "workflow.var.trigger.messageAuthor": NoParams;
  "workflow.var.trigger.emoji": NoParams;
  "workflow.var.trigger.time": NoParams;
  "workflow.var.output.submitter": NoParams;
  "workflow.var.output.message": NoParams;
  "workflow.var.output.channel": NoParams;
  "workflow.var.output.page": NoParams;
  "workflow.var.output.row": NoParams;
  "workflow.problem.noName": NoParams;
  "workflow.problem.noSteps": NoParams;
  "workflow.problem.tooManySteps": NoParams;
  "workflow.problem.noChannel": NoParams;
  "workflow.problem.noEmoji": NoParams;
  "workflow.problem.badTimeZone": NoParams;
  "workflow.problem.scheduleInPast": NoParams;
  "workflow.problem.duplicateVariable": { key: string };
  "workflow.problem.duplicateStep": NoParams;
  "workflow.problem.emptyText": NoParams;
  "workflow.problem.unknownVariable": { ref: string };
  "workflow.problem.noRunner": NoParams;
  "workflow.problem.formNeedsLink": NoParams;
  "workflow.problem.duplicateField": { field: string };
  "workflow.problem.noOptions": { field: string };
  "workflow.problem.notAMessage": NoParams;
  "workflow.problem.notAUser": NoParams;
  "workflow.problem.noDatabase": NoParams;
  "workflow.problem.noApp": NoParams;
  "workflow.managers.title": NoParams;
  "workflow.managers.body": NoParams;
  "workflow.managers.creator": { name: string };
  "workflow.managers.add": NoParams;
  "workflow.managers.remove": { name: string };
  "workflow.delete.action": NoParams;
  "workflow.delete.confirm": NoParams;
  "workflow.leave.title": NoParams;
  "workflow.leave.body": NoParams;
  "workflow.leave.stay": NoParams;
  "workflow.leave.discard": NoParams;
  "workflow.activity.title": NoParams;
  "workflow.activity.refresh": NoParams;
  "workflow.activity.empty": NoParams;
  "workflow.activity.error": NoParams;
  "workflow.run.status.running": NoParams;
  "workflow.run.status.waiting": NoParams;
  "workflow.run.status.completed": NoParams;
  "workflow.run.status.failed": NoParams;
  "workflow.run.status.cancelled": NoParams;
  "workflow.run.step.running": NoParams;
  "workflow.run.step.waiting": NoParams;
  "workflow.run.step.done": NoParams;
  "workflow.run.step.skipped": NoParams;
  "workflow.run.step.failed": NoParams;
  "workflow.run.test": NoParams;
  "workflow.run.by": { name: string; when: string };
  "workflow.run.version": { version: string };
  "workflow.run.attempts": { count: number };
  "workflow.menu.run": NoParams;
  "workflow.menu.manage": NoParams;
  "workflow.notice.saved": NoParams;
  "workflow.notice.saveFailed": NoParams;
  "workflow.notice.published": NoParams;
  "workflow.notice.publishFailed": NoParams;
  "workflow.notice.unpublished": NoParams;
  "workflow.notice.failed": NoParams;
  "workflow.notice.testStarted": NoParams;
  "workflow.notice.testFailed": NoParams;
  "workflow.notice.deleted": NoParams;
  "workflow.notice.cantCreate": NoParams;
  "moderation.report.action": NoParams;
  "moderation.block.action": { name: string };
  "moderation.profile.block": NoParams;
  "moderation.profile.unblock": NoParams;
  "moderation.report.title": NoParams;
  "moderation.report.reason.spam": NoParams;
  "moderation.report.reason.harassment": NoParams;
  "moderation.report.reason.inappropriate": NoParams;
  "moderation.report.reason.other": NoParams;
  "moderation.report.note.label": NoParams;
  "moderation.report.note.placeholder": NoParams;
  "moderation.report.submit": NoParams;
  "moderation.report.done": NoParams;
  "moderation.report.failed": NoParams;
  "moderation.block.confirm.title": { name: string };
  "moderation.block.confirm.body": NoParams;
  "moderation.block.confirm.action": NoParams;
  "moderation.block.done": { name: string };
  "moderation.unblock.done": { name: string };
  "moderation.block.failed": NoParams;
  "moderation.collapsed.text": NoParams;
  "moderation.collapsed.show": NoParams;
  "moderation.composer.blocked": { name: string };
  "moderation.composer.unblock": NoParams;
  "moderation.error.blocked": NoParams;
  "settings.nav.privacy": NoParams;
  "moderation.blockedPeople.title": NoParams;
  "moderation.blockedPeople.help": NoParams;
  "moderation.blockedPeople.empty": NoParams;
  "moderation.blockedPeople.unblock": NoParams;
  "settings.nav.reports": NoParams;
  "moderation.reports.title": NoParams;
  "moderation.reports.help": NoParams;
  "moderation.reports.empty": NoParams;
  "moderation.reports.reportedBy": { name: string };
  "moderation.reports.author": { name: string };
  "moderation.reports.in": { channel: string };
  "moderation.reports.reason": { reason: string };
  "moderation.reports.note": { note: string };
  "moderation.reports.deleteMessage": NoParams;
  "moderation.reports.dismiss": NoParams;
  "moderation.reports.deleted": NoParams;
  "moderation.reports.dismissed": NoParams;
  "moderation.reports.failed": NoParams;
  "moderation.reports.loadFailed": NoParams;
  "moderation.reports.directMessage": NoParams;
  "mail.sync.google.optionalScopes": NoParams;
  "mail.sync.google.noDomains": NoParams;
  "mail.sync.google.missingScopes": { scopes: string; clientId: string };
  "mail.sync.google.missingScopesOwn": { scopes: string };
  "mail.sync.google.syncNow": NoParams;
  "mail.sync.google.domainsTitle": NoParams;
  "mail.sync.google.domainsHelp": NoParams;
  "mail.sync.google.domainsProposed": NoParams;
  "mail.sync.google.domainPrimary": NoParams;
  "mail.sync.google.domainSecondary": NoParams;
  "mail.sync.google.domainAliasOf": { domain: string };
  "mail.sync.google.importDomain": NoParams;
  "mail.sync.google.saveDomains": NoParams;
  "mail.sync.google.aliases": { count: number };
  "mail.sync.google.skippedDomains": { domains: string };
  "mail.thread.via": { address: string };
  "mail.invite.organizer": NoParams;
  "mail.invite.organizerTime": { time: string; city: string };
  "mail.invite.guestsWithYou": { names: string };
  "mail.invite.guestsMore": { count: number };
  "mail.invite.join": NoParams;
  "mail.invite.inYourCalendar": NoParams;
  "mail.invite.noConflicts": NoParams;
  "mail.invite.conflict": { title: string; time: string };
  "mail.invite.propose": NoParams;
  "mail.invite.more": NoParams;
  "mail.invite.openCalendar": NoParams;
  "mail.invite.download": NoParams;
  "mail.invite.answered.accepted": NoParams;
  "mail.invite.answered.declined": NoParams;
  "mail.invite.answered.tentative": NoParams;
  "mail.invite.sentTo": { address: string };
  "mail.invite.change": NoParams;
  "mail.invite.answerKept": { answer: string };
  "mail.invite.cancelled": NoParams;
  "mail.invite.removed": NoParams;
  "mail.invite.superseded": NoParams;
  "mail.invite.answerFailed": NoParams;
  "mail.invite.replyNotSetUp": { domain: string };
  "mail.invite.proposeSubject": { title: string };
  "mail.invite.proposeText": { time: string };
  "mail.settings.tab.groups": NoParams;
  "mail.settings.groups": NoParams;
  "mail.settings.groupsHelp": NoParams;
  "mail.settings.groupsEmpty": NoParams;
  "mail.settings.groupNew": NoParams;
  "mail.settings.groupAddress": NoParams;
  "mail.settings.groupName": NoParams;
  "mail.settings.groupWhoCanPost": NoParams;
  "mail.settings.groupPost.anyone": NoParams;
  "mail.settings.groupPost.organization": NoParams;
  "mail.settings.groupPost.members": NoParams;
  "mail.settings.groupMembers": NoParams;
  "mail.settings.groupMembersCount": { count: number };
  "mail.settings.groupAddMailbox": NoParams;
  "mail.settings.groupAddExternal": NoParams;
  "mail.settings.groupAddExternalButton": NoParams;
  "mail.settings.groupOutside": NoParams;
  "mail.settings.groupImported": NoParams;
  "mail.settings.groupEdited": NoParams;
  "mail.settings.groupSave": NoParams;
  "mail.settings.groupEdit": NoParams;
  "mail.settings.groupDelete": NoParams;
  "mail.settings.groupDeleteConfirm": { address: string };
  "mail.settings.suggested": NoParams;
  "mail.settings.suggestedAdd": NoParams;
  "mail.settings.suggestedAlias": { domain: string };
  "mail.sync.google.domainsList": { domains: string };
  "mail.sync.google.groupsCount": { count: number };
  "settings.nav.features": NoParams;
  "shell.view.huddles": NoParams;
  "nav.huddles": NoParams;
  "settings.nav.huddles": NoParams;
  "huddles.title": NoParams;
  "huddles.new": NoParams;
  "huddles.all": NoParams;
  "huddles.start": NoParams;
  "huddles.start.hint": NoParams;
  "huddles.getLink": NoParams;
  "huddles.getLink.hint": { workspace: string };
  "huddles.schedule": NoParams;
  "huddles.schedule.hint": NoParams;
  "huddles.join.placeholder": NoParams;
  "huddles.join.action": NoParams;
  "huddles.join.invalid": NoParams;
  "huddles.section.live": NoParams;
  "huddles.section.upcoming": NoParams;
  "huddles.section.recent": NoParams;
  "huddles.section.links": NoParams;
  "huddles.empty.live": NoParams;
  "huddles.empty.upcoming": NoParams;
  "huddles.empty.recent": NoParams;
  "huddles.empty.links": NoParams;
  "huddles.people": { count: number };
  "huddles.outside": { count: number };
  "huddles.linkOf": { name: string };
  "huddles.untitled": NoParams;
  "huddles.join": NoParams;
  "huddles.open": NoParams;
  "huddles.revoke": NoParams;
  "huddles.revoke.confirm": NoParams;
  "huddles.chip.notes": NoParams;
  "huddles.chip.transcript": NoParams;
  "huddles.chip.chat": NoParams;
  "huddles.link.ready": NoParams;
  "huddles.link.name": NoParams;
  "huddles.link.making": NoParams;
  "huddles.link.untilRevoked": NoParams;
  "huddles.link.error": NoParams;
  "huddles.link.startNow": NoParams;
  "huddles.link.done": NoParams;
  "huddles.access.label": NoParams;
  "huddles.access.ask": NoParams;
  "huddles.access.ask.hint": { workspace: string };
  "huddles.access.open": NoParams;
  "huddles.access.open.hint": NoParams;
  "huddles.access.workspace": { workspace: string };
  "huddles.access.workspace.hint": NoParams;
  "huddles.schedule.title": NoParams;
  "huddles.schedule.date": NoParams;
  "huddles.schedule.time": NoParams;
  "huddles.schedule.invite": { workspace: string };
  "huddles.schedule.notice": NoParams;
  "huddles.schedule.save": NoParams;
  "huddles.schedule.past": NoParams;
  "huddles.start.title": NoParams;
  "huddles.start.who": NoParams;
  "huddles.start.whoPeople": NoParams;
  "huddles.start.nobody": NoParams;
  "huddles.start.chatOff": NoParams;
  "huddles.start.action": NoParams;
  "huddles.start.error": NoParams;
  "huddles.loadError": NoParams;
  "huddles.record.openInChat": NoParams;
  "huddles.record.again": NoParams;
  "huddles.record.attendees": NoParams;
  "huddles.record.noChat": NoParams;
  "huddles.record.noNotes": NoParams;
  "huddles.record.recording": NoParams;
  "huddles.record.recordedBy": { name: string };
  "huddles.record.error": NoParams;
  "settings.huddles.links": NoParams;
  "settings.huddles.links.hint": { workspace: string };
  "settings.huddles.transcribe": NoParams;
  "settings.huddles.transcribe.hint": { workspace: string };
  "settings.huddles.outside": { workspace: string };
  "settings.huddles.outside.link": NoParams;
  "settings.huddles.outside.link.hint": NoParams;
  "settings.huddles.outside.ask": NoParams;
  "settings.huddles.outside.ask.hint": NoParams;
  "settings.huddles.outside.none": NoParams;
  "settings.huddles.outside.none.hint": { workspace: string };
  "settings.huddles.default": NoParams;
  "settings.huddles.revokeAll": NoParams;
  "settings.huddles.revokeAll.hint": { workspace: string };
  "settings.huddles.revokeAll.confirm": { workspace: string };
  "settings.huddles.revoked": { count: number };
  "settings.huddles.chatOff": NoParams;
  "meeting.page.restricted": NoParams;
  "meeting.page.signIn": NoParams;
  "features.title": NoParams;
  "features.intro": NoParams;
  "features.chat.title": NoParams;
  "features.chat.hint": NoParams;
  "features.mail.title": NoParams;
  "features.mail.hint": NoParams;
  "features.calendar.title": NoParams;
  "features.calendar.hint": NoParams;
  "features.contacts.title": NoParams;
  "features.contacts.hint": NoParams;
  "features.docs.title": NoParams;
  "features.docs.hint": NoParams;
  "features.huddles.title": NoParams;
  "features.huddles.hint": NoParams;
  "features.needsParent": { area: string };
  "features.lastOne": NoParams;
  "features.adminsOnly": NoParams;
  "features.turnedOff": { area: string };
  "features.turnedOn": { area: string };
  "features.disabled.title": { area: string };
  "features.disabled.body": { area: string };
  "features.error": NoParams;
  "features.adminAccess.title": NoParams;
  "features.adminAccess.none": NoParams;
  "features.adminAccess.read": NoParams;
  "features.adminAccess.full": NoParams;
  "features.adminAccess.hint": NoParams;
  "features.readOnly": { area: string };
  "mail.sync.google.what": NoParams;
  "mail.sync.google.whatMail": NoParams;
  "mail.sync.google.messages": { count: number };
  "mail.sync.google.calendarNew": NoParams;
  "mail.sync.google.calendarHelp": NoParams;
  "mail.sync.google.calendarScopeTitle": NoParams;
  "mail.sync.google.calendarScope": { clientId: string };
  "mail.sync.google.calendarScopeOwn": NoParams;
  "mail.sync.google.copyScope": NoParams;
  "mail.sync.google.checkAgain": NoParams;
  "mail.sync.calendar.label": NoParams;
  "mail.sync.calendar.waiting": NoParams;
  "mail.sync.calendar.listing": NoParams;
  "mail.sync.calendar.importing": { total: number; done: string };
  "mail.sync.calendar.calendars": { count: number };
  "mail.sync.calendar.events": { count: number };
  "mail.sync.google.readersDelegates": { count: number };
  "mail.sync.google.readersGroup": { count: number };
  "mail.sync.google.readersPending": { count: number };
  "mail.sync.google.noDelegates": NoParams;
  "mail.sync.google.delegatesUnreadable": NoParams;
  "mail.settings.memberFromGoogle": NoParams;
  "mail.settings.noDelegates": NoParams;
  "mail.settings.googleReadersPending": { count: number };
  "settings.nav.navigation": NoParams;
  "settings.navigation.customizeTabs": NoParams;
  "settings.navigation.description": NoParams;
  "settings.navigation.rowFooter": NoParams;
  "settings.navigation.default": NoParams;
  "settings.navigation.custom": NoParams;
  "settings.navigation.preview": { workspace: string };
  "settings.navigation.tabBar": NoParams;
  "settings.navigation.tabBarCount": { count: string; max: string };
  "settings.navigation.tabBarFooter": { max: string };
  "settings.navigation.alwaysFirst": NoParams;
  "settings.navigation.alwaysLast": NoParams;
  "settings.navigation.onHome": NoParams;
  "settings.navigation.onHomeFooter": NoParams;
  "settings.navigation.onHomeFooterFull": NoParams;
  "settings.navigation.noRoom": NoParams;
  "settings.navigation.off": { workspace: string };
  "settings.navigation.offRow": NoParams;
  "settings.navigation.offShort": NoParams;
  "settings.navigation.offFooter": { workspace: string };
  "settings.navigation.remove": NoParams;
  "settings.navigation.removeLabel": { area: string };
  "settings.navigation.add": NoParams;
  "settings.navigation.addLabel": { area: string };
  "settings.navigation.moveUp": { area: string };
  "settings.navigation.moveDown": { area: string };
  "settings.navigation.drag": { area: string };
  "settings.navigation.saveNote": NoParams;
  "settings.navigation.reset": NoParams;
  "settings.navigation.resetTitle": NoParams;
  "settings.navigation.resetBody": NoParams;
  "settings.navigation.resetConfirm": NoParams;
  "settings.navigation.saveFailed": NoParams;
  "settings.navigation.loading": NoParams;
  "settings.navigation.loadFailedTitle": NoParams;
  "settings.navigation.loadFailedBody": NoParams;
  "settings.navigation.retry": NoParams;
  "drive.role.viewer": NoParams;
  "drive.role.commenter": NoParams;
  "drive.role.editor": NoParams;
  "drive.role.owner": NoParams;
  "drive.move.sameFolder": NoParams;
  "drive.move.intoItself": NoParams;
  "drive.title": NoParams;
  "files.picker.signIn": NoParams;
  "files.picker.offline": NoParams;
  "drive.new": NoParams;
  "drive.new.folder": NoParams;
  "drive.new.fileUpload": NoParams;
  "drive.new.folderUpload": NoParams;
  "drive.new.page": NoParams;
  "drive.new.database": NoParams;
  "drive.new.untitled": NoParams;
  "drive.view.my": NoParams;
  "drive.view.shared": NoParams;
  "drive.view.recent": NoParams;
  "drive.view.starred": NoParams;
  "drive.view.trash": NoParams;
  "drive.view.conversations": NoParams;
  "drive.search": NoParams;
  "drive.searchResults": { q: string };
  "drive.upload": NoParams;
  "drive.layout": NoParams;
  "drive.layout.list": NoParams;
  "drive.layout.grid": NoParams;
  "drive.col.name": NoParams;
  "drive.col.owner": NoParams;
  "drive.col.modified": NoParams;
  "drive.col.size": NoParams;
  "drive.col.actions": NoParams;
  "drive.owner.me": NoParams;
  "drive.modifiedBy": { date: string; name: string };
  "drive.section.folders": NoParams;
  "drive.section.files": NoParams;
  "drive.filter.type": NoParams;
  "drive.filter.people": NoParams;
  "drive.filter.modified": NoParams;
  "drive.filter.source": NoParams;
  "drive.filter.any": NoParams;
  "drive.filter.clear": NoParams;
  "drive.type.folder": NoParams;
  "drive.type.document": NoParams;
  "drive.type.spreadsheet": NoParams;
  "drive.type.presentation": NoParams;
  "drive.type.pdf": NoParams;
  "drive.type.image": NoParams;
  "drive.type.video": NoParams;
  "drive.type.audio": NoParams;
  "drive.type.archive": NoParams;
  "drive.type.page": NoParams;
  "drive.type.other": NoParams;
  "drive.people.me": NoParams;
  "drive.people.notMe": NoParams;
  "drive.modified.today": NoParams;
  "drive.modified.week": NoParams;
  "drive.modified.month": NoParams;
  "drive.modified.year": NoParams;
  "drive.source.files": NoParams;
  "drive.source.chat": NoParams;
  "drive.source.mail": NoParams;
  "drive.source.pages": NoParams;
  "drive.sort": { by: string };
  "drive.sort.name": NoParams;
  "drive.sort.modified": NoParams;
  "drive.sort.viewed": NoParams;
  "drive.sort.size": NoParams;
  "drive.sort.shared": NoParams;
  "drive.sort.asc": NoParams;
  "drive.sort.desc": NoParams;
  "drive.action.open": NoParams;
  "drive.action.share": NoParams;
  "drive.action.copyLink": NoParams;
  "drive.action.rename": NoParams;
  "drive.action.move": NoParams;
  "drive.action.copy": NoParams;
  "drive.action.star": NoParams;
  "drive.action.unstar": NoParams;
  "drive.action.versions": NoParams;
  "drive.action.download": NoParams;
  "drive.action.trash": NoParams;
  "drive.action.details": NoParams;
  "drive.action.restore": NoParams;
  "drive.action.deleteForever": NoParams;
  "drive.action.emptyTrash": NoParams;
  "drive.action.more": NoParams;
  "drive.selected": { count: number };
  "drive.clearSelection": NoParams;
  "drive.details": NoParams;
  "drive.details.activity": NoParams;
  "drive.details.access": NoParams;
  "drive.details.manage": NoParams;
  "drive.details.type": NoParams;
  "drive.details.size": NoParams;
  "drive.details.location": NoParams;
  "drive.details.owner": NoParams;
  "drive.details.modified": NoParams;
  "drive.details.created": NoParams;
  "drive.details.versions": NoParams;
  "drive.details.sharedIn": NoParams;
  "drive.details.close": NoParams;
  "drive.details.empty": NoParams;
  "drive.details.onlyOwner": NoParams;
  "drive.details.modifiedLine": { name: string; date: string };
  "drive.details.createdLine": { name: string; date: string };
  "drive.details.viewedLine": { date: string };
  "drive.kind.folder": NoParams;
  "drive.kind.page": NoParams;
  "drive.kind.database": NoParams;
  "drive.kind.shortcut": NoParams;
  "drive.breadcrumb": NoParams;
  "drive.shared": NoParams;
  "drive.folderMenu": NoParams;
  "drive.storage": NoParams;
  "drive.storage.used": { used: string; quota: string };
  "drive.storage.meter": { percent: string };
  "drive.storage.manage": NoParams;
  "drive.storage.warning": { percent: string };
  "drive.storage.warningBody": { quota: string };
  "drive.storage.full": NoParams;
  "drive.storage.fullNotice": NoParams;
  "drive.storage.mine.files": NoParams;
  "drive.storage.mine.attachments": NoParams;
  "drive.storage.mine.versions": NoParams;
  "drive.storage.mine.trash": NoParams;
  "drive.drop": { folder: string };
  "drive.drop.hint": NoParams;
  "drive.uploads.title": { count: number };
  "drive.uploads.finished": { count: number };
  "drive.uploads.collapse": NoParams;
  "drive.uploads.expand": NoParams;
  "drive.uploads.close": NoParams;
  "drive.uploads.instant": NoParams;
  "drive.uploads.done": NoParams;
  "drive.uploads.failed": NoParams;
  "drive.uploads.canceled": NoParams;
  "drive.uploads.waiting": NoParams;
  "drive.uploads.percent": { percent: string };
  "drive.uploads.folderCount": { done: string; total: string };
  "drive.uploads.cancel": NoParams;
  "drive.uploads.retry": NoParams;
  "drive.uploads.resume": NoParams;
  "drive.upload.tooBig": { count: number };
  "drive.conflict.title": NoParams;
  "drive.conflict.body": { count: number; name: string };
  "drive.conflict.replace": NoParams;
  "drive.conflict.keep": NoParams;
  "drive.conflict.upload": NoParams;
  "drive.name.rename": NoParams;
  "drive.name.label": NoParams;
  "drive.name.create": NoParams;
  "drive.name.ok": NoParams;
  "drive.name.invalid": NoParams;
  "drive.name.untitledFolder": NoParams;
  "drive.move.title": { count: number; name: string };
  "drive.move.here": NoParams;
  "drive.move.back": NoParams;
  "drive.move.empty": NoParams;
  "drive.move.noAccess": NoParams;
  "drive.move.current": NoParams;
  "drive.notice.trashed": { count: number };
  "drive.notice.restored": { count: number };
  "drive.notice.copied": { count: number };
  "drive.notice.moved": { count: number };
  "drive.notice.versionRestored": NoParams;
  "drive.notice.ownerChanged": NoParams;
  "drive.notice.linkCopied": NoParams;
  "drive.error.notFound": NoParams;
  "drive.error.conflict": NoParams;
  "drive.error.offline": NoParams;
  "drive.error.failed": NoParams;
  "drive.preview.close": NoParams;
  "drive.preview.noPreview.title": NoParams;
  "drive.preview.noPreview.body": { name: string; size: string };
  "drive.versions.title": NoParams;
  "drive.versions.hint": NoParams;
  "drive.versions.upload": NoParams;
  "drive.versions.current": NoParams;
  "drive.versions.number": { n: string };
  "drive.versions.keepForever": NoParams;
  "drive.versions.unkeep": NoParams;
  "drive.versions.kept": NoParams;
  "drive.versions.restore": NoParams;
  "drive.versions.delete": NoParams;
  "drive.versions.actions": NoParams;
  "drive.versions.open": NoParams;
  "drive.versions.device": { device: string };
  "drive.share.title": { name: string };
  "drive.share.add": NoParams;
  "drive.share.people": NoParams;
  "drive.share.you": { name: string };
  "drive.share.group": { count: number };
  "drive.share.channel": { count: number };
  "drive.share.workspace": { workspace: string };
  "drive.share.workspaceHint": NoParams;
  "drive.share.inherited": { folder: string };
  "drive.share.transfer": NoParams;
  "drive.share.remove": NoParams;
  "drive.share.general": NoParams;
  "drive.share.restricted": NoParams;
  "drive.share.restrictedHint": NoParams;
  "drive.share.anyoneAt": { workspace: string };
  "drive.share.anyoneHint": NoParams;
  "drive.share.copyLink": NoParams;
  "drive.share.done": NoParams;
  "drive.share.addRole": NoParams;
  "drive.share.noResults": NoParams;
  "drive.share.readOnly": NoParams;
  "drive.share.change": { name: string };
  "drive.share.anyone": NoParams;
  "drive.share.anyoneLinkHint": NoParams;
  "drive.share.blocked.off": NoParams;
  "drive.share.blocked.admins": NoParams;
  "drive.share.anyoneRoleNote": { workspace: string; role: string };
  "drive.empty.my.title": NoParams;
  "drive.empty.my.body": NoParams;
  "drive.empty.upload": NoParams;
  "drive.empty.shared.title": NoParams;
  "drive.empty.shared.body": NoParams;
  "drive.empty.recent.title": NoParams;
  "drive.empty.recent.body": NoParams;
  "drive.empty.starred.title": NoParams;
  "drive.empty.starred.body": NoParams;
  "drive.empty.trash.title": NoParams;
  "drive.empty.trash.body": NoParams;
  "drive.empty.conversations.title": NoParams;
  "drive.empty.conversations.body": NoParams;
  "drive.empty.folder.title": NoParams;
  "drive.empty.folder.body": NoParams;
  "drive.empty.search.title": { q: string };
  "drive.empty.search.body": NoParams;
  "drive.empty.filtered.title": NoParams;
  "drive.trash.banner": NoParams;
  "drive.trash.confirmTitle": NoParams;
  "drive.trash.confirmBody": { count: number; name: string };
  "drive.trash.emptyTitle": NoParams;
  "drive.trash.emptyBody": NoParams;
  "drive.cancel": NoParams;
  "drive.failed": NoParams;
  "drive.retry": NoParams;
  "drive.from.dm": NoParams;
  "drive.from.mail": NoParams;
  "drive.from.page": NoParams;
  "drive.from.row": NoParams;
  "drive.sharedIn": { where: string };
  "drive.attachment": NoParams;
  "files.share.anyone": NoParams;
  "files.share.anyoneHint": NoParams;
  "files.share.workspaceHint": NoParams;
  "files.share.anyoneNote": { workspace: string; role: string };
  "files.share.blockedOff": NoParams;
  "files.share.blockedAdmins": NoParams;
  "files.upload.photos": NoParams;
  "files.offline": NoParams;
  "sync.files.entry": NoParams;
  "sync.files.entryOn": NoParams;
  "sync.files.getApp": NoParams;
  "sync.setup.windowTitle": NoParams;
  "sync.setup.title": NoParams;
  "sync.setup.subtitle": NoParams;
  "sync.mode.label": NoParams;
  "sync.mode.mirror": NoParams;
  "sync.mode.mirrorBody": NoParams;
  "sync.mode.stream": NoParams;
  "sync.mode.streamBody": NoParams;
  "sync.mode.streamRecommended": NoParams;
  "sync.mode.streamOff": { reason: string };
  "sync.mode.streamOff.unsupportedOs": NoParams;
  "sync.mode.streamOff.notVerified": NoParams;
  "sync.mode.streamOff.unsigned": NoParams;
  "sync.location": NoParams;
  "sync.location.change": NoParams;
  "sync.location.hint": NoParams;
  "sync.location.streamHint": NoParams;
  "sync.folders.title": NoParams;
  "sync.folders.hint": NoParams;
  "sync.folders.loose": NoParams;
  "sync.folders.empty": NoParams;
  "sync.folders.failed": NoParams;
  "sync.folders.expand": { name: string };
  "sync.folders.collapse": { name: string };
  "sync.setup.start": NoParams;
  "sync.setup.failed": NoParams;
  "sync.setup.folderNotEmpty": NoParams;
  "sync.cancel": NoParams;
  "sync.save": NoParams;
  "sync.status.off": NoParams;
  "sync.status.offBody": NoParams;
  "sync.status.starting": NoParams;
  "sync.status.idle": NoParams;
  "sync.status.lastSynced": { time: string };
  "sync.status.syncing": { count: number };
  "sync.status.left": { size: string };
  "sync.status.paused": NoParams;
  "sync.status.pausedUntil": { time: string };
  "sync.status.pausedBody": NoParams;
  "sync.status.offline": NoParams;
  "sync.status.offlineBody": NoParams;
  "sync.status.offlineBodyStream": NoParams;
  "sync.status.error": NoParams;
  "sync.status.errorBody": { count: number };
  "sync.progress": NoParams;
  "sync.pause": NoParams;
  "sync.pause.hour": NoParams;
  "sync.pause.tomorrow": { time: string };
  "sync.pause.manual": NoParams;
  "sync.resume": NoParams;
  "sync.menu": NoParams;
  "sync.menu.preferences": NoParams;
  "sync.menu.quit": NoParams;
  "sync.openFolder": NoParams;
  "sync.openBundle": NoParams;
  "sync.setUp": NoParams;
  "sync.activity": NoParams;
  "sync.activity.empty": NoParams;
  "sync.activity.uploaded": NoParams;
  "sync.activity.downloaded": NoParams;
  "sync.activity.newVersion": NoParams;
  "sync.activity.newVersionBy": { name: string };
  "sync.activity.conflict": NoParams;
  "sync.activity.trashed": NoParams;
  "sync.activity.moved": NoParams;
  "sync.activity.created": NoParams;
  "sync.activity.error": NoParams;
  "sync.transfer.up": { percent: string; size: string };
  "sync.transfer.down": { percent: string; size: string };
  "sync.errors": NoParams;
  "sync.conflict.banner": { name: string };
  "sync.conflict.bannerMany": { count: number };
  "sync.conflict.review": NoParams;
  "sync.conflict.title": { name: string };
  "sync.conflict.body": NoParams;
  "sync.conflict.bodyBy": { name: string };
  "sync.conflict.mine": NoParams;
  "sync.conflict.theirs": NoParams;
  "sync.conflict.theirsBy": { name: string };
  "sync.conflict.savedAs": { name: string };
  "sync.conflict.keptAs": { name: string };
  "sync.conflict.useMine": NoParams;
  "sync.conflict.useTheirs": NoParams;
  "sync.conflict.keepBoth": NoParams;
  "sync.conflict.note": NoParams;
  "sync.conflict.failed": NoParams;
  "sync.prefs.windowTitle": NoParams;
  "sync.prefs.nav": NoParams;
  "sync.prefs.myFiles": NoParams;
  "sync.prefs.general": NoParams;
  "sync.prefs.conflicts": NoParams;
  "sync.prefs.foldersNote": NoParams;
  "sync.prefs.foldersStream": NoParams;
  "sync.prefs.toStreamTitle": NoParams;
  "sync.prefs.toStreamBody": { path: string };
  "sync.prefs.toStreamConfirm": NoParams;
  "sync.prefs.toMirrorTitle": NoParams;
  "sync.prefs.toMirrorBody": { path: string };
  "sync.prefs.toMirrorConfirm": NoParams;
  "sync.prefs.modeFailed": NoParams;
  "sync.prefs.saved": NoParams;
  "sync.prefs.launchAtLogin": NoParams;
  "sync.prefs.bandwidth": NoParams;
  "sync.prefs.uploadLimit": NoParams;
  "sync.prefs.downloadLimit": NoParams;
  "sync.prefs.noLimit": NoParams;
  "sync.prefs.kbps": { value: string };
  "sync.prefs.mbps": { value: string };
  "sync.prefs.disconnect": NoParams;
  "sync.prefs.disconnectTitle": NoParams;
  "sync.prefs.disconnectBody": { path: string };
  "sync.prefs.disconnectBodyStream": { path: string };
  "sync.prefs.noConflicts": NoParams;
  "sync.prefs.failed": NoParams;
  "sync.unavailable": NoParams;
  "shell.view.calendar": NoParams;
  "shell.view.contacts": NoParams;
  "booking.pages": NoParams;
  "booking.paused": NoParams;
  "booking.copyLink": NoParams;
  "booking.copyLinkTo": { title: string };
  "booking.moreFor": { title: string };
  "booking.linkCopied": NoParams;
  "booking.saveFailed": NoParams;
  "booking.deleteFailed": NoParams;
  "booking.create.button": NoParams;
  "booking.create.event": NoParams;
  "booking.create.page": NoParams;
  "booking.create.pageHelp": NoParams;
  "booking.empty.title": NoParams;
  "booking.empty.body": NoParams;
  "booking.menu.open": NoParams;
  "booking.menu.edit": NoParams;
  "booking.menu.pause": NoParams;
  "booking.menu.resume": NoParams;
  "booking.menu.reset": NoParams;
  "booking.menu.resetShort": NoParams;
  "booking.menu.delete": NoParams;
  "booking.menu.deleteShort": NoParams;
  "booking.reset.title": NoParams;
  "booking.reset.body": NoParams;
  "booking.delete.title": { title: string };
  "booking.delete.body": NoParams;
  "booking.location.bundleMeeting": NoParams;
  "booking.location.inPerson": NoParams;
  "booking.location.phone": NoParams;
  "booking.location.none": NoParams;
  "booking.color.gray": NoParams;
  "booking.color.brown": NoParams;
  "booking.color.orange": NoParams;
  "booking.color.yellow": NoParams;
  "booking.color.green": NoParams;
  "booking.color.blue": NoParams;
  "booking.color.purple": NoParams;
  "booking.color.pink": NoParams;
  "booking.color.red": NoParams;
  "booking.zone.label": NoParams;
  "booking.zone.detected": NoParams;
  "booking.editor.newTitle": NoParams;
  "booking.editor.editTitle": NoParams;
  "booking.editor.close": NoParams;
  "booking.editor.title": NoParams;
  "booking.editor.titlePlaceholder": NoParams;
  "booking.editor.duration": NoParams;
  "booking.editor.general": NoParams;
  "booking.editor.generalHelp": NoParams;
  "booking.editor.repeatsWeekly": NoParams;
  "booking.editor.unavailable": NoParams;
  "booking.editor.from": NoParams;
  "booking.editor.to": NoParams;
  "booking.editor.removePeriod": NoParams;
  "booking.editor.addPeriod": NoParams;
  "booking.editor.addAnotherPeriod": NoParams;
  "booking.editor.copyToAll": NoParams;
  "booking.editor.overlap": NoParams;
  "booking.editor.endBeforeStart": NoParams;
  "booking.editor.noHours": NoParams;
  "booking.editor.window": NoParams;
  "booking.editor.maxAhead": NoParams;
  "booking.editor.daysSuffix": { count: number };
  "booking.editor.noLimit": NoParams;
  "booking.editor.minNotice": NoParams;
  "booking.editor.noNotice": NoParams;
  "booking.editor.dateHours": NoParams;
  "booking.editor.dateHoursHelp": NoParams;
  "booking.editor.addDate": NoParams;
  "booking.editor.removeDate": NoParams;
  "booking.editor.appointment": NoParams;
  "booking.editor.buffer": NoParams;
  "booking.editor.noBuffer": NoParams;
  "booking.editor.minutesLong": { count: number };
  "booking.editor.hoursLong": { count: number };
  "booking.editor.maxPerDay": NoParams;
  "booking.editor.guestsCanInvite": NoParams;
  "booking.editor.calendars": NoParams;
  "booking.editor.checkCalendars": NoParams;
  "booking.editor.location": NoParams;
  "booking.editor.meetingHelp": NoParams;
  "booking.editor.address": NoParams;
  "booking.editor.phone": NoParams;
  "booking.editor.phoneHelp": NoParams;
  "booking.editor.description": NoParams;
  "booking.editor.form": NoParams;
  "booking.editor.formHelp": NoParams;
  "booking.editor.question": NoParams;
  "booking.editor.required": NoParams;
  "booking.editor.removeQuestion": NoParams;
  "booking.editor.addQuestion": NoParams;
  "booking.editor.verifyEmail": NoParams;
  "booking.editor.reminders": NoParams;
  "booking.editor.remindersHelp": NoParams;
  "booking.editor.addReminder": NoParams;
  "booking.editor.removeReminder": NoParams;
  "booking.editor.color": NoParams;
  "booking.editor.previewHelp": NoParams;
  "booking.event.booked": NoParams;
  "booking.event.bookedVia": { page: string };
  "booking.event.cancel": NoParams;
  "booking.event.showAs": NoParams;
  "booking.event.showAsBusy": NoParams;
  "booking.event.showAsFree": NoParams;
  "booking.public.poweredBy": NoParams;
  "booking.public.notFound": NoParams;
  "booking.public.loadFailed": NoParams;
  "booking.public.paused": NoParams;
  "booking.public.appointments": { duration: string };
  "booking.public.meetingLater": NoParams;
  "booking.public.phoneYou": NoParams;
  "booking.public.select": NoParams;
  "booking.public.prevWeek": NoParams;
  "booking.public.nextWeek": NoParams;
  "booking.public.jumpNext": NoParams;
  "booking.public.noTimes": NoParams;
  "booking.public.noTimesWeek": NoParams;
  "booking.public.dayNoTimes": { day: string };
  "booking.public.next": NoParams;
  "booking.public.back": NoParams;
  "booking.public.formTitle": NoParams;
  "booking.public.with": { title: string; name: string };
  "booking.public.firstName": NoParams;
  "booking.public.lastName": NoParams;
  "booking.public.email": NoParams;
  "booking.public.emailHelp": NoParams;
  "booking.public.emailInvalid": NoParams;
  "booking.public.required": NoParams;
  "booking.public.optional": { label: string };
  "booking.public.code": NoParams;
  "booking.public.codeHelp": { email: string };
  "booking.public.badCode": NoParams;
  "booking.public.consent": { name: string };
  "booking.public.sendCode": NoParams;
  "booking.public.book": NoParams;
  "booking.public.taken": NoParams;
  "booking.public.bookFailed": NoParams;
  "booking.public.booked": NoParams;
  "booking.public.sentTo": { email: string };
  "booking.public.reschedule": NoParams;
  "booking.public.cancel": NoParams;
  "booking.public.linksInEmail": NoParams;
  "booking.manage.title": NoParams;
  "booking.manage.notFound": NoParams;
  "booking.manage.join": NoParams;
  "booking.manage.pickNew": NoParams;
  "booking.manage.moveTo": { when: string };
  "booking.manage.keep": NoParams;
  "booking.manage.cancelTitle": NoParams;
  "booking.manage.cancelBody": { name: string };
  "booking.manage.reason": NoParams;
  "booking.manage.cancelled": NoParams;
  "booking.manage.ended": NoParams;
  "booking.manage.bookAgain": NoParams;
  "settings.nav.billing": NoParams;
  "billing.section.plan": NoParams;
  "billing.section.usage": NoParams;
  "billing.section.admins": NoParams;
  "billing.plan.trial": NoParams;
  "billing.plan.starter": NoParams;
  "billing.plan.none": NoParams;
  "billing.plan.founding": NoParams;
  "billing.founding": NoParams;
  "billing.founding.body": { ws: string };
  "billing.trial.chip": { n: number };
  "billing.trial.body": { date: string };
  "billing.trial.day": { day: string; total: string };
  "billing.trial.member": { ws: string; date: string };
  "billing.active.member": { ws: string };
  "billing.choosePlan": NoParams;
  "billing.whatsIncluded": NoParams;
  "billing.subscribe": NoParams;
  "billing.manage": NoParams;
  "billing.updateCard": NoParams;
  "billing.chip.active": NoParams;
  "billing.chip.trialCard": NoParams;
  "billing.chip.ending": NoParams;
  "billing.chip.readOnly": NoParams;
  "billing.pastDue.title": NoParams;
  "billing.price.perMonth": NoParams;
  "billing.price.annual": { total: string };
  "billing.price.monthly": NoParams;
  "billing.kv.nextPayment": NoParams;
  "billing.kv.trialEnds": NoParams;
  "billing.kv.firstPayment": NoParams;
  "billing.kv.amountOn": { amount: string; date: string };
  "billing.kv.endsOn": NoParams;
  "billing.kv.paymentDue": NoParams;
  "billing.kv.updateBy": { amount: string; date: string };
  "billing.kv.storage": NoParams;
  "billing.kv.storageValue": { n: string };
  "billing.kv.invoices": NoParams;
  "billing.viewInvoices": NoParams;
  "billing.portalFoot": NoParams;
  "billing.annual.title": { amount: string };
  "billing.annual.body": { annual: string; monthly: string };
  "billing.switchAnnual": NoParams;
  "billing.pastDue.banner.title": NoParams;
  "billing.pastDue.banner.until": { date: string; ws: string };
  "billing.pastDue.banner.body": { ws: string };
  "billing.readOnly": { ws: string };
  "billing.readOnly.trialEnded": { date: string };
  "billing.readOnly.ended": NoParams;
  "billing.readOnly.page": NoParams;
  "billing.locked.body": { date: string };
  "billing.locked.bodyNoDate": NoParams;
  "billing.native.attention": { ws: string };
  "billing.native.askAdmins": { names: string };
  "billing.native.composer": { names: string };
  "billing.native.trialMember": { ws: string; names: string };
  "billing.native.lockedBody": { date: string };
  "billing.native.lockedBodyNoDate": NoParams;
  "billing.native.inviteOver": { limit: string; ws: string; members: string; remove: string };
  "billing.native.inviteFullAdmin": NoParams;
  "billing.exportData": NoParams;
  "billing.askAdmins": { names: string };
  "billing.anAdmin": NoParams;
  "billing.trial.banner.title": { n: number };
  "billing.trial.banner.info": { ws: string; date: string };
  "billing.trial.banner.warning": { date: string; ws: string };
  "billing.trial.banner.danger": NoParams;
  "billing.trial.banner.member": { ws: string; names: string };
  "billing.composer.title": NoParams;
  "billing.composer.admin": NoParams;
  "billing.composer.member": { names: string };
  "billing.picker.title": NoParams;
  "billing.cycle.annual": { percent: string };
  "billing.cycle.monthly": NoParams;
  "billing.picker.billedYearly": { amount: string };
  "billing.picker.billedMonthly": NoParams;
  "billing.picker.inc.members": { n: string };
  "billing.picker.inc.storage": { gb: string };
  "billing.picker.inc.domain": NoParams;
  "billing.picker.inc.apps": NoParams;
  "billing.picker.storage.label": NoParams;
  "billing.picker.storage.hint": { price: string };
  "billing.picker.storage.none": NoParams;
  "billing.picker.storage.option": { gb: string };
  "billing.picker.dueToday": NoParams;
  "billing.picker.trialKept": { amount: string; date: string };
  "billing.continue": NoParams;
  "billing.picker.foot": NoParams;
  "billing.picker.pro": { n: string };
  "billing.contactPro": NoParams;
  "billing.confirm.title": NoParams;
  "billing.confirm.hint": NoParams;
  "billing.confirm.done": NoParams;
  "billing.confirm.slow": NoParams;
  "billing.usage.members": NoParams;
  "billing.usage.storage": NoParams;
  "billing.usage.membersLeft": { n: number };
  "billing.usage.membersFull": { limit: string };
  "billing.usage.pending": { n: number };
  "billing.usage.storageShared": NoParams;
  "billing.usage.storageAddons": { base: string; extra: string };
  "billing.pro.title": { n: string };
  "billing.pro.hint": NoParams;
  "billing.adminsOnly": NoParams;
  "billing.messageAdmin": NoParams;
  "billing.invite.over.title": { left: number };
  "billing.invite.over.body": { limit: string; ws: string; members: string; remove: string };
  "billing.invite.full.title": { ws: string; members: string; limit: string };
  "billing.invite.full.admin": NoParams;
  "billing.invite.full.memberTitle": { ws: string };
  "billing.invite.full.member": { limit: string; names: string };
  "billing.fault.required": { ws: string };
  "billing.fault.members": { ws: string };
  "billing.addStorage": NoParams;
  "billing.storageFull.title": { ws: string };
  "billing.storageFull.usage": { used: string; pool: string };
  "billing.storageFull.addStorage": NoParams;
  "billing.storageFull.choosePlan": NoParams;
  "billing.storageFull.contact": { ws: string };
  "billing.storageFull.web": NoParams;
  "billing.storageFull.store": { store: string };
  "billing.storageFull.member": { names: string };
  "billing.storageFull.notNow": NoParams;
  "billing.storageWarn.title": { ws: string; percent: string };
  "billing.storageWarn.fullTitle": { ws: string };
  "billing.storageWarn.addStorage": { used: string; pool: string };
  "billing.storageWarn.choosePlan": { used: string; pool: string };
  "billing.storageWarn.contact": { used: string; pool: string; ws: string };
  "billing.storageWarn.store": { used: string; pool: string; store: string };
  "billing.storageWarn.member": { used: string; pool: string; names: string };
  "billing.usage.storageLow": NoParams;
  "billing.usage.storageOut": NoParams;
  "billing.usage.storageLowMember": NoParams;
  "billing.usage.storageOutMember": NoParams;
  "billing.native.storageWarning": { used: string; pool: string };
  "billing.native.storageLow": NoParams;
  "billing.native.storageOut": NoParams;
  "billing.error.unavailable": NoParams;
  "billing.error.network": NoParams;
  "billing.error.generic": NoParams;
  "billing.usage.countRule": NoParams;
  "support.botName": NoParams;
  "support.help.button": NoParams;
  "support.help.center": NoParams;
  "support.help.whatsNew": NoParams;
  "support.help.shortcuts": NoParams;
  "support.help.ask": NoParams;
  "support.help.askHint": NoParams;
  "support.help.askFailed": NoParams;
  "support.help.feedback": NoParams;
  "support.help.section": NoParams;
  "support.help.version": { version: string };
  "support.kind.bug": NoParams;
  "support.kind.idea": NoParams;
  "support.kind.question": NoParams;
  "support.kind.label": NoParams;
  "support.form.title": NoParams;
  "support.form.subtitle": NoParams;
  "support.form.bug.label": NoParams;
  "support.form.bug.placeholder": NoParams;
  "support.form.idea.label": NoParams;
  "support.form.idea.placeholder": NoParams;
  "support.form.question.label": NoParams;
  "support.form.question.placeholder": NoParams;
  "support.form.addScreenshot": NoParams;
  "support.form.chooseFile": NoParams;
  "support.form.lastScreenshot": NoParams;
  "support.form.choosePhoto": NoParams;
  "support.form.removeScreenshot": NoParams;
  "support.form.screenshotSize": { size: string };
  "support.form.diagnostics": NoParams;
  "support.form.whatsIncluded": NoParams;
  "support.form.hideIncluded": NoParams;
  "support.form.send": NoParams;
  "support.form.cancel": NoParams;
  "support.form.tooShort": { min: string };
  "support.form.tooLong": { max: string };
  "support.form.notImage": NoParams;
  "support.form.tooBig": { mb: string };
  "support.form.rateLimited": { time: string };
  "support.form.error": NoParams;
  "support.form.tryAgain": NoParams;
  "support.sent": NoParams;
  "support.sentVote": NoParams;
  "support.open": NoParams;
  "support.diag.app": NoParams;
  "support.diag.language": NoParams;
  "support.diag.screen": NoParams;
  "support.diag.connection": NoParams;
  "support.dm.notice": NoParams;
  "support.dm.subtitle": NoParams;
  "support.mention.hint": NoParams;
  "settings.nav.calendar": NoParams;
  "calendar.meetSwap.prompt.which": NoParams;
  "calendar.meetSwap.confirm.link": NoParams;
  "calendar.meetSwap.confirm.google": NoParams;
  "calendar.meetSwap.confirm.left": NoParams;
  "calendar.meetSwap.movedQuiet": { count: number };
  "calendar.meetSwap.failed": NoParams;
  "calendar.meetSwap.busy": NoParams;
  "calendar.meetSwap.settings.restoring": { count: number };
  "calendar.meetSwap.settings.scopeBody": NoParams;
  "calendar.meetSwap.settings.showEvents": NoParams;
  "calendar.meetSwap.policy.details": NoParams;
  "calendar.meetSwap.policy.hideDetails": NoParams;
  "calendar.meetSwap.policy.memberRow": { done: string; total: string; skipped: string };
  "calendar.meetSwap.policy.restoring": NoParams;
  "calendar.meetSwap.policy.scopeTitle": NoParams;
  "calendar.meetSwap.policy.scopeBody": NoParams;
  "calendar.meetSwap.policy.setup": NoParams;
  "calendar.meetSwap.policy.existing": NoParams;
  "calendar.meetSwap.policy.outside": { workspace: string };
  "calendar.meetSwap.policy.turnOn": NoParams;
  "calendar.meetSwap.policy.restoreConfirm": NoParams;
  "calendar.meetSwap.policy.failed": NoParams;
  "getApp.banner.desktop": NoParams;
  "getApp.openInApp": NoParams;
  "getApp.download.mac": NoParams;
  "getApp.download.windows": NoParams;
  "getApp.download.linux": NoParams;
  "getApp.mobile.title": NoParams;
  "getApp.mobile.message": NoParams;
  "getApp.store.appStore": NoParams;
  "getApp.store.testflight": NoParams;
  "getApp.store.play": NoParams;
  "getApp.store.apk": NoParams;
  "getApp.action.get": NoParams;
  "getApp.action.install": NoParams;
  "getApp.action.download": NoParams;
  "getApp.menu.desktop": NoParams;
  "getApp.menu.mobile": NoParams;
  "getApp.menu.any": NoParams;
  "getApp.dismiss": NoParams;
  "getApp.handoff.title": NoParams;
  "getApp.handoff.body": NoParams;
  "getApp.handoff.open": NoParams;
  "getApp.handoff.browser": NoParams;
  "getApp.handoff.noApp": NoParams;
  "getApp.handoff.allDownloads": NoParams;
  "billing.store.choosePlan": NoParams;
  "billing.store.pickerTitle": NoParams;
  "billing.store.cycle.yearly": { percent: string };
  "billing.store.cycle.monthly": NoParams;
  "billing.store.price.perYear": { price: string };
  "billing.store.price.perMonth": { price: string };
  "billing.store.priceSource.appStore": NoParams;
  "billing.store.priceSource.googlePlay": NoParams;
  "billing.store.storage.label": NoParams;
  "billing.store.storage.value": { gb: string };
  "billing.store.storage.none": NoParams;
  "billing.store.storage.hint": NoParams;
  "billing.store.storage.less": NoParams;
  "billing.store.storage.more": NoParams;
  "billing.store.billedToday": NoParams;
  "billing.store.trialEnds": NoParams;
  "billing.store.subscribe.appStore": NoParams;
  "billing.store.subscribe.googlePlay": NoParams;
  "billing.store.period.month": NoParams;
  "billing.store.period.year": NoParams;
  "billing.store.legal.appStore": { price: string; period: string };
  "billing.store.legal.googlePlay": { price: string; period: string };
  "billing.store.terms": NoParams;
  "billing.store.privacy": NoParams;
  "billing.store.restore": NoParams;
  "billing.store.restored": NoParams;
  "billing.store.restoreNone": NoParams;
  "billing.store.confirming": NoParams;
  "billing.store.pending.appStore": { ws: string };
  "billing.store.pending.googlePlay": { ws: string };
  "billing.store.success": { ws: string };
  "billing.store.failed.appStore": NoParams;
  "billing.store.failed.googlePlay": NoParams;
  "billing.store.slow": NoParams;
  "billing.store.already": { ws: string };
  "billing.store.accountInUse.appStore": NoParams;
  "billing.store.accountInUse.googlePlay": NoParams;
  "billing.store.unavailable": NoParams;
  "billing.store.billedThrough": NoParams;
  "billing.store.name.appStore": NoParams;
  "billing.store.name.googlePlay": NoParams;
  "billing.store.name.stripe": NoParams;
  "billing.store.subscribedBy": NoParams;
  "billing.store.you": NoParams;
  "billing.store.manage.appStore": NoParams;
  "billing.store.manage.googlePlay": NoParams;
  "billing.store.manageHint.appStore": NoParams;
  "billing.store.manageHint.googlePlay": NoParams;
  "billing.store.elsewhere.appStore": { name: string };
  "billing.store.elsewhere.googlePlay": { name: string };
  "billing.store.card": NoParams;
  "settings.section.profile": NoParams;
  "settings.section.account": NoParams;
  "settings.section.notifications": NoParams;
  "settings.section.appearance": NoParams;
  "settings.section.mail": NoParams;
  "settings.section.calendar": NoParams;
  "settings.section.sidebar": NoParams;
  "settings.section.tabs": NoParams;
  "settings.section.privacy": NoParams;
  "settings.section.general": NoParams;
  "settings.section.people": NoParams;
  "settings.section.billing": NoParams;
  "settings.section.features": NoParams;
  "settings.section.domains": NoParams;
  "settings.section.huddles": NoParams;
  "settings.section.import": NoParams;
  "settings.section.workspace": NoParams;
  "settings.section.device": NoParams;
  "settings.section.sync": NoParams;
  "settings.section.help": NoParams;
  "settings.section.profile.desc": { workspace: string };
  "settings.section.account.desc": NoParams;
  "settings.section.notifications.desc": NoParams;
  "settings.section.appearance.desc": NoParams;
  "settings.section.mail.desc": NoParams;
  "settings.section.calendar.desc": NoParams;
  "settings.section.sidebar.desc": NoParams;
  "settings.section.privacy.desc": NoParams;
  "settings.section.general.desc": { workspace: string };
  "settings.section.people.desc": NoParams;
  "settings.section.billing.desc": NoParams;
  "settings.section.features.desc": NoParams;
  "settings.section.domains.desc": { workspace: string };
  "settings.section.huddles.desc": NoParams;
  "settings.section.import.desc": NoParams;
  "settings.section.workspace.desc": NoParams;
  "settings.section.device.desc": NoParams;
  "settings.section.sync.desc": NoParams;
  "settings.section.help.desc": NoParams;
  "settings.search.profile": NoParams;
  "settings.search.account": NoParams;
  "settings.search.notifications": NoParams;
  "settings.search.appearance": NoParams;
  "settings.search.mail": NoParams;
  "settings.search.calendar": NoParams;
  "settings.search.sidebar": NoParams;
  "settings.search.privacy": NoParams;
  "settings.search.general": NoParams;
  "settings.search.people": NoParams;
  "settings.search.billing": NoParams;
  "settings.search.features": NoParams;
  "settings.search.domains": NoParams;
  "settings.search.huddles": NoParams;
  "settings.search.import": NoParams;
  "settings.search.workspace": NoParams;
  "settings.search.device": NoParams;
  "settings.search.sync": NoParams;
  "settings.search.help": NoParams;
  "settings.searchPlaceholder": NoParams;
  "settings.searchEmpty": { query: string };
  "settings.adminChip": NoParams;
  "settings.group.device.browser": NoParams;
  "settings.group.device.mac": NoParams;
  "settings.group.device.computer": NoParams;
  "settings.group.device.iphone": NoParams;
  "settings.group.device.ipad": NoParams;
  "settings.group.device.phone": NoParams;
  "settings.group.device.tablet": NoParams;
  "settings.hub.group.general": NoParams;
  "settings.hub.group.people": NoParams;
  "settings.hub.group.whatsOn": NoParams;
  "settings.hub.group.mail": NoParams;
  "settings.hub.group.planData": NoParams;
  "settings.hub.name": NoParams;
  "settings.hub.linkPreviews": NoParams;
  "settings.hub.members": NoParams;
  "settings.hub.invitations": NoParams;
  "settings.hub.guests": NoParams;
  "settings.hub.userGroups": NoParams;
  "settings.hub.features": NoParams;
  "settings.hub.huddles": NoParams;
  "settings.hub.apps": NoParams;
  "settings.hub.domains": NoParams;
  "settings.hub.sentWithBundle": NoParams;
  "settings.hub.billing": NoParams;
  "settings.hub.pendingCount": { count: number };
  "settings.hub.import": NoParams;
  "settings.hub.reports": NoParams;
  "settings.hub.role.admin": NoParams;
  "settings.hub.role.owner": NoParams;
  "settings.hub.role.member": NoParams;
  "settings.hub.role.guest": NoParams;
  "settings.profileCard.sub": NoParams;
  "settings.saved.check": NoParams;
  "settings.notifications.deviceOnly": NoParams;
  "settings.notifications.alwaysCodes": NoParams;
  "settings.notifications.on": NoParams;
  "settings.notifications.quietSummary": { days: string; from: string; to: string };
  "settings.notifications.noQuiet": NoParams;
  "settings.notifications.quietHours": NoParams;
  "settings.notifications.pause": NoParams;
  "settings.notifications.unavailable": NoParams;
  "settings.notifications.blockedShort": NoParams;
  "settings.notifications.allowed": NoParams;
  "settings.notifications.allowedHelp": NoParams;
  "settings.notifications.banners": NoParams;
  "settings.notifications.soundOff": NoParams;
  "mail.notify.tabsNone": NoParams;
  "settings.help.title": NoParams;
  "settings.help.foot": NoParams;
  "settings.help.open": NoParams;
  "settings.help.about": NoParams;
  "settings.help.version": NoParams;
  "settings.sync.unavailable": NoParams;
  "settings.sync.on": NoParams;
  "settings.sync.off": NoParams;
  "settings.sync.body": NoParams;
  "settings.meta.mailboxes": { count: number };
  "mail.settings.addresses": NoParams;
  "mail.settings.addressesFoot": NoParams;
  "mail.settings.addressShared": { name: string };
  "mail.settings.addressDefault": NoParams;
  "mail.settings.addressGroup": { name: string };
  "mail.settings.sending": NoParams;
  "mail.settings.defaultFrom": NoParams;
  "mail.settings.replyFrom": NoParams;
  "mail.settings.replyFrom.same": NoParams;
  "mail.settings.replyFrom.default": NoParams;
  "mail.settings.sendingFailed": NoParams;
  "settings.appearance.accent": NoParams;
  "settings.appearance.accent.indigo": NoParams;
  "settings.appearance.accent.teal": NoParams;
  "settings.appearance.accent.orange": NoParams;
  "settings.appearance.accent.purple": NoParams;
  "settings.notifications.paused": NoParams;
  "settings.device.allowed": NoParams;
  "settings.device.notAllowed": NoParams;
  "settings.device.previews": NoParams;
  "settings.device.systemHint": NoParams;
  "settings.device.openSystem": NoParams;
  "settings.appearance.languageSystem": NoParams;
  "settings.workspace.admins": NoParams;
  "settings.workspace.message": NoParams;
  "settings.workspace.adminsFoot": NoParams;
  "settings.workspace.messageAdmin": NoParams;
  "settings.workspace.readOnly": NoParams;
  "settings.notifications.onShort": NoParams;
  "settings.device.haptics": NoParams;
  "settings.device.hapticsHint": NoParams;
  "auth.error.challengeExpired": NoParams;
  "auth.error.passkey": NoParams;
  "accountSecurity.emails.title": NoParams;
  "accountSecurity.emails.add": NoParams;
  "accountSecurity.emails.foot": NoParams;
  "accountSecurity.emails.primary": NoParams;
  "accountSecurity.emails.verified": NoParams;
  "accountSecurity.emails.pending": NoParams;
  "accountSecurity.emails.primaryHint": NoParams;
  "accountSecurity.emails.secondaryHint": NoParams;
  "accountSecurity.emails.makePrimary": NoParams;
  "accountSecurity.emails.remove": NoParams;
  "accountSecurity.emails.enterCode": NoParams;
  "accountSecurity.emails.addTitle": NoParams;
  "accountSecurity.emails.addBody": NoParams;
  "accountSecurity.emails.sendCode": NoParams;
  "accountSecurity.emails.verifyTitle": NoParams;
  "accountSecurity.emails.verifyBody": { email: string };
  "accountSecurity.emails.removeTitle": { email: string };
  "accountSecurity.emails.removeBody": NoParams;
  "accountSecurity.emails.primaryTitle": { email: string };
  "accountSecurity.emails.primaryBody": NoParams;
  "accountSecurity.password.title": NoParams;
  "accountSecurity.password.on": NoParams;
  "accountSecurity.password.off": NoParams;
  "accountSecurity.password.set": NoParams;
  "accountSecurity.password.change": NoParams;
  "accountSecurity.password.remove": NoParams;
  "accountSecurity.password.current": NoParams;
  "accountSecurity.password.removeBody": NoParams;
  "accountSecurity.passkeys.title": NoParams;
  "accountSecurity.passkeys.body": NoParams;
  "accountSecurity.passkeys.add": NoParams;
  "accountSecurity.passkeys.unnamed": NoParams;
  "accountSecurity.passkeys.used": { added: string; used: string };
  "accountSecurity.passkeys.unused": { added: string };
  "accountSecurity.passkeys.rename": NoParams;
  "accountSecurity.passkeys.renameTitle": NoParams;
  "accountSecurity.passkeys.name": NoParams;
  "accountSecurity.passkeys.deleteTitle": NoParams;
  "accountSecurity.passkeys.deleteBody": NoParams;
  "accountSecurity.passkeys.cancelled": NoParams;
  "accountSecurity.twoStep.title": NoParams;
  "accountSecurity.twoStep.on": { count: number };
  "accountSecurity.twoStep.off": NoParams;
  "accountSecurity.twoStep.setUp": NoParams;
  "accountSecurity.twoStep.turnOff": NoParams;
  "accountSecurity.twoStep.newCodes": NoParams;
  "accountSecurity.twoStep.setupBody": NoParams;
  "accountSecurity.twoStep.openApp": NoParams;
  "accountSecurity.twoStep.copyKey": NoParams;
  "accountSecurity.twoStep.keyCopied": NoParams;
  "accountSecurity.twoStep.keyLabel": NoParams;
  "accountSecurity.twoStep.noApp": NoParams;
  "accountSecurity.twoStep.backupTitle": NoParams;
  "accountSecurity.twoStep.backupBody": NoParams;
  "accountSecurity.twoStep.copyCodes": NoParams;
  "accountSecurity.twoStep.shareCodes": NoParams;
  "accountSecurity.twoStep.codesCopied": NoParams;
  "accountSecurity.twoStep.shareTitle": NoParams;
  "accountSecurity.twoStep.done": NoParams;
  "accountSecurity.twoStep.offTitle": NoParams;
  "accountSecurity.twoStep.offBody": NoParams;
  "accountSecurity.stepUp.title": NoParams;
  "accountSecurity.stepUp.passwordBody": NoParams;
  "accountSecurity.stepUp.codeBody": { email: string };
  "accountSecurity.stepUp.codeLabel": NoParams;
  "accountSecurity.stepUp.confirm": NoParams;
  "accountSecurity.sessions.place": { place: string; activity: string };
  "accountSecurity.error.wrongPassword": NoParams;
  "accountSecurity.error.locked": NoParams;
  "accountSecurity.error.invalidCode": NoParams;
  "accountSecurity.error.passwordTooLong": NoParams;
  "accountSecurity.error.passwordContainsEmail": NoParams;
  "accountSecurity.error.passwordLeaked": NoParams;
  "accountSecurity.error.lastMethod": NoParams;
  "accountSecurity.error.emailInUse": NoParams;
  "accountSecurity.error.signInAgain": NoParams;
  "accountSecurity.error.failed": NoParams;
  "settings.signIn.emails.title": NoParams;
  "settings.signIn.emails.add": NoParams;
  "settings.signIn.emails.foot": NoParams;
  "settings.signIn.emails.primary": NoParams;
  "settings.signIn.emails.verified": NoParams;
  "settings.signIn.emails.pending": NoParams;
  "settings.signIn.emails.primarySub": NoParams;
  "settings.signIn.emails.secondarySub": NoParams;
  "settings.signIn.emails.pendingSub": NoParams;
  "settings.signIn.emails.verify": NoParams;
  "settings.signIn.emails.makePrimary": NoParams;
  "settings.signIn.emails.remove": NoParams;
  "settings.signIn.emails.addTitle": NoParams;
  "settings.signIn.emails.addBody": NoParams;
  "settings.signIn.emails.addLabel": NoParams;
  "settings.signIn.emails.sendCode": NoParams;
  "settings.signIn.emails.codeTitle": NoParams;
  "settings.signIn.emails.codeBody": { email: string };
  "settings.signIn.emails.codeLabel": NoParams;
  "settings.signIn.emails.resend": NoParams;
  "settings.signIn.emails.changeEmail": NoParams;
  "settings.signIn.emails.removeTitle": { email: string };
  "settings.signIn.emails.removeBody": NoParams;
  "settings.signIn.emails.primaryTitle": { email: string };
  "settings.signIn.emails.primaryBody": { email: string; old: string };
  "settings.signIn.emails.primaryChanged": { email: string; old: string };
  "settings.signIn.methods.title": NoParams;
  "settings.signIn.password.label": NoParams;
  "settings.signIn.password.subOn": NoParams;
  "settings.signIn.password.subOff": NoParams;
  "settings.signIn.password.set": NoParams;
  "settings.signIn.password.change": NoParams;
  "settings.signIn.password.remove": NoParams;
  "settings.signIn.password.setTitle": NoParams;
  "settings.signIn.password.changeTitle": NoParams;
  "settings.signIn.password.removeTitle": NoParams;
  "settings.signIn.password.removeBody": NoParams;
  "settings.signIn.password.new": NoParams;
  "settings.signIn.password.save": NoParams;
  "settings.signIn.password.removeConfirm": NoParams;
  "settings.signIn.password.signedOut": { count: number };
  "settings.signIn.proof.passwordLabel": NoParams;
  "settings.signIn.proof.passwordBody": NoParams;
  "settings.signIn.proof.codeBody": { email: string };
  "settings.signIn.proof.sendCode": NoParams;
  "settings.signIn.proof.codeSent": { email: string };
  "settings.signIn.proof.codeLabel": NoParams;
  "settings.signIn.proof.resend": NoParams;
  "settings.signIn.continue": NoParams;
  "settings.signIn.passkeys.label": NoParams;
  "settings.signIn.passkeys.sub": NoParams;
  "settings.signIn.passkeys.add": NoParams;
  "settings.signIn.passkeys.unnamed": NoParams;
  "settings.signIn.passkeys.meta": { created: string; used: string };
  "settings.signIn.passkeys.metaNever": { created: string };
  "settings.signIn.passkeys.rename": NoParams;
  "settings.signIn.passkeys.delete": NoParams;
  "settings.signIn.passkeys.addTitle": NoParams;
  "settings.signIn.passkeys.addBody": NoParams;
  "settings.signIn.passkeys.nameLabel": NoParams;
  "settings.signIn.passkeys.namePlaceholder": NoParams;
  "settings.signIn.passkeys.renameTitle": NoParams;
  "settings.signIn.passkeys.renameLabel": NoParams;
  "settings.signIn.passkeys.deleteTitle": NoParams;
  "settings.signIn.passkeys.deleteBody": { name: string };
  "settings.signIn.passkeys.only": NoParams;
  "settings.signIn.twoFactor.label": NoParams;
  "settings.signIn.twoFactor.subOn": { count: number };
  "settings.signIn.twoFactor.subOff": NoParams;
  "settings.signIn.twoFactor.on": NoParams;
  "settings.signIn.twoFactor.setUp": NoParams;
  "settings.signIn.twoFactor.manage": NoParams;
  "settings.signIn.twoFactor.newCodes": NoParams;
  "settings.signIn.twoFactor.turnOff": NoParams;
  "settings.signIn.twoFactor.setupTitle": NoParams;
  "settings.signIn.twoFactor.scanBody": NoParams;
  "settings.signIn.twoFactor.qrLabel": NoParams;
  "settings.signIn.twoFactor.secretLabel": NoParams;
  "settings.signIn.twoFactor.copyKey": NoParams;
  "settings.signIn.twoFactor.codeLabel": NoParams;
  "settings.signIn.twoFactor.verify": NoParams;
  "settings.signIn.twoFactor.codesTitle": NoParams;
  "settings.signIn.twoFactor.codesBody": NoParams;
  "settings.signIn.twoFactor.copy": NoParams;
  "settings.signIn.twoFactor.copied": NoParams;
  "settings.signIn.twoFactor.download": NoParams;
  "settings.signIn.twoFactor.done": NoParams;
  "settings.signIn.twoFactor.fileHeading": NoParams;
  "settings.signIn.twoFactor.newCodesTitle": NoParams;
  "settings.signIn.twoFactor.newCodesBody": NoParams;
  "settings.signIn.twoFactor.offTitle": NoParams;
  "settings.signIn.twoFactor.offBody": NoParams;
  "settings.signIn.error.wrongPassword": NoParams;
  "settings.signIn.error.locked": NoParams;
  "settings.signIn.error.invalidCode": NoParams;
  "settings.signIn.error.challengeExpired": NoParams;
  "settings.signIn.error.passwordTooShort": NoParams;
  "settings.signIn.error.passwordTooLong": NoParams;
  "settings.signIn.error.passwordContainsEmail": NoParams;
  "settings.signIn.error.passwordTooCommon": NoParams;
  "settings.signIn.error.passwordLeaked": NoParams;
  "settings.signIn.error.passwordExists": NoParams;
  "settings.signIn.error.emailCodeRequired": NoParams;
  "settings.signIn.error.passwordRequired": NoParams;
  "settings.signIn.error.lastMethod": NoParams;
  "settings.signIn.error.emailInUse": NoParams;
  "settings.signIn.error.invalidEmail": NoParams;
  "settings.signIn.error.signInAgain": NoParams;
  "settings.signIn.error.rateLimited": NoParams;
  "settings.signIn.error.linkExpired": NoParams;
  "account.undoEmail.working": NoParams;
  "account.undoEmail.doneTitle": NoParams;
  "account.undoEmail.doneBody": { email: string };
  "account.undoEmail.signIn": NoParams;
  "account.undoEmail.expiredTitle": NoParams;
  "account.undoEmail.expiredBody": NoParams;
  "account.undoEmail.failedTitle": NoParams;
  "auth.signup.subtitle": NoParams;
  "auth.signup.haveAccount": NoParams;
  "auth.signup.newToBundle": NoParams;
  "auth.signup.secureSubtitle": NoParams;
  "phone.verifyTitle": NoParams;
  "phone.verifyBody": NoParams;
  "phone.requiredTitle": NoParams;
  "phone.requiredBody": NoParams;
  "phone.country": NoParams;
  "phone.number": NoParams;
  "phone.searchCountries": NoParams;
  "phone.fromGoogle": NoParams;
  "phone.fromSlack": NoParams;
  "phone.importGoogle": NoParams;
  "phone.sendCode": NoParams;
  "phone.otherNumber": NoParams;
  "phone.skip": NoParams;
  "phone.rates": NoParams;
  "phone.codeTitle": NoParams;
  "phone.codeSentTo": { phone: string };
  "phone.calledTo": { phone: string };
  "phone.codeLabel": NoParams;
  "phone.verify": NoParams;
  "phone.resendIn": { time: string };
  "phone.resend": NoParams;
  "phone.callMe": NoParams;
  "phone.changeNumber": NoParams;
  "phone.cantGetCode": NoParams;
  "phone.textMe": NoParams;
  "phone.textMeTo": { phone: string };
  "phone.signInTitle": NoParams;
  "phone.signInBody": { phone: string };
  "phone.twoStepNext": NoParams;
  "phone.tryOther": NoParams;
  "phone.twoStepTextMe": { phone: string };
  "phone.settingsRow": NoParams;
  "phone.settingsVerified": NoParams;
  "phone.settingsNone": NoParams;
  "phone.settingsNote": NoParams;
  "phone.add": NoParams;
  "phone.change": NoParams;
  "phone.remove": NoParams;
  "phone.removeTitle": NoParams;
  "phone.removeBody": { phone: string };
  "phone.added": NoParams;
  "phone.removed": NoParams;
  "phone.error.invalidCode": NoParams;
  "phone.error.tooMany": NoParams;
  "phone.error.inUse": NoParams;
  "phone.error.invalidPhone": NoParams;
  "phone.error.country": NoParams;
  "phone.error.rateLimited": NoParams;
  "phone.error.notSent": NoParams;
  "phone.error.required": NoParams;
  "phone.error.alreadyUsed": NoParams;
  "phone.error.usNotReady": NoParams;
  "phone.error.caNotReady": NoParams;
  "phone.noSmsTitle": NoParams;
  "phone.noSmsBody": { time: string };
  "phone.call": NoParams;
}
export type MessageKey = keyof MessageParams;

export const messages: { readonly [L in Locale]: { readonly [K in MessageKey]: CompiledMessage } } = {
  "en": {
    "app.name": "Bundle",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.close": "Close",
    "common.loading": "Loading…",
    "common.retry": "Try again",
    "primitive.badge.unread": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" unread"}]},"other":{"value":[{"type":7},{"type":0,"value":" unread"}]}},"offset":0,"pluralType":"cardinal"}],
    "primitive.iconButton.badgeCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"label"},{"type":0,"value":", "},{"type":7},{"type":0,"value":" unread"}]},"other":{"value":[{"type":1,"value":"label"},{"type":0,"value":", "},{"type":7},{"type":0,"value":" unread"}]}},"offset":0,"pluralType":"cardinal"}],
    "primitive.iconButton.badgeDot": [{"type":1,"value":"label"},{"type":0,"value":", new activity"}],
    "primitive.chip.remove": [{"type":0,"value":"Remove "},{"type":1,"value":"label"}],
    "primitive.select.placeholder": "Choose…",
    "primitive.listRow.expand": "Expand",
    "primitive.listRow.collapse": "Collapse",
    "usageMeter.value": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"limit"}],
    "usageMeter.almostFull": "Almost full",
    "usageMeter.full": "Full",
    "usageMeter.noLimit": "No limit",
    "usageMeter.noLimitDetail": [{"type":0,"value":"No limit · "},{"type":1,"value":"detail"}],
    "editor.todo.done": "Done",
    "shell.search.placeholder": "Search everything",
    "shell.omnibox.placeholder": "Search or jump to…",
    "shell.newTab": "New tab",
    "shell.closeTab": "Close tab",
    "shell.splitRight": "Open in split view",
    "shell.back": "Back",
    "shell.forward": "Forward",
    "shell.toggleSidebar": "Toggle sidebar",
    "shell.tabs.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" tab"}]},"other":{"value":[{"type":7},{"type":0,"value":" tabs"}]}},"offset":0,"pluralType":"cardinal"}],
    "shell.views": "Views",
    "shell.view.chat": "Chat",
    "shell.view.email": "Email",
    "shell.view.docs": "Docs",
    "nav.home": "Home",
    "tabTitle.channel": [{"type":1,"value":"name"},{"type":0,"value":" (Channel)"}],
    "tabTitle.dm": [{"type":1,"value":"name"},{"type":0,"value":" (DM)"}],
    "nav.inbox": "Inbox",
    "nav.projects": "Projects",
    "nav.agents": "Agents",
    "nav.channels": "Channels",
    "nav.directMessages": "Direct messages",
    "channel.composer.placeholder": [{"type":0,"value":"Message #"},{"type":1,"value":"channel"}],
    "channel.composer.placeholderDm": [{"type":0,"value":"Message "},{"type":1,"value":"name"}],
    "channel.newDivider": "New",
    "channel.newMessages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" new message"}]},"other":{"value":[{"type":7},{"type":0,"value":" new messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "channel.members": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" member"}]},"other":{"value":[{"type":7},{"type":0,"value":" members"}]}},"offset":0,"pluralType":"cardinal"}],
    "channel.empty.title": [{"type":0,"value":"This is the very beginning of #"},{"type":1,"value":"channel"}],
    "channel.empty.body": "Send a message to get the conversation going.",
    "message.edited": "(edited)",
    "message.deleted": "This message was deleted.",
    "message.unsupportedContent": "This message has content your app version can't show. Update Bundle",
    "message.replies": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" reply"}]},"other":{"value":[{"type":7},{"type":0,"value":" replies"}]}},"offset":0,"pluralType":"cardinal"}],
    "message.addReaction": "Add reaction",
    "message.reply": "Reply in thread",
    "message.more": "More actions",
    "reaction.added": [{"type":0,"value":"Reacted with "},{"type":1,"value":"emoji"}],
    "reaction.removed": [{"type":0,"value":"Removed "},{"type":1,"value":"emoji"}],
    "reaction.who.you": [{"type":0,"value":"You reacted with "},{"type":1,"value":"emoji"}],
    "reaction.who.youAndOne": [{"type":0,"value":"You and "},{"type":1,"value":"name"},{"type":0,"value":" reacted with "},{"type":1,"value":"emoji"}],
    "reaction.who.youAndMany": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"You, "},{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" other reacted with "},{"type":1,"value":"emoji"}]},"other":{"value":[{"type":0,"value":"You, "},{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" others reacted with "},{"type":1,"value":"emoji"}]}},"offset":0,"pluralType":"cardinal"}],
    "reaction.who.one": [{"type":1,"value":"name"},{"type":0,"value":" reacted with "},{"type":1,"value":"emoji"}],
    "reaction.who.two": [{"type":1,"value":"a"},{"type":0,"value":" and "},{"type":1,"value":"b"},{"type":0,"value":" reacted with "},{"type":1,"value":"emoji"}],
    "reaction.who.many": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"a"},{"type":0,"value":", "},{"type":1,"value":"b"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" other reacted with "},{"type":1,"value":"emoji"}]},"other":{"value":[{"type":1,"value":"a"},{"type":0,"value":", "},{"type":1,"value":"b"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" others reacted with "},{"type":1,"value":"emoji"}]}},"offset":0,"pluralType":"cardinal"}],
    "reaction.who.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" person reacted with "},{"type":1,"value":"emoji"}]},"other":{"value":[{"type":7},{"type":0,"value":" people reacted with "},{"type":1,"value":"emoji"}]}},"offset":0,"pluralType":"cardinal"}],
    "typing.one": [{"type":1,"value":"name"},{"type":0,"value":" is typing…"}],
    "typing.two": [{"type":1,"value":"a"},{"type":0,"value":" and "},{"type":1,"value":"b"},{"type":0,"value":" are typing…"}],
    "typing.many": "Several people are typing…",
    "agent.state.idle": "Idle",
    "agent.state.working": "Working",
    "agent.state.waiting": "Waiting for input",
    "agent.state.error": "Needs attention",
    "agent.state.offline": "Offline",
    "agent.status": [{"type":1,"value":"name"},{"type":0,"value":": "},{"type":1,"value":"state"}],
    "agent.badge": "Agent",
    "message.appBadge": "App",
    "time.today": "Today",
    "time.yesterday": "Yesterday",
    "time.justNow": "just now",
    "auth.signIn": "Sign in",
    "auth.email": "Email",
    "auth.sendCode": "Send code",
    "nav.starred": "Starred",
    "nav.activity": "Activity",
    "nav.unreads": "All unreads",
    "nav.search": "Search",
    "shell.newTabInSplit": "Open in split",
    "shell.openInNewTab": "Open in new tab",
    "shell.closePane": "Close pane",
    "shell.pinTab": "Pin tab",
    "shell.unpinTab": "Unpin tab",
    "shell.omnibox.channels": "Channels",
    "shell.omnibox.people": "People",
    "shell.omnibox.agents": "Agents",
    "shell.omnibox.commands": "Commands",
    "shell.omnibox.noResults": "No results",
    "shell.omnibox.hint": "↵ open · ⌘↵ new tab · ⇧↵ split",
    "shell.tabs.search": "Search tabs",
    "shell.tabs.searchPlaceholder": "Search open tabs",
    "shell.tabs.open": "Open tabs",
    "shell.tabs.pinned": "Pinned",
    "shell.tabs.ungrouped": "Tabs",
    "shell.tab.duplicate": "Duplicate",
    "shell.tab.closeOthers": "Close other tabs",
    "shell.tab.closeRight": "Close tabs to the right",
    "shell.tab.closeSelected": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Close "},{"type":7},{"type":0,"value":" tab"}]},"other":{"value":[{"type":0,"value":"Close "},{"type":7},{"type":0,"value":" tabs"}]}},"offset":0,"pluralType":"cardinal"}],
    "shell.tab.moveToWindow": "Move to new window",
    "shell.tab.copyLink": "Copy link",
    "shell.tab.addToNewGroup": "Add to new group",
    "shell.tab.addToGroup": "Add to group",
    "shell.tab.removeFromGroup": "Remove from group",
    "shell.tab.reopenClosed": "Reopen closed tab",
    "shell.split.separate": "Separate tabs",
    "shell.split.swap": "Swap sides",
    "shell.split.close": "Close both tabs",
    "shell.split.closeSide": [{"type":0,"value":"Close "},{"type":1,"value":"title"}],
    "shell.split.moveToNewTab": "Move to new tab",
    "shell.split.dropHint": "Drop to open in split view",
    "shell.group.namePlaceholder": "Name this group",
    "shell.group.unnamed": "Unnamed group",
    "shell.group.edit": "Edit group",
    "shell.group.collapse": "Collapse group",
    "shell.group.expand": "Expand group",
    "shell.group.newTab": "New tab in group",
    "shell.group.ungroup": "Ungroup",
    "shell.group.close": "Close group",
    "agent.statusLine.working": [{"type":1,"value":"name"},{"type":0,"value":": Working…"}],
    "agent.statusLine.activity": [{"type":1,"value":"name"},{"type":0,"value":": "},{"type":1,"value":"activity"},{"type":0,"value":"…"}],
    "agent.statusLine.waiting": [{"type":1,"value":"name"},{"type":0,"value":": Waiting for input"}],
    "agent.statusLine.error": [{"type":1,"value":"name"},{"type":0,"value":": Needs attention"}],
    "agent.sponsor": [{"type":0,"value":"Sponsored by "},{"type":1,"value":"name"}],
    "agent.runtime.hosted": "Hosted",
    "agent.runtime.external": "External runtime",
    "agent.message": "Message",
    "agents.title": "Agents",
    "agents.subtitle": "Agents are members of your workspace. They work in the channels they're added to.",
    "agents.empty": "No agents yet.",
    "agent.create.title": "Create an agent",
    "agent.create.name": "Name",
    "agent.create.description": "What does this agent do?",
    "agent.create.runtime": "Runs in Bundle (hosted)",
    "agent.create.submit": "Create agent",
    "agent.create.tokenNotice": "Copy this token now — it won't be shown again.",
    "guest.badge": "External",
    "guest.badgeOrg": [{"type":0,"value":"External · "},{"type":1,"value":"org"}],
    "channel.externalBanner": "This channel includes people from other organizations.",
    "channel.externalBannerOrgs": [{"type":0,"value":"This channel includes people from "},{"type":1,"value":"orgs"},{"type":0,"value":"."}],
    "channel.huddle": "Start a meet",
    "channel.settings": "Channel settings",
    "channel.loadingOlder": "Loading older messages…",
    "channel.newMessagesJump": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" new message"}]},"other":{"value":[{"type":7},{"type":0,"value":" new messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "composer.mention": "Mention someone",
    "composer.attach": "Attach a file",
    "composer.emoji": "Emoji",
    "composer.format": "Formatting",
    "composer.format.bold": "Bold",
    "composer.format.italic": "Italic",
    "composer.format.strike": "Strikethrough",
    "composer.format.link": "Link",
    "composer.format.orderedList": "Numbered list",
    "composer.format.bulletList": "Bulleted list",
    "composer.format.quote": "Quote",
    "composer.format.code": "Code",
    "composer.format.codeBlock": "Code block",
    "composer.format.show": "Show formatting",
    "composer.format.hide": "Hide formatting",
    "composer.send": "Send",
    "composer.placeholderThread": "Reply…",
    "composer.autocomplete.people": "People and agents",
    "composer.autocomplete.channels": "Channels",
    "composer.autocomplete.emoji": "Emoji",
    "composer.autocomplete.commands": "Commands",
    "composer.autocomplete.empty": [{"type":0,"value":"No matches for “"},{"type":1,"value":"query"},{"type":0,"value":"”"}],
    "composer.autocomplete.none": "No matches",
    "composer.broadcast.here": "Notify everyone online in this channel",
    "composer.broadcast.channel": "Notify everyone in this channel",
    "composer.broadcast.everyone": "Notify everyone in the workspace",
    "composer.command.remind.description": "Set a reminder",
    "composer.command.remind.usage": "[@someone or #channel] [what] [when]",
    "composer.command.status.description": "Set your status",
    "composer.command.status.usage": "[:emoji:] [status text]",
    "composer.command.invite.description": "Invite someone to this channel",
    "composer.command.invite.usage": "[@someone] [#channel]",
    "composer.command.mute.description": "Mute this conversation",
    "composer.command.mute.usage": "[#channel]",
    "composer.command.task.description": "Create a task",
    "composer.command.task.usage": "[title]",
    "composer.command.page.description": "Create a page",
    "composer.command.page.usage": "[title]",
    "composer.command.huddle.description": "Start or join a meeting",
    "message.sending": "Sending…",
    "message.failed": "Not sent.",
    "message.retry": "Retry",
    "message.discard": "Discard",
    "message.viewThread": "View thread",
    "message.lastReply": [{"type":0,"value":"Last reply "},{"type":1,"value":"time"}],
    "message.repliedToThread": [{"type":0,"value":"replied to a thread: "},{"type":1,"value":"preview"}],
    "message.repliedToThreadNoPreview": "replied to a thread",
    "thread.title": "Thread",
    "thread.in": [{"type":0,"value":"in #"},{"type":1,"value":"channel"}],
    "thread.inDm": [{"type":0,"value":"with "},{"type":1,"value":"name"}],
    "thread.alsoSendChannel": [{"type":0,"value":"Also send to #"},{"type":1,"value":"channel"}],
    "thread.alsoSendDm": "Also send as direct message",
    "thread.alsoSentChannel": [{"type":0,"value":"Also sent to #"},{"type":1,"value":"channel"}],
    "thread.alsoSentDm": "Also sent as direct message",
    "home.greeting": [{"type":0,"value":"Welcome to "},{"type":1,"value":"workspace"}],
    "home.subtitle": "Pick up where you left off.",
    "home.channels": "Channels",
    "home.directMessages": "Direct messages",
    "home.agents": "Agents at work",
    "home.unread": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" unread mention"}]},"other":{"value":[{"type":7},{"type":0,"value":" unread mentions"}]}},"offset":0,"pluralType":"cardinal"}],
    "home.allCaughtUp": "You're all caught up.",
    "home.greetingMorning": [{"type":0,"value":"Good morning, "},{"type":1,"value":"name"}],
    "home.greetingAfternoon": [{"type":0,"value":"Good afternoon, "},{"type":1,"value":"name"}],
    "home.greetingEvening": [{"type":0,"value":"Good evening, "},{"type":1,"value":"name"}],
    "home.unreads": "Unreads",
    "home.today": "Today",
    "home.tomorrow": "Tomorrow",
    "home.noMoreEvents": "No more events today",
    "home.now": "Now",
    "home.join": "Join",
    "home.openCalendar": "Open Calendar",
    "home.email": "Email",
    "home.openMail": "Open Mail",
    "home.needsReply": "Needs reply",
    "home.moreFaces": [{"type":0,"value":"+"},{"type":1,"value":"count"}],
    "home.briefing.needsYou": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" thing needs you"}]},"other":{"value":[{"type":7},{"type":0,"value":" things need you"}]}},"offset":0,"pluralType":"cardinal"}],
    "home.briefing.live": [{"type":1,"value":"title"},{"type":0,"value":" is live"}],
    "home.briefing.startsIn": [{"type":1,"value":"title"},{"type":0,"value":" in "},{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "home.briefing.nextAt": [{"type":0,"value":"Next: "},{"type":1,"value":"title"},{"type":0,"value":" at "},{"type":1,"value":"time"}],
    "home.briefing.chat": "Chat",
    "home.briefing.work": "Tasks and approvals",
    "home.briefing.reply": "Reply",
    "home.briefing.respond": "Respond",
    "home.briefing.review": "Review",
    "home.briefing.noMeetings": "No more meetings today",
    "home.briefing.caughtUpTitle": "You're all caught up",
    "home.briefing.caughtUpBody": "Mentions, replies, invites and approvals show up here.",
    "home.briefing.nothingNeedsYou": "Nothing needs you right now.",
    "home.briefing.invitedBy": [{"type":1,"value":"name"},{"type":0,"value":" invited you"}],
    "home.briefing.waitingApproval": "Waiting for your approval",
    "home.briefing.more": [{"type":1,"value":"count"},{"type":0,"value":" more"}],
    "search.title": "Search",
    "search.placeholder": "Search messages",
    "search.comingSoon": "Full-text search arrives in M2. Use ⌘K to jump to channels and people.",
    "search.hint": "Narrow it down with from:@name, in:#channel, with:@name, has:link, has:file, has:pin, has:reaction, before:2026-10-01, after:2026-10-01, on:2026-10-01, during:2026-10 or is:thread.",
    "search.empty": [{"type":0,"value":"No messages match “"},{"type":1,"value":"query"},{"type":0,"value":"”."}],
    "search.error": "Search didn't work. Check your connection and try again.",
    "search.unresolved": [{"type":0,"value":"Ignored: "},{"type":1,"value":"filters"}],
    "search.inThread": "in a thread",
    "search.resultCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" result"}]},"other":{"value":[{"type":7},{"type":0,"value":" results"}]}},"offset":0,"pluralType":"cardinal"}],
    "search.suggest.filters": "Narrow your search",
    "search.suggest.people": "People",
    "search.suggest.conversations": "Channels and conversations",
    "search.suggest.values": "Suggestions",
    "search.suggest.exclude": "Exclude",
    "search.filter.from": "Messages from a person",
    "search.filter.in": "In a channel or conversation",
    "search.filter.with": "In DMs and threads with a person",
    "search.filter.has": "Has a link, file, pin or reaction",
    "search.filter.is": "In threads, or saved for later",
    "search.filter.before": "Before a date",
    "search.filter.after": "After a date",
    "search.filter.on": "On a day",
    "search.filter.during": "During a day, month or year",
    "search.filter.notFrom": "Leave out messages from a person",
    "search.filter.notIn": "Leave out a channel or conversation",
    "search.filter.notWith": "Leave out DMs and threads with a person",
    "search.filter.notHas": "Leave out links, files, pins or reactions",
    "search.value.link": "Contains a link",
    "search.value.file": "Has a file",
    "search.value.pin": "Pinned",
    "search.value.reaction": "Has reactions",
    "search.value.thread": "In a thread",
    "search.value.today": "Today",
    "search.value.yesterday": "Yesterday",
    "search.value.thisMonth": "This month",
    "search.value.lastMonth": "Last month",
    "search.value.thisYear": "This year",
    "search.value.lastYear": "Last year",
    "search.value.saved": "Saved for later",
    "search.value.pickDate": "Choose a date…",
    "search.value.pickMonth": "Choose a month…",
    "search.date.title": "Search by date",
    "search.date.on": "On",
    "search.date.before": "Before",
    "search.date.after": "After",
    "search.date.during": "During",
    "search.date.wholeMonth": "The whole month",
    "search.date.apply": "Apply",
    "message.copyLink": "Copy link",
    "message.linkCopied": "Link copied",
    "message.code.copy": "Copy code",
    "message.code.copied": "Copied",
    "message.pin": "Pin to this conversation",
    "message.unpin": "Unpin from this conversation",
    "message.pinnedBy": [{"type":0,"value":"Pinned by "},{"type":1,"value":"name"}],
    "message.markUnread": "Mark unread",
    "message.share": "Share message",
    "message.shared.dm": "a direct message",
    "message.shared.someone": "Someone",
    "message.shared.postedIn": [{"type":0,"value":"Posted in "},{"type":1,"value":"where"},{"type":0,"value":" · "},{"type":1,"value":"when"}],
    "message.shared.view": "View message",
    "share.title": "Share this message",
    "share.to": "To",
    "share.search": "Search for a channel or person",
    "share.comment": "Add a message, if you’d like",
    "share.send": "Share",
    "share.failed": "Couldn’t share the message.",
    "share.empty": "No conversations match.",
    "share.done": "Message shared",
    "beta.banner.title": "Bundle is in beta.",
    "beta.banner.message": "Tell us what's broken or missing; the team reads every note.",
    "beta.banner.messageShort": "Tell us what's broken or missing.",
    "beta.banner.whatsNew": "What's new",
    "beta.banner.feedback": "Send feedback",
    "beta.banner.dismiss": "Dismiss",
    "beta.label": "Beta",
    "beta.label.open": "Bundle is in beta. Open Help",
    "bookmarks.add": "Add a bookmark",
    "bookmarks.edit": "Edit bookmark",
    "bookmarks.remove": "Remove bookmark",
    "bookmarks.link": "Link",
    "bookmarks.name": "Name",
    "bookmarks.namePlaceholder": "Optional — the site’s name is used otherwise",
    "bookmarks.save": "Save",
    "bookmarks.badUrl": "Enter a web link (https://…).",
    "bookmarks.failed": "Couldn’t save the bookmark.",
    "bookmarks.bar": "Bookmarks",
    "bookmarks.more": "Bookmark options",
    "bookmarks.addLink": "Add a link",
    "bookmarks.addFolder": "Create a folder",
    "bookmarks.editFolder": "Rename",
    "bookmarks.addFile": "Add a file",
    "bookmarks.addPage": "Add a page",
    "bookmarks.folderName": "Folder name",
    "bookmarks.nameNeeded": "Enter a name.",
    "bookmarks.searchFiles": "Search files in this conversation",
    "bookmarks.searchPages": "Search pages",
    "bookmarks.noFiles": "No files shared here yet.",
    "bookmarks.noPages": "No pages found.",
    "bookmarks.pickFailed": "Couldn’t load the list.",
    "bookmarks.moveTo": [{"type":0,"value":"Move to "},{"type":1,"value":"folder"}],
    "bookmarks.moveOut": "Move out of folder",
    "bookmarks.emptyFolder": "This folder is empty.",
    "bookmarks.removeFolder": "Delete folder",
    "bookmarks.addToFolder": "Add a link to this folder",
    "bookmarks.moveLeft": "Move left",
    "bookmarks.moveRight": "Move right",
    "bookmarks.reorder": "Reorder bookmarks",
    "channel.pins.open": "Pinned messages",
    "channel.pins.title": "Pinned messages",
    "channel.pins.empty": "Nothing is pinned yet. Pin important messages from their menu so everyone here can find them.",
    "channel.pins.error": "Couldn't load the pinned messages.",
    "channel.pins.jump": "Open in the conversation",
    "activity.title": "Activity",
    "activity.empty": "Mentions, thread replies and reactions to your messages will show up here.",
    "activity.memberJoined": [{"type":1,"value":"name"},{"type":0,"value":" joined via "},{"type":1,"value":"domain"}],
    "activity.memberJoined.someone": [{"type":0,"value":"Someone joined via "},{"type":1,"value":"domain"}],
    "activity.adminEmpty": "Mentions, thread replies and reactions will show up here, and people who join through your allowed email domains.",
    "activity.failed": "Couldn't load your activity. Check your connection and try again.",
    "activity.retry": "Try again",
    "activity.mention": [{"type":1,"value":"name"},{"type":0,"value":" mentioned you in #"},{"type":1,"value":"channel"}],
    "activity.mention.someone": [{"type":0,"value":"Someone mentioned you in #"},{"type":1,"value":"channel"}],
    "activity.broadcast": [{"type":1,"value":"name"},{"type":0,"value":" mentioned @"},{"type":1,"value":"range"},{"type":0,"value":" in #"},{"type":1,"value":"channel"}],
    "activity.broadcast.someone": [{"type":0,"value":"Someone mentioned @"},{"type":1,"value":"range"},{"type":0,"value":" in #"},{"type":1,"value":"channel"}],
    "activity.threadReply": [{"type":1,"value":"name"},{"type":0,"value":" replied to a thread in #"},{"type":1,"value":"channel"}],
    "activity.threadReply.dm": [{"type":1,"value":"name"},{"type":0,"value":" replied to a thread"}],
    "activity.threadReply.others": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" other replied to a thread in #"},{"type":1,"value":"channel"}]},"other":{"value":[{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" others replied to a thread in #"},{"type":1,"value":"channel"}]}},"offset":0,"pluralType":"cardinal"}],
    "activity.threadReply.others.dm": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" other replied to a thread"}]},"other":{"value":[{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" others replied to a thread"}]}},"offset":0,"pluralType":"cardinal"}],
    "activity.reaction": [{"type":1,"value":"name"},{"type":0,"value":" reacted "},{"type":1,"value":"emoji"},{"type":0,"value":" to your message"}],
    "activity.reaction.others": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" other reacted "},{"type":1,"value":"emoji"},{"type":0,"value":" to your message"}]},"other":{"value":[{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":7},{"type":0,"value":" others reacted "},{"type":1,"value":"emoji"},{"type":0,"value":" to your message"}]}},"offset":0,"pluralType":"cardinal"}],
    "activity.channelAdded": [{"type":1,"value":"name"},{"type":0,"value":" added you to #"},{"type":1,"value":"channel"}],
    "activity.channelAdded.someone": [{"type":0,"value":"You were added to #"},{"type":1,"value":"channel"}],
    "activity.filter.all": "All",
    "activity.filter.mentions": "Mentions",
    "activity.filter.threads": "Threads",
    "activity.filter.reactions": "Reactions",
    "activity.filters": "Filter activity",
    "activity.markAllRead": "Mark all as read",
    "activity.unread": "Unread",
    "activity.filteredEmpty": "Nothing here yet.",
    "activity.reminder": "Reminder",
    "activity.eventReminder": "Upcoming event",
    "activity.eventInvited": [{"type":1,"value":"name"},{"type":0,"value":" invited you"}],
    "activity.eventInvited.someone": "New invitation",
    "activity.eventChanged": [{"type":1,"value":"name"},{"type":0,"value":" changed the time"}],
    "activity.eventChanged.someone": "The time changed",
    "activity.eventCancelled": [{"type":1,"value":"name"},{"type":0,"value":" cancelled this event"}],
    "activity.eventCancelled.someone": "This event was cancelled",
    "nav.later": "Later",
    "later.title": "Later",
    "later.tabs": "Later tabs",
    "later.tab.inProgress": "In progress",
    "later.tab.archived": "Archived",
    "later.tab.completed": "Completed",
    "later.empty.inProgress": "Save messages and set reminders to keep track of what you need to do. They’ll show up here.",
    "later.empty.archived": "Archived items show up here.",
    "later.empty.completed": "Items you complete show up here.",
    "later.complete": "Mark complete",
    "later.moveToInProgress": "Move to In progress",
    "later.archive": "Archive",
    "later.remove": "Remove from Later",
    "later.more": "More actions",
    "later.remind": "Remind me",
    "later.reminder.clear": "Remove reminder",
    "later.due": [{"type":0,"value":"Due "},{"type":1,"value":"time"}],
    "later.overdue": [{"type":0,"value":"Overdue · "},{"type":1,"value":"time"}],
    "later.textReminder": "Reminder",
    "later.repeats": "Repeats",
    "later.stopRepeat": "Stop repeating",
    "later.fromPerson": [{"type":0,"value":"Reminder from "},{"type":1,"value":"name"}],
    "later.forConversation": [{"type":0,"value":"Reminder for "},{"type":1,"value":"conversation"}],
    "later.messageGone": "This message is no longer available.",
    "later.failed": "Couldn’t load your saved items.",
    "later.retry": "Try again",
    "later.saved": "Saved for later",
    "later.removed": "Removed from Later",
    "later.completed": "Marked complete",
    "message.saveForLater": "Save for later",
    "message.removeFromLater": "Remove from Later",
    "message.remindMe": "Remind me about this",
    "remind.title": "Remind me about this",
    "remind.preset.in20m": "In 20 minutes",
    "remind.preset.in1h": "In 1 hour",
    "remind.preset.in3h": "In 3 hours",
    "remind.preset.tomorrow": "Tomorrow",
    "remind.preset.nextWeek": "Next week",
    "remind.custom": "Custom…",
    "remind.date": "Date",
    "remind.time": "Time",
    "remind.set": "Set reminder",
    "remind.done": [{"type":0,"value":"Reminder set for "},{"type":1,"value":"when"}],
    "remind.failed": "Couldn’t set the reminder",
    "composer.remind.done": [{"type":0,"value":"Got it! I’ll remind you about “"},{"type":1,"value":"text"},{"type":0,"value":"” on "},{"type":1,"value":"when"},{"type":0,"value":"."}],
    "composer.remind.doneFor": [{"type":0,"value":"Got it! I’ll remind "},{"type":1,"value":"who"},{"type":0,"value":" about “"},{"type":1,"value":"text"},{"type":0,"value":"” on "},{"type":1,"value":"when"},{"type":0,"value":"."}],
    "composer.remind.doneRepeat": [{"type":0,"value":"Got it! I’ll remind "},{"type":1,"value":"who"},{"type":0,"value":" about “"},{"type":1,"value":"text"},{"type":0,"value":"” on repeat, starting "},{"type":1,"value":"when"},{"type":0,"value":"."}],
    "composer.remind.you": "you",
    "composer.remind.usage": "Try /remind me [what] [when] — for example /remind me to stretch in 20 minutes",
    "composer.remind.target": "Pick the person or channel from the @ or # list, or use /remind me.",
    "composer.remind.past": "That time has already passed.",
    "composer.remind.failed": "Couldn’t set the reminder.",
    "nav.scheduled": "Scheduled",
    "schedule.title": "Schedule message",
    "schedule.menu": "Schedule for later",
    "schedule.tomorrow": [{"type":0,"value":"Tomorrow at "},{"type":1,"value":"time"}],
    "schedule.monday": [{"type":0,"value":"Monday at "},{"type":1,"value":"time"}],
    "schedule.custom": "Custom time",
    "schedule.set": "Schedule message",
    "schedule.done": [{"type":0,"value":"Scheduled for "},{"type":1,"value":"when"}],
    "schedule.past": "Pick a time in the future.",
    "schedule.tooFar": "You can schedule messages up to 120 days ahead.",
    "schedule.failed": "Couldn’t schedule the message.",
    "scheduled.bar": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" scheduled message"}]},"other":{"value":[{"type":7},{"type":0,"value":" scheduled messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "scheduled.seeAll": "See all",
    "scheduled.title": "Scheduled",
    "scheduled.empty": "Messages you schedule show up here until they’re sent.",
    "nav.drafts": "Drafts & sent",
    "drafts.title": "Drafts & sent",
    "drafts.tab.drafts": "Drafts",
    "drafts.tab.scheduled": "Scheduled",
    "drafts.tab.sent": "Sent",
    "drafts.empty": "Drafts appear here when you start a message and leave it unsent. They follow you to all your devices.",
    "drafts.sentEmpty": "Messages you send in channels and direct messages show up here, so you can find them again.",
    "drafts.failed": "Couldn’t load your drafts.",
    "drafts.sentFailed": "Couldn’t load your sent messages.",
    "drafts.delete": "Delete draft",
    "drafts.inThread": [{"type":0,"value":"Thread in "},{"type":1,"value":"conversation"}],
    "drafts.empty.title": "No drafts right now",
    "drafts.sentEmpty.title": "Nothing sent yet",
    "drafts.scheduledEmpty.title": "No scheduled messages",
    "drafts.scheduledEmpty.body": "Schedule a message from the arrow next to Send in any conversation, and it waits here until it goes out.",
    "drafts.edit": "Edit draft",
    "drafts.open": "Open in conversation",
    "drafts.deleteConfirm.title": "Delete draft?",
    "drafts.deleteConfirm.body": "This draft will be deleted on all your devices. You can’t undo this.",
    "scheduled.sendsAt": [{"type":0,"value":"Sends "},{"type":1,"value":"when"}],
    "scheduled.notSent": "Not sent — you can’t post there anymore. Edit, reschedule or cancel it.",
    "scheduled.inThread": "Reply in a thread",
    "scheduled.edit": "Edit message",
    "scheduled.reschedule": "Reschedule",
    "scheduled.sendNow": "Send now",
    "scheduled.cancel": "Cancel message",
    "scheduled.save": "Save",
    "scheduled.failed": "Couldn’t load your scheduled messages.",
    "scheduled.more": "More actions",
    "scheduled.files": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" file"}]},"other":{"value":[{"type":7},{"type":0,"value":" files"}]}},"offset":0,"pluralType":"cardinal"}],
    "shortcuts.title": "Keyboard shortcuts",
    "shortcuts.omnibox": "Jump to a conversation or page",
    "shortcuts.prev": "Previous conversation",
    "shortcuts.next": "Next conversation",
    "shortcuts.prevUnread": "Previous unread conversation",
    "shortcuts.nextUnread": "Next unread conversation",
    "shortcuts.markRead": "Mark the current conversation as read",
    "shortcuts.allUnreads": "Open All unreads",
    "shortcuts.editLast": "Edit your last message (empty composer)",
    "shortcuts.newTab": "New tab",
    "shortcuts.closeTab": "Close tab",
    "shortcuts.tabSearch": "Search open tabs",
    "shortcuts.split": "Split view",
    "shortcuts.swapSplit": "Swap split sides",
    "shortcuts.back": "Back",
    "shortcuts.forward": "Forward",
    "shortcuts.sidebar": "Show or hide the sidebar",
    "shortcuts.views": "Switch to Chat, Email or Docs",
    "shortcuts.help": "Show keyboard shortcuts",
    "shortcuts.mail.title": "Mail",
    "shortcuts.mail.compose": "Compose",
    "shortcuts.mail.search": "Search mail",
    "shortcuts.mail.next": "Next conversation",
    "shortcuts.mail.prev": "Previous conversation",
    "shortcuts.mail.open": "Open conversation",
    "shortcuts.mail.archive": "Archive",
    "shortcuts.mail.trash": "Delete",
    "shortcuts.mail.spam": "Report spam",
    "shortcuts.mail.star": "Star / unstar",
    "shortcuts.mail.priority": "Mark as priority",
    "shortcuts.mail.notPriority": "Mark as not priority",
    "shortcuts.mail.select": "Select conversation",
    "shortcuts.mail.markRead": "Mark as read",
    "shortcuts.mail.markUnread": "Mark as unread",
    "shortcuts.mail.reply": "Reply",
    "shortcuts.mail.replyAll": "Reply all",
    "shortcuts.mail.forward": "Forward",
    "unreads.empty": "You’re all caught up.",
    "unreads.markAllRead": "Mark all as read",
    "unreads.markRead": "Mark as read",
    "unreads.more": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" more unread message"}]},"other":{"value":[{"type":7},{"type":0,"value":" more unread messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "unreads.new": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" new message"}]},"other":{"value":[{"type":7},{"type":0,"value":" new messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "unreads.mentions": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" mention"}]},"other":{"value":[{"type":7},{"type":0,"value":" mentions"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.title": "Meet",
    "huddle.comingSoon": "Meet arrives in M7.",
    "huddle.join": "Join",
    "huddle.joinHuddle": "Join meeting",
    "huddle.inHuddle": "In meeting",
    "huddle.start": "Start a meet",
    "huddle.leave": "Leave",
    "huddle.mute": "Mute",
    "huddle.unmute": "Unmute",
    "huddle.videoOn": "Turn on video",
    "huddle.videoOff": "Turn off video",
    "huddle.shareScreen": "Share screen",
    "huddle.stopSharing": "Stop sharing",
    "huddle.raiseHand": "Raise hand",
    "huddle.lowerHand": "Lower hand",
    "huddle.react": "React",
    "huddle.effects": "Effects",
    "huddle.effects.emoji": "Emoji effects",
    "huddle.effects.themes": "Themes",
    "huddle.theme.none": "None",
    "huddle.theme.sunrise": "Sunrise",
    "huddle.theme.ocean": "Ocean",
    "huddle.theme.forest": "Forest",
    "huddle.theme.galaxy": "Galaxy",
    "huddle.theme.party": "Party",
    "huddle.settings": "Meet settings",
    "huddle.openWindow": "Open meeting",
    "huddle.openInBrowser": "Open meeting in browser",
    "huddle.browserOnly": "Meet needs a browser on Linux for now.",
    "huddle.status.joining": "Joining…",
    "huddle.status.connecting": "Connecting…",
    "huddle.status.reconnecting": "Reconnecting…",
    "huddle.status.leaving": "Leaving…",
    "huddle.participants": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.youName": [{"type":1,"value":"name"},{"type":0,"value":" (you)"}],
    "huddle.sharingScreen": [{"type":1,"value":"name"},{"type":0,"value":" is sharing their screen"}],
    "huddle.youAreSharing": "You're sharing your screen",
    "huddle.handRaised": "Hand raised",
    "huddle.muted": "Muted",
    "huddle.mediaUnavailable": "Audio and video aren't set up on this server: you'll see who's here, but no media is exchanged.",
    "huddle.waiting": "Waiting for others to join…",
    "huddle.invite.open": "Invite people",
    "huddle.invite.title": "Invite people to the meeting",
    "huddle.invite.search": "Search people",
    "huddle.invite.ring": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Invite "},{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":0,"value":"Invite "},{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.invite.none": "Pick people to invite",
    "huddle.invite.empty": "Everyone here is already in the meeting",
    "huddle.invite.loadFailed": "Couldn't load the people here",
    "huddle.invite.failed": "Couldn't invite them. Try again.",
    "huddle.invite.rang": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Calling "},{"type":7},{"type":0,"value":" person…"}]},"other":{"value":[{"type":0,"value":"Calling "},{"type":7},{"type":0,"value":" people…"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.declined": [{"type":1,"value":"name"},{"type":0,"value":" declined"}],
    "huddle.recording.you": "You're recording this meeting",
    "huddle.recording.other": [{"type":1,"value":"name"},{"type":0,"value":" is recording this meeting"}],
    "huddle.recording.start": "Record meeting",
    "huddle.recording.stop": "Stop recording",
    "huddle.recording.indicator": "Recording",
    "huddle.recording.consent": "Everyone in the meeting sees that it's being recorded. When you stop, the recording is posted in the meeting's thread.",
    "huddle.recording.saving": "Saving the recording…",
    "huddle.recording.saved": "Recording posted in the meeting's thread",
    "huddle.transcript.on": "Transcript on",
    "huddle.transcript.about": "Transcript on. About the transcript",
    "huddle.transcript.title": "This meeting is transcribed",
    "huddle.transcript.body": "Everyone's speech is turned into text while they're unmuted. When you're muted, nothing you say is transcribed. The transcript is saved on the meeting's page for everyone who was in it.",
    "huddle.transcript.admin": "Workspace owners and admins can turn this off in Settings › Meet.",
    "huddle.transcript.muted": "You're muted. Nothing you say is transcribed.",
    "huddle.transcript.notice": "This meeting is transcribed while people are unmuted. The transcript is saved for everyone in it.",
    "huddle.recording.consentLink": "Everyone in the meeting sees that it's being recorded. When you stop, the recording is saved on the meeting's page for the people who were in it.",
    "huddle.recording.savedLink": "Recording saved on the meeting's page",
    "huddle.recording.failed": "Couldn't save the recording",
    "huddle.recording.unsupported": "Recording isn't available here",
    "huddle.captions.on": "Turn on captions",
    "huddle.captions.off": "Turn off captions",
    "huddle.captions.label": "Captions",
    "huddle.captions.unsupported": "Captions aren't available in this browser",
    "huddle.captions.listening": "Captions are on. Lines appear as people speak.",
    "huddle.captions.note.device": "Your captions are made on this device. Only the text is shared.",
    "huddle.captions.note.preparing": [{"type":0,"value":"Getting on-device captions ready · "},{"type":1,"value":"percent"},{"type":0,"value":"%. Until then, Bundle's server makes yours."}],
    "huddle.captions.note.notDownloaded": "On-device captions download in the background. Until then, Bundle's server makes yours.",
    "huddle.captions.note.unsupported": "This device can't make captions itself, so Bundle's server makes them. Audio isn't kept.",
    "huddle.captions.note.language": "On-device captions don't support this language here yet, so Bundle's server makes them.",
    "huddle.captions.note.lowStorage": [{"type":0,"value":"Not enough free space for on-device captions ("},{"type":1,"value":"size"},{"type":0,"value":"). Bundle's server makes them for now."}],
    "huddle.captions.note.failed": "On-device captions stopped working, so Bundle's server took over for this meeting.",
    "huddle.captions.note.off": "You turned off on-device captions. Bundle's server makes yours.",
    "huddle.captions.note.none": "Captions aren't available on this device.",
    "huddle.draw.start": "Draw on screen",
    "huddle.draw.stop": "Stop drawing",
    "huddle.draw.pen": "Pen",
    "huddle.draw.eraser": "Eraser",
    "huddle.recap.title": "Meet",
    "huddle.recap.live": "Meeting in progress",
    "huddle.recap.short": "Under a minute",
    "huddle.recap.minutes": [{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "huddle.recap.hours": [{"type":1,"value":"hours"},{"type":0,"value":" h "},{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "huddle.recap.notes": "Meeting notes",
    "huddle.recap.summary": "Summary",
    "huddle.recap.actionItems": "Action items",
    "huddle.recap.decisions": "Decisions",
    "huddle.recap.transcript": "Transcript",
    "huddle.recap.showTranscript": "Show transcript",
    "huddle.recap.hideTranscript": "Hide transcript",
    "huddle.recap.notesPending": "Writing meeting notes…",
    "huddle.recap.aiNotice": "Written by AI from the transcript. Check important details.",
    "huddle.recap.noTranscript": "No transcript: nobody turned on captions.",
    "huddle.missed.title": "Missed meeting",
    "huddle.missed.caller": [{"type":1,"value":"name"},{"type":0,"value":" called you"}],
    "huddle.missed.callBack": "Call back",
    "huddle.incoming.label": "Incoming meeting",
    "huddle.incoming.join": "Join",
    "huddle.incoming.decline": "Decline",
    "huddle.ring.micOn": "Microphone on",
    "huddle.ring.micOff": "Microphone off",
    "huddle.ring.cameraOn": "Camera on",
    "huddle.ring.cameraOff": "Camera off",
    "huddle.ring.declineWithMessage": "Decline with a message…",
    "huddle.ring.close": "Close and stop ringing",
    "huddle.ring.windowLabel": [{"type":0,"value":"Bundle · "},{"type":1,"value":"workspace"}],
    "huddle.ring.windowTitle": "Incoming meeting",
    "thread.follow.on": "Get notified about new replies",
    "thread.follow.off": "Turn off notifications for replies",
    "thread.follow.following": "Following",
    "thread.follow.notFollowing": "Not following",
    "richtext.privateChannel": "private channel",
    "huddle.idle.title": "No meeting right now",
    "huddle.idle.body": "Start one and everyone in the conversation can hop in.",
    "huddle.idle.linkBody": "Start it here, then share the link: people join from it.",
    "huddle.idle.active": [{"type":1,"value":"name"},{"type":0,"value":" and others are talking. Join them?"}],
    "huddle.summary.justYou": "Just you",
    "huddle.summary.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" person in the meeting"}]},"other":{"value":[{"type":7},{"type":0,"value":" people in the meeting"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.summary.one": [{"type":1,"value":"name"}],
    "huddle.summary.two": [{"type":1,"value":"a"},{"type":0,"value":" and "},{"type":1,"value":"b"}],
    "huddle.summary.many": [{"type":1,"value":"a"},{"type":0,"value":" +"},{"type":1,"value":"count"}],
    "huddle.error.forbidden": "You can't join meetings in this workspace.",
    "huddle.error.notFound": "That conversation isn't available.",
    "huddle.error.network": "Couldn't reach the meeting. Check your connection and try again.",
    "huddle.error.ended": "The meeting ended.",
    "huddle.error.micDenied": "Bundle can't use your microphone. Allow it in your browser or system settings.",
    "huddle.error.cameraDenied": "Bundle can't use your camera. Allow it in your browser or system settings.",
    "huddle.error.micDeniedApp": "Bundle can't use your microphone. Allow it in Settings.",
    "huddle.error.cameraDeniedApp": "Bundle can't use your camera. Allow it in Settings.",
    "huddle.error.screenDenied": "Screen sharing was blocked or cancelled.",
    "huddle.error.media": "The meeting connection failed.",
    "huddle.settings.audio": "Audio",
    "huddle.settings.video": "Video",
    "huddle.settings.microphone": "Microphone",
    "huddle.settings.speaker": "Speaker",
    "huddle.settings.camera": "Camera",
    "huddle.settings.noDevices": "None found",
    "huddle.settings.inputLevel": "Input level",
    "huddle.settings.testSpeaker": "Play test sound",
    "huddle.settings.noiseSuppression": "Noise suppression",
    "huddle.settings.noise.off": "Off",
    "huddle.settings.noise.standard": "Standard",
    "huddle.settings.noise.strong": "Strong",
    "huddle.settings.noise.hint": "Strong uses a noise-removal model for loud places: keyboards, fans, traffic.",
    "huddle.settings.echoCancellation": "Echo cancellation",
    "huddle.settings.autoGain": "Adjust microphone volume automatically",
    "huddle.settings.background": "Background",
    "huddle.settings.uploadBackground": "Upload image",
    "huddle.settings.mirror": "Mirror my video",
    "huddle.settings.joining": "When joining",
    "huddle.settings.joinMicOff": "Join with microphone off",
    "huddle.settings.joinCameraOff": "Join with camera off",
    "huddle.settings.captions": "Captions",
    "huddle.settings.captionsOnDevice": "Make captions on this device",
    "huddle.settings.captionsOnDevice.hint": "Your speech is turned into text here and only the text is shared. When this device can't, Bundle's server makes your captions and doesn't keep the audio.",
    "huddle.settings.speechModel": "Speech model",
    "huddle.settings.speechModel.system": "Managed by the system · nothing to download",
    "huddle.settings.speechModel.downloading": [{"type":0,"value":"Downloading · "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "huddle.settings.speechModel.web": [{"type":0,"value":"Desert Ant Voz · "},{"type":1,"value":"size"},{"type":0,"value":", downloaded once the first time you turn on captions"}],
    "huddle.settings.speechModel.android": [{"type":0,"value":"Desert Ant Voz · "},{"type":1,"value":"size"},{"type":0,"value":", downloaded over Wi-Fi the first time you turn on captions"}],
    "huddle.settings.speechModel.ready": [{"type":0,"value":"Desert Ant Voz · "},{"type":1,"value":"size"},{"type":0,"value":" · downloaded"}],
    "huddle.settings.captionsDeviceOnly": "Applies to this device only. Each device you use decides for itself.",
    "huddle.settings.cameraOff": "Camera preview is off",
    "huddle.settings.previewCamera": "Preview camera",
    "huddle.settings.effectsUnsupported": "This browser can't apply background effects.",
    "huddle.background.none": "None",
    "huddle.background.blurLight": "Light blur",
    "huddle.background.blurStrong": "Strong blur",
    "huddle.background.image.dusk": "Dusk",
    "huddle.background.image.paper": "Paper",
    "huddle.background.image.studio": "Studio",
    "huddle.background.custom": "My image",
    "huddle.device.microphone": [{"type":0,"value":"Microphone "},{"type":1,"value":"n"}],
    "huddle.device.camera": [{"type":0,"value":"Camera "},{"type":1,"value":"n"}],
    "huddle.device.speaker": [{"type":0,"value":"Speaker "},{"type":1,"value":"n"}],
    "huddle.lobby.one": [{"type":1,"value":"name"},{"type":0,"value":" wants to join"}],
    "huddle.lobby.many": [{"type":1,"value":"name"},{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" more want to join"}],
    "huddle.lobby.admit": "Admit",
    "huddle.lobby.deny": "Deny",
    "huddle.lobby.admitAll": "Admit all",
    "huddle.external": "External",
    "huddle.moderate.mute": "Mute",
    "huddle.moderate.remove": "Remove from meeting",
    "huddle.moderate.end": "End for everyone",
    "huddle.moderate.more": "More options",
    "huddle.share.link": "Share link",
    "huddle.share.copy": "Copy link",
    "huddle.share.copied": "Link copied",
    "huddle.meeting.lock": "Lock meeting",
    "huddle.meeting.unlock": "Unlock meeting",
    "huddle.meeting.openToAll": "Anyone with the link can join directly",
    "huddle.meeting.locked": "Locked: nobody new can join",
    "huddle.chat.title": "Meeting chat",
    "huddle.chat.open": "Chat",
    "huddle.chat.placeholder": "Message everyone in the meeting",
    "huddle.chat.empty": "Messages here last only as long as the meeting.",
    "huddle.chat.send": "Send",
    "meeting.new.title": "New external meeting",
    "meeting.new.name": "Title",
    "meeting.new.namePlaceholder": "Partner sync",
    "meeting.new.conversation": "Conversation",
    "meeting.new.noConversation": "None (standalone meeting)",
    "meeting.new.now": "Start now",
    "meeting.new.later": "Schedule for later",
    "meeting.new.time": "Time (HH:MM)",
    "meeting.new.create": "Create link",
    "meeting.new.ready": "Your meeting link is ready. Anyone with it can ask to join.",
    "meeting.new.start": "Start meeting",
    "meeting.new.error": "Couldn't create the link. Try again.",
    "meeting.page.hostedBy": [{"type":0,"value":"Hosted by "},{"type":1,"value":"name"}],
    "meeting.page.huddleWith": [{"type":0,"value":"Meet with "},{"type":1,"value":"name"}],
    "meeting.page.scheduled": [{"type":0,"value":"Scheduled for "},{"type":1,"value":"time"}],
    "meeting.page.live": "People are in the meeting",
    "meeting.page.yourName": "Your name",
    "meeting.page.namePlaceholder": "How others will see you",
    "meeting.page.join": "Join meeting",
    "meeting.page.askToJoin": "Ask to join",
    "meeting.page.joiningAs": [{"type":0,"value":"Joining as "},{"type":1,"value":"name"}],
    "meeting.page.waiting": "Waiting for someone to let you in…",
    "meeting.page.denied": "Nobody let you in. You can close this page.",
    "meeting.page.removed": "You were removed from the meeting.",
    "meeting.page.ended": "The meeting has ended.",
    "meeting.page.left": "You left the meeting.",
    "meeting.page.rejoin": "Rejoin",
    "meeting.page.unavailable": "This meeting link doesn't work anymore.",
    "meeting.page.locked": "This meeting is locked. Ask the host to unlock it.",
    "meeting.page.challengeFailed": "Please complete the check and try again.",
    "meeting.page.openInApp": "Open in the Bundle app",
    "meeting.page.noApp": "Don't have it?",
    "meeting.page.downloadApp": "Download",
    "meeting.page.choice.app": "Join in the Bundle app",
    "meeting.page.choice.browser": "Continue in browser",
    "meeting.page.choice.store.appStore": "Free on the App Store",
    "meeting.page.choice.store.testflight": "Beta on TestFlight",
    "meeting.page.choice.store.play": "Free on Google Play",
    "meeting.page.choice.store.apk": "Direct download (.apk)",
    "meeting.page.choice.getTitle": "Get Bundle to join",
    "meeting.page.choice.getBody": "Install the app, then open the meeting link again. It opens straight into this meeting.",
    "meeting.page.choice.get.appStore": "Get it on the App Store",
    "meeting.page.choice.get.testflight": "Get it on TestFlight",
    "meeting.page.choice.get.play": "Get it on Google Play",
    "meeting.page.choice.get.apk": "Download the app",
    "meeting.page.choice.haveIt": "Already have it?",
    "meeting.page.choice.openApp": "Open Bundle",
    "meeting.page.privacy": "Joining shares your name, camera and microphone with the people in this meeting, and nothing else.",
    "meeting.page.error": "Something went wrong. Try again.",
    "page.comingSoon": "Docs and databases arrive in M5.",
    "auth.title": "Sign in to Bundle",
    "auth.subtitle": "Chat, docs and agents in one place.",
    "auth.name": "Name (optional)",
    "auth.continue": "Continue",
    "auth.signingIn": "Signing in…",
    "auth.error": "Couldn't sign in. Is the API running?",
    "auth.mock": "Mock mode — no server needed.",
    "auth.signOut": "Sign out",
    "profile.language": "Language",
    "profile.theme": "Theme",
    "profile.theme.system": "System",
    "profile.theme.light": "Light",
    "profile.theme.dark": "Dark",
    "connection.reconnecting": "Connection lost — reconnecting…",
    "offline.banner": "You're offline — showing saved messages",
    "offline.bannerNoCache": "You're offline",
    "offline.bannerQueued": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"You're offline — "},{"type":7},{"type":0,"value":" message will send when you reconnect"}]},"other":{"value":[{"type":0,"value":"You're offline — "},{"type":7},{"type":0,"value":" messages will send when you reconnect"}]}},"offset":0,"pluralType":"cardinal"}],
    "offline.sending": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Sending "},{"type":7},{"type":0,"value":" queued message…"}]},"other":{"value":[{"type":0,"value":"Sending "},{"type":7},{"type":0,"value":" queued messages…"}]}},"offset":0,"pluralType":"cardinal"}],
    "message.queued": "Waiting to send",
    "invite.guest.title": "Invite a guest",
    "invite.guest.action": "Invite guest",
    "invite.guest.email": "Email",
    "invite.guest.name": "Name (optional)",
    "invite.guest.organization": "Organization",
    "invite.guest.channels": "Channels",
    "invite.guest.expiry": "Access expires",
    "invite.guest.expiry.never": "Never",
    "invite.guest.expiry.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"In "},{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":0,"value":"In "},{"type":7},{"type":0,"value":" days"}]}},"offset":0,"pluralType":"cardinal"}],
    "invite.guest.submit": "Send invite",
    "invite.guest.sent": [{"type":0,"value":"Invite sent to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "invite.guest.notice": "Guests only see the channels you pick.",
    "channel.create": "Create channel",
    "channelMembers.search": "Search members",
    "channelMembers.add": "Add people",
    "channelMembers.addSearch": "Search people to add",
    "channelMembers.addSubmit": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Add "},{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":0,"value":"Add "},{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "channelMembers.addNone": "No one else to add",
    "channelMembers.remove": "Remove",
    "channelMembers.you": "(you)",
    "channelMembers.role.owner": "Owner",
    "channelMembers.role.admin": "Admin",
    "channelMembers.role.guest": "Guest",
    "channelMembers.sponsor": [{"type":0,"value":"Sponsored by "},{"type":1,"value":"name"}],
    "channelMembers.empty": "No members match",
    "channelMembers.everyone": "Everyone in the workspace is in this channel.",
    "channelMembers.offline": "You're offline. Members show up once you're back online.",
    "channelMembers.failed": "Couldn't load the members",
    "channelMembers.addFailed": "Couldn't add people. Try again.",
    "channelMembers.removeFailed": [{"type":0,"value":"Couldn't remove "},{"type":1,"value":"name"}],
    "sidebar.folder.name": [{"type":1,"value":"name"}],
    "sidebar.folder.new": "New folder",
    "sidebar.folder.createSubmit": "Create",
    "sidebar.folder.edit": "Edit folder",
    "sidebar.folder.nameLabel": "Folder name",
    "sidebar.folder.namePlaceholder": "e.g. Launch",
    "sidebar.folder.nameRequired": "Enter a name for the folder",
    "sidebar.folder.nameTooLong": [{"type":6,"value":"max","options":{"one":{"value":[{"type":0,"value":"Names can be at most "},{"type":7},{"type":0,"value":" character"}]},"other":{"value":[{"type":0,"value":"Names can be at most "},{"type":7},{"type":0,"value":" characters"}]}},"offset":0,"pluralType":"cardinal"}],
    "sidebar.folder.look": "Emoji or icon",
    "sidebar.folder.emojiSearch": "Search emoji",
    "sidebar.folder.useIcon": "Use an icon",
    "sidebar.folder.options": "Folder options",
    "sidebar.folder.delete": "Delete folder",
    "sidebar.folder.moveUp": "Move folder up",
    "sidebar.folder.moveDown": "Move folder down",
    "sidebar.folder.empty": "Drag channels, DMs or pages here",
    "sidebar.row.move": "Move to folder…",
    "sidebar.move.title": [{"type":0,"value":"Move "},{"type":1,"value":"name"},{"type":0,"value":" to…"}],
    "sidebar.move.newFolder": "New folder…",
    "sidebar.move.toTree": "Back to the page tree",
    "channels.name.required": "Enter a name for the channel",
    "channels.name.tooLong": [{"type":6,"value":"max","options":{"one":{"value":[{"type":0,"value":"Names can be at most "},{"type":7},{"type":0,"value":" character"}]},"other":{"value":[{"type":0,"value":"Names can be at most "},{"type":7},{"type":0,"value":" characters"}]}},"offset":0,"pluralType":"cardinal"}],
    "channels.name.taken": [{"type":0,"value":"#"},{"type":1,"value":"name"},{"type":0,"value":" is already taken"}],
    "channels.name.willBe": [{"type":0,"value":"Names are lowercase with dashes: #"},{"type":1,"value":"name"}],
    "channels.create.title": "Create a channel",
    "channels.create.name": "Name",
    "channels.create.namePlaceholder": "e.g. plan-budget",
    "channels.create.description": "Description",
    "channels.create.descriptionPlaceholder": "What is this channel about?",
    "channels.create.private": "Make private",
    "channels.create.privateHint": "Only people who are added can see and join it.",
    "channels.create.publicHint": "Anyone in the workspace can find and join it.",
    "channels.create.members": "Add people",
    "channels.create.removeMember": [{"type":0,"value":"Remove "},{"type":1,"value":"name"}],
    "channels.create.membersSearch": "Search people",
    "channels.create.membersNone": "No one to add",
    "channels.create.submit": "Create",
    "channels.create.forbidden": "You can't create channels in this workspace",
    "channels.browse.title": "Browse channels",
    "channels.browse.search": "Search channels",
    "channels.browse.filter.all": "All channels",
    "channels.browse.filter.joined": "Joined",
    "channels.browse.filter.other": "Not joined",
    "channels.browse.filter.archived": "Archived",
    "channels.browse.empty": "No channels match",
    "channels.browse.joined": "Joined",
    "channels.browse.join": "Join",
    "channels.browse.leave": "Leave",
    "channels.join.prompt": [{"type":0,"value":"You're viewing #"},{"type":1,"value":"channel"}],
    "channels.join.button": "Join channel",
    "channels.join.failed": "Couldn't join the channel. Try again.",
    "channels.join.offline": "You're offline. Join once you're back online.",
    "channels.leave.failed": "Couldn't leave the channel",
    "channels.archived.banner": "This channel is archived. It's read-only.",
    "channels.settings.topic": "Topic",
    "channels.settings.topicPlaceholder": "Add a topic",
    "channels.settings.notifications": "Notifications",
    "channels.settings.mute": "Mute channel",
    "channels.settings.notify.default": "Default",
    "channels.settings.notify.all": "All messages",
    "channels.settings.notify.mentions": "Mentions only",
    "channels.settings.notify.none": "Nothing",
    "channels.settings.notify.set.default": "Following your notification settings",
    "channels.settings.notify.set.all": "You'll be notified about all messages",
    "channels.settings.notify.set.mentions": "You'll be notified about mentions only",
    "channels.settings.notify.set.none": "You won't be notified about this conversation",
    "channels.settings.muted": "Conversation muted",
    "channels.settings.unmuted": "Conversation unmuted",
    "channels.settings.makePrivate": "Change to a private channel",
    "channels.settings.makePublic": "Change to a public channel",
    "channels.settings.makePrivateHint": "Only current members will be able to see it.",
    "channels.settings.makePublicHint": "Anyone in the workspace will be able to find and join it.",
    "channels.settings.archive": "Archive channel",
    "channels.settings.unarchive": "Unarchive channel",
    "channels.settings.archiveHint": "Archived channels are read-only and leave everyone's sidebar. They stay searchable.",
    "channels.settings.leave": "Leave channel",
    "channels.details.about": "About",
    "channels.details.members": "Members",
    "channels.details.settings": "Settings",
    "channels.settings.created": "Created by",
    "channels.settings.createdBy": [{"type":1,"value":"name"},{"type":0,"value":" on "},{"type":1,"value":"date"}],
    "channels.settings.saved": "Saved",
    "channels.settings.failed": "Couldn't save the change",
    "sidebar.channels.add": "Add channels",
    "sidebar.row.star": "Star",
    "sidebar.row.unstar": "Unstar",
    "sidebar.row.mute": "Mute",
    "sidebar.row.unmute": "Unmute",
    "sidebar.row.leave": "Leave channel",
    "common.error": "Something went wrong. Try again.",
    "language.en": "English",
    "language.ptBR": "Português (Brasil)",
    "desktopAuth.title": "Sign in to Bundle for desktop",
    "desktopAuth.signedInAs": [{"type":0,"value":"Signed in as "},{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":")"}],
    "desktopAuth.device": [{"type":0,"value":"Device: "},{"type":1,"value":"device"}],
    "desktopAuth.open": "Open Bundle for desktop",
    "desktopAuth.switchAccount": "Use a different account",
    "desktopAuth.redirected": "You can close this tab",
    "desktopAuth.redirectedBody": "Bundle for desktop is finishing signing you in.",
    "desktopAuth.copyCode": "App didn't open? Copy code",
    "desktopAuth.copied": "Code copied — paste it in the desktop app.",
    "desktopAuth.invalid": "This sign-in link is invalid or has expired",
    "desktopAuth.invalidBody": "Start again from the Bundle desktop app.",
    "desktopAuth.offline": "You're offline. Connect to the internet and try again.",
    "desktopAuth.failed": "Couldn't create a sign-in code. Try again.",
    "auth.google": "Continue with Google",
    "auth.apple": "Continue with Apple",
    "auth.error.apple": "Apple sign-in didn't finish. Try again.",
    "auth.or": "or",
    "auth.emailPlaceholder": "name@company.com",
    "auth.emailCode.send": "Email me a sign-in code",
    "auth.code.title": "Check your email",
    "auth.code.sentTo": [{"type":0,"value":"We sent a 6-digit code to "},{"type":1,"value":"email"},{"type":0,"value":". It expires in 10 minutes."}],
    "auth.code.label": "Sign-in code",
    "auth.code.submit": "Sign in",
    "auth.code.resend": "Send a new code",
    "auth.code.changeEmail": "Use a different email",
    "auth.dev.title": "Developer sign-in",
    "auth.dev.hint": "Local development: any email signs you in to the demo workspace.",
    "auth.error.network": "Can't reach Bundle. Check your connection and try again.",
    "auth.error.invalid": "Couldn't sign you in. Try again.",
    "auth.error.invalidEmail": "Enter a valid email address.",
    "auth.error.invalidCode": "That code isn't right or has expired.",
    "auth.error.rateLimited": "Too many attempts. Wait a minute and try again.",
    "auth.error.unavailable": "Email sign-in isn't available right now.",
    "auth.error.google": "Google sign-in didn't finish. Try again.",
    "auth.methods.failed": "Can't reach Bundle right now.",
    "auth.browser.body": "You sign in with your browser, then come back here.",
    "auth.browser.start": "Sign in with your browser",
    "auth.browser.waiting": "Finish signing in in your browser…",
    "auth.browser.waitingBody": "We opened Bundle in your browser. Sign in there and it brings you back to the app.",
    "auth.browser.retry": "Try again",
    "auth.browser.paste": "Paste a code",
    "auth.browser.pasteLabel": "Sign-in code",
    "auth.browser.pastePlaceholder": "Paste the code your browser shows",
    "auth.error.cancelled": "Sign-in was cancelled in the browser.",
    "auth.error.signInExpired": "This sign-in expired. Start again.",
    "auth.error.codeRejected": "That code expired or was already used. Start again.",
    "auth.error.browser": "Couldn't open your browser. Try again.",
    "auth.signedInAs": [{"type":0,"value":"Signed in as "},{"type":1,"value":"email"}],
    "auth.switchAccount": "Use a different account",
    "workspace.loading": "Loading your workspaces…",
    "workspace.loadingStuck.title": "Bundle is having trouble loading",
    "workspace.loadingStuck.body": "Check your connection and try again. Signing out and back in can help too.",
    "workspace.create.title": "Create a workspace",
    "workspace.create.subtitle": "Your team's home for chat, docs and agents.",
    "workspace.create.name": "Workspace name",
    "workspace.create.placeholder": "Acme Inc.",
    "workspace.create.url": [{"type":0,"value":"Address: "},{"type":1,"value":"url"}],
    "workspace.create.submit": "Create workspace",
    "workspace.create.error": "Couldn't create the workspace. Try again.",
    "workspace.create.rateLimited": "You've created a lot of workspaces today. Try again tomorrow.",
    "workspace.create.offline": "You're offline. Connect to the internet to create a workspace.",
    "workspace.switcher.create": "Create workspace",
    "workspace.switcher.invite": "Invite people",
    "workspace.switcher.join": [{"type":0,"value":"Join "},{"type":1,"value":"name"}],
    "workspace.join.title": "Join your team",
    "workspace.join.subtitle": "Your verified email address lets you join these workspaces without an invite.",
    "workspace.join.domain": [{"type":0,"value":"Open to anyone at "},{"type":1,"value":"domain"}],
    "workspace.join.members": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" member"}]},"other":{"value":[{"type":7},{"type":0,"value":" members"}]}},"offset":0,"pluralType":"cardinal"}],
    "workspace.join.action": "Join",
    "workspace.join.error": "Couldn't join this workspace. Try again.",
    "workspace.join.offline": "You're offline. Connect to the internet to join a workspace.",
    "workspace.join.orCreate": "Or create a new workspace",
    "invite.people.title": [{"type":0,"value":"Invite people to "},{"type":1,"value":"workspace"}],
    "invite.people.link": "Invite link",
    "invite.people.linkHint": "Anyone with the link can join for 7 days.",
    "invite.people.createLink": "Create invite link",
    "invite.people.copy": "Copy link",
    "invite.people.copied": "Link copied",
    "invite.people.emails": "Invite by email",
    "invite.people.emailsPlaceholder": "ana@company.com, bo@company.com",
    "invite.people.asAdmins": "Invite as admins",
    "invite.people.send": "Send invites",
    "invite.people.sent": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Invited "},{"type":7},{"type":0,"value":" person."}]},"other":{"value":[{"type":0,"value":"Invited "},{"type":7},{"type":0,"value":" people."}]}},"offset":0,"pluralType":"cardinal"}],
    "invite.people.notEmailed": "Email isn't set up yet — share these links yourself:",
    "invite.people.invalid": [{"type":0,"value":"Not an email address: "},{"type":1,"value":"list"}],
    "invite.people.overLimit": "You can invite up to 50 people at a time.",
    "invite.people.done": "Done",
    "invite.people.skip": "Skip for now",
    "invite.accept.title": [{"type":1,"value":"inviter"},{"type":0,"value":" invited you to join "},{"type":1,"value":"workspace"}],
    "invite.accept.titleAnonymous": [{"type":0,"value":"You're invited to join "},{"type":1,"value":"workspace"}],
    "invite.accept.subtitle": "Bundle is where the team chats, writes docs and works with agents.",
    "invite.accept.join": [{"type":0,"value":"Join "},{"type":1,"value":"workspace"}],
    "invite.accept.signInToJoin": "Sign in to join",
    "invite.accept.invalid": "This invite link is invalid or has expired",
    "invite.accept.invalidBody": "Ask the person who invited you for a new link.",
    "invite.accept.emailMismatch": "This invite was sent to a different email address. Sign in with that address to join.",
    "invite.accept.offline": "You're offline. Connect to the internet and try again.",
    "invite.accept.continue": "Continue to Bundle",
    "invite.guest.link": [{"type":0,"value":"Sign-in link for "},{"type":1,"value":"email"},{"type":0,"value":" (valid 7 days):"}],
    "update.available": "A new version of Bundle is available.",
    "update.ready": [{"type":0,"value":"Bundle "},{"type":1,"value":"version"},{"type":0,"value":" is ready to install."}],
    "update.reload": "Reload",
    "update.restart": "Restart",
    "update.check": "Check for updates…",
    "update.checkPlain": "Check for updates",
    "update.downloadingMenu": [{"type":0,"value":"Downloading "},{"type":1,"value":"version"},{"type":0,"value":"…"}],
    "update.restartToUpdate": "Restart to update",
    "update.reloadToUpdate": "Reload to update",
    "update.checking": "Checking for updates…",
    "update.upToDate": "You're up to date",
    "update.upToDateVersion": [{"type":0,"value":"You're up to date ("},{"type":1,"value":"version"},{"type":0,"value":")"}],
    "update.checkedJustNow": "Checked just now.",
    "update.autoNote": "Updates install on their own when you're away.",
    "update.webLatest": [{"type":0,"value":"Web app "},{"type":1,"value":"commit"},{"type":0,"value":" is the newest build."}],
    "update.checkAgain": "Check again",
    "update.availableVersion": [{"type":0,"value":"Bundle "},{"type":1,"value":"version"},{"type":0,"value":" is available"}],
    "update.downloadingPercent": [{"type":0,"value":"Downloading… "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "update.downloadingPlain": "Downloading…",
    "update.readyVersion": [{"type":0,"value":"Bundle "},{"type":1,"value":"version"},{"type":0,"value":" is ready"}],
    "update.readyNote": "Installs when you're away or quit. Your windows and tabs come back.",
    "update.webReadyTitle": "A new version of Bundle is ready",
    "update.webReadyNote": "Reloads by itself when you step away, or now.",
    "update.errorCheck": "Couldn't check for updates",
    "update.errorDownload": "Couldn't download the update",
    "update.errorInstall": "Couldn't install the update",
    "update.errorHint": "Check your connection and try again.",
    "update.tryAgain": "Try again",
    "update.updatedTo": [{"type":0,"value":"Updated to Bundle "},{"type":1,"value":"version"},{"type":0,"value":"."}],
    "update.whatsNew": "What's new",
    "toast.region": "Notifications",
    "update.later": "Later",
    "update.download": "Download",
    "update.apkBody": "Download it here, then tap Install. Your messages and settings stay.",
    "update.apkNotifyBody": "Tap to download and install.",
    "update.checkedAt": [{"type":0,"value":"Checked "},{"type":1,"value":"time"}],
    "update.opensStoreIos": "Opens TestFlight or the App Store, which keep Bundle up to date.",
    "update.opensStorePlay": "Opens Bundle in Google Play",
    "about.title": "About Bundle",
    "about.section": "About",
    "about.versionLine": [{"type":0,"value":"Version "},{"type":1,"value":"version"},{"type":0,"value":" · "},{"type":1,"value":"channel"}],
    "about.version": "Version",
    "about.channel": "Channel",
    "about.channel.stable": "Stable",
    "about.channel.testflight": "TestFlight",
    "about.channel.direct": "Direct",
    "about.channel.dev": "Development",
    "about.desktopApp": "Desktop app",
    "about.webApp": "Web app",
    "about.server": "Server",
    "about.copy": "Copy version info",
    "about.copied": "Version info copied.",
    "about.licenses": "Licenses",
    "notification.reply": "Reply",
    "notification.markRead": "Mark as read",
    "notification.you": "You",
    "notification.newMessage": "New message",
    "notification.channel.mail": "Email",
    "notification.channel.mailDescription": "New email and verification codes",
    "notification.channel.reminders": "Reminders",
    "notification.channel.remindersDescription": "Later reminders, event reminders and invitations",
    "notification.channel.workspace": "Workspace",
    "notification.channel.workspaceDescription": "New members and other workspace alerts",
    "common.dismiss": "Dismiss",
    "db.untitled": "Untitled",
    "db.new": "New",
    "db.search.placeholder": "Search",
    "db.toolbar.filter": "Filter",
    "db.toolbar.sort": "Sort",
    "db.toolbar.group": "Group",
    "db.toolbar.properties": "Properties",
    "db.toolbar.search": "Search this view",
    "db.view.add": "Add view",
    "db.view.rename": "Rename",
    "db.view.duplicate": "Duplicate",
    "db.view.delete": "Delete view",
    "db.view.name": "View name",
    "db.view.copyName": [{"type":1,"value":"name"},{"type":0,"value":" (copy)"}],
    "db.view.options": "View options",
    "db.layout.board": "Board",
    "db.layout.table": "Table",
    "db.layout.list": "List",
    "db.layout.calendar": "Calendar",
    "db.layout.sheet": "Sheet",
    "db.sheet.nameBox": "Name box",
    "db.sheet.formulaBar": "Formula",
    "db.sheet.entryRow": "Type to add a row",
    "db.sheet.summary": "Summary",
    "db.sheet.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" row"}]},"other":{"value":[{"type":7},{"type":0,"value":" rows"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.sheet.summaryRows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" summary row"}]},"other":{"value":[{"type":7},{"type":0,"value":" summary rows"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.sheet.stat.label": "Selection statistic",
    "db.sheet.stat.sum": "Sum",
    "db.sheet.stat.average": "Average",
    "db.sheet.stat.min": "Min",
    "db.sheet.stat.max": "Max",
    "db.sheet.stat.count": "Count",
    "db.sheet.columnFormula": [{"type":0,"value":"Column formula · "},{"type":1,"value":"name"}],
    "db.sheet.editProperty": "Edit property…",
    "db.sheet.computed": "Computed",
    "db.sheet.functions": "Functions",
    "db.sheet.freeze": "Freeze",
    "db.sheet.freeze.headerOnly": "Header only",
    "db.sheet.freeze.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Header + 1 row"}]},"other":{"value":[{"type":0,"value":"Header + "},{"type":7},{"type":0,"value":" rows"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.sheet.freeze.noColumns": "No columns",
    "db.sheet.freeze.columns": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"1 column"}]},"other":{"value":[{"type":7},{"type":0,"value":" columns"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.sheet.freeze.upToRow": [{"type":0,"value":"Freeze up to row "},{"type":1,"value":"row"}],
    "db.sheet.freeze.upToColumn": [{"type":0,"value":"Freeze up to column "},{"type":1,"value":"column"}],
    "db.sheet.sortRange": "Sort range",
    "db.sheet.sortAsc": "Sort range A → Z",
    "db.sheet.sortDesc": "Sort range Z → A",
    "db.sheet.sorted": [{"type":0,"value":"Rows sorted by "},{"type":1,"value":"name"},{"type":0,"value":". Row numbers changed in every view."}],
    "db.sheet.sortFailed": "Couldn't sort the rows. Try again.",
    "db.sheet.undo": "Undo",
    "db.sheet.insert": "Insert",
    "db.sheet.insertAbove": "Insert row above",
    "db.sheet.insertBelow": "Insert row below",
    "db.sheet.addSummary": "Summary row",
    "db.sheet.insertSummaryAbove": "Insert summary row above",
    "db.sheet.insertSummaryBelow": "Insert summary row below",
    "db.sheet.moveUp": "Move up",
    "db.sheet.moveDown": "Move down",
    "db.sheet.deleteSummary": "Delete summary row",
    "db.sheet.deleteRow": "Delete row",
    "db.sheet.openRow": "Open row page",
    "db.sheet.cut": "Cut",
    "db.sheet.copy": "Copy",
    "db.sheet.paste": "Paste",
    "db.sheet.fillDown": "Fill down",
    "db.sheet.fillRight": "Fill right",
    "db.sheet.clear": "Clear",
    "db.sheet.typeMismatch": [{"type":1,"value":"name"},{"type":0,"value":" doesn't take “"},{"type":1,"value":"text"},{"type":0,"value":"”."}],
    "db.sheet.changeType": "Change type…",
    "db.sheet.tooMany": [{"type":0,"value":"A fill or paste can change up to "},{"type":1,"value":"max"},{"type":0,"value":" cells ("},{"type":1,"value":"count"},{"type":0,"value":" here)."}],
    "db.sheet.clipboardFailed": "Couldn't read the clipboard. Use ⌘V or Ctrl+V.",
    "db.sheet.fill": "Fill",
    "db.sheet.freezeHere": "Freeze up to here",
    "db.sheet.unfreeze": "Unfreeze",
    "db.sheet.placeholder": "Value or =formula",
    "db.sheet.notEditable": [{"type":1,"value":"name"},{"type":0,"value":" can't be edited here"}],
    "db.sheet.saveFailed": "Couldn't save the cell",
    "db.layout.label": "Layout",
    "db.filter.add": "Add filter",
    "db.filter.empty": "No filters applied to this view",
    "db.filter.and": "And",
    "db.filter.or": "Or",
    "db.filter.where": "Where",
    "db.filter.remove": "Remove filter",
    "db.filter.value": "Value",
    "db.filter.checked": "Checked",
    "db.filter.unchecked": "Unchecked",
    "db.op.eq": "Is",
    "db.op.neq": "Is not",
    "db.op.contains": "Contains",
    "db.op.notContains": "Does not contain",
    "db.op.startsWith": "Starts with",
    "db.op.endsWith": "Ends with",
    "db.op.isEmpty": "Is empty",
    "db.op.isNotEmpty": "Is not empty",
    "db.op.gt": "Greater than",
    "db.op.gte": "Greater than or equal to",
    "db.op.lt": "Less than",
    "db.op.lte": "Less than or equal to",
    "db.op.before": "Is before",
    "db.op.after": "Is after",
    "db.op.onOrBefore": "Is on or before",
    "db.op.onOrAfter": "Is on or after",
    "db.op.pastWeek": "Is within the past week",
    "db.op.nextWeek": "Is within the next week",
    "db.op.hasAny": "Has any of",
    "db.op.hasAll": "Has all of",
    "db.op.hasNone": "Has none of",
    "db.op.isMe": "Is me",
    "db.sort.add": "Add sort",
    "db.sort.empty": "No sorts applied to this view",
    "db.sort.asc": "Ascending",
    "db.sort.desc": "Descending",
    "db.sort.remove": "Remove sort",
    "db.group.by": "Group by",
    "db.group.noGrouping": "None",
    "db.group.none": [{"type":0,"value":"No "},{"type":1,"value":"property"}],
    "db.group.checked": "Checked",
    "db.group.unchecked": "Unchecked",
    "db.group.hide": "Hide group",
    "db.group.show": "Show group",
    "db.group.hidden": "Hidden groups",
    "db.props.shown": "Shown in this view",
    "db.props.hidden": "Hidden in this view",
    "db.props.show": "Show",
    "db.props.hide": "Hide",
    "db.props.moveUp": "Move up",
    "db.props.moveDown": "Move down",
    "db.property.add": "Add property",
    "db.property.name": "Property name",
    "db.property.type": "Type",
    "db.property.edit": "Edit property",
    "db.property.delete": "Delete property",
    "db.property.options": "Options",
    "db.property.addOption": "Add an option",
    "db.property.optionName": "Option name",
    "db.property.numberFormat": "Number format",
    "db.property.relationTarget": "Related database",
    "db.property.create": "Create",
    "db.numberFormat.number": "Number",
    "db.numberFormat.percent": "Percent",
    "db.numberFormat.currency": "Currency",
    "db.type.title": "Title",
    "db.type.text": "Text",
    "db.type.number": "Number",
    "db.type.select": "Select",
    "db.type.multiSelect": "Multi-select",
    "db.type.status": "Status",
    "db.type.date": "Date",
    "db.type.person": "Person",
    "db.type.checkbox": "Checkbox",
    "db.type.url": "URL",
    "db.type.email": "Email",
    "db.type.files": "Files & media",
    "db.type.relation": "Relation",
    "db.type.contact": "Contact",
    "db.contact.empty": "No contacts",
    "db.contact.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" contact"}]},"other":{"value":[{"type":7},{"type":0,"value":" contacts"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.contact.search": "Find a contact",
    "db.contact.recentEmails": "Recent emails with these clients",
    "db.type.createdTime": "Created time",
    "db.type.createdBy": "Created by",
    "db.type.editedTime": "Last edited time",
    "db.type.editedBy": "Last edited by",
    "db.type.formula": "Formula",
    "db.type.rollup": "Rollup",
    "db.calc.calculate": "Calculate",
    "db.calc.none": "None",
    "db.calc.countAll": "Count all",
    "db.calc.countValues": "Count values",
    "db.calc.countUnique": "Count unique values",
    "db.calc.countEmpty": "Count empty",
    "db.calc.countNotEmpty": "Count not empty",
    "db.calc.percentEmpty": "Percent empty",
    "db.calc.percentNotEmpty": "Percent not empty",
    "db.calc.sum": "Sum",
    "db.calc.average": "Average",
    "db.calc.median": "Median",
    "db.calc.min": "Min",
    "db.calc.max": "Max",
    "db.calc.range": "Range",
    "db.calc.earliest": "Earliest date",
    "db.calc.latest": "Latest date",
    "db.calc.dateRange": "Date range",
    "db.calc.checked": "Checked",
    "db.calc.unchecked": "Unchecked",
    "db.calc.percentChecked": "Percent checked",
    "db.calc.percentUnchecked": "Percent unchecked",
    "db.calc.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.formula.edit": "Edit formula",
    "db.formula.placeholder": "Type a property, a cell (C7), a range (C2:C10) or a function",
    "db.formula.properties": "Properties",
    "db.formula.functions": "Functions",
    "db.formula.format": "Format",
    "db.formula.format.auto": "Automatic",
    "db.formula.format.number": "Number",
    "db.formula.format.percent": "Percent",
    "db.formula.format.currency": "Currency",
    "db.formula.format.date": "Date",
    "db.formula.preview": [{"type":0,"value":"Row "},{"type":1,"value":"row"}],
    "db.formula.empty": "Empty",
    "db.formula.searchFunctions": "Search functions",
    "db.formula.examples": "Examples",
    "db.formula.done": "Done",
    "db.formula.cancel": "Cancel",
    "db.formula.column": [{"type":1,"value":"name"},{"type":0,"value":" · column "},{"type":1,"value":"letter"}],
    "db.formula.noFunctions": "No matching functions",
    "db.formula.offline": "Preview unavailable",
    "db.formula.hint": "Type prop(\"Name\"), a cell (C7), a range (C2:C10) or a function",
    "db.formula.fn.if": "Returns one value if a condition is true and another if it is false.",
    "db.formula.fn.ifs": "Checks conditions in order and returns the value of the first true one.",
    "db.formula.fn.and": "TRUE when every argument is true.",
    "db.formula.fn.or": "TRUE when any argument is true.",
    "db.formula.fn.not": "Reverses a logical value.",
    "db.formula.fn.sum": "Adds numbers, cells or ranges. Text and empty cells are skipped.",
    "db.formula.fn.average": "The average of numbers, ignoring text and empty cells.",
    "db.formula.fn.min": "The smallest number.",
    "db.formula.fn.max": "The largest number.",
    "db.formula.fn.round": "Rounds a number to a number of decimal places.",
    "db.formula.fn.abs": "The absolute value of a number.",
    "db.formula.fn.count": "Counts the numeric values.",
    "db.formula.fn.counta": "Counts the values that aren't empty.",
    "db.formula.fn.concat": "Joins two values as text.",
    "db.formula.fn.textjoin": "Joins text with a delimiter, optionally skipping empty values.",
    "db.formula.fn.left": "The first characters of a text.",
    "db.formula.fn.right": "The last characters of a text.",
    "db.formula.fn.mid": "Characters from the middle of a text.",
    "db.formula.fn.len": "The number of characters in a text.",
    "db.formula.fn.upper": "Converts text to uppercase.",
    "db.formula.fn.lower": "Converts text to lowercase.",
    "db.formula.fn.trim": "Removes extra spaces from text.",
    "db.formula.fn.substitute": "Replaces occurrences of a text with another.",
    "db.formula.fn.text": "Formats a number or date as text with a pattern.",
    "db.formula.fn.today": "Today's date (workspace time zone).",
    "db.formula.fn.now": "The current date and time.",
    "db.formula.fn.date": "A date from a year, month and day.",
    "db.formula.fn.edate": "A date a number of months before or after another.",
    "db.formula.fn.datedif": "The difference between two dates in days, months or years.",
    "db.formula.fn.year": "The year of a date.",
    "db.formula.fn.month": "The month of a date (1–12).",
    "db.formula.fn.day": "The day of the month of a date.",
    "db.formula.fn.switch": "Compares a value with cases and returns the matching result.",
    "db.formula.fn.iferror": "Returns a fallback when a value is an error.",
    "db.formula.fn.isblank": "TRUE when a value is empty.",
    "db.formula.fn.xlookup": "Finds a value in a range and returns the matching item of another.",
    "db.formula.fn.sumif": "Adds the cells of a range that meet a condition.",
    "db.formula.fn.countif": "Counts the cells of a range that meet a condition.",
    "db.formula.fn.median": "The middle number of a set.",
    "db.rollup.relation": "Relation",
    "db.rollup.property": "Property",
    "db.rollup.calculate": "Calculate",
    "db.rollup.showOriginal": "Show original",
    "db.rollup.noRelation": "Add a relation first",
    "db.view.showRowNumbers": "Show row numbers",
    "db.statusGroup.todo": "To-do",
    "db.statusGroup.inProgress": "In progress",
    "db.statusGroup.complete": "Complete",
    "db.status.notStarted": "Not started",
    "db.status.inProgress": "In progress",
    "db.status.done": "Done",
    "db.color.default": "Default",
    "db.color.gray": "Gray",
    "db.color.brown": "Brown",
    "db.color.orange": "Orange",
    "db.color.yellow": "Yellow",
    "db.color.green": "Green",
    "db.color.blue": "Blue",
    "db.color.purple": "Purple",
    "db.color.pink": "Pink",
    "db.color.red": "Red",
    "db.option.search": "Search or create an option",
    "db.option.create": [{"type":0,"value":"Create “"},{"type":1,"value":"name"},{"type":0,"value":"”"}],
    "db.option.delete": "Delete option",
    "db.option.color": "Color",
    "db.person.search": "Search for a person",
    "db.relation.search": "Search pages",
    "db.relation.empty": "No pages",
    "db.relation.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" page"}]},"other":{"value":[{"type":7},{"type":0,"value":" pages"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.files.comingSoon": "File uploads arrive soon.",
    "db.files.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" file"}]},"other":{"value":[{"type":7},{"type":0,"value":" files"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.date.end": "End date",
    "db.date.clear": "Clear",
    "db.value.empty": "Empty",
    "db.row.open": "Open",
    "db.row.openAsPage": "Open as page",
    "db.row.peek": "Open in side peek",
    "db.row.delete": "Delete",
    "db.row.pending": "Waiting to sync",
    "db.pending": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" change waiting to sync"}]},"other":{"value":[{"type":7},{"type":0,"value":" changes waiting to sync"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.empty.title": "No pages yet",
    "db.empty.body": "Select New to add the first one.",
    "db.empty.filtered": "No results",
    "db.error.title": "Couldn't load this database",
    "db.error.notFound": "This database doesn't exist or you don't have access to it.",
    "db.calendar.prev": "Previous month",
    "db.calendar.next": "Next month",
    "db.calendar.today": "Today",
    "db.calendar.more": [{"type":1,"value":"count"},{"type":0,"value":" more"}],
    "db.calendar.by": "Show calendar by",
    "db.calendar.noDate": "Add a date property to use the calendar.",
    "db.calendar.undated": "No date",
    "db.calendar.newOn": [{"type":0,"value":"New on "},{"type":1,"value":"date"}],
    "db.board.noGroup": "Choose a select, status or person property to group the board by.",
    "db.board.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" card"}]},"other":{"value":[{"type":7},{"type":0,"value":" cards"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.icon.change": "Change icon",
    "db.title.placeholder": "Untitled database",
    "docs.section.favorites": "Favorites",
    "docs.section.workspace": "Workspace",
    "docs.section.private": "Private",
    "docs.newPage": "New page",
    "docs.addPage": "Add a page",
    "docs.template.page": "Page",
    "docs.template.database": "Database",
    "docs.template.projects": "Projects",
    "docs.template.meetingNotes": "Meeting notes",
    "docs.template.wiki": "Wiki",
    "docs.menu.newSubpage": "New subpage",
    "docs.menu.rename": "Rename",
    "docs.menu.addFavorite": "Add to favorites",
    "docs.menu.removeFavorite": "Remove from favorites",
    "docs.menu.trash": "Move to trash",
    "docs.menu.more": "More actions",
    "docs.menu.moveToPrivate": "Move to Private",
    "docs.menu.moveToWorkspace": "Move to Workspace",
    "docs.row.expand": "Expand",
    "docs.row.collapse": "Collapse",
    "docs.rename.title": "Rename page",
    "docs.rename.placeholder": "Page title",
    "docs.empty": "No pages yet",
    "docs.trashed": "Moved to trash.",
    "docs.undo": "Undo",
    "docs.createFailed": "Couldn't create the page. Check your connection and try again.",
    "page.untitled": "Untitled",
    "page.titlePlaceholder": "Untitled",
    "page.notFound.title": "Page not found",
    "page.notFound.body": "This page doesn't exist, was moved to trash, or you don't have access to it.",
    "page.offlineUnavailable": "This page hasn't been opened on this device yet. Connect to load it.",
    "page.addIcon": "Add icon",
    "page.changeIcon": "Change icon",
    "page.removeIcon": "Remove icon",
    "page.sync.offline": "Offline · changes are kept on this device",
    "page.sync.connecting": "Connecting…",
    "page.sync.saving": "Saving…",
    "page.sync.saved": "Saved",
    "page.readOnly": "View only",
    "page.presence": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" other person here"}]},"other":{"value":[{"type":7},{"type":0,"value":" other people here"}]}},"offset":0,"pluralType":"cardinal"}],
    "page.edited": [{"type":0,"value":"Edited "},{"type":1,"value":"time"}],
    "editor.placeholder": "Type '/' for commands",
    "editor.placeholder.heading1": "Heading 1",
    "editor.placeholder.heading2": "Heading 2",
    "editor.placeholder.heading3": "Heading 3",
    "editor.placeholder.list": "List",
    "editor.placeholder.todo": "To-do",
    "editor.placeholder.toggle": "Toggle",
    "editor.placeholder.quote": "Empty quote",
    "editor.placeholder.callout": "Write a callout",
    "editor.placeholder.code": "Code",
    "editor.block.paragraph": "Text",
    "editor.block.heading1": "Heading 1",
    "editor.block.heading2": "Heading 2",
    "editor.block.heading3": "Heading 3",
    "editor.block.bulleted": "Bulleted list",
    "editor.block.numbered": "Numbered list",
    "editor.block.todo": "To-do list",
    "editor.block.toggle": "Toggle list",
    "editor.block.quote": "Quote",
    "editor.block.callout": "Callout",
    "editor.block.code": "Code",
    "editor.block.divider": "Divider",
    "editor.block.image": "Image",
    "editor.block.file": "File",
    "editor.block.childPage": "Page",
    "editor.block.linkToPage": "Link to page",
    "editor.block.childDatabase": "Project board",
    "editor.slash.title": "Blocks",
    "editor.slash.empty": "No results",
    "editor.turnInto": "Turn into",
    "editor.blockActions": "Block actions",
    "editor.addBelow": "Add a block below",
    "editor.toggle.open": "Open toggle",
    "editor.toggle.close": "Close toggle",
    "editor.toggle.empty": "Empty toggle. Click to add a block inside.",
    "editor.todo.check": "Mark as done",
    "editor.image.empty": "Add an image",
    "editor.file.empty": "Add a file",
    "editor.upload.comingSoon": "Uploads in pages arrive soon.",
    "editor.linkToPage.choose": "Choose a page to link",
    "editor.linkToPage.search": "Search pages",
    "editor.missingPage": "Page unavailable",
    "editor.link.placeholder": "Paste or type a link",
    "editor.link.apply": "Apply",
    "editor.link.remove": "Remove link",
    "editor.link.title": "Link",
    "editor.mention.people": "People",
    "editor.mention.pages": "Pages",
    "editor.mention.dates": "Dates",
    "editor.mention.today": "Today",
    "editor.mention.tomorrow": "Tomorrow",
    "editor.mention.empty": "No one or nothing matches",
    "editor.selection": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" block selected"}]},"other":{"value":[{"type":7},{"type":0,"value":" blocks selected"}]}},"offset":0,"pluralType":"cardinal"}],
    "editor.format.bold": "Bold",
    "editor.format.italic": "Italic",
    "editor.format.strike": "Strikethrough",
    "editor.format.code": "Inline code",
    "editor.format.link": "Link",
    "projects.title": "Projects",
    "projects.subtitle": "Project boards and other databases in this workspace.",
    "projects.new": "New project board",
    "projects.empty.title": "No project boards yet",
    "projects.empty.body": "Create a board to track projects and tasks with your team.",
    "projects.open": "Open",
    "home.recentDocs": "Recent docs",
    "shell.omnibox.pages": "Pages",
    "consent.analytics.title": "Usage analytics",
    "consent.analytics.message": "May Bundle use Google Analytics and Microsoft Clarity to see which screens and features are used, including replays with all text hidden? Never your messages, names or email. Nothing is collected and no analytics cookies are set unless you allow it. You can change this later in your profile menu.",
    "consent.analytics.messageSettings": "May Bundle use Google Analytics and Microsoft Clarity to see which screens and features are used, including replays with all text hidden? Never your messages, names or email. Nothing is collected and no analytics cookies are set unless you allow it. You can change this later in Settings → Preferences.",
    "consent.analytics.messageApp": "May Bundle use Google Analytics and Microsoft Clarity to see which screens and features are used, including replays with all text hidden? Never your messages, names or email. Nothing is collected unless you allow it. You can change this later in Settings.",
    "consent.analytics.accept": "Allow",
    "consent.analytics.decline": "Don't allow",
    "profile.analytics": "Usage analytics",
    "profile.notifications.enable": "Enable notifications",
    "profile.notifications.on": "Notifications on",
    "profile.notifications.enabling": "Enabling notifications…",
    "profile.notifications.retry": "Couldn't enable notifications. Try again",
    "profile.notifications.blocked": "Notifications are blocked in your browser settings",
    "notifications.offer.title": "Turn on desktop notifications",
    "notifications.offer.body": "Get notified about DMs and mentions, even when Bundle is in the background.",
    "notifications.offer.enable": "Turn on",
    "notifications.offer.dismiss": "Not now",
    "notifications.enabled.title": "Notifications are on",
    "notifications.enabled.body": "Bundle will notify you about DMs and mentions.",
    "notifications.web.offBody": "Turn on notifications so you don't miss calls and messages when this tab is in the background.",
    "notifications.web.turnOn": "Turn on",
    "notifications.web.blockedBody": "Notifications are blocked for Bundle in this browser. To get calls and messages while this tab is in the background, click the lock icon in the address bar and allow notifications.",
    "notifications.blocked.title.macos": "macOS is blocking Bundle's notifications.",
    "notifications.blocked.title.windows": "Windows is blocking Bundle's notifications.",
    "notifications.blocked.body": "You won't see meeting invites or messages while Bundle is in the background.",
    "notifications.blocked.open.macos": "Open System Settings",
    "notifications.blocked.open.windows": "Open Settings",
    "notifications.blocked.dismiss": "Dismiss for a week",
    "notifications.quiet.title": "Bundle's notifications are set to None.",
    "notifications.quiet.body": "They only go to Notification Center. Change them to Banners or Alerts in System Settings.",
    "settings.notifications.bannersOff": "Banners off",
    "settings.notifications.quietHelp": "Bundle's notifications are set to None. Change them to Banners or Alerts in System Settings. While a Focus is on, banners stay hidden too.",
    "settings.notifications.focusHelp": "Not seeing banners? While a Focus is on, macOS hides them until it ends.",
    "settings.notifications.os.macos": "Mac notifications",
    "settings.notifications.os.windows": "Windows notifications",
    "settings.notifications.offInOs.macos": "Off in macOS",
    "settings.notifications.offInOs.windows": "Off in Windows",
    "settings.notifications.osHelp.macos": "Turn on Allow notifications for Bundle, and choose Alerts so calls stay on screen.",
    "settings.notifications.osHelp.windows": "Turn on notifications for Bundle in Settings › System › Notifications.",
    "settings.notifications.test": "Send a test notification",
    "settings.notifications.test.body": "Check that banners reach you while Bundle is in the background.",
    "settings.notifications.test.button": "Test",
    "notifications.test.title": "Notifications are working",
    "notifications.test.body": "This is how Bundle tells you about calls and messages.",
    "notifications.ring.tabTitle": [{"type":1,"value":"name"},{"type":0,"value":" is calling you…"}],
    "files.drop.title": [{"type":0,"value":"Drop files to share in #"},{"type":1,"value":"channel"}],
    "files.drop.titleDm": [{"type":0,"value":"Drop files to share with "},{"type":1,"value":"name"}],
    "files.drop.titleThread": "Drop files to share in this thread",
    "files.drop.subtitle": [{"type":0,"value":"Up to "},{"type":1,"value":"max"},{"type":0,"value":" files, 1 GB each"}],
    "files.attach.remove": [{"type":0,"value":"Remove "},{"type":1,"value":"name"}],
    "files.attach.tooMany": [{"type":0,"value":"You can attach up to "},{"type":1,"value":"max"},{"type":0,"value":" files to a message"}],
    "files.attach.tooBig": [{"type":1,"value":"name"},{"type":0,"value":" is larger than 1 GB"}],
    "files.attach.duplicate": [{"type":1,"value":"name"},{"type":0,"value":" is already attached"}],
    "files.upload.queued": "Waiting to upload",
    "files.upload.progress": [{"type":0,"value":"Uploading… "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "files.upload.failed": "Upload failed",
    "files.upload.retry": "Retry upload",
    "files.upload.done": "Uploaded",
    "message.uploading": [{"type":0,"value":"Uploading files… "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "files.download": "Download",
    "files.copyLink": "Copy link",
    "files.linkCopied": "Link copied",
    "files.details": "View file details",
    "files.more": [{"type":0,"value":"+"},{"type":1,"value":"count"}],
    "files.play": [{"type":0,"value":"Play "},{"type":1,"value":"name"}],
    "files.open": [{"type":0,"value":"Open "},{"type":1,"value":"name"}],
    "files.viewer.prev": "Previous",
    "files.viewer.next": "Next",
    "files.viewer.counter": [{"type":1,"value":"index"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "files.viewer.zoomIn": "Zoom in",
    "files.viewer.zoomOut": "Zoom out",
    "files.viewer.fit": "Fit to width",
    "files.noPreview": "No preview available",
    "files.reason.pending": "This file is still uploading",
    "files.reason.notInChannel": [{"type":0,"value":"You're not a member of #"},{"type":1,"value":"channel"},{"type":0,"value":": ask to join"}],
    "files.reason.notInChannelJoin": [{"type":0,"value":"You're not a member of #"},{"type":1,"value":"channel"},{"type":0,"value":": join it to get access"}],
    "files.reason.notInConversation": "You're not in this conversation",
    "files.reason.guestNoDownload": "Your guest access doesn't allow downloads",
    "files.reason.agentNoDownload": "This agent's access doesn't allow downloads",
    "files.reason.previewBlocked": "This type of file can't be previewed. Download it to open it.",
    "files.reason.expired": "Your access to this workspace has expired",
    "files.page.title": "File",
    "files.page.size": "Size",
    "files.page.type": "Type",
    "files.page.sharedBy": "Shared by",
    "files.page.when": "When",
    "files.page.where": "Shared in",
    "files.page.whereDm": [{"type":0,"value":"Conversation with "},{"type":1,"value":"names"}],
    "files.page.wherePage": [{"type":0,"value":"Page "},{"type":1,"value":"title"}],
    "files.page.notShared": "Not shared yet",
    "files.page.access": "Who can access",
    "files.page.you": "What you can do",
    "files.page.view": "View",
    "files.page.allowed": "Allowed",
    "files.page.join": [{"type":0,"value":"Join #"},{"type":1,"value":"channel"}],
    "files.page.openConversation": "Open conversation",
    "files.page.notFound.title": "File not found",
    "files.page.notFound.body": "It may have been deleted, or it wasn't shared with you.",
    "files.page.signIn.title": "Sign in to view this file",
    "files.page.signIn.body": "Files in Bundle are visible only to the people they were shared with.",
    "files.audience.publicChannel": [{"type":0,"value":"Everyone in the workspace can open #"},{"type":1,"value":"channel"}],
    "files.audience.privateChannel": [{"type":0,"value":"Only members of #"},{"type":1,"value":"channel"}],
    "files.audience.dm": [{"type":0,"value":"Only the people in this conversation: "},{"type":1,"value":"names"}],
    "files.audience.page": [{"type":0,"value":"People who can see the page "},{"type":1,"value":"title"}],
    "files.audience.onlyYou": "Only you, until you share it",
    "files.audience.guests": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" guest can view and download it"}]},"other":{"value":[{"type":7},{"type":0,"value":" guests can view and download it"}]}},"offset":0,"pluralType":"cardinal"}],
    "files.audience.guestsNoDownload": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" guest can view images but not download"}]},"other":{"value":[{"type":7},{"type":0,"value":" guests can view images but not download"}]}},"offset":0,"pluralType":"cardinal"}],
    "files.audience.guestsMixed": [{"type":1,"value":"without"},{"type":0,"value":" of "},{"type":1,"value":"count"},{"type":0,"value":" guests can't download originals"}],
    "files.kind.image": "Image",
    "files.kind.video": "Video",
    "files.kind.audio": "Audio",
    "files.kind.pdf": "PDF",
    "files.kind.document": "Document",
    "files.kind.spreadsheet": "Spreadsheet",
    "files.kind.presentation": "Presentation",
    "files.kind.archive": "Archive",
    "files.kind.code": "Code",
    "files.kind.text": "Text",
    "files.kind.executable": "Program",
    "files.kind.other": "File",
    "files.audience.memberCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" member"}]},"other":{"value":[{"type":7},{"type":0,"value":" members"}]}},"offset":0,"pluralType":"cardinal"}],
    "files.page.whereChannel": [{"type":0,"value":"#"},{"type":1,"value":"channel"}],
    "files.audience.workspace": "Everyone in the workspace (sticker image)",
    "stickers.create.nameRequired": "Give the sticker a name",
    "stickers.create.nameTooLong": [{"type":0,"value":"Use at most "},{"type":1,"value":"max"},{"type":0,"value":" characters"}],
    "stickers.pack.nameRequired": "Give the pack a name",
    "stickers.pack.nameTooLong": [{"type":0,"value":"Use at most "},{"type":1,"value":"max"},{"type":0,"value":" characters"}],
    "stickers.create.badType": "Stickers can be PNG, JPEG, WebP or GIF images",
    "stickers.create.tooBig": [{"type":0,"value":"Animated stickers can be at most "},{"type":1,"value":"max"}],
    "stickers.create.tooLarge": [{"type":0,"value":"Animated stickers can be at most "},{"type":1,"value":"max"},{"type":0,"value":"×"},{"type":1,"value":"max"},{"type":0,"value":" pixels"}],
    "stickers.create.unreadable": "This image can't be read. Try another one.",
    "stickers.picker.results": "Results",
    "stickers.picker.recent": "Recently used",
    "stickers.notice.offline": "You're offline. Try again when you're back online.",
    "stickers.notice.failed": "Something went wrong. Try again.",
    "stickers.notice.forbidden": "You can't do that in this workspace.",
    "picker.title": "Emoji, stickers and GIFs",
    "picker.tab.emoji": "Emoji",
    "picker.tab.stickers": "Stickers",
    "picker.tab.gifs": "GIFs",
    "picker.emoji.search": "Search emoji",
    "picker.emoji.frequent": "Frequently used",
    "picker.emoji.skinTone": "Skin tone",
    "picker.stickers.search": "Search stickers",
    "picker.stickers.create": "Create sticker",
    "picker.stickers.add": "Add stickers",
    "picker.stickers.manage": "Manage stickers",
    "picker.stickers.empty": "No stickers yet",
    "picker.stickers.emptyBody": "Create one, or add packs from your workspace.",
    "picker.stickers.noResults": [{"type":0,"value":"No stickers match “"},{"type":1,"value":"query"},{"type":0,"value":"”"}],
    "picker.gifs.search": "Search KLIPY",
    "picker.gifs.poweredBy": "Powered by KLIPY",
    "picker.gifs.trending": "Trending",
    "picker.gifs.unavailable": "GIFs unavailable",
    "picker.gifs.unavailableBody": "GIF search isn't set up for this workspace.",
    "picker.gifs.empty": [{"type":0,"value":"No GIFs for “"},{"type":1,"value":"query"},{"type":0,"value":"”"}],
    "picker.gifs.error.network": "Can't reach KLIPY. Check your connection.",
    "picker.gifs.error.rateLimited": "Too many searches. Wait a moment and try again.",
    "picker.gifs.error.server": "GIF search failed.",
    "picker.gifs.loadingMore": "Loading more…",
    "message.sticker": [{"type":0,"value":"Sticker: "},{"type":1,"value":"name"}],
    "message.gif": [{"type":0,"value":"GIF: "},{"type":1,"value":"title"}],
    "message.gifVia": "via KLIPY",
    "message.openPack": "Open sticker pack",
    "message.edit": "Edit message",
    "message.editSave": "Save",
    "message.editCancel": "Cancel",
    "message.editHint": "Escape to cancel · Enter to save",
    "message.editEmpty": "A message can't be empty.",
    "message.delete": "Delete message",
    "message.deleteConfirm.title": "Delete message",
    "message.deleteConfirm.body": "Are you sure you want to delete this message? This can't be undone.",
    "message.deleteConfirm.others": [{"type":0,"value":"You're deleting a message by "},{"type":1,"value":"name"},{"type":0,"value":". It's deleted for everyone."}],
    "message.deleteConfirm.files": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Its attached file is deleted too."}]},"other":{"value":[{"type":0,"value":"Its "},{"type":7},{"type":0,"value":" attached files are deleted too."}]}},"offset":0,"pluralType":"cardinal"}],
    "message.deleteConfirm.replies": "Its replies stay: the thread keeps “This message was deleted.” in its place.",
    "message.deleteConfirm.confirm": "Delete",
    "message.deleteConfirm.cancel": "Cancel",
    "broadcast.confirm.title": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Notify "},{"type":7},{"type":0,"value":" person?"}]},"other":{"value":[{"type":0,"value":"Notify "},{"type":7},{"type":0,"value":" people?"}]}},"offset":0,"pluralType":"cardinal"}],
    "broadcast.confirm.channel": [{"type":1,"value":"range"},{"type":0,"value":" notifies everyone in this channel."}],
    "broadcast.confirm.here": "@here notifies everyone in this channel who is active right now.",
    "broadcast.confirm.zones": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"They're all in one time zone."}]},"other":{"value":[{"type":0,"value":"They're in "},{"type":7},{"type":0,"value":" time zones, so it may be outside working hours for some of them."}]}},"offset":0,"pluralType":"cardinal"}],
    "broadcast.confirm.send": "Send anyway",
    "files.saveAsSticker": "Save as sticker",
    "stickers.pack.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" sticker"}]},"other":{"value":[{"type":7},{"type":0,"value":" stickers"}]}},"offset":0,"pluralType":"cardinal"}],
    "stickers.pack.workspace": "Workspace pack",
    "stickers.pack.personal": [{"type":0,"value":"Personal pack by "},{"type":1,"value":"name"}],
    "stickers.pack.add": "Add to My stickers",
    "stickers.pack.added": "In My stickers",
    "stickers.pack.remove": "Remove from My stickers",
    "stickers.pack.delete": "Delete pack",
    "stickers.pack.makeWorkspace": "Make it a workspace pack",
    "stickers.pack.makePersonal": "Make it personal",
    "stickers.pack.addSticker": "Add a sticker",
    "stickers.pack.notFound": "This pack isn't available anymore.",
    "stickers.pack.empty": "No stickers in this pack yet.",
    "stickers.sticker.delete": "Delete sticker",
    "stickers.manage.title": "Stickers",
    "stickers.manage.mine": "My stickers",
    "stickers.manage.browse": "Packs in this workspace",
    "stickers.manage.moveUp": "Move up",
    "stickers.manage.moveDown": "Move down",
    "stickers.manage.add": "Add",
    "stickers.manage.remove": "Remove",
    "stickers.manage.open": [{"type":0,"value":"Open "},{"type":1,"value":"name"}],
    "stickers.manage.emptyMine": "No packs yet. Add some from the list below.",
    "stickers.manage.settings": "Workspace settings",
    "stickers.settings.creators": "Who can create stickers",
    "stickers.settings.creators.everyone": "Every member",
    "stickers.settings.creators.admins": "Admins only",
    "stickers.settings.gifsEnabled": "Allow GIFs (KLIPY)",
    "stickers.settings.rating": "GIF content filter",
    "stickers.settings.rating.high": "Strict (recommended)",
    "stickers.settings.rating.medium": "Moderate",
    "stickers.settings.rating.low": "Relaxed",
    "stickers.settings.rating.off": "Off",
    "stickers.settings.guests": "Guests and agents can send stickers and GIFs but can't create stickers.",
    "stickers.create.title": "Create sticker",
    "stickers.create.pick": "Choose an image",
    "stickers.create.pickHint": "PNG, JPEG, WebP or GIF — or paste an image here.",
    "stickers.create.pastePlaceholder": "Paste an image",
    "stickers.create.reading": "Reading the image…",
    "stickers.create.crop": "Drag and zoom to crop it square",
    "stickers.create.animatedNote": "Animated stickers are kept as they are (up to 1 MB).",
    "stickers.create.removeBackground": "Remove background",
    "stickers.create.name": "Name",
    "stickers.create.namePlaceholder": "e.g. party parrot",
    "stickers.create.keywords": "Keywords",
    "stickers.create.keywordsPlaceholder": "Words people might search for",
    "stickers.create.pack": "Pack",
    "stickers.create.newPack": "New pack",
    "stickers.create.newPackName": "New pack name",
    "stickers.create.newPackWorkspace": "Share the pack with the whole workspace",
    "stickers.create.save": "Save sticker",
    "stickers.create.saving": "Saving…",
    "stickers.create.notAllowed": "Only admins can create stickers in this workspace.",
    "stickers.create.change": "Choose another image",
    "files.page.whereSticker": "Shared as a sticker in this workspace",
    "settings.title": "Settings",
    "settings.about.speechCredit": "On-device speech recognition by Desert Ant Labs (Voz, Align).",
    "settings.comingSoon": "Settings are coming soon.",
    "roles.owner": "Owner",
    "roles.admin": "Admin",
    "roles.member": "Member",
    "roles.guest": "Guest",
    "roles.primaryOwner": "Primary owner",
    "roles.problem.forbidden": "Only owners and admins can manage people.",
    "roles.problem.ownersOnly": "Only owners can change owners and admins.",
    "roles.problem.primaryOwner": "Transfer primary ownership first.",
    "roles.problem.primaryOnly": "Only the primary owner can do this.",
    "roles.problem.lastOwner": "A workspace needs at least one owner.",
    "roles.problem.agent": "Agents keep their role. Edit their access instead.",
    "roles.problem.deactivated": "Reactivate this person first.",
    "roles.problem.unchanged": "Nothing to change.",
    "roles.problem.self": "You can't do this to yourself.",
    "roles.problem.ineligible": "Only an active member can become the primary owner.",
    "profile.error.displayNameRequired": "Enter a display name.",
    "profile.error.tooLong": [{"type":0,"value":"Use at most "},{"type":1,"value":"max"},{"type":0,"value":" characters."}],
    "profile.error.phone": "Enter a phone number with 6 to 15 digits.",
    "profile.error.timezone": "Pick a time zone from the list.",
    "profile.status.preset.meeting": "In a meeting",
    "profile.status.preset.commuting": "Commuting",
    "profile.status.preset.sick": "Out sick",
    "profile.status.preset.vacation": "Vacationing",
    "profile.status.preset.remote": "Working remotely",
    "profile.status.clear.never": "Don't clear",
    "profile.status.clear.halfHour": "30 minutes",
    "profile.status.clear.hour": "1 hour",
    "profile.status.clear.fourHours": "4 hours",
    "profile.status.clear.today": "Today",
    "profile.status.clear.week": "This week",
    "profile.time.ahead": [{"type":1,"value":"span"},{"type":0,"value":" ahead of you"}],
    "profile.time.behind": [{"type":1,"value":"span"},{"type":0,"value":" behind you"}],
    "settings.nav.profile": "Profile",
    "settings.nav.preferences": "Preferences",
    "settings.nav.notifications": "Notifications",
    "settings.nav.account": "Account",
    "settings.nav.workspace": "Workspace",
    "settings.nav.members": "Members",
    "settings.nav.invitations": "Invitations",
    "settings.nav.guests": "Guests & agents",
    "settings.nav.integrations": "Integrations",
    "settings.nav.security": "Security",
    "settings.nav.data": "Data",
    "settings.nav.stickers": "Stickers & GIFs",
    "settings.group.you": "You",
    "settings.group.workspace": "Workspace",
    "settings.menu.profile": "Profile & settings",
    "settings.menu.workspace": "Workspace settings",
    "settings.adminOnly": "Only workspace owners and admins can change these settings.",
    "settings.save": "Save changes",
    "settings.saving": "Saving…",
    "settings.saved": "Saved",
    "settings.unsaved": "Unsaved changes",
    "settings.discard": "Discard",
    "settings.failed": "Couldn't save. Try again.",
    "settings.offlineQueued": "You're offline. Your changes will save when you're back online.",
    "settings.offline": "You're offline. Try again when you're back online.",
    "settings.loadFailed": "Couldn't load these settings.",
    "settings.comingSoonBadge": "Coming soon",
    "settings.integrations.body": "Connect apps, incoming webhooks and slash commands.",
    "integrations.webhooks.title": "Incoming webhooks",
    "integrations.webhooks.body": "Post messages into a channel from other apps and scripts by sending JSON to a secret URL.",
    "integrations.webhooks.empty": "No webhooks yet.",
    "integrations.webhook.add": "Add webhook",
    "integrations.webhook.edit": "Edit webhook",
    "integrations.webhook.create": "Add",
    "integrations.webhook.name": "Name",
    "integrations.webhook.namePlaceholder": "For example: Deploy bot",
    "integrations.webhook.channel": "Posts to",
    "integrations.webhook.nameEmpty": "Give the webhook a name.",
    "integrations.webhook.nameTooLong": "Use 80 characters or fewer.",
    "integrations.webhook.pickChannel": "Pick a channel to post to.",
    "integrations.webhook.saveFailed": "Couldn’t save the webhook.",
    "integrations.webhook.failed": "Something went wrong. Try again.",
    "integrations.webhook.meta": [{"type":0,"value":"Posts to "},{"type":1,"value":"conversation"},{"type":0,"value":" · added by "},{"type":1,"value":"name"}],
    "integrations.webhook.hidden": "a channel you can’t see",
    "integrations.webhook.lastUsed": [{"type":0,"value":"last used "},{"type":1,"value":"when"}],
    "integrations.webhook.more": "More actions",
    "integrations.webhook.regenerate": "Regenerate URL",
    "integrations.webhook.remove": "Remove",
    "integrations.webhook.removeTitle": "Remove webhook?",
    "integrations.webhook.removeBody": [{"type":0,"value":"Apps using “"},{"type":1,"value":"name"},{"type":0,"value":"” won’t be able to post anymore."}],
    "integrations.webhook.urlTitle": "Webhook URL",
    "integrations.webhook.urlBody": "Copy this URL now — for your security it won’t be shown again. Anyone with it can post to the channel; regenerate it if it leaks.",
    "integrations.webhook.url": "URL",
    "integrations.webhook.copy": "Copy URL",
    "integrations.webhook.copied": "Copied",
    "integrations.webhook.done": "Done",
    "integrations.agents.title": "Agents",
    "integrations.agents.body": "AI agents connected to this workspace. Manage them in Members.",
    "integrations.agents.empty": "No agents connected.",
    "integrations.agent.hosted": "Runs in Bundle",
    "integrations.agent.external": "Connected with an agent token",
    "integrations.agent.sponsor": [{"type":0,"value":"Sponsored by "},{"type":1,"value":"name"}],
    "settings.security.body": "Single sign-on (SSO), required two-factor authentication and session length.",
    "settings.data.body": "Export workspace data and set retention policies.",
    "settings.stickers.body": "Who can create stickers, and the GIF content rating.",
    "settings.stickers.open": "Manage stickers",
    "settings.stickers.unavailable": "Stickers and GIFs aren't available here yet.",
    "settings.preferences.appearance": "Appearance",
    "settings.preferences.privacy": "Privacy",
    "settings.preferences.analytics.onByDefault": "On (you can turn this off)",
    "settings.preferences.analytics.body": "Let Bundle see which screens and features are used (Google Analytics, and Microsoft Clarity replays with all text hidden). Never your messages, names or email.",
    "settings.notifications.device": "Notifications on this device",
    "settings.notifications.unsupported": "This device can't show notifications from Bundle.",
    "settings.notifications.disable": "Turn off",
    "settings.notifications.sound": "Notification sound",
    "settings.notifications.sound.toggle": "Play a sound for new notifications",
    "settings.notifications.sound.body": "Rings for messages that notify you when you aren't looking at that conversation. Saved on this device.",
    "settings.notifications.sound.preview": "Play",
    "settings.notifyKinds.title": "Notify me about",
    "settings.notifyKinds.desc": [{"type":0,"value":"In "},{"type":1,"value":"workspace"},{"type":0,"value":", on all your devices. What you turn off still shows in Activity and unread counts."}],
    "settings.notifyKinds.footer": "A conversation with its own level keeps it. Change it in the conversation's settings.",
    "settings.notifyKinds.group.messages": "Messages",
    "settings.notifyKinds.group.calls": "Calls and reminders",
    "settings.notifyKinds.group.workspace": "Workspace",
    "settings.notifyKinds.dm": "Direct messages",
    "settings.notifyKinds.group": "Group messages",
    "settings.notifyKinds.mention": "Mentions of you",
    "settings.notifyKinds.mention.help": "Your name, or a group you're in.",
    "settings.notifyKinds.broadcast": "@channel, @here and @everyone",
    "settings.notifyKinds.thread": "Thread replies",
    "settings.notifyKinds.thread.help": "In threads you follow.",
    "settings.notifyKinds.channel": "Channel messages",
    "settings.notifyKinds.channel.help": "Every message in channels you've joined.",
    "settings.notifyKinds.huddle": "Meet",
    "settings.notifyKinds.huddle.help": "When someone calls you.",
    "settings.notifyKinds.eventInvite": "Event invitations",
    "settings.notifyKinds.eventReminder": "Event reminders",
    "settings.notifyKinds.eventReminder.help": "At the time set on each event. Emails you asked for still go.",
    "settings.notifyKinds.later": "Later reminders",
    "settings.notifyKinds.memberJoined": "New members",
    "settings.notifyKinds.memberJoined.help": "When someone joins through your email domain.",
    "settings.notifications.sound.knock": "Knock",
    "settings.notifications.sound.pop": "Pop",
    "settings.notifications.sound.chime": "Chime",
    "settings.notifications.sound.ding": "Ding",
    "settings.notifications.sound.pluck": "Pluck",
    "settings.notifications.dnd": "Pause notifications",
    "settings.notifications.dnd.body": "While paused there are no sounds, banners or pushes, on all your devices. Activity keeps collecting what you missed.",
    "settings.notifications.dnd.min30": "For 30 minutes",
    "settings.notifications.dnd.hour1": "For 1 hour",
    "settings.notifications.dnd.hour2": "For 2 hours",
    "settings.notifications.dnd.tomorrow": "Until tomorrow",
    "settings.notifications.dnd.custom": "Custom…",
    "settings.notifications.dnd.customLabel": "Pause until",
    "settings.notifications.dnd.customSave": "Pause",
    "settings.notifications.dnd.until": [{"type":0,"value":"Notifications are paused until "},{"type":1,"value":"time"}],
    "settings.notifications.dnd.resume": "Resume notifications",
    "settings.notifications.dnd.schedule": "Pause on a schedule",
    "settings.notifications.dnd.schedule.toggle": "Pause notifications every day during these hours",
    "settings.notifications.dnd.schedule.body": [{"type":0,"value":"Times are in "},{"type":1,"value":"zone"},{"type":0,"value":"."}],
    "settings.notifications.dnd.from": "From",
    "settings.notifications.dnd.to": "To",
    "settings.notifications.dnd.days": "On",
    "settings.notifications.dnd.day.sun": "Sun",
    "settings.notifications.dnd.day.mon": "Mon",
    "settings.notifications.dnd.day.tue": "Tue",
    "settings.notifications.dnd.day.wed": "Wed",
    "settings.notifications.dnd.day.thu": "Thu",
    "settings.notifications.dnd.day.fri": "Fri",
    "settings.notifications.dnd.day.sat": "Sat",
    "settings.notifications.dnd.failed": "Couldn't save your notification settings. Try again.",
    "dnd.paused": "Notifications paused",
    "profile.section.photo": "Photo",
    "profile.photo.upload": "Upload photo",
    "profile.photo.change": "Change photo",
    "profile.photo.remove": "Remove photo",
    "profile.photo.crop": "Drag and zoom to crop",
    "profile.photo.cropTitle": "Crop your photo",
    "profile.photo.use": "Use photo",
    "profile.photo.uploading": [{"type":0,"value":"Uploading… "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "profile.photo.hint": "A square image works best (at least 512 × 512 pixels).",
    "profile.photo.failed": "Couldn't upload the photo. Try again.",
    "profile.photo.unreadable": "That file isn't an image we can use.",
    "profile.section.about": "About you",
    "profile.displayName": "Display name",
    "profile.displayName.hint": "How you appear in messages and mentions.",
    "profile.fullName": "Full name",
    "profile.title": "Title",
    "profile.title.placeholder": "What you do",
    "profile.pronouns": "Pronouns (optional)",
    "profile.pronouns.placeholder": "e.g. she/her",
    "profile.phone": "Phone (optional)",
    "profile.phone.visible": "Show my phone number to this workspace",
    "profile.phone.privateHint": "Private: only you can see it.",
    "profile.phone.publicHint": "Members of this workspace can see it.",
    "profile.timezone": "Time zone",
    "profile.timezone.search": "Search time zones",
    "profile.timezone.useDevice": [{"type":0,"value":"Use this device's time zone ("},{"type":1,"value":"zone"},{"type":0,"value":")"}],
    "profile.timezone.none": "No time zones match.",
    "profile.timezone.localTime": [{"type":0,"value":"Local time there: "},{"type":1,"value":"time"}],
    "profile.language.hint": "Bundle, your emails and your notifications use this language.",
    "profile.section.status": "Status",
    "profile.status.placeholder": "What's your status?",
    "profile.status.emoji": "Choose an emoji",
    "profile.status.clearAfter": "Clear after",
    "profile.status.save": "Set status",
    "profile.status.clear": "Clear status",
    "profile.status.until": [{"type":0,"value":"Until "},{"type":1,"value":"time"}],
    "profile.status.saved": "Status updated",
    "status.until.time": [{"type":0,"value":"Until "},{"type":1,"value":"time"}],
    "status.until.tomorrow": "Until tomorrow",
    "status.until.weekday.sun": "Until Sunday",
    "status.until.weekday.mon": "Until Monday",
    "status.until.weekday.tue": "Until Tuesday",
    "status.until.weekday.wed": "Until Wednesday",
    "status.until.weekday.thu": "Until Thursday",
    "status.until.weekday.fri": "Until Friday",
    "status.until.weekday.sat": "Until Saturday",
    "status.until.month.jan": [{"type":0,"value":"Until Jan "},{"type":1,"value":"day"}],
    "status.until.month.feb": [{"type":0,"value":"Until Feb "},{"type":1,"value":"day"}],
    "status.until.month.mar": [{"type":0,"value":"Until Mar "},{"type":1,"value":"day"}],
    "status.until.month.apr": [{"type":0,"value":"Until Apr "},{"type":1,"value":"day"}],
    "status.until.month.may": [{"type":0,"value":"Until May "},{"type":1,"value":"day"}],
    "status.until.month.jun": [{"type":0,"value":"Until Jun "},{"type":1,"value":"day"}],
    "status.until.month.jul": [{"type":0,"value":"Until Jul "},{"type":1,"value":"day"}],
    "status.until.month.aug": [{"type":0,"value":"Until Aug "},{"type":1,"value":"day"}],
    "status.until.month.sep": [{"type":0,"value":"Until Sep "},{"type":1,"value":"day"}],
    "status.until.month.oct": [{"type":0,"value":"Until Oct "},{"type":1,"value":"day"}],
    "status.until.month.nov": [{"type":0,"value":"Until Nov "},{"type":1,"value":"day"}],
    "status.until.month.dec": [{"type":0,"value":"Until Dec "},{"type":1,"value":"day"}],
    "status.until.date": [{"type":0,"value":"Until "},{"type":1,"value":"date"}],
    "status.untilInline.time": [{"type":0,"value":"until "},{"type":1,"value":"time"}],
    "status.untilInline.tomorrow": "until tomorrow",
    "status.untilInline.weekday.sun": "until Sunday",
    "status.untilInline.weekday.mon": "until Monday",
    "status.untilInline.weekday.tue": "until Tuesday",
    "status.untilInline.weekday.wed": "until Wednesday",
    "status.untilInline.weekday.thu": "until Thursday",
    "status.untilInline.weekday.fri": "until Friday",
    "status.untilInline.weekday.sat": "until Saturday",
    "status.untilInline.month.jan": [{"type":0,"value":"until Jan "},{"type":1,"value":"day"}],
    "status.untilInline.month.feb": [{"type":0,"value":"until Feb "},{"type":1,"value":"day"}],
    "status.untilInline.month.mar": [{"type":0,"value":"until Mar "},{"type":1,"value":"day"}],
    "status.untilInline.month.apr": [{"type":0,"value":"until Apr "},{"type":1,"value":"day"}],
    "status.untilInline.month.may": [{"type":0,"value":"until May "},{"type":1,"value":"day"}],
    "status.untilInline.month.jun": [{"type":0,"value":"until Jun "},{"type":1,"value":"day"}],
    "status.untilInline.month.jul": [{"type":0,"value":"until Jul "},{"type":1,"value":"day"}],
    "status.untilInline.month.aug": [{"type":0,"value":"until Aug "},{"type":1,"value":"day"}],
    "status.untilInline.month.sep": [{"type":0,"value":"until Sep "},{"type":1,"value":"day"}],
    "status.untilInline.month.oct": [{"type":0,"value":"until Oct "},{"type":1,"value":"day"}],
    "status.untilInline.month.nov": [{"type":0,"value":"until Nov "},{"type":1,"value":"day"}],
    "status.untilInline.month.dec": [{"type":0,"value":"until Dec "},{"type":1,"value":"day"}],
    "status.untilInline.date": [{"type":0,"value":"until "},{"type":1,"value":"date"}],
    "status.a11y": [{"type":0,"value":"Status: "},{"type":1,"value":"text"}],
    "status.a11y.emojiOnly": "Status",
    "account.email": "Email",
    "account.email.hint": "You sign in with this address.",
    "account.methods": "Sign-in methods",
    "account.method.email": "Email code",
    "account.method.google": "Google",
    "account.method.apple": "Apple",
    "account.method.connected": "Connected",
    "account.method.notConnected": "Not connected",
    "account.method.googleHint": [{"type":0,"value":"Sign in with Google as "},{"type":1,"value":"email"},{"type":0,"value":" to connect it."}],
    "account.sessions": "Sessions",
    "account.sessions.current": "This device",
    "account.sessions.lastActive": [{"type":0,"value":"Last active "},{"type":1,"value":"time"}],
    "account.sessions.browser": "Web browser",
    "account.sessions.revokeOthers": "Sign out of other sessions",
    "account.sessions.revoked": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Signed out of "},{"type":7},{"type":0,"value":" session."}]},"other":{"value":[{"type":0,"value":"Signed out of "},{"type":7},{"type":0,"value":" sessions."}]}},"offset":0,"pluralType":"cardinal"}],
    "account.sessions.none": "No other sessions.",
    "account.sessions.moved": "See where you're signed in and sign out of other devices in Security.",
    "account.sessions.open": "Open Security",
    "security.sessions.title": "Where you're signed in",
    "security.sessions.body": "Browsers and Bundle apps signed in to your account. A session you sign out stops working within 15 minutes.",
    "security.sessions.app": [{"type":0,"value":"Bundle for "},{"type":1,"value":"os"}],
    "security.sessions.appUnknown": "Bundle app",
    "security.sessions.desktop": "Bundle desktop app",
    "security.sessions.browserOn": [{"type":1,"value":"browser"},{"type":0,"value":" on "},{"type":1,"value":"os"}],
    "security.sessions.unknown": "Unknown device",
    "security.sessions.signedIn": [{"type":0,"value":"Signed in "},{"type":1,"value":"time"}],
    "security.sessions.activity": [{"type":0,"value":"Last active "},{"type":1,"value":"active"},{"type":0,"value":" · Signed in "},{"type":1,"value":"signedIn"}],
    "security.sessions.signOut": "Sign out",
    "security.sessions.revokedOne": "Signed out of that session.",
    "security.sessions.confirmTitle": "Sign out of all other sessions?",
    "security.sessions.confirmBody": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" other session will be signed out. You stay signed in here."}]},"other":{"value":[{"type":7},{"type":0,"value":" other sessions will be signed out. You stay signed in here."}]}},"offset":0,"pluralType":"cardinal"}],
    "security.workspace.title": "Workspace security",
    "security.workspace.body": [{"type":0,"value":"How people get into "},{"type":1,"value":"name"},{"type":0,"value":". Only owners and admins see this."}],
    "security.workspace.invites": "Invitations",
    "security.workspace.invitesBody": "Members can invite people as members; owners and admins can also invite admins. Guests and agents can't invite anyone. Invites expire after 7 days.",
    "security.workspace.guests": "Guests",
    "security.workspace.guestsBody": "Guests only see the channels and pages shared with them, and their access can be set to expire.",
    "security.workspace.domains": "Joining by email domain",
    "security.workspace.domainsOff": "Off: people need an invite to join.",
    "security.workspace.domainsOn": [{"type":0,"value":"On: anyone with a verified address at "},{"type":1,"value":"domains"},{"type":0,"value":" can join as a member without an invite."}],
    "security.workspace.manage": "Manage on the Workspace page",
    "appPasswords.title": "App passwords",
    "appPasswords.body": [{"type":0,"value":"Mail, calendar and contacts apps sign in to "},{"type":1,"value":"name"},{"type":0,"value":" with an app password, not your Bundle sign-in. Use one per device or app: revoking one signs out only that device."}],
    "appPasswords.add": "Add device",
    "appPasswords.add.profile": "iPhone, iPad or Mac",
    "appPasswords.add.profileHelp": "A profile that sets up Mail, Calendar and Contacts",
    "appPasswords.add.mail": "Mail app",
    "appPasswords.add.mailHelp": "Outlook, Thunderbird, Spark and others",
    "appPasswords.add.calendar": "Calendar or contacts app",
    "appPasswords.add.calendarHelp": "Apple Calendar, DAVx⁵, Thunderbird and others",
    "appPasswords.name.titleProfile": "Set up an iPhone, iPad or Mac",
    "appPasswords.name.titleMail": "Add a mail app",
    "appPasswords.name.titleCalendar": "Add a calendar or contacts app",
    "appPasswords.name.body": "Give it a name you'll recognize when you want to sign it out.",
    "appPasswords.name.label": "Device or app",
    "appPasswords.name.helper": "For example “Mac — Spark” or “Ana's iPhone”. Only you see it.",
    "appPasswords.name.defaultProfile": "iPhone or Mac",
    "appPasswords.name.defaultMail": "Mail app",
    "appPasswords.name.defaultCalendar": "Calendar app",
    "appPasswords.create": "Create password",
    "appPasswords.made.title": [{"type":0,"value":"App password for "},{"type":1,"value":"name"}],
    "appPasswords.made.password": "Password",
    "appPasswords.made.once": "Shown once. Copy it into the app now.",
    "appPasswords.made.user": "User name",
    "appPasswords.made.userCaption": "Your mailbox address",
    "appPasswords.made.servers": "Servers",
    "appPasswords.made.serversCaption": "Most apps find these themselves from your address",
    "appPasswords.done": "Done",
    "appPasswords.unnamed": "App password",
    "appPasswords.unnamedNote": "Made before passwords had names",
    "appPasswords.created": [{"type":0,"value":"Created "},{"type":1,"value":"time"}],
    "appPasswords.lastUsed": [{"type":0,"value":"Last used "},{"type":1,"value":"time"}],
    "appPasswords.neverUsed": "Never used",
    "appPasswords.stale": "Not used in 3 months",
    "appPasswords.revoke": "Revoke",
    "appPasswords.revokeAll": "Revoke all",
    "appPasswords.footer": "Lost a device? Revoke its password here; it signs out within a few minutes.",
    "appPasswords.confirmOneTitle": [{"type":0,"value":"Revoke “"},{"type":1,"value":"name"},{"type":0,"value":"”?"}],
    "appPasswords.confirmOneTitleUnnamed": "Revoke this app password?",
    "appPasswords.confirmOneBody": "The app using it signs out within a few minutes and asks for a password. Your other devices keep working.",
    "appPasswords.confirmAllTitle": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Revoke "},{"type":7},{"type":0,"value":" app password?"}]},"other":{"value":[{"type":0,"value":"Revoke all "},{"type":7},{"type":0,"value":" app passwords?"}]}},"offset":0,"pluralType":"cardinal"}],
    "appPasswords.confirmAllBody": [{"type":0,"value":"Every mail, calendar and contacts app signed in to "},{"type":1,"value":"name"},{"type":0,"value":" signs out. Each device then needs a new app password. Bundle on the web and in its apps isn't affected."}],
    "appPasswords.revokedOne": [{"type":0,"value":"Revoked “"},{"type":1,"value":"name"},{"type":0,"value":"”. It signs out within a few minutes."}],
    "appPasswords.revokedUnnamed": "Revoked that app password. It signs out within a few minutes.",
    "appPasswords.revokedAll": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Revoked "},{"type":7},{"type":0,"value":" app password."}]},"other":{"value":[{"type":0,"value":"Revoked "},{"type":7},{"type":0,"value":" app passwords."}]}},"offset":0,"pluralType":"cardinal"}],
    "appPasswords.profileDownloaded": "Profile downloaded. Open it on the iPhone or Mac to install.",
    "appPasswords.empty.title": "No devices use an app password",
    "appPasswords.empty.body": "Add one to read your mail, calendar and contacts in iPhone Mail, Apple Calendar, Outlook, Spark or Thunderbird.",
    "appPasswords.limit": [{"type":0,"value":"You have "},{"type":1,"value":"count"},{"type":0,"value":" app passwords, the most allowed here. Revoke ones you no longer use to add another."}],
    "appPasswords.nearLimit": [{"type":0,"value":"You have "},{"type":1,"value":"count"},{"type":0,"value":" of "},{"type":1,"value":"limit"},{"type":0,"value":" app passwords. Revoke ones you no longer use."}],
    "appPasswords.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" device has an app password."}]},"other":{"value":[{"type":7},{"type":0,"value":" devices have an app password."}]}},"offset":0,"pluralType":"cardinal"}],
    "appPasswords.manage": "Manage app passwords",
    "mail.apps.deviceName": "Device name",
    "mail.apps.appName": "App name",
    "mail.apps.profileNote": "One profile per device: setting up a phone doesn't sign your Mac out.",
    "data.export.title": "Export your data",
    "data.export.body": "A .zip file with your profile, the messages you wrote, the list of files you uploaded and the pages you created, from every workspace you're in, as JSON and Markdown.",
    "data.export.action": "Export my data",
    "data.export.readyTitle": "Your export is ready",
    "data.export.readyMeta": [{"type":0,"value":"Created "},{"type":1,"value":"time"},{"type":0,"value":" · "},{"type":1,"value":"size"}],
    "data.export.download": "Download",
    "data.export.refreshLink": "Get a new link",
    "data.export.nextAt": [{"type":0,"value":"You can request another export after "},{"type":1,"value":"time"},{"type":0,"value":"."}],
    "data.export.kept": "Exports are kept for a day. The download link works for an hour; come back here for a new one.",
    "data.export.ready": "Your export is ready to download.",
    "data.export.tooSoon": "You can request one export every 10 minutes.",
    "data.export.failed": "Couldn't create the export. Try again.",
    "data.workspace.title": [{"type":0,"value":"Export "},{"type":1,"value":"name"}],
    "data.workspace.body": "Members, public channels and their messages as JSON, and pages shared with the whole workspace as Markdown. Private channels, direct messages and private pages are not included.",
    "data.workspace.action": "Export workspace",
    "data.delete.body": "To delete your account and remove your profile from every workspace, go to Account.",
    "data.delete.action": "Go to Account",
    "account.delete.title": "Delete account",
    "account.delete.body": "Deleting your account removes your profile from every workspace and signs you out everywhere. Your messages and pages stay, shown as a deleted user. This can't be undone.",
    "account.delete.action": "Delete my account",
    "account.delete.blocked": "Transfer ownership of these workspaces first:",
    "account.delete.blockedPrimary": [{"type":1,"value":"name"},{"type":0,"value":": you're the primary owner"}],
    "account.delete.blockedLast": [{"type":1,"value":"name"},{"type":0,"value":": you're the only owner"}],
    "account.delete.confirmTitle": "Delete your account?",
    "account.delete.typeEmail": [{"type":0,"value":"Type "},{"type":1,"value":"email"},{"type":0,"value":" to confirm"}],
    "account.delete.confirm": "Delete account",
    "account.delete.failed": "Couldn't delete your account. Try again.",
    "account.delete.mismatch": "That doesn't match your email address.",
    "account.delete.ownership": "Transfer ownership of your workspaces first.",
    "signInMethods.title": "Sign-in methods",
    "signInMethods.body": "Ways you can sign in to this account. Keep at least one.",
    "signInMethods.apple": "Apple",
    "signInMethods.google": "Google",
    "signInMethods.email": "Email code",
    "signInMethods.privateRelay": "Hide My Email address from Apple",
    "signInMethods.noEmail": "No email shared",
    "signInMethods.onlyMethod": "Your only way to sign in",
    "signInMethods.remove": "Remove",
    "signInMethods.remove.apple": "Remove Apple sign-in?",
    "signInMethods.remove.google": "Remove Google sign-in?",
    "signInMethods.remove.body": "You won't be able to sign in with it anymore. You can link it again later.",
    "signInMethods.removed.apple": "Apple sign-in was removed.",
    "signInMethods.removed.google": "Google sign-in was removed.",
    "signInMethods.linked.apple": "Apple is linked. You can now sign in with it.",
    "signInMethods.linked.google": "Google is linked. You can now sign in with it.",
    "signInMethods.addTitle": "Link another way to sign in",
    "signInMethods.addEmail": "Add email sign-in",
    "signInMethods.addEmail.body": "We'll email a 6-digit code to this address. Once verified, it becomes your account's email and you can sign in with codes sent to it.",
    "signInMethods.addEmail.send": "Send code",
    "signInMethods.addEmail.codeBody": [{"type":0,"value":"Enter the code we sent to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "signInMethods.addEmail.verify": "Verify",
    "signInMethods.emailAdded": [{"type":0,"value":"You can now sign in with codes sent to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "signInMethods.usePhoto": "Use Google photo",
    "signInMethods.photoUsed": "Your Google photo is now your profile photo.",
    "signInMethods.inBrowser": "You link and remove sign-in methods in your browser, the same way you signed in.",
    "signInMethods.manageInBrowser": "Manage in browser",
    "signInMethods.loadFailed": "Couldn't load your sign-in methods.",
    "signInMethods.error.otherAccount": "That account is already used by another Bundle account. Merging two accounts isn't supported: sign in with that one instead, or remove it there first.",
    "signInMethods.error.alreadyLinked": "That account is already linked here.",
    "signInMethods.error.lastMethod": "Keep at least one way to sign in.",
    "signInMethods.error.signInAgain": "For your security, sign out and sign in again, then try once more.",
    "signInMethods.error.emailInUse": "That email belongs to another Bundle account.",
    "signInMethods.error.cancelled": "Linking was cancelled.",
    "signInMethods.error.failed": "Something went wrong. Try again.",
    "auth.passkey.signIn": "Sign in with a passkey",
    "auth.password.use": "Use a password instead",
    "auth.password.title": "Enter your password",
    "auth.password.label": "Password",
    "auth.password.show": "Show password",
    "auth.password.hide": "Hide password",
    "auth.password.forgot": "Forgot password?",
    "auth.password.useCode": "Email me a code instead",
    "auth.error.wrongPassword": "That email and password don't match. Try again or reset your password.",
    "auth.error.locked": [{"type":0,"value":"Too many attempts. Try again in "},{"type":1,"value":"minutes"},{"type":0,"value":" minutes."}],
    "auth.password.lockedHint": "You can still sign in with a code from your email.",
    "auth.twoStep.title": "Two-step verification",
    "auth.twoStep.body": "Enter the 6-digit code from your authenticator app.",
    "auth.twoStep.codeLabel": "Authentication code",
    "auth.twoStep.digit": [{"type":0,"value":"Digit "},{"type":1,"value":"n"},{"type":0,"value":" of 6"}],
    "auth.twoStep.trust": "Trust this device for 30 days",
    "auth.twoStep.trustHint": "Leave this off on a shared device.",
    "auth.twoStep.submit": "Verify",
    "auth.twoStep.verifying": "Verifying…",
    "auth.twoStep.useBackup": "Use a backup code instead",
    "auth.twoStep.useApp": "Use your authenticator app instead",
    "auth.twoStep.backupTitle": "Enter a backup code",
    "auth.twoStep.backupBody": "Use one of the backup codes you saved when you turned on two-step verification. Each code works once.",
    "auth.twoStep.backupLabel": "Backup code",
    "auth.twoStep.lostAccess": "Can't use either? Ask a workspace admin to reset two-step verification.",
    "auth.error.twoStepCode": "That code isn't right. Check your authenticator app and try again.",
    "auth.error.backupCode": "That backup code isn't right or was already used.",
    "auth.reset.title": "Reset your password",
    "auth.reset.codeLabel": "Reset code",
    "auth.reset.back": "Back to sign in",
    "auth.reset.newTitle": "Choose a new password",
    "auth.reset.for": [{"type":0,"value":"For "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "auth.reset.newLabel": "New password",
    "auth.reset.hint.length": "At least 8 characters",
    "auth.reset.hint.common": "Not a common or leaked password",
    "auth.reset.hint.email": "Doesn't contain your email",
    "auth.reset.strength": [{"type":0,"value":"Strength: "},{"type":1,"value":"level"}],
    "auth.reset.strength.weak": "Weak",
    "auth.reset.strength.fair": "Fair",
    "auth.reset.strength.strong": "Strong",
    "auth.reset.signOutOthers": "Sign out of other devices",
    "auth.reset.signOutHint": "Recommended if someone else might know your old password.",
    "auth.reset.save": "Change password",
    "auth.reset.doneTitle": "Password changed",
    "auth.reset.doneBody": [{"type":0,"value":"You're signed in. We signed you out everywhere else and emailed "},{"type":1,"value":"email"},{"type":0,"value":" to let you know."}],
    "auth.reset.doneBodyKept": [{"type":0,"value":"You're signed in. We emailed "},{"type":1,"value":"email"},{"type":0,"value":" to let you know."}],
    "auth.reset.done": "Continue to Bundle",
    "auth.error.passwordShort": "Use at least 8 characters.",
    "auth.error.passwordCommon": "That password is too common. Choose another.",
    "auth.error.passwordEmail": "Don't use your email address in your password.",
    "auth.error.passwordLeaked": "That password showed up in a data breach. Choose another.",
    "auth.error.passwordLong": "Use 128 characters or fewer.",
    "auth.passkey.waiting": "Waiting for your passkey…",
    "auth.passkey.waitingBody": "Follow the prompt from your browser or device.",
    "auth.passkey.cancelledTitle": "Passkey sign-in didn't finish",
    "auth.error.passkeyCancelled": "The passkey prompt was closed. Try again or sign in another way.",
    "auth.passkey.notFoundTitle": "No passkey for Bundle here",
    "auth.signup.title": "Create your Bundle account",
    "auth.signup.name": "Full name",
    "auth.signup.email": "Work email",
    "auth.signup.have": "Already have an account?",
    "auth.signup.signIn": "Sign in",
    "auth.signup.newTo": "New to Bundle?",
    "auth.signup.create": "Create an account",
    "auth.signup.codeLabel": "Code",
    "auth.signup.codeSentTo": [{"type":0,"value":"We sent a 6-digit code to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "auth.signup.resend": "Resend code",
    "auth.signup.secureTitle": "Secure your account",
    "auth.signup.secureBody": "Optional. You can always sign in with an email code.",
    "auth.signup.addPasskey": "Add a passkey",
    "auth.signup.recommended": "Recommended",
    "auth.signup.passkeyBody": "Sign in with Face ID, Touch ID or your device PIN.",
    "auth.signup.setPassword": "Set a password",
    "auth.signup.passwordBody": "At least 8 characters.",
    "auth.signup.skip": "Skip for now",
    "auth.signup.existsTitle": "You already have an account",
    "auth.signup.existsBody": [{"type":1,"value":"email"},{"type":0,"value":" is already registered with Bundle."}],
    "auth.signup.signInInstead": "Sign in instead",
    "auth.error.passkeyNotFound": "Use a phone or security key that has one, or sign in another way. You can add a passkey in Settings after you sign in.",
    "security.emails.title": "Email addresses",
    "security.emails.add": "Add email",
    "security.emails.foot": "A new address gets a code before it can be used.",
    "security.emails.primary": "Primary",
    "security.emails.verified": "Verified",
    "security.emails.pending": "Waiting for code",
    "security.emails.primaryHint": "Sign-in and account emails go here",
    "security.emails.secondaryHint": "Can also sign in",
    "security.emails.makePrimary": "Make primary",
    "security.emails.enterCode": "Enter code",
    "security.emails.remove": "Remove",
    "security.emails.addBody": "We'll send a 6-digit code to the new address. Once it's verified, you can sign in with it.",
    "security.emails.removeConfirm": [{"type":0,"value":"Remove "},{"type":1,"value":"email"},{"type":0,"value":"?"}],
    "security.emails.removeBody": "You won't be able to sign in with this address anymore.",
    "security.password.title": "Password",
    "security.password.set": "Set password",
    "security.password.change": "Change password",
    "security.password.remove": "Remove password",
    "security.password.none": "Not set. You sign in with codes or another method.",
    "security.password.isSet": "Set",
    "security.password.current": "Current password",
    "security.password.removeBody": "Enter your password to remove it. You can still sign in other ways.",
    "security.passkeys.title": "Passkeys",
    "security.passkeys.body": "Sign in with Face ID or Touch ID",
    "security.passkeys.add": "Add passkey",
    "security.passkeys.rename": "Rename",
    "security.passkeys.delete": "Delete",
    "security.passkeys.unnamed": "Passkey",
    "security.passkeys.lastUsed": [{"type":0,"value":"Last used "},{"type":1,"value":"time"}],
    "security.passkeys.added": [{"type":0,"value":"Added "},{"type":1,"value":"time"},{"type":0,"value":", not used yet"}],
    "security.passkeys.deleteConfirm": "Delete this passkey?",
    "security.passkeys.deleteBody": "You won't be able to sign in with it anymore.",
    "security.passkeys.name": "Name",
    "security.passkeys.cancelled": "Adding the passkey was cancelled.",
    "security.twoStep.title": "Two-step verification",
    "security.twoStep.off": "Off",
    "security.twoStep.on": "On",
    "security.twoStep.app": "Authenticator app",
    "security.twoStep.turnOn": "Turn on",
    "security.twoStep.setupTitle": "Set up your authenticator app",
    "security.twoStep.setupBody": "Add Bundle to an authenticator app such as Passwords, 1Password or Google Authenticator, then enter the 6-digit code it shows.",
    "security.twoStep.openApp": "Open authenticator app",
    "security.twoStep.copyKey": "Copy setup key",
    "security.twoStep.keyCopied": "Setup key copied",
    "security.twoStep.key": "Setup key",
    "security.twoStep.backupTitle": "Save your backup codes",
    "security.twoStep.backupBody": "If you can't use your authenticator app, each code signs you in once. They won't be shown again.",
    "security.twoStep.copyCodes": "Copy codes",
    "security.twoStep.codesCopied": "Backup codes copied",
    "security.twoStep.shareCodes": "Share",
    "security.twoStep.done": "Done",
    "security.twoStep.remaining": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" backup code left"}]},"other":{"value":[{"type":7},{"type":0,"value":" backup codes left"}]}},"offset":0,"pluralType":"cardinal"}],
    "security.twoStep.regenerate": "Get new backup codes",
    "security.twoStep.regenerateBody": "Your old backup codes will stop working.",
    "security.twoStep.turnOff": "Turn off two-step verification",
    "security.twoStep.turnOffBody": "Signing in will only need your password, an email code or a linked account.",
    "security.stepUp.title": "Confirm it's you",
    "security.stepUp.passwordBody": "Enter your password to continue.",
    "security.stepUp.codeBody": [{"type":0,"value":"Enter the code we sent to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "security.stepUp.code": "Code",
    "security.sessions.activityAt": [{"type":1,"value":"city"},{"type":0,"value":" · Last active "},{"type":1,"value":"active"}],
    "security.error.wrongPassword": "That password isn't right.",
    "security.twoStep.turnedOn": "Two-step verification is on.",
    "security.emails.codeTitle": "Enter the code",
    "security.passkeys.unavailable": "Passkeys aren't available on this device right now.",
    "workspace.settings.general": "General",
    "workspace.settings.name": "Workspace name",
    "workspace.settings.nameRequired": "Enter a name.",
    "workspace.settings.slug": "URL",
    "workspace.settings.slugHint": "Lowercase letters, numbers and dashes.",
    "workspace.settings.slugWarning": [{"type":0,"value":"Links that use /"},{"type":1,"value":"slug"},{"type":0,"value":" stop working after you change it."}],
    "workspace.settings.slugInvalid": "Use up to 32 lowercase letters, numbers and single dashes.",
    "workspace.settings.slugReserved": "That address is reserved.",
    "workspace.settings.slugTaken": "That address is taken.",
    "workspace.settings.icon": "Icon",
    "workspace.settings.icon.upload": "Upload icon",
    "workspace.settings.icon.remove": "Remove icon",
    "workspace.settings.icon.cropTitle": "Crop the icon",
    "workspace.settings.defaultLanguage": "Default language",
    "workspace.settings.defaultLanguageHint": "For new members and for emails to people who haven't picked a language.",
    "workspace.settings.primaryOwnerHint": [{"type":1,"value":"name"},{"type":0,"value":" is the primary owner. Transfer primary ownership from the Members list."}],
    "workspace.settings.domains": "Join by email domain",
    "workspace.settings.domainsHint": "Anyone with a verified email address on these domains can join as a member, without an invite.",
    "workspace.settings.domainsEmpty": "No domains yet: people need an invite to join.",
    "workspace.settings.domainsReadOnly": "Only owners and admins can change this.",
    "workspace.settings.domainLabel": "Domain",
    "workspace.settings.domainPlaceholder": "company.com",
    "workspace.settings.domainAdd": "Add domain",
    "workspace.settings.domainRemove": [{"type":0,"value":"Remove "},{"type":1,"value":"domain"}],
    "workspace.settings.domainInvalid": "Enter a domain name, like company.com.",
    "workspace.settings.domainPublic": [{"type":1,"value":"domain"},{"type":0,"value":" is a public email provider: anyone can get an address there."}],
    "workspace.settings.domainDuplicate": "That domain is already on the list.",
    "workspace.settings.domainLimit": [{"type":0,"value":"A workspace can allow up to "},{"type":1,"value":"count"},{"type":0,"value":" domains."}],
    "workspace.settings.danger": "Danger zone",
    "workspace.settings.delete": "Delete workspace",
    "workspace.settings.deleteBody": "Only the primary owner can delete the workspace. Coming soon.",
    "members.search": "Search people",
    "members.filter.all": "All",
    "members.filter.active": "Active",
    "members.filter.invited": "Pending",
    "members.filter.deactivated": "Deactivated",
    "members.filter.admins": "Owners & admins",
    "members.filter.guests": "Guests",
    "members.filter.agents": "Agents",
    "members.kind.human": "Person",
    "members.kind.agent": "Agent",
    "members.status.active": "Active",
    "members.status.deactivated": "Deactivated",
    "members.status.invited": "Invite pending",
    "members.you": "(you)",
    "members.empty": "No one matches.",
    "members.actions": [{"type":0,"value":"Actions for "},{"type":1,"value":"name"}],
    "members.role.change": [{"type":0,"value":"Role for "},{"type":1,"value":"name"}],
    "members.action.deactivate": "Deactivate",
    "members.action.reactivate": "Reactivate",
    "members.action.editScope": "Edit access",
    "members.action.transfer": "Make primary owner",
    "members.action.revoke": "Revoke invite",
    "members.action.resend": "Resend invite",
    "members.confirm.go": "Confirm",
    "members.confirm.deactivate.title": [{"type":0,"value":"Deactivate "},{"type":1,"value":"name"},{"type":0,"value":"?"}],
    "members.confirm.deactivate.body": "They're signed out of this workspace and can't come back until reactivated. Their messages and pages stay.",
    "members.confirm.role.title": [{"type":0,"value":"Change "},{"type":1,"value":"name"},{"type":0,"value":"'s role to "},{"type":1,"value":"role"},{"type":0,"value":"?"}],
    "members.confirm.role.owner": "Owners manage everyone, including other owners, and every workspace setting.",
    "members.confirm.role.clearsRestriction": [{"type":1,"value":"name"},{"type":0,"value":" will see every public channel and the whole directory: their guest restrictions are removed."}],
    "members.confirm.transfer.title": [{"type":0,"value":"Make "},{"type":1,"value":"name"},{"type":0,"value":" the primary owner?"}],
    "members.confirm.transfer.body": "They become an owner and the only one who can transfer primary ownership or delete the workspace. You stay an owner.",
    "members.confirm.revoke.title": [{"type":0,"value":"Revoke the invite for "},{"type":1,"value":"email"},{"type":0,"value":"?"}],
    "members.confirm.revokeLink.title": "Revoke this invite link?",
    "members.confirm.revoke.body": "It stops working right away.",
    "members.notice.deactivated": [{"type":1,"value":"name"},{"type":0,"value":" was deactivated."}],
    "members.notice.reactivated": [{"type":1,"value":"name"},{"type":0,"value":" was reactivated."}],
    "members.notice.transferred": [{"type":1,"value":"name"},{"type":0,"value":" is now the primary owner."}],
    "members.notice.scopeSaved": [{"type":0,"value":"Access updated for "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "members.notice.revoked": "Invite revoked.",
    "members.notice.resent": "Invite sent again.",
    "members.notice.newLink": "A new invite link was created.",
    "members.notice.failed": "That didn't work. Try again.",
    "members.sponsor": [{"type":0,"value":"Sponsor: "},{"type":1,"value":"name"}],
    "members.accessEnds": [{"type":0,"value":"Access ends "},{"type":1,"value":"date"}],
    "members.accessEnded": "Access ended",
    "members.noEnd": "No end date",
    "invites.pending": "Pending invites",
    "invites.none": "No pending invites.",
    "invites.link": "Invite link",
    "invites.uses": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Used once"}]},"other":{"value":[{"type":0,"value":"Used "},{"type":7},{"type":0,"value":" times"}]}},"offset":0,"pluralType":"cardinal"}],
    "invites.expires": [{"type":0,"value":"Expires "},{"type":1,"value":"date"}],
    "invites.onlyYours": "You see the invites you created.",
    "guests.title": "Guests",
    "guests.none": "No guests.",
    "guests.agentsNone": "No agents.",
    "scope.title": [{"type":0,"value":"Access for "},{"type":1,"value":"name"}],
    "scope.makeGuestTitle": [{"type":0,"value":"Make "},{"type":1,"value":"name"},{"type":0,"value":" a guest"}],
    "scope.makeGuestBody": "Guests see only the channels they're in and the people they share them with.",
    "scope.sponsor": "Sponsor",
    "scope.organization": "Organization (optional)",
    "scope.expiry": "Access ends",
    "scope.expiry.keep": [{"type":0,"value":"Keep ("},{"type":1,"value":"date"},{"type":0,"value":")"}],
    "scope.expiry.never": "Never",
    "scope.expiry.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"In "},{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":0,"value":"In "},{"type":7},{"type":0,"value":" days"}]}},"offset":0,"pluralType":"cardinal"}],
    "scope.can": "Allowed to",
    "scope.can.createChannels": "Create channels",
    "scope.can.invite": "Invite people",
    "scope.can.search": "Search",
    "scope.can.downloadFiles": "Download files",
    "scope.can.joinHuddles": "Join meetings",
    "scope.can.mentionBroadcast": "Use @here and @channel",
    "scope.can.seeEmails": "See email addresses",
    "scope.dm": "Direct messages with",
    "scope.dm.anyone": "Anyone",
    "scope.dm.sharedChannels": "People in shared channels",
    "scope.dm.sponsorOnly": "The sponsor only",
    "scope.dm.none": "No one",
    "scope.directory": "Can see",
    "scope.directory.all": "Everyone in the directory",
    "scope.directory.shared": "People in shared channels",
    "scope.save": "Save access",
    "scope.makeGuest": "Make guest",
    "profileCard.message": "Message",
    "profileCard.localTime": [{"type":1,"value":"time"},{"type":0,"value":" local time"}],
    "profileCard.editProfile": "Edit profile",
    "profileCard.title": [{"type":0,"value":"Profile of "},{"type":1,"value":"name"}],
    "members.notice.nowOwner": [{"type":1,"value":"name"},{"type":0,"value":" is now an owner."}],
    "members.notice.nowAdmin": [{"type":1,"value":"name"},{"type":0,"value":" is now an admin."}],
    "members.notice.nowMember": [{"type":1,"value":"name"},{"type":0,"value":" is now a member."}],
    "members.notice.nowGuest": [{"type":1,"value":"name"},{"type":0,"value":" is now a guest."}],
    "handle.problem.tooShort": "Use at least 2 characters.",
    "handle.problem.tooLong": "Use at most 32 characters.",
    "handle.problem.characters": "Use lowercase letters, numbers, dots, dashes and underscores.",
    "handle.problem.edges": "Start and end with a letter or number.",
    "handle.problem.reserved": "That username is reserved.",
    "handle.problem.taken": "That username is taken.",
    "profile.handle": "Username",
    "profile.handle.hint": [{"type":0,"value":"People can mention you as @"},{"type":1,"value":"handle"},{"type":0,"value":"."}],
    "profile.handle.checking": "Checking…",
    "profile.handle.available": [{"type":0,"value":"@"},{"type":1,"value":"handle"},{"type":0,"value":" is available."}],
    "profile.handle.try": "Try:",
    "profile.avatar.change": "Change avatar",
    "profile.avatar.title": "Avatar",
    "profile.avatar.photo": "Photo",
    "profile.avatar.initials": "Initials",
    "profile.avatar.emoji": "Emoji",
    "profile.avatar.color": "Colour",
    "profile.avatar.colorOption": [{"type":0,"value":"Colour "},{"type":1,"value":"n"}],
    "profile.avatar.pickEmoji": "Pick an emoji",
    "profile.avatar.use": "Use this avatar",
    "profile.avatar.saved": "Avatar updated",
    "profile.copyLink": "Copy profile link",
    "profile.linkCopied": "Profile link copied",
    "sharing.share": "Share",
    "sharing.dialog.title": "Share",
    "sharing.level.full": "Full access",
    "sharing.level.edit": "Can edit",
    "sharing.level.comment": "Can comment",
    "sharing.level.view": "Can view",
    "sharing.level.full.description": "Edit, share and publish",
    "sharing.level.edit.description": "Edit content and invite others to edit or view",
    "sharing.level.comment.description": "View for now; comments are coming soon",
    "sharing.level.view.description": "Read only",
    "sharing.general.title": "General access",
    "sharing.general.invitedOnly": "Only people invited",
    "sharing.general.everyone": [{"type":0,"value":"Everyone at "},{"type":1,"value":"workspace"}],
    "sharing.general.noAccess": "No access",
    "sharing.general.invitedOnly.description": "Only the people listed above can open this page",
    "sharing.general.everyone.description": [{"type":0,"value":"Anyone in "},{"type":1,"value":"workspace"},{"type":0,"value":" can find and open this page"}],
    "sharing.general.privateShared": "Stays in its owner's Private section. Everyone else finds it under “Shared with me”.",
    "sharing.source.owner": "Workspace owner",
    "sharing.source.admin": "Workspace admin",
    "sharing.source.creator": "Page owner",
    "sharing.source.inherited": [{"type":0,"value":"Inherited from "},{"type":1,"value":"page"}],
    "sharing.source.inheritedUntitled": "Inherited from an untitled page",
    "sharing.publish.off": "Publishing to the web is turned off for this workspace",
    "sharing.publish.adminsOnly": "Only admins can publish to the web in this workspace",
    "sharing.indicator.public": "Published",
    "sharing.indicator.workspace": "Workspace",
    "sharing.indicator.private": "Private",
    "sharing.indicator.sharedWith": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Shared with "},{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":0,"value":"Shared with "},{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "sharing.expiry.never": "Never expires",
    "sharing.expiry.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Expires in "},{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":0,"value":"Expires in "},{"type":7},{"type":0,"value":" days"}]}},"offset":0,"pluralType":"cardinal"}],
    "sharing.expiry.on": [{"type":0,"value":"Expires "},{"type":1,"value":"date"}],
    "sharing.invite.placeholder": "Add people, agents or emails",
    "sharing.invite.button": "Invite",
    "sharing.invite.asGuest": "Invite as guest",
    "sharing.invite.guestNote": [{"type":1,"value":"email"},{"type":0,"value":" isn't in this workspace. They'll join as a guest who can only see this page and its subpages."}],
    "sharing.invite.guestExpiry": "Guest access",
    "sharing.invite.hasAccess": "Has access",
    "sharing.invite.noMatches": "No one matches. Type an email to invite a guest.",
    "sharing.invite.sent": "Invited",
    "sharing.invite.guestLink": "Guest invite link copied",
    "sharing.people.title": "People with access",
    "sharing.people.you": [{"type":1,"value":"name"},{"type":0,"value":" (you)"}],
    "sharing.people.guest": "Guest",
    "sharing.people.agent": "Agent",
    "sharing.people.remove": "Remove",
    "sharing.people.change": [{"type":0,"value":"Change access for "},{"type":1,"value":"name"}],
    "sharing.comment.note": "Comments are coming soon: people with comment access can view the page for now.",
    "sharing.publish.title": "Publish to web",
    "sharing.publish.description": "Anyone with the link can view this page. They can't see comments, other pages or people.",
    "sharing.publish.toggle": "Publish to web",
    "sharing.publish.link": "Public link",
    "sharing.publish.copy": "Copy public link",
    "sharing.publish.open": "Open public page",
    "sharing.publish.indexing": "Allow search engines",
    "sharing.publish.duplicate": "Allow duplicate as template",
    "sharing.publish.subpages": "Include subpages",
    "sharing.publish.expiry": "Link expiry",
    "sharing.publish.revokeNote": "Turning publishing off revokes this link for good.",
    "sharing.publish.needsFull": "You need full access to publish this page",
    "sharing.copyLink": "Copy link",
    "sharing.copied": "Link copied",
    "sharing.error.lastFullAccess": "Someone has to keep full access to this page.",
    "sharing.error.generic": "Couldn't update sharing. Check your connection and try again.",
    "sharing.error.alreadyMember": "That person is already in this workspace.",
    "sharing.loading": "Loading sharing…",
    "sharing.settings.title": "Sharing",
    "sharing.settings.description": "Who can publish pages and files outside the workspace.",
    "sharing.settings.publicPages": "Publish pages to the web",
    "sharing.settings.publicFiles": "Public file links",
    "sharing.settings.editorsCanShare": "People with edit access can invite others",
    "sharing.settings.policy.members": "Members",
    "sharing.settings.policy.admins": "Admins only",
    "sharing.settings.policy.off": "Off",
    "sharing.settings.offNote": "Off also stops every existing public link at once.",
    "sharing.settings.saved": "Sharing settings saved",
    "sharing.settings.publicFilesHint": "People can share files and folders with anyone who has the link. Guests never can.",
    "sharing.settings.filesOff.title": "Turn off public file links?",
    "sharing.settings.filesOff.body": "Every public file link stops working right away. They work again if you turn this back on.",
    "sharing.settings.filesOff.confirm": "Turn off",
    "sharing.settings.publicFilesActive": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" public link is active now."}]},"other":{"value":[{"type":7},{"type":0,"value":" public links are active now."}]}},"offset":0,"pluralType":"cardinal"}],
    "sharing.settings.filesOff.bodyCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" link stops working right away. It works again if you turn this back on."}]},"other":{"value":[{"type":7},{"type":0,"value":" links stop working right away. They work again if you turn this back on."}]}},"offset":0,"pluralType":"cardinal"}],
    "page.menu.more": "Page actions",
    "page.menu.copyLink": "Copy link",
    "page.menu.moveTo": "Move to…",
    "page.menu.lock": "Lock page",
    "page.menu.unlock": "Unlock page",
    "page.menu.export": "Export as Markdown",
    "page.menu.trash": "Move to trash",
    "page.favorite.add": "Add to favorites",
    "page.favorite.remove": "Remove from favorites",
    "page.locked": "Locked",
    "page.lockedNote": "This page is locked. Unlock it from the ··· menu to edit.",
    "page.moveTo.title": "Move to",
    "page.moveTo.search": "Search pages",
    "page.moveTo.workspace": "Workspace (top level)",
    "page.moveTo.private": "Private (top level)",
    "docs.section.shared": "Shared with me",
    "docs.badge.public": "Published to the web",
    "docs.badge.shared": "Shared with people",
    "docs.badge.restricted": "Only people invited",
    "publicPage.notFound.title": "This link doesn't work",
    "publicPage.notFound.body": "The page may have been unpublished, or the link expired.",
    "publicPage.footer": "Published with Bundle",
    "publicPage.duplicate": "Duplicate as template",
    "publicPage.duplicateNote": "Sign in to Bundle to duplicate this page into your workspace.",
    "publicPage.someone": "someone",
    "publicPage.unavailableBlock": "Not available on the public page",
    "publicPage.rateLimited": "Too many requests. Wait a minute and try again.",
    "publicDrive.signIn": "Sign in",
    "publicDrive.footer": "Shared with Bundle",
    "publicDrive.sharedBy": [{"type":0,"value":"Shared by "},{"type":1,"value":"owner"}],
    "publicDrive.itemCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" item"}]},"other":{"value":[{"type":7},{"type":0,"value":" items"}]}},"offset":0,"pluralType":"cardinal"}],
    "publicDrive.notFound.title": "This link isn't available",
    "publicDrive.notFound.body": "The owner may have stopped sharing it, or public links were turned off. If you have access, sign in.",
    "publicDrive.empty": "This folder is empty",
    "publicDrive.path": "Folder path",
    "publicDrive.openInBundle": "Open in Bundle",
    "publicDrive.signInNeeded": "Sign-in needed",
    "publicDrive.downloadName": [{"type":0,"value":"Download "},{"type":1,"value":"name"}],
    "publicDrive.back": "Back to the folder",
    "publicDrive.report.open": "Report abuse",
    "publicDrive.report.title": "Report abuse",
    "publicDrive.report.body": "Tell us what’s wrong with this file or folder. The workspace’s admins and Bundle review every report. You don’t need to sign in.",
    "publicDrive.report.reason": "What’s wrong?",
    "publicDrive.report.reasonPlaceholder": "Choose a reason",
    "publicDrive.report.reason.spam": "Spam",
    "publicDrive.report.reason.malware": "Malware",
    "publicDrive.report.reason.phishing": "Phishing",
    "publicDrive.report.reason.sexual": "Sexually explicit content",
    "publicDrive.report.reason.violence": "Violent or graphic content",
    "publicDrive.report.reason.hate": "Hate speech",
    "publicDrive.report.reason.harassment": "Harassment or bullying",
    "publicDrive.report.reason.copyright": "Copyright infringement",
    "publicDrive.report.reason.personalInfo": "Personal or confidential information",
    "publicDrive.report.reason.other": "Something else",
    "publicDrive.report.note": "Details (optional)",
    "publicDrive.report.notePlaceholder": "Anything that helps us review it",
    "publicDrive.report.submit": "Report",
    "publicDrive.report.sent": "Thanks for letting us know. We’ll review this link and act on it if it breaks the rules.",
    "publicDrive.report.done": "Done",
    "publicDrive.report.failed": "Couldn’t send the report. Try again.",
    "files.share": "Share",
    "files.share.title": "Share file",
    "files.share.to": "Share to a conversation",
    "files.share.pick": "Choose a channel or person",
    "files.share.message": "Add a message (optional)",
    "files.share.send": "Share",
    "files.share.sent": [{"type":0,"value":"Shared to "},{"type":1,"value":"name"}],
    "files.share.noDownload": "You can view this file but not download it, so you can't share it.",
    "files.share.publicLink": "Public link",
    "files.share.publicLink.description": "Anyone with the link can download this file.",
    "files.share.publicLink.create": "Create public link",
    "files.share.publicLink.revoke": "Revoke link",
    "files.share.publicLink.copy": "Copy public link",
    "files.share.publicLink.adminsOnly": "Only admins can create public file links in this workspace.",
    "files.share.publicLink.off": "Public file links are turned off for this workspace.",
    "files.share.access": "Who can access",
    "files.share.error": "Couldn't share the file. Check your connection and try again.",
    "files.access.anyone": "Anyone with the link",
    "files.access.anyoneHint": "Anyone on the internet with the link can view",
    "files.access.anyoneOff": "Your admin turned off public links",
    "files.access.anyoneAdmins": "Only admins can share with anyone with the link",
    "files.access.workspaceHint": "Anyone in this workspace with the link",
    "files.access.anyoneMembers": [{"type":1,"value":"workspace"},{"type":0,"value":" members who open the link get "},{"type":1,"value":"role"},{"type":0,"value":". Everyone else can only view and download."}],
    "files.openWith": "Open with…",
    "files.opening": [{"type":0,"value":"Opening “"},{"type":1,"value":"name"},{"type":0,"value":"”…"}],
    "files.noApp": [{"type":0,"value":"No app on this device can open “"},{"type":1,"value":"name"},{"type":0,"value":"”. Download it instead."}],
    "templates.title": "Templates",
    "templates.open": "Templates…",
    "templates.browse": "Browse templates",
    "templates.newFromTemplate": "New from template",
    "templates.search": "Search templates",
    "templates.filter.all": "All templates",
    "templates.filter.saved": "Saved",
    "templates.category.projects": "Projects & work",
    "templates.category.meetings": "Team & meetings",
    "templates.category.knowledge": "Knowledge",
    "templates.category.personal": "Personal",
    "templates.category.business": "Business",
    "templates.section.saved": "Saved templates",
    "templates.results": "Results",
    "templates.empty": [{"type":0,"value":"No templates match “"},{"type":1,"value":"query"},{"type":0,"value":"”."}],
    "templates.use": "Use template",
    "templates.destination": "Add to",
    "templates.destination.workspace": "Workspace",
    "templates.destination.private": "Private",
    "templates.destination.inside": [{"type":0,"value":"Inside “"},{"type":1,"value":"title"},{"type":0,"value":"”"}],
    "templates.startEmpty": "Start empty",
    "templates.startEmpty.hint": "Leave the sample rows out.",
    "templates.scope.builtin": "Built-in",
    "templates.scope.workspace": "Workspace template",
    "templates.scope.personal": "Only you",
    "templates.preview.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" sample row"}]},"other":{"value":[{"type":7},{"type":0,"value":" sample rows"}]}},"offset":0,"pluralType":"cardinal"}],
    "templates.preview.views": "Views",
    "templates.preview.properties": "Properties",
    "templates.preview.rowTemplates": "Row templates",
    "templates.preview.creates": "Creates",
    "templates.preview.none": "Select a template to preview it.",
    "templates.edit": "Edit template",
    "templates.rename": "Rename",
    "templates.delete": "Delete template",
    "templates.delete.confirm": [{"type":0,"value":"Delete “"},{"type":1,"value":"name"},{"type":0,"value":"”? Pages already made from it stay."}],
    "templates.loadFailed": "Couldn't load templates. Check your connection and try again.",
    "templates.useFailed": "Couldn't create the page from this template. Check your connection and try again.",
    "templates.save.title": "Save as template",
    "templates.save.name": "Name",
    "templates.save.description": "Description",
    "templates.save.category": "Category",
    "templates.save.scope": "Who can use it",
    "templates.save.scope.workspace": "Everyone in the workspace",
    "templates.save.scope.personal": "Only me",
    "templates.save.includeRows": "Include database rows",
    "templates.save.submit": "Save template",
    "templates.save.saved": [{"type":0,"value":"Saved “"},{"type":1,"value":"name"},{"type":0,"value":"” to your templates."}],
    "templates.save.failed": "Couldn't save the template. Check your connection and try again.",
    "templates.save.workspaceAdminsOnly": "Only admins can save workspace templates here.",
    "templates.settings.creators": "Who can save workspace templates",
    "templates.settings.admins": "Admins only",
    "templates.settings.members": "All members",
    "templates.editing.banner": [{"type":0,"value":"You're editing the template “"},{"type":1,"value":"name"},{"type":0,"value":"”. Changes apply to pages made from it from now on."}],
    "templates.editing.rowBanner": [{"type":0,"value":"You're editing the row template “"},{"type":1,"value":"name"},{"type":0,"value":"”. New rows made from it start like this."}],
    "templates.editing.readOnly": "Only its creator and admins can edit this template.",
    "templates.editing.done": "Done",
    "templates.duplicate": "Duplicate",
    "templates.duplicateFailed": "Couldn't duplicate. Check your connection and try again.",
    "templates.saveAs": "Save as template…",
    "templates.rowTemplates.menu": "Row templates",
    "templates.rowTemplates.newOptions": "New row from a template",
    "templates.rowTemplates.empty": "Empty row",
    "templates.rowTemplates.new": "New template",
    "templates.rowTemplates.fromRow": "Save row as template",
    "templates.rowTemplates.default": "Default",
    "templates.rowTemplates.setDefault": "Use for New",
    "templates.rowTemplates.clearDefault": "Stop using for New",
    "templates.rowTemplates.edit": "Edit",
    "templates.rowTemplates.delete": "Delete",
    "templates.rowTemplates.untitled": "Untitled template",
    "templates.rowTemplates.newName": "New template",
    "templates.rowTemplates.defaults": "Default values",
    "templates.rowTemplates.defaults.hint": "New rows made from this template start with these values.",
    "templates.rowTemplates.name": "Template name",
    "templates.rowTemplates.clear": "Clear",
    "templates.rowTemplates.failed": "Couldn't change the row templates. Check your connection and try again.",
    "legal.agreement": [{"type":0,"value":"By continuing, you agree to Bundle's "},{"type":1,"value":"terms"},{"type":0,"value":" and "},{"type":1,"value":"privacy"},{"type":0,"value":"."}],
    "legal.terms": "Terms of Service",
    "legal.privacy": "Privacy Policy",
    "legal.title": "Legal",
    "summary.title": "Summary",
    "summary.aiLabel": "AI-generated",
    "summary.updated.justNow": "updated just now",
    "summary.updated.minutes": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"updated "},{"type":7},{"type":0,"value":" min ago"}]},"other":{"value":[{"type":0,"value":"updated "},{"type":7},{"type":0,"value":" min ago"}]}},"offset":0,"pluralType":"cardinal"}],
    "summary.updated.hours": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"updated "},{"type":7},{"type":0,"value":" hour ago"}]},"other":{"value":[{"type":0,"value":"updated "},{"type":7},{"type":0,"value":" hours ago"}]}},"offset":0,"pluralType":"cardinal"}],
    "summary.updated.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"updated "},{"type":7},{"type":0,"value":" day ago"}]},"other":{"value":[{"type":0,"value":"updated "},{"type":7},{"type":0,"value":" days ago"}]}},"offset":0,"pluralType":"cardinal"}],
    "summary.empty": "Get a quick TL;DR of this thread.",
    "summary.summarize": "Summarize",
    "summary.refresh": "Refresh summary",
    "summary.loading": "Summarizing…",
    "summary.failed": "Couldn't summarize this thread. Try again in a moment.",
    "summary.stale": "New replies since this summary",
    "summary.collapse": "Hide summary",
    "summary.expand": "Show summary",
    "workspace.settings.aiSummaries": "AI thread summaries",
    "workspace.settings.aiSummariesHint": "Show a short AI-written TL;DR at the top of threads. To write it, the thread's messages are sent to our AI model provider; they are not used to train models. Turning this off also deletes the summaries already written.",
    "workspace.settings.unfurls": "Show link previews",
    "workspace.settings.unfurlsHint": "Show a preview (title, description and image) under messages with links. To make one, Bundle fetches the page. Turning this off also removes the previews already shown.",
    "workspace.settings.mailSentWith": "Members can add “Sent with Bundle” to their emails",
    "workspace.settings.mailSentWithHint": [{"type":0,"value":"Turn off to leave it out of every message from "},{"type":1,"value":"workspace"},{"type":0,"value":". Members then see the option off and can’t change it."}],
    "settings.nav.import": "Import",
    "import.title": "Import from Slack or Notion",
    "import.body": "Bring your Slack conversations or your Notion pages and databases into this workspace. Nothing is changed in Slack or Notion.",
    "import.source": "Import from",
    "import.via": "How",
    "import.via.file": "Export file",
    "import.via.token": "Connect with a token",
    "import.slack.file.step1": "In Slack, open Workspace settings → Import/Export data → Export.",
    "import.slack.file.step2": "Pick the date range (\"Entire history\" for everything) and start the export; Slack emails you when the .zip is ready.",
    "import.slack.file.step3": "Drop the .zip here. Free and Pro plans export public channels only; connect with a token to bring private channels and DMs too.",
    "import.slack.token.step1": "Create the \"Bundle import\" app in your Slack workspace with the button below (its permissions are read-only).",
    "import.slack.token.step2": "Install it to the workspace, then copy the User OAuth Token (starts with xoxp-).",
    "import.slack.token.step3": "Paste it here. Everything you can see in Slack comes over: channels, private channels and DMs, with their threads and files.",
    "import.notion.file.step1": "In Notion, open Settings → General → Export all workspace content.",
    "import.notion.file.step2": "Choose \"Markdown & CSV\", include subpages and files, and export.",
    "import.notion.file.step3": "Drop the .zip here. AI proposes how to sort the pages; you review it before anything is imported.",
    "import.notion.token.step1": "Create an internal integration in Notion with \"Read content\" (button below).",
    "import.notion.token.step2": "In Notion, share the pages to import with it (••• → Connections → your integration).",
    "import.notion.token.step3": "Paste its secret here. Databases keep their property types this way.",
    "import.slack.token.createApp": "Create the Slack app",
    "import.notion.token.open": "Open Notion integrations",
    "import.slack.token.label": "Slack user token",
    "import.notion.token.label": "Notion integration secret",
    "import.token.kept": "Kept only while the import runs, then deleted.",
    "import.connect": "Connect",
    "import.drop.slack": "Drop the Slack export (.zip) or choose it",
    "import.drop.notion": "Drop the Notion export (.zip) or choose it",
    "import.drop.hint": "Up to 1 GB",
    "import.uploading": [{"type":0,"value":"Uploading "},{"type":1,"value":"name"},{"type":0,"value":"…"}],
    "import.uploadProgress": "Upload progress",
    "import.cancel": "Cancel",
    "import.recent": "Recent imports",
    "import.recent.empty": "No imports yet.",
    "import.open": "Open",
    "import.status.scanning": "Reading",
    "import.status.review": "Waiting for review",
    "import.status.importing": "Importing",
    "import.status.done": "Imported",
    "import.status.failed": "Failed",
    "import.status.cancelled": "Cancelled",
    "import.phase.reading": "Reading the export…",
    "import.phase.sorting": "Sorting the pages with AI…",
    "import.phase.listing": "Listing files…",
    "import.phase.channels": "Creating channels…",
    "import.phase.messages": "Importing messages…",
    "import.phase.files": "Copying files…",
    "import.phase.pages": "Importing pages…",
    "import.phase.finishing": "Finishing…",
    "import.job.slack": [{"type":0,"value":"Slack: "},{"type":1,"value":"label"}],
    "import.job.notion": [{"type":0,"value":"Notion: "},{"type":1,"value":"label"}],
    "import.back": "Back",
    "import.stop": "Stop import",
    "import.running.note": "You can leave this page: the import keeps going on the server.",
    "import.discard": "Discard",
    "import.start": "Import",
    "import.done.title": "Import finished",
    "import.done.body": "Imported history comes in as read and notified nobody.",
    "import.failed.title": "The import stopped",
    "import.failed.body": "Something went wrong. Try again, or start a new import.",
    "import.cancelled": "This import was stopped. What was already imported stays.",
    "import.openPages": "Open the imported pages",
    "import.result.channels": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" channel"}]},"other":{"value":[{"type":7},{"type":0,"value":" channels"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.messages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" message"}]},"other":{"value":[{"type":7},{"type":0,"value":" messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.files": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" file"}]},"other":{"value":[{"type":7},{"type":0,"value":" files"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.pages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" page"}]},"other":{"value":[{"type":7},{"type":0,"value":" pages"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.databases": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" database"}]},"other":{"value":[{"type":7},{"type":0,"value":" databases"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" row"}]},"other":{"value":[{"type":7},{"type":0,"value":" rows"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.skipped": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" item skipped"}]},"other":{"value":[{"type":7},{"type":0,"value":" items skipped"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.trash.button": "Move to trash",
    "import.trash.title": [{"type":0,"value":"Move "},{"type":1,"value":"what"},{"type":0,"value":" to the trash?"}],
    "import.trash.and": [{"type":1,"value":"first"},{"type":0,"value":" and "},{"type":1,"value":"second"}],
    "import.trash.body": [{"type":0,"value":"Everything this import created that is still here: rows ("},{"type":1,"value":"rows"},{"type":0,"value":") and attached files ("},{"type":1,"value":"files"},{"type":0,"value":") go with it. You can restore it from Trash."}],
    "import.trash.kept": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" item someone else edited stays"}]},"other":{"value":[{"type":7},{"type":0,"value":" items someone else edited stay"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.trash.nothing": "Nothing this import created is left to move to the trash.",
    "import.trash.failed": "Couldn't move the import to the trash. Try again.",
    "import.delete.button": "Delete permanently",
    "import.delete.title": [{"type":0,"value":"Delete "},{"type":1,"value":"what"},{"type":0,"value":" permanently?"}],
    "import.delete.body": [{"type":0,"value":"This can't be undone. Everything this import created that is in the trash goes for good: rows ("},{"type":1,"value":"rows"},{"type":0,"value":"), attached files ("},{"type":1,"value":"files"},{"type":0,"value":"), page contents and search entries."}],
    "import.delete.nothing": "Nothing this import created is in the trash. Move it to the trash first.",
    "import.delete.failed": "Couldn't delete the import permanently. Try again.",
    "import.source.googleDrive": "Google Drive",
    "import.source.googleDriveHint": "Everyone's My Drive and your shared drives, into Files",
    "import.drive.title": "Import from Google Drive",
    "import.drive.heading": [{"type":0,"value":"Google Drive · "},{"type":1,"value":"domain"}],
    "import.drive.managersOnly": "Only workspace owners and admins can import from Google Drive.",
    "import.drive.noGoogle": "Connect Google Workspace first (Settings → Mail → Import mail).",
    "import.drive.connect.title": "Connect Google Workspace first",
    "import.drive.connect.body": "Google Drive comes over through the same Google Workspace connection that imports mail and calendars. A Google admin sets it up once in Settings → Mail → Import mail; then everyone's Drive and your shared drives can come over from here.",
    "import.drive.connect.button": "Connect Google Workspace",
    "import.drive.connect.how": "How it works",
    "import.drive.connected": [{"type":0,"value":"Connected "},{"type":1,"value":"date"},{"type":0,"value":" · "},{"type":1,"value":"people"}],
    "import.drive.mailSettings": "Mail import settings",
    "import.drive.scope.title": "Google Drive needs one more permission",
    "import.drive.scope.body": "A Google admin adds one scope to Bundle's client in the Google Admin console. Mail and calendars keep importing meanwhile.",
    "import.drive.scope.step1": "Open admin.google.com → Security → Access and data control → API controls.",
    "import.drive.scope.step2": [{"type":0,"value":"Choose Manage domain-wide delegation, find client ID "},{"type":1,"value":"clientId"},{"type":0,"value":" and choose Edit."}],
    "import.drive.scope.step2Own": "Choose Manage domain-wide delegation, find your service account's client ID and choose Edit.",
    "import.drive.scope.step3": "Add this scope to the list (keep the ones already there), then Authorize.",
    "import.drive.scope.clientId": "Client ID",
    "import.drive.scope.scope": "Scope to add",
    "import.drive.scope.all": "All scopes",
    "import.drive.scope.allHint": "Mail, calendar and Drive, comma-separated, to paste over the whole list",
    "import.drive.scope.copy": "Copy",
    "import.drive.scope.copyAll": "Copy all",
    "import.drive.scope.copied": "Copied",
    "import.drive.scope.check": "Check again",
    "import.drive.scope.checked": [{"type":0,"value":"Last checked "},{"type":1,"value":"time"},{"type":0,"value":". Google can take a few minutes to apply it."}],
    "import.drive.ready.title": [{"type":0,"value":"Ready to read Google Drive for "},{"type":1,"value":"domain"}],
    "import.drive.ready.body": "Bundle only reads. Nothing in Google Drive is changed, moved or shared.",
    "import.drive.ready.button": "Read Google Drive",
    "import.drive.scan.title": "Reading Google Drive…",
    "import.drive.scan.body": "Big drives take a few minutes; you can leave this page.",
    "import.drive.scan.cancel": "Cancel",
    "import.drive.review.read": [{"type":0,"value":"Read "},{"type":1,"value":"time"},{"type":0,"value":" · "},{"type":1,"value":"people"},{"type":0,"value":" and "},{"type":1,"value":"drives"},{"type":0,"value":". Choose what comes over to Files."}],
    "import.drive.review.total": [{"type":1,"value":"size"}],
    "import.drive.review.from": [{"type":0,"value":"from "},{"type":1,"value":"people"},{"type":0,"value":" and "},{"type":1,"value":"drives"}],
    "import.drive.review.thisImport": [{"type":0,"value":"This import · "},{"type":1,"value":"size"}],
    "import.drive.review.left": [{"type":0,"value":"Files storage left: "},{"type":1,"value":"size"}],
    "import.drive.review.over": [{"type":0,"value":"This won't fit. Uncheck "},{"type":1,"value":"size"},{"type":0,"value":" or more, or free up space in Manage storage."}],
    "import.drive.review.manageStorage": "Manage storage",
    "import.drive.review.sharedSizes": "Shared drives' sizes are counted while they're listed.",
    "import.drive.review.people": "People",
    "import.drive.review.peopleHint": "Each person's My Drive goes to their My files, in a folder named “Google Drive”.",
    "import.drive.review.peoplePicked": [{"type":1,"value":"picked"},{"type":0,"value":" of "},{"type":1,"value":"members"},{"type":0,"value":" members picked"}],
    "import.drive.review.account": "Google account",
    "import.drive.review.inBundle": "In Bundle",
    "import.drive.review.size": "Size",
    "import.drive.review.notInBundle": "Not in Bundle",
    "import.drive.review.inviteFirst": "Invite them first",
    "import.drive.review.invite": "Invite",
    "import.drive.review.include": [{"type":0,"value":"Include "},{"type":1,"value":"name"}],
    "import.drive.review.all": "Select all",
    "import.drive.review.none": "Select none",
    "import.drive.review.sharedDrives": "Shared drives",
    "import.drive.review.sharedDrivesHint": "Each becomes a shared folder at the top of Files, with the drive's members.",
    "import.drive.review.members": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" member"}]},"other":{"value":[{"type":7},{"type":0,"value":" members"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.review.cantRead": "No organizer in this Google Workspace can read it",
    "import.drive.review.noSharedDrives": "No shared drives.",
    "import.drive.review.filesTitle": "How files come over",
    "import.drive.review.files1": "Google Docs → .docx · Sheets → .xlsx · Slides → .pptx · Drawings → .pdf",
    "import.drive.review.files2": "Forms, Sites, My Maps and Apps Script aren't copied. They're listed in the report with “Open in Google”.",
    "import.drive.review.files3": "Shortcuts stay shortcuts.",
    "import.drive.review.files4": "Files in Google's trash aren't copied.",
    "import.drive.review.files5": [{"type":0,"value":"“Shared with me” files owned outside "},{"type":1,"value":"domain"},{"type":0,"value":" aren't copied."}],
    "import.drive.review.files6": "Other files come over as they are, up to 5 TB each.",
    "import.drive.review.sharingTitle": "How sharing comes over",
    "import.drive.review.sharing1": "People keep the same access (viewer, commenter, editor) when they're members or existing guests of this workspace.",
    "import.drive.review.sharing2": [{"type":0,"value":"“Anyone with the link” and “Anyone at "},{"type":1,"value":"domain"},{"type":0,"value":"” become “Anyone in this workspace with the link”. Bundle has no public links."}],
    "import.drive.review.sharing3": "People outside Bundle who had access don't get it. They're listed in the report so you can invite them.",
    "import.drive.review.sharing4": "Nobody is notified.",
    "import.drive.review.footer": [{"type":1,"value":"size"},{"type":0,"value":" · Google Drive is only read, never changed."}],
    "import.drive.review.discard": "Discard",
    "import.drive.review.readAgain": "Read again",
    "import.drive.review.start": "Start import",
    "import.drive.run.title": [{"type":0,"value":"Importing · "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "import.drive.run.listing": "Importing · listing files…",
    "import.drive.run.counts": [{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" items · "},{"type":1,"value":"size"}],
    "import.drive.run.countsUnknown": [{"type":1,"value":"done"},{"type":0,"value":" items · "},{"type":1,"value":"size"}],
    "import.drive.run.cancel": "Cancel import",
    "import.drive.run.body": "Runs on our servers; you can close this page. Folders appear in Files as they're copied. Nobody is notified.",
    "import.drive.run.units": "People and shared drives",
    "import.drive.run.sharedDrive": "Shared drive",
    "import.drive.unit.waiting": "Waiting",
    "import.drive.unit.listing": "Listing files…",
    "import.drive.unit.copying": [{"type":0,"value":"Copying "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "import.drive.unit.done": [{"type":0,"value":"Done · "},{"type":1,"value":"items"}],
    "import.drive.unit.attention": "Needs attention",
    "import.drive.run.problems": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Needs attention · "},{"type":7},{"type":0,"value":" file so far"}]},"other":{"value":[{"type":0,"value":"Needs attention · "},{"type":7},{"type":0,"value":" files so far"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.run.seeAll": "See all",
    "import.drive.problem.tooBig": "Too big: over 5 TB",
    "import.drive.problem.notCopyable": "Not copyable: a Google type with no file to export",
    "import.drive.problem.exportFailed": "Export failed: Google couldn't convert it",
    "import.drive.problem.refused": "Google refused: downloading is turned off, or the owner limited it",
    "import.drive.problem.gone": "Gone: deleted in Google before it was copied",
    "import.drive.problem.shortcutTarget": "Shortcut: what it points to isn't in this import",
    "import.drive.problem.folderMissing": "Its folder didn't come over",
    "import.drive.problem.storageFull": "Storage full: Files ran out of space",
    "import.drive.problem.failed": "Couldn't copy it after several tries",
    "import.drive.problem.open": "Open in Google",
    "import.drive.problems.title": "Not copied",
    "import.drive.problems.body": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" file didn't come over. Everything else did."}]},"other":{"value":[{"type":7},{"type":0,"value":" files didn't come over. Everything else did."}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.problems.all": "All",
    "import.drive.problems.csv": "Download CSV",
    "import.drive.problems.tryAgain": "Try again",
    "import.drive.problems.tryAgainHint": "Reads Google Drive again with the same choices; only what's new, changed or not copied yet comes over.",
    "import.drive.problems.empty": "Everything came over.",
    "import.drive.problems.truncated": [{"type":0,"value":"Showing the first "},{"type":1,"value":"count"},{"type":0,"value":". The CSV has the same list."}],
    "import.drive.done.title": "Google Drive is in Files",
    "import.drive.done.attention": "Google Drive is in Files, with some things to look at",
    "import.drive.done.cancelled": "Import cancelled. What was copied stays.",
    "import.drive.done.failed": "The import stopped",
    "import.drive.done.summary": [{"type":1,"value":"files"},{"type":0,"value":" and "},{"type":1,"value":"folders"},{"type":0,"value":" · "},{"type":1,"value":"size"}],
    "import.drive.review.outsideCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" not in Bundle"}]},"other":{"value":[{"type":7},{"type":0,"value":" not in Bundle"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.people": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.sharedDrives": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" shared drive"}]},"other":{"value":[{"type":7},{"type":0,"value":" shared drives"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.files": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" file"}]},"other":{"value":[{"type":7},{"type":0,"value":" files"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.folders": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" folder"}]},"other":{"value":[{"type":7},{"type":0,"value":" folders"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.items": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" item"}]},"other":{"value":[{"type":7},{"type":0,"value":" items"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.done.sharedDrives": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" shared drive"}]},"other":{"value":[{"type":7},{"type":0,"value":" shared drives"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.done.notCopied": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" not copied"}]},"other":{"value":[{"type":7},{"type":0,"value":" not copied"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.done.storageFull": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Files ran out of storage, so "},{"type":7},{"type":0,"value":" file wasn't copied. Free up space, then import again."}]},"other":{"value":[{"type":0,"value":"Files ran out of storage, so "},{"type":7},{"type":0,"value":" files weren't copied. Free up space, then import again."}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.done.openFiles": "Open Files",
    "import.drive.done.again": "Import again",
    "import.drive.done.againHint": "Brings only new and changed files. Nothing already here is copied twice.",
    "import.drive.done.undoTitle": "Undo this import",
    "import.drive.done.undoBody": "Moves everything this import created to the trash. Files someone edited after the import stay.",
    "import.drive.trash.body": "Everything this Google Drive import created that is still here, in everyone's My files and the shared folders. People lose access until it's restored. You can restore it from Trash for 30 days.",
    "import.drive.trash.kept": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" file someone edited after the import stays."}]},"other":{"value":[{"type":7},{"type":0,"value":" files someone edited after the import stay."}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.delete.body": "This can't be undone. Everything this import put in the trash goes for good: files, their versions, sharing and search entries. Google Drive still has the originals.",
    "import.drive.undo.trashing": [{"type":0,"value":"Moving to the trash · "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "import.drive.undo.deleting": [{"type":0,"value":"Deleting permanently · "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "import.drive.undo.trashed": "In the trash. You can restore it from Trash, or delete it permanently.",
    "import.drive.undo.deleted": "Deleted permanently.",
    "import.drive.undo.stopped": [{"type":0,"value":"Stopped at "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":". Try again to finish."}],
    "import.drive.banner": [{"type":0,"value":"Importing from Google Drive · "},{"type":1,"value":"percent"},{"type":0,"value":"%. Folders appear here as they're copied."}],
    "import.drive.banner.open": "See progress",
    "import.timeline.driveUnit": [{"type":0,"value":"Started "},{"type":1,"value":"name"}],
    "import.timeline.driveUnitDone": [{"type":1,"value":"name"},{"type":0,"value":": copied "},{"type":1,"value":"files"},{"type":0,"value":" files and "},{"type":1,"value":"folders"},{"type":0,"value":" folders"}],
    "import.timeline.driveUnitAttention": [{"type":1,"value":"name"},{"type":0,"value":" needs attention: "},{"type":1,"value":"message"}],
    "import.timeline.driveShortcuts": [{"type":0,"value":"Linked "},{"type":1,"value":"count"},{"type":0,"value":" shortcuts"}],
    "import.undo.trashing": [{"type":0,"value":"Moving to the trash · "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "import.undo.trashed": "In the trash. You can restore it from Trash, or delete it permanently.",
    "import.undo.deleting": [{"type":0,"value":"Deleting permanently · "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "import.undo.deleted": "Deleted permanently.",
    "import.undo.failed": [{"type":0,"value":"Stopped at "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":". Try again to finish."}],
    "import.slack.summary": [{"type":0,"value":"Channels: "},{"type":1,"value":"channels"},{"type":0,"value":" · Direct messages: "},{"type":1,"value":"dms"},{"type":0,"value":" · Matched: "},{"type":1,"value":"matched"},{"type":0,"value":" · To invite: "},{"type":1,"value":"invite"},{"type":0,"value":" · External guests: "},{"type":1,"value":"guest"},{"type":0,"value":" · Deactivated: "},{"type":1,"value":"deactivated"}],
    "import.slack.publicOnly": "This export has public channels only (Slack Free and Pro). To bring private channels and DMs, connect with a token instead.",
    "import.slack.copyFiles": "Copy attached files into Bundle",
    "import.slack.people": "People",
    "import.slack.people.body": "People with the same email are matched to members. Invited people get their account now, so their messages, channels and DMs are theirs when they join; people from other companies come in as external guests; who left stays as a deactivated profile.",
    "import.slack.nameOnly": "Keep as name only",
    "import.slack.matchFor": [{"type":0,"value":"Member for "},{"type":1,"value":"name"}],
    "import.slack.deactivated": "Deactivated in Slack",
    "import.slack.channels": "Channels",
    "import.slack.channels.body": "Untick what you don't want; rename to avoid clashes. Channels come in with their members.",
    "import.slack.include": [{"type":0,"value":"Import #"},{"type":1,"value":"name"}],
    "import.slack.rename": [{"type":0,"value":"Name for #"},{"type":1,"value":"name"}],
    "import.slack.merges": "Joins the empty channel with this name",
    "import.slack.archived": "Archived",
    "import.slack.duplicateNames": [{"type":0,"value":"Two channels would be called "},{"type":1,"value":"names"},{"type":0,"value":": rename one."}],
    "import.slack.dms": "Direct messages",
    "import.slack.dms.body": "DMs come over when everyone in them is someone in Bundle (matched, invited or deactivated), and only they can read them.",
    "import.slack.allDms": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Import the direct message"}]},"other":{"value":[{"type":0,"value":"Import all "},{"type":7},{"type":0,"value":" direct messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.notion.summary": [{"type":0,"value":"Pages: "},{"type":1,"value":"pages"},{"type":0,"value":" · Databases: "},{"type":1,"value":"databases"}],
    "import.notion.ai.title": "Sorted with AI",
    "import.notion.ai.body": "Review the sections below and move pages where they belong.",
    "import.notion.ai.unavailable": "The pages keep the layout they had in Notion. Add sections to group them.",
    "import.notion.ai.failed": "The AI couldn't sort this export, so the pages keep the layout they had in Notion. Add sections to group them.",
    "import.notion.sectionName": "Section name",
    "import.notion.shared": "Shared",
    "import.notion.private": "Private",
    "import.notion.visibility": "Who sees it",
    "import.notion.removeSection": "Remove section",
    "import.notion.emptySection": "Nothing here yet: move pages into it below.",
    "import.notion.topLevel": "Top level",
    "import.notion.topLevel.body": "These pages go straight into the workspace's pages.",
    "import.notion.addSection": "Add section",
    "import.notion.newSection": "New section",
    "import.notion.untitledSection": "Untitled section",
    "import.notion.nameSections": "Give every section a name.",
    "import.notion.untitled": "Untitled",
    "import.notion.renamed": [{"type":0,"value":"was \""},{"type":1,"value":"title"},{"type":0,"value":"\""}],
    "import.notion.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" row"}]},"other":{"value":[{"type":7},{"type":0,"value":" rows"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.notion.subpages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" subpage"}]},"other":{"value":[{"type":7},{"type":0,"value":" subpages"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.notion.view": [{"type":0,"value":"First view of "},{"type":1,"value":"name"}],
    "import.notion.moveTo": [{"type":0,"value":"Section for "},{"type":1,"value":"name"}],
    "import.notion.layout.table": "Table",
    "import.notion.layout.board": "Board",
    "import.notion.layout.list": "List",
    "import.notion.layout.calendar": "Calendar",
    "import.notion.layout.sheet": "Sheet",
    "import.slackApp.title": "Let people import their own Slack messages",
    "import.slackApp.body": "An admin's token can't read anyone's DMs or private channels. Connect the Slack app once and each person can bring over their own from Settings → Data, signing in with Slack.",
    "import.slackApp.step1": "Create the app in Slack with the button above (it already has Bundle's redirect URL), install it to your workspace.",
    "import.slackApp.step2": "In the app's Basic Information, copy the Client ID and Client Secret here.",
    "import.slackApp.clientId": "Client ID",
    "import.slackApp.clientSecret": "Client Secret",
    "import.slackApp.save": "Connect the app",
    "import.slackApp.connected": [{"type":0,"value":"Connected (Client ID "},{"type":1,"value":"clientId"},{"type":0,"value":"). People can import their own messages."}],
    "import.slackApp.saved": "Slack app connected.",
    "import.slackApp.failed": "Couldn't save the Slack app. Check the Client ID and Secret.",
    "import.sync.title": "Keep syncing from Slack",
    "import.sync.body": "While your team moves, Bundle brings in new Slack messages, thread replies, channels and files about every hour. Sync is one way: messages written in Bundle aren't posted to Slack.",
    "import.sync.toggle": "Keep syncing from Slack (hourly)",
    "import.sync.tokenNote": "Bundle needs a Slack user token (xoxp-…) to keep reading Slack, from the same kind of app as a token import. It's kept until you finish the move.",
    "import.sync.tokenLabel": "Slack user token",
    "import.sync.turnOn": "Turn on",
    "import.sync.never": "Not synced yet. The first sync runs within the hour.",
    "import.sync.running": "Syncing now…",
    "import.sync.last": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Last synced "},{"type":1,"value":"time"},{"type":0,"value":" · "},{"type":7},{"type":0,"value":" new message"}]},"other":{"value":[{"type":0,"value":"Last synced "},{"type":1,"value":"time"},{"type":0,"value":" · "},{"type":7},{"type":0,"value":" new messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.sync.lastFailed": [{"type":0,"value":"Last sync failed "},{"type":1,"value":"time"},{"type":0,"value":": "},{"type":1,"value":"error"}],
    "import.sync.paused": "Paused. New Slack messages aren't coming in.",
    "import.sync.now": "Sync now",
    "import.sync.finish": "Stop syncing (Finish move)",
    "import.sync.finishNote": "Once everyone works in Bundle, stop syncing. Bundle forgets the Slack token, and everything that came over stays.",
    "import.sync.finished": "Slack sync stopped. Everything that came over stays in Bundle.",
    "import.sync.failed": "Couldn't change the Slack sync. Try again.",
    "import.sync.badToken": "Slack didn't accept this token. Check it and try again.",
    "import.personal.title": "Import my Slack conversations",
    "import.personal.body": "Bring over your own DMs, group DMs and private channels from Slack. People who are already here are matched by email; nobody is invited. Conversations already here aren't duplicated.",
    "import.personal.connect": "Connect with Slack",
    "import.personal.notConfigured": "An admin needs to connect the Slack app first (Settings → Import → Slack).",
    "import.personal.connectFailed": "Couldn't connect to Slack. Try again.",
    "import.personal.guests": "Guests can't import conversations.",
    "import.personal.summary": [{"type":1,"value":"dms"},{"type":0,"value":" DMs and group DMs · "},{"type":1,"value":"channels"},{"type":0,"value":" private channels"}],
    "import.destination.title": "Import into",
    "import.destination.body": "Bring it into this workspace, another one you manage, or a new one made for it.",
    "import.destination.new": "New workspace…",
    "import.destination.name": "Workspace name",
    "import.destination.create": "Create and continue",
    "import.destination.cancel": "Cancel",
    "import.destination.failed": "Couldn't create the workspace. Try again.",
    "import.notion.reviewTitle": "Import from Notion",
    "import.notion.reviewBody": "Choose what comes over to Bundle. Nothing changes in Notion.",
    "import.notion.workspace": "Notion workspace",
    "import.notion.sees": [{"type":0,"value":"What the integration can see — pages: "},{"type":1,"value":"pages"},{"type":0,"value":" · databases: "},{"type":1,"value":"databases"}],
    "import.notion.readAgain": "Read again",
    "import.notion.missingPages": "Missing a page? With an integration, Notion only shows the pages connected to it (••• → Connections on the page). A personal token sees everything in the Notion workspace it was made in: pages in another workspace need a token from there. Then Read again.",
    "import.notion.what": "What to import",
    "import.notion.what.body": "Subpages and rows come along with the page or database above them.",
    "import.notion.databases": "Databases",
    "import.notion.page": "Page",
    "import.notion.leftOut": "Left out",
    "import.notion.moveToNew": "New section…",
    "import.notion.willImport": [{"type":1,"value":"picked"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" will be imported, with their subpages and rows"}],
    "import.notion.importCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Import "},{"type":7},{"type":0,"value":" item"}]},"other":{"value":[{"type":0,"value":"Import "},{"type":7},{"type":0,"value":" items"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.notion.selectAll": "Select all",
    "import.notion.picked": [{"type":1,"value":"picked"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" selected"}],
    "import.notion.pages": "Pages",
    "import.notion.noSection": "Not in a section",
    "import.notion.noSection.body": "These go straight to Pages, as they were in Notion.",
    "import.notion.database": "Database",
    "import.notion.showAs": [{"type":0,"value":"Show as "},{"type":1,"value":"layout"}],
    "import.notion.moveToNone": "Not in a section",
    "import.notion.moveToSection": [{"type":0,"value":"Move to "},{"type":1,"value":"section"}],
    "import.notion.options": [{"type":0,"value":"Options for "},{"type":1,"value":"name"}],
    "import.notion.nothingPicked": "Pick at least one page or database.",
    "import.managersOnly": "Only owners and admins can import.",
    "import.notZip": "Choose the export .zip file.",
    "import.busy": "Another import is running. Wait for it to finish or stop it.",
    "import.uploadFailed": "The upload failed. Try again.",
    "import.startFailed": "The import couldn't start. Try again.",
    "import.loadFailed": "Couldn't load this import.",
    "import.cancelFailed": "Couldn't stop the import. Try again.",
    "import.chooseFile": "Choose file",
    "nav.mail": "Mail",
    "nav.docs": "Docs",
    "nav.files": "Files",
    "nav.contacts": "Contacts",
    "settings.nav.mail": "Mail",
    "mail.title": "Mail",
    "mail.tab.email": "All",
    "mail.tab.clients": "Clients",
    "mail.tab.team": "Team",
    "mail.tab.promotions": "Promotions",
    "mail.tab.updates": "Updates",
    "mail.tab.new": [{"type":1,"value":"count"},{"type":0,"value":" new"}],
    "mail.updating": "Updating",
    "mail.updated.justNow": "Updated just now",
    "mail.updated.minutes": [{"type":0,"value":"Updated "},{"type":1,"value":"count"},{"type":0,"value":" min ago"}],
    "mail.updated.hours": [{"type":0,"value":"Updated "},{"type":1,"value":"count"},{"type":0,"value":"h ago"}],
    "mail.updated.days": [{"type":0,"value":"Updated "},{"type":1,"value":"count"},{"type":0,"value":"d ago"}],
    "mail.tab.priority": "Priority",
    "mail.action.markPriority": "Mark as priority",
    "mail.action.notPriority": "Not priority",
    "mail.priority.waiting": "Waiting on your reply",
    "mail.priority.waitingOn": [{"type":1,"value":"name"},{"type":0,"value":" is waiting on your reply"}],
    "mail.priority.starred": "Starred",
    "mail.priority.marked": "You marked this conversation",
    "mail.priority.sender": [{"type":0,"value":"You marked "},{"type":1,"value":"name"},{"type":0,"value":" as priority"}],
    "mail.priority.reminder": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"No reply in "},{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":0,"value":"No reply in "},{"type":7},{"type":0,"value":" days"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.priority.marker": [{"type":0,"value":"Priority: "},{"type":1,"value":"reason"},{"type":0,"value":". Mark as not priority"}],
    "mail.priority.unmarkHint": [{"type":0,"value":"Not priority (−) goes for "},{"type":1,"value":"name"},{"type":0,"value":"'s next emails too"}],
    "mail.priority.markHint": [{"type":0,"value":"Mark as priority (+) goes for "},{"type":1,"value":"name"},{"type":0,"value":"'s next emails too"}],
    "mail.priority.footer": "Showing what needs you from every tab. Each conversation is still in its own tab too.",
    "mail.empty.priority.title": "You're all caught up",
    "mail.empty.priority.body": "Replies people are waiting on, starred conversations and senders you mark as priority show up here.",
    "mail.empty.priority.goTab": [{"type":0,"value":"Go to "},{"type":1,"value":"tab"}],
    "mail.folder.inbox": "Inbox",
    "mail.folder.sent": "Sent",
    "mail.folder.archive": "Archive",
    "mail.folder.trash": "Trash",
    "mail.folder.spam": "Spam",
    "mail.search.all": "Search all mail",
    "mail.search.filter.mailbox": "One of your mailboxes",
    "mail.search.value.mailbox": "Your mailbox",
    "mail.filter.title": "Filter mail",
    "mail.filter.mailbox": "Mailbox",
    "mail.filter.allMailboxes": "All mailboxes",
    "mail.filter.myMailboxes": "My mailboxes",
    "mail.filter.groups": "Groups",
    "mail.filter.groupRow": [{"type":1,"value":"address"},{"type":0,"value":" (group)"}],
    "mail.filter.showOnly": "Show only",
    "mail.filter.unread": "Unread",
    "mail.filter.starred": "Starred",
    "mail.filter.attachment": "Attachment",
    "mail.filter.from": "From",
    "mail.filter.fromPlaceholder": "Name or address",
    "mail.filter.date": "Date",
    "mail.filter.date.today": "Today",
    "mail.filter.date.week": "Last 7 days",
    "mail.filter.date.month": "Last 30 days",
    "mail.filter.label": "Label",
    "mail.filter.anyone": "Anyone",
    "mail.filter.anyTime": "Any time",
    "mail.filter.any": "Any",
    "mail.filter.apply": "Apply",
    "mail.filter.clear": "Clear",
    "mail.filter.clearAll": "Clear filters",
    "mail.filter.empty": "No mail matches these filters",
    "mail.filter.show": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Show "},{"type":7},{"type":0,"value":" conversation"}]},"other":{"value":[{"type":0,"value":"Show "},{"type":7},{"type":0,"value":" conversations"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.filter.showMore": [{"type":0,"value":"Show "},{"type":1,"value":"count"},{"type":0,"value":"+ conversations"}],
    "mail.recent.title": "Recent searches",
    "mail.recent.clear": "Clear history",
    "mail.recent.remove": "Remove from history",
    "mail.recent.empty": "Your searches show up here. Only you can see them.",
    "mail.recent.filterBy": "Filter by",
    "mail.recent.close": "Close",
    "mail.recent.swipeHint": "Swipe left to remove one. Only you can see these.",
    "mail.search.placeholder": "Search mail",
    "mail.search.filter.from": "Sent by a person, email or domain",
    "mail.search.filter.to": "Sent to a person, email or domain",
    "mail.search.filter.domain": "Anyone on a domain, sender or recipient",
    "mail.search.filter.in": "In a folder or label",
    "mail.search.filter.has": "Has an attachment",
    "mail.search.filter.is": "Unread, read or starred",
    "mail.search.filter.before": "Before a date",
    "mail.search.filter.after": "After a date",
    "mail.search.filter.or": "Match either side",
    "mail.search.value.domain": "Everyone at this domain",
    "mail.search.value.folder": "Folder",
    "mail.search.value.label": "Label",
    "mail.search.value.attachment": "Has an attachment",
    "mail.search.value.unread": "Unread",
    "mail.search.value.read": "Read",
    "mail.search.value.starred": "Starred",
    "mail.search.suggest.people": "People and domains",
    "mail.search.suggest.domains": "Domains",
    "mail.search.suggest.folders": "Folders and labels",
    "mail.search.mode.like": "Contains",
    "mail.search.mode.exact": "Exactly this",
    "mail.search.mode.exclude": "Leave out",
    "mail.search.chip.remove": [{"type":0,"value":"Remove "},{"type":1,"value":"filter"}],
    "mail.search.chip.or": "or",
    "mail.compose": "Compose",
    "mail.empty.tab": [{"type":0,"value":"Nothing in "},{"type":1,"value":"tab"}],
    "mail.empty.folder": "No conversations here",
    "mail.empty.search": [{"type":0,"value":"No mail matches “"},{"type":1,"value":"query"},{"type":0,"value":"”"}],
    "mail.noMailbox.title": "No mailbox yet",
    "mail.noMailbox.body": "An admin can host your company's domain on Bundle in Settings → Mail and give you a mailbox.",
    "mail.noMailbox.adminBody": "Add your company's domain in Settings → Email, then create a mailbox on it. Mail sent to that address shows up here.",
    "mail.noMailbox.setup": "Set up email",
    "mail.loadFailed": "Couldn't load mail",
    "mail.thread.textFailed": "Couldn't load this message. Try again.",
    "mail.retry": "Try again",
    "mail.loadMore": "Load more",
    "mail.action.reply": "Reply",
    "mail.action.replyAll": "Reply all",
    "mail.action.replyAllShort": "Reply all",
    "mail.action.forward": "Forward",
    "mail.action.archive": "Archive",
    "mail.action.trash": "Delete",
    "mail.action.spam": "Report spam",
    "mail.action.notSpam": "Not spam",
    "mail.action.moveToInbox": "Move to Inbox",
    "mail.action.markRead": "Mark as read",
    "mail.action.markUnread": "Mark as unread",
    "mail.action.star": "Star",
    "mail.action.unstar": "Remove star",
    "mail.action.moveToTab": "Move to tab",
    "mail.action.loadImages": "Load images",
    "mail.imagesBlocked": "Images are hidden to protect your privacy.",
    "mail.view.original": "Show original email",
    "mail.view.reading": "Show reading view",
    "mail.view.setting.title": "Open messages in",
    "mail.view.setting.original": "Original",
    "mail.view.setting.originalHelp": "The email as the sender designed it, as Gmail shows it.",
    "mail.view.setting.reading": "Reading view",
    "mail.view.setting.readingHelp": "Just the text, images and links, in Bundle's colors. Short personal emails and replies still open as sent.",
    "mail.view.setting.help": "Applies on all your devices. Any message can still switch views.",
    "mail.warning.suspicious": "This message may not be from who it says. Don't click links or share passwords.",
    "mail.code.label": "Verification code",
    "mail.code.from": [{"type":0,"value":"Verification code from "},{"type":1,"value":"sender"},{"type":0,"value":" · "},{"type":1,"value":"time"}],
    "mail.code.copy": "Copy code",
    "mail.code.copied": "Copied",
    "mail.code.copiedToast": "Code copied",
    "mail.code.copyNamed": [{"type":0,"value":"Copy code "},{"type":1,"value":"code"}],
    "mail.code.spam": [{"type":0,"value":"This code landed in Spam. "},{"type":1,"value":"sender"},{"type":0,"value":" sent it and the sender checks passed."}],
    "mail.code.unverified": "This looks like a code, but we couldn't verify who sent it. Don't share it with anyone.",
    "home.briefing.codes": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" code"}]},"other":{"value":[{"type":7},{"type":0,"value":" codes"}]}},"offset":0,"pluralType":"cardinal"}],
    "home.briefing.copy": "Copy",
    "mail.needsReply": "Needs reply",
    "mail.auth.pass": "Verified sender",
    "mail.auth.fail": "Unverified sender",
    "mail.to": [{"type":0,"value":"to "},{"type":1,"value":"names"}],
    "mail.me": "me",
    "mail.attachment.cancel": [{"type":0,"value":"Cancel download of "},{"type":1,"value":"name"}],
    "mail.attachment.failedNamed": [{"type":0,"value":"Couldn't download "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "mail.attachment.offlineNamed": [{"type":0,"value":"You're offline. Couldn't download "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "mail.attachment.saved": [{"type":0,"value":"Saved "},{"type":1,"value":"name"}],
    "mail.attachment.saveFailed": [{"type":0,"value":"Couldn't save "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "mail.attachment.downloading": [{"type":0,"value":"Downloading "},{"type":1,"value":"name"}],
    "mail.attachment.opening": [{"type":0,"value":"Opening "},{"type":1,"value":"name"}],
    "mail.attachment.openNamed": [{"type":0,"value":"Open "},{"type":1,"value":"name"}],
    "mail.attachment.downloadNamed": [{"type":0,"value":"Download "},{"type":1,"value":"name"}],
    "mail.attachment.savedToDownloads": [{"type":1,"value":"name"},{"type":0,"value":" saved to Downloads"}],
    "mail.attachment.showInFolder": "Show in folder",
    "mail.attachment.offline": "You're offline. Tap to try again.",
    "mail.attachment.failed": "Couldn't download. Tap to try again.",
    "mail.attachment.open": "Open",
    "mail.attachment.share": "Share",
    "mail.attachment.saveToFiles": "Save to Files",
    "mail.attachments": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" attachment"}]},"other":{"value":[{"type":7},{"type":0,"value":" attachments"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.status.queued": "Sending…",
    "mail.status.failed": "Not sent",
    "mail.status.bounced": "Bounced",
    "mail.compose.new": "New message",
    "mail.compose.assist": "Describe the message",
    "mail.compose.assistFailed": "Couldn't write it. Try again.",
    "mail.compose.assisting": "Writing…",
    "mail.compose.linkAddress": "Link address",
    "mail.compose.linkApply": "Apply",
    "mail.compose.linkRemove": "Remove link",
    "mail.compose.formatting": "Formatting options",
    "mail.compose.minimize": "Minimize",
    "mail.compose.restore": "Restore",
    "mail.compose.expand": "Full screen",
    "mail.compose.collapse": "Exit full screen",
    "mail.compose.from": "From",
    "mail.compose.to": "To",
    "mail.compose.recipient.edit": [{"type":0,"value":"Edit "},{"type":1,"value":"name"}],
    "mail.compose.recipient.removeInvalid": [{"type":0,"value":"Remove "},{"type":1,"value":"name"},{"type":0,"value":", not a valid address"}],
    "mail.compose.cc": "Cc",
    "mail.compose.bcc": "Bcc",
    "mail.compose.subject": "Subject",
    "mail.compose.body": "Write your message",
    "mail.compose.attach": "Attach files",
    "mail.compose.send": "Send",
    "mail.compose.toLabel": "To:",
    "mail.compose.subjectLabel": "Subject:",
    "mail.compose.saySomething": "Say something",
    "mail.compose.noSignature": "No signature",
    "mail.compose.signatureOptions": "Signature options",
    "mail.compose.signatureEdit": "Edit signature",
    "mail.compose.signatureRemove": "Leave the signature off",
    "mail.compose.sentWithRemove": "Leave “Sent with Bundle” off this message",
    "mail.compose.sentWithAdd": "Add “Sent with Bundle”",
    "mail.compose.formatDone": "Done formatting",
    "mail.compose.translate": "Translate",
    "mail.compose.textStyle": "Text style",
    "mail.compose.templates": "Templates",
    "mail.compose.saveTemplate": "Save as template",
    "mail.compose.remind": "Remind me if no reply",
    "mail.compose.remindOff": "Don't remind me",
    "mail.compose.remindAt": [{"type":0,"value":"Reminder "},{"type":1,"value":"time"},{"type":0,"value":" if no reply"}],
    "mail.compose.addContact": "Add from contacts",
    "mail.compose.findContact": "Find a contact",
    "mail.compose.ai": "+ai",
    "mail.compose.ai.draft": "Generate a draft",
    "mail.compose.ai.ask": "Ask AI",
    "mail.compose.ai.askPlaceholder": "Ask anything about this email",
    "mail.compose.ai.rewrite": "Rewrite",
    "mail.compose.ai.shorten": "Make shorter",
    "mail.compose.ai.lengthen": "Make longer",
    "mail.compose.ai.formal": "More formal",
    "mail.compose.ai.friendly": "Friendlier",
    "mail.compose.ai.fix": "Fix spelling and grammar",
    "mail.compose.ccBcc": "Cc: Bcc:",
    "mail.compose.editRecipients": "Edit recipients",
    "mail.compose.recipientsSummary": [{"type":1,"value":"name"},{"type":0,"value":" +"},{"type":1,"value":"count"}],
    "mail.compose.saveDraft": "Save draft",
    "mail.compose.deleteDraft": "Delete draft",
    "mail.compose.templatesEmpty": "No templates yet. Write a message and save it as a template to reuse it.",
    "mail.compose.templateName": "Template name",
    "mail.compose.deleteTemplate": "Delete template",
    "mail.compose.sendLater": "Send later",
    "mail.compose.more": "More",
    "mail.compose.useSignatureOf": [{"type":0,"value":"Use the signature of "},{"type":1,"value":"address"}],
    "mail.compose.saveSignature": "Save as default signature",
    "mail.compose.discard": "Discard",
    "mail.compose.sent": "Message sent",
    "mail.compose.invalidRecipients": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" address isn't valid"}]},"other":{"value":[{"type":7},{"type":0,"value":" addresses aren't valid"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.compose.noRecipients": "Add at least one recipient",
    "mail.compose.noReply": [{"type":1,"value":"address"},{"type":0,"value":" may not read replies"}],
    "mail.compose.offline": "You're offline. Send when you're back online.",
    "mail.compose.failed": "Couldn't send. Try again.",
    "mail.compose.failedNetwork": "Couldn't reach Bundle. Your message is still here, so try again.",
    "mail.compose.failedLimit": "This mailbox reached its sending limit. Try again later.",
    "mail.compose.failedGone": "The mailbox or the message you're replying to no longer exists.",
    "mail.compose.failedForbidden": "You can't send from this mailbox.",
    "mail.compose.failedRefused": "Bundle refused this message. Check the From address, the recipients and the attachments.",
    "mail.compose.failedStorage": "Storage is full, so mail can't go out. An admin can add space in Billing.",
    "mail.compose.failedBilling": "Mail can't go out until the subscription is renewed.",
    "mail.compose.failedDomain": "Sending from this domain is paused or isn't set up. An admin can check it in Settings → Email.",
    "mail.compose.tooManyRecipients": [{"type":0,"value":"A message can go to at most "},{"type":1,"value":"max"},{"type":0,"value":" people"}],
    "mail.compose.tooLong": "This message is too long. Shorten it or remove the quoted text.",
    "mail.compose.sendingNotSetUp": [{"type":0,"value":"Sending from "},{"type":1,"value":"domain"},{"type":0,"value":" isn't set up yet. An admin can finish it in Settings → Email."}],
    "mail.contacts.title": "Contacts",
    "mail.contacts.filter.all": "All",
    "mail.contacts.filter.email": "Email",
    "mail.contacts.filter.client": "Clients",
    "mail.contacts.filter.team": "Team",
    "mail.contacts.search": "Search contacts",
    "mail.contacts.add": "Add contact",
    "mail.contacts.name": "Name",
    "mail.contacts.email": "Email address",
    "mail.contacts.org": "Company",
    "mail.contacts.kind": "Type",
    "mail.contacts.markClient": "Mark as client",
    "mail.contacts.markTeam": "Mark as team",
    "mail.contacts.markEmail": "Mark as other",
    "mail.contacts.remove": "Remove contact",
    "mail.contacts.sendMail": "Send email",
    "mail.contacts.empty": "No contacts yet. They appear as you send and receive mail.",
    "mail.contacts.messages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" message"}]},"other":{"value":[{"type":7},{"type":0,"value":" messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.contacts.invalidEmail": "Enter a valid email address",
    "mail.contacts.addFailed": "Couldn't add the contact",
    "mail.contacts.member": "Workspace member",
    "mail.people.copyEmail": "Copy email",
    "mail.people.kind.client": "Client",
    "mail.people.copied": "Email address copied",
    "mail.people.notContact": "Not in your contacts",
    "mail.people.projects": "Projects",
    "mail.people.addToProject": "Add to project",
    "mail.people.addToProjectTitle": [{"type":0,"value":"Add "},{"type":1,"value":"name"},{"type":0,"value":" to a project"}],
    "mail.people.findProject": "Find a project",
    "mail.people.noProjects": "No projects yet. Use the Projects & tasks template in Docs to start one.",
    "mail.people.noProjectsFor": "Not in any project yet",
    "mail.people.projectFailed": "Couldn't update the project",
    "mail.people.newEmail": "New email",
    "mail.people.openContact": "Open contact",
    "mail.people.addContact": "Add to contacts",
    "mail.people.addClient": "Add as client",
    "mail.people.message": "Message",
    "mail.people.viewProfile": "View profile",
    "mail.people.recentWith": [{"type":0,"value":"Recent emails with "},{"type":1,"value":"name"}],
    "mail.people.recent": "Recent emails",
    "mail.people.seeAllInMail": "See all in Mail",
    "mail.people.noRecent": "No emails yet",
    "mail.people.selectContact": "Select a contact to see their details",
    "mail.people.copyShort": "Copy",
    "mail.people.emailShort": "Email",
    "mail.people.contactShort": "Contact",
    "mail.people.card": [{"type":0,"value":"Contact card for "},{"type":1,"value":"name"}],
    "mail.people.removeFromProject": [{"type":0,"value":"Remove from "},{"type":1,"value":"project"}],
    "mail.settings.title": "Mail",
    "mail.settings.domains": "Domains",
    "mail.settings.domainsHelp": "Host your company's email on Bundle. Add your domain, then add these records at your DNS provider (any provider works).",
    "mail.settings.addDomain": "Add domain",
    "mail.settings.domainPlaceholder": "yourcompany.com",
    "mail.settings.check": "Check DNS now",
    "mail.settings.remove": "Remove domain",
    "mail.settings.removeConfirm": [{"type":0,"value":"Remove "},{"type":1,"value":"domain"},{"type":0,"value":"? Its alias addresses and groups go with it."}],
    "mail.settings.status.pending": "Waiting for DNS",
    "mail.settings.status.verified": "Active",
    "mail.settings.status.failed": "DNS problem",
    "mail.settings.status.paused": "Paused",
    "mail.settings.canReceive": "Receiving",
    "mail.settings.canSend": "Sending",
    "mail.settings.status.ownedGoogle": "Ownership verified · mail still at Google",
    "mail.settings.status.ownedElsewhere": "Ownership verified · mail still at your current provider",
    "mail.settings.receivesViaImport": "Receiving through import or sync",
    "mail.settings.sendingNotSetUp": "Sending not set up",
    "mail.settings.keptElsewhereHelp": "You can create mailboxes on this domain now; their mail comes in through the import. To send from Bundle, add the DKIM and return-path records below. The MX records are only for moving the domain's mail to Bundle.",
    "mail.settings.domainInUse": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"This domain can't be removed while "},{"type":7},{"type":0,"value":" mailbox uses it"}]},"other":{"value":[{"type":0,"value":"This domain can't be removed while "},{"type":7},{"type":0,"value":" mailboxes use it"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.settings.record.type": "Type",
    "mail.settings.record.name": "Name",
    "mail.settings.record.value": "Value",
    "mail.settings.record.priority": "Priority",
    "mail.settings.record.ok": "Found",
    "mail.settings.record.missing": "Missing",
    "mail.settings.record.mismatch": "Different value",
    "mail.settings.record.unchecked": "Not checked",
    "mail.settings.record.optional": "Optional",
    "mail.settings.record.srv": [{"type":0,"value":"Port "},{"type":1,"value":"port"},{"type":0,"value":" · Weight "},{"type":1,"value":"weight"}],
    "mail.settings.record.verification.pending": "Verifying",
    "mail.settings.record.verification.restarted": "Verifying",
    "mail.settings.record.verification.failed": "Retrying",
    "mail.settings.dkimNote.pending": "DKIM record found. Our sending service is still verifying it, which usually takes a few minutes and at most 72 hours. Sending turns on by itself once it's verified.",
    "mail.settings.dkimNote.restarted": "DKIM record found. Our sending service had stopped checking before the record was published, so Bundle started its check again. It usually takes a few minutes; sending turns on by itself once it's verified.",
    "mail.settings.dkimNote.failed": "DKIM record found, but our sending service hasn't verified it yet. Bundle starts its check again every hour while the record is in place.",
    "mail.settings.mailFromNote.pending": "Bounce (MAIL FROM) records found. Our sending service is still verifying them, which usually takes a few minutes. Until then your mail is sent with its own bounce address, and DMARC still passes through DKIM.",
    "mail.settings.mailFromNote.restarted": "Bounce (MAIL FROM) records found. Our sending service had stopped checking, so Bundle started its check again. Until it's verified your mail is sent with its own bounce address, and DMARC still passes through DKIM.",
    "mail.settings.mailFromNote.failed": "Bounce (MAIL FROM) records found, but our sending service hasn't verified them yet. Bundle starts its check again every hour while the records are in place.",
    "mail.settings.record.copy": "Copy",
    "mail.settings.purpose.verify": "Proves you own the domain",
    "mail.settings.purpose.mx": "Delivers mail to Bundle",
    "mail.settings.purpose.spf": "Allows Bundle to send for you (SPF)",
    "mail.settings.purpose.dkim": "Signs your mail (DKIM)",
    "mail.settings.purpose.returnPath": "Handles bounces",
    "mail.settings.purpose.dmarc": "Protects against spoofing (DMARC)",
    "mail.settings.purpose.mtaSts": "Requires encrypted delivery (MTA-STS)",
    "mail.settings.purpose.clientSetup": "Lets mail apps set themselves up",
    "mail.settings.purpose.bimi": "Shows your logo next to your mail (BIMI)",
    "mail.settings.purpose.mailFrom": "Bounces on your own domain (SPF alignment)",
    "mail.settings.bimi": "Brand logo (BIMI)",
    "mail.settings.bimi.help": "A square SVG logo that mail apps show next to messages from this domain. Add the default._bimi record below once you upload it. Gmail also needs a mark certificate (VMC or CMC).",
    "mail.settings.bimi.needsDmarc": "A square SVG logo that mail apps show next to messages from this domain. They only show it once DMARC is set to Quarantine or Reject.",
    "mail.settings.bimi.upload": "Upload SVG logo",
    "mail.settings.bimi.replace": "Replace logo",
    "mail.settings.bimi.remove": "Remove logo",
    "mail.settings.dmarc": "DMARC policy",
    "mail.settings.dmarc.none": "Monitor only",
    "mail.settings.dmarc.quarantine": "Send failures to spam",
    "mail.settings.dmarc.reject": "Reject failures",
    "mail.settings.mailboxes": "Mailboxes",
    "mail.settings.newMailbox": "New mailbox",
    "mail.settings.noMailboxYet": [{"type":1,"value":"domain"},{"type":0,"value":" is ready. Create a mailbox to start receiving email in Bundle."}],
    "mail.settings.createMine": [{"type":0,"value":"Create "},{"type":1,"value":"address"}],
    "mail.settings.tabs": "Email settings",
    "mail.settings.tab.domains": "Domains",
    "mail.settings.tab.people": "Users & forwarding",
    "mail.settings.people": "People",
    "mail.settings.people.help": "Each person's mailbox and the shared mailboxes they can read.",
    "mail.settings.people.noMailbox": "No mailbox",
    "mail.settings.people.create": "Create mailbox",
    "mail.settings.routing": "Aliases & forwarding",
    "mail.settings.aliases": "Aliases (other addresses that deliver here)",
    "mail.settings.aliasPlaceholder": [{"type":0,"value":"sales or sales@"},{"type":1,"value":"domain"}],
    "mail.settings.forwardTo": "Forward to",
    "mail.settings.forwardPlaceholder": "someone@elsewhere.com",
    "mail.settings.keepCopy": "Keep a copy in Bundle",
    "mail.settings.routingSave": "Save",
    "mail.settings.add": "Add",
    "mail.settings.aliasOf": "Alias of",
    "mail.settings.aliasOf.none": "Its own domain",
    "mail.settings.aliasOfHelp": [{"type":0,"value":"Mail to anyone@"},{"type":1,"value":"domain"},{"type":0,"value":" goes to the same name at the chosen domain."}],
    "mail.settings.sendPaused.bounces": "Sending is paused: too many messages from this domain bounced lately. Check the addresses people write to, then resume.",
    "mail.settings.sendPaused.complaints": "Sending is paused: recipients marked too many messages from this domain as spam lately. Check what's being sent, then resume.",
    "mail.settings.sendPaused.resume": "Resume sending",
    "mail.settings.records.allFound": [{"type":0,"value":"All "},{"type":1,"value":"count"},{"type":0,"value":" DNS records found"}],
    "mail.settings.records.toggle": "Show or hide the DNS records",
    "mail.settings.mailboxesFor": "Create mailboxes for",
    "mail.settings.mailboxesForHelp": "Made automatically once the domain's DNS records are in place, each at the person's own name.",
    "mail.settings.mailboxesFor.me": "Just me",
    "mail.settings.mailboxesFor.everyone": "Every member",
    "mail.settings.mailboxesFor.none": "Nobody yet (I'll add them)",
    "mail.settings.mailboxAddress": "Address",
    "mail.settings.mailboxName": "Display name",
    "mail.settings.mailboxKind.personal": "Personal",
    "mail.settings.mailboxKind.shared": "Shared",
    "mail.settings.mailboxMembers": "Who can read it",
    "mail.settings.deleteMailbox": "Delete mailbox",
    "mail.settings.domainNotReady": "Verify a domain's ownership first (its TXT record)",
    "mail.settings.invalidDomain": "Enter a domain like yourcompany.com",
    "mail.settings.invalidLocalPart": "Use letters, numbers, dots or dashes",
    "mail.settings.failed": "Something went wrong. Try again.",
    "mail.back": "Back",
    "mail.more": "More actions",
    "mail.undo.archived": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Conversation archived"}]},"other":{"value":[{"type":7},{"type":0,"value":" conversations archived"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.trashed": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Conversation moved to Trash"}]},"other":{"value":[{"type":7},{"type":0,"value":" conversations moved to Trash"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.spam": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Conversation marked as spam"}]},"other":{"value":[{"type":7},{"type":0,"value":" conversations marked as spam"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.inbox": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Conversation moved to Inbox"}]},"other":{"value":[{"type":7},{"type":0,"value":" conversations moved to Inbox"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.priority": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Marked as priority"}]},"other":{"value":[{"type":0,"value":"Marked "},{"type":7},{"type":0,"value":" as priority"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.priority.sender": [{"type":0,"value":"Marked as priority. "},{"type":1,"value":"name"},{"type":0,"value":"'s next emails will be too."}],
    "mail.undo.notPriority": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Marked not priority"}]},"other":{"value":[{"type":0,"value":"Marked "},{"type":7},{"type":0,"value":" not priority"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.notPriority.sender": [{"type":0,"value":"Not priority. "},{"type":1,"value":"name"},{"type":0,"value":"'s next emails won't be either."}],
    "mail.select": [{"type":0,"value":"Select "},{"type":1,"value":"subject"}],
    "mail.selectAll": "Select all",
    "mail.selectedCount": [{"type":1,"value":"count"},{"type":0,"value":" selected"}],
    "mail.clearSelection": "Clear selection",
    "mail.folder.starred": "Starred",
    "mail.folder.snoozed": "Snoozed",
    "mail.folder.scheduled": "Scheduled",
    "mail.folder.drafts": "Drafts",
    "mail.labels": "Labels",
    "mail.label.new": "New label",
    "mail.label.namePlaceholder": "Label name",
    "mail.action.snooze": "Snooze",
    "mail.action.unsnooze": "Unsnooze",
    "mail.action.labelAs": [{"type":0,"value":"Label: "},{"type":1,"value":"label"}],
    "mail.action.cancelSend": "Cancel send",
    "mail.snooze.option": [{"type":1,"value":"option"},{"type":0,"value":" · "},{"type":1,"value":"time"}],
    "mail.time.laterToday": "Later today",
    "mail.time.tomorrowMorning": "Tomorrow morning",
    "mail.time.tomorrowAfternoon": "Tomorrow afternoon",
    "mail.time.thisWeekend": "This weekend",
    "mail.time.nextWeek": "Next week",
    "mail.time.mondayMorning": "Monday morning",
    "mail.snoozedUntil": [{"type":0,"value":"Until "},{"type":1,"value":"time"}],
    "mail.scheduledFor": [{"type":0,"value":"Scheduled for "},{"type":1,"value":"time"}],
    "mail.compose.schedule": "Schedule send",
    "mail.compose.saved": "Draft saved",
    "mail.compose.replyKind": [{"type":0,"value":"Reply type: "},{"type":1,"value":"kind"}],
    "mail.compose.removeQuote": "Remove quoted text",
    "mail.compose.saveFailed": "Draft not saved",
    "mail.compose.undo": "Undo",
    "mail.compose.scheduled": [{"type":0,"value":"Scheduled for "},{"type":1,"value":"time"}],
    "mail.drafts.empty": "No drafts",
    "mail.draft.label": "Draft",
    "mail.draft.discard": "Discard draft",
    "mail.reader.empty": "No conversation selected",
    "mail.reader.emptyHelp": "Pick a conversation to read it here.",
    "mail.showMessages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Show "},{"type":7},{"type":0,"value":" message"}]},"other":{"value":[{"type":0,"value":"Show "},{"type":7},{"type":0,"value":" messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.reply.kind": [{"type":0,"value":"Reply type: "},{"type":1,"value":"kind"}],
    "mail.reply.editRecipients": "Edit recipients",
    "mail.reply.editSubject": "Edit subject",
    "mail.reply.popOut": "Pop out",
    "mail.reply.popped": "You're editing this reply in a separate window.",
    "mail.reply.showHere": "Show it here",
    "mail.reply.moveBack": "Move back to the thread",
    "mail.reply.sendKey": [{"type":1,"value":"mod"},{"type":0,"value":"Enter"}],
    "mail.olderMessages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" older message"}]},"other":{"value":[{"type":7},{"type":0,"value":" older messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.showQuoted": "Show trimmed content",
    "mail.folders": "Folders",
    "mail.mailboxes": "Mailboxes",
    "mail.tabs": "Categories",
    "mail.noSubject": "(no subject)",
    "mail.compose.removeAttachment": "Remove attachment",
    "mail.settings.adminsOnly": "Only workspace owners and admins can manage mail domains and mailboxes.",
    "mail.signature.title": "Signature",
    "mail.signature.help": "Added below what you write. Each mailbox you send from has its own, with bold, italic and links.",
    "mail.signature.mailbox": "Mailbox",
    "mail.signature.editor": "Signature text",
    "mail.signature.placeholder": "Your name, role, phone…",
    "mail.signature.onNew": "Add to new messages",
    "mail.signature.onReply": "Add to replies and forwards",
    "mail.signature.sentWith": "Add “Sent with Bundle” to my emails",
    "mail.signature.sentWithHint": "A small grey line linking to Bundle, below your signature. You can leave it off any message before you send it.",
    "mail.signature.sentWithShared": "On for shared mailboxes too, until you turn it off for this one.",
    "mail.signature.sentWithLocked": [{"type":0,"value":"Turned off for "},{"type":1,"value":"workspace"},{"type":0,"value":" by an admin."}],
    "mail.signature.sentWithPreview": "Preview",
    "mail.sentWith.title": "Sent with Bundle",
    "mail.sentWith.admins": "Admins",
    "mail.sentWith.line": "Sent with Bundle · mail, chat and calls in one app",
    "mail.signature.save": "Save",
    "mail.signature.saved": "Signature saved",
    "mail.signature.saveFailed": "Couldn't save the signature. Try again.",
    "mail.signature.offline": "You're offline. Connect to save your signature.",
    "mail.signature.noMailbox": "You don't have a mailbox to send from yet.",
    "mail.apps.title": "Mail apps",
    "mail.apps.help": "Read and send your Bundle mail in Apple Mail, Outlook, Thunderbird, Spark or Gmail, and sync your calendar and contacts. Apps sign in with your email address and an app password, not your Bundle sign-in.",
    "mail.apps.create": "Create app password",
    "mail.apps.failed": "The app password couldn't be created. Try again.",
    "mail.apps.profile": "Download profile",
    "mail.apps.password": "App password",
    "mail.apps.apple.title": "Set up on iPhone or Mac",
    "mail.apps.apple.help": "One profile adds every mailbox you have here, your calendar and your contacts.",
    "mail.apps.apple.install": "On iPhone, open Settings → Profile Downloaded → Install. On a Mac, open System Settings → General → Device Management. The profile isn't signed, so it shows as Unverified. Calendar and Contacts appear as their own accounts.",
    "mail.apps.other.title": "Other apps",
    "mail.apps.other.help": "Outlook, Thunderbird, Spark, Gmail, DAVx⁵ and others.",
    "mail.apps.once": "Shown once. Sign in with your email address and this password; most apps find the server settings themselves.",
    "mail.apps.perDevice": "Each device or app gets its own app password (or profile), and making a new one never signs the others out. You can revoke any of them on its own.",
    "mail.apps.server.title": "Server settings",
    "mail.apps.server.help": "For apps that ask for them.",
    "mail.apps.server.imap": "Incoming mail (IMAP)",
    "mail.apps.server.imapPort": "Port 993 · SSL/TLS",
    "mail.apps.server.smtp": "Outgoing mail (SMTP)",
    "mail.apps.server.smtpPort": "Port 465 · SSL/TLS, or port 587 · STARTTLS",
    "mail.apps.server.dav": "Calendar and contacts (CalDAV, CardDAV)",
    "mail.apps.server.davPort": "Port 443 · SSL/TLS",
    "mail.apps.server.user": "User name",
    "mail.apps.server.userMine": "Your full email address",
    "mail.apps.server.userShared": "Shared mailbox",
    "mail.apps.server.password": "Password",
    "mail.apps.server.passwordValue": "An app password (above)",
    "mail.apps.copy": "Copy",
    "mail.settings.record.copied": "Copied",
    "docs.title": "Docs",
    "docs.filter.all": "All",
    "docs.filter.recent": "Recent",
    "docs.filter.mine": "Created by me",
    "docs.filter.favorites": "Favorites",
    "docs.filter.databases": "Databases",
    "docs.search": "Search docs",
    "docs.new": "New page",
    "docs.edited": [{"type":0,"value":"Edited "},{"type":1,"value":"when"}],
    "nav.calendar": "Calendar",
    "calendar.title": "Calendar",
    "calendar.today": "Today",
    "calendar.view.day": "Day",
    "calendar.view.week": "Week",
    "calendar.view.month": "Month",
    "calendar.prev": "Previous",
    "calendar.next": "Next",
    "calendar.allDay": "All day",
    "calendar.new": "New event",
    "calendar.scope.this": "This event",
    "calendar.scope.following": "This and following events",
    "calendar.scope.all": "All events",
    "calendar.scope.editTitle": "Edit repeating event",
    "calendar.scope.rsvpTitle": "Answer repeating event",
    "calendar.phone.title": "Sync with your phone",
    "calendar.phone.intro": "See your Bundle events in Apple Calendar, Google Calendar, Outlook or any calendar app.",
    "calendar.phone.subscribe": "Subscription link",
    "calendar.phone.subscribeHelp": "Add it as a subscribed calendar: on iPhone, Settings → Apps → Calendar → Calendar Accounts → Add Account → Other → Add Subscribed Calendar; in Google Calendar, Other calendars → From URL. It's read-only, and Google refreshes it every few hours.",
    "calendar.phone.copy": "Copy link",
    "calendar.phone.copied": "Copied",
    "calendar.phone.open": "Open in calendar app",
    "calendar.phone.reset": "Reset link",
    "calendar.phone.secret": "Anyone with this link can see your events. Reset it if it gets out; the old link stops working.",
    "calendar.phone.dav": "Calendar account (CalDAV)",
    "calendar.phone.davHelp": "Two-way: events you add or change in the phone's calendar come back to Bundle. On iPhone: Settings → Apps → Calendar → Calendar Accounts → Add Account → Other → Add CalDAV Account; on Mac: System Settings → Internet Accounts → Add Other Account → CalDAV Account. On Android, use DAVx5.",
    "calendar.phone.davCreate": "Create app password",
    "calendar.phone.davOff": "Turn off",
    "calendar.phone.davServer": "Server",
    "calendar.phone.davUser": "User name",
    "calendar.phone.davPassword": "Password",
    "calendar.phone.davOnce": "Copy the password now: it isn't shown again. Each device gets its own; the others keep working.",
    "calendar.phone.device": "Sync with phone calendar",
    "calendar.phone.deviceHint": [{"type":1,"value":"workspace"},{"type":0,"value":"'s events show in Google Calendar and other calendar apps on this phone, and changes you make there come back to Bundle."}],
    "calendar.phone.deviceDenied": "Allow calendar access for Bundle in Android settings to sync.",
    "calendar.more": [{"type":1,"value":"count"},{"type":0,"value":" more"}],
    "calendar.moreActions": "More",
    "calendar.booking.title": "Booking pages",
    "calendar.booking.copyLink": "Copy link",
    "calendar.booking.linkCopied": "Link copied",
    "calendar.booking.share": "Share",
    "calendar.booking.open": "Open booking page",
    "calendar.booking.pause": "Pause",
    "calendar.booking.resume": "Resume",
    "calendar.booking.paused": "Paused",
    "calendar.booking.empty": "No booking pages yet",
    "calendar.booking.emptyHint": "Create booking pages in Bundle on the web or the desktop app, then share them from here.",
    "calendar.booking.footer": "Create and edit pages on the web or desktop app.",
    "calendar.booking.loadFailed": "Couldn’t load your booking pages.",
    "calendar.booking.updateFailed": "Couldn’t update the booking page.",
    "calendar.booking.bookedVia": [{"type":0,"value":"Booked via "},{"type":1,"value":"page"}],
    "calendar.booking.minutes": [{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "calendar.booking.hours": [{"type":1,"value":"hours"},{"type":0,"value":" h"}],
    "calendar.booking.hoursMinutes": [{"type":1,"value":"hours"},{"type":0,"value":" h "},{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "calendar.booking.location.bundleMeeting": "Bundle meeting",
    "calendar.booking.location.inPerson": "In person",
    "calendar.booking.location.phone": "Phone call",
    "calendar.showAsFree": "Show as free",
    "calendar.event.title": "Add title",
    "calendar.event.when": "When",
    "calendar.event.starts": "Starts",
    "calendar.event.ends": "Ends",
    "calendar.event.location": "Add location",
    "calendar.event.description": "Add description",
    "calendar.event.guests": "Add guests",
    "calendar.event.guestsHelp": "Members or email addresses",
    "calendar.event.huddleHelp": "A Bundle Meet link in the invitation",
    "calendar.event.outsideGuests": "Guests outside the workspace get the invitation by email",
    "calendar.event.guestsPlaceholder": "Add guests — members or email addresses",
    "calendar.event.optional": "Optional",
    "calendar.event.organizer": "Organizer",
    "calendar.event.huddle": "Add Meet",
    "calendar.event.joinHuddle": "Join meeting",
    "calendar.event.visibility.attendees": "Only guests",
    "calendar.event.visibility.workspace": "Everyone in the workspace",
    "calendar.event.inviteFrom": "Send invitations from",
    "calendar.event.reminder": "Remind me",
    "calendar.event.reminderMinutes": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" minute before"}]},"other":{"value":[{"type":7},{"type":0,"value":" minutes before"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.reminder.none": "No reminder",
    "calendar.reminder.atStart": "At time of event",
    "calendar.reminder.hours": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" hour before"}]},"other":{"value":[{"type":7},{"type":0,"value":" hours before"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.reminder.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" day before"}]},"other":{"value":[{"type":7},{"type":0,"value":" days before"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.reminder.sameDayAt": [{"type":0,"value":"On the day at "},{"type":1,"value":"time"}],
    "calendar.reminder.daysBeforeAt": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"The day before at "},{"type":1,"value":"time"}]},"other":{"value":[{"type":7},{"type":0,"value":" days before at "},{"type":1,"value":"time"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.reminder.email": "Also email me",
    "calendar.reminder.title": "Notification",
    "calendar.event.save": "Save",
    "calendar.event.delete": "Delete event",
    "calendar.event.deleteOccurrence": "Delete only this event",
    "calendar.event.deleteFollowing": "Delete this and following events",
    "calendar.event.deleteSeries": "Delete all events",
    "calendar.event.edit": "Edit event",
    "calendar.repeat": "Repeat",
    "calendar.repeat.none": "Does not repeat",
    "calendar.repeat.daily": "Daily",
    "calendar.repeat.weekly": "Weekly",
    "calendar.repeat.weekdays": "Every weekday (Mon–Fri)",
    "calendar.repeat.monthly": "Monthly",
    "calendar.repeat.yearly": "Yearly",
    "calendar.rsvp.question": "Going?",
    "calendar.rsvp.accepted": "Yes",
    "calendar.rsvp.declined": "No",
    "calendar.rsvp.tentative": "Maybe",
    "calendar.rsvp.needsAction": "Awaiting",
    "calendar.guests.summary": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" guest"}]},"other":{"value":[{"type":7},{"type":0,"value":" guests"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.empty": "Nothing scheduled",
    "calendar.loadFailed": "Couldn't load the calendar",
    "calendar.error.noTitle": "Add a title",
    "calendar.error.endBeforeStart": "The event must end after it starts",
    "calendar.error.saveFailed": "Couldn't save. Try again.",
    "calendar.event.imported": "Imported from Google Calendar",
    "calendar.event.joinMeet": "Join with Google Meet",
    "calendar.event.joinVideo": "Join video call",
    "calendar.mine": "My calendars",
    "calendar.fromGoogle": "from Google",
    "calendar.googleSync": "Google Calendar keeps syncing here until the Google sync is stopped.",
    "calendar.repeat.custom": "Custom…",
    "calendar.repeat.customTitle": "Custom recurrence",
    "calendar.repeat.every": "Repeat every",
    "calendar.repeat.every.daily": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Daily"}]},"other":{"value":[{"type":0,"value":"Every "},{"type":7},{"type":0,"value":" days"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.every.weekly": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Weekly"}]},"other":{"value":[{"type":0,"value":"Every "},{"type":7},{"type":0,"value":" weeks"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.every.weeklyOn": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Weekly on "},{"type":1,"value":"days"}]},"other":{"value":[{"type":0,"value":"Every "},{"type":7},{"type":0,"value":" weeks on "},{"type":1,"value":"days"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.every.monthly": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Monthly"}]},"other":{"value":[{"type":0,"value":"Every "},{"type":7},{"type":0,"value":" months"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.every.yearly": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Yearly"}]},"other":{"value":[{"type":0,"value":"Every "},{"type":7},{"type":0,"value":" years"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.until": [{"type":0,"value":"until "},{"type":1,"value":"date"}],
    "calendar.repeat.times": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" time"}]},"other":{"value":[{"type":7},{"type":0,"value":" times"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.unit.daily": "day",
    "calendar.repeat.units.daily": "days",
    "calendar.repeat.unit.weekly": "week",
    "calendar.repeat.units.weekly": "weeks",
    "calendar.repeat.unit.monthly": "month",
    "calendar.repeat.units.monthly": "months",
    "calendar.repeat.unit.yearly": "year",
    "calendar.repeat.units.yearly": "years",
    "calendar.repeat.on": "Repeat on",
    "calendar.repeat.ends": "Ends",
    "calendar.repeat.endsNever": "Never",
    "calendar.repeat.endsOn": "On",
    "calendar.repeat.endsAfter": "After",
    "calendar.repeat.occurrence": "occurrence",
    "calendar.repeat.occurrences": "occurrences",
    "calendar.event.timeZone": "Time zone",
    "calendar.event.timeZoneHelp": "Times show in this zone. Guests see them in their own.",
    "calendar.event.markOptional": "Mark optional",
    "calendar.event.markRequired": "Mark required",
    "calendar.event.you": [{"type":1,"value":"name"},{"type":0,"value":" (you)"}],
    "calendar.meetSwap.joinLine": "Join Bundle meeting",
    "calendar.meetSwap.inviteNote": "This meeting moved to Bundle. The Google Meet link no longer applies.",
    "calendar.meetSwap.answerKept": "Your answer: kept",
    "calendar.meetSwap.oldLink": "Old Google Meet link",
    "calendar.meetSwap.lockedByAdmin": [{"type":0,"value":"Turned on for "},{"type":1,"value":"workspace"},{"type":0,"value":" by an admin."}],
    "calendar.meetSwap.activityTitle": "Your meetings moved to Bundle",
    "calendar.meetSwap.activityBody": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" event now uses a Bundle meeting instead of Google Meet."}]},"other":{"value":[{"type":7},{"type":0,"value":" events now use Bundle meetings instead of Google Meet."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.skip.googleScope": "An admin needs to let Bundle edit calendars",
    "calendar.meetSwap.skip.googleError": "Google didn't accept the change",
    "calendar.meetSwap.skip.notOrganizer": "You don't organise this event any more",
    "calendar.meetSwap.skip.noMeet": "No Google Meet link any more",
    "calendar.meetSwap.skip.ended": "Already over",
    "calendar.meetSwap.skip.gone": "Deleted",
    "calendar.meetSwap.skip.noMailbox": "No mailbox to email guests from",
    "calendar.meetSwap.skip.mailError": "The updated invitation couldn't be sent",
    "calendar.meetSwap.prompt.title": "Use a Bundle meeting instead?",
    "calendar.meetSwap.prompt.body": "Guests join from a link in their browser. No Google account needed. We'll email them the new link.",
    "calendar.meetSwap.prompt.justThis": "Just this event",
    "calendar.meetSwap.prompt.justThisHint": "All its repeats",
    "calendar.meetSwap.prompt.upcoming": "All my upcoming events",
    "calendar.meetSwap.prompt.upcomingCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" event you organise uses Google Meet"}]},"other":{"value":[{"type":7},{"type":0,"value":" events you organise use Google Meet"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.prompt.always": "Always use Bundle meetings for new events I organise",
    "calendar.meetSwap.prompt.alwaysShort": "Always for new events I organise",
    "calendar.meetSwap.prompt.move": "Move to Bundle",
    "calendar.meetSwap.prompt.notNow": "Not now",
    "calendar.meetSwap.useBundle": "Use a Bundle meeting",
    "calendar.meetSwap.confirm.title": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Move "},{"type":7},{"type":0,"value":" event to Bundle meetings?"}]},"other":{"value":[{"type":0,"value":"Move "},{"type":7},{"type":0,"value":" events to Bundle meetings?"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.confirm.body": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" guest gets an updated invite with the new link. Their answers stay as they are."}]},"other":{"value":[{"type":7},{"type":0,"value":" guests get an updated invite with the new link. Their answers stay as they are."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.confirm.notify": "Move and email guests",
    "calendar.meetSwap.confirm.silent": "Don't email guests",
    "calendar.meetSwap.moved": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Moved "},{"type":7},{"type":0,"value":" event to Bundle. Guests are getting the new link."}]},"other":{"value":[{"type":0,"value":"Moved "},{"type":7},{"type":0,"value":" events to Bundle. Guests are getting the new link."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.undo": "Undo",
    "calendar.meetSwap.settings.section": "Video calls",
    "calendar.meetSwap.settings.toggle": "Add a Bundle meeting to new events I organise",
    "calendar.meetSwap.settings.toggleHint": "When the event has guests. Booking pages use one too.",
    "calendar.meetSwap.settings.moving": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Moving "},{"type":7},{"type":0,"value":" event to Bundle meetings"}]},"other":{"value":[{"type":0,"value":"Moving "},{"type":7},{"type":0,"value":" events to Bundle meetings"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.settings.progress": [{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "calendar.meetSwap.settings.progressHint": "Guests get their updated invites a few at a time. You can close Bundle; this keeps going.",
    "calendar.meetSwap.settings.restore": "Put the Google Meet links back",
    "calendar.meetSwap.settings.restoreHint": "For the events moved in the last 30 days. Guests get another update.",
    "calendar.meetSwap.settings.restoreAction": "Restore…",
    "calendar.meetSwap.settings.restoreConfirm": "Put the Google Meet links back?",
    "calendar.meetSwap.settings.skipped": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" event couldn't be changed."}]},"other":{"value":[{"type":7},{"type":0,"value":" events couldn't be changed."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.policy.title": "Video calls on calendar events",
    "calendar.meetSwap.policy.member": "Each person chooses",
    "calendar.meetSwap.policy.memberHint": "Members get the one-time offer and their own setting.",
    "calendar.meetSwap.policy.bundle": "Bundle meetings for everyone",
    "calendar.meetSwap.policy.bundleHint": "New events members organise get a Bundle meeting, and their Google Meet links are replaced. Members can't turn it off.",
    "calendar.meetSwap.policy.moving": "Moving members' events",
    "calendar.meetSwap.policy.progress": [{"type":1,"value":"people"},{"type":0,"value":" of "},{"type":1,"value":"peopleTotal"},{"type":0,"value":" people · "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" events"}],
    "calendar.meetSwap.policy.progressHint": "Runs in the background, a few people at a time. Guests get updated invites gradually, so it can take a few hours.",
    "calendar.meetSwap.policy.pause": "Pause",
    "calendar.meetSwap.policy.resume": "Resume",
    "calendar.meetSwap.policy.restoreAll": "Put the Google Meet links back for everyone",
    "calendar.meetSwap.policy.restoreAllHint": "For events this policy moved in the last 30 days. Guests get another update.",
    "calendar.meetSwap.policy.confirmTitle": [{"type":0,"value":"Use Bundle meetings for everyone at "},{"type":1,"value":"workspace"},{"type":0,"value":"?"}],
    "calendar.meetSwap.policy.confirmBody": "New events members organise get a Bundle meeting. Members can't turn this off. It runs in the background.",
    "calendar.meetSwap.policy.moveAndEmail": "Move existing events and email guests",
    "calendar.meetSwap.policy.moveSilent": "Move existing events without emailing",
    "calendar.meetSwap.policy.newOnly": "Only new events",
    "calendar.rsvp.failed": "Couldn't send your answer. Try again.",
    "calendar.loading": "Loading",
    "calendar.bookingPages.title": "Booking pages",
    "calendar.bookingPages.empty": "No booking pages yet",
    "calendar.bookingPages.emptyHint": "Create booking pages in Bundle on the web or the desktop app. They show up here so you can share them.",
    "calendar.bookingPages.loadFailed": "Couldn't load your booking pages.",
    "calendar.bookingPages.updateFailed": "Couldn't update the booking page. Try again.",
    "calendar.bookingPages.copyLink": "Copy link",
    "calendar.bookingPages.linkCopied": "Link copied",
    "calendar.bookingPages.share": "Share",
    "calendar.bookingPages.shareNamed": [{"type":0,"value":"Share "},{"type":1,"value":"title"}],
    "calendar.bookingPages.moreNamed": [{"type":0,"value":"More for "},{"type":1,"value":"title"}],
    "calendar.bookingPages.open": "Open booking page",
    "calendar.bookingPages.pause": "Pause",
    "calendar.bookingPages.resume": "Resume",
    "calendar.bookingPages.paused": "Paused",
    "calendar.bookingPages.minutes": [{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "calendar.bookingPages.location.bundleMeeting": "Bundle meeting",
    "calendar.bookingPages.location.inPerson": "In person",
    "calendar.bookingPages.location.phone": "Phone call",
    "calendar.event.bookedVia": [{"type":0,"value":"Booked via "},{"type":1,"value":"title"}],
    "calendar.event.showAsFree": "Show as free",
    "calendar.moreOptions": "More options",
    "import.timeline.title": "Step by step",
    "import.timeline.started": [{"type":0,"value":"Started reading "},{"type":1,"value":"source"}],
    "import.timeline.people": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Found "},{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":0,"value":"Found "},{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.conversations": [{"type":0,"value":"Found "},{"type":1,"value":"channels"},{"type":0,"value":" channels and "},{"type":1,"value":"dms"},{"type":0,"value":" direct messages"}],
    "import.timeline.pages": [{"type":0,"value":"Found pages: "},{"type":1,"value":"pages"},{"type":0,"value":" · databases: "},{"type":1,"value":"databases"}],
    "import.timeline.sorting": "Sorting the pages with AI",
    "import.timeline.sorted": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"AI proposed "},{"type":7},{"type":0,"value":" section"}]},"other":{"value":[{"type":0,"value":"AI proposed "},{"type":7},{"type":0,"value":" sections"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.sortSkipped": "Kept the source's own layout (no AI sorting)",
    "import.timeline.review": "Ready for your review",
    "import.timeline.importing": "Import started",
    "import.timeline.channel": [{"type":0,"value":"Created "},{"type":1,"value":"name"}],
    "import.timeline.history": [{"type":1,"value":"name"},{"type":0,"value":": read "},{"type":1,"value":"count"},{"type":0,"value":" messages so far"}],
    "import.timeline.files": [{"type":1,"value":"name"},{"type":0,"value":": copied "},{"type":1,"value":"count"},{"type":0,"value":" files so far"}],
    "import.timeline.channelDone": [{"type":1,"value":"name"},{"type":0,"value":": imported "},{"type":1,"value":"count"},{"type":0,"value":" messages"}],
    "import.timeline.page": [{"type":0,"value":"Imported the page "},{"type":1,"value":"title"}],
    "import.timeline.database": [{"type":0,"value":"Created the database "},{"type":1,"value":"title"}],
    "import.timeline.rows": [{"type":1,"value":"title"},{"type":0,"value":": "},{"type":1,"value":"count"},{"type":0,"value":" rows added"}],
    "import.timeline.canvas": [{"type":0,"value":"Made the Slack canvas "},{"type":1,"value":"title"},{"type":0,"value":" a page"}],
    "import.timeline.filesRepaired": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Fixed the file links in "},{"type":7},{"type":0,"value":" message"}]},"other":{"value":[{"type":0,"value":"Fixed the file links in "},{"type":7},{"type":0,"value":" messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.slack.repairLinks": "Only bring over files still linked to Slack",
    "import.slack.repairLinks.note": "Nothing new is imported: messages already here that still link to Slack files get those files (canvases become pages), and the timeline says why any couldn't come over.",
    "import.timeline.repairing": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Found "},{"type":7},{"type":0,"value":" message still linking to Slack files"}]},"other":{"value":[{"type":0,"value":"Found "},{"type":7},{"type":0,"value":" messages still linking to Slack files"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.renamed": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Fixed the name of "},{"type":7},{"type":0,"value":" person who showed as their Slack @handle"}]},"other":{"value":[{"type":0,"value":"Fixed the names of "},{"type":7},{"type":0,"value":" people who showed as their Slack @handle"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.fileNotFound": [{"type":1,"value":"name"},{"type":0,"value":": Slack no longer has this file (deleted, or this token can't see it)"}],
    "import.timeline.fileNoAccess": [{"type":1,"value":"name"},{"type":0,"value":": Slack wouldn't hand this file over (hidden by the plan's limits, or shared from another workspace)"}],
    "import.timeline.fileTooBig": [{"type":1,"value":"name"},{"type":0,"value":": bigger than 1 GB, left as a Slack link"}],
    "import.timeline.canvasUnreadable": [{"type":1,"value":"name"},{"type":0,"value":": Slack didn't give this canvas's content, left as a Slack link"}],
    "import.timeline.fileFailed": [{"type":1,"value":"name"},{"type":0,"value":": the copy failed, left as a Slack link"}],
    "import.repairTitle": "Files from Slack",
    "import.timeline.rateLimited": [{"type":0,"value":"The source asked to slow down: waiting "},{"type":1,"value":"seconds"},{"type":0,"value":" s"}],
    "import.timeline.retrying": [{"type":0,"value":"Attempt "},{"type":1,"value":"attempt"},{"type":0,"value":" failed, retrying: "},{"type":1,"value":"message"}],
    "import.timeline.done": "Import finished",
    "import.timeline.failed": [{"type":0,"value":"Stopped: "},{"type":1,"value":"message"}],
    "import.timeline.cancelled": "Stopped by you",
    "import.slack.person.invite": "Invite to Bundle",
    "import.slack.person.guest": [{"type":0,"value":"Invite as external guest ("},{"type":1,"value":"org"},{"type":0,"value":")"}],
    "import.slack.person.otherCompany": "other company",
    "import.slack.person.deactivated": "Keep as deactivated profile",
    "import.slack.inviteAll": "Invite everyone missing",
    "import.slack.external": [{"type":0,"value":"External · "},{"type":1,"value":"org"}],
    "import.slack.apps": "Conversations with apps",
    "import.slack.apps.body": "Off by default. Each one you pick comes over as a private channel just for you (like #notion-dm), with the app's messages under its name.",
    "import.slack.allApps": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Import the conversation with an app"}]},"other":{"value":[{"type":0,"value":"Import all "},{"type":7},{"type":0,"value":" conversations with apps"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.invited": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Invited "},{"type":7},{"type":0,"value":" person (their history is theirs when they join)"}]},"other":{"value":[{"type":0,"value":"Invited "},{"type":7},{"type":0,"value":" people (their history is theirs when they join)"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.guests": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Invited "},{"type":7},{"type":0,"value":" external guest"}]},"other":{"value":[{"type":0,"value":"Invited "},{"type":7},{"type":0,"value":" external guests"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.deactivatedPeople": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Kept "},{"type":7},{"type":0,"value":" deactivated profile"}]},"other":{"value":[{"type":0,"value":"Kept "},{"type":7},{"type":0,"value":" deactivated profiles"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.rescan": "Read again",
    "import.rescanFailed": "Couldn't read the source again. Try again.",
    "import.slack.sendInvites": "Email the invites now",
    "import.slack.sendInvites.off": "Nobody is emailed. Accounts and pending invites are still created; send them later from Invitations (Resend).",
    "import.slack.restrictExternal": "People from other companies only get the channels they were in",
    "newMessage.title": "New message",
    "newMessage.to": "To:",
    "newMessage.toPlaceholder": "Type a name",
    "newMessage.limit": [{"type":0,"value":"Group conversations can have up to "},{"type":1,"value":"max"},{"type":0,"value":" people."}],
    "newMessage.existing": [{"type":0,"value":"Continue your conversation with "},{"type":1,"value":"name"}],
    "newMessage.start": [{"type":0,"value":"This is the start of your conversation with "},{"type":1,"value":"name"}],
    "newMessage.open": "Open conversation",
    "newMessage.recent": "Recent conversations",
    "newMessage.noConversations": "No conversations match",
    "newMessage.failed": "Couldn't start the conversation. Try again.",
    "newMessage.offline": "Starting a new conversation needs a connection.",
    "sidebar.moreConversations": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" more conversation…"}]},"other":{"value":[{"type":7},{"type":0,"value":" more conversations…"}]}},"offset":0,"pluralType":"cardinal"}],
    "dm.close": "Close conversation",
    "dm.addPeople": "Add people",
    "dm.addPeopleHint": "Adding people starts a new conversation. This one stays as it is.",
    "dm.convert": "Convert to private channel",
    "dm.convertHint": "Everyone in this conversation becomes a member of the channel, and the history stays.",
    "dm.convertName": "Channel name",
    "dm.convertAction": "Convert",
    "mail.notify.title": "New email",
    "mail.notify.enabled": "Notify me about new email",
    "mail.notify.priority": "Priority conversations",
    "mail.notify.priorityHelp": "Replies people are waiting on, starred conversations and senders you marked, from any tab.",
    "mail.notify.tabsAlso": "Also everything in these tabs",
    "mail.notify.tabs": "Only for these tabs",
    "mail.notify.uncategorized": "Uncategorized",
    "mail.notify.help": "Spam never notifies. Do not disturb pauses the rest too. Verification codes always notify.",
    "mail.settings.provider": [{"type":0,"value":"DNS at "},{"type":1,"value":"name"}],
    "mail.settings.providerUnknown": "Add these records where your domain's DNS is managed.",
    "mail.settings.openDns": "Open DNS settings",
    "mail.settings.zoneFile": "Download zone file",
    "mail.settings.zoneFile.help": "A file with every record above, for importing at your DNS provider instead of copying them one by one.",
    "mail.settings.zoneFile.cloudflare": "At Cloudflare: DNS → Records → Import and Export → Import, choose this file. Then delete the old records it replaces: the other MX records (e.g. Email Routing's route1/2/3.mx.cloudflare.net), the old SPF TXT (the v=spf1 one without _spf.bundle.direct) and the old _dmarc record.",
    "mail.settings.zoneFile.other": [{"type":0,"value":"At "},{"type":1,"value":"name"},{"type":0,"value":": use the DNS page's import option and choose this file. Then delete the old records it replaces: other MX records, the old SPF TXT and the old _dmarc record."}],
    "mail.sync.title": "Import mail",
    "mail.sync.help": "Bring your existing mail into Bundle and keep it syncing while you move your MX records. Replies to old threads land in the right conversation. Imported mail never notifies anyone.",
    "mail.sync.connectGoogle": "Connect Google Workspace",
    "mail.sync.addImap": "Add IMAP account",
    "mail.sync.noMailboxes": "Create a mailbox first: imported mail goes into one.",
    "mail.sync.connect": "Connect",
    "mail.sync.google.title": "Google Workspace",
    "mail.sync.google.step1": "1. In Google Cloud, create a service account with a JSON key, and enable the Gmail API, the Admin SDK API, the Groups Settings API and the Google Calendar API.",
    "mail.sync.google.step2": "2. In the Google Admin console, go to Security → API controls → Domain-wide delegation, and add the service account's client ID with these scopes:",
    "mail.sync.google.scopes": "gmail.readonly, admin.directory.user.readonly, admin.directory.domain.readonly, admin.directory.group.readonly, apps.groups.settings, calendar.readonly",
    "mail.sync.google.copyScopes": "Copy scopes",
    "mail.sync.google.step3": "3. Paste the key here with a super admin's address. Everyone's mail is imported into the mailbox with the same name, and a shared mailbox can be read by the people Gmail delegation lets read it (gmail.readonly lists them).",
    "mail.sync.google.bundleClient": [{"type":0,"value":"Or authorize Bundle's client ID "},{"type":1,"value":"clientId"},{"type":0,"value":" with the same scopes and leave the key empty."}],
    "mail.sync.google.copyClientId": "Copy client ID",
    "mail.sync.google.adminEmail": "Super admin's address",
    "mail.sync.google.key": "Service account key (JSON)",
    "mail.sync.google.keyHelp": "Stored encrypted. Bundle only reads mail.",
    "mail.sync.google.keyOptional": "Optional with Bundle's client ID. Stored encrypted. Bundle only reads mail.",
    "mail.sync.google.users": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" user"}]},"other":{"value":[{"type":7},{"type":0,"value":" users"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.dontImport": "Don't import",
    "mail.sync.google.mailboxFor": [{"type":0,"value":"Mailbox for "},{"type":1,"value":"email"}],
    "mail.sync.imap.title": "IMAP account",
    "mail.sync.imap.into": "Import into",
    "mail.sync.imap.username": "Email address or username",
    "mail.sync.imap.password": "Password",
    "mail.sync.imap.passwordHelp": "Most providers need an app password when 2-step verification is on. Stored encrypted.",
    "mail.sync.imap.appPassword": [{"type":0,"value":"Use an app password: "},{"type":1,"value":"url"},{"type":0,"value":". Stored encrypted."}],
    "mail.sync.imap.host": "IMAP server",
    "mail.sync.imap.port": "Port",
    "mail.sync.imap.security": "Security",
    "mail.sync.imap.security.tls": "SSL/TLS",
    "mail.sync.imap.security.starttls": "STARTTLS",
    "mail.sync.imap.security.none": "None",
    "mail.sync.imap.folders": "Folders to import",
    "mail.sync.imap.folder": [{"type":1,"value":"path"},{"type":0,"value":" ("},{"type":1,"value":"count"},{"type":0,"value":")"}],
    "mail.sync.imap.check": "Check",
    "mail.sync.imap.start": "Start import",
    "mail.sync.imap.newPassword": "New password",
    "mail.sync.imap.updatePassword": "Update password",
    "mail.sync.phase.connecting": "Connecting",
    "mail.sync.phase.listing": "Counting messages",
    "mail.sync.phase.importing": "Importing",
    "mail.sync.phase.syncing": "Syncing",
    "mail.sync.phase.paused": "Paused",
    "mail.sync.phase.error": "Needs attention",
    "mail.sync.into": [{"type":0,"value":"into "},{"type":1,"value":"address"}],
    "mail.sync.finding": "Finding messages…",
    "mail.sync.counting": [{"type":6,"value":"total","options":{"one":{"value":[{"type":7},{"type":0,"value":" message found so far"}]},"other":{"value":[{"type":7},{"type":0,"value":" messages found so far"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.counts": [{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" messages · "},{"type":1,"value":"duplicates"},{"type":0,"value":" already here · "},{"type":1,"value":"failed"},{"type":0,"value":" failed"}],
    "mail.sync.accountCounts": [{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "mail.sync.lastSync": [{"type":0,"value":"last checked "},{"type":1,"value":"time"}],
    "mail.sync.pause": "Pause",
    "mail.sync.resume": "Resume",
    "mail.sync.remove": "Remove",
    "mail.sync.removeConfirm": "Stop syncing? The mail already imported stays.",
    "mail.sync.refused": [{"type":1,"value":"detail"}],
    "mail.sync.forbidden": "Only workspace admins and the mailbox's members can do that.",
    "mail.sync.failed": "Something went wrong. Try again.",
    "mail.sync.google.reviewTitle": "Choose whose mail to import",
    "mail.sync.google.reviewHelp": "Bundle found these people in your Google Workspace and proposed a mailbox for each. Nothing is imported until you start.",
    "mail.sync.google.newMailbox": [{"type":0,"value":"New mailbox "},{"type":1,"value":"address"}],
    "mail.sync.google.newMailboxHelp": "A new mailbox is the person's own. For someone who hasn't joined yet, nobody can read it until they join; then it becomes theirs.",
    "mail.sync.google.start": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Import "},{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":0,"value":"Import "},{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.phase.review": "Waiting for you",
    "composer.command.appUsage": [{"type":1,"value":"usage"}],
    "composer.appCommand.failed": [{"type":0,"value":"Couldn’t run "},{"type":1,"value":"command"},{"type":0,"value":". Try again."}],
    "workflow.run.failed": [{"type":0,"value":"Couldn’t start "},{"type":1,"value":"name"},{"type":0,"value":". Try again."}],
    "workflow.menu.title": "Workflows",
    "workflow.menu.empty": "No workflows in this channel yet.",
    "workflow.menu.badge": "Workflow",
    "composer.appAction.failed": "The app didn’t respond. Try again.",
    "composer.appCommand.running": [{"type":0,"value":"Running "},{"type":1,"value":"command"},{"type":0,"value":"…"}],
    "message.ephemeral.onlyYou": "Only visible to you",
    "message.ephemeral.dismiss": "Dismiss",
    "appModal.error.required": "Please complete this required field.",
    "appModal.error.tooShort": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Enter at least "},{"type":7},{"type":0,"value":" character."}]},"other":{"value":[{"type":0,"value":"Enter at least "},{"type":7},{"type":0,"value":" characters."}]}},"offset":0,"pluralType":"cardinal"}],
    "appModal.error.tooLong": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Use "},{"type":7},{"type":0,"value":" character or fewer."}]},"other":{"value":[{"type":0,"value":"Use "},{"type":7},{"type":0,"value":" characters or fewer."}]}},"offset":0,"pluralType":"cardinal"}],
    "appModal.error.tooMany": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Choose up to "},{"type":7},{"type":0,"value":" option."}]},"other":{"value":[{"type":0,"value":"Choose up to "},{"type":7},{"type":0,"value":" options."}]}},"offset":0,"pluralType":"cardinal"}],
    "appModal.appError": [{"type":1,"value":"text"}],
    "appModal.unreachable": "We had some trouble connecting. Try again?",
    "appModal.cancel": "Cancel",
    "appModal.submit": "Submit",
    "appModal.back": "Back",
    "appModal.optional": "(optional)",
    "blockKit.select.placeholder": "Select an option",
    "blockKit.multiSelect.placeholder": "Select options",
    "blockKit.users.placeholder": "Select a person",
    "blockKit.multiUsers.placeholder": "Select people",
    "blockKit.conversations.placeholder": "Select a conversation",
    "blockKit.channels.placeholder": "Select a channel",
    "blockKit.date.placeholder": "Select a date",
    "blockKit.time.placeholder": "Select a time",
    "blockKit.overflow.label": "More options",
    "blockKit.search": "Search",
    "blockKit.remove": [{"type":0,"value":"Remove "},{"type":1,"value":"name"}],
    "blockKit.selected": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" selected"}]},"other":{"value":[{"type":7},{"type":0,"value":" selected"}]}},"offset":0,"pluralType":"cardinal"}],
    "integrations.apps.title": "Apps",
    "integrations.apps.body": "Apps have a bot user and a token for the Web API, can add slash commands and buttons, and can be installed in other workspaces with OAuth.",
    "integrations.apps.empty": "No apps yet.",
    "integrations.apps.adminsOnly": "Only workspace owners and admins can create apps.",
    "integrations.app.create": "Create app",
    "integrations.app.edit": "Edit app",
    "integrations.app.save": "Save",
    "integrations.app.cancel": "Cancel",
    "integrations.app.name": "Name",
    "integrations.app.namePlaceholder": "For example: Deployer",
    "integrations.app.description": "Description",
    "integrations.app.scopes": "Permissions (scopes)",
    "integrations.app.redirectUrls": "OAuth redirect URLs",
    "integrations.app.redirectUrlsHelp": "One per line. Needed to install the app in other workspaces.",
    "integrations.app.interactivityUrl": "Interactivity request URL",
    "integrations.app.interactivityHelp": "Button presses are sent here as signed POST requests.",
    "integrations.app.commands": "Slash commands",
    "integrations.app.addCommand": "Add command",
    "integrations.app.removeCommand": "Remove command",
    "integrations.app.command": "Command",
    "integrations.app.commandUrl": "Request URL",
    "integrations.app.commandDescription": "Short description",
    "integrations.app.commandHint": "Usage hint",
    "integrations.app.nameEmpty": "Give the app a name.",
    "integrations.app.commandInvalid": [{"type":1,"value":"command"},{"type":0,"value":": use a slash and up to 31 lowercase letters, digits, - or _."}],
    "integrations.app.commandReserved": [{"type":1,"value":"command"},{"type":0,"value":" is a built-in command."}],
    "integrations.app.commandTaken": [{"type":1,"value":"command"},{"type":0,"value":" is already used."}],
    "integrations.app.commandIncomplete": "Each command needs a request URL and a description.",
    "integrations.app.urlInvalid": "Use full URLs starting with https://.",
    "integrations.app.saveFailed": "Couldn’t save the app.",
    "integrations.app.failed": "Something went wrong. Try again.",
    "integrations.app.external": "Installed from another workspace",
    "integrations.app.meta": [{"type":1,"value":"scopes"},{"type":0,"value":" · "},{"type":1,"value":"commands"}],
    "integrations.app.commandCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" command"}]},"other":{"value":[{"type":7},{"type":0,"value":" commands"}]}},"offset":0,"pluralType":"cardinal"}],
    "integrations.app.scopeCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" scope"}]},"other":{"value":[{"type":7},{"type":0,"value":" scopes"}]}},"offset":0,"pluralType":"cardinal"}],
    "integrations.app.more": "More actions",
    "integrations.app.showSigningSecret": "Show signing secret",
    "integrations.app.rotateBotToken": "Regenerate bot token",
    "integrations.app.rotateClientSecret": "Regenerate client secret",
    "integrations.app.rotateSigningSecret": "Regenerate signing secret",
    "integrations.app.remove": "Remove",
    "integrations.app.removeTitle": "Remove app?",
    "integrations.app.removeBody": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” loses access to this workspace and its tokens stop working."}],
    "integrations.app.credentialsTitle": "App credentials",
    "integrations.app.credentialsBody": "Copy these now — tokens and the client secret won’t be shown again. Regenerate them if they leak.",
    "integrations.app.secretTitle": "New credential",
    "integrations.app.secretBody": "Copy it now. The old one has stopped working.",
    "integrations.app.signingTitle": "Signing secret",
    "integrations.app.signingBody": "Verify the X-Bundle-Signature header of requests from Bundle with this secret.",
    "integrations.app.botToken": "Bot token",
    "integrations.app.clientId": "Client ID",
    "integrations.app.clientSecret": "Client secret",
    "integrations.app.signingSecret": "Signing secret",
    "integrations.app.copy": "Copy",
    "integrations.app.copied": "Copied",
    "integrations.app.done": "Done",
    "integrations.scope.chatWrite": "Send messages as the app",
    "integrations.scope.channelsRead": "See the list of channels",
    "integrations.scope.channelsHistory": "Read messages in channels it’s in",
    "integrations.scope.usersRead": "See people in the workspace",
    "integrations.scope.reactionsWrite": "Add emoji reactions",
    "integrations.scope.commands": "Add slash commands",
    "integrations.outgoing.title": "Outgoing webhooks",
    "integrations.outgoing.body": "Send new messages in chosen channels, or starting with a trigger word, to a URL. A reply with text is posted back.",
    "integrations.outgoing.empty": "No outgoing webhooks yet.",
    "integrations.outgoing.add": "Add outgoing webhook",
    "integrations.outgoing.edit": "Edit outgoing webhook",
    "integrations.outgoing.channels": "Channels",
    "integrations.outgoing.channelsHelp": "None selected: every public channel (a trigger word is then required).",
    "integrations.outgoing.triggerWords": "Trigger words",
    "integrations.outgoing.triggerHelp": "Comma-separated. Only messages starting with one of them are sent.",
    "integrations.outgoing.url": "URL",
    "integrations.outgoing.needsChannelOrTrigger": "Pick a channel or add a trigger word.",
    "integrations.outgoing.meta": [{"type":1,"value":"where"},{"type":0,"value":" · "},{"type":1,"value":"url"}],
    "integrations.outgoing.allPublic": "All public channels",
    "integrations.outgoing.triggers": [{"type":0,"value":"Triggers: "},{"type":1,"value":"words"}],
    "integrations.outgoing.lastError": [{"type":0,"value":"Last delivery failed: "},{"type":1,"value":"error"}],
    "integrations.outgoing.signingSecret": "Signing secret",
    "integrations.outgoing.regenerate": "Regenerate signing secret",
    "integrations.outgoing.removeTitle": "Remove outgoing webhook?",
    "integrations.outgoing.removeBody": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” will stop receiving messages."}],
    "oauth.title": [{"type":1,"value":"app"},{"type":0,"value":" wants to access a Bundle workspace"}],
    "oauth.madeBy": [{"type":0,"value":"Made in "},{"type":1,"value":"workspace"}],
    "oauth.workspace": "Install in",
    "oauth.scopesTitle": "It will be able to:",
    "oauth.noScopes": "Install a bot user (no other permissions)",
    "oauth.allow": "Allow",
    "oauth.cancel": "Cancel",
    "oauth.noWorkspaces": "You need to be an owner or admin of a workspace to install apps.",
    "oauth.failed": "This install link isn’t valid. Ask the app’s developer for a new one.",
    "oauth.approveFailed": "Couldn’t install the app. Try again.",
    "oauth.loading": "Loading…",
    "settings.nav.userGroups": "User groups",
    "userGroups.problem.nameMissing": "Give the group a name.",
    "userGroups.problem.nameTooLong": "Use at most 80 characters for the name.",
    "userGroups.problem.descriptionTooLong": "Use at most 250 characters for the description.",
    "userGroups.problem.handleTaken": "A person or another group already uses that handle.",
    "userGroups.failed": "Couldn’t save the user group.",
    "userGroups.intro": "Mention a whole team at once, like @design. Members of a group are added to its default channels.",
    "userGroups.create": "Create user group",
    "userGroups.edit": "Edit user group",
    "userGroups.tab.active": "Active",
    "userGroups.tab.disabled": "Disabled",
    "userGroups.search": "Search user groups",
    "userGroups.empty": "No user groups yet.",
    "userGroups.emptyDisabled": "No disabled groups.",
    "userGroups.emptySearch": "No groups match your search.",
    "userGroups.memberCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" member"}]},"other":{"value":[{"type":7},{"type":0,"value":" members"}]}},"offset":0,"pluralType":"cardinal"}],
    "userGroups.field.name": "Name",
    "userGroups.field.namePlaceholder": "e.g. Design team",
    "userGroups.field.handle": "Handle",
    "userGroups.field.handleHelp": "People mention the group with this, like @design.",
    "userGroups.field.description": "Description (optional)",
    "userGroups.field.members": "Members",
    "userGroups.field.membersSearch": "Add people",
    "userGroups.field.channels": "Default channels",
    "userGroups.field.channelsHelp": "People added to the group join these channels.",
    "userGroups.disable": "Disable group",
    "userGroups.enable": "Enable group",
    "userGroups.disabledBadge": "Disabled",
    "userGroups.mine": "You’re a member",
    "userGroups.policy.label": "Who can manage user groups",
    "userGroups.policy.everyone": "Everyone except guests",
    "userGroups.policy.admins": "Only owners and admins",
    "userGroups.card.members": "Members",
    "userGroups.card.channels": "Default channels",
    "userGroups.card.join": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Join "},{"type":7},{"type":0,"value":" default channel"}]},"other":{"value":[{"type":0,"value":"Join "},{"type":7},{"type":0,"value":" default channels"}]}},"offset":0,"pluralType":"cardinal"}],
    "userGroups.card.disabled": "This group is disabled and can’t be mentioned.",
    "userGroups.card.noMembers": "No members yet.",
    "userGroups.unknown": "This group isn’t available.",
    "composer.group.members": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" member"}]},"other":{"value":[{"type":7},{"type":0,"value":" members"}]}},"offset":0,"pluralType":"cardinal"}],
    "profile.userGroups": "User groups",
    "userGroups.actions": [{"type":0,"value":"More actions for "},{"type":1,"value":"name"}],
    "userGroups.field.channelsSearch": "Add channels",
    "userGroups.field.noMatches": "No matches",
    "userGroups.cardTitle": [{"type":0,"value":"User group "},{"type":1,"value":"name"}],
    "message.unfurl.remove": "Remove preview",
    "message.unfurl.label": [{"type":0,"value":"Link preview: "},{"type":1,"value":"title"}],
    "message.unfurl.play": [{"type":0,"value":"Play "},{"type":1,"value":"title"}],
    "blockKit.typeMore": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Type "},{"type":7},{"type":0,"value":" more character"}]},"other":{"value":[{"type":0,"value":"Type "},{"type":7},{"type":0,"value":" more characters"}]}},"offset":0,"pluralType":"cardinal"}],
    "blockKit.searchFailed": "Couldn't load the options",
    "blockKit.noMatches": "No matches",
    "blockKit.showMore": "Show more",
    "appHome.tab": "Home",
    "appHome.messages": "Messages",
    "appHome.empty": [{"type":1,"value":"app"},{"type":0,"value":" hasn't set up its Home tab yet."}],
    "appHome.loading": "Loading Home",
    "integrations.app.optionsUrl": "Options load URL",
    "integrations.app.optionsHelp": "Menus with options from your app (external_select) ask here as people type.",
    "integrations.app.eventsUrl": "Events request URL",
    "integrations.app.eventsHelp": "Bundle checks this URL with a url_verification challenge when you save it, then sends app_home_opened and the events you subscribe to as signed JSON.",
    "integrations.scope.groupsRead": "See private channels it’s in",
    "integrations.scope.groupsHistory": "Read messages in private channels it’s in",
    "integrations.scope.imHistory": "Read its direct messages",
    "integrations.scope.mpimHistory": "Read messages in group DMs it’s in",
    "integrations.scope.appMentionsRead": "See messages that mention it",
    "integrations.scope.reactionsRead": "See emoji reactions",
    "integrations.app.events": "Bot events",
    "integrations.app.eventsSubscribeHelp": "Sent to the events request URL for conversations the app is in. Subscribing adds the permission it needs.",
    "integrations.app.eventsNeedUrl": "Add an events request URL to subscribe to events.",
    "integrations.app.eventsUrlFailed": "The events request URL didn’t answer the url_verification challenge. It must respond with the challenge value.",
    "integrations.app.eventsLoopWarning": "Bundle paused events to this app for a minute because it kept replying to its own messages. Ignore events whose bot_id is your bot’s user id.",
    "integrations.app.workflowSteps": "Workflow steps",
    "integrations.app.workflowStepsHelp": "Steps people can add to workflows in Workflow Builder. When one runs, Bundle sends a signed function_executed event to the events request URL.",
    "integrations.app.addStep": "Add step",
    "integrations.app.removeStep": "Remove step",
    "integrations.app.stepCallbackId": "Callback ID",
    "integrations.app.stepTitle": "Title",
    "integrations.app.stepDescription": "Description",
    "integrations.app.stepInputs": "Inputs",
    "integrations.app.stepOutputs": "Outputs",
    "integrations.app.addStepInput": "Add input",
    "integrations.app.addStepOutput": "Add output",
    "integrations.app.stepParamName": "Name",
    "integrations.app.stepParamLabel": "Label",
    "integrations.app.stepParamType": "Type",
    "integrations.app.stepParamRequired": "Required",
    "integrations.app.removeParam": "Remove",
    "integrations.app.stepIncomplete": "Each workflow step needs a callback ID (letters, digits, _, - or .) and a title, and each input a label. Input and output names use lowercase letters, digits and _.",
    "integrations.app.stepDuplicate": [{"type":1,"value":"callbackId"},{"type":0,"value":" is used by more than one step."}],
    "integrations.app.stepDuplicateParam": [{"type":1,"value":"callbackId"},{"type":0,"value":": “"},{"type":1,"value":"name"},{"type":0,"value":"” is used more than once."}],
    "integrations.event.messageChannels": "Messages in public channels",
    "integrations.event.messageGroups": "Messages in private channels",
    "integrations.event.messageIm": "Direct messages with the app",
    "integrations.event.messageMpim": "Messages in group DMs",
    "integrations.event.appMention": "Messages that mention the app",
    "integrations.event.reactionAdded": "Reaction added",
    "integrations.event.reactionRemoved": "Reaction removed",
    "integrations.event.memberJoinedChannel": "Someone joined a channel",
    "integrations.event.memberLeftChannel": "Someone left a channel",
    "integrations.event.channelCreated": "Public channel created",
    "integrations.event.channelRename": "Public channel renamed",
    "nav.workflows": "Workflows",
    "workflow.builder.title": "Workflow Builder",
    "workflow.list.title": "Workflows you manage",
    "workflow.list.body": "Automate routine work: a trigger starts a workflow, and its steps run in order.",
    "workflow.list.new": "New workflow",
    "workflow.list.error": "Couldn’t load workflows.",
    "workflow.list.empty.title": "No workflows yet",
    "workflow.list.empty.body": "Create one to post messages, collect answers with a form, or welcome new members.",
    "workflow.list.empty.cantCreate": "Only workspace owners and admins can create workflows here.",
    "workflow.list.edited": [{"type":0,"value":"Edited "},{"type":1,"value":"when"}],
    "workflow.status.published": "Published",
    "workflow.status.changed": "Unpublished changes",
    "workflow.status.draft": "Draft",
    "workflow.creators.title": "Who can create workflows",
    "workflow.creators.everyone": "Everyone except guests",
    "workflow.creators.admins": "Only owners and admins",
    "workflow.editor.untitled": "Untitled workflow",
    "workflow.editor.back": "All workflows",
    "workflow.tab.build": "Steps",
    "workflow.tab.activity": "Activity",
    "workflow.action.save": "Save",
    "workflow.action.test": "Test run",
    "workflow.action.publish": "Publish",
    "workflow.action.publishChanges": "Publish changes",
    "workflow.action.unpublish": "Unpublish",
    "workflow.details.icon": "Icon",
    "workflow.details.icon.remove": "Remove icon",
    "workflow.details.name": "Name",
    "workflow.details.name.placeholder": "e.g. Request time off",
    "workflow.details.description": "Description (optional)",
    "workflow.section.trigger": "Start the workflow…",
    "workflow.section.steps": "Then, do these things",
    "workflow.steps.empty": "Add the first step.",
    "workflow.steps.add": "Add step",
    "workflow.trigger.label": "Trigger",
    "workflow.trigger.link": "From a link in a channel",
    "workflow.trigger.memberJoined": "When someone joins a channel",
    "workflow.trigger.reaction": "When someone reacts with an emoji",
    "workflow.trigger.schedule": "On a schedule",
    "workflow.trigger.webhook": "From a webhook",
    "workflow.trigger.link.help": "Members of the channel run it from the channel’s workflows menu or by typing / in the message box.",
    "workflow.trigger.memberJoined.help": "Runs for each person who joins the channel.",
    "workflow.trigger.reaction.help": "Runs when someone adds this emoji to a message in the channel.",
    "workflow.trigger.schedule.help": "Runs at this time in the chosen time zone.",
    "workflow.trigger.webhook.help": "Another app starts it by sending a POST request with these variables. The URL shows once, when you publish.",
    "workflow.trigger.channel": "Channel",
    "workflow.trigger.emoji": "Emoji",
    "workflow.trigger.emoji.help": "An emoji like ✅, or a custom emoji’s :name:",
    "workflow.channel.choose": "Choose a channel",
    "workflow.person.choose": "Choose a person",
    "workflow.variable.choose": "Choose a variable",
    "workflow.variable.insert": "Insert a variable",
    "workflow.schedule.date": "Starts on",
    "workflow.schedule.time": "Time",
    "workflow.schedule.zone": "Time zone",
    "workflow.schedule.repeat": "Repeat",
    "workflow.schedule.repeat.none": "Doesn’t repeat",
    "workflow.schedule.repeat.daily": "Every day",
    "workflow.schedule.repeat.weekdays": "Every weekday (Mon–Fri)",
    "workflow.schedule.repeat.weekly": "Every week",
    "workflow.schedule.repeat.monthly": "Every month",
    "workflow.schedule.days": "Days of the week",
    "workflow.webhook.variables": "Variables",
    "workflow.webhook.key": "Key",
    "workflow.webhook.type": "Type",
    "workflow.webhook.add": "Add variable",
    "workflow.webhook.remove": "Remove variable",
    "workflow.webhook.once": "Copy this URL now: it won’t be shown again. Anyone with it can start this workflow.",
    "workflow.webhook.done": "Done",
    "workflow.webhook.copy": "Copy URL",
    "workflow.webhook.hidden": "The webhook URL was shown when it was made. Make a new one if you lost it (the old one stops working).",
    "workflow.webhook.regenerate": "New URL",
    "workflow.varType.text": "Text",
    "workflow.varType.number": "Number",
    "workflow.varType.user": "Person",
    "workflow.varType.channel": "Channel",
    "workflow.varType.message": "Message",
    "workflow.varType.date": "Date",
    "workflow.varType.time": "Time",
    "workflow.varType.page": "Page",
    "workflow.varType.row": "Row",
    "workflow.step.sendMessage": "Send a message",
    "workflow.step.form": "Collect info in a form",
    "workflow.step.addReaction": "Add a reaction",
    "workflow.step.createPage": "Create a page",
    "workflow.step.createRow": "Add a row to a database",
    "workflow.step.addToChannel": "Add someone to a channel",
    "workflow.step.delay": "Wait",
    "workflow.step.appStep": "Run an app’s step",
    "workflow.step.moveUp": "Move up",
    "workflow.step.moveDown": "Move down",
    "workflow.step.delete": "Delete step",
    "workflow.step.edit": "Edit",
    "workflow.step.done": "Done",
    "workflow.step.incomplete": "Fill in this step’s required fields before saving.",
    "workflow.message.to": "Send to",
    "workflow.message.to.runner": "The person who used this workflow",
    "workflow.message.to.channel": "A channel",
    "workflow.message.to.user": "A person",
    "workflow.message.to.variable": "A person or channel from a variable",
    "workflow.message.text": "Message",
    "workflow.message.placeholder": "Write a message…",
    "workflow.form.title": "Form title",
    "workflow.form.submit": "Submit button",
    "workflow.form.question": "Question",
    "workflow.form.fieldLabel": "Question",
    "workflow.form.fieldKind": "Answer type",
    "workflow.form.kind.text": "Short answer",
    "workflow.form.kind.paragraph": "Paragraph",
    "workflow.form.kind.number": "Number",
    "workflow.form.kind.select": "Dropdown",
    "workflow.form.kind.user": "Person",
    "workflow.form.kind.channel": "Channel",
    "workflow.form.kind.date": "Date",
    "workflow.form.required": "Required",
    "workflow.form.fieldId": [{"type":0,"value":"Variable: "},{"type":1,"value":"id"}],
    "workflow.form.option": [{"type":0,"value":"Option "},{"type":1,"value":"n"}],
    "workflow.form.options": "Choices",
    "workflow.form.options.help": "One per line (up to 20).",
    "workflow.form.addField": "Add question",
    "workflow.form.removeField": "Remove question",
    "workflow.reaction.message": "Message to react to",
    "workflow.reaction.emoji": "Emoji",
    "workflow.page.title": "Page title",
    "workflow.page.text": "Page text (optional)",
    "workflow.row.database": "Database",
    "workflow.row.choose": "Choose a database",
    "workflow.row.title": "Row title",
    "workflow.row.untitled": "Untitled",
    "workflow.addToChannel.channel": "Channel",
    "workflow.addToChannel.user": "Person",
    "workflow.delay.count": "Wait for",
    "workflow.delay.unit": "Unit",
    "workflow.delay.minutes": "Minutes",
    "workflow.delay.hours": "Hours",
    "workflow.delay.days": "Days",
    "workflow.app.title": "Step name",
    "workflow.app.appId": "App ID",
    "workflow.app.callbackId": "Callback ID",
    "workflow.app.inputs": "Inputs",
    "workflow.app.inputName": "Input name",
    "workflow.app.inputValue": "Value",
    "workflow.app.addInput": "Add input",
    "workflow.app.outputs": "Outputs",
    "workflow.app.outputName": "Output name",
    "workflow.app.outputType": "Output type",
    "workflow.app.addOutput": "Add output",
    "workflow.app.remove": "Remove",
    "workflow.app.chooseApp": "App",
    "workflow.app.chooseAppPlaceholder": "Choose an app",
    "workflow.app.chooseStep": "Step",
    "workflow.app.chooseStepPlaceholder": "Choose a step",
    "workflow.app.noApps": "No app installed here offers workflow steps yet. Apps add them in Settings → Apps.",
    "workflow.app.noInputs": "This step takes no inputs.",
    "workflow.app.inputRequired": [{"type":1,"value":"label"},{"type":0,"value":" (required)"}],
    "workflow.app.outputsHelp": "The app sends these back for later steps to use.",
    "workflow.app.issue.appMissing": "This app isn’t installed in this workspace anymore.",
    "workflow.app.issue.stepMissing": "The app doesn’t offer this step anymore.",
    "workflow.app.issue.requiredInput": [{"type":0,"value":"Fill in “"},{"type":1,"value":"field"},{"type":0,"value":"”."}],
    "workflow.condition.add": "Only run this step if…",
    "workflow.condition.title": "Only run this step if",
    "workflow.condition.summary": "Runs only when its condition holds",
    "workflow.condition.remove": "Remove condition",
    "workflow.condition.value": "Variable",
    "workflow.condition.op": "Comparison",
    "workflow.condition.compare": "Value",
    "workflow.condition.op.is": "is",
    "workflow.condition.op.isNot": "is not",
    "workflow.condition.op.contains": "contains",
    "workflow.condition.op.isEmpty": "is empty",
    "workflow.condition.op.isNotEmpty": "is not empty",
    "workflow.condition.op.greaterThan": "is greater than",
    "workflow.condition.op.lessThan": "is less than",
    "workflow.var.trigger.user": "Person who used this workflow",
    "workflow.var.trigger.joined": "Person who joined",
    "workflow.var.trigger.reactor": "Person who reacted",
    "workflow.var.trigger.channel": "Channel where it was used",
    "workflow.var.trigger.message": "Message reacted to",
    "workflow.var.trigger.messageText": "Text of the message",
    "workflow.var.trigger.messageAuthor": "Author of the message",
    "workflow.var.trigger.emoji": "Emoji used",
    "workflow.var.trigger.time": "Time it started",
    "workflow.var.output.submitter": "Person who submitted",
    "workflow.var.output.message": "Message sent",
    "workflow.var.output.channel": "Channel it went to",
    "workflow.var.output.page": "Page created",
    "workflow.var.output.row": "Row created",
    "workflow.problem.noName": "Give the workflow a name.",
    "workflow.problem.noSteps": "Add at least one step.",
    "workflow.problem.tooManySteps": "A workflow can have up to 30 steps.",
    "workflow.problem.noChannel": "Choose a channel.",
    "workflow.problem.noEmoji": "Choose an emoji.",
    "workflow.problem.badTimeZone": "Choose a valid time zone.",
    "workflow.problem.scheduleInPast": "This time has already passed.",
    "workflow.problem.duplicateVariable": [{"type":0,"value":"The variable "},{"type":1,"value":"key"},{"type":0,"value":" is listed twice."}],
    "workflow.problem.duplicateStep": "Two steps share an id.",
    "workflow.problem.emptyText": "Write the message.",
    "workflow.problem.unknownVariable": [{"type":0,"value":"Uses a variable that isn’t available at this step ("},{"type":1,"value":"ref"},{"type":0,"value":")."}],
    "workflow.problem.noRunner": "This trigger has no person who used the workflow; send it somewhere else.",
    "workflow.problem.formNeedsLink": "Forms only work in workflows started from a link.",
    "workflow.problem.duplicateField": [{"type":0,"value":"Two questions use the variable "},{"type":1,"value":"field"},{"type":0,"value":"."}],
    "workflow.problem.noOptions": [{"type":0,"value":"Add choices to the dropdown ("},{"type":1,"value":"field"},{"type":0,"value":")."}],
    "workflow.problem.notAMessage": "Choose a message variable.",
    "workflow.problem.notAUser": "Choose a person variable.",
    "workflow.problem.noDatabase": "Choose a database.",
    "workflow.problem.noApp": "Choose an app.",
    "workflow.managers.title": "Workflow managers",
    "workflow.managers.body": "Managers can edit, publish and see the activity of this workflow.",
    "workflow.managers.creator": [{"type":1,"value":"name"},{"type":0,"value":" (creator)"}],
    "workflow.managers.add": "Add a manager",
    "workflow.managers.remove": [{"type":0,"value":"Remove "},{"type":1,"value":"name"}],
    "workflow.delete.action": "Delete workflow",
    "workflow.delete.confirm": "Delete this workflow and its activity? This can’t be undone.",
    "workflow.leave.title": "Discard changes?",
    "workflow.leave.body": "Your changes to this workflow haven’t been saved.",
    "workflow.leave.stay": "Keep editing",
    "workflow.leave.discard": "Discard",
    "workflow.activity.title": "Activity",
    "workflow.activity.refresh": "Refresh",
    "workflow.activity.empty": "No runs yet.",
    "workflow.activity.error": "Couldn’t load the activity.",
    "workflow.run.status.running": "Running",
    "workflow.run.status.waiting": "Waiting",
    "workflow.run.status.completed": "Completed",
    "workflow.run.status.failed": "Failed",
    "workflow.run.status.cancelled": "Cancelled",
    "workflow.run.step.running": "Running",
    "workflow.run.step.waiting": "Waiting",
    "workflow.run.step.done": "Done",
    "workflow.run.step.skipped": "Skipped",
    "workflow.run.step.failed": "Failed",
    "workflow.run.test": "Test",
    "workflow.run.by": [{"type":1,"value":"name"},{"type":0,"value":" · "},{"type":1,"value":"when"}],
    "workflow.run.version": [{"type":0,"value":"Version "},{"type":1,"value":"version"}],
    "workflow.run.attempts": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" try"}]},"other":{"value":[{"type":7},{"type":0,"value":" tries"}]}},"offset":0,"pluralType":"cardinal"}],
    "workflow.menu.run": "Run",
    "workflow.menu.manage": "Manage workflows",
    "workflow.notice.saved": "Saved.",
    "workflow.notice.saveFailed": "Couldn’t save the workflow. Check its steps and try again.",
    "workflow.notice.published": "Published.",
    "workflow.notice.publishFailed": "Couldn’t publish. You need to be in every channel the workflow uses.",
    "workflow.notice.unpublished": "Unpublished: its trigger is off.",
    "workflow.notice.failed": "Something went wrong. Try again.",
    "workflow.notice.testStarted": "Test run started. See it in Activity.",
    "workflow.notice.testFailed": "Couldn’t start the test run.",
    "workflow.notice.deleted": "Workflow deleted.",
    "workflow.notice.cantCreate": "Only workspace owners and admins can create workflows here.",
    "moderation.report.action": "Report message",
    "moderation.block.action": [{"type":0,"value":"Block @"},{"type":1,"value":"name"}],
    "moderation.profile.block": "Block",
    "moderation.profile.unblock": "Unblock",
    "moderation.report.title": "Report message",
    "moderation.report.reason.spam": "Spam",
    "moderation.report.reason.harassment": "Harassment or bullying",
    "moderation.report.reason.inappropriate": "Inappropriate content",
    "moderation.report.reason.other": "Something else",
    "moderation.report.note.label": "Add a note (optional)",
    "moderation.report.note.placeholder": "Anything workspace admins should know",
    "moderation.report.submit": "Report",
    "moderation.report.done": "Thanks for reporting. Workspace admins have been notified.",
    "moderation.report.failed": "Couldn’t send the report. Try again.",
    "moderation.block.confirm.title": [{"type":0,"value":"Block @"},{"type":1,"value":"name"},{"type":0,"value":"?"}],
    "moderation.block.confirm.body": "You won’t get notifications from them, they can’t message you directly, and their messages will be hidden.",
    "moderation.block.confirm.action": "Block",
    "moderation.block.done": [{"type":0,"value":"@"},{"type":1,"value":"name"},{"type":0,"value":" is blocked"}],
    "moderation.unblock.done": [{"type":0,"value":"@"},{"type":1,"value":"name"},{"type":0,"value":" is unblocked"}],
    "moderation.block.failed": "Couldn’t update your blocked people. Try again.",
    "moderation.collapsed.text": "Message from someone you blocked",
    "moderation.collapsed.show": "Show",
    "moderation.composer.blocked": [{"type":0,"value":"You blocked @"},{"type":1,"value":"name"}],
    "moderation.composer.unblock": "Unblock",
    "moderation.error.blocked": "You can’t message this person.",
    "settings.nav.privacy": "Privacy",
    "moderation.blockedPeople.title": "Blocked people",
    "moderation.blockedPeople.help": "People you block can’t message you directly, you won’t get notifications from them, and their messages are hidden. They aren’t told.",
    "moderation.blockedPeople.empty": "You haven’t blocked anyone.",
    "moderation.blockedPeople.unblock": "Unblock",
    "settings.nav.reports": "Reports",
    "moderation.reports.title": "Reports",
    "moderation.reports.help": "Messages people reported in this workspace. Review each one within 24 hours: delete the message or dismiss the report.",
    "moderation.reports.empty": "No open reports.",
    "moderation.reports.reportedBy": [{"type":0,"value":"Reported by "},{"type":1,"value":"name"}],
    "moderation.reports.author": [{"type":0,"value":"From "},{"type":1,"value":"name"}],
    "moderation.reports.in": [{"type":0,"value":"in "},{"type":1,"value":"channel"}],
    "moderation.reports.reason": [{"type":0,"value":"Reason: "},{"type":1,"value":"reason"}],
    "moderation.reports.note": [{"type":0,"value":"Note: "},{"type":1,"value":"note"}],
    "moderation.reports.deleteMessage": "Delete message",
    "moderation.reports.dismiss": "Dismiss",
    "moderation.reports.deleted": "Message deleted and report resolved.",
    "moderation.reports.dismissed": "Report dismissed.",
    "moderation.reports.failed": "Couldn’t resolve the report. Try again.",
    "moderation.reports.loadFailed": "Couldn’t load reports.",
    "moderation.reports.directMessage": "a direct message",
    "mail.sync.google.optionalScopes": "The last four are optional: they add the Workspace's domains, groups (imported as aliases), who can post to them, and everyone's calendars.",
    "mail.sync.google.noDomains": "none yet",
    "mail.sync.google.missingScopes": [{"type":0,"value":"Not authorized yet: "},{"type":1,"value":"scopes"},{"type":0,"value":". Add them in the Google Admin console → Security → API controls → Domain-wide delegation for client ID "},{"type":1,"value":"clientId"},{"type":0,"value":". Until then that part is skipped; the rest keeps importing."}],
    "mail.sync.google.missingScopesOwn": [{"type":0,"value":"Not authorized yet: "},{"type":1,"value":"scopes"},{"type":0,"value":". Add them in the Google Admin console → Security → API controls → Domain-wide delegation for your service account's client ID. Until then that part is skipped; the rest keeps importing."}],
    "mail.sync.google.syncNow": "Sync now",
    "mail.sync.google.domainsTitle": "Domains",
    "mail.sync.google.domainsHelp": "Choose which Google Workspace domains come into Bundle. Checked domains are added in Settings → Email (pending until their DNS records are in place) and their users, aliases and groups (as aliases) are imported. Unchecking one stops importing from it; nothing is deleted.",
    "mail.sync.google.domainsProposed": "Proposed: the primary domain and its aliases. Save to confirm.",
    "mail.sync.google.domainPrimary": "Primary",
    "mail.sync.google.domainSecondary": "Secondary",
    "mail.sync.google.domainAliasOf": [{"type":0,"value":"Alias of "},{"type":1,"value":"domain"}],
    "mail.sync.google.importDomain": "Import into Bundle",
    "mail.sync.google.saveDomains": "Save domains",
    "mail.sync.google.aliases": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" alias"}]},"other":{"value":[{"type":7},{"type":0,"value":" aliases"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.skippedDomains": [{"type":0,"value":"Not imported (domain not added): "},{"type":1,"value":"domains"}],
    "mail.thread.via": [{"type":0,"value":"via "},{"type":1,"value":"address"}],
    "mail.invite.organizer": "Organizer",
    "mail.invite.organizerTime": [{"type":1,"value":"time"},{"type":0,"value":" in "},{"type":1,"value":"city"},{"type":0,"value":" (organizer)"}],
    "mail.invite.guestsWithYou": [{"type":1,"value":"names"},{"type":0,"value":" and you"}],
    "mail.invite.guestsMore": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"and "},{"type":7},{"type":0,"value":" more"}]},"other":{"value":[{"type":0,"value":"and "},{"type":7},{"type":0,"value":" more"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.invite.join": "Join the meeting",
    "mail.invite.inYourCalendar": "In your calendar",
    "mail.invite.noConflicts": "No conflicts",
    "mail.invite.conflict": [{"type":0,"value":"Conflicts with "},{"type":1,"value":"title"},{"type":0,"value":", "},{"type":1,"value":"time"}],
    "mail.invite.propose": "Propose new time",
    "mail.invite.more": "More invitation options",
    "mail.invite.openCalendar": "Open in Calendar",
    "mail.invite.download": "Download invite.ics",
    "mail.invite.answered.accepted": "You're going",
    "mail.invite.answered.declined": "You're not going",
    "mail.invite.answered.tentative": "You might go",
    "mail.invite.sentTo": [{"type":0,"value":"· sent to "},{"type":1,"value":"address"}],
    "mail.invite.change": "Change",
    "mail.invite.answerKept": [{"type":0,"value":"Your answer ("},{"type":1,"value":"answer"},{"type":0,"value":") was kept. Answer again if the new time doesn't work."}],
    "mail.invite.cancelled": "The organizer cancelled this event.",
    "mail.invite.removed": "Removed from your calendar.",
    "mail.invite.superseded": "This invitation is out of date: the organizer sent a newer one.",
    "mail.invite.answerFailed": "Couldn't send your answer. Try again.",
    "mail.invite.replyNotSetUp": [{"type":0,"value":"Answers can't be emailed to the organizer yet: sending from "},{"type":1,"value":"domain"},{"type":0,"value":" isn't set up. An admin can finish it in Settings → Email."}],
    "mail.invite.proposeSubject": [{"type":0,"value":"New time proposed: "},{"type":1,"value":"title"}],
    "mail.invite.proposeText": [{"type":1,"value":"time"},{"type":0,"value":" doesn't work for me. Could we find another time?"}],
    "mail.settings.tab.groups": "Aliases",
    "mail.settings.groups": "Aliases",
    "mail.settings.groupsHelp": "An alias delivers each message to all its members: mailboxes here or outside addresses. Members can send as the alias.",
    "mail.settings.groupsEmpty": "No aliases yet.",
    "mail.settings.groupNew": "New alias",
    "mail.settings.groupAddress": "Alias address",
    "mail.settings.groupName": "Name",
    "mail.settings.groupWhoCanPost": "Who can send to it",
    "mail.settings.groupPost.anyone": "Anyone (public)",
    "mail.settings.groupPost.organization": "Only people in the organization",
    "mail.settings.groupPost.members": "Only alias members",
    "mail.settings.groupMembers": "Members",
    "mail.settings.groupMembersCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" member"}]},"other":{"value":[{"type":7},{"type":0,"value":" members"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.settings.groupAddMailbox": "Add a mailbox",
    "mail.settings.groupAddExternal": "Outside address",
    "mail.settings.groupAddExternalButton": "Add",
    "mail.settings.groupOutside": "Outside",
    "mail.settings.groupImported": "Imported from Google",
    "mail.settings.groupEdited": "Edited in Bundle",
    "mail.settings.groupSave": "Save",
    "mail.settings.groupEdit": "Edit",
    "mail.settings.groupDelete": "Delete",
    "mail.settings.groupDeleteConfirm": [{"type":0,"value":"Delete "},{"type":1,"value":"address"},{"type":0,"value":"? Mail sent to it will bounce."}],
    "mail.settings.suggested": "Found in your Google Workspace import",
    "mail.settings.suggestedAdd": "Add",
    "mail.settings.suggestedAlias": [{"type":0,"value":"Alias of "},{"type":1,"value":"domain"}],
    "mail.sync.google.domainsList": [{"type":0,"value":"Domains: "},{"type":1,"value":"domains"}],
    "mail.sync.google.groupsCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" shared alias"}]},"other":{"value":[{"type":7},{"type":0,"value":" shared aliases"}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.nav.features": "Features",
    "shell.view.huddles": "Meet",
    "nav.huddles": "Meet",
    "settings.nav.huddles": "Meet",
    "huddles.title": "Meet",
    "huddles.new": "New meeting",
    "huddles.all": "All meetings",
    "huddles.start": "Start a meet",
    "huddles.start.hint": "Call people now",
    "huddles.getLink": "Get a link to share",
    "huddles.getLink.hint": [{"type":0,"value":"For later, or for people outside "},{"type":1,"value":"workspace"}],
    "huddles.schedule": "Schedule",
    "huddles.schedule.hint": "Pick a day and time",
    "huddles.join.placeholder": "Paste a link or code",
    "huddles.join.action": "Join",
    "huddles.join.invalid": "That isn't a meeting link or code.",
    "huddles.section.live": "Live now",
    "huddles.section.upcoming": "Upcoming",
    "huddles.section.recent": "Recent",
    "huddles.section.links": "My links",
    "huddles.empty.live": "Nobody is in a meeting right now.",
    "huddles.empty.upcoming": "Nothing scheduled.",
    "huddles.empty.recent": "Meetings you were in show here, with their notes, transcript and chat.",
    "huddles.empty.links": "Links you make stay here until you revoke them.",
    "huddles.people": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddles.outside": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" from outside"}]},"other":{"value":[{"type":7},{"type":0,"value":" from outside"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddles.linkOf": [{"type":1,"value":"name"},{"type":0,"value":"'s link"}],
    "huddles.untitled": "Meeting",
    "huddles.join": "Join",
    "huddles.open": "Open",
    "huddles.revoke": "Revoke",
    "huddles.revoke.confirm": "Revoke this link? People can't join from it anymore.",
    "huddles.chip.notes": "Notes",
    "huddles.chip.transcript": "Transcript",
    "huddles.chip.chat": "Chat",
    "huddles.link.ready": "Your link is ready",
    "huddles.link.name": "Name",
    "huddles.link.making": "Making your link…",
    "huddles.link.untilRevoked": "Works until you revoke it in My links.",
    "huddles.link.error": "Couldn't make the link. Try again.",
    "huddles.link.startNow": "Start now",
    "huddles.link.done": "Done",
    "huddles.access.label": "Who can join",
    "huddles.access.ask": "Ask to join",
    "huddles.access.ask.hint": [{"type":0,"value":"People in "},{"type":1,"value":"workspace"},{"type":0,"value":" and anyone you invite join directly. Others ask, and someone in the meeting lets them in."}],
    "huddles.access.open": "Open",
    "huddles.access.open.hint": "Anyone with the link joins directly.",
    "huddles.access.workspace": [{"type":0,"value":"Only people in "},{"type":1,"value":"workspace"}],
    "huddles.access.workspace.hint": "They sign in to join. Nobody else can ask.",
    "huddles.schedule.title": "Schedule a meeting",
    "huddles.schedule.date": "Date",
    "huddles.schedule.time": "Time",
    "huddles.schedule.invite": [{"type":0,"value":"Invite people in "},{"type":1,"value":"workspace"}],
    "huddles.schedule.notice": "They'll find it in Meet, under Upcoming.",
    "huddles.schedule.save": "Schedule",
    "huddles.schedule.past": "Pick a time that hasn't passed.",
    "huddles.start.title": "Start a meet",
    "huddles.start.who": "Add people or a channel",
    "huddles.start.whoPeople": "Add people",
    "huddles.start.nobody": "Nobody added yet: you'll get a link to share.",
    "huddles.start.chatOff": "The people you add get a meeting link. It shows in their Meet, under Live now.",
    "huddles.start.action": "Start",
    "huddles.start.error": "Couldn't start the meeting. Try again.",
    "huddles.loadError": "Couldn't load your meetings.",
    "huddles.record.openInChat": "Open in Chat",
    "huddles.record.again": "Meet again",
    "huddles.record.attendees": "Who was there",
    "huddles.record.noChat": "Nobody wrote in the meeting's chat.",
    "huddles.record.noNotes": "No notes for this meeting.",
    "huddles.record.recording": "Recording",
    "huddles.record.recordedBy": [{"type":0,"value":"Recorded by "},{"type":1,"value":"name"}],
    "huddles.record.error": "Couldn't load this meeting.",
    "settings.huddles.links": "Links to share",
    "settings.huddles.links.hint": [{"type":0,"value":"Members can make meeting links for people inside and outside "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.huddles.transcribe": "Transcribe meetings",
    "settings.huddles.transcribe.hint": [{"type":0,"value":"Every meeting in "},{"type":1,"value":"workspace"},{"type":0,"value":" is transcribed while people are unmuted, and the transcript is saved for everyone in it. AI meeting notes are made from it. Off: captions still work for whoever turns them on, and aren't saved."}],
    "settings.huddles.outside": [{"type":0,"value":"People outside "},{"type":1,"value":"workspace"}],
    "settings.huddles.outside.link": "Can join from a link",
    "settings.huddles.outside.link.hint": "Each link's Who can join decides.",
    "settings.huddles.outside.ask": "Always ask to join",
    "settings.huddles.outside.ask.hint": "Someone in the meeting lets them in, even on open links.",
    "settings.huddles.outside.none": "Can't join",
    "settings.huddles.outside.none.hint": [{"type":0,"value":"Links only work for people in "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.huddles.default": "Who can join new links",
    "settings.huddles.revokeAll": "Revoke all links",
    "settings.huddles.revokeAll.hint": [{"type":0,"value":"Every meeting link in "},{"type":1,"value":"workspace"},{"type":0,"value":" stops working. People from outside who joined from one leave the meeting."}],
    "settings.huddles.revokeAll.confirm": [{"type":0,"value":"Revoke every meeting link in "},{"type":1,"value":"workspace"},{"type":0,"value":"?"}],
    "settings.huddles.revoked": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" link revoked"}]},"other":{"value":[{"type":7},{"type":0,"value":" links revoked"}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.huddles.chatOff": "Meet works with Chat off: people start meetings from the Meet area.",
    "meeting.page.restricted": "Only people in the workspace can join this meeting.",
    "meeting.page.signIn": "Sign in to join",
    "features.title": "Features",
    "features.intro": "Choose which parts of Bundle people in this workspace can use. Turning one off hides it for everyone and blocks it in every app. Nothing is deleted: turn it back on and everything is where it was.",
    "features.chat.title": "Chat",
    "features.chat.hint": "Channels, direct messages, threads and agents' conversations.",
    "features.mail.title": "Email",
    "features.mail.hint": "Mailboxes and sending from your domains. Mail that arrives while it's off is kept and shows up when it's back on.",
    "features.calendar.title": "Calendar",
    "features.calendar.hint": "Events, invitations, booking pages and calendar sync.",
    "features.contacts.title": "Contacts",
    "features.contacts.hint": "People you email, clients and your team, synced with phones and Macs.",
    "features.docs.title": "Docs",
    "features.docs.hint": "Pages, databases, project boards and templates.",
    "features.huddles.title": "Meet",
    "features.huddles.hint": "Voice and video calls, meeting links and meeting notes.",
    "features.needsParent": [{"type":0,"value":"Needs "},{"type":1,"value":"area"},{"type":0,"value":" on"}],
    "features.lastOne": "At least one feature has to stay on.",
    "features.adminsOnly": "Only workspace owners and admins can change features.",
    "features.turnedOff": [{"type":1,"value":"area"},{"type":0,"value":" turned off"}],
    "features.turnedOn": [{"type":1,"value":"area"},{"type":0,"value":" turned on"}],
    "features.disabled.title": [{"type":1,"value":"area"},{"type":0,"value":" is turned off"}],
    "features.disabled.body": [{"type":0,"value":"An admin turned "},{"type":1,"value":"area"},{"type":0,"value":" off for this workspace. Ask an owner or admin if you need it."}],
    "features.error": "Couldn't update features. Try again.",
    "features.adminAccess.title": "When a feature is off, owners and admins",
    "features.adminAccess.none": "Lose it too",
    "features.adminAccess.read": "Can still look",
    "features.adminAccess.full": "Keep using it",
    "features.adminAccess.hint": "Everyone else loses switched-off features. Letting owners and admins keep them helps set things up before turning them on for everyone.",
    "features.readOnly": [{"type":1,"value":"area"},{"type":0,"value":" is turned off for this workspace. You can look, but not change anything."}],
    "mail.sync.google.what": "What to import",
    "mail.sync.google.whatMail": "Mail",
    "mail.sync.google.messages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" message"}]},"other":{"value":[{"type":7},{"type":0,"value":" messages"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.calendarNew": "New",
    "mail.sync.google.calendarHelp": "Everyone's own calendars: events from the past year and everything ahead, recurring events, guests and Meet links. Nobody gets an invite or email.",
    "mail.sync.google.calendarScopeTitle": "Calendar needs one more permission",
    "mail.sync.google.calendarScope": [{"type":0,"value":"In the Google Admin console → Security → API controls → Domain-wide delegation, add this scope to Bundle's client ID "},{"type":1,"value":"clientId"},{"type":0,"value":". Mail keeps importing meanwhile."}],
    "mail.sync.google.calendarScopeOwn": "In the Google Admin console → Security → API controls → Domain-wide delegation, add this scope to your service account's client ID. Mail keeps importing meanwhile.",
    "mail.sync.google.copyScope": "Copy scope",
    "mail.sync.google.checkAgain": "Check again",
    "mail.sync.calendar.label": "Calendar",
    "mail.sync.calendar.waiting": "waiting",
    "mail.sync.calendar.listing": "counting events…",
    "mail.sync.calendar.importing": [{"type":6,"value":"total","options":{"one":{"value":[{"type":0,"value":"importing "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":7},{"type":0,"value":" event"}]},"other":{"value":[{"type":0,"value":"importing "},{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":7},{"type":0,"value":" events"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.calendar.calendars": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" calendar"}]},"other":{"value":[{"type":7},{"type":0,"value":" calendars"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.calendar.events": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" event"}]},"other":{"value":[{"type":7},{"type":0,"value":" events"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.readersDelegates": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Gmail delegation: "},{"type":7},{"type":0,"value":" person can read it"}]},"other":{"value":[{"type":0,"value":"Gmail delegation: "},{"type":7},{"type":0,"value":" people can read it"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.readersGroup": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Its Google Group: "},{"type":7},{"type":0,"value":" person can read it"}]},"other":{"value":[{"type":0,"value":"Its Google Group: "},{"type":7},{"type":0,"value":" people can read it"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.readersPending": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" more gets access on joining Bundle"}]},"other":{"value":[{"type":7},{"type":0,"value":" more get access on joining Bundle"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.noDelegates": "Google lists no delegates for it, so only admins can read it. Add readers in Settings → Email.",
    "mail.sync.google.delegatesUnreadable": "Google wouldn't list its delegates; who can read it was left as is.",
    "mail.settings.memberFromGoogle": "From Google",
    "mail.settings.noDelegates": "Google lists no delegates for this mailbox: only the people checked here can read it.",
    "mail.settings.googleReadersPending": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" Gmail delegate gets access on joining Bundle."}]},"other":{"value":[{"type":7},{"type":0,"value":" Gmail delegates get access on joining Bundle."}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.nav.navigation": "Navigation",
    "settings.navigation.customizeTabs": "Customize tabs",
    "settings.navigation.description": "Choose what sits in the bottom bar of the Bundle phone app. Everything else shows at the top of Home. Saved to your account, so every phone you sign in on matches.",
    "settings.navigation.rowFooter": "Choose what's in the bottom bar. Saved to your account.",
    "settings.navigation.default": "Default",
    "settings.navigation.custom": "Custom",
    "settings.navigation.preview": [{"type":0,"value":"Preview · "},{"type":1,"value":"workspace"}],
    "settings.navigation.tabBar": "Tab bar",
    "settings.navigation.tabBarCount": [{"type":1,"value":"count"},{"type":0,"value":" of "},{"type":1,"value":"max"}],
    "settings.navigation.tabBarFooter": [{"type":0,"value":"Home and Activity always stay. Up to "},{"type":1,"value":"max"},{"type":0,"value":" more fit between them."}],
    "settings.navigation.alwaysFirst": "Always first",
    "settings.navigation.alwaysLast": "Always last",
    "settings.navigation.onHome": "On Home",
    "settings.navigation.onHomeFooter": "These show at the top of Home.",
    "settings.navigation.onHomeFooterFull": "These show at the top of Home. Adding one to a full bar moves the bar's last tab here.",
    "settings.navigation.noRoom": "No room in the tab bar",
    "settings.navigation.off": [{"type":0,"value":"Off in "},{"type":1,"value":"workspace"}],
    "settings.navigation.offRow": "Turned off by an admin",
    "settings.navigation.offShort": "Off",
    "settings.navigation.offFooter": [{"type":0,"value":"An admin turned these off for "},{"type":1,"value":"workspace"},{"type":0,"value":". They keep their place for your other workspaces."}],
    "settings.navigation.remove": "Remove",
    "settings.navigation.removeLabel": [{"type":0,"value":"Remove "},{"type":1,"value":"area"},{"type":0,"value":" from tab bar"}],
    "settings.navigation.add": "Add to tab bar",
    "settings.navigation.addLabel": [{"type":0,"value":"Add "},{"type":1,"value":"area"},{"type":0,"value":" to tab bar"}],
    "settings.navigation.moveUp": [{"type":0,"value":"Move "},{"type":1,"value":"area"},{"type":0,"value":" up"}],
    "settings.navigation.moveDown": [{"type":0,"value":"Move "},{"type":1,"value":"area"},{"type":0,"value":" down"}],
    "settings.navigation.drag": [{"type":0,"value":"Drag to reorder "},{"type":1,"value":"area"}],
    "settings.navigation.saveNote": "Changes save as you make them. On a computer, the sidebar lists every area.",
    "settings.navigation.reset": "Reset to default",
    "settings.navigation.resetTitle": "Reset your tabs?",
    "settings.navigation.resetBody": "Your bottom bar goes back to Bundle's default order on every phone you use.",
    "settings.navigation.resetConfirm": "Reset",
    "settings.navigation.saveFailed": "Couldn't save your tabs. Check your connection and try again.",
    "settings.navigation.loading": "Loading your tabs…",
    "settings.navigation.loadFailedTitle": "Couldn't load your tabs",
    "settings.navigation.loadFailedBody": "Check your connection and try again. Your bottom bar keeps Bundle's default order until then.",
    "settings.navigation.retry": "Try again",
    "drive.role.viewer": "Viewer",
    "drive.role.commenter": "Commenter",
    "drive.role.editor": "Editor",
    "drive.role.owner": "Owner",
    "drive.move.sameFolder": "It's already in this folder",
    "drive.move.intoItself": "A folder can't go inside itself",
    "drive.title": "Files",
    "files.picker.signIn": "Open Bundle and sign in to use your files here",
    "files.picker.offline": "Couldn't reach Bundle. Showing what was loaded last.",
    "drive.new": "New",
    "drive.new.folder": "New folder",
    "drive.new.fileUpload": "File upload",
    "drive.new.folderUpload": "Folder upload",
    "drive.new.page": "Page",
    "drive.new.database": "Database",
    "drive.new.untitled": "Untitled",
    "drive.view.my": "My files",
    "drive.view.shared": "Shared with me",
    "drive.view.recent": "Recent",
    "drive.view.starred": "Starred",
    "drive.view.trash": "Trash",
    "drive.view.conversations": "From conversations",
    "drive.search": "Search in Files",
    "drive.searchResults": [{"type":0,"value":"Results for “"},{"type":1,"value":"q"},{"type":0,"value":"”"}],
    "drive.upload": "Upload",
    "drive.layout": "Layout",
    "drive.layout.list": "List view",
    "drive.layout.grid": "Grid view",
    "drive.col.name": "Name",
    "drive.col.owner": "Owner",
    "drive.col.modified": "Last modified",
    "drive.col.size": "File size",
    "drive.col.actions": "Actions",
    "drive.owner.me": "me",
    "drive.modifiedBy": [{"type":1,"value":"date"},{"type":0,"value":" · "},{"type":1,"value":"name"}],
    "drive.section.folders": "Folders",
    "drive.section.files": "Files",
    "drive.filter.type": "Type",
    "drive.filter.people": "People",
    "drive.filter.modified": "Modified",
    "drive.filter.source": "Source",
    "drive.filter.any": "Any",
    "drive.filter.clear": "Clear filters",
    "drive.type.folder": "Folders",
    "drive.type.document": "Documents",
    "drive.type.spreadsheet": "Spreadsheets",
    "drive.type.presentation": "Presentations",
    "drive.type.pdf": "PDFs",
    "drive.type.image": "Photos & images",
    "drive.type.video": "Videos",
    "drive.type.audio": "Audio",
    "drive.type.archive": "Archives (zip)",
    "drive.type.page": "Pages & databases",
    "drive.type.other": "Other",
    "drive.people.me": "Owned by me",
    "drive.people.notMe": "Not owned by me",
    "drive.modified.today": "Today",
    "drive.modified.week": "Last 7 days",
    "drive.modified.month": "Last 30 days",
    "drive.modified.year": "Last 12 months",
    "drive.source.files": "Uploaded to Files",
    "drive.source.chat": "Shared in chat",
    "drive.source.mail": "Mail attachments",
    "drive.source.pages": "Pages + databases",
    "drive.sort": [{"type":0,"value":"Sort: "},{"type":1,"value":"by"}],
    "drive.sort.name": "Name",
    "drive.sort.modified": "Last modified",
    "drive.sort.viewed": "Last opened by me",
    "drive.sort.size": "File size",
    "drive.sort.shared": "Date shared",
    "drive.sort.asc": "Ascending",
    "drive.sort.desc": "Descending",
    "drive.action.open": "Open",
    "drive.action.share": "Share",
    "drive.action.copyLink": "Copy link",
    "drive.action.rename": "Rename",
    "drive.action.move": "Move",
    "drive.action.copy": "Make a copy",
    "drive.action.star": "Add to Starred",
    "drive.action.unstar": "Remove from Starred",
    "drive.action.versions": "Manage versions",
    "drive.action.download": "Download",
    "drive.action.trash": "Move to trash",
    "drive.action.details": "View details",
    "drive.action.restore": "Restore",
    "drive.action.deleteForever": "Delete forever",
    "drive.action.emptyTrash": "Empty trash",
    "drive.action.more": "More actions",
    "drive.selected": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" selected"}]},"other":{"value":[{"type":7},{"type":0,"value":" selected"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.clearSelection": "Clear selection",
    "drive.details": "Details",
    "drive.details.activity": "Activity",
    "drive.details.access": "Who has access",
    "drive.details.manage": "Manage access",
    "drive.details.type": "Type",
    "drive.details.size": "Size",
    "drive.details.location": "Location",
    "drive.details.owner": "Owner",
    "drive.details.modified": "Modified",
    "drive.details.created": "Created",
    "drive.details.versions": "Versions",
    "drive.details.sharedIn": "Shared in",
    "drive.details.close": "Close details",
    "drive.details.empty": "Select a file or folder to see its details.",
    "drive.details.onlyOwner": "Only the owner",
    "drive.details.modifiedLine": [{"type":1,"value":"name"},{"type":0,"value":" modified this · "},{"type":1,"value":"date"}],
    "drive.details.createdLine": [{"type":1,"value":"name"},{"type":0,"value":" created this · "},{"type":1,"value":"date"}],
    "drive.details.viewedLine": [{"type":0,"value":"You opened this · "},{"type":1,"value":"date"}],
    "drive.kind.folder": "Folder",
    "drive.kind.page": "Page",
    "drive.kind.database": "Database",
    "drive.kind.shortcut": "Shortcut",
    "drive.breadcrumb": "Breadcrumb",
    "drive.shared": "Shared",
    "drive.folderMenu": "Folder actions",
    "drive.storage": "Storage",
    "drive.storage.used": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"quota"},{"type":0,"value":" used · workspace"}],
    "drive.storage.meter": [{"type":1,"value":"percent"},{"type":0,"value":"% used"}],
    "drive.storage.manage": "Manage storage",
    "drive.storage.warning": [{"type":0,"value":"Workspace storage is "},{"type":1,"value":"percent"},{"type":0,"value":"% full."}],
    "drive.storage.warningBody": [{"type":0,"value":"Uploads and sync stop at "},{"type":1,"value":"quota"},{"type":0,"value":". Empty the trash or ask an admin for more space."}],
    "drive.storage.full": "Workspace storage is full.",
    "drive.storage.fullNotice": "Workspace storage is full: uploads to Files are paused.",
    "drive.storage.mine.files": "Your files",
    "drive.storage.mine.attachments": "Your attachments in conversations",
    "drive.storage.mine.versions": "Older versions",
    "drive.storage.mine.trash": "Trash",
    "drive.drop": [{"type":0,"value":"Drop files to upload them to “"},{"type":1,"value":"folder"},{"type":0,"value":"”"}],
    "drive.drop.hint": "Folders keep their structure.",
    "drive.uploads.title": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Uploading "},{"type":7},{"type":0,"value":" item"}]},"other":{"value":[{"type":0,"value":"Uploading "},{"type":7},{"type":0,"value":" items"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.uploads.finished": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" upload complete"}]},"other":{"value":[{"type":7},{"type":0,"value":" uploads complete"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.uploads.collapse": "Collapse",
    "drive.uploads.expand": "Expand",
    "drive.uploads.close": "Close",
    "drive.uploads.instant": "Already in Bundle · instant",
    "drive.uploads.done": "Done",
    "drive.uploads.failed": "Failed",
    "drive.uploads.canceled": "Canceled",
    "drive.uploads.waiting": "Waiting",
    "drive.uploads.percent": [{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "drive.uploads.folderCount": [{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "drive.uploads.cancel": "Cancel upload",
    "drive.uploads.retry": "Retry",
    "drive.uploads.resume": "Large files resume where they stopped if you lose connection or close the tab.",
    "drive.upload.tooBig": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" file is over 5 TB and wasn't uploaded"}]},"other":{"value":[{"type":7},{"type":0,"value":" files are over 5 TB and weren't uploaded"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.conflict.title": "Upload options",
    "drive.conflict.body": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” already exists in this folder. Replace it with a new version, or keep both?"}]},"other":{"value":[{"type":7},{"type":0,"value":" items already exist in this folder. Replace them with new versions, or keep all items separate?"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.conflict.replace": "Replace existing file",
    "drive.conflict.keep": "Keep all items separate",
    "drive.conflict.upload": "Upload",
    "drive.name.rename": "Rename",
    "drive.name.label": "Name",
    "drive.name.create": "Create",
    "drive.name.ok": "OK",
    "drive.name.invalid": "Use a name with 1–255 characters, without “/”.",
    "drive.name.untitledFolder": "Untitled folder",
    "drive.move.title": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Move “"},{"type":1,"value":"name"},{"type":0,"value":"”"}]},"other":{"value":[{"type":0,"value":"Move "},{"type":7},{"type":0,"value":" items"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.move.here": "Move here",
    "drive.move.back": "Back",
    "drive.move.empty": "No folders here",
    "drive.move.noAccess": "You can't add items to this folder",
    "drive.move.current": "Current location",
    "drive.notice.trashed": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Moved to trash"}]},"other":{"value":[{"type":7},{"type":0,"value":" items moved to trash"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.notice.restored": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Restored"}]},"other":{"value":[{"type":7},{"type":0,"value":" items restored"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.notice.copied": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Copy made"}]},"other":{"value":[{"type":7},{"type":0,"value":" copies made"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.notice.moved": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Moved"}]},"other":{"value":[{"type":7},{"type":0,"value":" items moved"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.notice.versionRestored": "Version restored",
    "drive.notice.ownerChanged": "Ownership transferred",
    "drive.notice.linkCopied": "Link copied",
    "drive.error.notFound": "This item doesn't exist or you don't have access.",
    "drive.error.conflict": "Someone changed this. Showing the latest version.",
    "drive.error.offline": "You're offline. Try again when you're connected.",
    "drive.error.failed": "Something went wrong. Try again.",
    "drive.preview.close": "Close preview",
    "drive.preview.noPreview.title": "No preview available",
    "drive.preview.noPreview.body": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” ("},{"type":1,"value":"size"},{"type":0,"value":") can't be previewed. Download it or open it with an app on your computer."}],
    "drive.versions.title": "Manage versions",
    "drive.versions.hint": "Older versions are kept 30 days or 100 versions. Keep forever to hold one.",
    "drive.versions.upload": "Upload new version",
    "drive.versions.current": "Current version",
    "drive.versions.number": [{"type":0,"value":"Version "},{"type":1,"value":"n"}],
    "drive.versions.keepForever": "Keep forever",
    "drive.versions.unkeep": "Don't keep forever",
    "drive.versions.kept": "Kept forever",
    "drive.versions.restore": "Restore this version",
    "drive.versions.delete": "Delete",
    "drive.versions.actions": "Version actions",
    "drive.versions.open": "Open",
    "drive.versions.device": [{"type":0,"value":"from "},{"type":1,"value":"device"}],
    "drive.share.title": [{"type":0,"value":"Share “"},{"type":1,"value":"name"},{"type":0,"value":"”"}],
    "drive.share.add": "Add people, groups or channels",
    "drive.share.people": "People with access",
    "drive.share.you": [{"type":1,"value":"name"},{"type":0,"value":" (you)"}],
    "drive.share.group": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"User group · "},{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":0,"value":"User group · "},{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.share.channel": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Channel members · "},{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":0,"value":"Channel members · "},{"type":7},{"type":0,"value":" people"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.share.workspace": [{"type":0,"value":"Everyone at "},{"type":1,"value":"workspace"}],
    "drive.share.workspaceHint": "Workspace members (not guests)",
    "drive.share.inherited": [{"type":0,"value":"From “"},{"type":1,"value":"folder"},{"type":0,"value":"”"}],
    "drive.share.transfer": "Transfer ownership",
    "drive.share.remove": "Remove access",
    "drive.share.general": "General access",
    "drive.share.restricted": "Restricted",
    "drive.share.restrictedHint": "Only people with access can open with the link.",
    "drive.share.anyoneAt": [{"type":0,"value":"Anyone at "},{"type":1,"value":"workspace"},{"type":0,"value":" with the link"}],
    "drive.share.anyoneHint": "Workspace members with the link get access. Guests don't.",
    "drive.share.copyLink": "Copy link",
    "drive.share.done": "Done",
    "drive.share.addRole": "Role for new people",
    "drive.share.noResults": "No matches",
    "drive.share.readOnly": "Only editors can change who has access.",
    "drive.share.change": [{"type":0,"value":"Change access for "},{"type":1,"value":"name"}],
    "drive.share.anyone": "Anyone with the link",
    "drive.share.anyoneLinkHint": "Anyone on the internet with the link can view",
    "drive.share.blocked.off": "Turned off by an admin",
    "drive.share.blocked.admins": "Only admins can do this",
    "drive.share.anyoneRoleNote": [{"type":1,"value":"workspace"},{"type":0,"value":" members who open the link get "},{"type":1,"value":"role"},{"type":0,"value":". Everyone else can only view and download."}],
    "drive.empty.my.title": "A place for all your files",
    "drive.empty.my.body": "Drag files or folders here, or use the New button. Files shared in chat, mail and docs show up in Recent.",
    "drive.empty.upload": "Upload files",
    "drive.empty.shared.title": "Nothing shared with you yet",
    "drive.empty.shared.body": "Files, folders, pages and databases people share with you, or post where you are, show here.",
    "drive.empty.recent.title": "No recent files",
    "drive.empty.recent.body": "Files you open, edit or share show here.",
    "drive.empty.starred.title": "No starred files",
    "drive.empty.starred.body": "Add stars to things you want to find easily later.",
    "drive.empty.trash.title": "Trash is empty",
    "drive.empty.trash.body": "Items in the trash are deleted forever after 30 days.",
    "drive.empty.conversations.title": "No files from conversations",
    "drive.empty.conversations.body": "Files you share in chat, mail and pages show here.",
    "drive.empty.folder.title": "This folder is empty",
    "drive.empty.folder.body": "Drag files here or use the New button.",
    "drive.empty.search.title": [{"type":0,"value":"No results for “"},{"type":1,"value":"q"},{"type":0,"value":"”"}],
    "drive.empty.search.body": "Try other words or remove filters. Search looks at names, owners and where files were shared.",
    "drive.empty.filtered.title": "Nothing matches these filters",
    "drive.trash.banner": "Items in the trash are deleted forever after 30 days.",
    "drive.trash.confirmTitle": "Delete forever?",
    "drive.trash.confirmBody": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” will be deleted forever. You can't undo this."}]},"other":{"value":[{"type":7},{"type":0,"value":" items will be deleted forever. You can't undo this."}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.trash.emptyTitle": "Empty trash?",
    "drive.trash.emptyBody": "All items in the trash will be deleted forever. You can't undo this.",
    "drive.cancel": "Cancel",
    "drive.failed": "Couldn't load Files.",
    "drive.retry": "Try again",
    "drive.from.dm": "Direct message",
    "drive.from.mail": "Email",
    "drive.from.page": "Page",
    "drive.from.row": "Database row",
    "drive.sharedIn": [{"type":0,"value":"Shared in "},{"type":1,"value":"where"}],
    "drive.attachment": "Attachment",
    "files.share.anyone": "Anyone with the link",
    "files.share.anyoneHint": "Anyone on the internet with the link can view",
    "files.share.workspaceHint": "Anyone in this workspace with the link",
    "files.share.anyoneNote": [{"type":1,"value":"workspace"},{"type":0,"value":" members who open the link get "},{"type":1,"value":"role"},{"type":0,"value":". Everyone else can only view and download."}],
    "files.share.blockedOff": "Your admin turned off public links",
    "files.share.blockedAdmins": "Only owners and admins can share with anyone",
    "files.upload.photos": "Photos and videos",
    "files.offline": "Showing what's saved on this device",
    "sync.files.entry": "Sync to this computer",
    "sync.files.entryOn": "Syncing to this computer",
    "sync.files.getApp": "Get the desktop app",
    "sync.setup.windowTitle": "Set up Bundle Files sync",
    "sync.setup.title": "Sync your files to this computer",
    "sync.setup.subtitle": "Your My files folders stay in sync between Bundle and a folder on this computer. You can change this later in Preferences.",
    "sync.mode.label": "How should your files sync?",
    "sync.mode.mirror": "Mirror files",
    "sync.mode.mirrorBody": "Every file is stored both in the cloud and on this computer, in a folder you choose. Everything works offline.",
    "sync.mode.stream": "Stream files",
    "sync.mode.streamBody": "Files stay in the cloud and download when you open them. Make any file or folder available offline. Uses almost no disk space.",
    "sync.mode.streamRecommended": "Stream files (recommended)",
    "sync.mode.streamOff": [{"type":0,"value":"Stream files · "},{"type":1,"value":"reason"}],
    "sync.mode.streamOff.unsupportedOs": "Needs macOS 26 or later",
    "sync.mode.streamOff.notVerified": "Coming soon on Windows",
    "sync.mode.streamOff.unsigned": "Not available in this build",
    "sync.location": "Location",
    "sync.location.change": "Change…",
    "sync.location.hint": "Pick an empty folder, or a new one.",
    "sync.location.streamHint": "macOS sets the location for streamed files. It shows in Finder under Locations.",
    "sync.folders.title": "Folders to sync",
    "sync.folders.hint": "Unchecked folders stay on the web only. New folders sync automatically.",
    "sync.folders.loose": "Files not in a folder",
    "sync.folders.empty": "No folders in My files yet. Everything you add will sync.",
    "sync.folders.failed": "Couldn't load your folders.",
    "sync.folders.expand": [{"type":0,"value":"Show folders in "},{"type":1,"value":"name"}],
    "sync.folders.collapse": [{"type":0,"value":"Hide folders in "},{"type":1,"value":"name"}],
    "sync.setup.start": "Start syncing",
    "sync.setup.failed": "Couldn't start syncing. Check the folder and try again.",
    "sync.setup.folderNotEmpty": "This folder isn't empty. Choose an empty or new folder for Bundle.",
    "sync.cancel": "Cancel",
    "sync.save": "Save",
    "sync.status.off": "Sync is off",
    "sync.status.offBody": "Set up sync to keep a folder on this computer up to date.",
    "sync.status.starting": "Starting…",
    "sync.status.idle": "Up to date",
    "sync.status.lastSynced": [{"type":0,"value":"Last synced "},{"type":1,"value":"time"}],
    "sync.status.syncing": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Syncing "},{"type":7},{"type":0,"value":" file"}]},"other":{"value":[{"type":0,"value":"Syncing "},{"type":7},{"type":0,"value":" files"}]}},"offset":0,"pluralType":"cardinal"}],
    "sync.status.left": [{"type":1,"value":"size"},{"type":0,"value":" left"}],
    "sync.status.paused": "Sync paused",
    "sync.status.pausedUntil": [{"type":0,"value":"Paused until "},{"type":1,"value":"time"}],
    "sync.status.pausedBody": "Changes are saved and will sync when you resume.",
    "sync.status.offline": "You're offline",
    "sync.status.offlineBody": "Changes will sync when you're back online.",
    "sync.status.offlineBodyStream": "Files you made available offline still open. Changes will sync when you're back online.",
    "sync.status.error": "Can't sync some files",
    "sync.status.errorBody": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" error"}]},"other":{"value":[{"type":7},{"type":0,"value":" errors"}]}},"offset":0,"pluralType":"cardinal"}],
    "sync.progress": "Sync progress",
    "sync.pause": "Pause syncing",
    "sync.pause.hour": "Pause for 1 hour",
    "sync.pause.tomorrow": [{"type":0,"value":"Pause until tomorrow ("},{"type":1,"value":"time"},{"type":0,"value":")"}],
    "sync.pause.manual": "Pause until I resume",
    "sync.resume": "Resume",
    "sync.menu": "Settings",
    "sync.menu.preferences": "Preferences…",
    "sync.menu.quit": "Quit Bundle",
    "sync.openFolder": "Open folder",
    "sync.openBundle": "Open Bundle",
    "sync.setUp": "Set up sync",
    "sync.activity": "Activity",
    "sync.activity.empty": "Files you add, change or delete will show up here.",
    "sync.activity.uploaded": "Uploaded",
    "sync.activity.downloaded": "Downloaded",
    "sync.activity.newVersion": "Updated",
    "sync.activity.newVersionBy": [{"type":0,"value":"Updated by "},{"type":1,"value":"name"}],
    "sync.activity.conflict": "Conflict · kept both",
    "sync.activity.trashed": "Moved to trash",
    "sync.activity.moved": "Moved",
    "sync.activity.created": "Added",
    "sync.activity.error": "Couldn't sync",
    "sync.transfer.up": [{"type":0,"value":"Uploading · "},{"type":1,"value":"percent"},{"type":0,"value":"% of "},{"type":1,"value":"size"}],
    "sync.transfer.down": [{"type":0,"value":"Downloading · "},{"type":1,"value":"percent"},{"type":0,"value":"% of "},{"type":1,"value":"size"}],
    "sync.errors": "Errors",
    "sync.conflict.banner": [{"type":0,"value":"1 conflict: “"},{"type":1,"value":"name"},{"type":0,"value":"” changed here and on the web. Both copies kept."}],
    "sync.conflict.bannerMany": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" conflict: a file changed here and on the web. Both copies kept."}]},"other":{"value":[{"type":7},{"type":0,"value":" conflicts: files changed here and on the web. Both copies of each were kept."}]}},"offset":0,"pluralType":"cardinal"}],
    "sync.conflict.review": "Review",
    "sync.conflict.title": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” was changed in two places"}],
    "sync.conflict.body": "It was changed on this computer and in Bundle since it last synced. Bundle kept both, so nothing is lost.",
    "sync.conflict.bodyBy": [{"type":1,"value":"name"},{"type":0,"value":" saved a version in Bundle while you were changing it here. Bundle kept both, so nothing is lost."}],
    "sync.conflict.mine": "This computer",
    "sync.conflict.theirs": "Bundle",
    "sync.conflict.theirsBy": [{"type":0,"value":"Bundle ("},{"type":1,"value":"name"},{"type":0,"value":")"}],
    "sync.conflict.savedAs": [{"type":0,"value":"Saved as “"},{"type":1,"value":"name"},{"type":0,"value":"”"}],
    "sync.conflict.keptAs": [{"type":0,"value":"Kept as “"},{"type":1,"value":"name"},{"type":0,"value":"”"}],
    "sync.conflict.useMine": "Use mine",
    "sync.conflict.useTheirs": "Use theirs",
    "sync.conflict.keepBoth": "Keep both",
    "sync.conflict.note": "“Use mine” saves your copy as the newest version (the other stays in version history). “Use theirs” moves your copy to the trash.",
    "sync.conflict.failed": "Couldn't resolve the conflict. Try again.",
    "sync.prefs.windowTitle": "Bundle Files — Preferences",
    "sync.prefs.nav": "Preferences",
    "sync.prefs.myFiles": "My files",
    "sync.prefs.general": "General",
    "sync.prefs.conflicts": "Conflicts",
    "sync.prefs.foldersNote": "Folders you remove from sync go to this computer's trash. On the web they stay put.",
    "sync.prefs.foldersStream": "When streaming, every folder in My files shows on this computer and downloads only what you open.",
    "sync.prefs.toStreamTitle": "Switch to streaming files?",
    "sync.prefs.toStreamBody": [{"type":0,"value":"Your files will stay in the cloud and download when you open them. The files already in "},{"type":1,"value":"path"},{"type":0,"value":" stay on this computer as regular files, but they won't sync anymore. You can delete them once you've checked everything is in Bundle."}],
    "sync.prefs.toStreamConfirm": "Stream files",
    "sync.prefs.toMirrorTitle": "Switch to mirroring files?",
    "sync.prefs.toMirrorBody": [{"type":0,"value":"Bundle will finish uploading your changes, then download a copy of every file in My files to a Bundle folder in your home folder. This uses disk space for all of them. The streamed location "},{"type":1,"value":"path"},{"type":0,"value":" is removed from this computer."}],
    "sync.prefs.toMirrorConfirm": "Mirror files",
    "sync.prefs.modeFailed": "Couldn't switch how your files sync. Try again.",
    "sync.prefs.saved": "Saved",
    "sync.prefs.launchAtLogin": "Open Bundle at login",
    "sync.prefs.bandwidth": "Bandwidth",
    "sync.prefs.uploadLimit": "Upload limit",
    "sync.prefs.downloadLimit": "Download limit",
    "sync.prefs.noLimit": "No limit",
    "sync.prefs.kbps": [{"type":1,"value":"value"},{"type":0,"value":" KB/s"}],
    "sync.prefs.mbps": [{"type":1,"value":"value"},{"type":0,"value":" MB/s"}],
    "sync.prefs.disconnect": "Disconnect",
    "sync.prefs.disconnectTitle": "Stop syncing this folder?",
    "sync.prefs.disconnectBody": [{"type":0,"value":"Files already on this computer stay in "},{"type":1,"value":"path"},{"type":0,"value":", but changes won't sync anymore. Your files in Bundle aren't affected."}],
    "sync.prefs.disconnectBodyStream": [{"type":1,"value":"path"},{"type":0,"value":" is removed from this computer, including files you made available offline. Your files in Bundle aren't affected."}],
    "sync.prefs.noConflicts": "No conflicts. When a file changes here and in Bundle at the same time, it shows up here.",
    "sync.prefs.failed": "Couldn't save. Try again.",
    "sync.unavailable": "File sync works in the Bundle desktop app.",
    "shell.view.calendar": "Calendar",
    "shell.view.contacts": "Contacts",
    "booking.pages": "Booking pages",
    "booking.paused": "Paused",
    "booking.copyLink": "Copy link",
    "booking.copyLinkTo": [{"type":0,"value":"Copy link to "},{"type":1,"value":"title"}],
    "booking.moreFor": [{"type":0,"value":"More for "},{"type":1,"value":"title"}],
    "booking.linkCopied": "Link copied",
    "booking.saveFailed": "Couldn't save the booking page. Try again.",
    "booking.deleteFailed": "Couldn't delete the booking page. Try again.",
    "booking.create.button": "Create",
    "booking.create.event": "Event",
    "booking.create.page": "Booking page",
    "booking.create.pageHelp": "A link people use to book time with you",
    "booking.empty.title": "No booking pages yet",
    "booking.empty.body": "Let people book time with you: create a booking page and share its link.",
    "booking.menu.open": "Open booking page",
    "booking.menu.edit": "Edit",
    "booking.menu.pause": "Pause bookings",
    "booking.menu.resume": "Resume bookings",
    "booking.menu.reset": "Reset link…",
    "booking.menu.resetShort": "Reset link",
    "booking.menu.delete": "Delete…",
    "booking.menu.deleteShort": "Delete",
    "booking.reset.title": "Reset the link?",
    "booking.reset.body": "The page gets a new link and the old one stops working. Bookings already made stay on your calendar.",
    "booking.delete.title": [{"type":0,"value":"Delete "},{"type":1,"value":"title"},{"type":0,"value":"?"}],
    "booking.delete.body": "Its link stops working. Bookings already made stay on your calendar.",
    "booking.location.bundleMeeting": "Bundle meeting",
    "booking.location.inPerson": "In person",
    "booking.location.phone": "Phone call",
    "booking.location.none": "None",
    "booking.color.gray": "Gray",
    "booking.color.brown": "Brown",
    "booking.color.orange": "Orange",
    "booking.color.yellow": "Yellow",
    "booking.color.green": "Green",
    "booking.color.blue": "Blue",
    "booking.color.purple": "Purple",
    "booking.color.pink": "Pink",
    "booking.color.red": "Red",
    "booking.zone.label": "Time zone",
    "booking.zone.detected": "Detected",
    "booking.editor.newTitle": "New booking page",
    "booking.editor.editTitle": "Booking page",
    "booking.editor.close": "Close editor",
    "booking.editor.title": "Title",
    "booking.editor.titlePlaceholder": "Add title",
    "booking.editor.duration": "Appointment duration",
    "booking.editor.general": "General availability",
    "booking.editor.generalHelp": "Times you're open for this page. Busy events on your calendars still block them.",
    "booking.editor.repeatsWeekly": "Repeats weekly, in",
    "booking.editor.unavailable": "Unavailable",
    "booking.editor.from": "Starts",
    "booking.editor.to": "Ends",
    "booking.editor.removePeriod": "Remove period",
    "booking.editor.addPeriod": "Add a period",
    "booking.editor.addAnotherPeriod": "Add another period to this day",
    "booking.editor.copyToAll": "Copy times to all days",
    "booking.editor.overlap": "Times overlap",
    "booking.editor.endBeforeStart": "Must end after it starts",
    "booking.editor.noHours": "Add at least one period long enough for an appointment.",
    "booking.editor.window": "Scheduling window",
    "booking.editor.maxAhead": "Maximum time in advance (days)",
    "booking.editor.daysSuffix": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" day ahead"}]},"other":{"value":[{"type":7},{"type":0,"value":" days ahead"}]}},"offset":0,"pluralType":"cardinal"}],
    "booking.editor.noLimit": "No limit",
    "booking.editor.minNotice": "Minimum time before it starts",
    "booking.editor.noNotice": "No minimum",
    "booking.editor.dateHours": "Date-specific hours",
    "booking.editor.dateHoursHelp": "Change your hours on one date, or mark it unavailable.",
    "booking.editor.addDate": "Change a date's hours",
    "booking.editor.removeDate": "Remove date",
    "booking.editor.appointment": "Booked appointment settings",
    "booking.editor.buffer": "Buffer time",
    "booking.editor.noBuffer": "No buffer",
    "booking.editor.minutesLong": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" minute"}]},"other":{"value":[{"type":7},{"type":0,"value":" minutes"}]}},"offset":0,"pluralType":"cardinal"}],
    "booking.editor.hoursLong": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" hour"}]},"other":{"value":[{"type":7},{"type":0,"value":" hours"}]}},"offset":0,"pluralType":"cardinal"}],
    "booking.editor.maxPerDay": "Maximum bookings per day",
    "booking.editor.guestsCanInvite": "Guests can invite others",
    "booking.editor.calendars": "Calendars",
    "booking.editor.checkCalendars": "Check my calendars for availability",
    "booking.editor.location": "Location",
    "booking.editor.meetingHelp": "Each booking gets its own meeting link. Guests without Bundle ask to join; you admit them.",
    "booking.editor.address": "Address",
    "booking.editor.phone": "Phone number",
    "booking.editor.phoneHelp": "Leave empty to ask guests for their number.",
    "booking.editor.description": "Description",
    "booking.editor.form": "Booking form",
    "booking.editor.formHelp": "First name, last name and email are always asked.",
    "booking.editor.question": "Question",
    "booking.editor.required": "Required",
    "booking.editor.removeQuestion": "Remove question",
    "booking.editor.addQuestion": "Add question",
    "booking.editor.verifyEmail": "Verify guests' email with a code",
    "booking.editor.reminders": "Reminders",
    "booking.editor.remindersHelp": "Emailed to guests before the appointment.",
    "booking.editor.addReminder": "Add reminder",
    "booking.editor.removeReminder": "Remove reminder",
    "booking.editor.color": "Colour",
    "booking.editor.previewHelp": "Preview: what guests can book, with your events",
    "booking.event.booked": "Booked through your booking page",
    "booking.event.bookedVia": [{"type":0,"value":"Booked through your booking page "},{"type":1,"value":"page"}],
    "booking.event.cancel": "Cancel appointment",
    "booking.event.showAs": "Show as",
    "booking.event.showAsBusy": "Busy",
    "booking.event.showAsFree": "Free",
    "booking.public.poweredBy": "Scheduling by Bundle",
    "booking.public.notFound": "This booking link doesn't work anymore. Ask for a new one.",
    "booking.public.loadFailed": "Couldn't load the times. Check your connection and try again.",
    "booking.public.paused": "This page isn't taking bookings right now.",
    "booking.public.appointments": [{"type":1,"value":"duration"},{"type":0,"value":" appointments"}],
    "booking.public.meetingLater": "Bundle meeting — link in your confirmation",
    "booking.public.phoneYou": "Phone call — you'll give your number",
    "booking.public.select": "Select an appointment time",
    "booking.public.prevWeek": "Previous week",
    "booking.public.nextWeek": "Next week",
    "booking.public.jumpNext": "Jump to the next open date",
    "booking.public.noTimes": "No times",
    "booking.public.noTimesWeek": "No open times this week.",
    "booking.public.dayNoTimes": [{"type":1,"value":"day"},{"type":0,"value":", no times"}],
    "booking.public.next": "Next",
    "booking.public.back": "Back",
    "booking.public.formTitle": "Book an appointment",
    "booking.public.with": [{"type":1,"value":"title"},{"type":0,"value":" with "},{"type":1,"value":"name"}],
    "booking.public.firstName": "First name",
    "booking.public.lastName": "Last name",
    "booking.public.email": "Email",
    "booking.public.emailHelp": "The invite and links to reschedule or cancel go here.",
    "booking.public.emailInvalid": "Enter a valid email",
    "booking.public.required": "Required",
    "booking.public.optional": [{"type":1,"value":"label"},{"type":0,"value":" (optional)"}],
    "booking.public.code": "Verification code",
    "booking.public.codeHelp": [{"type":0,"value":"We sent a code to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "booking.public.badCode": "That code didn't work. Check it and try again.",
    "booking.public.consent": [{"type":0,"value":"By booking you share these details with "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "booking.public.sendCode": "Send code",
    "booking.public.book": "Book",
    "booking.public.taken": "That time was just taken. Pick another one.",
    "booking.public.bookFailed": "Couldn't book. Try again.",
    "booking.public.booked": "You're booked",
    "booking.public.sentTo": [{"type":0,"value":"We sent the invite to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "booking.public.reschedule": "Reschedule",
    "booking.public.cancel": "Cancel booking",
    "booking.public.linksInEmail": "The same Reschedule and Cancel links are in the email.",
    "booking.manage.title": "Your booking",
    "booking.manage.notFound": "This booking link doesn't work.",
    "booking.manage.join": "Join the meeting",
    "booking.manage.pickNew": "Pick a new time",
    "booking.manage.moveTo": [{"type":0,"value":"Move to "},{"type":1,"value":"when"}],
    "booking.manage.keep": "Keep it",
    "booking.manage.cancelTitle": "Cancel this booking?",
    "booking.manage.cancelBody": [{"type":1,"value":"name"},{"type":0,"value":" gets an email and the event leaves their calendar. The meeting link stops working."}],
    "booking.manage.reason": "Reason (optional)",
    "booking.manage.cancelled": "This booking was cancelled",
    "booking.manage.ended": "This booking has ended",
    "booking.manage.bookAgain": "Book another time",
    "settings.nav.billing": "Billing",
    "billing.section.plan": "Plan",
    "billing.section.usage": "Usage",
    "billing.section.admins": "Who manages billing",
    "billing.plan.trial": "Starter trial",
    "billing.plan.starter": "Starter",
    "billing.plan.none": "No plan",
    "billing.plan.founding": "Founding",
    "billing.founding": "Founding workspace",
    "billing.founding.body": [{"type":1,"value":"ws"},{"type":0,"value":" was here from the start, so it has no member or storage limits and no bill. Thank you."}],
    "billing.trial.chip": [{"type":6,"value":"n","options":{"one":{"value":[{"type":7},{"type":0,"value":" day left"}]},"other":{"value":[{"type":7},{"type":0,"value":" days left"}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.trial.body": [{"type":0,"value":"Your free trial ends on "},{"type":1,"value":"date"},{"type":0,"value":". Subscribe before then to keep everything as it is. You won't need a card until you subscribe."}],
    "billing.trial.day": [{"type":0,"value":"Day "},{"type":1,"value":"day"},{"type":0,"value":" of "},{"type":1,"value":"total"}],
    "billing.trial.member": [{"type":1,"value":"ws"},{"type":0,"value":" is trying Starter. The trial ends on "},{"type":1,"value":"date"},{"type":0,"value":"."}],
    "billing.active.member": [{"type":1,"value":"ws"},{"type":0,"value":" is on the Starter plan."}],
    "billing.choosePlan": "Choose a plan",
    "billing.whatsIncluded": "What's included",
    "billing.subscribe": "Subscribe",
    "billing.manage": "Manage billing",
    "billing.updateCard": "Update payment method",
    "billing.chip.active": "Active",
    "billing.chip.trialCard": "Trial · card on file",
    "billing.chip.ending": "Canceled",
    "billing.chip.readOnly": "Read-only",
    "billing.pastDue.title": "Payment failed",
    "billing.price.perMonth": "/month",
    "billing.price.annual": [{"type":0,"value":"/month, billed annually ("},{"type":1,"value":"total"},{"type":0,"value":" a year)"}],
    "billing.price.monthly": "/month, billed monthly",
    "billing.kv.nextPayment": "Next payment",
    "billing.kv.trialEnds": "Trial ends",
    "billing.kv.firstPayment": "First payment",
    "billing.kv.amountOn": [{"type":1,"value":"amount"},{"type":0,"value":" on "},{"type":1,"value":"date"}],
    "billing.kv.endsOn": "Ends on",
    "billing.kv.paymentDue": "Payment due",
    "billing.kv.updateBy": [{"type":1,"value":"amount"},{"type":0,"value":" · update by "},{"type":1,"value":"date"}],
    "billing.kv.storage": "Extra storage",
    "billing.kv.storageValue": [{"type":1,"value":"n"},{"type":0,"value":" × 50 GB"}],
    "billing.kv.invoices": "Invoices",
    "billing.viewInvoices": "View invoices",
    "billing.portalFoot": "Change your card, download invoices or cancel on Stripe. You'll come back here when you're done.",
    "billing.annual.title": [{"type":0,"value":"Pay yearly and save "},{"type":1,"value":"amount"},{"type":0,"value":"."}],
    "billing.annual.body": [{"type":0,"value":"Annual billing is "},{"type":1,"value":"annual"},{"type":0,"value":" a month instead of "},{"type":1,"value":"monthly"},{"type":0,"value":"."}],
    "billing.switchAnnual": "Switch to annual",
    "billing.pastDue.banner.title": "We couldn't charge your card.",
    "billing.pastDue.banner.until": [{"type":0,"value":"Update your payment method by "},{"type":1,"value":"date"},{"type":0,"value":" to keep "},{"type":1,"value":"ws"},{"type":0,"value":" running. After that it becomes read-only."}],
    "billing.pastDue.banner.body": [{"type":0,"value":"Update your payment method to keep "},{"type":1,"value":"ws"},{"type":0,"value":" running."}],
    "billing.readOnly": [{"type":1,"value":"ws"},{"type":0,"value":" is read-only"}],
    "billing.readOnly.trialEnded": [{"type":0,"value":"The trial ended on "},{"type":1,"value":"date"},{"type":0,"value":"."}],
    "billing.readOnly.ended": "The subscription ended.",
    "billing.readOnly.page": "Everyone can still read and export, but no one can send, upload or edit until you subscribe.",
    "billing.locked.body": [{"type":0,"value":"Your messages, mail, docs and files are safe. We keep them until "},{"type":1,"value":"date"},{"type":0,"value":" (90 days). Subscribe any time before then and everything switches back on."}],
    "billing.locked.bodyNoDate": "Your messages, mail, docs and files are safe for 90 days. Subscribe any time before then and everything switches back on.",
    "billing.native.attention": [{"type":1,"value":"ws"},{"type":0,"value":"'s plan needs attention. Manage it in Bundle on the web."}],
    "billing.native.askAdmins": [{"type":0,"value":"Ask "},{"type":1,"value":"names"},{"type":0,"value":" about the plan."}],
    "billing.native.composer": [{"type":0,"value":"Ask "},{"type":1,"value":"names"},{"type":0,"value":" about the plan. You can still read and search everything."}],
    "billing.native.trialMember": [{"type":0,"value":"After that, "},{"type":1,"value":"ws"},{"type":0,"value":" becomes read-only. Ask "},{"type":1,"value":"names"},{"type":0,"value":" about the plan."}],
    "billing.native.lockedBody": [{"type":0,"value":"Your messages, mail, docs and files are safe. We keep them until "},{"type":1,"value":"date"},{"type":0,"value":" (90 days)."}],
    "billing.native.lockedBodyNoDate": "Your messages, mail, docs and files are safe for 90 days.",
    "billing.native.inviteOver": [{"type":0,"value":"Starter holds "},{"type":1,"value":"limit"},{"type":0,"value":" members and "},{"type":1,"value":"ws"},{"type":0,"value":" has "},{"type":1,"value":"members"},{"type":0,"value":", so remove "},{"type":1,"value":"remove"},{"type":0,"value":" of these."}],
    "billing.native.inviteFullAdmin": "To invite someone, remove a member in Members.",
    "billing.exportData": "Export data",
    "billing.askAdmins": [{"type":0,"value":"Ask "},{"type":1,"value":"names"},{"type":0,"value":" to subscribe."}],
    "billing.anAdmin": "an owner or admin",
    "billing.trial.banner.title": [{"type":6,"value":"n","options":{"one":{"value":[{"type":0,"value":"Your trial ends tomorrow."}]},"other":{"value":[{"type":0,"value":"Your trial ends in "},{"type":7},{"type":0,"value":" days."}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.trial.banner.info": [{"type":0,"value":"Subscribe to keep "},{"type":1,"value":"ws"},{"type":0,"value":" running after "},{"type":1,"value":"date"},{"type":0,"value":"."}],
    "billing.trial.banner.warning": [{"type":0,"value":"After "},{"type":1,"value":"date"},{"type":0,"value":", "},{"type":1,"value":"ws"},{"type":0,"value":" becomes read-only until someone subscribes."}],
    "billing.trial.banner.danger": "Subscribe today so everyone can keep sending messages and mail.",
    "billing.trial.banner.member": [{"type":0,"value":"After that, "},{"type":1,"value":"ws"},{"type":0,"value":" becomes read-only. Ask "},{"type":1,"value":"names"},{"type":0,"value":" to subscribe."}],
    "billing.composer.title": "You can't send messages right now",
    "billing.composer.admin": "Subscribe to switch sending, uploads and editing back on.",
    "billing.composer.member": [{"type":0,"value":"Ask "},{"type":1,"value":"names"},{"type":0,"value":" to subscribe. You can still read and search everything."}],
    "billing.picker.title": "Subscribe to Starter",
    "billing.cycle.annual": [{"type":0,"value":"Annual · save "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "billing.cycle.monthly": "Monthly",
    "billing.picker.billedYearly": [{"type":0,"value":"Billed "},{"type":1,"value":"amount"},{"type":0,"value":" once a year"}],
    "billing.picker.billedMonthly": "Billed every month. Cancel any time.",
    "billing.picker.inc.members": [{"type":0,"value":"Up to "},{"type":1,"value":"n"},{"type":0,"value":" members"}],
    "billing.picker.inc.storage": [{"type":1,"value":"gb"},{"type":0,"value":" GB of storage shared by the workspace"}],
    "billing.picker.inc.domain": "Email on your own domain",
    "billing.picker.inc.apps": "Chat, Meet, mail, calendar, docs and files",
    "billing.picker.storage.label": "Extra storage",
    "billing.picker.storage.hint": [{"type":0,"value":"50 GB for "},{"type":1,"value":"price"},{"type":0,"value":"/month each. Change it later in Billing."}],
    "billing.picker.storage.none": "None",
    "billing.picker.storage.option": [{"type":0,"value":"+"},{"type":1,"value":"gb"},{"type":0,"value":" GB"}],
    "billing.picker.dueToday": "Due today",
    "billing.picker.trialKept": [{"type":0,"value":"Your trial continues. The first charge of "},{"type":1,"value":"amount"},{"type":0,"value":" is on "},{"type":1,"value":"date"},{"type":0,"value":"."}],
    "billing.continue": "Continue to checkout",
    "billing.picker.foot": "You'll pay on Stripe's secure page, then come back to Bundle. Plus tax where it applies.",
    "billing.picker.pro": [{"type":0,"value":"More than "},{"type":1,"value":"n"},{"type":0,"value":" people? Pro is coming."}],
    "billing.contactPro": "Contact us",
    "billing.confirm.title": "Confirming your payment with Stripe…",
    "billing.confirm.hint": "This usually takes a few seconds. You can keep working.",
    "billing.confirm.done": "You're on Starter. Thanks for subscribing.",
    "billing.confirm.slow": "Stripe hasn't confirmed the payment yet. This page updates when it does.",
    "billing.usage.members": "Members",
    "billing.usage.storage": "Storage",
    "billing.usage.membersLeft": [{"type":6,"value":"n","options":{"one":{"value":[{"type":7},{"type":0,"value":" spot left."}]},"other":{"value":[{"type":7},{"type":0,"value":" spots left."}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.usage.membersFull": [{"type":0,"value":"Starter holds "},{"type":1,"value":"limit"},{"type":0,"value":" members. Remove someone or contact us about Pro."}],
    "billing.usage.pending": [{"type":6,"value":"n","options":{"one":{"value":[{"type":0,"value":"Includes "},{"type":7},{"type":0,"value":" pending invitation."}]},"other":{"value":[{"type":0,"value":"Includes "},{"type":7},{"type":0,"value":" pending invitations."}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.usage.storageShared": "Shared by the whole workspace.",
    "billing.usage.storageAddons": [{"type":1,"value":"base"},{"type":0,"value":" with Starter + "},{"type":1,"value":"extra"},{"type":0,"value":" in add-ons."}],
    "billing.pro.title": [{"type":0,"value":"Need more than "},{"type":1,"value":"n"},{"type":0,"value":" members?"}],
    "billing.pro.hint": "A per-person Pro plan is coming.",
    "billing.adminsOnly": "Only owners and admins can manage billing.",
    "billing.messageAdmin": "Message",
    "billing.invite.over.title": [{"type":6,"value":"left","options":{"one":{"value":[{"type":0,"value":"Only "},{"type":7},{"type":0,"value":" more person fits."}]},"other":{"value":[{"type":0,"value":"Only "},{"type":7},{"type":0,"value":" more people fit."}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.invite.over.body": [{"type":0,"value":"Starter holds "},{"type":1,"value":"limit"},{"type":0,"value":" members and "},{"type":1,"value":"ws"},{"type":0,"value":" has "},{"type":1,"value":"members"},{"type":0,"value":", so remove "},{"type":1,"value":"remove"},{"type":0,"value":" of these or contact us about Pro."}],
    "billing.invite.full.title": [{"type":1,"value":"ws"},{"type":0,"value":" has "},{"type":1,"value":"members"},{"type":0,"value":" of "},{"type":1,"value":"limit"},{"type":0,"value":" members."}],
    "billing.invite.full.admin": "To invite someone, remove a member in Members, or contact us about Pro.",
    "billing.invite.full.memberTitle": [{"type":1,"value":"ws"},{"type":0,"value":" is full."}],
    "billing.invite.full.member": [{"type":0,"value":"Starter holds "},{"type":1,"value":"limit"},{"type":0,"value":" members. Ask "},{"type":1,"value":"names"},{"type":0,"value":" to make room."}],
    "billing.fault.required": [{"type":1,"value":"ws"},{"type":0,"value":" is read-only, so that didn't go through."}],
    "billing.fault.members": [{"type":1,"value":"ws"},{"type":0,"value":" has reached its member limit."}],
    "billing.addStorage": "Add storage",
    "billing.storageFull.title": [{"type":1,"value":"ws"},{"type":0,"value":" is out of storage"}],
    "billing.storageFull.usage": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"pool"},{"type":0,"value":" used."}],
    "billing.storageFull.addStorage": "That upload didn't go through. Add storage to keep uploading, or delete files you no longer need.",
    "billing.storageFull.choosePlan": "That upload didn't go through. Choose a plan with more storage, or delete files you no longer need.",
    "billing.storageFull.contact": [{"type":0,"value":"That upload didn't go through. "},{"type":1,"value":"ws"},{"type":0,"value":" has every storage add-on, so contact us about more, or delete files you no longer need."}],
    "billing.storageFull.web": "That upload didn't go through. Manage storage on the web, or delete files you no longer need.",
    "billing.storageFull.store": [{"type":0,"value":"That upload didn't go through. Add storage to the "},{"type":1,"value":"store"},{"type":0,"value":" subscription, or delete files you no longer need."}],
    "billing.storageFull.member": [{"type":0,"value":"That upload didn't go through. Ask "},{"type":1,"value":"names"},{"type":0,"value":" to add storage, or delete files you no longer need."}],
    "billing.storageFull.notNow": "Not now",
    "billing.storageWarn.title": [{"type":1,"value":"ws"},{"type":0,"value":" has used "},{"type":1,"value":"percent"},{"type":0,"value":"% of its storage"}],
    "billing.storageWarn.fullTitle": [{"type":1,"value":"ws"},{"type":0,"value":" is out of storage"}],
    "billing.storageWarn.addStorage": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"pool"},{"type":0,"value":" used. Add storage to keep uploading, or delete files you no longer need."}],
    "billing.storageWarn.choosePlan": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"pool"},{"type":0,"value":" used. Choose a plan with more storage, or delete files you no longer need."}],
    "billing.storageWarn.contact": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"pool"},{"type":0,"value":" used. "},{"type":1,"value":"ws"},{"type":0,"value":" has every storage add-on, so contact us about more, or delete files you no longer need."}],
    "billing.storageWarn.store": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"pool"},{"type":0,"value":" used. Add storage to the "},{"type":1,"value":"store"},{"type":0,"value":" subscription, or delete files you no longer need."}],
    "billing.storageWarn.member": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"pool"},{"type":0,"value":" used. Ask "},{"type":1,"value":"names"},{"type":0,"value":" to add storage, or delete files you no longer need."}],
    "billing.usage.storageLow": "Running low on space. Add storage, or delete files you no longer need.",
    "billing.usage.storageOut": "Out of space. Add storage, or delete files you no longer need.",
    "billing.usage.storageLowMember": "Running low on space. Delete files you no longer need, or ask an owner or admin to add storage.",
    "billing.usage.storageOutMember": "Out of space. Delete files you no longer need, or ask an owner or admin to add storage.",
    "billing.native.storageWarning": [{"type":1,"value":"used"},{"type":0,"value":" of "},{"type":1,"value":"pool"},{"type":0,"value":" used. Manage storage in Bundle on the web or delete files you no longer need."}],
    "billing.native.storageLow": "Running low on space. Manage storage in Bundle on the web or delete files you no longer need.",
    "billing.native.storageOut": "Out of space. Manage storage in Bundle on the web or delete files you no longer need.",
    "billing.error.unavailable": "Billing isn't available right now. Try again later.",
    "billing.error.network": "You're offline. Try again when you're connected.",
    "billing.error.generic": "Something went wrong. Try again.",
    "billing.usage.countRule": "Pending invitations count; guests don't.",
    "support.botName": "Support",
    "support.help.button": "Help",
    "support.help.center": "Help center",
    "support.help.whatsNew": "What's new",
    "support.help.shortcuts": "Keyboard shortcuts",
    "support.help.ask": "Ask Support",
    "support.help.askHint": "Answers right away",
    "support.help.askFailed": "Couldn't open Support. Try again in a moment.",
    "support.help.feedback": "Send feedback…",
    "support.help.section": "Help & feedback",
    "support.help.version": [{"type":0,"value":"Bundle "},{"type":1,"value":"version"}],
    "support.kind.bug": "Bug",
    "support.kind.idea": "Idea",
    "support.kind.question": "Question",
    "support.kind.label": "Kind",
    "support.form.title": "Send feedback",
    "support.form.subtitle": "Starts a thread in your DM with Support. The Bundle team sees it too; your workspace doesn't.",
    "support.form.bug.label": "What went wrong?",
    "support.form.bug.placeholder": "What did you do, what happened, and what did you expect?",
    "support.form.idea.label": "What would make Bundle better?",
    "support.form.idea.placeholder": "Describe the idea and the problem it solves for you.",
    "support.form.question.label": "What do you want to know?",
    "support.form.question.placeholder": "Ask anything about Bundle. Support answers in your DM.",
    "support.form.addScreenshot": "Add screenshot",
    "support.form.chooseFile": "Choose file",
    "support.form.lastScreenshot": "Use last screenshot",
    "support.form.choosePhoto": "Choose from Photos…",
    "support.form.removeScreenshot": "Remove screenshot",
    "support.form.screenshotSize": [{"type":0,"value":"Screenshot · "},{"type":1,"value":"size"}],
    "support.form.diagnostics": "Include diagnostics",
    "support.form.whatsIncluded": "What's included",
    "support.form.hideIncluded": "Hide what's included",
    "support.form.send": "Send",
    "support.form.cancel": "Cancel",
    "support.form.tooShort": [{"type":0,"value":"Write at least "},{"type":1,"value":"min"},{"type":0,"value":" characters."}],
    "support.form.tooLong": [{"type":0,"value":"Keep it under "},{"type":1,"value":"max"},{"type":0,"value":" characters."}],
    "support.form.notImage": "Choose an image.",
    "support.form.tooBig": [{"type":0,"value":"Images can be up to "},{"type":1,"value":"mb"},{"type":0,"value":" MB."}],
    "support.form.rateLimited": [{"type":0,"value":"You've sent a lot of feedback recently. You can send more at "},{"type":1,"value":"time"},{"type":0,"value":". Your text stays here."}],
    "support.form.error": "Couldn't send your feedback. Check your connection and try again.",
    "support.form.tryAgain": "Try again",
    "support.sent": "Sent to Support.",
    "support.sentVote": "Sent to Support. Someone reported this already, so we added your vote.",
    "support.open": "Open",
    "support.diag.app": "App",
    "support.diag.language": "Language",
    "support.diag.screen": "Screen",
    "support.diag.connection": "Connection",
    "support.dm.notice": "Messages here are shared with the Bundle team, not with your workspace.",
    "support.dm.subtitle": "Answers right away. The Bundle team steps in when it can't.",
    "support.mention.hint": "Bundle's help agent",
    "settings.nav.calendar": "Calendar",
    "calendar.meetSwap.prompt.which": "Move which events",
    "calendar.meetSwap.confirm.link": "Each event gets its own link, like Meet. The Google Meet link is removed from the location, the description and the video call.",
    "calendar.meetSwap.confirm.google": "Events from Google Calendar are changed there too, so everyone's copy matches.",
    "calendar.meetSwap.confirm.left": "Left as they are: events someone else organises, and past events.",
    "calendar.meetSwap.movedQuiet": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Moved "},{"type":7},{"type":0,"value":" event to Bundle."}]},"other":{"value":[{"type":0,"value":"Moved "},{"type":7},{"type":0,"value":" events to Bundle."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.failed": "Couldn't move the events. Try again.",
    "calendar.meetSwap.busy": "Another move is still running.",
    "calendar.meetSwap.settings.restoring": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Putting the Google Meet link back on "},{"type":7},{"type":0,"value":" event"}]},"other":{"value":[{"type":0,"value":"Putting the Google Meet links back on "},{"type":7},{"type":0,"value":" events"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.settings.scopeBody": "An admin needs to let Bundle edit calendars in the Google Admin console.",
    "calendar.meetSwap.settings.showEvents": "Show events",
    "calendar.meetSwap.policy.details": "See details",
    "calendar.meetSwap.policy.hideDetails": "Hide details",
    "calendar.meetSwap.policy.memberRow": [{"type":1,"value":"done"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" events · "},{"type":1,"value":"skipped"},{"type":0,"value":" skipped"}],
    "calendar.meetSwap.policy.restoring": "Putting members' Google Meet links back",
    "calendar.meetSwap.policy.scopeTitle": "Events from Google Calendar are waiting.",
    "calendar.meetSwap.policy.scopeBody": "Let Bundle edit calendars in the Google Admin console, and they'll move on their own.",
    "calendar.meetSwap.policy.setup": "Set up now",
    "calendar.meetSwap.policy.existing": "Existing events with Google Meet",
    "calendar.meetSwap.policy.outside": [{"type":0,"value":"Events organised outside "},{"type":1,"value":"workspace"},{"type":0,"value":" are never changed. Each person gets a notice in Activity listing what moved."}],
    "calendar.meetSwap.policy.turnOn": "Turn on",
    "calendar.meetSwap.policy.restoreConfirm": "Put the Google Meet links back for everyone? Guests get another update.",
    "calendar.meetSwap.policy.failed": "Couldn't change the setting. Try again.",
    "getApp.banner.desktop": "Bundle works better in the desktop app.",
    "getApp.openInApp": "Open in app",
    "getApp.download.mac": "Download for Mac",
    "getApp.download.windows": "Download for Windows",
    "getApp.download.linux": "Download for Linux",
    "getApp.mobile.title": "Bundle",
    "getApp.mobile.message": "Mail, chat and calls work better in the app.",
    "getApp.store.appStore": "Free on the App Store",
    "getApp.store.testflight": "Free beta on TestFlight",
    "getApp.store.play": "Free on Google Play",
    "getApp.store.apk": "Direct download (.apk)",
    "getApp.action.get": "Get",
    "getApp.action.install": "Install",
    "getApp.action.download": "Download",
    "getApp.menu.desktop": "Get the desktop app",
    "getApp.menu.mobile": "Get the mobile app",
    "getApp.menu.any": "Get the apps",
    "getApp.dismiss": "Not now",
    "getApp.handoff.title": "Opening Bundle…",
    "getApp.handoff.body": "Click Open Bundle if nothing happens.",
    "getApp.handoff.open": "Open Bundle",
    "getApp.handoff.browser": "Continue in browser",
    "getApp.handoff.noApp": "Don't have the app?",
    "getApp.handoff.allDownloads": "See all downloads",
    "billing.store.choosePlan": "Choose a plan",
    "billing.store.pickerTitle": "Subscribe to Starter",
    "billing.store.cycle.yearly": [{"type":0,"value":"Yearly · save "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "billing.store.cycle.monthly": "Monthly",
    "billing.store.price.perYear": [{"type":1,"value":"price"},{"type":0,"value":"/year"}],
    "billing.store.price.perMonth": [{"type":1,"value":"price"},{"type":0,"value":"/month"}],
    "billing.store.priceSource.appStore": "Price from the App Store, in your currency.",
    "billing.store.priceSource.googlePlay": "Price from Google Play, in your currency.",
    "billing.store.storage.label": "Extra storage",
    "billing.store.storage.value": [{"type":0,"value":"+"},{"type":1,"value":"gb"},{"type":0,"value":" GB"}],
    "billing.store.storage.none": "None",
    "billing.store.storage.hint": "Starter includes 30 GB shared by everyone. Each step adds 50 GB.",
    "billing.store.storage.less": "Less storage",
    "billing.store.storage.more": "More storage",
    "billing.store.billedToday": "Billed today",
    "billing.store.trialEnds": "Your free trial ends when you subscribe.",
    "billing.store.subscribe.appStore": "Subscribe with Apple",
    "billing.store.subscribe.googlePlay": "Subscribe with Google",
    "billing.store.period.month": "month",
    "billing.store.period.year": "year",
    "billing.store.legal.appStore": [{"type":0,"value":"Renews automatically at "},{"type":1,"value":"price"},{"type":0,"value":" a "},{"type":1,"value":"period"},{"type":0,"value":" until you cancel. Payment is charged to your Apple Account when you confirm. Cancel at least 24 hours before renewal in Settings → Apple Account → Subscriptions."}],
    "billing.store.legal.googlePlay": [{"type":0,"value":"Renews automatically at "},{"type":1,"value":"price"},{"type":0,"value":" a "},{"type":1,"value":"period"},{"type":0,"value":" until you cancel. Charged to your Google Play account. Cancel any time in Google Play → Payments & subscriptions."}],
    "billing.store.terms": "Terms of Use",
    "billing.store.privacy": "Privacy Policy",
    "billing.store.restore": "Restore purchases",
    "billing.store.restored": "Purchases restored.",
    "billing.store.restoreNone": "No subscription to restore on this account.",
    "billing.store.confirming": "Confirming…",
    "billing.store.pending.appStore": [{"type":0,"value":"Purchase pending. We'll switch "},{"type":1,"value":"ws"},{"type":0,"value":" to Starter as soon as the App Store approves the payment."}],
    "billing.store.pending.googlePlay": [{"type":0,"value":"Purchase pending. We'll switch "},{"type":1,"value":"ws"},{"type":0,"value":" to Starter as soon as Google Play confirms the payment."}],
    "billing.store.success": [{"type":1,"value":"ws"},{"type":0,"value":" is on Starter. Thanks for subscribing."}],
    "billing.store.failed.appStore": "The App Store couldn't complete the purchase. You weren't charged. Try again.",
    "billing.store.failed.googlePlay": "Google Play couldn't complete the purchase. You weren't charged. Try again.",
    "billing.store.slow": "Your purchase went through, but Bundle hasn't confirmed it yet. This page updates by itself. If it doesn't, tap Restore purchases.",
    "billing.store.already": [{"type":1,"value":"ws"},{"type":0,"value":" already has a subscription. Nothing was charged."}],
    "billing.store.accountInUse.appStore": "This Apple Account already pays for another workspace. Use a different Apple Account, or subscribe from Bundle on the web.",
    "billing.store.accountInUse.googlePlay": "This Google account already pays for another workspace. Use a different Google account, or subscribe from Bundle on the web.",
    "billing.store.unavailable": "Purchases aren't available right now. Try again later.",
    "billing.store.billedThrough": "Billed through",
    "billing.store.name.appStore": "App Store",
    "billing.store.name.googlePlay": "Google Play",
    "billing.store.name.stripe": "Card",
    "billing.store.subscribedBy": "Subscribed by",
    "billing.store.you": "You",
    "billing.store.manage.appStore": "Manage in App Store",
    "billing.store.manage.googlePlay": "Manage in Google Play",
    "billing.store.manageHint.appStore": "Change the plan, extra storage or cancel in the App Store.",
    "billing.store.manageHint.googlePlay": "Change the plan, extra storage or cancel in Google Play.",
    "billing.store.elsewhere.appStore": [{"type":0,"value":"This subscription is managed in the App Store by "},{"type":1,"value":"name"},{"type":0,"value":". Change or cancel it there, on their iPhone, iPad or Mac."}],
    "billing.store.elsewhere.googlePlay": [{"type":0,"value":"This subscription is managed in Google Play by "},{"type":1,"value":"name"},{"type":0,"value":". Change or cancel it there, on their Android phone or tablet."}],
    "billing.store.card": "Billed by card. Change the plan, card or invoices from Bundle on the web or desktop.",
    "settings.section.profile": "Profile & status",
    "settings.section.account": "Account & sign-in",
    "settings.section.notifications": "Notifications",
    "settings.section.appearance": "Appearance",
    "settings.section.mail": "Mail",
    "settings.section.calendar": "Calendar & meetings",
    "settings.section.sidebar": "Sidebar & tabs",
    "settings.section.tabs": "Tabs",
    "settings.section.privacy": "Privacy & data",
    "settings.section.general": "General",
    "settings.section.people": "People",
    "settings.section.billing": "Plan & billing",
    "settings.section.features": "Features & apps",
    "settings.section.domains": "Mail & domains",
    "settings.section.huddles": "Meet",
    "settings.section.import": "Import & export",
    "settings.section.workspace": "Workspace",
    "settings.section.device": "Sounds & haptics",
    "settings.section.sync": "Desktop sync",
    "settings.section.help": "Help & about",
    "settings.section.profile.desc": [{"type":0,"value":"How people see you in "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.section.account.desc": "How you get into Bundle. The addresses you send mail from are in Mail.",
    "settings.section.notifications.desc": "Everything that can ping you, in one place. Saved to your account and used on every device.",
    "settings.section.appearance.desc": "Theme, accent colour and language. Saved to your account.",
    "settings.section.mail.desc": "The addresses you send from, your signatures and the accounts you bring in.",
    "settings.section.calendar.desc": "Video calls on your events, and your booking pages.",
    "settings.section.sidebar.desc": "What's in your tabs and your phone's bottom bar.",
    "settings.section.privacy.desc": "People you've blocked, a copy of your data, and deleting your account.",
    "settings.section.general.desc": [{"type":0,"value":"Name, icon, link and email domains for "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.section.people.desc": "Members, invitations, guests and agents, and user groups.",
    "settings.section.billing.desc": "Plan, usage and invoices.",
    "settings.section.features.desc": "Turn parts of Bundle on or off, and connect apps.",
    "settings.section.domains.desc": [{"type":0,"value":"Domains, mailboxes, routing and inbox tabs for everyone in "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.section.huddles.desc": "Meeting links, notes and people from outside.",
    "settings.section.import.desc": "Bring things in from Slack and Google Drive, export the workspace, and review reports.",
    "settings.section.workspace.desc": "Only owners and admins can change these.",
    "settings.section.device.desc": "Only on this device.",
    "settings.section.sync.desc": "Folders on this computer that stay in step with Files.",
    "settings.section.help.desc": "Help, what's new, feedback and the version you're on.",
    "settings.search.profile": "photo, avatar, name, display name, title, pronouns, phone, status, time zone, link",
    "settings.search.account": "email, sign-in, sign in, login, Google, Apple, password, app passwords, sessions, devices, sign out, delete account",
    "settings.search.notifications": "pause, quiet hours, do not disturb, mentions, direct messages, threads, channels, meet, meetings, calls, huddles, reminders, new email, mail tabs, sound, banners, push",
    "settings.search.appearance": "theme, dark mode, light mode, accent, colour, color, language, idioma, Português, English",
    "settings.search.mail": "mailbox, alias, send as, reply from, default address, signature, import mail, Gmail, IMAP, groups",
    "settings.search.calendar": "video calls, Google Meet, Zoom, meeting links, booking pages, phone sync, CalDAV",
    "settings.search.sidebar": "tabs, bottom bar, navigation, customize tabs, sidebar",
    "settings.search.privacy": "blocked people, block, export my data, download data, delete account, Slack import",
    "settings.search.general": "workspace name, icon, link, URL, email domains, link previews, unfurls, sharing, delete workspace",
    "settings.search.people": "members, invite, invitations, guests, agents, bots, user groups, roles, admins, deactivate",
    "settings.search.billing": "plan, billing, invoices, card, payment, storage, upgrade, subscription",
    "settings.search.features": "features, turn off chat, mail, calendar, contacts, docs, integrations, apps, webhooks, slash commands, stickers, GIFs",
    "settings.search.domains": "domains, DNS, MX, SPF, DKIM, mailboxes, aliases, routing, inbox tabs, Sent with Bundle, footer",
    "settings.search.huddles": "meet, meetings, calls, huddles, meeting links, transcripts, recordings, notes, outside people, video calls policy",
    "settings.search.import": "Slack import, Slack sync, Google Drive, export workspace, reports, reported messages",
    "settings.search.workspace": "workspace, plan, admins, owners",
    "settings.search.device": "sound, haptics, vibration, notification sound, allow notifications, banners",
    "settings.search.sync": "desktop sync, folders, launch at login, bandwidth, conflicts",
    "settings.search.help": "help, what's new, feedback, analytics, version, about, legal, privacy policy",
    "settings.searchPlaceholder": "Search settings",
    "settings.searchEmpty": [{"type":0,"value":"No settings match “"},{"type":1,"value":"query"},{"type":0,"value":"”."}],
    "settings.adminChip": "Admin",
    "settings.group.device.browser": "This browser",
    "settings.group.device.mac": "This Mac",
    "settings.group.device.computer": "This computer",
    "settings.group.device.iphone": "This iPhone",
    "settings.group.device.ipad": "This iPad",
    "settings.group.device.phone": "This phone",
    "settings.group.device.tablet": "This tablet",
    "settings.hub.group.general": "General",
    "settings.hub.group.people": "People",
    "settings.hub.group.whatsOn": "What’s on",
    "settings.hub.group.mail": "Mail",
    "settings.hub.group.planData": "Plan & data",
    "settings.hub.name": "Name, icon & link",
    "settings.hub.linkPreviews": "Link previews",
    "settings.hub.members": "Members",
    "settings.hub.invitations": "Invitations",
    "settings.hub.guests": "Guests & agents",
    "settings.hub.userGroups": "User groups",
    "settings.hub.features": "Features",
    "settings.hub.huddles": "Meet",
    "settings.hub.apps": "Apps & integrations",
    "settings.hub.domains": "Domains & mailboxes",
    "settings.hub.sentWithBundle": "“Sent with Bundle”",
    "settings.hub.billing": "Plan & billing",
    "settings.hub.pendingCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pending"}]},"other":{"value":[{"type":7},{"type":0,"value":" pending"}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.hub.import": "Import & export",
    "settings.hub.reports": "Reports",
    "settings.hub.role.admin": "You're an admin",
    "settings.hub.role.owner": "You're an owner",
    "settings.hub.role.member": "Member",
    "settings.hub.role.guest": "Guest",
    "settings.profileCard.sub": "Profile and status",
    "settings.saved.check": "Saved",
    "settings.notifications.deviceOnly": "This device only",
    "settings.notifications.alwaysCodes": "Verification codes always notify, with a Copy button. Spam never does.",
    "settings.notifications.on": "Notifications are on",
    "settings.notifications.quietSummary": [{"type":0,"value":"Quiet hours "},{"type":1,"value":"days"},{"type":0,"value":", "},{"type":1,"value":"from"},{"type":0,"value":" to "},{"type":1,"value":"to"}],
    "settings.notifications.noQuiet": "No quiet hours",
    "settings.notifications.quietHours": "Quiet hours",
    "settings.notifications.pause": "Pause…",
    "settings.notifications.unavailable": "Not available here",
    "settings.notifications.blockedShort": "Blocked",
    "settings.notifications.allowed": "Allowed · Turn off",
    "settings.notifications.allowedHelp": "Banners show when Bundle isn't in front.",
    "settings.notifications.banners": "Notifications on this device",
    "settings.notifications.soundOff": "Off",
    "mail.notify.tabsNone": "None",
    "settings.help.title": "Help",
    "settings.help.foot": "Ask Support and Send feedback are in the Help menu (?).",
    "settings.help.open": "Open",
    "settings.help.about": "About",
    "settings.help.version": "Version",
    "settings.sync.unavailable": "This version of the app can't sync folders.",
    "settings.sync.on": "Sync is on",
    "settings.sync.off": "Sync is off",
    "settings.sync.body": "Choose folders, launch at login, bandwidth and conflicts in the sync panel.",
    "settings.meta.mailboxes": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" account"}]},"other":{"value":[{"type":7},{"type":0,"value":" accounts"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.settings.addresses": "Addresses you send from",
    "mail.settings.addressesFoot": "You can still pick another address in From when you write.",
    "mail.settings.addressShared": [{"type":0,"value":"Shared · "},{"type":1,"value":"name"}],
    "mail.settings.addressDefault": "Default",
    "mail.settings.addressGroup": [{"type":0,"value":"Group · "},{"type":1,"value":"name"}],
    "mail.settings.sending": "Sending and replying",
    "mail.settings.defaultFrom": "Send new messages from",
    "mail.settings.replyFrom": "When replying to a message",
    "mail.settings.replyFrom.same": "Reply from the same address the message was sent to",
    "mail.settings.replyFrom.default": "Always reply from default address",
    "mail.settings.sendingFailed": "Couldn't save. Try again.",
    "settings.appearance.accent": "Accent colour",
    "settings.appearance.accent.indigo": "Indigo",
    "settings.appearance.accent.teal": "Teal",
    "settings.appearance.accent.orange": "Orange",
    "settings.appearance.accent.purple": "Purple",
    "settings.notifications.paused": "Paused",
    "settings.device.allowed": "Allowed",
    "settings.device.notAllowed": "Not allowed",
    "settings.device.previews": "Show message text",
    "settings.device.systemHint": "Sounds, banners and message previews for Bundle are set in this device's Settings app.",
    "settings.device.openSystem": "Open device settings",
    "settings.appearance.languageSystem": "Bundle uses the language chosen for it in this device's Settings app.",
    "settings.workspace.admins": "Owners and admins",
    "settings.workspace.message": "Message",
    "settings.workspace.adminsFoot": "Ask one of them to change workspace settings or the plan.",
    "settings.workspace.messageAdmin": "Message admin",
    "settings.workspace.readOnly": "Only owners and admins can change workspace settings. Ask one of them for help.",
    "settings.notifications.onShort": "On",
    "settings.device.haptics": "Haptics",
    "settings.device.hapticsHint": "Light vibrations when you save a change, switch something on or off, or press and hold.",
    "auth.error.challengeExpired": "That took too long. Sign in again.",
    "auth.error.passkey": "Passkey sign-in didn't work. Try again or sign in another way.",
    "accountSecurity.emails.title": "Email addresses",
    "accountSecurity.emails.add": "Add email",
    "accountSecurity.emails.foot": "A new address gets a code before it can be used.",
    "accountSecurity.emails.primary": "Primary",
    "accountSecurity.emails.verified": "Verified",
    "accountSecurity.emails.pending": "Waiting for code",
    "accountSecurity.emails.primaryHint": "Sign-in and account emails go here",
    "accountSecurity.emails.secondaryHint": "Can also sign in",
    "accountSecurity.emails.makePrimary": "Make primary",
    "accountSecurity.emails.remove": "Remove",
    "accountSecurity.emails.enterCode": "Enter code",
    "accountSecurity.emails.addTitle": "Add an email address",
    "accountSecurity.emails.addBody": "You can sign in with any of your addresses. We'll send a 6-digit code to the new one.",
    "accountSecurity.emails.sendCode": "Send code",
    "accountSecurity.emails.verifyTitle": "Enter the code",
    "accountSecurity.emails.verifyBody": [{"type":0,"value":"We sent a 6-digit code to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "accountSecurity.emails.removeTitle": [{"type":0,"value":"Remove "},{"type":1,"value":"email"},{"type":0,"value":"?"}],
    "accountSecurity.emails.removeBody": "You won't be able to sign in with this address any more.",
    "accountSecurity.emails.primaryTitle": [{"type":0,"value":"Make "},{"type":1,"value":"email"},{"type":0,"value":" your primary address?"}],
    "accountSecurity.emails.primaryBody": "Sign-in and account emails will go there. We'll email your old address a link to undo it.",
    "accountSecurity.password.title": "Password",
    "accountSecurity.password.on": "Sign in with your email and password",
    "accountSecurity.password.off": "Not set. You sign in with a code or another way.",
    "accountSecurity.password.set": "Set password",
    "accountSecurity.password.change": "Change password",
    "accountSecurity.password.remove": "Remove password",
    "accountSecurity.password.current": "Current password",
    "accountSecurity.password.removeBody": "You'll sign in with an email code or another way instead.",
    "accountSecurity.passkeys.title": "Passkeys",
    "accountSecurity.passkeys.body": "Sign in with your fingerprint, face or screen lock.",
    "accountSecurity.passkeys.add": "Add passkey",
    "accountSecurity.passkeys.unnamed": "Passkey",
    "accountSecurity.passkeys.used": [{"type":0,"value":"Added "},{"type":1,"value":"added"},{"type":0,"value":" · Last used "},{"type":1,"value":"used"}],
    "accountSecurity.passkeys.unused": [{"type":0,"value":"Added "},{"type":1,"value":"added"},{"type":0,"value":" · Not used yet"}],
    "accountSecurity.passkeys.rename": "Rename",
    "accountSecurity.passkeys.renameTitle": "Rename passkey",
    "accountSecurity.passkeys.name": "Name",
    "accountSecurity.passkeys.deleteTitle": "Delete this passkey?",
    "accountSecurity.passkeys.deleteBody": "You won't be able to sign in with it any more. Remove it from your password manager too.",
    "accountSecurity.passkeys.cancelled": "The passkey wasn't created.",
    "accountSecurity.twoStep.title": "Two-step verification",
    "accountSecurity.twoStep.on": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"On · Authenticator app · "},{"type":7},{"type":0,"value":" backup code left"}]},"other":{"value":[{"type":0,"value":"On · Authenticator app · "},{"type":7},{"type":0,"value":" backup codes left"}]}},"offset":0,"pluralType":"cardinal"}],
    "accountSecurity.twoStep.off": "Ask for a code from an authenticator app when you sign in.",
    "accountSecurity.twoStep.setUp": "Set up",
    "accountSecurity.twoStep.turnOff": "Turn off",
    "accountSecurity.twoStep.newCodes": "New backup codes",
    "accountSecurity.twoStep.setupBody": "Add Bundle to the authenticator app on this phone, then enter the 6-digit code it shows.",
    "accountSecurity.twoStep.openApp": "Open authenticator app",
    "accountSecurity.twoStep.copyKey": "Copy setup key",
    "accountSecurity.twoStep.keyCopied": "Setup key copied",
    "accountSecurity.twoStep.keyLabel": "Setup key",
    "accountSecurity.twoStep.noApp": "No authenticator app found. Copy the setup key into one instead.",
    "accountSecurity.twoStep.backupTitle": "Save your backup codes",
    "accountSecurity.twoStep.backupBody": "Each code works once if you can't use your authenticator app. They're shown only now.",
    "accountSecurity.twoStep.copyCodes": "Copy codes",
    "accountSecurity.twoStep.shareCodes": "Share",
    "accountSecurity.twoStep.codesCopied": "Backup codes copied",
    "accountSecurity.twoStep.shareTitle": "Bundle backup codes",
    "accountSecurity.twoStep.done": "Done",
    "accountSecurity.twoStep.offTitle": "Turn off two-step verification?",
    "accountSecurity.twoStep.offBody": "Signing in will need only your password, an email code or a linked account.",
    "accountSecurity.stepUp.title": "Confirm it's you",
    "accountSecurity.stepUp.passwordBody": "Enter your current password.",
    "accountSecurity.stepUp.codeBody": [{"type":0,"value":"We sent a 6-digit code to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "accountSecurity.stepUp.codeLabel": "Code",
    "accountSecurity.stepUp.confirm": "Confirm",
    "accountSecurity.sessions.place": [{"type":1,"value":"place"},{"type":0,"value":" · "},{"type":1,"value":"activity"}],
    "accountSecurity.error.wrongPassword": "That password isn't right.",
    "accountSecurity.error.locked": "Too many attempts. Try again in 15 minutes.",
    "accountSecurity.error.invalidCode": "That code isn't right or has expired.",
    "accountSecurity.error.passwordTooLong": "Use at most 128 characters.",
    "accountSecurity.error.passwordContainsEmail": "Don't use your email address in your password.",
    "accountSecurity.error.passwordLeaked": "That password has appeared in a data breach. Choose another.",
    "accountSecurity.error.lastMethod": "This is your only way to sign in. Add another one first.",
    "accountSecurity.error.emailInUse": "That address belongs to another Bundle account.",
    "accountSecurity.error.signInAgain": "Sign out and back in, then try again.",
    "accountSecurity.error.failed": "Something went wrong. Try again.",
    "settings.signIn.emails.title": "Email addresses",
    "settings.signIn.emails.add": "Add email",
    "settings.signIn.emails.foot": "A new address gets a code before it can be used.",
    "settings.signIn.emails.primary": "Primary",
    "settings.signIn.emails.verified": "Verified",
    "settings.signIn.emails.pending": "Waiting for code",
    "settings.signIn.emails.primarySub": "Sign-in and account emails go here",
    "settings.signIn.emails.secondarySub": "Can also sign in",
    "settings.signIn.emails.pendingSub": "Enter the code we sent to start using it",
    "settings.signIn.emails.verify": "Verify",
    "settings.signIn.emails.makePrimary": "Make primary",
    "settings.signIn.emails.remove": "Remove",
    "settings.signIn.emails.addTitle": "Add an email address",
    "settings.signIn.emails.addBody": "You can sign in with it too. We'll send it a 6-digit code.",
    "settings.signIn.emails.addLabel": "Email address",
    "settings.signIn.emails.sendCode": "Send code",
    "settings.signIn.emails.codeTitle": "Check your email",
    "settings.signIn.emails.codeBody": [{"type":0,"value":"We sent a 6-digit code to "},{"type":1,"value":"email"},{"type":0,"value":". It expires in 10 minutes."}],
    "settings.signIn.emails.codeLabel": "Code",
    "settings.signIn.emails.resend": "Send a new code",
    "settings.signIn.emails.changeEmail": "Use a different email",
    "settings.signIn.emails.removeTitle": [{"type":0,"value":"Remove "},{"type":1,"value":"email"},{"type":0,"value":"?"}],
    "settings.signIn.emails.removeBody": "You won't be able to sign in with this address any more.",
    "settings.signIn.emails.primaryTitle": [{"type":0,"value":"Make "},{"type":1,"value":"email"},{"type":0,"value":" your primary address?"}],
    "settings.signIn.emails.primaryBody": [{"type":0,"value":"Sign-in and account emails will go to "},{"type":1,"value":"email"},{"type":0,"value":". We'll email "},{"type":1,"value":"old"},{"type":0,"value":" a link to undo this for 7 days, and "},{"type":1,"value":"old"},{"type":0,"value":" can still sign in."}],
    "settings.signIn.emails.primaryChanged": [{"type":1,"value":"email"},{"type":0,"value":" is now your primary address. We emailed "},{"type":1,"value":"old"},{"type":0,"value":" a link to undo this for 7 days."}],
    "settings.signIn.methods.title": "Password & sign-in",
    "settings.signIn.password.label": "Password",
    "settings.signIn.password.subOn": "Sign in with your email and password",
    "settings.signIn.password.subOff": "Not set. You sign in with a code from your email.",
    "settings.signIn.password.set": "Set password",
    "settings.signIn.password.change": "Change password",
    "settings.signIn.password.remove": "Remove",
    "settings.signIn.password.setTitle": "Set a password",
    "settings.signIn.password.changeTitle": "Change your password",
    "settings.signIn.password.removeTitle": "Remove your password?",
    "settings.signIn.password.removeBody": "You'll sign in with a code from your email, a passkey or a linked account instead.",
    "settings.signIn.password.new": "New password",
    "settings.signIn.password.save": "Save password",
    "settings.signIn.password.removeConfirm": "Remove password",
    "settings.signIn.password.signedOut": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Password saved. We signed you out on "},{"type":7},{"type":0,"value":" other device."}]},"other":{"value":[{"type":0,"value":"Password saved. We signed you out on "},{"type":7},{"type":0,"value":" other devices."}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.signIn.proof.passwordLabel": "Current password",
    "settings.signIn.proof.passwordBody": "Enter your password to continue.",
    "settings.signIn.proof.codeBody": [{"type":0,"value":"To continue, we'll email a 6-digit code to "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "settings.signIn.proof.sendCode": "Email me a code",
    "settings.signIn.proof.codeSent": [{"type":0,"value":"We sent a 6-digit code to "},{"type":1,"value":"email"},{"type":0,"value":". It expires in 10 minutes."}],
    "settings.signIn.proof.codeLabel": "Code from your email",
    "settings.signIn.proof.resend": "Send a new code",
    "settings.signIn.continue": "Continue",
    "settings.signIn.passkeys.label": "Passkeys",
    "settings.signIn.passkeys.sub": "Sign in with Face ID, Touch ID or a security key",
    "settings.signIn.passkeys.add": "Add passkey",
    "settings.signIn.passkeys.unnamed": "Passkey",
    "settings.signIn.passkeys.meta": [{"type":0,"value":"Added "},{"type":1,"value":"created"},{"type":0,"value":" · last used "},{"type":1,"value":"used"}],
    "settings.signIn.passkeys.metaNever": [{"type":0,"value":"Added "},{"type":1,"value":"created"},{"type":0,"value":" · not used yet"}],
    "settings.signIn.passkeys.rename": "Rename",
    "settings.signIn.passkeys.delete": "Delete",
    "settings.signIn.passkeys.addTitle": "Add a passkey",
    "settings.signIn.passkeys.addBody": "Your browser or device will ask you to confirm with Face ID, Touch ID, your screen lock or a security key.",
    "settings.signIn.passkeys.nameLabel": "Name (optional)",
    "settings.signIn.passkeys.namePlaceholder": "MacBook Touch ID",
    "settings.signIn.passkeys.renameTitle": "Rename passkey",
    "settings.signIn.passkeys.renameLabel": "Name",
    "settings.signIn.passkeys.deleteTitle": "Delete this passkey?",
    "settings.signIn.passkeys.deleteBody": [{"type":0,"value":"You won't be able to sign in with "},{"type":1,"value":"name"},{"type":0,"value":" any more. Remove it from your password manager too."}],
    "settings.signIn.passkeys.only": "It's your only way to sign in, so it can't be deleted.",
    "settings.signIn.twoFactor.label": "Two-step verification",
    "settings.signIn.twoFactor.subOn": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Authenticator app · "},{"type":7},{"type":0,"value":" backup code left"}]},"other":{"value":[{"type":0,"value":"Authenticator app · "},{"type":7},{"type":0,"value":" backup codes left"}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.signIn.twoFactor.subOff": "Ask for a code from an authenticator app when you sign in",
    "settings.signIn.twoFactor.on": "On",
    "settings.signIn.twoFactor.setUp": "Set up",
    "settings.signIn.twoFactor.manage": "Manage",
    "settings.signIn.twoFactor.newCodes": "Get new backup codes",
    "settings.signIn.twoFactor.turnOff": "Turn off",
    "settings.signIn.twoFactor.setupTitle": "Set up two-step verification",
    "settings.signIn.twoFactor.scanBody": "Scan this QR code with an authenticator app, like Google Authenticator, 1Password or Authy. Then enter the 6-digit code it shows.",
    "settings.signIn.twoFactor.qrLabel": "QR code for your authenticator app",
    "settings.signIn.twoFactor.secretLabel": "Can't scan it? Enter this key",
    "settings.signIn.twoFactor.copyKey": "Copy key",
    "settings.signIn.twoFactor.codeLabel": "6-digit code from the app",
    "settings.signIn.twoFactor.verify": "Turn on",
    "settings.signIn.twoFactor.codesTitle": "Save your backup codes",
    "settings.signIn.twoFactor.codesBody": "Use one when you can't get a code from your app. Each code works once. You won't see them again.",
    "settings.signIn.twoFactor.copy": "Copy",
    "settings.signIn.twoFactor.copied": "Copied",
    "settings.signIn.twoFactor.download": "Download",
    "settings.signIn.twoFactor.done": "Done",
    "settings.signIn.twoFactor.fileHeading": "Bundle backup codes. Each code works once.",
    "settings.signIn.twoFactor.newCodesTitle": "Get new backup codes",
    "settings.signIn.twoFactor.newCodesBody": "Your old backup codes stop working.",
    "settings.signIn.twoFactor.offTitle": "Turn off two-step verification?",
    "settings.signIn.twoFactor.offBody": "Signing in will no longer ask for a code from your authenticator app, and your backup codes stop working.",
    "settings.signIn.error.wrongPassword": "That password isn't right.",
    "settings.signIn.error.locked": "Too many attempts. Try again in 15 minutes.",
    "settings.signIn.error.invalidCode": "That code isn't right or has expired.",
    "settings.signIn.error.challengeExpired": "That took too long. Start again.",
    "settings.signIn.error.passwordTooShort": "Use at least 8 characters.",
    "settings.signIn.error.passwordTooLong": "Use 128 characters or fewer.",
    "settings.signIn.error.passwordContainsEmail": "Don't use your email address in your password.",
    "settings.signIn.error.passwordTooCommon": "That password is too common. Choose another.",
    "settings.signIn.error.passwordLeaked": "That password has appeared in a data breach. Choose another.",
    "settings.signIn.error.passwordExists": "You already have a password.",
    "settings.signIn.error.emailCodeRequired": "Enter the code from your email.",
    "settings.signIn.error.passwordRequired": "Enter your current password.",
    "settings.signIn.error.lastMethod": "It's your only way to sign in. Add another one first.",
    "settings.signIn.error.emailInUse": "That address is already used by another account.",
    "settings.signIn.error.invalidEmail": "Enter a valid email address.",
    "settings.signIn.error.signInAgain": "For your security, sign in again and try once more.",
    "settings.signIn.error.rateLimited": "Too many tries. Wait a few minutes and try again.",
    "settings.signIn.error.linkExpired": "That link has expired.",
    "account.undoEmail.working": "Restoring your sign-in email…",
    "account.undoEmail.doneTitle": "Your email is back",
    "account.undoEmail.doneBody": [{"type":1,"value":"email"},{"type":0,"value":" is your sign-in email again. We signed you out everywhere, so sign in again. If you didn't make the change, change your password too."}],
    "account.undoEmail.signIn": "Sign in",
    "account.undoEmail.expiredTitle": "This link has expired",
    "account.undoEmail.expiredBody": "Undo links work once, for 7 days. Sign in and check your email addresses in Settings › Account & sign-in, or ask a workspace admin for help.",
    "account.undoEmail.failedTitle": "Couldn't undo the change",
    "auth.signup.subtitle": "Start with your name and work email.",
    "auth.signup.haveAccount": "Already have an account?",
    "auth.signup.newToBundle": "New to Bundle?",
    "auth.signup.secureSubtitle": "Optional. You can always sign in with an email code.",
    "phone.verifyTitle": "Verify your phone",
    "phone.verifyBody": "If you ever can't get to your email, you can sign in with a code sent to this number.",
    "phone.requiredTitle": "Add a phone number",
    "phone.requiredBody": "Your email is hosted on Bundle. If you're ever locked out of it, your phone is how you get back in.",
    "phone.country": "Country",
    "phone.number": "Phone number",
    "phone.searchCountries": "Search countries",
    "phone.fromGoogle": "From your Google account",
    "phone.fromSlack": "From Slack",
    "phone.importGoogle": "Use the number from my Google account",
    "phone.sendCode": "Send code",
    "phone.otherNumber": "Use a different number",
    "phone.skip": "Skip for now",
    "phone.rates": "Message and data rates may apply.",
    "phone.codeTitle": "Enter the code",
    "phone.codeSentTo": [{"type":0,"value":"We texted a 6-digit code to "},{"type":1,"value":"phone"},{"type":0,"value":"."}],
    "phone.calledTo": [{"type":0,"value":"We're calling "},{"type":1,"value":"phone"},{"type":0,"value":" to read you a 6-digit code."}],
    "phone.codeLabel": "Code",
    "phone.verify": "Verify",
    "phone.resendIn": [{"type":0,"value":"Resend code in "},{"type":1,"value":"time"}],
    "phone.resend": "Resend code",
    "phone.callMe": "Call me instead",
    "phone.changeNumber": "Change number",
    "phone.cantGetCode": "Can't get the code?",
    "phone.textMe": "Text me a code instead",
    "phone.textMeTo": [{"type":0,"value":"To "},{"type":1,"value":"phone"}],
    "phone.signInTitle": "Check your phone",
    "phone.signInBody": [{"type":0,"value":"We texted a 6-digit code to "},{"type":1,"value":"phone"},{"type":0,"value":"."}],
    "phone.twoStepNext": "If two-step verification is on, your authenticator code comes next.",
    "phone.tryOther": "Try another way",
    "phone.twoStepTextMe": [{"type":0,"value":"Text a code to "},{"type":1,"value":"phone"}],
    "phone.settingsRow": "Phone number",
    "phone.settingsVerified": "Verified · signs you in when you can't get your email",
    "phone.settingsNone": "Add a number to sign in when you can't get your email.",
    "phone.settingsNote": "Adding, changing or removing it asks for your password or an email code first, then a text to the new number. We email you and send a notification about every change.",
    "phone.add": "Add",
    "phone.change": "Change",
    "phone.remove": "Remove",
    "phone.removeTitle": "Remove your phone number?",
    "phone.removeBody": [{"type":0,"value":"You won't be able to sign in with a text to "},{"type":1,"value":"phone"},{"type":0,"value":" any more."}],
    "phone.added": "Phone number added",
    "phone.removed": "Phone number removed",
    "phone.error.invalidCode": "That code isn't right. Check it and try again.",
    "phone.error.tooMany": "Too many tries. Wait 15 minutes, or sign in with your email.",
    "phone.error.inUse": "This number is already on another Bundle account. Use a different number.",
    "phone.error.invalidPhone": "Enter a valid phone number.",
    "phone.error.country": "We can't text numbers in that country yet.",
    "phone.error.rateLimited": "Too many codes. Try again later.",
    "phone.error.notSent": "We couldn't send the code. Try again.",
    "phone.error.required": "Your email is hosted on Bundle, so your account needs a phone number. You can change it.",
    "phone.error.alreadyUsed": "You signed in with your phone. Use your authenticator app or a backup code.",
    "phone.error.usNotReady": "Texts to US numbers aren't available yet.",
    "phone.error.caNotReady": "Texts to Canadian numbers aren't available yet.",
    "phone.noSmsTitle": "Didn't get a text?",
    "phone.noSmsBody": [{"type":0,"value":"It can take a minute. You can resend in "},{"type":1,"value":"time"},{"type":0,"value":", or we can call you with the code."}],
    "phone.call": "Call me",
  },
  "pt-BR": {
    "app.name": "Bundle",
    "common.cancel": "Cancelar",
    "common.save": "Salvar",
    "common.delete": "Excluir",
    "common.edit": "Editar",
    "common.close": "Fechar",
    "common.loading": "Carregando…",
    "common.retry": "Tentar novamente",
    "primitive.badge.unread": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" não lida"}]},"other":{"value":[{"type":7},{"type":0,"value":" não lidas"}]}},"offset":0,"pluralType":"cardinal"}],
    "primitive.iconButton.badgeCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"label"},{"type":0,"value":", "},{"type":7},{"type":0,"value":" não lida"}]},"other":{"value":[{"type":1,"value":"label"},{"type":0,"value":", "},{"type":7},{"type":0,"value":" não lidas"}]}},"offset":0,"pluralType":"cardinal"}],
    "primitive.iconButton.badgeDot": [{"type":1,"value":"label"},{"type":0,"value":", nova atividade"}],
    "primitive.chip.remove": [{"type":0,"value":"Remover "},{"type":1,"value":"label"}],
    "primitive.select.placeholder": "Escolher…",
    "primitive.listRow.expand": "Expandir",
    "primitive.listRow.collapse": "Recolher",
    "usageMeter.value": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"limit"}],
    "usageMeter.almostFull": "Quase cheio",
    "usageMeter.full": "Cheio",
    "usageMeter.noLimit": "Sem limite",
    "usageMeter.noLimitDetail": [{"type":0,"value":"Sem limite · "},{"type":1,"value":"detail"}],
    "editor.todo.done": "Concluída",
    "shell.search.placeholder": "Pesquisar em tudo",
    "shell.omnibox.placeholder": "Pesquisar ou ir para…",
    "shell.newTab": "Nova aba",
    "shell.closeTab": "Fechar aba",
    "shell.splitRight": "Abrir em tela dividida",
    "shell.back": "Voltar",
    "shell.forward": "Avançar",
    "shell.toggleSidebar": "Mostrar/ocultar barra lateral",
    "shell.tabs.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" aba"}]},"other":{"value":[{"type":7},{"type":0,"value":" abas"}]}},"offset":0,"pluralType":"cardinal"}],
    "shell.views": "Visualizações",
    "shell.view.chat": "Chat",
    "shell.view.email": "E-mail",
    "shell.view.docs": "Documentos",
    "nav.home": "Início",
    "tabTitle.channel": [{"type":1,"value":"name"},{"type":0,"value":" (Canal)"}],
    "tabTitle.dm": [{"type":1,"value":"name"},{"type":0,"value":" (DM)"}],
    "nav.inbox": "Caixa de entrada",
    "nav.projects": "Projetos",
    "nav.agents": "Agentes",
    "nav.channels": "Canais",
    "nav.directMessages": "Mensagens diretas",
    "channel.composer.placeholder": [{"type":0,"value":"Mensagem em #"},{"type":1,"value":"channel"}],
    "channel.composer.placeholderDm": [{"type":0,"value":"Mensagem para "},{"type":1,"value":"name"}],
    "channel.newDivider": "Novas",
    "channel.newMessages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" nova mensagem"}]},"other":{"value":[{"type":7},{"type":0,"value":" novas mensagens"}]}},"offset":0,"pluralType":"cardinal"}],
    "channel.members": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" membro"}]},"other":{"value":[{"type":7},{"type":0,"value":" membros"}]}},"offset":0,"pluralType":"cardinal"}],
    "channel.empty.title": [{"type":0,"value":"Este é o início de #"},{"type":1,"value":"channel"}],
    "channel.empty.body": "Envie uma mensagem para começar a conversa.",
    "message.edited": "(editada)",
    "message.deleted": "Esta mensagem foi excluída.",
    "message.unsupportedContent": "Esta mensagem tem conteúdo que sua versão do app não consegue mostrar. Atualize o Bundle",
    "message.replies": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" resposta"}]},"other":{"value":[{"type":7},{"type":0,"value":" respostas"}]}},"offset":0,"pluralType":"cardinal"}],
    "message.addReaction": "Adicionar reação",
    "message.reply": "Responder na conversa",
    "message.more": "Mais ações",
    "reaction.added": [{"type":0,"value":"Você reagiu com "},{"type":1,"value":"emoji"}],
    "reaction.removed": [{"type":0,"value":"Reação "},{"type":1,"value":"emoji"},{"type":0,"value":" removida"}],
    "reaction.who.you": [{"type":0,"value":"Você reagiu com "},{"type":1,"value":"emoji"}],
    "reaction.who.youAndOne": [{"type":0,"value":"Você e "},{"type":1,"value":"name"},{"type":0,"value":" reagiram com "},{"type":1,"value":"emoji"}],
    "reaction.who.youAndMany": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Você, "},{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoa reagiram com "},{"type":1,"value":"emoji"}]},"other":{"value":[{"type":0,"value":"Você, "},{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoas reagiram com "},{"type":1,"value":"emoji"}]}},"offset":0,"pluralType":"cardinal"}],
    "reaction.who.one": [{"type":1,"value":"name"},{"type":0,"value":" reagiu com "},{"type":1,"value":"emoji"}],
    "reaction.who.two": [{"type":1,"value":"a"},{"type":0,"value":" e "},{"type":1,"value":"b"},{"type":0,"value":" reagiram com "},{"type":1,"value":"emoji"}],
    "reaction.who.many": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"a"},{"type":0,"value":", "},{"type":1,"value":"b"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoa reagiram com "},{"type":1,"value":"emoji"}]},"other":{"value":[{"type":1,"value":"a"},{"type":0,"value":", "},{"type":1,"value":"b"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoas reagiram com "},{"type":1,"value":"emoji"}]}},"offset":0,"pluralType":"cardinal"}],
    "reaction.who.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pessoa reagiu com "},{"type":1,"value":"emoji"}]},"other":{"value":[{"type":7},{"type":0,"value":" pessoas reagiram com "},{"type":1,"value":"emoji"}]}},"offset":0,"pluralType":"cardinal"}],
    "typing.one": [{"type":1,"value":"name"},{"type":0,"value":" está digitando…"}],
    "typing.two": [{"type":1,"value":"a"},{"type":0,"value":" e "},{"type":1,"value":"b"},{"type":0,"value":" estão digitando…"}],
    "typing.many": "Várias pessoas estão digitando…",
    "agent.state.idle": "Ocioso",
    "agent.state.working": "Trabalhando",
    "agent.state.waiting": "Aguardando resposta",
    "agent.state.error": "Precisa de atenção",
    "agent.state.offline": "Offline",
    "agent.status": [{"type":1,"value":"name"},{"type":0,"value":": "},{"type":1,"value":"state"}],
    "agent.badge": "Agente",
    "message.appBadge": "App",
    "time.today": "Hoje",
    "time.yesterday": "Ontem",
    "time.justNow": "agora mesmo",
    "auth.signIn": "Entrar",
    "auth.email": "E-mail",
    "auth.sendCode": "Enviar código",
    "nav.starred": "Favoritos",
    "nav.activity": "Atividade",
    "nav.unreads": "Todas as não lidas",
    "nav.search": "Buscar",
    "shell.newTabInSplit": "Abrir em divisão",
    "shell.openInNewTab": "Abrir em nova aba",
    "shell.closePane": "Fechar painel",
    "shell.pinTab": "Fixar aba",
    "shell.unpinTab": "Desafixar aba",
    "shell.omnibox.channels": "Canais",
    "shell.omnibox.people": "Pessoas",
    "shell.omnibox.agents": "Agentes",
    "shell.omnibox.commands": "Comandos",
    "shell.omnibox.noResults": "Nenhum resultado",
    "shell.omnibox.hint": "↵ abrir · ⌘↵ nova aba · ⇧↵ dividir",
    "shell.tabs.search": "Pesquisar abas",
    "shell.tabs.searchPlaceholder": "Pesquisar abas abertas",
    "shell.tabs.open": "Abas abertas",
    "shell.tabs.pinned": "Fixadas",
    "shell.tabs.ungrouped": "Abas",
    "shell.tab.duplicate": "Duplicar",
    "shell.tab.closeOthers": "Fechar outras abas",
    "shell.tab.closeRight": "Fechar abas à direita",
    "shell.tab.closeSelected": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Fechar "},{"type":7},{"type":0,"value":" aba"}]},"other":{"value":[{"type":0,"value":"Fechar "},{"type":7},{"type":0,"value":" abas"}]}},"offset":0,"pluralType":"cardinal"}],
    "shell.tab.moveToWindow": "Mover para nova janela",
    "shell.tab.copyLink": "Copiar link",
    "shell.tab.addToNewGroup": "Adicionar a novo grupo",
    "shell.tab.addToGroup": "Adicionar ao grupo",
    "shell.tab.removeFromGroup": "Remover do grupo",
    "shell.tab.reopenClosed": "Reabrir aba fechada",
    "shell.split.separate": "Separar abas",
    "shell.split.swap": "Inverter lados",
    "shell.split.close": "Fechar as duas abas",
    "shell.split.closeSide": [{"type":0,"value":"Fechar "},{"type":1,"value":"title"}],
    "shell.split.moveToNewTab": "Mover para nova aba",
    "shell.split.dropHint": "Solte para abrir em tela dividida",
    "shell.group.namePlaceholder": "Dê um nome a este grupo",
    "shell.group.unnamed": "Grupo sem nome",
    "shell.group.edit": "Editar grupo",
    "shell.group.collapse": "Recolher grupo",
    "shell.group.expand": "Expandir grupo",
    "shell.group.newTab": "Nova aba no grupo",
    "shell.group.ungroup": "Desagrupar",
    "shell.group.close": "Fechar grupo",
    "agent.statusLine.working": [{"type":1,"value":"name"},{"type":0,"value":": Trabalhando…"}],
    "agent.statusLine.activity": [{"type":1,"value":"name"},{"type":0,"value":": "},{"type":1,"value":"activity"},{"type":0,"value":"…"}],
    "agent.statusLine.waiting": [{"type":1,"value":"name"},{"type":0,"value":": Aguardando resposta"}],
    "agent.statusLine.error": [{"type":1,"value":"name"},{"type":0,"value":": Precisa de atenção"}],
    "agent.sponsor": [{"type":0,"value":"Responsável: "},{"type":1,"value":"name"}],
    "agent.runtime.hosted": "Hospedado",
    "agent.runtime.external": "Execução externa",
    "agent.message": "Mensagem",
    "agents.title": "Agentes",
    "agents.subtitle": "Agentes são membros do seu workspace. Eles trabalham nos canais em que foram adicionados.",
    "agents.empty": "Nenhum agente ainda.",
    "agent.create.title": "Criar um agente",
    "agent.create.name": "Nome",
    "agent.create.description": "O que este agente faz?",
    "agent.create.runtime": "Executa no Bundle (hospedado)",
    "agent.create.submit": "Criar agente",
    "agent.create.tokenNotice": "Copie este token agora — ele não será exibido novamente.",
    "guest.badge": "Externo",
    "guest.badgeOrg": [{"type":0,"value":"Externo · "},{"type":1,"value":"org"}],
    "channel.externalBanner": "Este canal inclui pessoas de outras organizações.",
    "channel.externalBannerOrgs": [{"type":0,"value":"Este canal inclui pessoas de "},{"type":1,"value":"orgs"},{"type":0,"value":"."}],
    "channel.huddle": "Iniciar reunião",
    "channel.settings": "Configurações do canal",
    "channel.loadingOlder": "Carregando mensagens anteriores…",
    "channel.newMessagesJump": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" nova mensagem"}]},"other":{"value":[{"type":7},{"type":0,"value":" novas mensagens"}]}},"offset":0,"pluralType":"cardinal"}],
    "composer.mention": "Mencionar alguém",
    "composer.attach": "Anexar um arquivo",
    "composer.emoji": "Emoji",
    "composer.format": "Formatação",
    "composer.format.bold": "Negrito",
    "composer.format.italic": "Itálico",
    "composer.format.strike": "Tachado",
    "composer.format.link": "Link",
    "composer.format.orderedList": "Lista numerada",
    "composer.format.bulletList": "Lista com marcadores",
    "composer.format.quote": "Citação",
    "composer.format.code": "Código",
    "composer.format.codeBlock": "Bloco de código",
    "composer.format.show": "Mostrar formatação",
    "composer.format.hide": "Ocultar formatação",
    "composer.send": "Enviar",
    "composer.placeholderThread": "Responder…",
    "composer.autocomplete.people": "Pessoas e agentes",
    "composer.autocomplete.channels": "Canais",
    "composer.autocomplete.emoji": "Emoji",
    "composer.autocomplete.commands": "Comandos",
    "composer.autocomplete.empty": [{"type":0,"value":"Nenhum resultado para “"},{"type":1,"value":"query"},{"type":0,"value":"”"}],
    "composer.autocomplete.none": "Nenhum resultado",
    "composer.broadcast.here": "Notificar quem está online neste canal",
    "composer.broadcast.channel": "Notificar todos neste canal",
    "composer.broadcast.everyone": "Notificar todos no workspace",
    "composer.command.remind.description": "Criar um lembrete",
    "composer.command.remind.usage": "[@alguém ou #canal] [o quê] [quando]",
    "composer.command.status.description": "Definir seu status",
    "composer.command.status.usage": "[:emoji:] [texto do status]",
    "composer.command.invite.description": "Convidar alguém para este canal",
    "composer.command.invite.usage": "[@alguém] [#canal]",
    "composer.command.mute.description": "Silenciar esta conversa",
    "composer.command.mute.usage": "[#canal]",
    "composer.command.task.description": "Criar uma tarefa",
    "composer.command.task.usage": "[título]",
    "composer.command.page.description": "Criar uma página",
    "composer.command.page.usage": "[título]",
    "composer.command.huddle.description": "Iniciar ou entrar em uma reunião",
    "message.sending": "Enviando…",
    "message.failed": "Não enviada.",
    "message.retry": "Tentar novamente",
    "message.discard": "Descartar",
    "message.viewThread": "Ver conversa",
    "message.lastReply": [{"type":0,"value":"Última resposta "},{"type":1,"value":"time"}],
    "message.repliedToThread": [{"type":0,"value":"respondeu a uma conversa: "},{"type":1,"value":"preview"}],
    "message.repliedToThreadNoPreview": "respondeu a uma conversa",
    "thread.title": "Conversa",
    "thread.in": [{"type":0,"value":"em #"},{"type":1,"value":"channel"}],
    "thread.inDm": [{"type":0,"value":"com "},{"type":1,"value":"name"}],
    "thread.alsoSendChannel": [{"type":0,"value":"Também enviar para #"},{"type":1,"value":"channel"}],
    "thread.alsoSendDm": "Também enviar como mensagem direta",
    "thread.alsoSentChannel": [{"type":0,"value":"Também enviada para #"},{"type":1,"value":"channel"}],
    "thread.alsoSentDm": "Também enviada como mensagem direta",
    "home.greeting": [{"type":0,"value":"Boas-vindas a "},{"type":1,"value":"workspace"}],
    "home.subtitle": "Continue de onde parou.",
    "home.channels": "Canais",
    "home.directMessages": "Mensagens diretas",
    "home.agents": "Agentes trabalhando",
    "home.unread": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" menção não lida"}]},"other":{"value":[{"type":7},{"type":0,"value":" menções não lidas"}]}},"offset":0,"pluralType":"cardinal"}],
    "home.allCaughtUp": "Você está em dia.",
    "home.greetingMorning": [{"type":0,"value":"Bom dia, "},{"type":1,"value":"name"}],
    "home.greetingAfternoon": [{"type":0,"value":"Boa tarde, "},{"type":1,"value":"name"}],
    "home.greetingEvening": [{"type":0,"value":"Boa noite, "},{"type":1,"value":"name"}],
    "home.unreads": "Não lidas",
    "home.today": "Hoje",
    "home.tomorrow": "Amanhã",
    "home.noMoreEvents": "Nenhum outro evento hoje",
    "home.now": "Agora",
    "home.join": "Entrar",
    "home.openCalendar": "Abrir Agenda",
    "home.email": "E-mail",
    "home.openMail": "Abrir E-mail",
    "home.needsReply": "Aguardando resposta",
    "home.moreFaces": [{"type":0,"value":"+"},{"type":1,"value":"count"}],
    "home.briefing.needsYou": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" coisa precisa de você"}]},"other":{"value":[{"type":7},{"type":0,"value":" coisas precisam de você"}]}},"offset":0,"pluralType":"cardinal"}],
    "home.briefing.live": [{"type":1,"value":"title"},{"type":0,"value":" ao vivo"}],
    "home.briefing.startsIn": [{"type":1,"value":"title"},{"type":0,"value":" em "},{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "home.briefing.nextAt": [{"type":0,"value":"Depois: "},{"type":1,"value":"title"},{"type":0,"value":" às "},{"type":1,"value":"time"}],
    "home.briefing.chat": "Chat",
    "home.briefing.work": "Tarefas e aprovações",
    "home.briefing.reply": "Responder",
    "home.briefing.respond": "Responder",
    "home.briefing.review": "Revisar",
    "home.briefing.noMeetings": "Nenhuma outra reunião hoje",
    "home.briefing.caughtUpTitle": "Você está em dia",
    "home.briefing.caughtUpBody": "Menções, respostas, convites e aprovações aparecem aqui.",
    "home.briefing.nothingNeedsYou": "Nada precisa de você agora.",
    "home.briefing.invitedBy": [{"type":1,"value":"name"},{"type":0,"value":" convidou você"}],
    "home.briefing.waitingApproval": "Aguardando sua aprovação",
    "home.briefing.more": [{"type":0,"value":"mais "},{"type":1,"value":"count"}],
    "search.title": "Buscar",
    "search.placeholder": "Buscar mensagens",
    "search.comingSoon": "A busca completa chega no M2. Use ⌘K para ir a canais e pessoas.",
    "search.hint": "Refine com from:@nome, in:#canal, with:@nome, has:link, has:file, has:pin, has:reaction, before:2026-10-01, after:2026-10-01, on:2026-10-01, during:2026-10 ou is:thread.",
    "search.empty": [{"type":0,"value":"Nenhuma mensagem corresponde a “"},{"type":1,"value":"query"},{"type":0,"value":"”."}],
    "search.error": "A busca não funcionou. Verifique sua conexão e tente novamente.",
    "search.unresolved": [{"type":0,"value":"Ignorado: "},{"type":1,"value":"filters"}],
    "search.inThread": "em uma conversa",
    "search.resultCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" resultado"}]},"other":{"value":[{"type":7},{"type":0,"value":" resultados"}]}},"offset":0,"pluralType":"cardinal"}],
    "search.suggest.filters": "Refine sua busca",
    "search.suggest.people": "Pessoas",
    "search.suggest.conversations": "Canais e conversas",
    "search.suggest.values": "Sugestões",
    "search.suggest.exclude": "Deixar de fora",
    "search.filter.from": "Mensagens de uma pessoa",
    "search.filter.in": "Em um canal ou conversa",
    "search.filter.with": "Em DMs e threads com uma pessoa",
    "search.filter.has": "Tem link, arquivo, fixação ou reação",
    "search.filter.is": "Em threads ou salvas para depois",
    "search.filter.before": "Antes de uma data",
    "search.filter.after": "Depois de uma data",
    "search.filter.on": "Em um dia",
    "search.filter.during": "Durante um dia, mês ou ano",
    "search.filter.notFrom": "Sem mensagens de uma pessoa",
    "search.filter.notIn": "Fora de um canal ou conversa",
    "search.filter.notWith": "Sem DMs e threads com uma pessoa",
    "search.filter.notHas": "Sem links, arquivos, fixações ou reações",
    "search.value.link": "Contém um link",
    "search.value.file": "Tem um arquivo",
    "search.value.pin": "Fixada",
    "search.value.reaction": "Tem reações",
    "search.value.thread": "Em uma thread",
    "search.value.today": "Hoje",
    "search.value.yesterday": "Ontem",
    "search.value.thisMonth": "Este mês",
    "search.value.lastMonth": "Mês passado",
    "search.value.thisYear": "Este ano",
    "search.value.lastYear": "Ano passado",
    "search.value.saved": "Salvas para depois",
    "search.value.pickDate": "Escolher uma data…",
    "search.value.pickMonth": "Escolher um mês…",
    "search.date.title": "Buscar por data",
    "search.date.on": "Em",
    "search.date.before": "Antes de",
    "search.date.after": "Depois de",
    "search.date.during": "Durante",
    "search.date.wholeMonth": "O mês inteiro",
    "search.date.apply": "Aplicar",
    "message.copyLink": "Copiar link",
    "message.linkCopied": "Link copiado",
    "message.code.copy": "Copiar código",
    "message.code.copied": "Copiado",
    "message.pin": "Fixar nesta conversa",
    "message.unpin": "Desafixar desta conversa",
    "message.pinnedBy": [{"type":0,"value":"Fixada por "},{"type":1,"value":"name"}],
    "message.markUnread": "Marcar como não lida",
    "message.share": "Compartilhar mensagem",
    "message.shared.dm": "uma mensagem direta",
    "message.shared.someone": "Alguém",
    "message.shared.postedIn": [{"type":0,"value":"Publicada em "},{"type":1,"value":"where"},{"type":0,"value":" · "},{"type":1,"value":"when"}],
    "message.shared.view": "Ver mensagem",
    "share.title": "Compartilhar esta mensagem",
    "share.to": "Para",
    "share.search": "Busque um canal ou uma pessoa",
    "share.comment": "Adicione uma mensagem, se quiser",
    "share.send": "Compartilhar",
    "share.failed": "Não foi possível compartilhar a mensagem.",
    "share.empty": "Nenhuma conversa encontrada.",
    "share.done": "Mensagem compartilhada",
    "beta.banner.title": "O Bundle está em beta.",
    "beta.banner.message": "Conte o que está quebrado ou faltando; o time lê cada nota.",
    "beta.banner.messageShort": "Conte o que está quebrado ou faltando.",
    "beta.banner.whatsNew": "Novidades",
    "beta.banner.feedback": "Enviar feedback",
    "beta.banner.dismiss": "Dispensar",
    "beta.label": "Beta",
    "beta.label.open": "O Bundle está em beta. Abrir Ajuda",
    "bookmarks.add": "Adicionar um favorito",
    "bookmarks.edit": "Editar favorito",
    "bookmarks.remove": "Remover favorito",
    "bookmarks.link": "Link",
    "bookmarks.name": "Nome",
    "bookmarks.namePlaceholder": "Opcional — senão usamos o nome do site",
    "bookmarks.save": "Salvar",
    "bookmarks.badUrl": "Digite um link da web (https://…).",
    "bookmarks.failed": "Não foi possível salvar o favorito.",
    "bookmarks.bar": "Favoritos",
    "bookmarks.more": "Opções do favorito",
    "bookmarks.addLink": "Adicionar um link",
    "bookmarks.addFolder": "Criar uma pasta",
    "bookmarks.editFolder": "Renomear",
    "bookmarks.addFile": "Adicionar um arquivo",
    "bookmarks.addPage": "Adicionar uma página",
    "bookmarks.folderName": "Nome da pasta",
    "bookmarks.nameNeeded": "Digite um nome.",
    "bookmarks.searchFiles": "Buscar arquivos nesta conversa",
    "bookmarks.searchPages": "Buscar páginas",
    "bookmarks.noFiles": "Nenhum arquivo compartilhado aqui ainda.",
    "bookmarks.noPages": "Nenhuma página encontrada.",
    "bookmarks.pickFailed": "Não foi possível carregar a lista.",
    "bookmarks.moveTo": [{"type":0,"value":"Mover para "},{"type":1,"value":"folder"}],
    "bookmarks.moveOut": "Tirar da pasta",
    "bookmarks.emptyFolder": "Esta pasta está vazia.",
    "bookmarks.removeFolder": "Excluir pasta",
    "bookmarks.addToFolder": "Adicionar um link a esta pasta",
    "bookmarks.moveLeft": "Mover para a esquerda",
    "bookmarks.moveRight": "Mover para a direita",
    "bookmarks.reorder": "Reordenar favoritos",
    "channel.pins.open": "Mensagens fixadas",
    "channel.pins.title": "Mensagens fixadas",
    "channel.pins.empty": "Nada fixado ainda. Fixe mensagens importantes pelo menu delas para que todos aqui as encontrem.",
    "channel.pins.error": "Não foi possível carregar as mensagens fixadas.",
    "channel.pins.jump": "Abrir na conversa",
    "activity.title": "Atividade",
    "activity.empty": "Menções, respostas em conversas e reações às suas mensagens aparecem aqui.",
    "activity.memberJoined": [{"type":1,"value":"name"},{"type":0,"value":" entrou via "},{"type":1,"value":"domain"}],
    "activity.memberJoined.someone": [{"type":0,"value":"Alguém entrou via "},{"type":1,"value":"domain"}],
    "activity.adminEmpty": "Menções, respostas em conversas e reações aparecem aqui, além de quem entrar pelos seus domínios de e-mail permitidos.",
    "activity.failed": "Não foi possível carregar sua atividade. Verifique sua conexão e tente novamente.",
    "activity.retry": "Tentar novamente",
    "activity.mention": [{"type":1,"value":"name"},{"type":0,"value":" mencionou você em #"},{"type":1,"value":"channel"}],
    "activity.mention.someone": [{"type":0,"value":"Alguém mencionou você em #"},{"type":1,"value":"channel"}],
    "activity.broadcast": [{"type":1,"value":"name"},{"type":0,"value":" mencionou @"},{"type":1,"value":"range"},{"type":0,"value":" em #"},{"type":1,"value":"channel"}],
    "activity.broadcast.someone": [{"type":0,"value":"Alguém mencionou @"},{"type":1,"value":"range"},{"type":0,"value":" em #"},{"type":1,"value":"channel"}],
    "activity.threadReply": [{"type":1,"value":"name"},{"type":0,"value":" respondeu a uma conversa em #"},{"type":1,"value":"channel"}],
    "activity.threadReply.dm": [{"type":1,"value":"name"},{"type":0,"value":" respondeu a uma conversa"}],
    "activity.threadReply.others": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoa responderam a uma conversa em #"},{"type":1,"value":"channel"}]},"other":{"value":[{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoas responderam a uma conversa em #"},{"type":1,"value":"channel"}]}},"offset":0,"pluralType":"cardinal"}],
    "activity.threadReply.others.dm": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoa responderam a uma conversa"}]},"other":{"value":[{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoas responderam a uma conversa"}]}},"offset":0,"pluralType":"cardinal"}],
    "activity.reaction": [{"type":1,"value":"name"},{"type":0,"value":" reagiu com "},{"type":1,"value":"emoji"},{"type":0,"value":" à sua mensagem"}],
    "activity.reaction.others": [{"type":6,"value":"count","options":{"one":{"value":[{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoa reagiram com "},{"type":1,"value":"emoji"},{"type":0,"value":" à sua mensagem"}]},"other":{"value":[{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":7},{"type":0,"value":" pessoas reagiram com "},{"type":1,"value":"emoji"},{"type":0,"value":" à sua mensagem"}]}},"offset":0,"pluralType":"cardinal"}],
    "activity.channelAdded": [{"type":1,"value":"name"},{"type":0,"value":" adicionou você a #"},{"type":1,"value":"channel"}],
    "activity.channelAdded.someone": [{"type":0,"value":"Você foi adicionado a #"},{"type":1,"value":"channel"}],
    "activity.filter.all": "Tudo",
    "activity.filter.mentions": "Menções",
    "activity.filter.threads": "Conversas",
    "activity.filter.reactions": "Reações",
    "activity.filters": "Filtrar atividade",
    "activity.markAllRead": "Marcar tudo como lido",
    "activity.unread": "Não lido",
    "activity.filteredEmpty": "Nada aqui ainda.",
    "activity.reminder": "Lembrete",
    "activity.eventReminder": "Próximo evento",
    "activity.eventInvited": [{"type":1,"value":"name"},{"type":0,"value":" convidou você"}],
    "activity.eventInvited.someone": "Novo convite",
    "activity.eventChanged": [{"type":1,"value":"name"},{"type":0,"value":" mudou o horário"}],
    "activity.eventChanged.someone": "O horário mudou",
    "activity.eventCancelled": [{"type":1,"value":"name"},{"type":0,"value":" cancelou este evento"}],
    "activity.eventCancelled.someone": "Este evento foi cancelado",
    "nav.later": "Mais tarde",
    "later.title": "Mais tarde",
    "later.tabs": "Abas de Mais tarde",
    "later.tab.inProgress": "Em andamento",
    "later.tab.archived": "Arquivados",
    "later.tab.completed": "Concluídos",
    "later.empty.inProgress": "Salve mensagens e crie lembretes para acompanhar o que você precisa fazer. Eles aparecem aqui.",
    "later.empty.archived": "Os itens arquivados aparecem aqui.",
    "later.empty.completed": "Os itens que você concluir aparecem aqui.",
    "later.complete": "Marcar como concluído",
    "later.moveToInProgress": "Mover para Em andamento",
    "later.archive": "Arquivar",
    "later.remove": "Remover de Mais tarde",
    "later.more": "Mais ações",
    "later.remind": "Lembrar-me",
    "later.reminder.clear": "Remover lembrete",
    "later.due": [{"type":0,"value":"Para "},{"type":1,"value":"time"}],
    "later.overdue": [{"type":0,"value":"Atrasado · "},{"type":1,"value":"time"}],
    "later.textReminder": "Lembrete",
    "later.repeats": "Repete",
    "later.stopRepeat": "Parar de repetir",
    "later.fromPerson": [{"type":0,"value":"Lembrete de "},{"type":1,"value":"name"}],
    "later.forConversation": [{"type":0,"value":"Lembrete para "},{"type":1,"value":"conversation"}],
    "later.messageGone": "Esta mensagem não está mais disponível.",
    "later.failed": "Não foi possível carregar seus itens salvos.",
    "later.retry": "Tentar novamente",
    "later.saved": "Salvo para mais tarde",
    "later.removed": "Removido de Mais tarde",
    "later.completed": "Marcado como concluído",
    "message.saveForLater": "Salvar para mais tarde",
    "message.removeFromLater": "Remover de Mais tarde",
    "message.remindMe": "Lembrar-me disto",
    "remind.title": "Lembrar-me disto",
    "remind.preset.in20m": "Em 20 minutos",
    "remind.preset.in1h": "Em 1 hora",
    "remind.preset.in3h": "Em 3 horas",
    "remind.preset.tomorrow": "Amanhã",
    "remind.preset.nextWeek": "Semana que vem",
    "remind.custom": "Personalizado…",
    "remind.date": "Data",
    "remind.time": "Hora",
    "remind.set": "Criar lembrete",
    "remind.done": [{"type":0,"value":"Lembrete para "},{"type":1,"value":"when"}],
    "remind.failed": "Não foi possível criar o lembrete",
    "composer.remind.done": [{"type":0,"value":"Certo! Vou lembrar você de “"},{"type":1,"value":"text"},{"type":0,"value":"” em "},{"type":1,"value":"when"},{"type":0,"value":"."}],
    "composer.remind.doneFor": [{"type":0,"value":"Certo! Vou lembrar "},{"type":1,"value":"who"},{"type":0,"value":" de “"},{"type":1,"value":"text"},{"type":0,"value":"” em "},{"type":1,"value":"when"},{"type":0,"value":"."}],
    "composer.remind.doneRepeat": [{"type":0,"value":"Certo! Vou lembrar "},{"type":1,"value":"who"},{"type":0,"value":" de “"},{"type":1,"value":"text"},{"type":0,"value":"” periodicamente, a partir de "},{"type":1,"value":"when"},{"type":0,"value":"."}],
    "composer.remind.you": "você",
    "composer.remind.usage": "Tente /remind me [o quê] [quando] — por exemplo /remind me alongar em 20 minutos",
    "composer.remind.target": "Escolha a pessoa ou o canal na lista do @ ou do #, ou use /remind me.",
    "composer.remind.past": "Esse horário já passou.",
    "composer.remind.failed": "Não foi possível criar o lembrete.",
    "nav.scheduled": "Agendadas",
    "schedule.title": "Agendar mensagem",
    "schedule.menu": "Agendar para depois",
    "schedule.tomorrow": [{"type":0,"value":"Amanhã às "},{"type":1,"value":"time"}],
    "schedule.monday": [{"type":0,"value":"Segunda-feira às "},{"type":1,"value":"time"}],
    "schedule.custom": "Horário personalizado",
    "schedule.set": "Agendar mensagem",
    "schedule.done": [{"type":0,"value":"Agendada para "},{"type":1,"value":"when"}],
    "schedule.past": "Escolha um horário no futuro.",
    "schedule.tooFar": "Você pode agendar mensagens para até 120 dias.",
    "schedule.failed": "Não foi possível agendar a mensagem.",
    "scheduled.bar": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" mensagem agendada"}]},"other":{"value":[{"type":7},{"type":0,"value":" mensagens agendadas"}]}},"offset":0,"pluralType":"cardinal"}],
    "scheduled.seeAll": "Ver todas",
    "scheduled.title": "Agendadas",
    "scheduled.empty": "As mensagens que você agendar aparecem aqui até serem enviadas.",
    "nav.drafts": "Rascunhos e enviadas",
    "drafts.title": "Rascunhos e enviadas",
    "drafts.tab.drafts": "Rascunhos",
    "drafts.tab.scheduled": "Agendadas",
    "drafts.tab.sent": "Enviadas",
    "drafts.empty": "Os rascunhos aparecem aqui quando você começa uma mensagem e não a envia. Eles acompanham você em todos os seus dispositivos.",
    "drafts.sentEmpty": "As mensagens que você envia em canais e mensagens diretas aparecem aqui, para você encontrá-las de novo.",
    "drafts.failed": "Não foi possível carregar seus rascunhos.",
    "drafts.sentFailed": "Não foi possível carregar suas mensagens enviadas.",
    "drafts.delete": "Excluir rascunho",
    "drafts.inThread": [{"type":0,"value":"Conversa em "},{"type":1,"value":"conversation"}],
    "drafts.empty.title": "Nenhum rascunho no momento",
    "drafts.sentEmpty.title": "Nada enviado ainda",
    "drafts.scheduledEmpty.title": "Nenhuma mensagem agendada",
    "drafts.scheduledEmpty.body": "Agende uma mensagem pela seta ao lado de Enviar em qualquer conversa, e ela espera aqui até ser enviada.",
    "drafts.edit": "Editar rascunho",
    "drafts.open": "Abrir na conversa",
    "drafts.deleteConfirm.title": "Excluir rascunho?",
    "drafts.deleteConfirm.body": "Este rascunho será excluído em todos os seus dispositivos. Não é possível desfazer.",
    "scheduled.sendsAt": [{"type":0,"value":"Envio "},{"type":1,"value":"when"}],
    "scheduled.notSent": "Não enviada — você não pode mais postar lá. Edite, reagende ou cancele.",
    "scheduled.inThread": "Resposta em uma conversa",
    "scheduled.edit": "Editar mensagem",
    "scheduled.reschedule": "Reagendar",
    "scheduled.sendNow": "Enviar agora",
    "scheduled.cancel": "Cancelar mensagem",
    "scheduled.save": "Salvar",
    "scheduled.failed": "Não foi possível carregar suas mensagens agendadas.",
    "scheduled.more": "Mais ações",
    "scheduled.files": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" arquivo"}]},"other":{"value":[{"type":7},{"type":0,"value":" arquivos"}]}},"offset":0,"pluralType":"cardinal"}],
    "shortcuts.title": "Atalhos de teclado",
    "shortcuts.omnibox": "Ir para uma conversa ou página",
    "shortcuts.prev": "Conversa anterior",
    "shortcuts.next": "Próxima conversa",
    "shortcuts.prevUnread": "Conversa não lida anterior",
    "shortcuts.nextUnread": "Próxima conversa não lida",
    "shortcuts.markRead": "Marcar a conversa atual como lida",
    "shortcuts.allUnreads": "Abrir Todas as não lidas",
    "shortcuts.editLast": "Editar sua última mensagem (campo vazio)",
    "shortcuts.newTab": "Nova aba",
    "shortcuts.closeTab": "Fechar aba",
    "shortcuts.tabSearch": "Buscar abas abertas",
    "shortcuts.split": "Dividir a tela",
    "shortcuts.swapSplit": "Inverter lados da tela dividida",
    "shortcuts.back": "Voltar",
    "shortcuts.forward": "Avançar",
    "shortcuts.sidebar": "Mostrar ou ocultar a barra lateral",
    "shortcuts.views": "Ir para Chat, E-mail ou Documentos",
    "shortcuts.help": "Mostrar atalhos de teclado",
    "shortcuts.mail.title": "E-mail",
    "shortcuts.mail.compose": "Escrever",
    "shortcuts.mail.search": "Pesquisar e-mails",
    "shortcuts.mail.next": "Próxima conversa",
    "shortcuts.mail.prev": "Conversa anterior",
    "shortcuts.mail.open": "Abrir conversa",
    "shortcuts.mail.archive": "Arquivar",
    "shortcuts.mail.trash": "Excluir",
    "shortcuts.mail.spam": "Denunciar spam",
    "shortcuts.mail.star": "Adicionar / remover estrela",
    "shortcuts.mail.priority": "Marcar como prioridade",
    "shortcuts.mail.notPriority": "Marcar como não prioridade",
    "shortcuts.mail.select": "Selecionar conversa",
    "shortcuts.mail.markRead": "Marcar como lida",
    "shortcuts.mail.markUnread": "Marcar como não lida",
    "shortcuts.mail.reply": "Responder",
    "shortcuts.mail.replyAll": "Responder a todos",
    "shortcuts.mail.forward": "Encaminhar",
    "unreads.empty": "Você está em dia.",
    "unreads.markAllRead": "Marcar tudo como lido",
    "unreads.markRead": "Marcar como lida",
    "unreads.more": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"mais "},{"type":7},{"type":0,"value":" mensagem não lida"}]},"other":{"value":[{"type":0,"value":"mais "},{"type":7},{"type":0,"value":" mensagens não lidas"}]}},"offset":0,"pluralType":"cardinal"}],
    "unreads.new": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" mensagem nova"}]},"other":{"value":[{"type":7},{"type":0,"value":" mensagens novas"}]}},"offset":0,"pluralType":"cardinal"}],
    "unreads.mentions": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" menção"}]},"other":{"value":[{"type":7},{"type":0,"value":" menções"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.title": "Meet",
    "huddle.comingSoon": "O Meet chega no M7.",
    "huddle.join": "Entrar",
    "huddle.joinHuddle": "Entrar na reunião",
    "huddle.inHuddle": "Na reunião",
    "huddle.start": "Iniciar reunião",
    "huddle.leave": "Sair",
    "huddle.mute": "Silenciar",
    "huddle.unmute": "Ativar microfone",
    "huddle.videoOn": "Ligar câmera",
    "huddle.videoOff": "Desligar câmera",
    "huddle.shareScreen": "Compartilhar tela",
    "huddle.stopSharing": "Parar de compartilhar",
    "huddle.raiseHand": "Levantar a mão",
    "huddle.lowerHand": "Abaixar a mão",
    "huddle.react": "Reagir",
    "huddle.effects": "Efeitos",
    "huddle.effects.emoji": "Efeitos de emoji",
    "huddle.effects.themes": "Temas",
    "huddle.theme.none": "Nenhum",
    "huddle.theme.sunrise": "Amanhecer",
    "huddle.theme.ocean": "Oceano",
    "huddle.theme.forest": "Floresta",
    "huddle.theme.galaxy": "Galáxia",
    "huddle.theme.party": "Festa",
    "huddle.settings": "Configurações do Meet",
    "huddle.openWindow": "Abrir reunião",
    "huddle.openInBrowser": "Abrir reunião no navegador",
    "huddle.browserOnly": "No Linux, por enquanto, o Meet precisa do navegador.",
    "huddle.status.joining": "Entrando…",
    "huddle.status.connecting": "Conectando…",
    "huddle.status.reconnecting": "Reconectando…",
    "huddle.status.leaving": "Saindo…",
    "huddle.participants": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.youName": [{"type":1,"value":"name"},{"type":0,"value":" (você)"}],
    "huddle.sharingScreen": [{"type":1,"value":"name"},{"type":0,"value":" está compartilhando a tela"}],
    "huddle.youAreSharing": "Você está compartilhando a tela",
    "huddle.handRaised": "Mão levantada",
    "huddle.muted": "Silenciado",
    "huddle.mediaUnavailable": "Áudio e vídeo não estão configurados neste servidor: você vê quem está aqui, mas nenhuma mídia é transmitida.",
    "huddle.waiting": "Esperando outras pessoas entrarem…",
    "huddle.invite.open": "Convidar pessoas",
    "huddle.invite.title": "Convidar pessoas para a reunião",
    "huddle.invite.search": "Buscar pessoas",
    "huddle.invite.ring": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Convidar "},{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":0,"value":"Convidar "},{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.invite.none": "Escolha quem convidar",
    "huddle.invite.empty": "Todos daqui já estão na reunião",
    "huddle.invite.loadFailed": "Não foi possível carregar as pessoas daqui",
    "huddle.invite.failed": "Não foi possível convidar. Tente de novo.",
    "huddle.invite.rang": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Chamando "},{"type":7},{"type":0,"value":" pessoa…"}]},"other":{"value":[{"type":0,"value":"Chamando "},{"type":7},{"type":0,"value":" pessoas…"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.declined": [{"type":1,"value":"name"},{"type":0,"value":" recusou"}],
    "huddle.recording.you": "Você está gravando esta reunião",
    "huddle.recording.other": [{"type":1,"value":"name"},{"type":0,"value":" está gravando esta reunião"}],
    "huddle.recording.start": "Gravar reunião",
    "huddle.recording.stop": "Parar gravação",
    "huddle.recording.indicator": "Gravando",
    "huddle.recording.consent": "Todos na reunião veem que ela está sendo gravada. Ao parar, a gravação é publicada no fio da reunião.",
    "huddle.recording.saving": "Salvando a gravação…",
    "huddle.recording.saved": "Gravação publicada no fio da reunião",
    "huddle.transcript.on": "Transcrição ativa",
    "huddle.transcript.about": "Transcrição ativa. Sobre a transcrição",
    "huddle.transcript.title": "Esta reunião é transcrita",
    "huddle.transcript.body": "A fala de todos vira texto enquanto estão com o microfone ligado. Quando você está no mudo, nada do que você diz é transcrito. A transcrição fica salva na página da reunião para todos que participaram.",
    "huddle.transcript.admin": "Proprietários e administradores do espaço de trabalho podem desativar isso em Configurações › Meet.",
    "huddle.transcript.muted": "Você está no mudo. Nada do que você diz é transcrito.",
    "huddle.transcript.notice": "Esta reunião é transcrita enquanto as pessoas estão com o microfone ligado. A transcrição fica salva para todos que participaram.",
    "huddle.recording.consentLink": "Todos na reunião veem que ela está sendo gravada. Ao parar, a gravação fica salva na página da reunião, para quem participou.",
    "huddle.recording.savedLink": "Gravação salva na página da reunião",
    "huddle.recording.failed": "Não foi possível salvar a gravação",
    "huddle.recording.unsupported": "Gravação indisponível aqui",
    "huddle.captions.on": "Ativar legendas",
    "huddle.captions.off": "Desativar legendas",
    "huddle.captions.label": "Legendas",
    "huddle.captions.unsupported": "Legendas não estão disponíveis neste navegador",
    "huddle.captions.listening": "Legendas ativadas. As falas aparecem enquanto as pessoas falam.",
    "huddle.captions.note.device": "Suas legendas são feitas neste dispositivo. Só o texto é compartilhado.",
    "huddle.captions.note.preparing": [{"type":0,"value":"Preparando legendas no dispositivo · "},{"type":1,"value":"percent"},{"type":0,"value":"%. Até lá, o servidor do Bundle faz as suas."}],
    "huddle.captions.note.notDownloaded": "As legendas no dispositivo baixam em segundo plano. Até lá, o servidor do Bundle faz as suas.",
    "huddle.captions.note.unsupported": "Este dispositivo não consegue fazer legendas sozinho, então o servidor do Bundle faz. O áudio não é guardado.",
    "huddle.captions.note.language": "As legendas no dispositivo ainda não aceitam esse idioma aqui, então o servidor do Bundle faz.",
    "huddle.captions.note.lowStorage": [{"type":0,"value":"Sem espaço livre para legendas no dispositivo ("},{"type":1,"value":"size"},{"type":0,"value":"). Por enquanto, o servidor do Bundle faz."}],
    "huddle.captions.note.failed": "As legendas no dispositivo pararam de funcionar, então o servidor do Bundle assumiu nesta reunião.",
    "huddle.captions.note.off": "Você desligou as legendas no dispositivo. O servidor do Bundle faz as suas.",
    "huddle.captions.note.none": "As legendas não estão disponíveis neste dispositivo.",
    "huddle.draw.start": "Desenhar na tela",
    "huddle.draw.stop": "Parar de desenhar",
    "huddle.draw.pen": "Caneta",
    "huddle.draw.eraser": "Borracha",
    "huddle.recap.title": "Meet",
    "huddle.recap.live": "Reunião em andamento",
    "huddle.recap.short": "Menos de um minuto",
    "huddle.recap.minutes": [{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "huddle.recap.hours": [{"type":1,"value":"hours"},{"type":0,"value":" h "},{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "huddle.recap.notes": "Notas da reunião",
    "huddle.recap.summary": "Resumo",
    "huddle.recap.actionItems": "Itens de ação",
    "huddle.recap.decisions": "Decisões",
    "huddle.recap.transcript": "Transcrição",
    "huddle.recap.showTranscript": "Mostrar transcrição",
    "huddle.recap.hideTranscript": "Ocultar transcrição",
    "huddle.recap.notesPending": "Escrevendo as notas da reunião…",
    "huddle.recap.aiNotice": "Escrito por IA a partir da transcrição. Confira os detalhes importantes.",
    "huddle.recap.noTranscript": "Sem transcrição: ninguém ativou as legendas.",
    "huddle.missed.title": "Reunião perdida",
    "huddle.missed.caller": [{"type":1,"value":"name"},{"type":0,"value":" ligou para você"}],
    "huddle.missed.callBack": "Ligar de volta",
    "huddle.incoming.label": "Convite para reunião",
    "huddle.incoming.join": "Entrar",
    "huddle.incoming.decline": "Recusar",
    "huddle.ring.micOn": "Microfone ligado",
    "huddle.ring.micOff": "Microfone desligado",
    "huddle.ring.cameraOn": "Câmera ligada",
    "huddle.ring.cameraOff": "Câmera desligada",
    "huddle.ring.declineWithMessage": "Recusar com uma mensagem…",
    "huddle.ring.close": "Fechar e parar de tocar",
    "huddle.ring.windowLabel": [{"type":0,"value":"Bundle · "},{"type":1,"value":"workspace"}],
    "huddle.ring.windowTitle": "Convite para reunião",
    "thread.follow.on": "Receber notificações de novas respostas",
    "thread.follow.off": "Desativar notificações de respostas",
    "thread.follow.following": "Seguindo",
    "thread.follow.notFollowing": "Sem seguir",
    "richtext.privateChannel": "canal privado",
    "huddle.idle.title": "Nenhuma reunião agora",
    "huddle.idle.body": "Inicie uma e todos da conversa podem participar.",
    "huddle.idle.linkBody": "Inicie aqui e compartilhe o link: as pessoas entram por ele.",
    "huddle.idle.active": [{"type":1,"value":"name"},{"type":0,"value":" e outras pessoas estão conversando. Quer entrar?"}],
    "huddle.summary.justYou": "Só você",
    "huddle.summary.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pessoa na reunião"}]},"other":{"value":[{"type":7},{"type":0,"value":" pessoas na reunião"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddle.summary.one": [{"type":1,"value":"name"}],
    "huddle.summary.two": [{"type":1,"value":"a"},{"type":0,"value":" e "},{"type":1,"value":"b"}],
    "huddle.summary.many": [{"type":1,"value":"a"},{"type":0,"value":" +"},{"type":1,"value":"count"}],
    "huddle.error.forbidden": "Você não pode entrar em reuniões neste espaço de trabalho.",
    "huddle.error.notFound": "Essa conversa não está disponível.",
    "huddle.error.network": "Não foi possível conectar à reunião. Verifique sua conexão e tente de novo.",
    "huddle.error.ended": "A reunião terminou.",
    "huddle.error.micDenied": "O Bundle não consegue usar seu microfone. Permita o acesso nas configurações do navegador ou do sistema.",
    "huddle.error.cameraDenied": "O Bundle não consegue usar sua câmera. Permita o acesso nas configurações do navegador ou do sistema.",
    "huddle.error.micDeniedApp": "O Bundle não consegue usar seu microfone. Permita o acesso nas configurações do aparelho.",
    "huddle.error.cameraDeniedApp": "O Bundle não consegue usar sua câmera. Permita o acesso nas configurações do aparelho.",
    "huddle.error.screenDenied": "O compartilhamento de tela foi bloqueado ou cancelado.",
    "huddle.error.media": "A conexão da reunião falhou.",
    "huddle.settings.audio": "Áudio",
    "huddle.settings.video": "Vídeo",
    "huddle.settings.microphone": "Microfone",
    "huddle.settings.speaker": "Alto-falante",
    "huddle.settings.camera": "Câmera",
    "huddle.settings.noDevices": "Nenhum encontrado",
    "huddle.settings.inputLevel": "Nível de entrada",
    "huddle.settings.testSpeaker": "Tocar som de teste",
    "huddle.settings.noiseSuppression": "Supressão de ruído",
    "huddle.settings.noise.off": "Desligada",
    "huddle.settings.noise.standard": "Padrão",
    "huddle.settings.noise.strong": "Forte",
    "huddle.settings.noise.hint": "A opção Forte usa um modelo de remoção de ruído para lugares barulhentos: teclados, ventiladores, trânsito.",
    "huddle.settings.echoCancellation": "Cancelamento de eco",
    "huddle.settings.autoGain": "Ajustar o volume do microfone automaticamente",
    "huddle.settings.background": "Fundo",
    "huddle.settings.uploadBackground": "Enviar imagem",
    "huddle.settings.mirror": "Espelhar meu vídeo",
    "huddle.settings.joining": "Ao entrar",
    "huddle.settings.joinMicOff": "Entrar com o microfone desligado",
    "huddle.settings.joinCameraOff": "Entrar com a câmera desligada",
    "huddle.settings.captions": "Legendas",
    "huddle.settings.captionsOnDevice": "Fazer as legendas neste dispositivo",
    "huddle.settings.captionsOnDevice.hint": "Sua fala vira texto aqui e só o texto é compartilhado. Quando este dispositivo não consegue, o servidor do Bundle faz suas legendas e não guarda o áudio.",
    "huddle.settings.speechModel": "Modelo de fala",
    "huddle.settings.speechModel.system": "Gerenciado pelo sistema · nada para baixar",
    "huddle.settings.speechModel.downloading": [{"type":0,"value":"Baixando · "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "huddle.settings.speechModel.web": [{"type":0,"value":"Desert Ant Voz · "},{"type":1,"value":"size"},{"type":0,"value":", baixado uma vez na primeira vez que você liga as legendas"}],
    "huddle.settings.speechModel.android": [{"type":0,"value":"Desert Ant Voz · "},{"type":1,"value":"size"},{"type":0,"value":", baixado pelo Wi-Fi na primeira vez que você liga as legendas"}],
    "huddle.settings.speechModel.ready": [{"type":0,"value":"Desert Ant Voz · "},{"type":1,"value":"size"},{"type":0,"value":" · baixado"}],
    "huddle.settings.captionsDeviceOnly": "Vale só para este dispositivo. Cada dispositivo seu decide por si.",
    "huddle.settings.cameraOff": "A prévia da câmera está desligada",
    "huddle.settings.previewCamera": "Ver prévia da câmera",
    "huddle.settings.effectsUnsupported": "Este navegador não consegue aplicar efeitos de fundo.",
    "huddle.background.none": "Nenhum",
    "huddle.background.blurLight": "Desfoque leve",
    "huddle.background.blurStrong": "Desfoque forte",
    "huddle.background.image.dusk": "Entardecer",
    "huddle.background.image.paper": "Papel",
    "huddle.background.image.studio": "Estúdio",
    "huddle.background.custom": "Minha imagem",
    "huddle.device.microphone": [{"type":0,"value":"Microfone "},{"type":1,"value":"n"}],
    "huddle.device.camera": [{"type":0,"value":"Câmera "},{"type":1,"value":"n"}],
    "huddle.device.speaker": [{"type":0,"value":"Alto-falante "},{"type":1,"value":"n"}],
    "huddle.lobby.one": [{"type":1,"value":"name"},{"type":0,"value":" quer entrar"}],
    "huddle.lobby.many": [{"type":1,"value":"name"},{"type":0,"value":" e mais "},{"type":1,"value":"count"},{"type":0,"value":" querem entrar"}],
    "huddle.lobby.admit": "Admitir",
    "huddle.lobby.deny": "Recusar",
    "huddle.lobby.admitAll": "Admitir todos",
    "huddle.external": "Externo",
    "huddle.moderate.mute": "Silenciar",
    "huddle.moderate.remove": "Remover da reunião",
    "huddle.moderate.end": "Encerrar para todos",
    "huddle.moderate.more": "Mais opções",
    "huddle.share.link": "Compartilhar link",
    "huddle.share.copy": "Copiar link",
    "huddle.share.copied": "Link copiado",
    "huddle.meeting.lock": "Trancar reunião",
    "huddle.meeting.unlock": "Destrancar reunião",
    "huddle.meeting.openToAll": "Qualquer pessoa com o link entra direto",
    "huddle.meeting.locked": "Trancada: ninguém novo pode entrar",
    "huddle.chat.title": "Chat da reunião",
    "huddle.chat.open": "Chat",
    "huddle.chat.placeholder": "Mensagem para todos na reunião",
    "huddle.chat.empty": "As mensagens aqui duram só enquanto a reunião durar.",
    "huddle.chat.send": "Enviar",
    "meeting.new.title": "Nova reunião externa",
    "meeting.new.name": "Título",
    "meeting.new.namePlaceholder": "Alinhamento com parceiro",
    "meeting.new.conversation": "Conversa",
    "meeting.new.noConversation": "Nenhuma (reunião avulsa)",
    "meeting.new.now": "Começar agora",
    "meeting.new.later": "Agendar para depois",
    "meeting.new.time": "Horário (HH:MM)",
    "meeting.new.create": "Criar link",
    "meeting.new.ready": "O link da reunião está pronto. Quem tiver o link pode pedir para entrar.",
    "meeting.new.start": "Começar reunião",
    "meeting.new.error": "Não foi possível criar o link. Tente de novo.",
    "meeting.page.hostedBy": [{"type":0,"value":"Organizada por "},{"type":1,"value":"name"}],
    "meeting.page.huddleWith": [{"type":0,"value":"Meet com "},{"type":1,"value":"name"}],
    "meeting.page.scheduled": [{"type":0,"value":"Agendada para "},{"type":1,"value":"time"}],
    "meeting.page.live": "Há pessoas na reunião",
    "meeting.page.yourName": "Seu nome",
    "meeting.page.namePlaceholder": "Como os outros vão ver você",
    "meeting.page.join": "Entrar na reunião",
    "meeting.page.askToJoin": "Pedir para entrar",
    "meeting.page.joiningAs": [{"type":0,"value":"Entrando como "},{"type":1,"value":"name"}],
    "meeting.page.waiting": "Esperando alguém deixar você entrar…",
    "meeting.page.denied": "Ninguém deixou você entrar. Você pode fechar esta página.",
    "meeting.page.removed": "Você foi removido da reunião.",
    "meeting.page.ended": "A reunião terminou.",
    "meeting.page.left": "Você saiu da reunião.",
    "meeting.page.rejoin": "Entrar de novo",
    "meeting.page.unavailable": "Este link de reunião não funciona mais.",
    "meeting.page.locked": "Esta reunião está trancada. Peça para quem organiza destrancar.",
    "meeting.page.challengeFailed": "Conclua a verificação e tente de novo.",
    "meeting.page.openInApp": "Abrir no app do Bundle",
    "meeting.page.noApp": "Não tem o app?",
    "meeting.page.downloadApp": "Baixar",
    "meeting.page.choice.app": "Entrar no app do Bundle",
    "meeting.page.choice.browser": "Continuar no navegador",
    "meeting.page.choice.store.appStore": "Grátis na App Store",
    "meeting.page.choice.store.testflight": "Beta no TestFlight",
    "meeting.page.choice.store.play": "Grátis no Google Play",
    "meeting.page.choice.store.apk": "Download direto (.apk)",
    "meeting.page.choice.getTitle": "Baixe o Bundle para entrar",
    "meeting.page.choice.getBody": "Instale o app e abra o link da reunião de novo. Ele abre direto nesta reunião.",
    "meeting.page.choice.get.appStore": "Baixar na App Store",
    "meeting.page.choice.get.testflight": "Baixar no TestFlight",
    "meeting.page.choice.get.play": "Baixar no Google Play",
    "meeting.page.choice.get.apk": "Baixar o app",
    "meeting.page.choice.haveIt": "Já tem o app?",
    "meeting.page.choice.openApp": "Abrir o Bundle",
    "meeting.page.privacy": "Ao entrar, você compartilha seu nome, câmera e microfone com as pessoas desta reunião, e nada mais.",
    "meeting.page.error": "Algo deu errado. Tente de novo.",
    "page.comingSoon": "Documentos e bancos de dados chegam no M5.",
    "auth.title": "Entrar no Bundle",
    "auth.subtitle": "Chat, documentos e agentes num só lugar.",
    "auth.name": "Nome (opcional)",
    "auth.continue": "Continuar",
    "auth.signingIn": "Entrando…",
    "auth.error": "Não foi possível entrar. A API está rodando?",
    "auth.mock": "Modo simulado — sem servidor.",
    "auth.signOut": "Sair",
    "profile.language": "Idioma",
    "profile.theme": "Tema",
    "profile.theme.system": "Sistema",
    "profile.theme.light": "Claro",
    "profile.theme.dark": "Escuro",
    "connection.reconnecting": "Conexão perdida — reconectando…",
    "offline.banner": "Você está offline — mostrando mensagens salvas",
    "offline.bannerNoCache": "Você está offline",
    "offline.bannerQueued": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Você está offline — "},{"type":7},{"type":0,"value":" mensagem será enviada ao reconectar"}]},"other":{"value":[{"type":0,"value":"Você está offline — "},{"type":7},{"type":0,"value":" mensagens serão enviadas ao reconectar"}]}},"offset":0,"pluralType":"cardinal"}],
    "offline.sending": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Enviando "},{"type":7},{"type":0,"value":" mensagem na fila…"}]},"other":{"value":[{"type":0,"value":"Enviando "},{"type":7},{"type":0,"value":" mensagens na fila…"}]}},"offset":0,"pluralType":"cardinal"}],
    "message.queued": "Aguardando envio",
    "invite.guest.title": "Convidar um convidado",
    "invite.guest.action": "Convidar convidado",
    "invite.guest.email": "E-mail",
    "invite.guest.name": "Nome (opcional)",
    "invite.guest.organization": "Organização",
    "invite.guest.channels": "Canais",
    "invite.guest.expiry": "O acesso expira",
    "invite.guest.expiry.never": "Nunca",
    "invite.guest.expiry.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Em "},{"type":7},{"type":0,"value":" dia"}]},"other":{"value":[{"type":0,"value":"Em "},{"type":7},{"type":0,"value":" dias"}]}},"offset":0,"pluralType":"cardinal"}],
    "invite.guest.submit": "Enviar convite",
    "invite.guest.sent": [{"type":0,"value":"Convite enviado para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "invite.guest.notice": "Convidados só veem os canais que você escolher.",
    "channel.create": "Criar canal",
    "channelMembers.search": "Buscar membros",
    "channelMembers.add": "Adicionar pessoas",
    "channelMembers.addSearch": "Buscar pessoas para adicionar",
    "channelMembers.addSubmit": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Adicionar "},{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":0,"value":"Adicionar "},{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "channelMembers.addNone": "Ninguém mais para adicionar",
    "channelMembers.remove": "Remover",
    "channelMembers.you": "(você)",
    "channelMembers.role.owner": "Proprietário",
    "channelMembers.role.admin": "Admin",
    "channelMembers.role.guest": "Convidado",
    "channelMembers.sponsor": [{"type":0,"value":"Responsável: "},{"type":1,"value":"name"}],
    "channelMembers.empty": "Nenhum membro encontrado",
    "channelMembers.everyone": "Todos do workspace estão neste canal.",
    "channelMembers.offline": "Você está offline. Os membros aparecem quando a conexão voltar.",
    "channelMembers.failed": "Não foi possível carregar os membros",
    "channelMembers.addFailed": "Não foi possível adicionar pessoas. Tente de novo.",
    "channelMembers.removeFailed": [{"type":0,"value":"Não foi possível remover "},{"type":1,"value":"name"}],
    "sidebar.folder.name": [{"type":1,"value":"name"}],
    "sidebar.folder.new": "Nova pasta",
    "sidebar.folder.createSubmit": "Criar",
    "sidebar.folder.edit": "Editar pasta",
    "sidebar.folder.nameLabel": "Nome da pasta",
    "sidebar.folder.namePlaceholder": "ex.: Lançamento",
    "sidebar.folder.nameRequired": "Dê um nome à pasta",
    "sidebar.folder.nameTooLong": [{"type":6,"value":"max","options":{"one":{"value":[{"type":0,"value":"Os nomes podem ter no máximo "},{"type":7},{"type":0,"value":" caractere"}]},"other":{"value":[{"type":0,"value":"Os nomes podem ter no máximo "},{"type":7},{"type":0,"value":" caracteres"}]}},"offset":0,"pluralType":"cardinal"}],
    "sidebar.folder.look": "Emoji ou ícone",
    "sidebar.folder.emojiSearch": "Buscar emoji",
    "sidebar.folder.useIcon": "Usar um ícone",
    "sidebar.folder.options": "Opções da pasta",
    "sidebar.folder.delete": "Excluir pasta",
    "sidebar.folder.moveUp": "Mover pasta para cima",
    "sidebar.folder.moveDown": "Mover pasta para baixo",
    "sidebar.folder.empty": "Arraste canais, DMs ou páginas para cá",
    "sidebar.row.move": "Mover para pasta…",
    "sidebar.move.title": [{"type":0,"value":"Mover "},{"type":1,"value":"name"},{"type":0,"value":" para…"}],
    "sidebar.move.newFolder": "Nova pasta…",
    "sidebar.move.toTree": "Voltar para a árvore de páginas",
    "channels.name.required": "Dê um nome ao canal",
    "channels.name.tooLong": [{"type":6,"value":"max","options":{"one":{"value":[{"type":0,"value":"Os nomes podem ter no máximo "},{"type":7},{"type":0,"value":" caractere"}]},"other":{"value":[{"type":0,"value":"Os nomes podem ter no máximo "},{"type":7},{"type":0,"value":" caracteres"}]}},"offset":0,"pluralType":"cardinal"}],
    "channels.name.taken": [{"type":0,"value":"#"},{"type":1,"value":"name"},{"type":0,"value":" já está em uso"}],
    "channels.name.willBe": [{"type":0,"value":"Nomes ficam em minúsculas com hifens: #"},{"type":1,"value":"name"}],
    "channels.create.title": "Criar um canal",
    "channels.create.name": "Nome",
    "channels.create.namePlaceholder": "ex.: plano-orcamento",
    "channels.create.description": "Descrição",
    "channels.create.descriptionPlaceholder": "Sobre o que é este canal?",
    "channels.create.private": "Tornar privado",
    "channels.create.privateHint": "Só quem for adicionado pode ver e entrar.",
    "channels.create.publicHint": "Qualquer pessoa do workspace pode encontrar e entrar.",
    "channels.create.members": "Adicionar pessoas",
    "channels.create.removeMember": [{"type":0,"value":"Remover "},{"type":1,"value":"name"}],
    "channels.create.membersSearch": "Buscar pessoas",
    "channels.create.membersNone": "Ninguém para adicionar",
    "channels.create.submit": "Criar",
    "channels.create.forbidden": "Você não pode criar canais neste workspace",
    "channels.browse.title": "Explorar canais",
    "channels.browse.search": "Buscar canais",
    "channels.browse.filter.all": "Todos os canais",
    "channels.browse.filter.joined": "Participando",
    "channels.browse.filter.other": "Não participando",
    "channels.browse.filter.archived": "Arquivados",
    "channels.browse.empty": "Nenhum canal encontrado",
    "channels.browse.joined": "Participando",
    "channels.browse.join": "Entrar",
    "channels.browse.leave": "Sair",
    "channels.join.prompt": [{"type":0,"value":"Você está vendo #"},{"type":1,"value":"channel"}],
    "channels.join.button": "Entrar no canal",
    "channels.join.failed": "Não foi possível entrar no canal. Tente de novo.",
    "channels.join.offline": "Você está offline. Entre quando a conexão voltar.",
    "channels.leave.failed": "Não foi possível sair do canal",
    "channels.archived.banner": "Este canal está arquivado e é somente leitura.",
    "channels.settings.topic": "Tópico",
    "channels.settings.topicPlaceholder": "Adicione um tópico",
    "channels.settings.notifications": "Notificações",
    "channels.settings.mute": "Silenciar canal",
    "channels.settings.notify.default": "Padrão",
    "channels.settings.notify.all": "Todas as mensagens",
    "channels.settings.notify.mentions": "Só menções",
    "channels.settings.notify.none": "Nada",
    "channels.settings.notify.set.default": "Seguindo suas configurações de notificação",
    "channels.settings.notify.set.all": "Você será notificado sobre todas as mensagens",
    "channels.settings.notify.set.mentions": "Você será notificado só sobre menções",
    "channels.settings.notify.set.none": "Você não será notificado sobre esta conversa",
    "channels.settings.muted": "Conversa silenciada",
    "channels.settings.unmuted": "Som da conversa reativado",
    "channels.settings.makePrivate": "Tornar canal privado",
    "channels.settings.makePublic": "Tornar canal público",
    "channels.settings.makePrivateHint": "Só os membros atuais poderão vê-lo.",
    "channels.settings.makePublicHint": "Qualquer pessoa do workspace poderá encontrá-lo e entrar.",
    "channels.settings.archive": "Arquivar canal",
    "channels.settings.unarchive": "Desarquivar canal",
    "channels.settings.archiveHint": "Canais arquivados são somente leitura e saem da barra lateral de todos. Continuam pesquisáveis.",
    "channels.settings.leave": "Sair do canal",
    "channels.details.about": "Sobre",
    "channels.details.members": "Membros",
    "channels.details.settings": "Configurações",
    "channels.settings.created": "Criado por",
    "channels.settings.createdBy": [{"type":1,"value":"name"},{"type":0,"value":" em "},{"type":1,"value":"date"}],
    "channels.settings.saved": "Salvo",
    "channels.settings.failed": "Não foi possível salvar a alteração",
    "sidebar.channels.add": "Adicionar canais",
    "sidebar.row.star": "Favoritar",
    "sidebar.row.unstar": "Remover dos favoritos",
    "sidebar.row.mute": "Silenciar",
    "sidebar.row.unmute": "Reativar som",
    "sidebar.row.leave": "Sair do canal",
    "common.error": "Algo deu errado. Tente novamente.",
    "language.en": "English",
    "language.ptBR": "Português (Brasil)",
    "desktopAuth.title": "Entrar no Bundle para desktop",
    "desktopAuth.signedInAs": [{"type":0,"value":"Conectado como "},{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":")"}],
    "desktopAuth.device": [{"type":0,"value":"Dispositivo: "},{"type":1,"value":"device"}],
    "desktopAuth.open": "Abrir o Bundle para desktop",
    "desktopAuth.switchAccount": "Usar outra conta",
    "desktopAuth.redirected": "Você pode fechar esta aba",
    "desktopAuth.redirectedBody": "O Bundle para desktop está concluindo seu login.",
    "desktopAuth.copyCode": "O app não abriu? Copiar código",
    "desktopAuth.copied": "Código copiado — cole-o no app para desktop.",
    "desktopAuth.invalid": "Este link de login é inválido ou expirou",
    "desktopAuth.invalidBody": "Comece novamente pelo app Bundle para desktop.",
    "desktopAuth.offline": "Você está offline. Conecte-se à internet e tente novamente.",
    "desktopAuth.failed": "Não foi possível gerar um código de login. Tente novamente.",
    "auth.google": "Continuar com o Google",
    "auth.apple": "Continuar com a Apple",
    "auth.error.apple": "O login com a Apple não terminou. Tente de novo.",
    "auth.or": "ou",
    "auth.emailPlaceholder": "nome@empresa.com",
    "auth.emailCode.send": "Enviar código por e-mail",
    "auth.code.title": "Confira seu e-mail",
    "auth.code.sentTo": [{"type":0,"value":"Enviamos um código de 6 dígitos para "},{"type":1,"value":"email"},{"type":0,"value":". Ele expira em 10 minutos."}],
    "auth.code.label": "Código de acesso",
    "auth.code.submit": "Entrar",
    "auth.code.resend": "Enviar outro código",
    "auth.code.changeEmail": "Usar outro e-mail",
    "auth.dev.title": "Acesso de desenvolvimento",
    "auth.dev.hint": "Desenvolvimento local: qualquer e-mail entra no workspace de demonstração.",
    "auth.error.network": "Não foi possível falar com o Bundle. Verifique sua conexão e tente de novo.",
    "auth.error.invalid": "Não foi possível entrar. Tente de novo.",
    "auth.error.invalidEmail": "Digite um endereço de e-mail válido.",
    "auth.error.invalidCode": "Esse código está incorreto ou expirou.",
    "auth.error.rateLimited": "Muitas tentativas. Aguarde um minuto e tente de novo.",
    "auth.error.unavailable": "O acesso por e-mail não está disponível agora.",
    "auth.error.google": "O acesso com o Google não foi concluído. Tente de novo.",
    "auth.methods.failed": "Não foi possível falar com o Bundle agora.",
    "auth.browser.body": "Você entra pelo navegador e depois volta para cá.",
    "auth.browser.start": "Entrar pelo navegador",
    "auth.browser.waiting": "Conclua o acesso no seu navegador…",
    "auth.browser.waitingBody": "Abrimos o Bundle no seu navegador. Entre por lá e você volta para o app.",
    "auth.browser.retry": "Tentar de novo",
    "auth.browser.paste": "Colar um código",
    "auth.browser.pasteLabel": "Código de acesso",
    "auth.browser.pastePlaceholder": "Cole o código que o navegador mostra",
    "auth.error.cancelled": "O acesso foi cancelado no navegador.",
    "auth.error.signInExpired": "Este acesso expirou. Comece de novo.",
    "auth.error.codeRejected": "Esse código expirou ou já foi usado. Comece de novo.",
    "auth.error.browser": "Não foi possível abrir o navegador. Tente de novo.",
    "auth.signedInAs": [{"type":0,"value":"Conectado como "},{"type":1,"value":"email"}],
    "auth.switchAccount": "Usar outra conta",
    "workspace.loading": "Carregando seus workspaces…",
    "workspace.loadingStuck.title": "O Bundle está com problemas para carregar",
    "workspace.loadingStuck.body": "Verifique sua conexão e tente novamente. Sair e entrar de novo também pode ajudar.",
    "workspace.create.title": "Criar um workspace",
    "workspace.create.subtitle": "O lugar do seu time para chat, documentos e agentes.",
    "workspace.create.name": "Nome do workspace",
    "workspace.create.placeholder": "Acme Ltda.",
    "workspace.create.url": [{"type":0,"value":"Endereço: "},{"type":1,"value":"url"}],
    "workspace.create.submit": "Criar workspace",
    "workspace.create.error": "Não foi possível criar o workspace. Tente de novo.",
    "workspace.create.rateLimited": "Você criou muitos workspaces hoje. Tente de novo amanhã.",
    "workspace.create.offline": "Você está offline. Conecte-se à internet para criar um workspace.",
    "workspace.switcher.create": "Criar workspace",
    "workspace.switcher.invite": "Convidar pessoas",
    "workspace.switcher.join": [{"type":0,"value":"Entrar em "},{"type":1,"value":"name"}],
    "workspace.join.title": "Entre no workspace do seu time",
    "workspace.join.subtitle": "Seu e-mail verificado permite entrar nestes workspaces sem convite.",
    "workspace.join.domain": [{"type":0,"value":"Aberto a qualquer pessoa de "},{"type":1,"value":"domain"}],
    "workspace.join.members": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" membro"}]},"other":{"value":[{"type":7},{"type":0,"value":" membros"}]}},"offset":0,"pluralType":"cardinal"}],
    "workspace.join.action": "Entrar",
    "workspace.join.error": "Não foi possível entrar no workspace. Tente de novo.",
    "workspace.join.offline": "Você está offline. Conecte-se à internet para entrar em um workspace.",
    "workspace.join.orCreate": "Ou crie um novo workspace",
    "invite.people.title": [{"type":0,"value":"Convidar pessoas para "},{"type":1,"value":"workspace"}],
    "invite.people.link": "Link de convite",
    "invite.people.linkHint": "Qualquer pessoa com o link pode entrar durante 7 dias.",
    "invite.people.createLink": "Criar link de convite",
    "invite.people.copy": "Copiar link",
    "invite.people.copied": "Link copiado",
    "invite.people.emails": "Convidar por e-mail",
    "invite.people.emailsPlaceholder": "ana@empresa.com, bo@empresa.com",
    "invite.people.asAdmins": "Convidar como administradores",
    "invite.people.send": "Enviar convites",
    "invite.people.sent": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pessoa convidada."}]},"other":{"value":[{"type":7},{"type":0,"value":" pessoas convidadas."}]}},"offset":0,"pluralType":"cardinal"}],
    "invite.people.notEmailed": "O e-mail ainda não está configurado — compartilhe estes links você mesmo:",
    "invite.people.invalid": [{"type":0,"value":"Não é um endereço de e-mail: "},{"type":1,"value":"list"}],
    "invite.people.overLimit": "Você pode convidar até 50 pessoas por vez.",
    "invite.people.done": "Concluir",
    "invite.people.skip": "Agora não",
    "invite.accept.title": [{"type":1,"value":"inviter"},{"type":0,"value":" convidou você para participar de "},{"type":1,"value":"workspace"}],
    "invite.accept.titleAnonymous": [{"type":0,"value":"Você foi convidado para participar de "},{"type":1,"value":"workspace"}],
    "invite.accept.subtitle": "No Bundle o time conversa, escreve documentos e trabalha com agentes.",
    "invite.accept.join": [{"type":0,"value":"Entrar em "},{"type":1,"value":"workspace"}],
    "invite.accept.signInToJoin": "Entre para participar",
    "invite.accept.invalid": "Este link de convite é inválido ou expirou",
    "invite.accept.invalidBody": "Peça um novo link a quem convidou você.",
    "invite.accept.emailMismatch": "Este convite foi enviado para outro endereço de e-mail. Entre com esse endereço para participar.",
    "invite.accept.offline": "Você está offline. Conecte-se à internet e tente de novo.",
    "invite.accept.continue": "Continuar para o Bundle",
    "invite.guest.link": [{"type":0,"value":"Link de acesso para "},{"type":1,"value":"email"},{"type":0,"value":" (válido por 7 dias):"}],
    "update.available": "Uma nova versão do Bundle está disponível.",
    "update.ready": [{"type":0,"value":"O Bundle "},{"type":1,"value":"version"},{"type":0,"value":" está pronto para instalar."}],
    "update.reload": "Recarregar",
    "update.restart": "Reiniciar",
    "update.check": "Procurar atualizações…",
    "update.checkPlain": "Procurar atualizações",
    "update.downloadingMenu": [{"type":0,"value":"Baixando "},{"type":1,"value":"version"},{"type":0,"value":"…"}],
    "update.restartToUpdate": "Reiniciar para atualizar",
    "update.reloadToUpdate": "Recarregar para atualizar",
    "update.checking": "Procurando atualizações…",
    "update.upToDate": "Você está com a versão mais recente",
    "update.upToDateVersion": [{"type":0,"value":"Você está com a versão mais recente ("},{"type":1,"value":"version"},{"type":0,"value":")"}],
    "update.checkedJustNow": "Verificado agora.",
    "update.autoNote": "As atualizações são instaladas sozinhas quando você não está usando o app.",
    "update.webLatest": [{"type":0,"value":"O app web "},{"type":1,"value":"commit"},{"type":0,"value":" é a versão mais recente."}],
    "update.checkAgain": "Verificar de novo",
    "update.availableVersion": [{"type":0,"value":"O Bundle "},{"type":1,"value":"version"},{"type":0,"value":" está disponível"}],
    "update.downloadingPercent": [{"type":0,"value":"Baixando… "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "update.downloadingPlain": "Baixando…",
    "update.readyVersion": [{"type":0,"value":"O Bundle "},{"type":1,"value":"version"},{"type":0,"value":" está pronto"}],
    "update.readyNote": "É instalado quando você não estiver usando o app ou ao sair. Suas janelas e abas voltam.",
    "update.webReadyTitle": "Uma nova versão do Bundle está pronta",
    "update.webReadyNote": "Recarrega sozinho quando você se afastar, ou agora.",
    "update.errorCheck": "Não foi possível procurar atualizações",
    "update.errorDownload": "Não foi possível baixar a atualização",
    "update.errorInstall": "Não foi possível instalar a atualização",
    "update.errorHint": "Verifique sua conexão e tente de novo.",
    "update.tryAgain": "Tentar de novo",
    "update.updatedTo": [{"type":0,"value":"Atualizado para o Bundle "},{"type":1,"value":"version"},{"type":0,"value":"."}],
    "update.whatsNew": "Novidades",
    "toast.region": "Notificações",
    "update.later": "Depois",
    "update.download": "Baixar",
    "update.apkBody": "Baixe aqui e toque em Instalar. Suas mensagens e configurações continuam.",
    "update.apkNotifyBody": "Toque para baixar e instalar.",
    "update.checkedAt": [{"type":0,"value":"Verificado "},{"type":1,"value":"time"}],
    "update.opensStoreIos": "Abre o TestFlight ou a App Store, que mantêm o Bundle atualizado.",
    "update.opensStorePlay": "Abre o Bundle no Google Play",
    "about.title": "Sobre o Bundle",
    "about.section": "Sobre",
    "about.versionLine": [{"type":0,"value":"Versão "},{"type":1,"value":"version"},{"type":0,"value":" · "},{"type":1,"value":"channel"}],
    "about.version": "Versão",
    "about.channel": "Canal",
    "about.channel.stable": "Estável",
    "about.channel.testflight": "TestFlight",
    "about.channel.direct": "Direto",
    "about.channel.dev": "Desenvolvimento",
    "about.desktopApp": "App para desktop",
    "about.webApp": "App web",
    "about.server": "Servidor",
    "about.copy": "Copiar informações da versão",
    "about.copied": "Informações da versão copiadas.",
    "about.licenses": "Licenças",
    "notification.reply": "Responder",
    "notification.markRead": "Marcar como lida",
    "notification.you": "Você",
    "notification.newMessage": "Nova mensagem",
    "notification.channel.mail": "E-mail",
    "notification.channel.mailDescription": "Novos e-mails e códigos de verificação",
    "notification.channel.reminders": "Lembretes",
    "notification.channel.remindersDescription": "Lembretes, lembretes de eventos e convites",
    "notification.channel.workspace": "Espaço de trabalho",
    "notification.channel.workspaceDescription": "Novos membros e outros alertas do espaço de trabalho",
    "common.dismiss": "Dispensar",
    "db.untitled": "Sem título",
    "db.new": "Novo",
    "db.search.placeholder": "Pesquisar",
    "db.toolbar.filter": "Filtro",
    "db.toolbar.sort": "Ordenar",
    "db.toolbar.group": "Agrupar",
    "db.toolbar.properties": "Propriedades",
    "db.toolbar.search": "Pesquisar nesta visualização",
    "db.view.add": "Adicionar visualização",
    "db.view.rename": "Renomear",
    "db.view.duplicate": "Duplicar",
    "db.view.delete": "Excluir visualização",
    "db.view.name": "Nome da visualização",
    "db.view.copyName": [{"type":1,"value":"name"},{"type":0,"value":" (cópia)"}],
    "db.view.options": "Opções da visualização",
    "db.layout.board": "Quadro",
    "db.layout.table": "Tabela",
    "db.layout.list": "Lista",
    "db.layout.calendar": "Calendário",
    "db.layout.sheet": "Planilha",
    "db.sheet.nameBox": "Caixa de nome",
    "db.sheet.formulaBar": "Fórmula",
    "db.sheet.entryRow": "Digite para adicionar uma linha",
    "db.sheet.summary": "Resumo",
    "db.sheet.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" linha"}]},"other":{"value":[{"type":7},{"type":0,"value":" linhas"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.sheet.summaryRows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" linha de resumo"}]},"other":{"value":[{"type":7},{"type":0,"value":" linhas de resumo"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.sheet.stat.label": "Estatística da seleção",
    "db.sheet.stat.sum": "Soma",
    "db.sheet.stat.average": "Média",
    "db.sheet.stat.min": "Mín.",
    "db.sheet.stat.max": "Máx.",
    "db.sheet.stat.count": "Contagem",
    "db.sheet.columnFormula": [{"type":0,"value":"Fórmula da coluna · "},{"type":1,"value":"name"}],
    "db.sheet.editProperty": "Editar propriedade…",
    "db.sheet.computed": "Calculado",
    "db.sheet.functions": "Funções",
    "db.sheet.freeze": "Congelar",
    "db.sheet.freeze.headerOnly": "Só o cabeçalho",
    "db.sheet.freeze.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Cabeçalho + 1 linha"}]},"other":{"value":[{"type":0,"value":"Cabeçalho + "},{"type":7},{"type":0,"value":" linhas"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.sheet.freeze.noColumns": "Nenhuma coluna",
    "db.sheet.freeze.columns": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"1 coluna"}]},"other":{"value":[{"type":7},{"type":0,"value":" colunas"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.sheet.freeze.upToRow": [{"type":0,"value":"Congelar até a linha "},{"type":1,"value":"row"}],
    "db.sheet.freeze.upToColumn": [{"type":0,"value":"Congelar até a coluna "},{"type":1,"value":"column"}],
    "db.sheet.sortRange": "Classificar intervalo",
    "db.sheet.sortAsc": "Classificar intervalo A → Z",
    "db.sheet.sortDesc": "Classificar intervalo Z → A",
    "db.sheet.sorted": [{"type":0,"value":"Linhas classificadas por "},{"type":1,"value":"name"},{"type":0,"value":". Os números das linhas mudaram em todas as visualizações."}],
    "db.sheet.sortFailed": "Não foi possível classificar as linhas. Tente novamente.",
    "db.sheet.undo": "Desfazer",
    "db.sheet.insert": "Inserir",
    "db.sheet.insertAbove": "Inserir linha acima",
    "db.sheet.insertBelow": "Inserir linha abaixo",
    "db.sheet.addSummary": "Linha de resumo",
    "db.sheet.insertSummaryAbove": "Inserir linha de resumo acima",
    "db.sheet.insertSummaryBelow": "Inserir linha de resumo abaixo",
    "db.sheet.moveUp": "Mover para cima",
    "db.sheet.moveDown": "Mover para baixo",
    "db.sheet.deleteSummary": "Excluir linha de resumo",
    "db.sheet.deleteRow": "Excluir linha",
    "db.sheet.openRow": "Abrir página da linha",
    "db.sheet.cut": "Recortar",
    "db.sheet.copy": "Copiar",
    "db.sheet.paste": "Colar",
    "db.sheet.fillDown": "Preencher para baixo",
    "db.sheet.fillRight": "Preencher para a direita",
    "db.sheet.clear": "Limpar",
    "db.sheet.typeMismatch": [{"type":1,"value":"name"},{"type":0,"value":" não aceita “"},{"type":1,"value":"text"},{"type":0,"value":"”."}],
    "db.sheet.changeType": "Alterar tipo…",
    "db.sheet.tooMany": [{"type":0,"value":"Um preenchimento ou colagem pode alterar até "},{"type":1,"value":"max"},{"type":0,"value":" células ("},{"type":1,"value":"count"},{"type":0,"value":" aqui)."}],
    "db.sheet.clipboardFailed": "Não foi possível ler a área de transferência. Use ⌘V ou Ctrl+V.",
    "db.sheet.fill": "Preencher",
    "db.sheet.freezeHere": "Congelar até aqui",
    "db.sheet.unfreeze": "Descongelar",
    "db.sheet.placeholder": "Valor ou =fórmula",
    "db.sheet.notEditable": [{"type":1,"value":"name"},{"type":0,"value":" não pode ser editada aqui"}],
    "db.sheet.saveFailed": "Não foi possível salvar a célula",
    "db.layout.label": "Layout",
    "db.filter.add": "Adicionar filtro",
    "db.filter.empty": "Nenhum filtro aplicado a esta visualização",
    "db.filter.and": "E",
    "db.filter.or": "Ou",
    "db.filter.where": "Onde",
    "db.filter.remove": "Remover filtro",
    "db.filter.value": "Valor",
    "db.filter.checked": "Marcado",
    "db.filter.unchecked": "Desmarcado",
    "db.op.eq": "É",
    "db.op.neq": "Não é",
    "db.op.contains": "Contém",
    "db.op.notContains": "Não contém",
    "db.op.startsWith": "Começa com",
    "db.op.endsWith": "Termina com",
    "db.op.isEmpty": "Está vazio",
    "db.op.isNotEmpty": "Não está vazio",
    "db.op.gt": "Maior que",
    "db.op.gte": "Maior ou igual a",
    "db.op.lt": "Menor que",
    "db.op.lte": "Menor ou igual a",
    "db.op.before": "É antes de",
    "db.op.after": "É depois de",
    "db.op.onOrBefore": "É em ou antes de",
    "db.op.onOrAfter": "É em ou depois de",
    "db.op.pastWeek": "Está na última semana",
    "db.op.nextWeek": "Está na próxima semana",
    "db.op.hasAny": "Contém algum de",
    "db.op.hasAll": "Contém todos de",
    "db.op.hasNone": "Não contém nenhum de",
    "db.op.isMe": "Sou eu",
    "db.sort.add": "Adicionar ordenação",
    "db.sort.empty": "Nenhuma ordenação aplicada a esta visualização",
    "db.sort.asc": "Crescente",
    "db.sort.desc": "Decrescente",
    "db.sort.remove": "Remover ordenação",
    "db.group.by": "Agrupar por",
    "db.group.noGrouping": "Nenhum",
    "db.group.none": [{"type":0,"value":"Sem "},{"type":1,"value":"property"}],
    "db.group.checked": "Marcado",
    "db.group.unchecked": "Desmarcado",
    "db.group.hide": "Ocultar grupo",
    "db.group.show": "Mostrar grupo",
    "db.group.hidden": "Grupos ocultos",
    "db.props.shown": "Visíveis nesta visualização",
    "db.props.hidden": "Ocultas nesta visualização",
    "db.props.show": "Mostrar",
    "db.props.hide": "Ocultar",
    "db.props.moveUp": "Mover para cima",
    "db.props.moveDown": "Mover para baixo",
    "db.property.add": "Adicionar propriedade",
    "db.property.name": "Nome da propriedade",
    "db.property.type": "Tipo",
    "db.property.edit": "Editar propriedade",
    "db.property.delete": "Excluir propriedade",
    "db.property.options": "Opções",
    "db.property.addOption": "Adicionar uma opção",
    "db.property.optionName": "Nome da opção",
    "db.property.numberFormat": "Formato do número",
    "db.property.relationTarget": "Banco de dados relacionado",
    "db.property.create": "Criar",
    "db.numberFormat.number": "Número",
    "db.numberFormat.percent": "Porcentagem",
    "db.numberFormat.currency": "Moeda",
    "db.type.title": "Título",
    "db.type.text": "Texto",
    "db.type.number": "Número",
    "db.type.select": "Seleção",
    "db.type.multiSelect": "Seleção múltipla",
    "db.type.status": "Status",
    "db.type.date": "Data",
    "db.type.person": "Pessoa",
    "db.type.checkbox": "Caixa de seleção",
    "db.type.url": "URL",
    "db.type.email": "E-mail",
    "db.type.files": "Arquivos e mídia",
    "db.type.relation": "Relação",
    "db.type.contact": "Contato",
    "db.contact.empty": "Nenhum contato",
    "db.contact.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" contato"}]},"other":{"value":[{"type":7},{"type":0,"value":" contatos"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.contact.search": "Encontrar um contato",
    "db.contact.recentEmails": "E-mails recentes com estes clientes",
    "db.type.createdTime": "Data de criação",
    "db.type.createdBy": "Criado por",
    "db.type.editedTime": "Última edição",
    "db.type.editedBy": "Editado por",
    "db.type.formula": "Fórmula",
    "db.type.rollup": "Rollup",
    "db.calc.calculate": "Calcular",
    "db.calc.none": "Nenhum",
    "db.calc.countAll": "Contar tudo",
    "db.calc.countValues": "Contar valores",
    "db.calc.countUnique": "Contar valores únicos",
    "db.calc.countEmpty": "Contar vazios",
    "db.calc.countNotEmpty": "Contar não vazios",
    "db.calc.percentEmpty": "Percentual vazio",
    "db.calc.percentNotEmpty": "Percentual não vazio",
    "db.calc.sum": "Soma",
    "db.calc.average": "Média",
    "db.calc.median": "Mediana",
    "db.calc.min": "Mínimo",
    "db.calc.max": "Máximo",
    "db.calc.range": "Intervalo",
    "db.calc.earliest": "Data mais antiga",
    "db.calc.latest": "Data mais recente",
    "db.calc.dateRange": "Intervalo de datas",
    "db.calc.checked": "Marcados",
    "db.calc.unchecked": "Desmarcados",
    "db.calc.percentChecked": "Percentual marcado",
    "db.calc.percentUnchecked": "Percentual desmarcado",
    "db.calc.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" dia"}]},"other":{"value":[{"type":7},{"type":0,"value":" dias"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.formula.edit": "Editar fórmula",
    "db.formula.placeholder": "Digite uma propriedade, uma célula (C7), um intervalo (C2:C10) ou uma função",
    "db.formula.properties": "Propriedades",
    "db.formula.functions": "Funções",
    "db.formula.format": "Formato",
    "db.formula.format.auto": "Automático",
    "db.formula.format.number": "Número",
    "db.formula.format.percent": "Percentual",
    "db.formula.format.currency": "Moeda",
    "db.formula.format.date": "Data",
    "db.formula.preview": [{"type":0,"value":"Linha "},{"type":1,"value":"row"}],
    "db.formula.empty": "Vazio",
    "db.formula.searchFunctions": "Buscar funções",
    "db.formula.examples": "Exemplos",
    "db.formula.done": "Concluir",
    "db.formula.cancel": "Cancelar",
    "db.formula.column": [{"type":1,"value":"name"},{"type":0,"value":" · coluna "},{"type":1,"value":"letter"}],
    "db.formula.noFunctions": "Nenhuma função encontrada",
    "db.formula.offline": "Prévia indisponível",
    "db.formula.hint": "Digite prop(\"Nome\"), uma célula (C7), um intervalo (C2:C10) ou uma função",
    "db.formula.fn.if": "Retorna um valor se a condição for verdadeira e outro se for falsa.",
    "db.formula.fn.ifs": "Testa condições em ordem e retorna o valor da primeira verdadeira.",
    "db.formula.fn.and": "VERDADEIRO quando todos os argumentos são verdadeiros.",
    "db.formula.fn.or": "VERDADEIRO quando algum argumento é verdadeiro.",
    "db.formula.fn.not": "Inverte um valor lógico.",
    "db.formula.fn.sum": "Soma números, células ou intervalos. Texto e células vazias são ignorados.",
    "db.formula.fn.average": "A média dos números, ignorando texto e células vazias.",
    "db.formula.fn.min": "O menor número.",
    "db.formula.fn.max": "O maior número.",
    "db.formula.fn.round": "Arredonda um número para uma quantidade de casas decimais.",
    "db.formula.fn.abs": "O valor absoluto de um número.",
    "db.formula.fn.count": "Conta os valores numéricos.",
    "db.formula.fn.counta": "Conta os valores que não estão vazios.",
    "db.formula.fn.concat": "Junta dois valores como texto.",
    "db.formula.fn.textjoin": "Junta textos com um delimitador, podendo ignorar valores vazios.",
    "db.formula.fn.left": "Os primeiros caracteres de um texto.",
    "db.formula.fn.right": "Os últimos caracteres de um texto.",
    "db.formula.fn.mid": "Caracteres do meio de um texto.",
    "db.formula.fn.len": "A quantidade de caracteres de um texto.",
    "db.formula.fn.upper": "Converte o texto para maiúsculas.",
    "db.formula.fn.lower": "Converte o texto para minúsculas.",
    "db.formula.fn.trim": "Remove espaços extras do texto.",
    "db.formula.fn.substitute": "Substitui ocorrências de um texto por outro.",
    "db.formula.fn.text": "Formata um número ou data como texto com um padrão.",
    "db.formula.fn.today": "A data de hoje (fuso horário do workspace).",
    "db.formula.fn.now": "A data e a hora atuais.",
    "db.formula.fn.date": "Uma data a partir de ano, mês e dia.",
    "db.formula.fn.edate": "Uma data alguns meses antes ou depois de outra.",
    "db.formula.fn.datedif": "A diferença entre duas datas em dias, meses ou anos.",
    "db.formula.fn.year": "O ano de uma data.",
    "db.formula.fn.month": "O mês de uma data (1–12).",
    "db.formula.fn.day": "O dia do mês de uma data.",
    "db.formula.fn.switch": "Compara um valor com casos e retorna o resultado correspondente.",
    "db.formula.fn.iferror": "Retorna um valor alternativo quando o valor é um erro.",
    "db.formula.fn.isblank": "VERDADEIRO quando o valor está vazio.",
    "db.formula.fn.xlookup": "Busca um valor em um intervalo e retorna o item correspondente de outro.",
    "db.formula.fn.sumif": "Soma as células de um intervalo que atendem a uma condição.",
    "db.formula.fn.countif": "Conta as células de um intervalo que atendem a uma condição.",
    "db.formula.fn.median": "O número do meio de um conjunto.",
    "db.rollup.relation": "Relação",
    "db.rollup.property": "Propriedade",
    "db.rollup.calculate": "Calcular",
    "db.rollup.showOriginal": "Mostrar original",
    "db.rollup.noRelation": "Adicione uma relação primeiro",
    "db.view.showRowNumbers": "Mostrar números das linhas",
    "db.statusGroup.todo": "A fazer",
    "db.statusGroup.inProgress": "Em andamento",
    "db.statusGroup.complete": "Concluído",
    "db.status.notStarted": "Não iniciado",
    "db.status.inProgress": "Em andamento",
    "db.status.done": "Concluído",
    "db.color.default": "Padrão",
    "db.color.gray": "Cinza",
    "db.color.brown": "Marrom",
    "db.color.orange": "Laranja",
    "db.color.yellow": "Amarelo",
    "db.color.green": "Verde",
    "db.color.blue": "Azul",
    "db.color.purple": "Roxo",
    "db.color.pink": "Rosa",
    "db.color.red": "Vermelho",
    "db.option.search": "Pesquise ou crie uma opção",
    "db.option.create": [{"type":0,"value":"Criar “"},{"type":1,"value":"name"},{"type":0,"value":"”"}],
    "db.option.delete": "Excluir opção",
    "db.option.color": "Cor",
    "db.person.search": "Buscar uma pessoa",
    "db.relation.search": "Buscar páginas",
    "db.relation.empty": "Nenhuma página",
    "db.relation.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" página"}]},"other":{"value":[{"type":7},{"type":0,"value":" páginas"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.files.comingSoon": "O envio de arquivos chega em breve.",
    "db.files.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" arquivo"}]},"other":{"value":[{"type":7},{"type":0,"value":" arquivos"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.date.end": "Data de término",
    "db.date.clear": "Limpar",
    "db.value.empty": "Vazio",
    "db.row.open": "Abrir",
    "db.row.openAsPage": "Abrir como página",
    "db.row.peek": "Abrir na lateral",
    "db.row.delete": "Excluir",
    "db.row.pending": "Aguardando sincronização",
    "db.pending": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" alteração aguardando sincronização"}]},"other":{"value":[{"type":7},{"type":0,"value":" alterações aguardando sincronização"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.empty.title": "Nenhuma página ainda",
    "db.empty.body": "Selecione Novo para adicionar a primeira.",
    "db.empty.filtered": "Nenhum resultado",
    "db.error.title": "Não foi possível carregar este banco de dados",
    "db.error.notFound": "Este banco de dados não existe ou você não tem acesso a ele.",
    "db.calendar.prev": "Mês anterior",
    "db.calendar.next": "Próximo mês",
    "db.calendar.today": "Hoje",
    "db.calendar.more": [{"type":0,"value":"Mais "},{"type":1,"value":"count"}],
    "db.calendar.by": "Mostrar calendário por",
    "db.calendar.noDate": "Adicione uma propriedade de data para usar o calendário.",
    "db.calendar.undated": "Sem data",
    "db.calendar.newOn": [{"type":0,"value":"Novo em "},{"type":1,"value":"date"}],
    "db.board.noGroup": "Escolha uma propriedade de seleção, status ou pessoa para agrupar o quadro.",
    "db.board.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" cartão"}]},"other":{"value":[{"type":7},{"type":0,"value":" cartões"}]}},"offset":0,"pluralType":"cardinal"}],
    "db.icon.change": "Alterar ícone",
    "db.title.placeholder": "Banco de dados sem título",
    "docs.section.favorites": "Favoritos",
    "docs.section.workspace": "Espaço de trabalho",
    "docs.section.private": "Particular",
    "docs.newPage": "Nova página",
    "docs.addPage": "Adicionar uma página",
    "docs.template.page": "Página",
    "docs.template.database": "Banco de dados",
    "docs.template.projects": "Projetos",
    "docs.template.meetingNotes": "Notas de reunião",
    "docs.template.wiki": "Wiki",
    "docs.menu.newSubpage": "Nova subpágina",
    "docs.menu.rename": "Renomear",
    "docs.menu.addFavorite": "Adicionar aos favoritos",
    "docs.menu.removeFavorite": "Remover dos favoritos",
    "docs.menu.trash": "Mover para a lixeira",
    "docs.menu.more": "Mais ações",
    "docs.menu.moveToPrivate": "Mover para Particular",
    "docs.menu.moveToWorkspace": "Mover para o espaço de trabalho",
    "docs.row.expand": "Expandir",
    "docs.row.collapse": "Recolher",
    "docs.rename.title": "Renomear página",
    "docs.rename.placeholder": "Título da página",
    "docs.empty": "Nenhuma página ainda",
    "docs.trashed": "Movida para a lixeira.",
    "docs.undo": "Desfazer",
    "docs.createFailed": "Não foi possível criar a página. Verifique sua conexão e tente novamente.",
    "page.untitled": "Sem título",
    "page.titlePlaceholder": "Sem título",
    "page.notFound.title": "Página não encontrada",
    "page.notFound.body": "Esta página não existe, foi movida para a lixeira ou você não tem acesso a ela.",
    "page.offlineUnavailable": "Esta página ainda não foi aberta neste dispositivo. Conecte-se para carregá-la.",
    "page.addIcon": "Adicionar ícone",
    "page.changeIcon": "Alterar ícone",
    "page.removeIcon": "Remover ícone",
    "page.sync.offline": "Offline · as alterações ficam salvas neste dispositivo",
    "page.sync.connecting": "Conectando…",
    "page.sync.saving": "Salvando…",
    "page.sync.saved": "Salvo",
    "page.readOnly": "Somente leitura",
    "page.presence": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"mais "},{"type":7},{"type":0,"value":" pessoa aqui"}]},"other":{"value":[{"type":0,"value":"mais "},{"type":7},{"type":0,"value":" pessoas aqui"}]}},"offset":0,"pluralType":"cardinal"}],
    "page.edited": [{"type":0,"value":"Editado "},{"type":1,"value":"time"}],
    "editor.placeholder": "Digite '/' para ver os comandos",
    "editor.placeholder.heading1": "Título 1",
    "editor.placeholder.heading2": "Título 2",
    "editor.placeholder.heading3": "Título 3",
    "editor.placeholder.list": "Lista",
    "editor.placeholder.todo": "Tarefa",
    "editor.placeholder.toggle": "Recolhível",
    "editor.placeholder.quote": "Citação vazia",
    "editor.placeholder.callout": "Escreva um destaque",
    "editor.placeholder.code": "Código",
    "editor.block.paragraph": "Texto",
    "editor.block.heading1": "Título 1",
    "editor.block.heading2": "Título 2",
    "editor.block.heading3": "Título 3",
    "editor.block.bulleted": "Lista com marcadores",
    "editor.block.numbered": "Lista numerada",
    "editor.block.todo": "Lista de tarefas",
    "editor.block.toggle": "Lista recolhível",
    "editor.block.quote": "Citação",
    "editor.block.callout": "Destaque",
    "editor.block.code": "Código",
    "editor.block.divider": "Divisor",
    "editor.block.image": "Imagem",
    "editor.block.file": "Arquivo",
    "editor.block.childPage": "Página",
    "editor.block.linkToPage": "Link para página",
    "editor.block.childDatabase": "Quadro de projetos",
    "editor.slash.title": "Blocos",
    "editor.slash.empty": "Nenhum resultado",
    "editor.turnInto": "Transformar em",
    "editor.blockActions": "Ações do bloco",
    "editor.addBelow": "Adicionar um bloco abaixo",
    "editor.toggle.open": "Abrir",
    "editor.toggle.close": "Fechar",
    "editor.toggle.empty": "Lista recolhível vazia. Clique para adicionar um bloco.",
    "editor.todo.check": "Marcar como concluída",
    "editor.image.empty": "Adicionar uma imagem",
    "editor.file.empty": "Adicionar um arquivo",
    "editor.upload.comingSoon": "O envio de arquivos em páginas chega em breve.",
    "editor.linkToPage.choose": "Escolha uma página para vincular",
    "editor.linkToPage.search": "Buscar páginas",
    "editor.missingPage": "Página indisponível",
    "editor.link.placeholder": "Cole ou digite um link",
    "editor.link.apply": "Aplicar",
    "editor.link.remove": "Remover link",
    "editor.link.title": "Link",
    "editor.mention.people": "Pessoas",
    "editor.mention.pages": "Páginas",
    "editor.mention.dates": "Datas",
    "editor.mention.today": "Hoje",
    "editor.mention.tomorrow": "Amanhã",
    "editor.mention.empty": "Nenhum resultado",
    "editor.selection": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" bloco selecionado"}]},"other":{"value":[{"type":7},{"type":0,"value":" blocos selecionados"}]}},"offset":0,"pluralType":"cardinal"}],
    "editor.format.bold": "Negrito",
    "editor.format.italic": "Itálico",
    "editor.format.strike": "Tachado",
    "editor.format.code": "Código embutido",
    "editor.format.link": "Link",
    "projects.title": "Projetos",
    "projects.subtitle": "Quadros de projetos e outros bancos de dados deste espaço de trabalho.",
    "projects.new": "Novo quadro de projetos",
    "projects.empty.title": "Nenhum quadro de projetos ainda",
    "projects.empty.body": "Crie um quadro para acompanhar projetos e tarefas com a sua equipe.",
    "projects.open": "Abrir",
    "home.recentDocs": "Documentos recentes",
    "shell.omnibox.pages": "Páginas",
    "consent.analytics.title": "Estatísticas de uso",
    "consent.analytics.message": "O Bundle pode usar o Google Analytics e o Microsoft Clarity para ver quais telas e recursos são usados, incluindo gravações com todo o texto oculto? Nunca suas mensagens, nomes ou e-mail. Nada é coletado e nenhum cookie de análise é usado sem a sua permissão. Você pode mudar isso depois no menu do seu perfil.",
    "consent.analytics.messageSettings": "O Bundle pode usar o Google Analytics e o Microsoft Clarity para ver quais telas e recursos são usados, incluindo gravações com todo o texto oculto? Nunca suas mensagens, nomes ou e-mail. Nada é coletado e nenhum cookie de análise é usado sem a sua permissão. Você pode mudar isso depois em Configurações → Preferências.",
    "consent.analytics.messageApp": "O Bundle pode usar o Google Analytics e o Microsoft Clarity para ver quais telas e recursos são usados, incluindo gravações com todo o texto oculto? Nunca suas mensagens, nomes ou e-mail. Nada é coletado sem a sua permissão. Você pode mudar isso depois em Configurações.",
    "consent.analytics.accept": "Permitir",
    "consent.analytics.decline": "Não permitir",
    "profile.analytics": "Estatísticas de uso",
    "profile.notifications.enable": "Ativar notificações",
    "profile.notifications.on": "Notificações ativadas",
    "profile.notifications.enabling": "Ativando notificações…",
    "profile.notifications.retry": "Não foi possível ativar as notificações. Tente de novo",
    "profile.notifications.blocked": "As notificações estão bloqueadas nas configurações do navegador",
    "notifications.offer.title": "Ative as notificações no computador",
    "notifications.offer.body": "Receba avisos de mensagens diretas e menções, mesmo com o Bundle em segundo plano.",
    "notifications.offer.enable": "Ativar",
    "notifications.offer.dismiss": "Agora não",
    "notifications.enabled.title": "Notificações ativadas",
    "notifications.enabled.body": "O Bundle vai avisar você sobre mensagens diretas e menções.",
    "notifications.web.offBody": "Ative as notificações para não perder chamadas e mensagens quando esta aba estiver em segundo plano.",
    "notifications.web.turnOn": "Ativar",
    "notifications.web.blockedBody": "As notificações do Bundle estão bloqueadas neste navegador. Para receber chamadas e mensagens com esta aba em segundo plano, clique no ícone de cadeado na barra de endereço e permita as notificações.",
    "notifications.blocked.title.macos": "O macOS está bloqueando as notificações do Bundle.",
    "notifications.blocked.title.windows": "O Windows está bloqueando as notificações do Bundle.",
    "notifications.blocked.body": "Você não verá convites para reuniões nem mensagens enquanto o Bundle estiver em segundo plano.",
    "notifications.blocked.open.macos": "Abrir Ajustes do Sistema",
    "notifications.blocked.open.windows": "Abrir Configurações",
    "notifications.blocked.dismiss": "Dispensar por uma semana",
    "notifications.quiet.title": "As notificações do Bundle estão definidas como Nenhum.",
    "notifications.quiet.body": "Elas só vão para a Central de Notificações. Mude para Faixas ou Alertas nos Ajustes do Sistema.",
    "settings.notifications.bannersOff": "Faixas desativadas",
    "settings.notifications.quietHelp": "As notificações do Bundle estão definidas como Nenhum. Mude para Faixas ou Alertas nos Ajustes do Sistema. Com um Foco ativado, as faixas também ficam ocultas.",
    "settings.notifications.focusHelp": "Não vê as faixas? Com um Foco ativado, o macOS as oculta até ele terminar.",
    "settings.notifications.os.macos": "Notificações do Mac",
    "settings.notifications.os.windows": "Notificações do Windows",
    "settings.notifications.offInOs.macos": "Desativadas no macOS",
    "settings.notifications.offInOs.windows": "Desativadas no Windows",
    "settings.notifications.osHelp.macos": "Ative Permitir notificações para o Bundle e escolha Alertas para que as chamadas fiquem na tela.",
    "settings.notifications.osHelp.windows": "Ative as notificações do Bundle em Configurações › Sistema › Notificações.",
    "settings.notifications.test": "Enviar uma notificação de teste",
    "settings.notifications.test.body": "Confira se os avisos chegam enquanto o Bundle está em segundo plano.",
    "settings.notifications.test.button": "Testar",
    "notifications.test.title": "As notificações estão funcionando",
    "notifications.test.body": "É assim que o Bundle avisa você sobre chamadas e mensagens.",
    "notifications.ring.tabTitle": [{"type":1,"value":"name"},{"type":0,"value":" está ligando para você…"}],
    "files.drop.title": [{"type":0,"value":"Solte arquivos para compartilhar em #"},{"type":1,"value":"channel"}],
    "files.drop.titleDm": [{"type":0,"value":"Solte arquivos para compartilhar com "},{"type":1,"value":"name"}],
    "files.drop.titleThread": "Solte arquivos para compartilhar nesta conversa",
    "files.drop.subtitle": [{"type":0,"value":"Até "},{"type":1,"value":"max"},{"type":0,"value":" arquivos, 1 GB cada"}],
    "files.attach.remove": [{"type":0,"value":"Remover "},{"type":1,"value":"name"}],
    "files.attach.tooMany": [{"type":0,"value":"Você pode anexar até "},{"type":1,"value":"max"},{"type":0,"value":" arquivos a uma mensagem"}],
    "files.attach.tooBig": [{"type":1,"value":"name"},{"type":0,"value":" tem mais de 1 GB"}],
    "files.attach.duplicate": [{"type":1,"value":"name"},{"type":0,"value":" já está anexado"}],
    "files.upload.queued": "Aguardando envio",
    "files.upload.progress": [{"type":0,"value":"Enviando… "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "files.upload.failed": "Falha no envio",
    "files.upload.retry": "Tentar enviar de novo",
    "files.upload.done": "Enviado",
    "message.uploading": [{"type":0,"value":"Enviando arquivos… "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "files.download": "Baixar",
    "files.copyLink": "Copiar link",
    "files.linkCopied": "Link copiado",
    "files.details": "Ver detalhes do arquivo",
    "files.more": [{"type":0,"value":"+"},{"type":1,"value":"count"}],
    "files.play": [{"type":0,"value":"Reproduzir "},{"type":1,"value":"name"}],
    "files.open": [{"type":0,"value":"Abrir "},{"type":1,"value":"name"}],
    "files.viewer.prev": "Anterior",
    "files.viewer.next": "Próximo",
    "files.viewer.counter": [{"type":1,"value":"index"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "files.viewer.zoomIn": "Ampliar",
    "files.viewer.zoomOut": "Reduzir",
    "files.viewer.fit": "Ajustar à largura",
    "files.noPreview": "Pré-visualização indisponível",
    "files.reason.pending": "Este arquivo ainda está sendo enviado",
    "files.reason.notInChannel": [{"type":0,"value":"Você não participa de #"},{"type":1,"value":"channel"},{"type":0,"value":": peça para entrar"}],
    "files.reason.notInChannelJoin": [{"type":0,"value":"Você não participa de #"},{"type":1,"value":"channel"},{"type":0,"value":": entre no canal para ter acesso"}],
    "files.reason.notInConversation": "Você não participa desta conversa",
    "files.reason.guestNoDownload": "Seu acesso de convidado não permite downloads",
    "files.reason.agentNoDownload": "O acesso deste agente não permite downloads",
    "files.reason.previewBlocked": "Este tipo de arquivo não pode ser pré-visualizado. Baixe-o para abrir.",
    "files.reason.expired": "Seu acesso a este workspace expirou",
    "files.page.title": "Arquivo",
    "files.page.size": "Tamanho",
    "files.page.type": "Tipo",
    "files.page.sharedBy": "Compartilhado por",
    "files.page.when": "Quando",
    "files.page.where": "Compartilhado em",
    "files.page.whereDm": [{"type":0,"value":"Conversa com "},{"type":1,"value":"names"}],
    "files.page.wherePage": [{"type":0,"value":"Página "},{"type":1,"value":"title"}],
    "files.page.notShared": "Ainda não compartilhado",
    "files.page.access": "Quem tem acesso",
    "files.page.you": "O que você pode fazer",
    "files.page.view": "Visualizar",
    "files.page.allowed": "Permitido",
    "files.page.join": [{"type":0,"value":"Entrar em #"},{"type":1,"value":"channel"}],
    "files.page.openConversation": "Abrir conversa",
    "files.page.notFound.title": "Arquivo não encontrado",
    "files.page.notFound.body": "Ele pode ter sido excluído ou não foi compartilhado com você.",
    "files.page.signIn.title": "Entre para ver este arquivo",
    "files.page.signIn.body": "No Bundle, os arquivos só ficam visíveis para quem os recebeu.",
    "files.audience.publicChannel": [{"type":0,"value":"Todos no workspace podem abrir #"},{"type":1,"value":"channel"}],
    "files.audience.privateChannel": [{"type":0,"value":"Só os membros de #"},{"type":1,"value":"channel"}],
    "files.audience.dm": [{"type":0,"value":"Só as pessoas desta conversa: "},{"type":1,"value":"names"}],
    "files.audience.page": [{"type":0,"value":"Quem pode ver a página "},{"type":1,"value":"title"}],
    "files.audience.onlyYou": "Só você, até compartilhar",
    "files.audience.guests": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" convidado pode ver e baixar"}]},"other":{"value":[{"type":7},{"type":0,"value":" convidados podem ver e baixar"}]}},"offset":0,"pluralType":"cardinal"}],
    "files.audience.guestsNoDownload": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" convidado pode ver imagens, mas não baixar"}]},"other":{"value":[{"type":7},{"type":0,"value":" convidados podem ver imagens, mas não baixar"}]}},"offset":0,"pluralType":"cardinal"}],
    "files.audience.guestsMixed": [{"type":1,"value":"without"},{"type":0,"value":" de "},{"type":1,"value":"count"},{"type":0,"value":" convidados não podem baixar os originais"}],
    "files.kind.image": "Imagem",
    "files.kind.video": "Vídeo",
    "files.kind.audio": "Áudio",
    "files.kind.pdf": "PDF",
    "files.kind.document": "Documento",
    "files.kind.spreadsheet": "Planilha",
    "files.kind.presentation": "Apresentação",
    "files.kind.archive": "Arquivo compactado",
    "files.kind.code": "Código",
    "files.kind.text": "Texto",
    "files.kind.executable": "Programa",
    "files.kind.other": "Arquivo",
    "files.audience.memberCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" membro"}]},"other":{"value":[{"type":7},{"type":0,"value":" membros"}]}},"offset":0,"pluralType":"cardinal"}],
    "files.page.whereChannel": [{"type":0,"value":"#"},{"type":1,"value":"channel"}],
    "files.audience.workspace": "Todos no workspace (imagem de figurinha)",
    "stickers.create.nameRequired": "Dê um nome à figurinha",
    "stickers.create.nameTooLong": [{"type":0,"value":"Use no máximo "},{"type":1,"value":"max"},{"type":0,"value":" caracteres"}],
    "stickers.pack.nameRequired": "Dê um nome ao pacote",
    "stickers.pack.nameTooLong": [{"type":0,"value":"Use no máximo "},{"type":1,"value":"max"},{"type":0,"value":" caracteres"}],
    "stickers.create.badType": "Figurinhas podem ser imagens PNG, JPEG, WebP ou GIF",
    "stickers.create.tooBig": [{"type":0,"value":"Figurinhas animadas podem ter no máximo "},{"type":1,"value":"max"}],
    "stickers.create.tooLarge": [{"type":0,"value":"Figurinhas animadas podem ter no máximo "},{"type":1,"value":"max"},{"type":0,"value":"×"},{"type":1,"value":"max"},{"type":0,"value":" pixels"}],
    "stickers.create.unreadable": "Não foi possível ler esta imagem. Tente outra.",
    "stickers.picker.results": "Resultados",
    "stickers.picker.recent": "Usadas recentemente",
    "stickers.notice.offline": "Você está offline. Tente de novo quando estiver online.",
    "stickers.notice.failed": "Algo deu errado. Tente de novo.",
    "stickers.notice.forbidden": "Você não pode fazer isso neste workspace.",
    "picker.title": "Emoji, figurinhas e GIFs",
    "picker.tab.emoji": "Emoji",
    "picker.tab.stickers": "Figurinhas",
    "picker.tab.gifs": "GIFs",
    "picker.emoji.search": "Buscar emoji",
    "picker.emoji.frequent": "Usados com frequência",
    "picker.emoji.skinTone": "Tom de pele",
    "picker.stickers.search": "Buscar figurinhas",
    "picker.stickers.create": "Criar figurinha",
    "picker.stickers.add": "Adicionar figurinhas",
    "picker.stickers.manage": "Gerenciar figurinhas",
    "picker.stickers.empty": "Nenhuma figurinha ainda",
    "picker.stickers.emptyBody": "Crie uma ou adicione pacotes do seu workspace.",
    "picker.stickers.noResults": [{"type":0,"value":"Nenhuma figurinha para “"},{"type":1,"value":"query"},{"type":0,"value":"”"}],
    "picker.gifs.search": "Search KLIPY",
    "picker.gifs.poweredBy": "Powered by KLIPY",
    "picker.gifs.trending": "Em alta",
    "picker.gifs.unavailable": "GIFs indisponíveis",
    "picker.gifs.unavailableBody": "A busca de GIFs não está configurada neste workspace.",
    "picker.gifs.empty": [{"type":0,"value":"Nenhum GIF para “"},{"type":1,"value":"query"},{"type":0,"value":"”"}],
    "picker.gifs.error.network": "Não foi possível acessar o KLIPY. Verifique sua conexão.",
    "picker.gifs.error.rateLimited": "Muitas buscas. Espere um pouco e tente de novo.",
    "picker.gifs.error.server": "A busca de GIFs falhou.",
    "picker.gifs.loadingMore": "Carregando mais…",
    "message.sticker": [{"type":0,"value":"Figurinha: "},{"type":1,"value":"name"}],
    "message.gif": [{"type":0,"value":"GIF: "},{"type":1,"value":"title"}],
    "message.gifVia": "via KLIPY",
    "message.openPack": "Abrir pacote de figurinhas",
    "message.edit": "Editar mensagem",
    "message.editSave": "Salvar",
    "message.editCancel": "Cancelar",
    "message.editHint": "Esc para cancelar · Enter para salvar",
    "message.editEmpty": "A mensagem não pode ficar vazia.",
    "message.delete": "Excluir mensagem",
    "message.deleteConfirm.title": "Excluir mensagem",
    "message.deleteConfirm.body": "Tem certeza de que deseja excluir esta mensagem? Não é possível desfazer.",
    "message.deleteConfirm.others": [{"type":0,"value":"Você está excluindo uma mensagem de "},{"type":1,"value":"name"},{"type":0,"value":". Ela será excluída para todos."}],
    "message.deleteConfirm.files": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"O arquivo anexado também será excluído."}]},"other":{"value":[{"type":0,"value":"Os "},{"type":7},{"type":0,"value":" arquivos anexados também serão excluídos."}]}},"offset":0,"pluralType":"cardinal"}],
    "message.deleteConfirm.replies": "As respostas ficam: a conversa mantém “Esta mensagem foi excluída.” no lugar dela.",
    "message.deleteConfirm.confirm": "Excluir",
    "message.deleteConfirm.cancel": "Cancelar",
    "broadcast.confirm.title": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Notificar "},{"type":7},{"type":0,"value":" pessoa?"}]},"other":{"value":[{"type":0,"value":"Notificar "},{"type":7},{"type":0,"value":" pessoas?"}]}},"offset":0,"pluralType":"cardinal"}],
    "broadcast.confirm.channel": [{"type":1,"value":"range"},{"type":0,"value":" notifica todos neste canal."}],
    "broadcast.confirm.here": "@here notifica todos neste canal que estão ativos agora.",
    "broadcast.confirm.zones": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Todos estão no mesmo fuso horário."}]},"other":{"value":[{"type":0,"value":"Estão em "},{"type":7},{"type":0,"value":" fusos horários, então pode ser fora do horário de trabalho para alguns."}]}},"offset":0,"pluralType":"cardinal"}],
    "broadcast.confirm.send": "Enviar mesmo assim",
    "files.saveAsSticker": "Salvar como figurinha",
    "stickers.pack.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" figurinha"}]},"other":{"value":[{"type":7},{"type":0,"value":" figurinhas"}]}},"offset":0,"pluralType":"cardinal"}],
    "stickers.pack.workspace": "Pacote do workspace",
    "stickers.pack.personal": [{"type":0,"value":"Pacote pessoal de "},{"type":1,"value":"name"}],
    "stickers.pack.add": "Adicionar às Minhas figurinhas",
    "stickers.pack.added": "Nas Minhas figurinhas",
    "stickers.pack.remove": "Remover das Minhas figurinhas",
    "stickers.pack.delete": "Excluir pacote",
    "stickers.pack.makeWorkspace": "Tornar pacote do workspace",
    "stickers.pack.makePersonal": "Tornar pessoal",
    "stickers.pack.addSticker": "Adicionar figurinha",
    "stickers.pack.notFound": "Este pacote não está mais disponível.",
    "stickers.pack.empty": "Nenhuma figurinha neste pacote ainda.",
    "stickers.sticker.delete": "Excluir figurinha",
    "stickers.manage.title": "Figurinhas",
    "stickers.manage.mine": "Minhas figurinhas",
    "stickers.manage.browse": "Pacotes neste workspace",
    "stickers.manage.moveUp": "Mover para cima",
    "stickers.manage.moveDown": "Mover para baixo",
    "stickers.manage.add": "Adicionar",
    "stickers.manage.remove": "Remover",
    "stickers.manage.open": [{"type":0,"value":"Abrir "},{"type":1,"value":"name"}],
    "stickers.manage.emptyMine": "Nenhum pacote ainda. Adicione alguns da lista abaixo.",
    "stickers.manage.settings": "Configurações do workspace",
    "stickers.settings.creators": "Quem pode criar figurinhas",
    "stickers.settings.creators.everyone": "Todos os membros",
    "stickers.settings.creators.admins": "Somente administradores",
    "stickers.settings.gifsEnabled": "Permitir GIFs (KLIPY)",
    "stickers.settings.rating": "Filtro de conteúdo dos GIFs",
    "stickers.settings.rating.high": "Rigoroso (recomendado)",
    "stickers.settings.rating.medium": "Moderado",
    "stickers.settings.rating.low": "Flexível",
    "stickers.settings.rating.off": "Desligado",
    "stickers.settings.guests": "Convidados e agentes podem enviar figurinhas e GIFs, mas não criar figurinhas.",
    "stickers.create.title": "Criar figurinha",
    "stickers.create.pick": "Escolher imagem",
    "stickers.create.pickHint": "PNG, JPEG, WebP ou GIF — ou cole uma imagem aqui.",
    "stickers.create.pastePlaceholder": "Cole uma imagem",
    "stickers.create.reading": "Lendo a imagem…",
    "stickers.create.crop": "Arraste e amplie para recortar em quadrado",
    "stickers.create.animatedNote": "Figurinhas animadas ficam como estão (até 1 MB).",
    "stickers.create.removeBackground": "Remover fundo",
    "stickers.create.name": "Nome",
    "stickers.create.namePlaceholder": "ex.: papagaio festeiro",
    "stickers.create.keywords": "Palavras-chave",
    "stickers.create.keywordsPlaceholder": "Palavras que as pessoas podem buscar",
    "stickers.create.pack": "Pacote",
    "stickers.create.newPack": "Novo pacote",
    "stickers.create.newPackName": "Nome do novo pacote",
    "stickers.create.newPackWorkspace": "Compartilhar o pacote com todo o workspace",
    "stickers.create.save": "Salvar figurinha",
    "stickers.create.saving": "Salvando…",
    "stickers.create.notAllowed": "Somente administradores podem criar figurinhas neste workspace.",
    "stickers.create.change": "Escolher outra imagem",
    "files.page.whereSticker": "Compartilhado como figurinha neste workspace",
    "settings.title": "Configurações",
    "settings.about.speechCredit": "Reconhecimento de fala no dispositivo por Desert Ant Labs (Voz, Align).",
    "settings.comingSoon": "As configurações chegam em breve.",
    "roles.owner": "Proprietário",
    "roles.admin": "Administrador",
    "roles.member": "Membro",
    "roles.guest": "Convidado",
    "roles.primaryOwner": "Proprietário principal",
    "roles.problem.forbidden": "Só proprietários e administradores podem gerenciar pessoas.",
    "roles.problem.ownersOnly": "Só proprietários podem alterar proprietários e administradores.",
    "roles.problem.primaryOwner": "Transfira a propriedade principal antes.",
    "roles.problem.primaryOnly": "Só o proprietário principal pode fazer isso.",
    "roles.problem.lastOwner": "Um espaço de trabalho precisa de pelo menos um proprietário.",
    "roles.problem.agent": "Agentes mantêm a função. Edite o acesso deles.",
    "roles.problem.deactivated": "Reative esta pessoa antes.",
    "roles.problem.unchanged": "Nada a alterar.",
    "roles.problem.self": "Você não pode fazer isso com você mesmo.",
    "roles.problem.ineligible": "Só um membro ativo pode se tornar o proprietário principal.",
    "profile.error.displayNameRequired": "Informe um nome de exibição.",
    "profile.error.tooLong": [{"type":0,"value":"Use no máximo "},{"type":1,"value":"max"},{"type":0,"value":" caracteres."}],
    "profile.error.phone": "Informe um telefone com 6 a 15 dígitos.",
    "profile.error.timezone": "Escolha um fuso horário da lista.",
    "profile.status.preset.meeting": "Em reunião",
    "profile.status.preset.commuting": "A caminho",
    "profile.status.preset.sick": "Doente",
    "profile.status.preset.vacation": "De férias",
    "profile.status.preset.remote": "Trabalhando remotamente",
    "profile.status.clear.never": "Não limpar",
    "profile.status.clear.halfHour": "30 minutos",
    "profile.status.clear.hour": "1 hora",
    "profile.status.clear.fourHours": "4 horas",
    "profile.status.clear.today": "Hoje",
    "profile.status.clear.week": "Esta semana",
    "profile.time.ahead": [{"type":1,"value":"span"},{"type":0,"value":" à sua frente"}],
    "profile.time.behind": [{"type":1,"value":"span"},{"type":0,"value":" atrás de você"}],
    "settings.nav.profile": "Perfil",
    "settings.nav.preferences": "Preferências",
    "settings.nav.notifications": "Notificações",
    "settings.nav.account": "Conta",
    "settings.nav.workspace": "Espaço de trabalho",
    "settings.nav.members": "Membros",
    "settings.nav.invitations": "Convites",
    "settings.nav.guests": "Convidados e agentes",
    "settings.nav.integrations": "Integrações",
    "settings.nav.security": "Segurança",
    "settings.nav.data": "Dados",
    "settings.nav.stickers": "Figurinhas e GIFs",
    "settings.group.you": "Você",
    "settings.group.workspace": "Espaço de trabalho",
    "settings.menu.profile": "Perfil e configurações",
    "settings.menu.workspace": "Configurações do espaço",
    "settings.adminOnly": "Só proprietários e administradores do espaço podem alterar estas configurações.",
    "settings.save": "Salvar alterações",
    "settings.saving": "Salvando…",
    "settings.saved": "Salvo",
    "settings.unsaved": "Alterações não salvas",
    "settings.discard": "Descartar",
    "settings.failed": "Não foi possível salvar. Tente novamente.",
    "settings.offlineQueued": "Você está offline. Suas alterações serão salvas quando você voltar a ficar online.",
    "settings.offline": "Você está offline. Tente novamente quando voltar a ficar online.",
    "settings.loadFailed": "Não foi possível carregar estas configurações.",
    "settings.comingSoonBadge": "Em breve",
    "settings.integrations.body": "Conecte apps, webhooks de entrada e comandos de barra.",
    "integrations.webhooks.title": "Webhooks de entrada",
    "integrations.webhooks.body": "Publique mensagens em um canal a partir de outros apps e scripts enviando JSON para uma URL secreta.",
    "integrations.webhooks.empty": "Nenhum webhook ainda.",
    "integrations.webhook.add": "Adicionar webhook",
    "integrations.webhook.edit": "Editar webhook",
    "integrations.webhook.create": "Adicionar",
    "integrations.webhook.name": "Nome",
    "integrations.webhook.namePlaceholder": "Por exemplo: Bot de deploy",
    "integrations.webhook.channel": "Publica em",
    "integrations.webhook.nameEmpty": "Dê um nome ao webhook.",
    "integrations.webhook.nameTooLong": "Use até 80 caracteres.",
    "integrations.webhook.pickChannel": "Escolha um canal para publicar.",
    "integrations.webhook.saveFailed": "Não foi possível salvar o webhook.",
    "integrations.webhook.failed": "Algo deu errado. Tente de novo.",
    "integrations.webhook.meta": [{"type":0,"value":"Publica em "},{"type":1,"value":"conversation"},{"type":0,"value":" · adicionado por "},{"type":1,"value":"name"}],
    "integrations.webhook.hidden": "um canal que você não vê",
    "integrations.webhook.lastUsed": [{"type":0,"value":"usado pela última vez "},{"type":1,"value":"when"}],
    "integrations.webhook.more": "Mais ações",
    "integrations.webhook.regenerate": "Gerar nova URL",
    "integrations.webhook.remove": "Remover",
    "integrations.webhook.removeTitle": "Remover webhook?",
    "integrations.webhook.removeBody": [{"type":0,"value":"Apps que usam “"},{"type":1,"value":"name"},{"type":0,"value":"” não poderão mais publicar."}],
    "integrations.webhook.urlTitle": "URL do webhook",
    "integrations.webhook.urlBody": "Copie esta URL agora — por segurança, ela não será mostrada de novo. Qualquer pessoa com ela pode publicar no canal; gere uma nova se ela vazar.",
    "integrations.webhook.url": "URL",
    "integrations.webhook.copy": "Copiar URL",
    "integrations.webhook.copied": "Copiada",
    "integrations.webhook.done": "Concluído",
    "integrations.agents.title": "Agentes",
    "integrations.agents.body": "Agentes de IA conectados a este workspace. Gerencie-os em Membros.",
    "integrations.agents.empty": "Nenhum agente conectado.",
    "integrations.agent.hosted": "Roda no Bundle",
    "integrations.agent.external": "Conectado com um token de agente",
    "integrations.agent.sponsor": [{"type":0,"value":"Patrocinado por "},{"type":1,"value":"name"}],
    "settings.security.body": "Login único (SSO), autenticação em dois fatores obrigatória e duração das sessões.",
    "settings.data.body": "Exporte os dados do espaço e defina políticas de retenção.",
    "settings.stickers.body": "Quem pode criar figurinhas e a classificação de conteúdo dos GIFs.",
    "settings.stickers.open": "Gerenciar figurinhas",
    "settings.stickers.unavailable": "Figurinhas e GIFs ainda não estão disponíveis aqui.",
    "settings.preferences.appearance": "Aparência",
    "settings.preferences.privacy": "Privacidade",
    "settings.preferences.analytics.onByDefault": "Ativado (você pode desativar)",
    "settings.preferences.analytics.body": "Permite que o Bundle veja quais telas e recursos são usados (Google Analytics e gravações do Microsoft Clarity com todo o texto oculto). Nunca suas mensagens, nomes ou e-mail.",
    "settings.notifications.device": "Notificações neste dispositivo",
    "settings.notifications.unsupported": "Este dispositivo não pode mostrar notificações do Bundle.",
    "settings.notifications.disable": "Desativar",
    "settings.notifications.sound": "Som de notificação",
    "settings.notifications.sound.toggle": "Tocar um som em novas notificações",
    "settings.notifications.sound.body": "Toca para as mensagens que notificam você quando você não está vendo essa conversa. Salvo neste dispositivo.",
    "settings.notifications.sound.preview": "Ouvir",
    "settings.notifyKinds.title": "Me notificar sobre",
    "settings.notifyKinds.desc": [{"type":0,"value":"Na "},{"type":1,"value":"workspace"},{"type":0,"value":", em todos os seus dispositivos. O que você desativar continua na Atividade e nos contadores de não lidas."}],
    "settings.notifyKinds.footer": "Uma conversa com nível próprio mantém esse nível. Ele fica nas configurações da conversa.",
    "settings.notifyKinds.group.messages": "Mensagens",
    "settings.notifyKinds.group.calls": "Chamadas e lembretes",
    "settings.notifyKinds.group.workspace": "Espaço de trabalho",
    "settings.notifyKinds.dm": "Mensagens diretas",
    "settings.notifyKinds.group": "Mensagens em grupo",
    "settings.notifyKinds.mention": "Menções a você",
    "settings.notifyKinds.mention.help": "Seu nome ou um grupo do qual você faz parte.",
    "settings.notifyKinds.broadcast": "@channel, @here e @everyone",
    "settings.notifyKinds.thread": "Respostas em conversas",
    "settings.notifyKinds.thread.help": "Em conversas que você segue.",
    "settings.notifyKinds.channel": "Mensagens em canais",
    "settings.notifyKinds.channel.help": "Todas as mensagens dos canais em que você entrou.",
    "settings.notifyKinds.huddle": "Meet",
    "settings.notifyKinds.huddle.help": "Quando alguém chama você.",
    "settings.notifyKinds.eventInvite": "Convites de eventos",
    "settings.notifyKinds.eventReminder": "Lembretes de eventos",
    "settings.notifyKinds.eventReminder.help": "No horário de cada evento. Os e-mails pedidos continuam.",
    "settings.notifyKinds.later": "Lembretes do Mais tarde",
    "settings.notifyKinds.memberJoined": "Novos membros",
    "settings.notifyKinds.memberJoined.help": "Quando alguém entra pelo seu domínio de e-mail.",
    "settings.notifications.sound.knock": "Batida",
    "settings.notifications.sound.pop": "Estalo",
    "settings.notifications.sound.chime": "Carrilhão",
    "settings.notifications.sound.ding": "Sino",
    "settings.notifications.sound.pluck": "Dedilhado",
    "settings.notifications.dnd": "Pausar notificações",
    "settings.notifications.dnd.body": "Enquanto pausado não há sons, banners nem notificações push, em todos os seus dispositivos. A Atividade continua reunindo o que você perdeu.",
    "settings.notifications.dnd.min30": "Por 30 minutos",
    "settings.notifications.dnd.hour1": "Por 1 hora",
    "settings.notifications.dnd.hour2": "Por 2 horas",
    "settings.notifications.dnd.tomorrow": "Até amanhã",
    "settings.notifications.dnd.custom": "Personalizado…",
    "settings.notifications.dnd.customLabel": "Pausar até",
    "settings.notifications.dnd.customSave": "Pausar",
    "settings.notifications.dnd.until": [{"type":0,"value":"Notificações pausadas até "},{"type":1,"value":"time"}],
    "settings.notifications.dnd.resume": "Retomar notificações",
    "settings.notifications.dnd.schedule": "Pausar em um horário",
    "settings.notifications.dnd.schedule.toggle": "Pausar notificações todos os dias nesse horário",
    "settings.notifications.dnd.schedule.body": [{"type":0,"value":"Horários no fuso "},{"type":1,"value":"zone"},{"type":0,"value":"."}],
    "settings.notifications.dnd.from": "De",
    "settings.notifications.dnd.to": "Até",
    "settings.notifications.dnd.days": "Em",
    "settings.notifications.dnd.day.sun": "Dom",
    "settings.notifications.dnd.day.mon": "Seg",
    "settings.notifications.dnd.day.tue": "Ter",
    "settings.notifications.dnd.day.wed": "Qua",
    "settings.notifications.dnd.day.thu": "Qui",
    "settings.notifications.dnd.day.fri": "Sex",
    "settings.notifications.dnd.day.sat": "Sáb",
    "settings.notifications.dnd.failed": "Não foi possível salvar suas configurações de notificação. Tente de novo.",
    "dnd.paused": "Notificações pausadas",
    "profile.section.photo": "Foto",
    "profile.photo.upload": "Enviar foto",
    "profile.photo.change": "Trocar foto",
    "profile.photo.remove": "Remover foto",
    "profile.photo.crop": "Arraste e aproxime para recortar",
    "profile.photo.cropTitle": "Recortar sua foto",
    "profile.photo.use": "Usar foto",
    "profile.photo.uploading": [{"type":0,"value":"Enviando… "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "profile.photo.hint": "Uma imagem quadrada funciona melhor (pelo menos 512 × 512 pixels).",
    "profile.photo.failed": "Não foi possível enviar a foto. Tente novamente.",
    "profile.photo.unreadable": "Esse arquivo não é uma imagem que podemos usar.",
    "profile.section.about": "Sobre você",
    "profile.displayName": "Nome de exibição",
    "profile.displayName.hint": "Como você aparece em mensagens e menções.",
    "profile.fullName": "Nome completo",
    "profile.title": "Cargo",
    "profile.title.placeholder": "O que você faz",
    "profile.pronouns": "Pronomes (opcional)",
    "profile.pronouns.placeholder": "ex.: ela/dela",
    "profile.phone": "Telefone (opcional)",
    "profile.phone.visible": "Mostrar meu telefone para este espaço",
    "profile.phone.privateHint": "Privado: só você pode ver.",
    "profile.phone.publicHint": "Membros deste espaço podem ver.",
    "profile.timezone": "Fuso horário",
    "profile.timezone.search": "Buscar fusos horários",
    "profile.timezone.useDevice": [{"type":0,"value":"Usar o fuso deste dispositivo ("},{"type":1,"value":"zone"},{"type":0,"value":")"}],
    "profile.timezone.none": "Nenhum fuso horário encontrado.",
    "profile.timezone.localTime": [{"type":0,"value":"Horário local: "},{"type":1,"value":"time"}],
    "profile.language.hint": "O Bundle, seus e-mails e suas notificações usam este idioma.",
    "profile.section.status": "Status",
    "profile.status.placeholder": "Qual é o seu status?",
    "profile.status.emoji": "Escolher um emoji",
    "profile.status.clearAfter": "Limpar após",
    "profile.status.save": "Definir status",
    "profile.status.clear": "Limpar status",
    "profile.status.until": [{"type":0,"value":"Até "},{"type":1,"value":"time"}],
    "profile.status.saved": "Status atualizado",
    "status.until.time": [{"type":0,"value":"Até "},{"type":1,"value":"time"}],
    "status.until.tomorrow": "Até amanhã",
    "status.until.weekday.sun": "Até domingo",
    "status.until.weekday.mon": "Até segunda",
    "status.until.weekday.tue": "Até terça",
    "status.until.weekday.wed": "Até quarta",
    "status.until.weekday.thu": "Até quinta",
    "status.until.weekday.fri": "Até sexta",
    "status.until.weekday.sat": "Até sábado",
    "status.until.month.jan": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de jan."}],
    "status.until.month.feb": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de fev."}],
    "status.until.month.mar": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de mar."}],
    "status.until.month.apr": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de abr."}],
    "status.until.month.may": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de mai."}],
    "status.until.month.jun": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de jun."}],
    "status.until.month.jul": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de jul."}],
    "status.until.month.aug": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de ago."}],
    "status.until.month.sep": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de set."}],
    "status.until.month.oct": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de out."}],
    "status.until.month.nov": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de nov."}],
    "status.until.month.dec": [{"type":0,"value":"Até "},{"type":1,"value":"day"},{"type":0,"value":" de dez."}],
    "status.until.date": [{"type":0,"value":"Até "},{"type":1,"value":"date"}],
    "status.untilInline.time": [{"type":0,"value":"até "},{"type":1,"value":"time"}],
    "status.untilInline.tomorrow": "até amanhã",
    "status.untilInline.weekday.sun": "até domingo",
    "status.untilInline.weekday.mon": "até segunda",
    "status.untilInline.weekday.tue": "até terça",
    "status.untilInline.weekday.wed": "até quarta",
    "status.untilInline.weekday.thu": "até quinta",
    "status.untilInline.weekday.fri": "até sexta",
    "status.untilInline.weekday.sat": "até sábado",
    "status.untilInline.month.jan": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de jan."}],
    "status.untilInline.month.feb": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de fev."}],
    "status.untilInline.month.mar": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de mar."}],
    "status.untilInline.month.apr": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de abr."}],
    "status.untilInline.month.may": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de mai."}],
    "status.untilInline.month.jun": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de jun."}],
    "status.untilInline.month.jul": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de jul."}],
    "status.untilInline.month.aug": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de ago."}],
    "status.untilInline.month.sep": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de set."}],
    "status.untilInline.month.oct": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de out."}],
    "status.untilInline.month.nov": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de nov."}],
    "status.untilInline.month.dec": [{"type":0,"value":"até "},{"type":1,"value":"day"},{"type":0,"value":" de dez."}],
    "status.untilInline.date": [{"type":0,"value":"até "},{"type":1,"value":"date"}],
    "status.a11y": [{"type":0,"value":"Status: "},{"type":1,"value":"text"}],
    "status.a11y.emojiOnly": "Status",
    "account.email": "E-mail",
    "account.email.hint": "Você entra com este endereço.",
    "account.methods": "Formas de entrar",
    "account.method.email": "Código por e-mail",
    "account.method.google": "Google",
    "account.method.apple": "Apple",
    "account.method.connected": "Conectado",
    "account.method.notConnected": "Não conectado",
    "account.method.googleHint": [{"type":0,"value":"Entre com o Google como "},{"type":1,"value":"email"},{"type":0,"value":" para conectá-lo."}],
    "account.sessions": "Sessões",
    "account.sessions.current": "Este dispositivo",
    "account.sessions.lastActive": [{"type":0,"value":"Ativa pela última vez em "},{"type":1,"value":"time"}],
    "account.sessions.browser": "Navegador",
    "account.sessions.revokeOthers": "Sair das outras sessões",
    "account.sessions.revoked": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Saiu de "},{"type":7},{"type":0,"value":" sessão."}]},"other":{"value":[{"type":0,"value":"Saiu de "},{"type":7},{"type":0,"value":" sessões."}]}},"offset":0,"pluralType":"cardinal"}],
    "account.sessions.none": "Nenhuma outra sessão.",
    "account.sessions.moved": "Veja onde você está conectado e saia de outros dispositivos em Segurança.",
    "account.sessions.open": "Abrir Segurança",
    "security.sessions.title": "Onde você está conectado",
    "security.sessions.body": "Navegadores e apps do Bundle conectados à sua conta. Uma sessão encerrada para de funcionar em até 15 minutos.",
    "security.sessions.app": [{"type":0,"value":"Bundle para "},{"type":1,"value":"os"}],
    "security.sessions.appUnknown": "App do Bundle",
    "security.sessions.desktop": "App do Bundle para computador",
    "security.sessions.browserOn": [{"type":1,"value":"browser"},{"type":0,"value":" no "},{"type":1,"value":"os"}],
    "security.sessions.unknown": "Dispositivo desconhecido",
    "security.sessions.signedIn": [{"type":0,"value":"Conectado em "},{"type":1,"value":"time"}],
    "security.sessions.activity": [{"type":0,"value":"Ativo em "},{"type":1,"value":"active"},{"type":0,"value":" · Conectado em "},{"type":1,"value":"signedIn"}],
    "security.sessions.signOut": "Sair",
    "security.sessions.revokedOne": "Sessão encerrada.",
    "security.sessions.confirmTitle": "Sair de todas as outras sessões?",
    "security.sessions.confirmBody": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" outra sessão será encerrada. Você continua conectado aqui."}]},"other":{"value":[{"type":7},{"type":0,"value":" outras sessões serão encerradas. Você continua conectado aqui."}]}},"offset":0,"pluralType":"cardinal"}],
    "security.workspace.title": "Segurança do workspace",
    "security.workspace.body": [{"type":0,"value":"Como as pessoas entram em "},{"type":1,"value":"name"},{"type":0,"value":". Só proprietários e administradores veem isto."}],
    "security.workspace.invites": "Convites",
    "security.workspace.invitesBody": "Membros podem convidar pessoas como membros; proprietários e administradores também podem convidar administradores. Convidados e agentes não podem convidar ninguém. Convites expiram em 7 dias.",
    "security.workspace.guests": "Convidados",
    "security.workspace.guestsBody": "Convidados só veem os canais e páginas compartilhados com eles, e o acesso deles pode ter data para expirar.",
    "security.workspace.domains": "Entrada por domínio de e-mail",
    "security.workspace.domainsOff": "Desativada: é preciso um convite para entrar.",
    "security.workspace.domainsOn": [{"type":0,"value":"Ativada: qualquer pessoa com um endereço verificado em "},{"type":1,"value":"domains"},{"type":0,"value":" pode entrar como membro sem convite."}],
    "security.workspace.manage": "Gerenciar em Espaço de trabalho",
    "appPasswords.title": "Senhas de app",
    "appPasswords.body": [{"type":0,"value":"Apps de e-mail, agenda e contatos entram em "},{"type":1,"value":"name"},{"type":0,"value":" com uma senha de app, não com o seu login do Bundle. Use uma por dispositivo ou app: revogar uma desconecta só aquele dispositivo."}],
    "appPasswords.add": "Adicionar dispositivo",
    "appPasswords.add.profile": "iPhone, iPad ou Mac",
    "appPasswords.add.profileHelp": "Um perfil que configura Mail, Calendário e Contatos",
    "appPasswords.add.mail": "App de e-mail",
    "appPasswords.add.mailHelp": "Outlook, Thunderbird, Spark e outros",
    "appPasswords.add.calendar": "App de agenda ou contatos",
    "appPasswords.add.calendarHelp": "Calendário da Apple, DAVx⁵, Thunderbird e outros",
    "appPasswords.name.titleProfile": "Configurar um iPhone, iPad ou Mac",
    "appPasswords.name.titleMail": "Adicionar um app de e-mail",
    "appPasswords.name.titleCalendar": "Adicionar um app de agenda ou contatos",
    "appPasswords.name.body": "Dê um nome que você reconheça quando quiser desconectá-lo.",
    "appPasswords.name.label": "Dispositivo ou app",
    "appPasswords.name.helper": "Por exemplo “Mac — Spark” ou “iPhone da Ana”. Só você vê.",
    "appPasswords.name.defaultProfile": "iPhone ou Mac",
    "appPasswords.name.defaultMail": "App de e-mail",
    "appPasswords.name.defaultCalendar": "App de agenda",
    "appPasswords.create": "Criar senha",
    "appPasswords.made.title": [{"type":0,"value":"Senha de app para "},{"type":1,"value":"name"}],
    "appPasswords.made.password": "Senha",
    "appPasswords.made.once": "Aparece uma vez só. Copie para o app agora.",
    "appPasswords.made.user": "Nome de usuário",
    "appPasswords.made.userCaption": "O endereço da sua caixa de e-mail",
    "appPasswords.made.servers": "Servidores",
    "appPasswords.made.serversCaption": "A maioria dos apps encontra sozinha a partir do seu endereço",
    "appPasswords.done": "Concluído",
    "appPasswords.unnamed": "Senha de app",
    "appPasswords.unnamedNote": "Criada antes de as senhas terem nome",
    "appPasswords.created": [{"type":0,"value":"Criada "},{"type":1,"value":"time"}],
    "appPasswords.lastUsed": [{"type":0,"value":"Último uso "},{"type":1,"value":"time"}],
    "appPasswords.neverUsed": "Nunca usada",
    "appPasswords.stale": "Sem uso há 3 meses",
    "appPasswords.revoke": "Revogar",
    "appPasswords.revokeAll": "Revogar todas",
    "appPasswords.footer": "Perdeu um dispositivo? Revogue a senha dele aqui; ele é desconectado em poucos minutos.",
    "appPasswords.confirmOneTitle": [{"type":0,"value":"Revogar “"},{"type":1,"value":"name"},{"type":0,"value":"”?"}],
    "appPasswords.confirmOneTitleUnnamed": "Revogar esta senha de app?",
    "appPasswords.confirmOneBody": "O app que a usa é desconectado em poucos minutos e pede uma senha. Seus outros dispositivos continuam funcionando.",
    "appPasswords.confirmAllTitle": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Revogar "},{"type":7},{"type":0,"value":" senha de app?"}]},"other":{"value":[{"type":0,"value":"Revogar todas as "},{"type":7},{"type":0,"value":" senhas de app?"}]}},"offset":0,"pluralType":"cardinal"}],
    "appPasswords.confirmAllBody": [{"type":0,"value":"Todos os apps de e-mail, agenda e contatos conectados a "},{"type":1,"value":"name"},{"type":0,"value":" são desconectados. Cada dispositivo vai precisar de uma nova senha de app. O Bundle na web e nos apps dele não é afetado."}],
    "appPasswords.revokedOne": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” revogada. O app é desconectado em poucos minutos."}],
    "appPasswords.revokedUnnamed": "Senha de app revogada. O app é desconectado em poucos minutos.",
    "appPasswords.revokedAll": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" senha de app revogada."}]},"other":{"value":[{"type":7},{"type":0,"value":" senhas de app revogadas."}]}},"offset":0,"pluralType":"cardinal"}],
    "appPasswords.profileDownloaded": "Perfil baixado. Abra no iPhone ou Mac para instalar.",
    "appPasswords.empty.title": "Nenhum dispositivo usa senha de app",
    "appPasswords.empty.body": "Adicione uma para ler seus e-mails, agenda e contatos no Mail do iPhone, Calendário da Apple, Outlook, Spark ou Thunderbird.",
    "appPasswords.limit": [{"type":0,"value":"Você tem "},{"type":1,"value":"count"},{"type":0,"value":" senhas de app, o máximo permitido aqui. Revogue as que não usa mais para adicionar outra."}],
    "appPasswords.nearLimit": [{"type":0,"value":"Você tem "},{"type":1,"value":"count"},{"type":0,"value":" de "},{"type":1,"value":"limit"},{"type":0,"value":" senhas de app. Revogue as que não usa mais."}],
    "appPasswords.count": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" dispositivo tem senha de app."}]},"other":{"value":[{"type":7},{"type":0,"value":" dispositivos têm senha de app."}]}},"offset":0,"pluralType":"cardinal"}],
    "appPasswords.manage": "Gerenciar senhas de app",
    "mail.apps.deviceName": "Nome do dispositivo",
    "mail.apps.appName": "Nome do app",
    "mail.apps.profileNote": "Um perfil por dispositivo: configurar um celular não desconecta o seu Mac.",
    "data.export.title": "Exportar seus dados",
    "data.export.body": "Um arquivo .zip com seu perfil, as mensagens que você escreveu, a lista de arquivos que você enviou e as páginas que você criou, de todos os workspaces em que você está, em JSON e Markdown.",
    "data.export.action": "Exportar meus dados",
    "data.export.readyTitle": "Sua exportação está pronta",
    "data.export.readyMeta": [{"type":0,"value":"Criada em "},{"type":1,"value":"time"},{"type":0,"value":" · "},{"type":1,"value":"size"}],
    "data.export.download": "Baixar",
    "data.export.refreshLink": "Gerar novo link",
    "data.export.nextAt": [{"type":0,"value":"Você pode pedir outra exportação depois das "},{"type":1,"value":"time"},{"type":0,"value":"."}],
    "data.export.kept": "As exportações ficam guardadas por um dia. O link de download vale por uma hora; volte aqui para gerar outro.",
    "data.export.ready": "Sua exportação está pronta para baixar.",
    "data.export.tooSoon": "Você pode pedir uma exportação a cada 10 minutos.",
    "data.export.failed": "Não foi possível criar a exportação. Tente de novo.",
    "data.workspace.title": [{"type":0,"value":"Exportar "},{"type":1,"value":"name"}],
    "data.workspace.body": "Membros, canais públicos e suas mensagens em JSON, e páginas compartilhadas com todo o workspace em Markdown. Canais privados, mensagens diretas e páginas privadas não entram.",
    "data.workspace.action": "Exportar workspace",
    "data.delete.body": "Para excluir sua conta e remover seu perfil de todos os workspaces, vá para Conta.",
    "data.delete.action": "Ir para Conta",
    "account.delete.title": "Excluir conta",
    "account.delete.body": "Excluir sua conta remove seu perfil de todos os espaços e encerra suas sessões. Suas mensagens e páginas continuam lá, como de um usuário excluído. Não é possível desfazer.",
    "account.delete.action": "Excluir minha conta",
    "account.delete.blocked": "Transfira a propriedade destes espaços antes:",
    "account.delete.blockedPrimary": [{"type":1,"value":"name"},{"type":0,"value":": você é o proprietário principal"}],
    "account.delete.blockedLast": [{"type":1,"value":"name"},{"type":0,"value":": você é o único proprietário"}],
    "account.delete.confirmTitle": "Excluir sua conta?",
    "account.delete.typeEmail": [{"type":0,"value":"Digite "},{"type":1,"value":"email"},{"type":0,"value":" para confirmar"}],
    "account.delete.confirm": "Excluir conta",
    "account.delete.failed": "Não foi possível excluir sua conta. Tente novamente.",
    "account.delete.mismatch": "Isso não corresponde ao seu e-mail.",
    "account.delete.ownership": "Transfira a propriedade dos seus espaços antes.",
    "signInMethods.title": "Formas de entrar",
    "signInMethods.body": "Como você pode entrar nesta conta. Mantenha pelo menos uma.",
    "signInMethods.apple": "Apple",
    "signInMethods.google": "Google",
    "signInMethods.email": "Código por email",
    "signInMethods.privateRelay": "Endereço do Ocultar Meu Email da Apple",
    "signInMethods.noEmail": "Nenhum email compartilhado",
    "signInMethods.onlyMethod": "Sua única forma de entrar",
    "signInMethods.remove": "Remover",
    "signInMethods.remove.apple": "Remover o login com a Apple?",
    "signInMethods.remove.google": "Remover o login com o Google?",
    "signInMethods.remove.body": "Você não vai mais conseguir entrar com ele. Dá para vincular de novo depois.",
    "signInMethods.removed.apple": "O login com a Apple foi removido.",
    "signInMethods.removed.google": "O login com o Google foi removido.",
    "signInMethods.linked.apple": "A Apple foi vinculada. Agora você pode entrar com ela.",
    "signInMethods.linked.google": "O Google foi vinculado. Agora você pode entrar com ele.",
    "signInMethods.addTitle": "Vincular outra forma de entrar",
    "signInMethods.addEmail": "Adicionar login por email",
    "signInMethods.addEmail.body": "Vamos enviar um código de 6 dígitos para este endereço. Depois de confirmado, ele vira o email da sua conta e você pode entrar com códigos enviados para ele.",
    "signInMethods.addEmail.send": "Enviar código",
    "signInMethods.addEmail.codeBody": [{"type":0,"value":"Digite o código que enviamos para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "signInMethods.addEmail.verify": "Confirmar",
    "signInMethods.emailAdded": [{"type":0,"value":"Agora você pode entrar com códigos enviados para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "signInMethods.usePhoto": "Usar foto do Google",
    "signInMethods.photoUsed": "Sua foto do Google agora é sua foto de perfil.",
    "signInMethods.inBrowser": "Você vincula e remove formas de entrar no navegador, do mesmo jeito que entrou.",
    "signInMethods.manageInBrowser": "Gerenciar no navegador",
    "signInMethods.loadFailed": "Não foi possível carregar suas formas de entrar.",
    "signInMethods.error.otherAccount": "Essa conta já é usada por outra conta do Bundle. Não é possível juntar duas contas: entre com aquela, ou remova a forma de entrar por lá primeiro.",
    "signInMethods.error.alreadyLinked": "Essa conta já está vinculada aqui.",
    "signInMethods.error.lastMethod": "Mantenha pelo menos uma forma de entrar.",
    "signInMethods.error.signInAgain": "Por segurança, saia e entre de novo, depois tente outra vez.",
    "signInMethods.error.emailInUse": "Esse email pertence a outra conta do Bundle.",
    "signInMethods.error.cancelled": "A vinculação foi cancelada.",
    "signInMethods.error.failed": "Algo deu errado. Tente de novo.",
    "auth.passkey.signIn": "Entrar com uma chave de acesso",
    "auth.password.use": "Usar uma senha",
    "auth.password.title": "Digite sua senha",
    "auth.password.label": "Senha",
    "auth.password.show": "Mostrar senha",
    "auth.password.hide": "Ocultar senha",
    "auth.password.forgot": "Esqueceu a senha?",
    "auth.password.useCode": "Receber um código por e-mail",
    "auth.error.wrongPassword": "Esse e-mail e essa senha não conferem. Tente de novo ou redefina sua senha.",
    "auth.error.locked": [{"type":0,"value":"Muitas tentativas. Tente de novo em "},{"type":1,"value":"minutes"},{"type":0,"value":" minutos."}],
    "auth.password.lockedHint": "Você ainda pode entrar com um código enviado por e-mail.",
    "auth.twoStep.title": "Verificação em duas etapas",
    "auth.twoStep.body": "Digite o código de 6 dígitos do seu app autenticador.",
    "auth.twoStep.codeLabel": "Código de autenticação",
    "auth.twoStep.digit": [{"type":0,"value":"Dígito "},{"type":1,"value":"n"},{"type":0,"value":" de 6"}],
    "auth.twoStep.trust": "Confiar neste dispositivo por 30 dias",
    "auth.twoStep.trustHint": "Deixe desmarcado em dispositivos compartilhados.",
    "auth.twoStep.submit": "Verificar",
    "auth.twoStep.verifying": "Verificando…",
    "auth.twoStep.useBackup": "Usar um código de backup",
    "auth.twoStep.useApp": "Usar o app autenticador",
    "auth.twoStep.backupTitle": "Digite um código de backup",
    "auth.twoStep.backupBody": "Use um dos códigos de backup que você salvou ao ativar a verificação em duas etapas. Cada código funciona uma vez.",
    "auth.twoStep.backupLabel": "Código de backup",
    "auth.twoStep.lostAccess": "Não consegue usar nenhum? Peça a um admin do workspace para redefinir a verificação em duas etapas.",
    "auth.error.twoStepCode": "Esse código está incorreto. Confira seu app autenticador e tente de novo.",
    "auth.error.backupCode": "Esse código de backup está incorreto ou já foi usado.",
    "auth.reset.title": "Redefinir sua senha",
    "auth.reset.codeLabel": "Código de redefinição",
    "auth.reset.back": "Voltar para o login",
    "auth.reset.newTitle": "Escolha uma nova senha",
    "auth.reset.for": [{"type":0,"value":"Para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "auth.reset.newLabel": "Nova senha",
    "auth.reset.hint.length": "Pelo menos 8 caracteres",
    "auth.reset.hint.common": "Não é uma senha comum ou vazada",
    "auth.reset.hint.email": "Não contém seu e-mail",
    "auth.reset.strength": [{"type":0,"value":"Força: "},{"type":1,"value":"level"}],
    "auth.reset.strength.weak": "Fraca",
    "auth.reset.strength.fair": "Razoável",
    "auth.reset.strength.strong": "Forte",
    "auth.reset.signOutOthers": "Sair dos outros dispositivos",
    "auth.reset.signOutHint": "Recomendado se outra pessoa puder saber sua senha antiga.",
    "auth.reset.save": "Alterar senha",
    "auth.reset.doneTitle": "Senha alterada",
    "auth.reset.doneBody": [{"type":0,"value":"Você está conectado. Encerramos suas outras sessões e avisamos "},{"type":1,"value":"email"},{"type":0,"value":" por e-mail."}],
    "auth.reset.doneBodyKept": [{"type":0,"value":"Você está conectado. Avisamos "},{"type":1,"value":"email"},{"type":0,"value":" por e-mail."}],
    "auth.reset.done": "Continuar para o Bundle",
    "auth.error.passwordShort": "Use pelo menos 8 caracteres.",
    "auth.error.passwordCommon": "Essa senha é muito comum. Escolha outra.",
    "auth.error.passwordEmail": "Não use seu endereço de e-mail na senha.",
    "auth.error.passwordLeaked": "Essa senha apareceu em um vazamento de dados. Escolha outra.",
    "auth.error.passwordLong": "Use no máximo 128 caracteres.",
    "auth.passkey.waiting": "Aguardando sua chave de acesso…",
    "auth.passkey.waitingBody": "Siga as instruções do navegador ou do dispositivo.",
    "auth.passkey.cancelledTitle": "O login com chave de acesso não foi concluído",
    "auth.error.passkeyCancelled": "A janela da chave de acesso foi fechada. Tente de novo ou entre de outro jeito.",
    "auth.passkey.notFoundTitle": "Nenhuma chave de acesso do Bundle aqui",
    "auth.signup.title": "Crie sua conta no Bundle",
    "auth.signup.name": "Nome completo",
    "auth.signup.email": "E-mail de trabalho",
    "auth.signup.have": "Já tem uma conta?",
    "auth.signup.signIn": "Entrar",
    "auth.signup.newTo": "Novo no Bundle?",
    "auth.signup.create": "Criar uma conta",
    "auth.signup.codeLabel": "Código",
    "auth.signup.codeSentTo": [{"type":0,"value":"Enviamos um código de 6 dígitos para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "auth.signup.resend": "Reenviar código",
    "auth.signup.secureTitle": "Proteja sua conta",
    "auth.signup.secureBody": "Opcional. Você sempre pode entrar com um código por e-mail.",
    "auth.signup.addPasskey": "Adicionar uma chave de acesso",
    "auth.signup.recommended": "Recomendado",
    "auth.signup.passkeyBody": "Entre com Face ID, Touch ID ou o PIN do dispositivo.",
    "auth.signup.setPassword": "Definir uma senha",
    "auth.signup.passwordBody": "Pelo menos 8 caracteres.",
    "auth.signup.skip": "Pular por enquanto",
    "auth.signup.existsTitle": "Você já tem uma conta",
    "auth.signup.existsBody": [{"type":1,"value":"email"},{"type":0,"value":" já está cadastrado no Bundle."}],
    "auth.signup.signInInstead": "Entrar na conta",
    "auth.error.passkeyNotFound": "Use um celular ou chave de segurança que tenha uma, ou entre de outro jeito. Você pode adicionar uma chave de acesso nas Configurações depois de entrar.",
    "security.emails.title": "Endereços de e-mail",
    "security.emails.add": "Adicionar e-mail",
    "security.emails.foot": "Um endereço novo recebe um código antes de poder ser usado.",
    "security.emails.primary": "Principal",
    "security.emails.verified": "Verificado",
    "security.emails.pending": "Aguardando código",
    "security.emails.primaryHint": "E-mails de login e da conta vão para cá",
    "security.emails.secondaryHint": "Também pode entrar",
    "security.emails.makePrimary": "Tornar principal",
    "security.emails.enterCode": "Digitar código",
    "security.emails.remove": "Remover",
    "security.emails.addBody": "Vamos enviar um código de 6 dígitos para o novo endereço. Depois de verificado, você pode entrar com ele.",
    "security.emails.removeConfirm": [{"type":0,"value":"Remover "},{"type":1,"value":"email"},{"type":0,"value":"?"}],
    "security.emails.removeBody": "Você não poderá mais entrar com este endereço.",
    "security.password.title": "Senha",
    "security.password.set": "Definir senha",
    "security.password.change": "Alterar senha",
    "security.password.remove": "Remover senha",
    "security.password.none": "Não definida. Você entra com códigos ou outro método.",
    "security.password.isSet": "Definida",
    "security.password.current": "Senha atual",
    "security.password.removeBody": "Digite sua senha para removê-la. Você ainda pode entrar de outras formas.",
    "security.passkeys.title": "Chaves de acesso",
    "security.passkeys.body": "Entre com Face ID ou Touch ID",
    "security.passkeys.add": "Adicionar chave de acesso",
    "security.passkeys.rename": "Renomear",
    "security.passkeys.delete": "Excluir",
    "security.passkeys.unnamed": "Chave de acesso",
    "security.passkeys.lastUsed": [{"type":0,"value":"Usada pela última vez "},{"type":1,"value":"time"}],
    "security.passkeys.added": [{"type":0,"value":"Adicionada "},{"type":1,"value":"time"},{"type":0,"value":", ainda não usada"}],
    "security.passkeys.deleteConfirm": "Excluir esta chave de acesso?",
    "security.passkeys.deleteBody": "Você não poderá mais entrar com ela.",
    "security.passkeys.name": "Nome",
    "security.passkeys.cancelled": "A adição da chave de acesso foi cancelada.",
    "security.twoStep.title": "Verificação em duas etapas",
    "security.twoStep.off": "Desativada",
    "security.twoStep.on": "Ativada",
    "security.twoStep.app": "App autenticador",
    "security.twoStep.turnOn": "Ativar",
    "security.twoStep.setupTitle": "Configure seu app autenticador",
    "security.twoStep.setupBody": "Adicione o Bundle a um app autenticador, como Senhas, 1Password ou Google Authenticator, e digite o código de 6 dígitos que ele mostrar.",
    "security.twoStep.openApp": "Abrir app autenticador",
    "security.twoStep.copyKey": "Copiar chave de configuração",
    "security.twoStep.keyCopied": "Chave de configuração copiada",
    "security.twoStep.key": "Chave de configuração",
    "security.twoStep.backupTitle": "Guarde seus códigos de backup",
    "security.twoStep.backupBody": "Se não puder usar seu app autenticador, cada código permite entrar uma vez. Eles não serão mostrados de novo.",
    "security.twoStep.copyCodes": "Copiar códigos",
    "security.twoStep.codesCopied": "Códigos de backup copiados",
    "security.twoStep.shareCodes": "Compartilhar",
    "security.twoStep.done": "Concluir",
    "security.twoStep.remaining": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" código de backup restante"}]},"other":{"value":[{"type":7},{"type":0,"value":" códigos de backup restantes"}]}},"offset":0,"pluralType":"cardinal"}],
    "security.twoStep.regenerate": "Gerar novos códigos de backup",
    "security.twoStep.regenerateBody": "Seus códigos de backup antigos deixarão de funcionar.",
    "security.twoStep.turnOff": "Desativar verificação em duas etapas",
    "security.twoStep.turnOffBody": "Para entrar, bastará sua senha, um código por e-mail ou uma conta vinculada.",
    "security.stepUp.title": "Confirme que é você",
    "security.stepUp.passwordBody": "Digite sua senha para continuar.",
    "security.stepUp.codeBody": [{"type":0,"value":"Digite o código que enviamos para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "security.stepUp.code": "Código",
    "security.sessions.activityAt": [{"type":1,"value":"city"},{"type":0,"value":" · Ativo "},{"type":1,"value":"active"}],
    "security.error.wrongPassword": "Essa senha está incorreta.",
    "security.twoStep.turnedOn": "A verificação em duas etapas está ativada.",
    "security.emails.codeTitle": "Digite o código",
    "security.passkeys.unavailable": "As chaves de acesso não estão disponíveis neste dispositivo agora.",
    "workspace.settings.general": "Geral",
    "workspace.settings.name": "Nome do espaço de trabalho",
    "workspace.settings.nameRequired": "Informe um nome.",
    "workspace.settings.slug": "URL",
    "workspace.settings.slugHint": "Letras minúsculas, números e hifens.",
    "workspace.settings.slugWarning": [{"type":0,"value":"Links que usam /"},{"type":1,"value":"slug"},{"type":0,"value":" deixam de funcionar depois da alteração."}],
    "workspace.settings.slugInvalid": "Use até 32 letras minúsculas, números e hifens simples.",
    "workspace.settings.slugReserved": "Esse endereço é reservado.",
    "workspace.settings.slugTaken": "Esse endereço já está em uso.",
    "workspace.settings.icon": "Ícone",
    "workspace.settings.icon.upload": "Enviar ícone",
    "workspace.settings.icon.remove": "Remover ícone",
    "workspace.settings.icon.cropTitle": "Recortar o ícone",
    "workspace.settings.defaultLanguage": "Idioma padrão",
    "workspace.settings.defaultLanguageHint": "Para novos membros e e-mails a quem não escolheu um idioma.",
    "workspace.settings.primaryOwnerHint": [{"type":1,"value":"name"},{"type":0,"value":" é o proprietário principal. Transfira a propriedade principal pela lista de Membros."}],
    "workspace.settings.domains": "Entrada por domínio de e-mail",
    "workspace.settings.domainsHint": "Qualquer pessoa com um e-mail verificado nesses domínios pode entrar como membro, sem convite.",
    "workspace.settings.domainsEmpty": "Nenhum domínio ainda: as pessoas precisam de um convite para entrar.",
    "workspace.settings.domainsReadOnly": "Só proprietários e administradores podem mudar isso.",
    "workspace.settings.domainLabel": "Domínio",
    "workspace.settings.domainPlaceholder": "empresa.com.br",
    "workspace.settings.domainAdd": "Adicionar domínio",
    "workspace.settings.domainRemove": [{"type":0,"value":"Remover "},{"type":1,"value":"domain"}],
    "workspace.settings.domainInvalid": "Digite um nome de domínio, como empresa.com.br.",
    "workspace.settings.domainPublic": [{"type":1,"value":"domain"},{"type":0,"value":" é um provedor de e-mail público: qualquer pessoa pode criar um endereço lá."}],
    "workspace.settings.domainDuplicate": "Esse domínio já está na lista.",
    "workspace.settings.domainLimit": [{"type":0,"value":"Um espaço de trabalho pode permitir até "},{"type":1,"value":"count"},{"type":0,"value":" domínios."}],
    "workspace.settings.danger": "Zona de perigo",
    "workspace.settings.delete": "Excluir espaço de trabalho",
    "workspace.settings.deleteBody": "Só o proprietário principal pode excluir o espaço. Em breve.",
    "members.search": "Buscar pessoas",
    "members.filter.all": "Todos",
    "members.filter.active": "Ativos",
    "members.filter.invited": "Pendentes",
    "members.filter.deactivated": "Desativados",
    "members.filter.admins": "Proprietários e admins",
    "members.filter.guests": "Convidados",
    "members.filter.agents": "Agentes",
    "members.kind.human": "Pessoa",
    "members.kind.agent": "Agente",
    "members.status.active": "Ativo",
    "members.status.deactivated": "Desativado",
    "members.status.invited": "Convite pendente",
    "members.you": "(você)",
    "members.empty": "Ninguém encontrado.",
    "members.actions": [{"type":0,"value":"Ações para "},{"type":1,"value":"name"}],
    "members.role.change": [{"type":0,"value":"Função de "},{"type":1,"value":"name"}],
    "members.action.deactivate": "Desativar",
    "members.action.reactivate": "Reativar",
    "members.action.editScope": "Editar acesso",
    "members.action.transfer": "Tornar proprietário principal",
    "members.action.revoke": "Revogar convite",
    "members.action.resend": "Reenviar convite",
    "members.confirm.go": "Confirmar",
    "members.confirm.deactivate.title": [{"type":0,"value":"Desativar "},{"type":1,"value":"name"},{"type":0,"value":"?"}],
    "members.confirm.deactivate.body": "A pessoa sai deste espaço e não pode voltar até ser reativada. As mensagens e páginas dela continuam.",
    "members.confirm.role.title": [{"type":0,"value":"Alterar a função de "},{"type":1,"value":"name"},{"type":0,"value":" para "},{"type":1,"value":"role"},{"type":0,"value":"?"}],
    "members.confirm.role.owner": "Proprietários gerenciam todos, inclusive outros proprietários, e todas as configurações do espaço.",
    "members.confirm.role.clearsRestriction": [{"type":1,"value":"name"},{"type":0,"value":" passará a ver todos os canais públicos e o diretório inteiro: as restrições de convidado serão removidas."}],
    "members.confirm.transfer.title": [{"type":0,"value":"Tornar "},{"type":1,"value":"name"},{"type":0,"value":" o proprietário principal?"}],
    "members.confirm.transfer.body": "A pessoa se torna proprietária e a única que pode transferir a propriedade principal ou excluir o espaço. Você continua proprietário.",
    "members.confirm.revoke.title": [{"type":0,"value":"Revogar o convite para "},{"type":1,"value":"email"},{"type":0,"value":"?"}],
    "members.confirm.revokeLink.title": "Revogar este link de convite?",
    "members.confirm.revoke.body": "Ele deixa de funcionar na hora.",
    "members.notice.deactivated": [{"type":1,"value":"name"},{"type":0,"value":" foi desativado(a)."}],
    "members.notice.reactivated": [{"type":1,"value":"name"},{"type":0,"value":" foi reativado(a)."}],
    "members.notice.transferred": [{"type":1,"value":"name"},{"type":0,"value":" agora é o proprietário principal."}],
    "members.notice.scopeSaved": [{"type":0,"value":"Acesso de "},{"type":1,"value":"name"},{"type":0,"value":" atualizado."}],
    "members.notice.revoked": "Convite revogado.",
    "members.notice.resent": "Convite reenviado.",
    "members.notice.newLink": "Um novo link de convite foi criado.",
    "members.notice.failed": "Não funcionou. Tente novamente.",
    "members.sponsor": [{"type":0,"value":"Responsável: "},{"type":1,"value":"name"}],
    "members.accessEnds": [{"type":0,"value":"Acesso termina em "},{"type":1,"value":"date"}],
    "members.accessEnded": "Acesso encerrado",
    "members.noEnd": "Sem data de término",
    "invites.pending": "Convites pendentes",
    "invites.none": "Nenhum convite pendente.",
    "invites.link": "Link de convite",
    "invites.uses": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Usado uma vez"}]},"other":{"value":[{"type":0,"value":"Usado "},{"type":7},{"type":0,"value":" vezes"}]}},"offset":0,"pluralType":"cardinal"}],
    "invites.expires": [{"type":0,"value":"Expira em "},{"type":1,"value":"date"}],
    "invites.onlyYours": "Você vê os convites que criou.",
    "guests.title": "Convidados",
    "guests.none": "Nenhum convidado.",
    "guests.agentsNone": "Nenhum agente.",
    "scope.title": [{"type":0,"value":"Acesso de "},{"type":1,"value":"name"}],
    "scope.makeGuestTitle": [{"type":0,"value":"Tornar "},{"type":1,"value":"name"},{"type":0,"value":" convidado(a)"}],
    "scope.makeGuestBody": "Convidados veem só os canais em que estão e as pessoas que estão neles.",
    "scope.sponsor": "Responsável",
    "scope.organization": "Organização (opcional)",
    "scope.expiry": "Acesso termina",
    "scope.expiry.keep": [{"type":0,"value":"Manter ("},{"type":1,"value":"date"},{"type":0,"value":")"}],
    "scope.expiry.never": "Nunca",
    "scope.expiry.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Em "},{"type":7},{"type":0,"value":" dia"}]},"other":{"value":[{"type":0,"value":"Em "},{"type":7},{"type":0,"value":" dias"}]}},"offset":0,"pluralType":"cardinal"}],
    "scope.can": "Pode",
    "scope.can.createChannels": "Criar canais",
    "scope.can.invite": "Convidar pessoas",
    "scope.can.search": "Buscar",
    "scope.can.downloadFiles": "Baixar arquivos",
    "scope.can.joinHuddles": "Participar de reuniões",
    "scope.can.mentionBroadcast": "Usar @here e @channel",
    "scope.can.seeEmails": "Ver endereços de e-mail",
    "scope.dm": "Mensagens diretas com",
    "scope.dm.anyone": "Qualquer pessoa",
    "scope.dm.sharedChannels": "Pessoas em canais em comum",
    "scope.dm.sponsorOnly": "Só o responsável",
    "scope.dm.none": "Ninguém",
    "scope.directory": "Pode ver",
    "scope.directory.all": "Todos do diretório",
    "scope.directory.shared": "Pessoas em canais em comum",
    "scope.save": "Salvar acesso",
    "scope.makeGuest": "Tornar convidado",
    "profileCard.message": "Mensagem",
    "profileCard.localTime": [{"type":1,"value":"time"},{"type":0,"value":" no horário local"}],
    "profileCard.editProfile": "Editar perfil",
    "profileCard.title": [{"type":0,"value":"Perfil de "},{"type":1,"value":"name"}],
    "members.notice.nowOwner": [{"type":1,"value":"name"},{"type":0,"value":" agora é proprietário(a)."}],
    "members.notice.nowAdmin": [{"type":1,"value":"name"},{"type":0,"value":" agora é administrador(a)."}],
    "members.notice.nowMember": [{"type":1,"value":"name"},{"type":0,"value":" agora é membro."}],
    "members.notice.nowGuest": [{"type":1,"value":"name"},{"type":0,"value":" agora é convidado(a)."}],
    "handle.problem.tooShort": "Use pelo menos 2 caracteres.",
    "handle.problem.tooLong": "Use no máximo 32 caracteres.",
    "handle.problem.characters": "Use letras minúsculas, números, pontos, hifens e sublinhados.",
    "handle.problem.edges": "Comece e termine com uma letra ou número.",
    "handle.problem.reserved": "Esse nome de usuário é reservado.",
    "handle.problem.taken": "Esse nome de usuário já está em uso.",
    "profile.handle": "Nome de usuário",
    "profile.handle.hint": [{"type":0,"value":"As pessoas podem mencionar você como @"},{"type":1,"value":"handle"},{"type":0,"value":"."}],
    "profile.handle.checking": "Verificando…",
    "profile.handle.available": [{"type":0,"value":"@"},{"type":1,"value":"handle"},{"type":0,"value":" está disponível."}],
    "profile.handle.try": "Tente:",
    "profile.avatar.change": "Trocar avatar",
    "profile.avatar.title": "Avatar",
    "profile.avatar.photo": "Foto",
    "profile.avatar.initials": "Iniciais",
    "profile.avatar.emoji": "Emoji",
    "profile.avatar.color": "Cor",
    "profile.avatar.colorOption": [{"type":0,"value":"Cor "},{"type":1,"value":"n"}],
    "profile.avatar.pickEmoji": "Escolher um emoji",
    "profile.avatar.use": "Usar este avatar",
    "profile.avatar.saved": "Avatar atualizado",
    "profile.copyLink": "Copiar link do perfil",
    "profile.linkCopied": "Link do perfil copiado",
    "sharing.share": "Compartilhar",
    "sharing.dialog.title": "Compartilhar",
    "sharing.level.full": "Acesso total",
    "sharing.level.edit": "Pode editar",
    "sharing.level.comment": "Pode comentar",
    "sharing.level.view": "Pode ver",
    "sharing.level.full.description": "Editar, compartilhar e publicar",
    "sharing.level.edit.description": "Editar o conteúdo e convidar outras pessoas para editar ou ver",
    "sharing.level.comment.description": "Por enquanto só ver; comentários em breve",
    "sharing.level.view.description": "Somente leitura",
    "sharing.general.title": "Acesso geral",
    "sharing.general.invitedOnly": "Só pessoas convidadas",
    "sharing.general.everyone": [{"type":0,"value":"Todos em "},{"type":1,"value":"workspace"}],
    "sharing.general.noAccess": "Sem acesso",
    "sharing.general.invitedOnly.description": "Só as pessoas listadas acima podem abrir esta página",
    "sharing.general.everyone.description": [{"type":0,"value":"Qualquer pessoa em "},{"type":1,"value":"workspace"},{"type":0,"value":" pode encontrar e abrir esta página"}],
    "sharing.general.privateShared": "Continua na seção Particular de quem a criou. Os demais a encontram em “Compartilhadas comigo”.",
    "sharing.source.owner": "Proprietário do workspace",
    "sharing.source.admin": "Admin do workspace",
    "sharing.source.creator": "Dono da página",
    "sharing.source.inherited": [{"type":0,"value":"Herdado de "},{"type":1,"value":"page"}],
    "sharing.source.inheritedUntitled": "Herdado de uma página sem título",
    "sharing.publish.off": "A publicação na web está desativada neste workspace",
    "sharing.publish.adminsOnly": "Neste workspace, só admins podem publicar na web",
    "sharing.indicator.public": "Publicada",
    "sharing.indicator.workspace": "Workspace",
    "sharing.indicator.private": "Privada",
    "sharing.indicator.sharedWith": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Compartilhada com "},{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":0,"value":"Compartilhada com "},{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "sharing.expiry.never": "Não expira",
    "sharing.expiry.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Expira em "},{"type":7},{"type":0,"value":" dia"}]},"other":{"value":[{"type":0,"value":"Expira em "},{"type":7},{"type":0,"value":" dias"}]}},"offset":0,"pluralType":"cardinal"}],
    "sharing.expiry.on": [{"type":0,"value":"Expira em "},{"type":1,"value":"date"}],
    "sharing.invite.placeholder": "Adicionar pessoas, agentes ou e-mails",
    "sharing.invite.button": "Convidar",
    "sharing.invite.asGuest": "Convidar como convidado",
    "sharing.invite.guestNote": [{"type":1,"value":"email"},{"type":0,"value":" não está neste workspace. Vai entrar como convidado e só verá esta página e as subpáginas."}],
    "sharing.invite.guestExpiry": "Acesso do convidado",
    "sharing.invite.hasAccess": "Já tem acesso",
    "sharing.invite.noMatches": "Ninguém encontrado. Digite um e-mail para convidar alguém de fora.",
    "sharing.invite.sent": "Convite enviado",
    "sharing.invite.guestLink": "Link de convite copiado",
    "sharing.people.title": "Pessoas com acesso",
    "sharing.people.you": [{"type":1,"value":"name"},{"type":0,"value":" (você)"}],
    "sharing.people.guest": "Convidado",
    "sharing.people.agent": "Agente",
    "sharing.people.remove": "Remover",
    "sharing.people.change": [{"type":0,"value":"Alterar o acesso de "},{"type":1,"value":"name"}],
    "sharing.comment.note": "Comentários em breve: por enquanto, quem pode comentar consegue só ver a página.",
    "sharing.publish.title": "Publicar na web",
    "sharing.publish.description": "Qualquer pessoa com o link pode ver esta página. Ela não vê comentários, outras páginas nem pessoas.",
    "sharing.publish.toggle": "Publicar na web",
    "sharing.publish.link": "Link público",
    "sharing.publish.copy": "Copiar link público",
    "sharing.publish.open": "Abrir a página pública",
    "sharing.publish.indexing": "Permitir mecanismos de busca",
    "sharing.publish.duplicate": "Permitir duplicar como modelo",
    "sharing.publish.subpages": "Incluir subpáginas",
    "sharing.publish.expiry": "Validade do link",
    "sharing.publish.revokeNote": "Desativar a publicação revoga este link de vez.",
    "sharing.publish.needsFull": "Você precisa de acesso total para publicar esta página",
    "sharing.copyLink": "Copiar link",
    "sharing.copied": "Link copiado",
    "sharing.error.lastFullAccess": "Alguém precisa manter o acesso total a esta página.",
    "sharing.error.generic": "Não foi possível atualizar o compartilhamento. Verifique sua conexão e tente de novo.",
    "sharing.error.alreadyMember": "Essa pessoa já está neste workspace.",
    "sharing.loading": "Carregando o compartilhamento…",
    "sharing.settings.title": "Compartilhamento",
    "sharing.settings.description": "Quem pode publicar páginas e arquivos fora do workspace.",
    "sharing.settings.publicPages": "Publicar páginas na web",
    "sharing.settings.publicFiles": "Links públicos de arquivos",
    "sharing.settings.editorsCanShare": "Quem pode editar também pode convidar outras pessoas",
    "sharing.settings.policy.members": "Membros",
    "sharing.settings.policy.admins": "Só admins",
    "sharing.settings.policy.off": "Desativado",
    "sharing.settings.offNote": "Desativar também interrompe na hora todos os links públicos existentes.",
    "sharing.settings.saved": "Configurações de compartilhamento salvas",
    "sharing.settings.publicFilesHint": "As pessoas podem compartilhar arquivos e pastas com qualquer pessoa que tenha o link. Convidados nunca podem.",
    "sharing.settings.filesOff.title": "Desativar links públicos de arquivos?",
    "sharing.settings.filesOff.body": "Todos os links públicos de arquivos param de funcionar na hora. Eles voltam a funcionar se você reativar.",
    "sharing.settings.filesOff.confirm": "Desativar",
    "sharing.settings.publicFilesActive": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" link público ativo agora."}]},"other":{"value":[{"type":7},{"type":0,"value":" links públicos ativos agora."}]}},"offset":0,"pluralType":"cardinal"}],
    "sharing.settings.filesOff.bodyCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" link para de funcionar na hora. Ele volta a funcionar se você reativar."}]},"other":{"value":[{"type":7},{"type":0,"value":" links param de funcionar na hora. Eles voltam a funcionar se você reativar."}]}},"offset":0,"pluralType":"cardinal"}],
    "page.menu.more": "Ações da página",
    "page.menu.copyLink": "Copiar link",
    "page.menu.moveTo": "Mover para…",
    "page.menu.lock": "Bloquear página",
    "page.menu.unlock": "Desbloquear página",
    "page.menu.export": "Exportar como Markdown",
    "page.menu.trash": "Mover para a lixeira",
    "page.favorite.add": "Adicionar aos favoritos",
    "page.favorite.remove": "Remover dos favoritos",
    "page.locked": "Bloqueada",
    "page.lockedNote": "Esta página está bloqueada. Desbloqueie pelo menu ··· para editar.",
    "page.moveTo.title": "Mover para",
    "page.moveTo.search": "Buscar páginas",
    "page.moveTo.workspace": "Workspace (nível superior)",
    "page.moveTo.private": "Privado (nível superior)",
    "docs.section.shared": "Compartilhadas comigo",
    "docs.badge.public": "Publicada na web",
    "docs.badge.shared": "Compartilhada com pessoas",
    "docs.badge.restricted": "Só pessoas convidadas",
    "publicPage.notFound.title": "Este link não funciona",
    "publicPage.notFound.body": "A página pode ter deixado de ser publicada, ou o link expirou.",
    "publicPage.footer": "Publicado com o Bundle",
    "publicPage.duplicate": "Duplicar como modelo",
    "publicPage.duplicateNote": "Entre no Bundle para duplicar esta página no seu workspace.",
    "publicPage.someone": "alguém",
    "publicPage.unavailableBlock": "Indisponível na página pública",
    "publicPage.rateLimited": "Muitas solicitações. Aguarde um minuto e tente de novo.",
    "publicDrive.signIn": "Entrar",
    "publicDrive.footer": "Compartilhado com o Bundle",
    "publicDrive.sharedBy": [{"type":0,"value":"Compartilhado por "},{"type":1,"value":"owner"}],
    "publicDrive.itemCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" item"}]},"other":{"value":[{"type":7},{"type":0,"value":" itens"}]}},"offset":0,"pluralType":"cardinal"}],
    "publicDrive.notFound.title": "Este link não está disponível",
    "publicDrive.notFound.body": "O dono pode ter parado de compartilhar, ou os links públicos foram desativados. Se você tem acesso, entre.",
    "publicDrive.empty": "Esta pasta está vazia",
    "publicDrive.path": "Caminho da pasta",
    "publicDrive.openInBundle": "Abrir no Bundle",
    "publicDrive.signInNeeded": "É preciso entrar",
    "publicDrive.downloadName": [{"type":0,"value":"Baixar "},{"type":1,"value":"name"}],
    "publicDrive.back": "Voltar para a pasta",
    "publicDrive.report.open": "Denunciar abuso",
    "publicDrive.report.title": "Denunciar abuso",
    "publicDrive.report.body": "Conte o que há de errado com este arquivo ou pasta. Os administradores do workspace e o Bundle analisam todas as denúncias. Não é preciso entrar.",
    "publicDrive.report.reason": "O que há de errado?",
    "publicDrive.report.reasonPlaceholder": "Escolha um motivo",
    "publicDrive.report.reason.spam": "Spam",
    "publicDrive.report.reason.malware": "Malware",
    "publicDrive.report.reason.phishing": "Phishing",
    "publicDrive.report.reason.sexual": "Conteúdo sexualmente explícito",
    "publicDrive.report.reason.violence": "Conteúdo violento ou explícito",
    "publicDrive.report.reason.hate": "Discurso de ódio",
    "publicDrive.report.reason.harassment": "Assédio ou bullying",
    "publicDrive.report.reason.copyright": "Violação de direitos autorais",
    "publicDrive.report.reason.personalInfo": "Informações pessoais ou confidenciais",
    "publicDrive.report.reason.other": "Outro motivo",
    "publicDrive.report.note": "Detalhes (opcional)",
    "publicDrive.report.notePlaceholder": "Qualquer coisa que ajude na análise",
    "publicDrive.report.submit": "Denunciar",
    "publicDrive.report.sent": "Obrigado por avisar. Vamos analisar este link e agir se ele violar as regras.",
    "publicDrive.report.done": "Concluir",
    "publicDrive.report.failed": "Não foi possível enviar a denúncia. Tente de novo.",
    "files.share": "Compartilhar",
    "files.share.title": "Compartilhar arquivo",
    "files.share.to": "Compartilhar em uma conversa",
    "files.share.pick": "Escolha um canal ou uma pessoa",
    "files.share.message": "Adicionar uma mensagem (opcional)",
    "files.share.send": "Compartilhar",
    "files.share.sent": [{"type":0,"value":"Compartilhado em "},{"type":1,"value":"name"}],
    "files.share.noDownload": "Você pode ver este arquivo, mas não baixá-lo, então não pode compartilhá-lo.",
    "files.share.publicLink": "Link público",
    "files.share.publicLink.description": "Qualquer pessoa com o link pode baixar este arquivo.",
    "files.share.publicLink.create": "Criar link público",
    "files.share.publicLink.revoke": "Revogar link",
    "files.share.publicLink.copy": "Copiar link público",
    "files.share.publicLink.adminsOnly": "Neste workspace, só admins podem criar links públicos de arquivos.",
    "files.share.publicLink.off": "Os links públicos de arquivos estão desativados neste workspace.",
    "files.share.access": "Quem pode acessar",
    "files.share.error": "Não foi possível compartilhar o arquivo. Verifique sua conexão e tente de novo.",
    "files.access.anyone": "Qualquer pessoa com o link",
    "files.access.anyoneHint": "Qualquer pessoa na internet com o link pode ver",
    "files.access.anyoneOff": "Seu administrador desativou os links públicos",
    "files.access.anyoneAdmins": "Só administradores podem compartilhar com qualquer pessoa com o link",
    "files.access.workspaceHint": "Qualquer pessoa neste workspace com o link",
    "files.access.anyoneMembers": [{"type":0,"value":"Membros de "},{"type":1,"value":"workspace"},{"type":0,"value":" que abrirem o link terão "},{"type":1,"value":"role"},{"type":0,"value":". As demais pessoas só podem ver e baixar."}],
    "files.openWith": "Abrir com…",
    "files.opening": [{"type":0,"value":"Abrindo “"},{"type":1,"value":"name"},{"type":0,"value":"”…"}],
    "files.noApp": [{"type":0,"value":"Nenhum app deste dispositivo abre “"},{"type":1,"value":"name"},{"type":0,"value":"”. Faça o download."}],
    "templates.title": "Modelos",
    "templates.open": "Modelos…",
    "templates.browse": "Ver modelos",
    "templates.newFromTemplate": "Novo a partir de modelo",
    "templates.search": "Buscar modelos",
    "templates.filter.all": "Todos os modelos",
    "templates.filter.saved": "Salvos",
    "templates.category.projects": "Projetos e trabalho",
    "templates.category.meetings": "Equipe e reuniões",
    "templates.category.knowledge": "Conhecimento",
    "templates.category.personal": "Pessoal",
    "templates.category.business": "Negócios",
    "templates.section.saved": "Modelos salvos",
    "templates.results": "Resultados",
    "templates.empty": [{"type":0,"value":"Nenhum modelo corresponde a “"},{"type":1,"value":"query"},{"type":0,"value":"”."}],
    "templates.use": "Usar modelo",
    "templates.destination": "Adicionar em",
    "templates.destination.workspace": "Workspace",
    "templates.destination.private": "Privado",
    "templates.destination.inside": [{"type":0,"value":"Dentro de “"},{"type":1,"value":"title"},{"type":0,"value":"”"}],
    "templates.startEmpty": "Começar vazio",
    "templates.startEmpty.hint": "Sem as linhas de exemplo.",
    "templates.scope.builtin": "Padrão",
    "templates.scope.workspace": "Modelo do workspace",
    "templates.scope.personal": "Só você",
    "templates.preview.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" linha de exemplo"}]},"other":{"value":[{"type":7},{"type":0,"value":" linhas de exemplo"}]}},"offset":0,"pluralType":"cardinal"}],
    "templates.preview.views": "Visões",
    "templates.preview.properties": "Propriedades",
    "templates.preview.rowTemplates": "Modelos de linha",
    "templates.preview.creates": "Cria",
    "templates.preview.none": "Selecione um modelo para visualizar.",
    "templates.edit": "Editar modelo",
    "templates.rename": "Renomear",
    "templates.delete": "Excluir modelo",
    "templates.delete.confirm": [{"type":0,"value":"Excluir “"},{"type":1,"value":"name"},{"type":0,"value":"”? As páginas já criadas a partir dele continuam."}],
    "templates.loadFailed": "Não foi possível carregar os modelos. Verifique sua conexão e tente de novo.",
    "templates.useFailed": "Não foi possível criar a página a partir deste modelo. Verifique sua conexão e tente de novo.",
    "templates.save.title": "Salvar como modelo",
    "templates.save.name": "Nome",
    "templates.save.description": "Descrição",
    "templates.save.category": "Categoria",
    "templates.save.scope": "Quem pode usar",
    "templates.save.scope.workspace": "Todos no workspace",
    "templates.save.scope.personal": "Só eu",
    "templates.save.includeRows": "Incluir as linhas dos bancos de dados",
    "templates.save.submit": "Salvar modelo",
    "templates.save.saved": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” foi salvo nos seus modelos."}],
    "templates.save.failed": "Não foi possível salvar o modelo. Verifique sua conexão e tente de novo.",
    "templates.save.workspaceAdminsOnly": "Só administradores podem salvar modelos do workspace aqui.",
    "templates.settings.creators": "Quem pode salvar modelos do workspace",
    "templates.settings.admins": "Só administradores",
    "templates.settings.members": "Todos os membros",
    "templates.editing.banner": [{"type":0,"value":"Você está editando o modelo “"},{"type":1,"value":"name"},{"type":0,"value":"”. As mudanças valem para as próximas páginas criadas a partir dele."}],
    "templates.editing.rowBanner": [{"type":0,"value":"Você está editando o modelo de linha “"},{"type":1,"value":"name"},{"type":0,"value":"”. As novas linhas criadas a partir dele começam assim."}],
    "templates.editing.readOnly": "Só quem criou e os administradores podem editar este modelo.",
    "templates.editing.done": "Concluir",
    "templates.duplicate": "Duplicar",
    "templates.duplicateFailed": "Não foi possível duplicar. Verifique sua conexão e tente de novo.",
    "templates.saveAs": "Salvar como modelo…",
    "templates.rowTemplates.menu": "Modelos de linha",
    "templates.rowTemplates.newOptions": "Nova linha a partir de um modelo",
    "templates.rowTemplates.empty": "Linha vazia",
    "templates.rowTemplates.new": "Novo modelo",
    "templates.rowTemplates.fromRow": "Salvar linha como modelo",
    "templates.rowTemplates.default": "Padrão",
    "templates.rowTemplates.setDefault": "Usar no Novo",
    "templates.rowTemplates.clearDefault": "Não usar mais no Novo",
    "templates.rowTemplates.edit": "Editar",
    "templates.rowTemplates.delete": "Excluir",
    "templates.rowTemplates.untitled": "Modelo sem título",
    "templates.rowTemplates.newName": "Novo modelo",
    "templates.rowTemplates.defaults": "Valores padrão",
    "templates.rowTemplates.defaults.hint": "Novas linhas criadas a partir deste modelo começam com estes valores.",
    "templates.rowTemplates.name": "Nome do modelo",
    "templates.rowTemplates.clear": "Limpar",
    "templates.rowTemplates.failed": "Não foi possível alterar os modelos de linha. Verifique sua conexão e tente de novo.",
    "legal.agreement": [{"type":0,"value":"Ao continuar, você concorda com os "},{"type":1,"value":"terms"},{"type":0,"value":" e a "},{"type":1,"value":"privacy"},{"type":0,"value":" do Bundle."}],
    "legal.terms": "Termos de Uso",
    "legal.privacy": "Política de Privacidade",
    "legal.title": "Jurídico",
    "summary.title": "Resumo",
    "summary.aiLabel": "Gerado por IA",
    "summary.updated.justNow": "atualizado agora",
    "summary.updated.minutes": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"atualizado há "},{"type":7},{"type":0,"value":" min"}]},"other":{"value":[{"type":0,"value":"atualizado há "},{"type":7},{"type":0,"value":" min"}]}},"offset":0,"pluralType":"cardinal"}],
    "summary.updated.hours": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"atualizado há "},{"type":7},{"type":0,"value":" hora"}]},"other":{"value":[{"type":0,"value":"atualizado há "},{"type":7},{"type":0,"value":" horas"}]}},"offset":0,"pluralType":"cardinal"}],
    "summary.updated.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"atualizado há "},{"type":7},{"type":0,"value":" dia"}]},"other":{"value":[{"type":0,"value":"atualizado há "},{"type":7},{"type":0,"value":" dias"}]}},"offset":0,"pluralType":"cardinal"}],
    "summary.empty": "Veja um resumo rápido desta conversa.",
    "summary.summarize": "Resumir",
    "summary.refresh": "Atualizar resumo",
    "summary.loading": "Resumindo…",
    "summary.failed": "Não foi possível resumir esta conversa. Tente de novo daqui a pouco.",
    "summary.stale": "Há respostas novas desde este resumo",
    "summary.collapse": "Ocultar resumo",
    "summary.expand": "Mostrar resumo",
    "workspace.settings.aiSummaries": "Resumos de conversas com IA",
    "workspace.settings.aiSummariesHint": "Mostra um resumo curto, escrito por IA, no topo das conversas. Para escrevê-lo, as mensagens da conversa são enviadas ao nosso provedor de modelos de IA; elas não são usadas para treinar modelos. Desligar também apaga os resumos já escritos.",
    "workspace.settings.unfurls": "Mostrar prévias de links",
    "workspace.settings.unfurlsHint": "Mostra uma prévia (título, descrição e imagem) sob mensagens com links. Para criá-la, o Bundle busca a página. Desligar também remove as prévias já mostradas.",
    "workspace.settings.mailSentWith": "Membros podem adicionar “Enviado com o Bundle” aos e-mails",
    "workspace.settings.mailSentWithHint": [{"type":0,"value":"Desligue para deixar de fora de todas as mensagens de "},{"type":1,"value":"workspace"},{"type":0,"value":". Os membros passam a ver a opção desligada, sem poder mudar."}],
    "settings.nav.import": "Importar",
    "import.title": "Importar do Slack ou do Notion",
    "import.body": "Traga suas conversas do Slack ou suas páginas e bancos de dados do Notion para este espaço de trabalho. Nada muda no Slack nem no Notion.",
    "import.source": "Importar de",
    "import.via": "Como",
    "import.via.file": "Arquivo de exportação",
    "import.via.token": "Conectar com um token",
    "import.slack.file.step1": "No Slack, abra Configurações do espaço de trabalho → Importar/exportar dados → Exportar.",
    "import.slack.file.step2": "Escolha o período (\"Todo o histórico\" para tudo) e inicie a exportação; o Slack avisa por email quando o .zip estiver pronto.",
    "import.slack.file.step3": "Solte o .zip aqui. Os planos Free e Pro exportam só canais públicos; conecte com um token para trazer também canais privados e mensagens diretas.",
    "import.slack.token.step1": "Crie o app \"Bundle import\" no seu espaço do Slack com o botão abaixo (as permissões são só de leitura).",
    "import.slack.token.step2": "Instale no espaço de trabalho e copie o User OAuth Token (começa com xoxp-).",
    "import.slack.token.step3": "Cole aqui. Tudo o que você vê no Slack vem junto: canais, canais privados e mensagens diretas, com conversas e arquivos.",
    "import.notion.file.step1": "No Notion, abra Configurações → Geral → Exportar todo o conteúdo do espaço de trabalho.",
    "import.notion.file.step2": "Escolha \"Markdown e CSV\", inclua subpáginas e arquivos e exporte.",
    "import.notion.file.step3": "Solte o .zip aqui. A IA sugere como organizar as páginas; você revisa antes de importar qualquer coisa.",
    "import.notion.token.step1": "Crie uma integração interna no Notion com \"Ler conteúdo\" (botão abaixo).",
    "import.notion.token.step2": "No Notion, compartilhe com ela as páginas a importar (••• → Conexões → sua integração).",
    "import.notion.token.step3": "Cole o segredo aqui. Assim os bancos de dados mantêm os tipos de propriedade.",
    "import.slack.token.createApp": "Criar o app no Slack",
    "import.notion.token.open": "Abrir integrações do Notion",
    "import.slack.token.label": "Token de usuário do Slack",
    "import.notion.token.label": "Segredo da integração do Notion",
    "import.token.kept": "Guardado só enquanto a importação roda; depois é apagado.",
    "import.connect": "Conectar",
    "import.drop.slack": "Solte a exportação do Slack (.zip) ou escolha o arquivo",
    "import.drop.notion": "Solte a exportação do Notion (.zip) ou escolha o arquivo",
    "import.drop.hint": "Até 1 GB",
    "import.uploading": [{"type":0,"value":"Enviando "},{"type":1,"value":"name"},{"type":0,"value":"…"}],
    "import.uploadProgress": "Progresso do envio",
    "import.cancel": "Cancelar",
    "import.recent": "Importações recentes",
    "import.recent.empty": "Nenhuma importação ainda.",
    "import.open": "Abrir",
    "import.status.scanning": "Lendo",
    "import.status.review": "Aguardando revisão",
    "import.status.importing": "Importando",
    "import.status.done": "Importado",
    "import.status.failed": "Falhou",
    "import.status.cancelled": "Cancelado",
    "import.phase.reading": "Lendo a exportação…",
    "import.phase.sorting": "Organizando as páginas com IA…",
    "import.phase.listing": "Listando arquivos…",
    "import.phase.channels": "Criando canais…",
    "import.phase.messages": "Importando mensagens…",
    "import.phase.files": "Copiando arquivos…",
    "import.phase.pages": "Importando páginas…",
    "import.phase.finishing": "Finalizando…",
    "import.job.slack": [{"type":0,"value":"Slack: "},{"type":1,"value":"label"}],
    "import.job.notion": [{"type":0,"value":"Notion: "},{"type":1,"value":"label"}],
    "import.back": "Voltar",
    "import.stop": "Parar importação",
    "import.running.note": "Você pode sair desta página: a importação continua no servidor.",
    "import.discard": "Descartar",
    "import.start": "Importar",
    "import.done.title": "Importação concluída",
    "import.done.body": "O histórico importado chega como lido e não notificou ninguém.",
    "import.failed.title": "A importação parou",
    "import.failed.body": "Algo deu errado. Tente de novo ou comece uma nova importação.",
    "import.cancelled": "Esta importação foi interrompida. O que já foi importado continua aqui.",
    "import.openPages": "Abrir as páginas importadas",
    "import.result.channels": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" canal"}]},"other":{"value":[{"type":7},{"type":0,"value":" canais"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.messages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" mensagem"}]},"other":{"value":[{"type":7},{"type":0,"value":" mensagens"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.files": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" arquivo"}]},"other":{"value":[{"type":7},{"type":0,"value":" arquivos"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.pages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" página"}]},"other":{"value":[{"type":7},{"type":0,"value":" páginas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.databases": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" banco de dados"}]},"other":{"value":[{"type":7},{"type":0,"value":" bancos de dados"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" linha"}]},"other":{"value":[{"type":7},{"type":0,"value":" linhas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.result.skipped": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" item ignorado"}]},"other":{"value":[{"type":7},{"type":0,"value":" itens ignorados"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.trash.button": "Mover para a lixeira",
    "import.trash.title": [{"type":0,"value":"Mover "},{"type":1,"value":"what"},{"type":0,"value":" para a lixeira?"}],
    "import.trash.and": [{"type":1,"value":"first"},{"type":0,"value":" e "},{"type":1,"value":"second"}],
    "import.trash.body": [{"type":0,"value":"Tudo o que esta importação criou e ainda está aqui: as linhas ("},{"type":1,"value":"rows"},{"type":0,"value":") e os arquivos anexados ("},{"type":1,"value":"files"},{"type":0,"value":") vão junto. Dá para restaurar pela Lixeira."}],
    "import.trash.kept": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" item editado por outra pessoa fica"}]},"other":{"value":[{"type":7},{"type":0,"value":" itens editados por outras pessoas ficam"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.trash.nothing": "Não sobrou nada criado por esta importação para mover para a lixeira.",
    "import.trash.failed": "Não foi possível mover a importação para a lixeira. Tente de novo.",
    "import.delete.button": "Excluir permanentemente",
    "import.delete.title": [{"type":0,"value":"Excluir "},{"type":1,"value":"what"},{"type":0,"value":" permanentemente?"}],
    "import.delete.body": [{"type":0,"value":"Não dá para desfazer. Tudo o que esta importação criou e está na lixeira some de vez: as linhas ("},{"type":1,"value":"rows"},{"type":0,"value":"), os arquivos anexados ("},{"type":1,"value":"files"},{"type":0,"value":"), o conteúdo das páginas e a busca."}],
    "import.delete.nothing": "Nada criado por esta importação está na lixeira. Mova para a lixeira primeiro.",
    "import.delete.failed": "Não foi possível excluir a importação permanentemente. Tente de novo.",
    "import.source.googleDrive": "Google Drive",
    "import.source.googleDriveHint": "O Meu Drive de cada pessoa e seus drives compartilhados, para Arquivos",
    "import.drive.title": "Importar do Google Drive",
    "import.drive.heading": [{"type":0,"value":"Google Drive · "},{"type":1,"value":"domain"}],
    "import.drive.managersOnly": "Só proprietários e administradores do workspace podem importar do Google Drive.",
    "import.drive.noGoogle": "Conecte o Google Workspace primeiro (Configurações → E-mail → Importar e-mail).",
    "import.drive.connect.title": "Conecte o Google Workspace primeiro",
    "import.drive.connect.body": "O Google Drive vem pela mesma conexão do Google Workspace que importa e-mails e agendas. Um administrador do Google configura uma vez em Configurações → E-mail → Importar e-mail; depois, o Drive de todos e os drives compartilhados podem vir por aqui.",
    "import.drive.connect.button": "Conectar Google Workspace",
    "import.drive.connect.how": "Como funciona",
    "import.drive.connected": [{"type":0,"value":"Conectado em "},{"type":1,"value":"date"},{"type":0,"value":" · "},{"type":1,"value":"people"}],
    "import.drive.mailSettings": "Configurações da importação de e-mail",
    "import.drive.scope.title": "O Google Drive precisa de mais uma permissão",
    "import.drive.scope.body": "Um administrador do Google adiciona um escopo ao cliente do Bundle no Google Admin Console. E-mails e agendas continuam sendo importados enquanto isso.",
    "import.drive.scope.step1": "Abra admin.google.com → Segurança → Controle de acesso e dados → Controles de API.",
    "import.drive.scope.step2": [{"type":0,"value":"Escolha Gerenciar delegação em todo o domínio, encontre o ID do cliente "},{"type":1,"value":"clientId"},{"type":0,"value":" e escolha Editar."}],
    "import.drive.scope.step2Own": "Escolha Gerenciar delegação em todo o domínio, encontre o ID do cliente da sua conta de serviço e escolha Editar.",
    "import.drive.scope.step3": "Adicione este escopo à lista (mantenha os que já estão lá) e escolha Autorizar.",
    "import.drive.scope.clientId": "ID do cliente",
    "import.drive.scope.scope": "Escopo a adicionar",
    "import.drive.scope.all": "Todos os escopos",
    "import.drive.scope.allHint": "E-mail, agenda e Drive, separados por vírgula, para colar sobre a lista inteira",
    "import.drive.scope.copy": "Copiar",
    "import.drive.scope.copyAll": "Copiar tudo",
    "import.drive.scope.copied": "Copiado",
    "import.drive.scope.check": "Verificar de novo",
    "import.drive.scope.checked": [{"type":0,"value":"Última verificação "},{"type":1,"value":"time"},{"type":0,"value":". O Google pode levar alguns minutos para aplicar."}],
    "import.drive.ready.title": [{"type":0,"value":"Pronto para ler o Google Drive de "},{"type":1,"value":"domain"}],
    "import.drive.ready.body": "O Bundle só lê. Nada no Google Drive é alterado, movido ou compartilhado.",
    "import.drive.ready.button": "Ler o Google Drive",
    "import.drive.scan.title": "Lendo o Google Drive…",
    "import.drive.scan.body": "Drives grandes levam alguns minutos; você pode sair desta página.",
    "import.drive.scan.cancel": "Cancelar",
    "import.drive.review.read": [{"type":0,"value":"Lido "},{"type":1,"value":"time"},{"type":0,"value":" · "},{"type":1,"value":"people"},{"type":0,"value":" e "},{"type":1,"value":"drives"},{"type":0,"value":". Escolha o que vem para Arquivos."}],
    "import.drive.review.total": [{"type":1,"value":"size"}],
    "import.drive.review.from": [{"type":0,"value":"de "},{"type":1,"value":"people"},{"type":0,"value":" e "},{"type":1,"value":"drives"}],
    "import.drive.review.thisImport": [{"type":0,"value":"Esta importação · "},{"type":1,"value":"size"}],
    "import.drive.review.left": [{"type":0,"value":"Espaço livre em Arquivos: "},{"type":1,"value":"size"}],
    "import.drive.review.over": [{"type":0,"value":"Não cabe. Desmarque "},{"type":1,"value":"size"},{"type":0,"value":" ou mais, ou libere espaço em Gerenciar armazenamento."}],
    "import.drive.review.manageStorage": "Gerenciar armazenamento",
    "import.drive.review.sharedSizes": "O tamanho dos drives compartilhados é contado enquanto são listados.",
    "import.drive.review.people": "Pessoas",
    "import.drive.review.peopleHint": "O Meu Drive de cada pessoa vai para os Meus arquivos dela, numa pasta chamada “Google Drive”.",
    "import.drive.review.peoplePicked": [{"type":1,"value":"picked"},{"type":0,"value":" de "},{"type":1,"value":"members"},{"type":0,"value":" membros escolhidos"}],
    "import.drive.review.account": "Conta Google",
    "import.drive.review.inBundle": "No Bundle",
    "import.drive.review.size": "Tamanho",
    "import.drive.review.notInBundle": "Fora do Bundle",
    "import.drive.review.inviteFirst": "Convide primeiro",
    "import.drive.review.invite": "Convidar",
    "import.drive.review.include": [{"type":0,"value":"Incluir "},{"type":1,"value":"name"}],
    "import.drive.review.all": "Selecionar tudo",
    "import.drive.review.none": "Selecionar nada",
    "import.drive.review.sharedDrives": "Drives compartilhados",
    "import.drive.review.sharedDrivesHint": "Cada um vira uma pasta compartilhada no topo de Arquivos, com os membros do drive.",
    "import.drive.review.members": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" membro"}]},"other":{"value":[{"type":7},{"type":0,"value":" membros"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.review.cantRead": "Nenhum organizador deste Google Workspace consegue lê-lo",
    "import.drive.review.noSharedDrives": "Nenhum drive compartilhado.",
    "import.drive.review.filesTitle": "Como os arquivos vêm",
    "import.drive.review.files1": "Google Docs → .docx · Planilhas → .xlsx · Apresentações → .pptx · Desenhos → .pdf",
    "import.drive.review.files2": "Formulários, Sites, Meus Mapas e Apps Script não são copiados. Aparecem no relatório com “Abrir no Google”.",
    "import.drive.review.files3": "Atalhos continuam atalhos.",
    "import.drive.review.files4": "Arquivos na lixeira do Google não são copiados.",
    "import.drive.review.files5": [{"type":0,"value":"Arquivos “Compartilhados comigo” de donos fora de "},{"type":1,"value":"domain"},{"type":0,"value":" não são copiados."}],
    "import.drive.review.files6": "Os demais arquivos vêm como estão, até 5 TB cada.",
    "import.drive.review.sharingTitle": "Como o compartilhamento vem",
    "import.drive.review.sharing1": "As pessoas mantêm o mesmo acesso (leitor, comentarista, editor) quando são membros ou convidados deste workspace.",
    "import.drive.review.sharing2": [{"type":0,"value":"“Qualquer pessoa com o link” e “Qualquer pessoa em "},{"type":1,"value":"domain"},{"type":0,"value":"” viram “Qualquer pessoa deste workspace com o link”. O Bundle não tem links públicos."}],
    "import.drive.review.sharing3": "Pessoas fora do Bundle que tinham acesso não o recebem. Elas aparecem no relatório para você convidá-las.",
    "import.drive.review.sharing4": "Ninguém é notificado.",
    "import.drive.review.footer": [{"type":1,"value":"size"},{"type":0,"value":" · O Google Drive é só lido, nunca alterado."}],
    "import.drive.review.discard": "Descartar",
    "import.drive.review.readAgain": "Ler de novo",
    "import.drive.review.start": "Iniciar importação",
    "import.drive.run.title": [{"type":0,"value":"Importando · "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "import.drive.run.listing": "Importando · listando arquivos…",
    "import.drive.run.counts": [{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"},{"type":0,"value":" itens · "},{"type":1,"value":"size"}],
    "import.drive.run.countsUnknown": [{"type":1,"value":"done"},{"type":0,"value":" itens · "},{"type":1,"value":"size"}],
    "import.drive.run.cancel": "Cancelar importação",
    "import.drive.run.body": "Roda nos nossos servidores; você pode fechar esta página. As pastas aparecem em Arquivos conforme são copiadas. Ninguém é notificado.",
    "import.drive.run.units": "Pessoas e drives compartilhados",
    "import.drive.run.sharedDrive": "Drive compartilhado",
    "import.drive.unit.waiting": "Aguardando",
    "import.drive.unit.listing": "Listando arquivos…",
    "import.drive.unit.copying": [{"type":0,"value":"Copiando "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "import.drive.unit.done": [{"type":0,"value":"Concluído · "},{"type":1,"value":"items"}],
    "import.drive.unit.attention": "Precisa de atenção",
    "import.drive.run.problems": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Precisa de atenção · "},{"type":7},{"type":0,"value":" arquivo até agora"}]},"other":{"value":[{"type":0,"value":"Precisa de atenção · "},{"type":7},{"type":0,"value":" arquivos até agora"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.run.seeAll": "Ver tudo",
    "import.drive.problem.tooBig": "Grande demais: mais de 5 TB",
    "import.drive.problem.notCopyable": "Não copiável: um tipo do Google sem arquivo para exportar",
    "import.drive.problem.exportFailed": "Falha na exportação: o Google não conseguiu converter",
    "import.drive.problem.refused": "O Google recusou: o download está desativado ou o dono o limitou",
    "import.drive.problem.gone": "Removido: apagado no Google antes de ser copiado",
    "import.drive.problem.shortcutTarget": "Atalho: o item para o qual ele aponta não está nesta importação",
    "import.drive.problem.folderMissing": "A pasta dele não veio",
    "import.drive.problem.storageFull": "Armazenamento cheio: o Arquivos ficou sem espaço",
    "import.drive.problem.failed": "Não foi possível copiar depois de várias tentativas",
    "import.drive.problem.open": "Abrir no Google",
    "import.drive.problems.title": "Não copiados",
    "import.drive.problems.body": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" arquivo não veio. Todo o resto veio."}]},"other":{"value":[{"type":7},{"type":0,"value":" arquivos não vieram. Todo o resto veio."}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.problems.all": "Todos",
    "import.drive.problems.csv": "Baixar CSV",
    "import.drive.problems.tryAgain": "Tentar de novo",
    "import.drive.problems.tryAgainHint": "Lê o Google Drive de novo com as mesmas escolhas; só vem o que é novo, mudou ou ainda não foi copiado.",
    "import.drive.problems.empty": "Tudo veio.",
    "import.drive.problems.truncated": [{"type":0,"value":"Mostrando os primeiros "},{"type":1,"value":"count"},{"type":0,"value":". O CSV tem a mesma lista."}],
    "import.drive.done.title": "O Google Drive está em Arquivos",
    "import.drive.done.attention": "O Google Drive está em Arquivos, com algumas coisas para ver",
    "import.drive.done.cancelled": "Importação cancelada. O que foi copiado fica.",
    "import.drive.done.failed": "A importação parou",
    "import.drive.done.summary": [{"type":1,"value":"files"},{"type":0,"value":" e "},{"type":1,"value":"folders"},{"type":0,"value":" · "},{"type":1,"value":"size"}],
    "import.drive.review.outsideCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" fora do Bundle"}]},"other":{"value":[{"type":7},{"type":0,"value":" fora do Bundle"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.people": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.sharedDrives": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" drive compartilhado"}]},"other":{"value":[{"type":7},{"type":0,"value":" drives compartilhados"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.files": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" arquivo"}]},"other":{"value":[{"type":7},{"type":0,"value":" arquivos"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.folders": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pasta"}]},"other":{"value":[{"type":7},{"type":0,"value":" pastas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.count.items": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" item"}]},"other":{"value":[{"type":7},{"type":0,"value":" itens"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.done.sharedDrives": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" drive compartilhado"}]},"other":{"value":[{"type":7},{"type":0,"value":" drives compartilhados"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.done.notCopied": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" não copiado"}]},"other":{"value":[{"type":7},{"type":0,"value":" não copiados"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.done.storageFull": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"O Arquivos ficou sem espaço, então "},{"type":7},{"type":0,"value":" arquivo não foi copiado. Libere espaço e importe de novo."}]},"other":{"value":[{"type":0,"value":"O Arquivos ficou sem espaço, então "},{"type":7},{"type":0,"value":" arquivos não foram copiados. Libere espaço e importe de novo."}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.done.openFiles": "Abrir Arquivos",
    "import.drive.done.again": "Importar de novo",
    "import.drive.done.againHint": "Traz só arquivos novos e alterados. Nada que já está aqui é copiado duas vezes.",
    "import.drive.done.undoTitle": "Desfazer esta importação",
    "import.drive.done.undoBody": "Move para a lixeira tudo o que esta importação criou. Arquivos editados depois da importação ficam.",
    "import.drive.trash.body": "Tudo o que esta importação do Google Drive criou e ainda está aqui, nos Meus arquivos de cada pessoa e nas pastas compartilhadas. As pessoas perdem o acesso até que seja restaurado. Você pode restaurar pela Lixeira por 30 dias.",
    "import.drive.trash.kept": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" arquivo editado depois da importação fica."}]},"other":{"value":[{"type":7},{"type":0,"value":" arquivos editados depois da importação ficam."}]}},"offset":0,"pluralType":"cardinal"}],
    "import.drive.delete.body": "Não dá para desfazer. Tudo o que esta importação colocou na lixeira vai embora de vez: arquivos, versões, compartilhamento e entradas de busca. O Google Drive ainda tem os originais.",
    "import.drive.undo.trashing": [{"type":0,"value":"Movendo para a lixeira · "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "import.drive.undo.deleting": [{"type":0,"value":"Excluindo permanentemente · "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "import.drive.undo.trashed": "Na lixeira. Você pode restaurar pela Lixeira ou excluir permanentemente.",
    "import.drive.undo.deleted": "Excluído permanentemente.",
    "import.drive.undo.stopped": [{"type":0,"value":"Parou em "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"},{"type":0,"value":". Tente de novo para terminar."}],
    "import.drive.banner": [{"type":0,"value":"Importando do Google Drive · "},{"type":1,"value":"percent"},{"type":0,"value":"%. As pastas aparecem aqui conforme são copiadas."}],
    "import.drive.banner.open": "Ver progresso",
    "import.timeline.driveUnit": [{"type":0,"value":"Começou "},{"type":1,"value":"name"}],
    "import.timeline.driveUnitDone": [{"type":1,"value":"name"},{"type":0,"value":": "},{"type":1,"value":"files"},{"type":0,"value":" arquivos e "},{"type":1,"value":"folders"},{"type":0,"value":" pastas copiados"}],
    "import.timeline.driveUnitAttention": [{"type":1,"value":"name"},{"type":0,"value":" precisa de atenção: "},{"type":1,"value":"message"}],
    "import.timeline.driveShortcuts": [{"type":1,"value":"count"},{"type":0,"value":" atalhos vinculados"}],
    "import.undo.trashing": [{"type":0,"value":"Movendo para a lixeira · "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "import.undo.trashed": "Na lixeira. Dá para restaurar pela Lixeira ou excluir permanentemente.",
    "import.undo.deleting": [{"type":0,"value":"Excluindo permanentemente · "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "import.undo.deleted": "Excluído permanentemente.",
    "import.undo.failed": [{"type":0,"value":"Parou em "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"},{"type":0,"value":". Tente de novo para terminar."}],
    "import.slack.summary": [{"type":0,"value":"Canais: "},{"type":1,"value":"channels"},{"type":0,"value":" · Mensagens diretas: "},{"type":1,"value":"dms"},{"type":0,"value":" · Associadas: "},{"type":1,"value":"matched"},{"type":0,"value":" · A convidar: "},{"type":1,"value":"invite"},{"type":0,"value":" · Convidados externos: "},{"type":1,"value":"guest"},{"type":0,"value":" · Desativadas: "},{"type":1,"value":"deactivated"}],
    "import.slack.publicOnly": "Esta exportação tem só canais públicos (Slack Free e Pro). Para trazer canais privados e mensagens diretas, conecte com um token.",
    "import.slack.copyFiles": "Copiar os arquivos anexados para o Bundle",
    "import.slack.people": "Pessoas",
    "import.slack.people.body": "Pessoas com o mesmo email são associadas a membros. Quem for convidado ganha a conta agora, então mensagens, canais e conversas já são dele quando entrar; pessoas de outras empresas entram como convidados externos; quem saiu fica como perfil desativado.",
    "import.slack.nameOnly": "Manter só o nome",
    "import.slack.matchFor": [{"type":0,"value":"Membro para "},{"type":1,"value":"name"}],
    "import.slack.deactivated": "Desativado no Slack",
    "import.slack.channels": "Canais",
    "import.slack.channels.body": "Desmarque o que não quiser; renomeie para evitar conflitos. Os canais vêm com seus membros.",
    "import.slack.include": [{"type":0,"value":"Importar #"},{"type":1,"value":"name"}],
    "import.slack.rename": [{"type":0,"value":"Nome para #"},{"type":1,"value":"name"}],
    "import.slack.merges": "Entra no canal vazio com este nome",
    "import.slack.archived": "Arquivado",
    "import.slack.duplicateNames": [{"type":0,"value":"Dois canais ficariam com o nome "},{"type":1,"value":"names"},{"type":0,"value":": renomeie um deles."}],
    "import.slack.dms": "Mensagens diretas",
    "import.slack.dms.body": "As mensagens diretas vêm quando todos nelas existem no Bundle (associados, convidados ou desativados), e só eles podem lê-las.",
    "import.slack.allDms": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Importar a mensagem direta"}]},"other":{"value":[{"type":0,"value":"Importar todas as "},{"type":7},{"type":0,"value":" mensagens diretas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.notion.summary": [{"type":0,"value":"Páginas: "},{"type":1,"value":"pages"},{"type":0,"value":" · Bancos de dados: "},{"type":1,"value":"databases"}],
    "import.notion.ai.title": "Organizado com IA",
    "import.notion.ai.body": "Revise as seções abaixo e mova as páginas para onde devem ficar.",
    "import.notion.ai.unavailable": "As páginas mantêm a organização que tinham no Notion. Adicione seções para agrupá-las.",
    "import.notion.ai.failed": "A IA não conseguiu organizar esta exportação, então as páginas mantêm a organização do Notion. Adicione seções para agrupá-las.",
    "import.notion.sectionName": "Nome da seção",
    "import.notion.shared": "Compartilhada",
    "import.notion.private": "Privada",
    "import.notion.visibility": "Quem vê",
    "import.notion.removeSection": "Remover seção",
    "import.notion.emptySection": "Nada aqui ainda: mova páginas para cá abaixo.",
    "import.notion.topLevel": "Nível superior",
    "import.notion.topLevel.body": "Estas páginas vão direto para as páginas do espaço de trabalho.",
    "import.notion.addSection": "Adicionar seção",
    "import.notion.newSection": "Nova seção",
    "import.notion.untitledSection": "Seção sem título",
    "import.notion.nameSections": "Dê um nome a cada seção.",
    "import.notion.untitled": "Sem título",
    "import.notion.renamed": [{"type":0,"value":"era \""},{"type":1,"value":"title"},{"type":0,"value":"\""}],
    "import.notion.rows": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" linha"}]},"other":{"value":[{"type":7},{"type":0,"value":" linhas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.notion.subpages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" subpágina"}]},"other":{"value":[{"type":7},{"type":0,"value":" subpáginas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.notion.view": [{"type":0,"value":"Primeira visualização de "},{"type":1,"value":"name"}],
    "import.notion.moveTo": [{"type":0,"value":"Seção de "},{"type":1,"value":"name"}],
    "import.notion.layout.table": "Tabela",
    "import.notion.layout.board": "Quadro",
    "import.notion.layout.list": "Lista",
    "import.notion.layout.calendar": "Calendário",
    "import.notion.layout.sheet": "Planilha",
    "import.slackApp.title": "Deixar cada pessoa importar as próprias mensagens do Slack",
    "import.slackApp.body": "O token de um administrador não lê DMs nem canais privados dos outros. Conecte o app do Slack uma vez e cada pessoa traz as suas em Configurações → Dados, entrando com o Slack.",
    "import.slackApp.step1": "Crie o app no Slack com o botão acima (ele já vem com o endereço de retorno do Bundle) e instale no seu espaço de trabalho.",
    "import.slackApp.step2": "Em Basic Information do app, copie o Client ID e o Client Secret para cá.",
    "import.slackApp.clientId": "Client ID",
    "import.slackApp.clientSecret": "Client Secret",
    "import.slackApp.save": "Conectar o app",
    "import.slackApp.connected": [{"type":0,"value":"Conectado (Client ID "},{"type":1,"value":"clientId"},{"type":0,"value":"). Cada pessoa já pode importar as próprias mensagens."}],
    "import.slackApp.saved": "App do Slack conectado.",
    "import.slackApp.failed": "Não foi possível salvar o app do Slack. Confira o Client ID e o Secret.",
    "import.sync.title": "Continuar sincronizando com o Slack",
    "import.sync.body": "Enquanto sua equipe se muda, o Bundle traz mais ou menos a cada hora as novas mensagens, respostas em conversas, canais e arquivos do Slack. A sincronização é de mão única: mensagens escritas no Bundle não vão para o Slack.",
    "import.sync.toggle": "Continuar sincronizando com o Slack (a cada hora)",
    "import.sync.tokenNote": "O Bundle precisa de um token de usuário do Slack (xoxp-…) para continuar lendo o Slack, do mesmo tipo de app usado na importação por token. Ele fica guardado até você concluir a mudança.",
    "import.sync.tokenLabel": "Token de usuário do Slack",
    "import.sync.turnOn": "Ativar",
    "import.sync.never": "Ainda não sincronizado. A primeira sincronização acontece em até uma hora.",
    "import.sync.running": "Sincronizando agora…",
    "import.sync.last": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Última sincronização "},{"type":1,"value":"time"},{"type":0,"value":" · "},{"type":7},{"type":0,"value":" mensagem nova"}]},"other":{"value":[{"type":0,"value":"Última sincronização "},{"type":1,"value":"time"},{"type":0,"value":" · "},{"type":7},{"type":0,"value":" mensagens novas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.sync.lastFailed": [{"type":0,"value":"A última sincronização falhou "},{"type":1,"value":"time"},{"type":0,"value":": "},{"type":1,"value":"error"}],
    "import.sync.paused": "Pausada. Novas mensagens do Slack não estão chegando.",
    "import.sync.now": "Sincronizar agora",
    "import.sync.finish": "Parar de sincronizar (Concluir mudança)",
    "import.sync.finishNote": "Quando todos estiverem trabalhando no Bundle, pare de sincronizar. O Bundle esquece o token do Slack, e tudo o que veio fica.",
    "import.sync.finished": "Sincronização com o Slack encerrada. Tudo o que veio continua no Bundle.",
    "import.sync.failed": "Não foi possível alterar a sincronização com o Slack. Tente de novo.",
    "import.sync.badToken": "O Slack não aceitou este token. Confira e tente de novo.",
    "import.personal.title": "Importar minhas conversas do Slack",
    "import.personal.body": "Traga suas DMs, DMs em grupo e canais privados do Slack. Quem já está aqui é reconhecido pelo email; ninguém é convidado. Conversas que já estão aqui não são duplicadas.",
    "import.personal.connect": "Conectar com o Slack",
    "import.personal.notConfigured": "Um administrador precisa conectar o app do Slack antes (Configurações → Importar → Slack).",
    "import.personal.connectFailed": "Não foi possível conectar ao Slack. Tente de novo.",
    "import.personal.guests": "Convidados não podem importar conversas.",
    "import.personal.summary": [{"type":1,"value":"dms"},{"type":0,"value":" DMs e DMs em grupo · "},{"type":1,"value":"channels"},{"type":0,"value":" canais privados"}],
    "import.destination.title": "Importar para",
    "import.destination.body": "Traga para este espaço de trabalho, outro que você administra, ou um novo criado para isso.",
    "import.destination.new": "Novo espaço de trabalho…",
    "import.destination.name": "Nome do espaço de trabalho",
    "import.destination.create": "Criar e continuar",
    "import.destination.cancel": "Cancelar",
    "import.destination.failed": "Não foi possível criar o espaço de trabalho. Tente de novo.",
    "import.notion.reviewTitle": "Importar do Notion",
    "import.notion.reviewBody": "Escolha o que vem para o Bundle. Nada muda no Notion.",
    "import.notion.workspace": "Espaço do Notion",
    "import.notion.sees": [{"type":0,"value":"O que a integração consegue ver — páginas: "},{"type":1,"value":"pages"},{"type":0,"value":" · bancos de dados: "},{"type":1,"value":"databases"}],
    "import.notion.readAgain": "Ler de novo",
    "import.notion.missingPages": "Falta alguma página? Com uma integração, o Notion só mostra as páginas conectadas a ela (••• → Conexões na página). Um token pessoal vê tudo do espaço do Notion onde foi criado: páginas de outro espaço precisam de um token de lá. Depois clique em Ler de novo.",
    "import.notion.what": "O que importar",
    "import.notion.what.body": "Subpáginas e linhas vêm junto com a página ou banco de dados de cima.",
    "import.notion.databases": "Bancos de dados",
    "import.notion.page": "Página",
    "import.notion.leftOut": "Fica de fora",
    "import.notion.moveToNew": "Nova seção…",
    "import.notion.willImport": [{"type":1,"value":"picked"},{"type":0,"value":" de "},{"type":1,"value":"total"},{"type":0,"value":" serão importados, com subpáginas e linhas"}],
    "import.notion.importCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Importar "},{"type":7},{"type":0,"value":" item"}]},"other":{"value":[{"type":0,"value":"Importar "},{"type":7},{"type":0,"value":" itens"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.notion.selectAll": "Selecionar tudo",
    "import.notion.picked": [{"type":1,"value":"picked"},{"type":0,"value":" de "},{"type":1,"value":"total"},{"type":0,"value":" selecionados"}],
    "import.notion.pages": "Páginas",
    "import.notion.noSection": "Sem seção",
    "import.notion.noSection.body": "Vão direto para Páginas, como estavam no Notion.",
    "import.notion.database": "Banco de dados",
    "import.notion.showAs": [{"type":0,"value":"Mostrar como "},{"type":1,"value":"layout"}],
    "import.notion.moveToNone": "Sem seção",
    "import.notion.moveToSection": [{"type":0,"value":"Mover para "},{"type":1,"value":"section"}],
    "import.notion.options": [{"type":0,"value":"Opções de "},{"type":1,"value":"name"}],
    "import.notion.nothingPicked": "Escolha pelo menos uma página ou banco de dados.",
    "import.managersOnly": "Só proprietários e administradores podem importar.",
    "import.notZip": "Escolha o arquivo .zip da exportação.",
    "import.busy": "Outra importação está em andamento. Espere terminar ou interrompa.",
    "import.uploadFailed": "O envio falhou. Tente de novo.",
    "import.startFailed": "Não foi possível iniciar a importação. Tente de novo.",
    "import.loadFailed": "Não foi possível carregar esta importação.",
    "import.cancelFailed": "Não foi possível parar a importação. Tente de novo.",
    "import.chooseFile": "Escolher arquivo",
    "nav.mail": "E-mail",
    "nav.docs": "Documentos",
    "nav.files": "Arquivos",
    "nav.contacts": "Contatos",
    "settings.nav.mail": "E-mail",
    "mail.title": "E-mail",
    "mail.tab.email": "Todos",
    "mail.tab.clients": "Clientes",
    "mail.tab.team": "Time",
    "mail.tab.promotions": "Promoções",
    "mail.tab.updates": "Atualizações",
    "mail.tab.new": [{"type":1,"value":"count"},{"type":0,"value":" novos"}],
    "mail.updating": "Atualizando",
    "mail.updated.justNow": "Atualizado agora",
    "mail.updated.minutes": [{"type":0,"value":"Atualizado há "},{"type":1,"value":"count"},{"type":0,"value":" min"}],
    "mail.updated.hours": [{"type":0,"value":"Atualizado há "},{"type":1,"value":"count"},{"type":0,"value":" h"}],
    "mail.updated.days": [{"type":0,"value":"Atualizado há "},{"type":1,"value":"count"},{"type":0,"value":" d"}],
    "mail.tab.priority": "Prioridade",
    "mail.action.markPriority": "Marcar como prioridade",
    "mail.action.notPriority": "Não é prioridade",
    "mail.priority.waiting": "Aguardando sua resposta",
    "mail.priority.waitingOn": [{"type":1,"value":"name"},{"type":0,"value":" aguarda sua resposta"}],
    "mail.priority.starred": "Com estrela",
    "mail.priority.marked": "Você marcou esta conversa",
    "mail.priority.sender": [{"type":0,"value":"Você marcou "},{"type":1,"value":"name"},{"type":0,"value":" como prioridade"}],
    "mail.priority.reminder": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Sem resposta há "},{"type":7},{"type":0,"value":" dia"}]},"other":{"value":[{"type":0,"value":"Sem resposta há "},{"type":7},{"type":0,"value":" dias"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.priority.marker": [{"type":0,"value":"Prioridade: "},{"type":1,"value":"reason"},{"type":0,"value":". Marcar como não prioridade"}],
    "mail.priority.unmarkHint": [{"type":0,"value":"Não é prioridade (−) vale também para os próximos e-mails de "},{"type":1,"value":"name"}],
    "mail.priority.markHint": [{"type":0,"value":"Marcar como prioridade (+) vale também para os próximos e-mails de "},{"type":1,"value":"name"}],
    "mail.priority.footer": "Mostrando o que precisa de você em todas as abas. Cada conversa continua também na sua própria aba.",
    "mail.empty.priority.title": "Tudo em dia",
    "mail.empty.priority.body": "Respostas que as pessoas aguardam, conversas com estrela e remetentes que você marcar como prioridade aparecem aqui.",
    "mail.empty.priority.goTab": [{"type":0,"value":"Ir para "},{"type":1,"value":"tab"}],
    "mail.folder.inbox": "Caixa de entrada",
    "mail.folder.sent": "Enviados",
    "mail.folder.archive": "Arquivados",
    "mail.folder.trash": "Lixeira",
    "mail.folder.spam": "Spam",
    "mail.search.all": "Buscar em todos os e-mails",
    "mail.search.filter.mailbox": "Uma das suas caixas",
    "mail.search.value.mailbox": "Sua caixa",
    "mail.filter.title": "Filtrar e-mails",
    "mail.filter.mailbox": "Caixa",
    "mail.filter.allMailboxes": "Todas as caixas",
    "mail.filter.myMailboxes": "Minhas caixas",
    "mail.filter.groups": "Grupos",
    "mail.filter.groupRow": [{"type":1,"value":"address"},{"type":0,"value":" (grupo)"}],
    "mail.filter.showOnly": "Mostrar só",
    "mail.filter.unread": "Não lidos",
    "mail.filter.starred": "Com estrela",
    "mail.filter.attachment": "Anexo",
    "mail.filter.from": "De",
    "mail.filter.fromPlaceholder": "Nome ou endereço",
    "mail.filter.date": "Data",
    "mail.filter.date.today": "Hoje",
    "mail.filter.date.week": "Últimos 7 dias",
    "mail.filter.date.month": "Últimos 30 dias",
    "mail.filter.label": "Marcador",
    "mail.filter.anyone": "Qualquer pessoa",
    "mail.filter.anyTime": "Qualquer data",
    "mail.filter.any": "Qualquer um",
    "mail.filter.apply": "Aplicar",
    "mail.filter.clear": "Limpar",
    "mail.filter.clearAll": "Limpar filtros",
    "mail.filter.empty": "Nenhum e-mail com esses filtros",
    "mail.filter.show": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Mostrar "},{"type":7},{"type":0,"value":" conversa"}]},"other":{"value":[{"type":0,"value":"Mostrar "},{"type":7},{"type":0,"value":" conversas"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.filter.showMore": [{"type":0,"value":"Mostrar "},{"type":1,"value":"count"},{"type":0,"value":"+ conversas"}],
    "mail.recent.title": "Buscas recentes",
    "mail.recent.clear": "Limpar histórico",
    "mail.recent.remove": "Remover do histórico",
    "mail.recent.empty": "Suas buscas aparecem aqui. Só você pode vê-las.",
    "mail.recent.filterBy": "Filtrar por",
    "mail.recent.close": "Fechar",
    "mail.recent.swipeHint": "Deslize para a esquerda para remover. Só você pode ver.",
    "mail.search.placeholder": "Pesquisar e-mails",
    "mail.search.filter.from": "Enviado por uma pessoa, e-mail ou domínio",
    "mail.search.filter.to": "Enviado para uma pessoa, e-mail ou domínio",
    "mail.search.filter.domain": "Qualquer pessoa de um domínio, remetente ou destinatário",
    "mail.search.filter.in": "Em uma pasta ou marcador",
    "mail.search.filter.has": "Tem anexo",
    "mail.search.filter.is": "Não lido, lido ou com estrela",
    "mail.search.filter.before": "Antes de uma data",
    "mail.search.filter.after": "Depois de uma data",
    "mail.search.filter.or": "Um lado ou o outro",
    "mail.search.value.domain": "Todos deste domínio",
    "mail.search.value.folder": "Pasta",
    "mail.search.value.label": "Marcador",
    "mail.search.value.attachment": "Tem anexo",
    "mail.search.value.unread": "Não lido",
    "mail.search.value.read": "Lido",
    "mail.search.value.starred": "Com estrela",
    "mail.search.suggest.people": "Pessoas e domínios",
    "mail.search.suggest.domains": "Domínios",
    "mail.search.suggest.folders": "Pastas e marcadores",
    "mail.search.mode.like": "Contém",
    "mail.search.mode.exact": "Exatamente este",
    "mail.search.mode.exclude": "Deixar de fora",
    "mail.search.chip.remove": [{"type":0,"value":"Remover "},{"type":1,"value":"filter"}],
    "mail.search.chip.or": "ou",
    "mail.compose": "Escrever",
    "mail.empty.tab": [{"type":0,"value":"Nada em "},{"type":1,"value":"tab"}],
    "mail.empty.folder": "Nenhuma conversa aqui",
    "mail.empty.search": [{"type":0,"value":"Nenhum e-mail corresponde a “"},{"type":1,"value":"query"},{"type":0,"value":"”"}],
    "mail.noMailbox.title": "Nenhuma caixa de e-mail ainda",
    "mail.noMailbox.body": "Um administrador pode hospedar o domínio da empresa no Bundle em Configurações → E-mail e criar uma caixa para você.",
    "mail.noMailbox.adminBody": "Adicione o domínio da empresa em Configurações → E-mail e crie uma caixa nele. Os e-mails enviados para esse endereço aparecem aqui.",
    "mail.noMailbox.setup": "Configurar e-mail",
    "mail.loadFailed": "Não foi possível carregar os e-mails",
    "mail.thread.textFailed": "Não foi possível carregar esta mensagem. Tente de novo.",
    "mail.retry": "Tentar de novo",
    "mail.loadMore": "Carregar mais",
    "mail.action.reply": "Responder",
    "mail.action.replyAll": "Responder a todos",
    "mail.action.replyAllShort": "Resp. a todos",
    "mail.action.forward": "Encaminhar",
    "mail.action.archive": "Arquivar",
    "mail.action.trash": "Excluir",
    "mail.action.spam": "Denunciar spam",
    "mail.action.notSpam": "Não é spam",
    "mail.action.moveToInbox": "Mover para a Caixa de entrada",
    "mail.action.markRead": "Marcar como lido",
    "mail.action.markUnread": "Marcar como não lido",
    "mail.action.star": "Adicionar estrela",
    "mail.action.unstar": "Remover estrela",
    "mail.action.moveToTab": "Mover para a aba",
    "mail.action.loadImages": "Carregar imagens",
    "mail.imagesBlocked": "As imagens foram ocultadas para proteger sua privacidade.",
    "mail.view.original": "Ver e-mail original",
    "mail.view.reading": "Ver modo leitura",
    "mail.view.setting.title": "Abrir mensagens em",
    "mail.view.setting.original": "Original",
    "mail.view.setting.originalHelp": "O e-mail como o remetente o criou, como o Gmail mostra.",
    "mail.view.setting.reading": "Modo leitura",
    "mail.view.setting.readingHelp": "Só o texto, as imagens e os links, nas cores do Bundle. E-mails pessoais curtos e respostas continuam abrindo como foram enviados.",
    "mail.view.setting.help": "Vale em todos os seus dispositivos. Cada mensagem ainda pode trocar de modo.",
    "mail.warning.suspicious": "Esta mensagem pode não ser de quem diz ser. Não clique em links nem compartilhe senhas.",
    "mail.code.label": "Código de verificação",
    "mail.code.from": [{"type":0,"value":"Código de verificação de "},{"type":1,"value":"sender"},{"type":0,"value":" · "},{"type":1,"value":"time"}],
    "mail.code.copy": "Copiar código",
    "mail.code.copied": "Copiado",
    "mail.code.copiedToast": "Código copiado",
    "mail.code.copyNamed": [{"type":0,"value":"Copiar código "},{"type":1,"value":"code"}],
    "mail.code.spam": [{"type":0,"value":"Este código caiu no Spam. "},{"type":1,"value":"sender"},{"type":0,"value":" enviou e as verificações do remetente passaram."}],
    "mail.code.unverified": "Parece um código, mas não conseguimos verificar quem enviou. Não compartilhe com ninguém.",
    "home.briefing.codes": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" código"}]},"other":{"value":[{"type":7},{"type":0,"value":" códigos"}]}},"offset":0,"pluralType":"cardinal"}],
    "home.briefing.copy": "Copiar",
    "mail.needsReply": "Aguardando resposta",
    "mail.auth.pass": "Remetente verificado",
    "mail.auth.fail": "Remetente não verificado",
    "mail.to": [{"type":0,"value":"para "},{"type":1,"value":"names"}],
    "mail.me": "mim",
    "mail.attachment.cancel": [{"type":0,"value":"Cancelar o download de "},{"type":1,"value":"name"}],
    "mail.attachment.failedNamed": [{"type":0,"value":"Não foi possível baixar "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "mail.attachment.offlineNamed": [{"type":0,"value":"Você está sem conexão. Não foi possível baixar "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "mail.attachment.saved": [{"type":1,"value":"name"},{"type":0,"value":" foi salvo"}],
    "mail.attachment.saveFailed": [{"type":0,"value":"Não foi possível salvar "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "mail.attachment.downloading": [{"type":0,"value":"Baixando "},{"type":1,"value":"name"}],
    "mail.attachment.opening": [{"type":0,"value":"Abrindo "},{"type":1,"value":"name"}],
    "mail.attachment.openNamed": [{"type":0,"value":"Abrir "},{"type":1,"value":"name"}],
    "mail.attachment.downloadNamed": [{"type":0,"value":"Baixar "},{"type":1,"value":"name"}],
    "mail.attachment.savedToDownloads": [{"type":1,"value":"name"},{"type":0,"value":" foi salvo em Downloads"}],
    "mail.attachment.showInFolder": "Mostrar na pasta",
    "mail.attachment.offline": "Você está offline. Toque para tentar de novo.",
    "mail.attachment.failed": "Não foi possível baixar. Toque para tentar de novo.",
    "mail.attachment.open": "Abrir",
    "mail.attachment.share": "Compartilhar",
    "mail.attachment.saveToFiles": "Salvar em Arquivos",
    "mail.attachments": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" anexo"}]},"other":{"value":[{"type":7},{"type":0,"value":" anexos"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.status.queued": "Enviando…",
    "mail.status.failed": "Não enviado",
    "mail.status.bounced": "Devolvido",
    "mail.compose.new": "Nova mensagem",
    "mail.compose.assist": "Descreva a mensagem",
    "mail.compose.assistFailed": "Não deu para escrever. Tente de novo.",
    "mail.compose.assisting": "Escrevendo…",
    "mail.compose.linkAddress": "Endereço do link",
    "mail.compose.linkApply": "Aplicar",
    "mail.compose.linkRemove": "Remover link",
    "mail.compose.formatting": "Opções de formatação",
    "mail.compose.minimize": "Minimizar",
    "mail.compose.restore": "Restaurar",
    "mail.compose.expand": "Tela cheia",
    "mail.compose.collapse": "Sair da tela cheia",
    "mail.compose.from": "De",
    "mail.compose.to": "Para",
    "mail.compose.recipient.edit": [{"type":0,"value":"Editar "},{"type":1,"value":"name"}],
    "mail.compose.recipient.removeInvalid": [{"type":0,"value":"Remover "},{"type":1,"value":"name"},{"type":0,"value":", endereço inválido"}],
    "mail.compose.cc": "Cc",
    "mail.compose.bcc": "Cco",
    "mail.compose.subject": "Assunto",
    "mail.compose.body": "Escreva sua mensagem",
    "mail.compose.attach": "Anexar arquivos",
    "mail.compose.send": "Enviar",
    "mail.compose.toLabel": "Para:",
    "mail.compose.subjectLabel": "Assunto:",
    "mail.compose.saySomething": "Escreva algo",
    "mail.compose.noSignature": "Sem assinatura",
    "mail.compose.signatureOptions": "Opções da assinatura",
    "mail.compose.signatureEdit": "Editar assinatura",
    "mail.compose.signatureRemove": "Enviar sem assinatura",
    "mail.compose.sentWithRemove": "Enviar esta mensagem sem o “Enviado com o Bundle”",
    "mail.compose.sentWithAdd": "Adicionar “Enviado com o Bundle”",
    "mail.compose.formatDone": "Concluir formatação",
    "mail.compose.translate": "Traduzir",
    "mail.compose.textStyle": "Estilo do texto",
    "mail.compose.templates": "Modelos",
    "mail.compose.saveTemplate": "Salvar como modelo",
    "mail.compose.remind": "Lembrar se não responderem",
    "mail.compose.remindOff": "Não lembrar",
    "mail.compose.remindAt": [{"type":0,"value":"Lembrete "},{"type":1,"value":"time"},{"type":0,"value":" se não responderem"}],
    "mail.compose.addContact": "Adicionar dos contatos",
    "mail.compose.findContact": "Buscar contato",
    "mail.compose.ai": "+ia",
    "mail.compose.ai.draft": "Gerar um rascunho",
    "mail.compose.ai.ask": "Perguntar à IA",
    "mail.compose.ai.askPlaceholder": "Pergunte algo sobre este e-mail",
    "mail.compose.ai.rewrite": "Reescrever",
    "mail.compose.ai.shorten": "Encurtar",
    "mail.compose.ai.lengthen": "Aumentar",
    "mail.compose.ai.formal": "Mais formal",
    "mail.compose.ai.friendly": "Mais simpático",
    "mail.compose.ai.fix": "Corrigir ortografia e gramática",
    "mail.compose.ccBcc": "Cc: Cco:",
    "mail.compose.editRecipients": "Editar destinatários",
    "mail.compose.recipientsSummary": [{"type":1,"value":"name"},{"type":0,"value":" +"},{"type":1,"value":"count"}],
    "mail.compose.saveDraft": "Salvar rascunho",
    "mail.compose.deleteDraft": "Excluir rascunho",
    "mail.compose.templatesEmpty": "Nenhum modelo ainda. Escreva uma mensagem e salve como modelo para reutilizá-la.",
    "mail.compose.templateName": "Nome do modelo",
    "mail.compose.deleteTemplate": "Excluir modelo",
    "mail.compose.sendLater": "Enviar depois",
    "mail.compose.more": "Mais",
    "mail.compose.useSignatureOf": [{"type":0,"value":"Usar a assinatura de "},{"type":1,"value":"address"}],
    "mail.compose.saveSignature": "Salvar como assinatura padrão",
    "mail.compose.discard": "Descartar",
    "mail.compose.sent": "Mensagem enviada",
    "mail.compose.invalidRecipients": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" endereço não é válido"}]},"other":{"value":[{"type":7},{"type":0,"value":" endereços não são válidos"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.compose.noRecipients": "Adicione pelo menos um destinatário",
    "mail.compose.noReply": [{"type":1,"value":"address"},{"type":0,"value":" pode não ler respostas"}],
    "mail.compose.offline": "Você está offline. Envie quando estiver on-line.",
    "mail.compose.failed": "Não foi possível enviar. Tente de novo.",
    "mail.compose.failedNetwork": "Não foi possível conectar ao Bundle. Sua mensagem continua aqui, tente de novo.",
    "mail.compose.failedLimit": "Esta caixa atingiu o limite de envio. Tente mais tarde.",
    "mail.compose.failedGone": "A caixa ou a mensagem que você está respondendo não existe mais.",
    "mail.compose.failedForbidden": "Você não pode enviar por esta caixa.",
    "mail.compose.failedRefused": "O Bundle recusou esta mensagem. Confira o endereço de envio, os destinatários e os anexos.",
    "mail.compose.failedStorage": "O armazenamento está cheio e os e-mails não podem sair. Um admin pode adicionar espaço em Cobrança.",
    "mail.compose.failedBilling": "Os e-mails só voltam a sair quando a assinatura for renovada.",
    "mail.compose.failedDomain": "O envio por este domínio está pausado ou não foi configurado. Um admin pode verificar em Configurações → E-mail.",
    "mail.compose.tooManyRecipients": [{"type":0,"value":"Uma mensagem pode ir para no máximo "},{"type":1,"value":"max"},{"type":0,"value":" pessoas"}],
    "mail.compose.tooLong": "Esta mensagem é longa demais. Encurte-a ou remova o texto citado.",
    "mail.compose.sendingNotSetUp": [{"type":0,"value":"O envio por "},{"type":1,"value":"domain"},{"type":0,"value":" ainda não está configurado. Um administrador pode concluir em Configurações → E-mail."}],
    "mail.contacts.title": "Contatos",
    "mail.contacts.filter.all": "Todos",
    "mail.contacts.filter.email": "E-mail",
    "mail.contacts.filter.client": "Clientes",
    "mail.contacts.filter.team": "Time",
    "mail.contacts.search": "Pesquisar contatos",
    "mail.contacts.add": "Adicionar contato",
    "mail.contacts.name": "Nome",
    "mail.contacts.email": "Endereço de e-mail",
    "mail.contacts.org": "Empresa",
    "mail.contacts.kind": "Tipo",
    "mail.contacts.markClient": "Marcar como cliente",
    "mail.contacts.markTeam": "Marcar como time",
    "mail.contacts.markEmail": "Marcar como outro",
    "mail.contacts.remove": "Remover contato",
    "mail.contacts.sendMail": "Enviar e-mail",
    "mail.contacts.empty": "Nenhum contato ainda. Eles aparecem conforme você envia e recebe e-mails.",
    "mail.contacts.messages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" mensagem"}]},"other":{"value":[{"type":7},{"type":0,"value":" mensagens"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.contacts.invalidEmail": "Digite um endereço de e-mail válido",
    "mail.contacts.addFailed": "Não foi possível adicionar o contato",
    "mail.contacts.member": "Membro do workspace",
    "mail.people.copyEmail": "Copiar e-mail",
    "mail.people.kind.client": "Cliente",
    "mail.people.copied": "Endereço de e-mail copiado",
    "mail.people.notContact": "Não está nos seus contatos",
    "mail.people.projects": "Projetos",
    "mail.people.addToProject": "Adicionar a projeto",
    "mail.people.addToProjectTitle": [{"type":0,"value":"Adicionar "},{"type":1,"value":"name"},{"type":0,"value":" a um projeto"}],
    "mail.people.findProject": "Encontrar um projeto",
    "mail.people.noProjects": "Nenhum projeto ainda. Use o modelo Projetos e tarefas em Docs para começar.",
    "mail.people.noProjectsFor": "Ainda não está em nenhum projeto",
    "mail.people.projectFailed": "Não foi possível atualizar o projeto",
    "mail.people.newEmail": "Novo e-mail",
    "mail.people.openContact": "Abrir contato",
    "mail.people.addContact": "Adicionar aos contatos",
    "mail.people.addClient": "Adicionar como cliente",
    "mail.people.message": "Mensagem",
    "mail.people.viewProfile": "Ver perfil",
    "mail.people.recentWith": [{"type":0,"value":"E-mails recentes com "},{"type":1,"value":"name"}],
    "mail.people.recent": "E-mails recentes",
    "mail.people.seeAllInMail": "Ver todos no E-mail",
    "mail.people.noRecent": "Nenhum e-mail ainda",
    "mail.people.selectContact": "Selecione um contato para ver os detalhes",
    "mail.people.copyShort": "Copiar",
    "mail.people.emailShort": "E-mail",
    "mail.people.contactShort": "Contato",
    "mail.people.card": [{"type":0,"value":"Cartão de contato de "},{"type":1,"value":"name"}],
    "mail.people.removeFromProject": [{"type":0,"value":"Remover de "},{"type":1,"value":"project"}],
    "mail.settings.title": "E-mail",
    "mail.settings.domains": "Domínios",
    "mail.settings.domainsHelp": "Hospede o e-mail da sua empresa no Bundle. Adicione seu domínio e crie estes registros no seu provedor de DNS (qualquer provedor funciona).",
    "mail.settings.addDomain": "Adicionar domínio",
    "mail.settings.domainPlaceholder": "suaempresa.com.br",
    "mail.settings.check": "Verificar DNS agora",
    "mail.settings.remove": "Remover domínio",
    "mail.settings.removeConfirm": [{"type":0,"value":"Remover "},{"type":1,"value":"domain"},{"type":0,"value":"? Os endereços alternativos e grupos dele também serão removidos."}],
    "mail.settings.status.pending": "Aguardando DNS",
    "mail.settings.status.verified": "Ativo",
    "mail.settings.status.failed": "Problema no DNS",
    "mail.settings.status.paused": "Pausado",
    "mail.settings.canReceive": "Recebendo",
    "mail.settings.canSend": "Enviando",
    "mail.settings.status.ownedGoogle": "Propriedade verificada · e-mail ainda no Google",
    "mail.settings.status.ownedElsewhere": "Propriedade verificada · e-mail ainda no provedor atual",
    "mail.settings.receivesViaImport": "Recebendo por importação ou sincronização",
    "mail.settings.sendingNotSetUp": "Envio não configurado",
    "mail.settings.keptElsewhereHelp": "Você já pode criar caixas de e-mail neste domínio; as mensagens chegam pela importação. Para enviar pelo Bundle, adicione os registros DKIM e de retorno abaixo. Os registros MX servem só para trazer o e-mail do domínio para o Bundle.",
    "mail.settings.domainInUse": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Este domínio não pode ser removido enquanto "},{"type":7},{"type":0,"value":" caixa de e-mail o usa"}]},"other":{"value":[{"type":0,"value":"Este domínio não pode ser removido enquanto "},{"type":7},{"type":0,"value":" caixas de e-mail o usam"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.settings.record.type": "Tipo",
    "mail.settings.record.name": "Nome",
    "mail.settings.record.value": "Valor",
    "mail.settings.record.priority": "Prioridade",
    "mail.settings.record.ok": "Encontrado",
    "mail.settings.record.missing": "Ausente",
    "mail.settings.record.mismatch": "Valor diferente",
    "mail.settings.record.unchecked": "Não verificado",
    "mail.settings.record.optional": "Opcional",
    "mail.settings.record.srv": [{"type":0,"value":"Porta "},{"type":1,"value":"port"},{"type":0,"value":" · Peso "},{"type":1,"value":"weight"}],
    "mail.settings.record.verification.pending": "Verificando",
    "mail.settings.record.verification.restarted": "Verificando",
    "mail.settings.record.verification.failed": "Tentando de novo",
    "mail.settings.dkimNote.pending": "Registro DKIM encontrado. Nosso serviço de envio ainda está verificando o registro, o que costuma levar alguns minutos e no máximo 72 horas. O envio é ativado sozinho assim que ele for verificado.",
    "mail.settings.dkimNote.restarted": "Registro DKIM encontrado. Nosso serviço de envio tinha parado de verificar antes de o registro ser publicado, então o Bundle reiniciou a verificação. Costuma levar alguns minutos; o envio é ativado sozinho assim que ele for verificado.",
    "mail.settings.dkimNote.failed": "Registro DKIM encontrado, mas nosso serviço de envio ainda não o verificou. O Bundle reinicia a verificação a cada hora enquanto o registro estiver publicado.",
    "mail.settings.mailFromNote.pending": "Registros de devolução (MAIL FROM) encontrados. Nosso serviço de envio ainda está verificando os registros, o que costuma levar alguns minutos. Até lá seus e-mails saem com o endereço de devolução dele, e o DMARC continua passando pelo DKIM.",
    "mail.settings.mailFromNote.restarted": "Registros de devolução (MAIL FROM) encontrados. Nosso serviço de envio tinha parado de verificar, então o Bundle reiniciou a verificação. Até ela terminar seus e-mails saem com o endereço de devolução dele, e o DMARC continua passando pelo DKIM.",
    "mail.settings.mailFromNote.failed": "Registros de devolução (MAIL FROM) encontrados, mas nosso serviço de envio ainda não os verificou. O Bundle reinicia a verificação a cada hora enquanto os registros estiverem publicados.",
    "mail.settings.record.copy": "Copiar",
    "mail.settings.purpose.verify": "Comprova que o domínio é seu",
    "mail.settings.purpose.mx": "Entrega os e-mails no Bundle",
    "mail.settings.purpose.spf": "Autoriza o Bundle a enviar por você (SPF)",
    "mail.settings.purpose.dkim": "Assina seus e-mails (DKIM)",
    "mail.settings.purpose.returnPath": "Trata devoluções",
    "mail.settings.purpose.dmarc": "Protege contra falsificação (DMARC)",
    "mail.settings.purpose.mtaSts": "Exige entrega criptografada (MTA-STS)",
    "mail.settings.purpose.clientSetup": "Permite que apps de e-mail se configurem sozinhos",
    "mail.settings.purpose.bimi": "Mostra seu logo ao lado dos seus e-mails (BIMI)",
    "mail.settings.purpose.mailFrom": "Devoluções no seu próprio domínio (alinhamento SPF)",
    "mail.settings.bimi": "Logo da marca (BIMI)",
    "mail.settings.bimi.help": "Um logo SVG quadrado que os apps de e-mail mostram ao lado das mensagens deste domínio. Depois de enviar, adicione o registro default._bimi abaixo. O Gmail também exige um certificado de marca (VMC ou CMC).",
    "mail.settings.bimi.needsDmarc": "Um logo SVG quadrado que os apps de e-mail mostram ao lado das mensagens deste domínio. Eles só o mostram com o DMARC em Quarentena ou Rejeitar.",
    "mail.settings.bimi.upload": "Enviar logo SVG",
    "mail.settings.bimi.replace": "Trocar logo",
    "mail.settings.bimi.remove": "Remover logo",
    "mail.settings.dmarc": "Política DMARC",
    "mail.settings.dmarc.none": "Somente monitorar",
    "mail.settings.dmarc.quarantine": "Enviar falhas para o spam",
    "mail.settings.dmarc.reject": "Rejeitar falhas",
    "mail.settings.mailboxes": "Caixas de e-mail",
    "mail.settings.newMailbox": "Nova caixa de e-mail",
    "mail.settings.noMailboxYet": [{"type":1,"value":"domain"},{"type":0,"value":" está pronto. Crie uma caixa de e-mail para começar a receber mensagens no Bundle."}],
    "mail.settings.createMine": [{"type":0,"value":"Criar "},{"type":1,"value":"address"}],
    "mail.settings.tabs": "Configurações de e-mail",
    "mail.settings.tab.domains": "Domínios",
    "mail.settings.tab.people": "Usuários e encaminhamento",
    "mail.settings.people": "Pessoas",
    "mail.settings.people.help": "A caixa de e-mail de cada pessoa e as caixas compartilhadas que ela pode ler.",
    "mail.settings.people.noMailbox": "Sem caixa de e-mail",
    "mail.settings.people.create": "Criar caixa",
    "mail.settings.routing": "Aliases e encaminhamento",
    "mail.settings.aliases": "Aliases (outros endereços que chegam aqui)",
    "mail.settings.aliasPlaceholder": [{"type":0,"value":"vendas ou vendas@"},{"type":1,"value":"domain"}],
    "mail.settings.forwardTo": "Encaminhar para",
    "mail.settings.forwardPlaceholder": "alguem@outro.com",
    "mail.settings.keepCopy": "Manter uma cópia no Bundle",
    "mail.settings.routingSave": "Salvar",
    "mail.settings.add": "Adicionar",
    "mail.settings.aliasOf": "Alias de",
    "mail.settings.aliasOf.none": "Domínio próprio",
    "mail.settings.aliasOfHelp": [{"type":0,"value":"E-mails para qualquer@"},{"type":1,"value":"domain"},{"type":0,"value":" vão para o mesmo nome no domínio escolhido."}],
    "mail.settings.sendPaused.bounces": "O envio está pausado: muitas mensagens deste domínio voltaram recentemente. Confira os endereços usados e retome.",
    "mail.settings.sendPaused.complaints": "O envio está pausado: destinatários marcaram muitas mensagens deste domínio como spam recentemente. Confira o que está sendo enviado e retome.",
    "mail.settings.sendPaused.resume": "Retomar envio",
    "mail.settings.records.allFound": [{"type":0,"value":"Todos os "},{"type":1,"value":"count"},{"type":0,"value":" registros DNS encontrados"}],
    "mail.settings.records.toggle": "Mostrar ou ocultar os registros DNS",
    "mail.settings.mailboxesFor": "Criar caixas de e-mail para",
    "mail.settings.mailboxesForHelp": "Criadas automaticamente assim que os registros DNS do domínio estiverem configurados, cada uma com o nome da pessoa.",
    "mail.settings.mailboxesFor.me": "Só para mim",
    "mail.settings.mailboxesFor.everyone": "Todos os membros",
    "mail.settings.mailboxesFor.none": "Ninguém por enquanto (eu crio)",
    "mail.settings.mailboxAddress": "Endereço",
    "mail.settings.mailboxName": "Nome de exibição",
    "mail.settings.mailboxKind.personal": "Pessoal",
    "mail.settings.mailboxKind.shared": "Compartilhada",
    "mail.settings.mailboxMembers": "Quem pode ler",
    "mail.settings.deleteMailbox": "Excluir caixa de e-mail",
    "mail.settings.domainNotReady": "Verifique primeiro a propriedade de um domínio (o registro TXT)",
    "mail.settings.invalidDomain": "Digite um domínio como suaempresa.com.br",
    "mail.settings.invalidLocalPart": "Use letras, números, pontos ou hífens",
    "mail.settings.failed": "Algo deu errado. Tente de novo.",
    "mail.back": "Voltar",
    "mail.more": "Mais ações",
    "mail.undo.archived": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Conversa arquivada"}]},"other":{"value":[{"type":7},{"type":0,"value":" conversas arquivadas"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.trashed": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Conversa movida para a Lixeira"}]},"other":{"value":[{"type":7},{"type":0,"value":" conversas movidas para a Lixeira"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.spam": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Conversa marcada como spam"}]},"other":{"value":[{"type":7},{"type":0,"value":" conversas marcadas como spam"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.inbox": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Conversa movida para a Caixa de entrada"}]},"other":{"value":[{"type":7},{"type":0,"value":" conversas movidas para a Caixa de entrada"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.priority": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Marcada como prioridade"}]},"other":{"value":[{"type":7},{"type":0,"value":" marcadas como prioridade"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.priority.sender": [{"type":0,"value":"Marcada como prioridade. Os próximos e-mails de "},{"type":1,"value":"name"},{"type":0,"value":" também serão."}],
    "mail.undo.notPriority": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Marcada como não prioridade"}]},"other":{"value":[{"type":7},{"type":0,"value":" marcadas como não prioridade"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.undo.notPriority.sender": [{"type":0,"value":"Não é prioridade. Os próximos e-mails de "},{"type":1,"value":"name"},{"type":0,"value":" também não serão."}],
    "mail.select": [{"type":0,"value":"Selecionar "},{"type":1,"value":"subject"}],
    "mail.selectAll": "Selecionar tudo",
    "mail.selectedCount": [{"type":1,"value":"count"},{"type":0,"value":" selecionadas"}],
    "mail.clearSelection": "Limpar seleção",
    "mail.folder.starred": "Com estrela",
    "mail.folder.snoozed": "Adiados",
    "mail.folder.scheduled": "Programados",
    "mail.folder.drafts": "Rascunhos",
    "mail.labels": "Marcadores",
    "mail.label.new": "Novo marcador",
    "mail.label.namePlaceholder": "Nome do marcador",
    "mail.action.snooze": "Adiar",
    "mail.action.unsnooze": "Cancelar adiamento",
    "mail.action.labelAs": [{"type":0,"value":"Marcador: "},{"type":1,"value":"label"}],
    "mail.action.cancelSend": "Cancelar envio",
    "mail.snooze.option": [{"type":1,"value":"option"},{"type":0,"value":" · "},{"type":1,"value":"time"}],
    "mail.time.laterToday": "Mais tarde hoje",
    "mail.time.tomorrowMorning": "Amanhã de manhã",
    "mail.time.tomorrowAfternoon": "Amanhã à tarde",
    "mail.time.thisWeekend": "Neste fim de semana",
    "mail.time.nextWeek": "Próxima semana",
    "mail.time.mondayMorning": "Segunda de manhã",
    "mail.snoozedUntil": [{"type":0,"value":"Até "},{"type":1,"value":"time"}],
    "mail.scheduledFor": [{"type":0,"value":"Programado para "},{"type":1,"value":"time"}],
    "mail.compose.schedule": "Programar envio",
    "mail.compose.saved": "Rascunho salvo",
    "mail.compose.replyKind": [{"type":0,"value":"Tipo de resposta: "},{"type":1,"value":"kind"}],
    "mail.compose.removeQuote": "Remover texto citado",
    "mail.compose.saveFailed": "Rascunho não salvo",
    "mail.compose.undo": "Desfazer",
    "mail.compose.scheduled": [{"type":0,"value":"Programado para "},{"type":1,"value":"time"}],
    "mail.drafts.empty": "Nenhum rascunho",
    "mail.draft.label": "Rascunho",
    "mail.draft.discard": "Descartar rascunho",
    "mail.reader.empty": "Nenhuma conversa aberta",
    "mail.reader.emptyHelp": "Escolha uma conversa para lê-la aqui.",
    "mail.showMessages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Mostrar "},{"type":7},{"type":0,"value":" mensagem"}]},"other":{"value":[{"type":0,"value":"Mostrar "},{"type":7},{"type":0,"value":" mensagens"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.reply.kind": [{"type":0,"value":"Tipo de resposta: "},{"type":1,"value":"kind"}],
    "mail.reply.editRecipients": "Editar destinatários",
    "mail.reply.editSubject": "Editar assunto",
    "mail.reply.popOut": "Abrir em janela separada",
    "mail.reply.popped": "Você está editando esta resposta em uma janela separada.",
    "mail.reply.showHere": "Mostrar aqui",
    "mail.reply.moveBack": "Voltar para a conversa",
    "mail.reply.sendKey": [{"type":1,"value":"mod"},{"type":0,"value":"Enter"}],
    "mail.olderMessages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" mensagem mais antiga"}]},"other":{"value":[{"type":7},{"type":0,"value":" mensagens mais antigas"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.showQuoted": "Mostrar conteúdo cortado",
    "mail.folders": "Pastas",
    "mail.mailboxes": "Caixas de e-mail",
    "mail.tabs": "Categorias",
    "mail.noSubject": "(sem assunto)",
    "mail.compose.removeAttachment": "Remover anexo",
    "mail.settings.adminsOnly": "Só proprietários e administradores do workspace podem gerenciar domínios e caixas de e-mail.",
    "mail.signature.title": "Assinatura",
    "mail.signature.help": "Vai abaixo do que você escreve. Cada caixa de e-mail de onde você envia tem a sua, com negrito, itálico e links.",
    "mail.signature.mailbox": "Caixa de e-mail",
    "mail.signature.editor": "Texto da assinatura",
    "mail.signature.placeholder": "Seu nome, cargo, telefone…",
    "mail.signature.onNew": "Adicionar a novas mensagens",
    "mail.signature.onReply": "Adicionar a respostas e encaminhamentos",
    "mail.signature.sentWith": "Adicionar “Enviado com o Bundle” aos meus e-mails",
    "mail.signature.sentWithHint": "Uma linha pequena e cinza com um link para o Bundle, abaixo da sua assinatura. Você pode tirá-la de qualquer mensagem antes de enviar.",
    "mail.signature.sentWithShared": "Ligado também nas caixas compartilhadas, até você desligar nesta.",
    "mail.signature.sentWithLocked": [{"type":0,"value":"Desligado para "},{"type":1,"value":"workspace"},{"type":0,"value":" por um admin."}],
    "mail.signature.sentWithPreview": "Prévia",
    "mail.sentWith.title": "Enviado com o Bundle",
    "mail.sentWith.admins": "Admins",
    "mail.sentWith.line": "Enviado com o Bundle · e-mail, chat e chamadas em um só app",
    "mail.signature.save": "Salvar",
    "mail.signature.saved": "Assinatura salva",
    "mail.signature.saveFailed": "Não foi possível salvar a assinatura. Tente de novo.",
    "mail.signature.offline": "Você está offline. Conecte-se para salvar a assinatura.",
    "mail.signature.noMailbox": "Você ainda não tem uma caixa de e-mail para enviar.",
    "mail.apps.title": "Apps de e-mail",
    "mail.apps.help": "Leia e envie seus e-mails do Bundle no Apple Mail, Outlook, Thunderbird, Spark ou Gmail, e sincronize calendário e contatos. Os apps entram com seu endereço de e-mail e uma senha de app, não com seu login do Bundle.",
    "mail.apps.create": "Criar senha de app",
    "mail.apps.failed": "Não foi possível criar a senha de app. Tente de novo.",
    "mail.apps.profile": "Baixar perfil",
    "mail.apps.password": "Senha de app",
    "mail.apps.apple.title": "Configurar no iPhone ou Mac",
    "mail.apps.apple.help": "Um perfil adiciona todas as suas caixas de e-mail daqui, seu calendário e seus contatos.",
    "mail.apps.apple.install": "No iPhone, abra Ajustes → Perfil Transferido → Instalar. No Mac, abra Ajustes do Sistema → Geral → Gerenciamento de Dispositivos. O perfil não é assinado, então aparece como Não Verificado. Calendário e Contatos aparecem como contas separadas.",
    "mail.apps.other.title": "Outros apps",
    "mail.apps.other.help": "Outlook, Thunderbird, Spark, Gmail, DAVx⁵ e outros.",
    "mail.apps.once": "Aparece só uma vez. Entre com seu endereço de e-mail e esta senha; a maioria dos apps encontra as configurações do servidor sozinha.",
    "mail.apps.perDevice": "Cada dispositivo ou app tem a sua própria senha de app (ou perfil), e criar uma nova nunca desconecta as outras. Você pode revogar qualquer uma delas separadamente.",
    "mail.apps.server.title": "Configurações do servidor",
    "mail.apps.server.help": "Para apps que pedem.",
    "mail.apps.server.imap": "Entrada (IMAP)",
    "mail.apps.server.imapPort": "Porta 993 · SSL/TLS",
    "mail.apps.server.smtp": "Saída (SMTP)",
    "mail.apps.server.smtpPort": "Porta 465 · SSL/TLS, ou porta 587 · STARTTLS",
    "mail.apps.server.dav": "Calendário e contatos (CalDAV, CardDAV)",
    "mail.apps.server.davPort": "Porta 443 · SSL/TLS",
    "mail.apps.server.user": "Usuário",
    "mail.apps.server.userMine": "Seu endereço de e-mail completo",
    "mail.apps.server.userShared": "Caixa compartilhada",
    "mail.apps.server.password": "Senha",
    "mail.apps.server.passwordValue": "Uma senha de app (acima)",
    "mail.apps.copy": "Copiar",
    "mail.settings.record.copied": "Copiado",
    "docs.title": "Documentos",
    "docs.filter.all": "Todos",
    "docs.filter.recent": "Recentes",
    "docs.filter.mine": "Criados por mim",
    "docs.filter.favorites": "Favoritos",
    "docs.filter.databases": "Bancos de dados",
    "docs.search": "Pesquisar documentos",
    "docs.new": "Nova página",
    "docs.edited": [{"type":0,"value":"Editado "},{"type":1,"value":"when"}],
    "nav.calendar": "Agenda",
    "calendar.title": "Agenda",
    "calendar.today": "Hoje",
    "calendar.view.day": "Dia",
    "calendar.view.week": "Semana",
    "calendar.view.month": "Mês",
    "calendar.prev": "Anterior",
    "calendar.next": "Próximo",
    "calendar.allDay": "Dia inteiro",
    "calendar.new": "Novo evento",
    "calendar.scope.this": "Este evento",
    "calendar.scope.following": "Este e os eventos seguintes",
    "calendar.scope.all": "Todos os eventos",
    "calendar.scope.editTitle": "Editar evento recorrente",
    "calendar.scope.rsvpTitle": "Responder a evento recorrente",
    "calendar.phone.title": "Sincronizar com o celular",
    "calendar.phone.intro": "Veja seus eventos do Bundle no Calendário da Apple, Google Agenda, Outlook ou qualquer app de agenda.",
    "calendar.phone.subscribe": "Link de assinatura",
    "calendar.phone.subscribeHelp": "Adicione como agenda assinada: no iPhone, Ajustes → Apps → Calendário → Contas de Calendário → Adicionar Conta → Outra → Adicionar Calendário Assinado; no Google Agenda, Outras agendas → Do URL. É só leitura, e o Google atualiza a cada algumas horas.",
    "calendar.phone.copy": "Copiar link",
    "calendar.phone.copied": "Copiado",
    "calendar.phone.open": "Abrir no app de agenda",
    "calendar.phone.reset": "Gerar novo link",
    "calendar.phone.secret": "Quem tiver este link vê seus eventos. Gere um novo se ele vazar; o antigo para de funcionar.",
    "calendar.phone.dav": "Conta de calendário (CalDAV)",
    "calendar.phone.davHelp": "Nos dois sentidos: eventos que você cria ou muda no calendário do celular voltam para o Bundle. No iPhone: Ajustes → Apps → Calendário → Contas de Calendário → Adicionar Conta → Outra → Adicionar Conta CalDAV; no Mac: Ajustes do Sistema → Contas de Internet → Adicionar Outra Conta → Conta CalDAV. No Android, use o DAVx5.",
    "calendar.phone.davCreate": "Criar senha de app",
    "calendar.phone.davOff": "Desativar",
    "calendar.phone.davServer": "Servidor",
    "calendar.phone.davUser": "Nome de usuário",
    "calendar.phone.davPassword": "Senha",
    "calendar.phone.davOnce": "Copie a senha agora: ela não aparece de novo. Cada dispositivo tem a sua; as outras continuam funcionando.",
    "calendar.phone.device": "Sincronizar com a agenda do celular",
    "calendar.phone.deviceHint": [{"type":0,"value":"Os eventos de "},{"type":1,"value":"workspace"},{"type":0,"value":" aparecem no Google Agenda e em outros apps de agenda deste celular, e o que você muda lá volta para o Bundle."}],
    "calendar.phone.deviceDenied": "Permita o acesso à agenda para o Bundle nas configurações do Android para sincronizar.",
    "calendar.more": [{"type":0,"value":"Mais "},{"type":1,"value":"count"}],
    "calendar.moreActions": "Mais",
    "calendar.booking.title": "Páginas de agendamento",
    "calendar.booking.copyLink": "Copiar link",
    "calendar.booking.linkCopied": "Link copiado",
    "calendar.booking.share": "Compartilhar",
    "calendar.booking.open": "Abrir página de agendamento",
    "calendar.booking.pause": "Pausar",
    "calendar.booking.resume": "Retomar",
    "calendar.booking.paused": "Pausada",
    "calendar.booking.empty": "Nenhuma página de agendamento ainda",
    "calendar.booking.emptyHint": "Crie páginas de agendamento no Bundle na web ou no app para computador e compartilhe-as daqui.",
    "calendar.booking.footer": "Crie e edite páginas na web ou no app para computador.",
    "calendar.booking.loadFailed": "Não foi possível carregar suas páginas de agendamento.",
    "calendar.booking.updateFailed": "Não foi possível atualizar a página de agendamento.",
    "calendar.booking.bookedVia": [{"type":0,"value":"Agendado por "},{"type":1,"value":"page"}],
    "calendar.booking.minutes": [{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "calendar.booking.hours": [{"type":1,"value":"hours"},{"type":0,"value":" h"}],
    "calendar.booking.hoursMinutes": [{"type":1,"value":"hours"},{"type":0,"value":" h "},{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "calendar.booking.location.bundleMeeting": "Reunião do Bundle",
    "calendar.booking.location.inPerson": "Presencial",
    "calendar.booking.location.phone": "Ligação",
    "calendar.showAsFree": "Mostrar como livre",
    "calendar.event.title": "Adicionar título",
    "calendar.event.when": "Quando",
    "calendar.event.starts": "Início",
    "calendar.event.ends": "Fim",
    "calendar.event.location": "Adicionar local",
    "calendar.event.description": "Adicionar descrição",
    "calendar.event.guests": "Adicionar convidados",
    "calendar.event.guestsHelp": "Membros ou endereços de e-mail",
    "calendar.event.huddleHelp": "Um link do Bundle Meet no convite",
    "calendar.event.outsideGuests": "Convidados de fora do workspace recebem o convite por e-mail",
    "calendar.event.guestsPlaceholder": "Adicionar convidados — membros ou e-mails",
    "calendar.event.optional": "Opcional",
    "calendar.event.organizer": "Organizador",
    "calendar.event.huddle": "Adicionar Meet",
    "calendar.event.joinHuddle": "Entrar na reunião",
    "calendar.event.visibility.attendees": "Somente convidados",
    "calendar.event.visibility.workspace": "Todos no workspace",
    "calendar.event.inviteFrom": "Enviar convites de",
    "calendar.event.reminder": "Lembrar-me",
    "calendar.event.reminderMinutes": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" minuto antes"}]},"other":{"value":[{"type":7},{"type":0,"value":" minutos antes"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.reminder.none": "Sem lembrete",
    "calendar.reminder.atStart": "No horário do evento",
    "calendar.reminder.hours": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" hora antes"}]},"other":{"value":[{"type":7},{"type":0,"value":" horas antes"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.reminder.days": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" dia antes"}]},"other":{"value":[{"type":7},{"type":0,"value":" dias antes"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.reminder.sameDayAt": [{"type":0,"value":"No dia, às "},{"type":1,"value":"time"}],
    "calendar.reminder.daysBeforeAt": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Na véspera, às "},{"type":1,"value":"time"}]},"other":{"value":[{"type":7},{"type":0,"value":" dias antes, às "},{"type":1,"value":"time"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.reminder.email": "Também me enviar por e-mail",
    "calendar.reminder.title": "Notificação",
    "calendar.event.save": "Salvar",
    "calendar.event.delete": "Excluir evento",
    "calendar.event.deleteOccurrence": "Excluir somente este evento",
    "calendar.event.deleteFollowing": "Excluir este e os eventos seguintes",
    "calendar.event.deleteSeries": "Excluir todos os eventos",
    "calendar.event.edit": "Editar evento",
    "calendar.repeat": "Repetir",
    "calendar.repeat.none": "Não se repete",
    "calendar.repeat.daily": "Todos os dias",
    "calendar.repeat.weekly": "Semanalmente",
    "calendar.repeat.weekdays": "Todos os dias úteis (seg–sex)",
    "calendar.repeat.monthly": "Mensalmente",
    "calendar.repeat.yearly": "Anualmente",
    "calendar.rsvp.question": "Vai participar?",
    "calendar.rsvp.accepted": "Sim",
    "calendar.rsvp.declined": "Não",
    "calendar.rsvp.tentative": "Talvez",
    "calendar.rsvp.needsAction": "Aguardando",
    "calendar.guests.summary": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" convidado"}]},"other":{"value":[{"type":7},{"type":0,"value":" convidados"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.empty": "Nada agendado",
    "calendar.loadFailed": "Não foi possível carregar a agenda",
    "calendar.error.noTitle": "Adicione um título",
    "calendar.error.endBeforeStart": "O evento precisa terminar depois de começar",
    "calendar.error.saveFailed": "Não foi possível salvar. Tente de novo.",
    "calendar.event.imported": "Importado do Google Agenda",
    "calendar.event.joinMeet": "Participar com o Google Meet",
    "calendar.event.joinVideo": "Entrar na videochamada",
    "calendar.mine": "Minhas agendas",
    "calendar.fromGoogle": "do Google",
    "calendar.googleSync": "O Google Agenda continua sincronizando aqui até que a sincronização com o Google seja interrompida.",
    "calendar.repeat.custom": "Personalizar…",
    "calendar.repeat.customTitle": "Recorrência personalizada",
    "calendar.repeat.every": "Repetir a cada",
    "calendar.repeat.every.daily": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Todos os dias"}]},"other":{"value":[{"type":0,"value":"A cada "},{"type":7},{"type":0,"value":" dias"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.every.weekly": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Semanalmente"}]},"other":{"value":[{"type":0,"value":"A cada "},{"type":7},{"type":0,"value":" semanas"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.every.weeklyOn": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Semanalmente: "},{"type":1,"value":"days"}]},"other":{"value":[{"type":0,"value":"A cada "},{"type":7},{"type":0,"value":" semanas: "},{"type":1,"value":"days"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.every.monthly": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Mensalmente"}]},"other":{"value":[{"type":0,"value":"A cada "},{"type":7},{"type":0,"value":" meses"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.every.yearly": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Anualmente"}]},"other":{"value":[{"type":0,"value":"A cada "},{"type":7},{"type":0,"value":" anos"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.until": [{"type":0,"value":"até "},{"type":1,"value":"date"}],
    "calendar.repeat.times": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" vez"}]},"other":{"value":[{"type":7},{"type":0,"value":" vezes"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.repeat.unit.daily": "dia",
    "calendar.repeat.units.daily": "dias",
    "calendar.repeat.unit.weekly": "semana",
    "calendar.repeat.units.weekly": "semanas",
    "calendar.repeat.unit.monthly": "mês",
    "calendar.repeat.units.monthly": "meses",
    "calendar.repeat.unit.yearly": "ano",
    "calendar.repeat.units.yearly": "anos",
    "calendar.repeat.on": "Repetir em",
    "calendar.repeat.ends": "Termina",
    "calendar.repeat.endsNever": "Nunca",
    "calendar.repeat.endsOn": "Em",
    "calendar.repeat.endsAfter": "Após",
    "calendar.repeat.occurrence": "ocorrência",
    "calendar.repeat.occurrences": "ocorrências",
    "calendar.event.timeZone": "Fuso horário",
    "calendar.event.timeZoneHelp": "Os horários aparecem neste fuso. Os convidados veem no deles.",
    "calendar.event.markOptional": "Marcar como opcional",
    "calendar.event.markRequired": "Marcar como obrigatório",
    "calendar.event.you": [{"type":1,"value":"name"},{"type":0,"value":" (você)"}],
    "calendar.meetSwap.joinLine": "Entrar na reunião do Bundle",
    "calendar.meetSwap.inviteNote": "Esta reunião foi transferida para o Bundle. O link do Google Meet não vale mais.",
    "calendar.meetSwap.answerKept": "Sua resposta: mantida",
    "calendar.meetSwap.oldLink": "Link antigo do Google Meet",
    "calendar.meetSwap.lockedByAdmin": [{"type":0,"value":"Ativado para "},{"type":1,"value":"workspace"},{"type":0,"value":" por um administrador."}],
    "calendar.meetSwap.activityTitle": "Suas reuniões foram transferidas para o Bundle",
    "calendar.meetSwap.activityBody": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" evento agora usa uma reunião do Bundle em vez do Google Meet."}]},"other":{"value":[{"type":7},{"type":0,"value":" eventos agora usam reuniões do Bundle em vez do Google Meet."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.skip.googleScope": "Um administrador precisa permitir que o Bundle edite agendas",
    "calendar.meetSwap.skip.googleError": "O Google não aceitou a alteração",
    "calendar.meetSwap.skip.notOrganizer": "Você não organiza mais este evento",
    "calendar.meetSwap.skip.noMeet": "Não tem mais link do Google Meet",
    "calendar.meetSwap.skip.ended": "Já terminou",
    "calendar.meetSwap.skip.gone": "Excluído",
    "calendar.meetSwap.skip.noMailbox": "Nenhuma caixa de e-mail para enviar aos convidados",
    "calendar.meetSwap.skip.mailError": "Não foi possível enviar o convite atualizado",
    "calendar.meetSwap.prompt.title": "Usar uma reunião do Bundle?",
    "calendar.meetSwap.prompt.body": "Os convidados entram por um link no navegador, sem conta Google. Vamos enviar o novo link por email.",
    "calendar.meetSwap.prompt.justThis": "Só este evento",
    "calendar.meetSwap.prompt.justThisHint": "Todas as repetições",
    "calendar.meetSwap.prompt.upcoming": "Todos os meus próximos eventos",
    "calendar.meetSwap.prompt.upcomingCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" evento que você organiza usa o Google Meet"}]},"other":{"value":[{"type":7},{"type":0,"value":" eventos que você organiza usam o Google Meet"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.prompt.always": "Sempre usar reuniões do Bundle nos novos eventos que eu organizar",
    "calendar.meetSwap.prompt.alwaysShort": "Sempre nos novos eventos que eu organizar",
    "calendar.meetSwap.prompt.move": "Mover para o Bundle",
    "calendar.meetSwap.prompt.notNow": "Agora não",
    "calendar.meetSwap.useBundle": "Usar uma reunião do Bundle",
    "calendar.meetSwap.confirm.title": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Mover "},{"type":7},{"type":0,"value":" evento para reuniões do Bundle?"}]},"other":{"value":[{"type":0,"value":"Mover "},{"type":7},{"type":0,"value":" eventos para reuniões do Bundle?"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.confirm.body": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" convidado recebe um convite atualizado com o novo link. As respostas continuam como estão."}]},"other":{"value":[{"type":7},{"type":0,"value":" convidados recebem um convite atualizado com o novo link. As respostas continuam como estão."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.confirm.notify": "Mover e avisar convidados",
    "calendar.meetSwap.confirm.silent": "Não avisar convidados",
    "calendar.meetSwap.moved": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" evento movido para o Bundle. Os convidados estão recebendo o novo link."}]},"other":{"value":[{"type":7},{"type":0,"value":" eventos movidos para o Bundle. Os convidados estão recebendo o novo link."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.undo": "Desfazer",
    "calendar.meetSwap.settings.section": "Videochamadas",
    "calendar.meetSwap.settings.toggle": "Adicionar uma reunião do Bundle aos novos eventos que eu organizar",
    "calendar.meetSwap.settings.toggleHint": "Quando o evento tem convidados. As páginas de agendamento também usam.",
    "calendar.meetSwap.settings.moving": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Movendo "},{"type":7},{"type":0,"value":" evento para reuniões do Bundle"}]},"other":{"value":[{"type":0,"value":"Movendo "},{"type":7},{"type":0,"value":" eventos para reuniões do Bundle"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.settings.progress": [{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "calendar.meetSwap.settings.progressHint": "Os convidados recebem os convites atualizados aos poucos. Você pode fechar o Bundle; isso continua.",
    "calendar.meetSwap.settings.restore": "Voltar para os links do Google Meet",
    "calendar.meetSwap.settings.restoreHint": "Para os eventos movidos nos últimos 30 dias. Os convidados recebem outra atualização.",
    "calendar.meetSwap.settings.restoreAction": "Restaurar…",
    "calendar.meetSwap.settings.restoreConfirm": "Voltar para os links do Google Meet?",
    "calendar.meetSwap.settings.skipped": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" evento não pôde ser alterado."}]},"other":{"value":[{"type":7},{"type":0,"value":" eventos não puderam ser alterados."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.policy.title": "Videochamadas em eventos da agenda",
    "calendar.meetSwap.policy.member": "Cada pessoa escolhe",
    "calendar.meetSwap.policy.memberHint": "Os membros recebem a oferta uma vez e têm a própria configuração.",
    "calendar.meetSwap.policy.bundle": "Reuniões do Bundle para todos",
    "calendar.meetSwap.policy.bundleHint": "Os novos eventos que os membros organizam ganham uma reunião do Bundle, e os links do Google Meet são substituídos. Os membros não podem desativar.",
    "calendar.meetSwap.policy.moving": "Movendo os eventos dos membros",
    "calendar.meetSwap.policy.progress": [{"type":1,"value":"people"},{"type":0,"value":" de "},{"type":1,"value":"peopleTotal"},{"type":0,"value":" pessoas · "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"},{"type":0,"value":" eventos"}],
    "calendar.meetSwap.policy.progressHint": "Roda em segundo plano, algumas pessoas por vez. Os convidados recebem os convites aos poucos, então pode levar algumas horas.",
    "calendar.meetSwap.policy.pause": "Pausar",
    "calendar.meetSwap.policy.resume": "Retomar",
    "calendar.meetSwap.policy.restoreAll": "Voltar para os links do Google Meet para todos",
    "calendar.meetSwap.policy.restoreAllHint": "Para os eventos que esta política moveu nos últimos 30 dias. Os convidados recebem outra atualização.",
    "calendar.meetSwap.policy.confirmTitle": [{"type":0,"value":"Usar reuniões do Bundle para todos em "},{"type":1,"value":"workspace"},{"type":0,"value":"?"}],
    "calendar.meetSwap.policy.confirmBody": "Os novos eventos que os membros organizam ganham uma reunião do Bundle. Os membros não podem desativar. Roda em segundo plano.",
    "calendar.meetSwap.policy.moveAndEmail": "Mover os eventos existentes e avisar convidados",
    "calendar.meetSwap.policy.moveSilent": "Mover os eventos existentes sem avisar",
    "calendar.meetSwap.policy.newOnly": "Só os novos eventos",
    "calendar.rsvp.failed": "Não foi possível enviar sua resposta. Tente de novo.",
    "calendar.loading": "Carregando",
    "calendar.bookingPages.title": "Páginas de agendamento",
    "calendar.bookingPages.empty": "Nenhuma página de agendamento ainda",
    "calendar.bookingPages.emptyHint": "Crie páginas de agendamento no Bundle pela web ou pelo app para computador. Elas aparecem aqui para você compartilhar.",
    "calendar.bookingPages.loadFailed": "Não foi possível carregar suas páginas de agendamento.",
    "calendar.bookingPages.updateFailed": "Não foi possível atualizar a página de agendamento. Tente de novo.",
    "calendar.bookingPages.copyLink": "Copiar link",
    "calendar.bookingPages.linkCopied": "Link copiado",
    "calendar.bookingPages.share": "Compartilhar",
    "calendar.bookingPages.shareNamed": [{"type":0,"value":"Compartilhar "},{"type":1,"value":"title"}],
    "calendar.bookingPages.moreNamed": [{"type":0,"value":"Mais opções de "},{"type":1,"value":"title"}],
    "calendar.bookingPages.open": "Abrir página de agendamento",
    "calendar.bookingPages.pause": "Pausar",
    "calendar.bookingPages.resume": "Retomar",
    "calendar.bookingPages.paused": "Pausada",
    "calendar.bookingPages.minutes": [{"type":1,"value":"minutes"},{"type":0,"value":" min"}],
    "calendar.bookingPages.location.bundleMeeting": "Reunião do Bundle",
    "calendar.bookingPages.location.inPerson": "Presencial",
    "calendar.bookingPages.location.phone": "Ligação",
    "calendar.event.bookedVia": [{"type":0,"value":"Agendado por "},{"type":1,"value":"title"}],
    "calendar.event.showAsFree": "Mostrar como livre",
    "calendar.moreOptions": "Mais opções",
    "import.timeline.title": "Passo a passo",
    "import.timeline.started": [{"type":0,"value":"Começou a ler o "},{"type":1,"value":"source"}],
    "import.timeline.people": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Encontrou "},{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":0,"value":"Encontrou "},{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.conversations": [{"type":0,"value":"Encontrou "},{"type":1,"value":"channels"},{"type":0,"value":" canais e "},{"type":1,"value":"dms"},{"type":0,"value":" mensagens diretas"}],
    "import.timeline.pages": [{"type":0,"value":"Encontrou páginas: "},{"type":1,"value":"pages"},{"type":0,"value":" · bancos de dados: "},{"type":1,"value":"databases"}],
    "import.timeline.sorting": "Organizando as páginas com IA",
    "import.timeline.sorted": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"A IA sugeriu "},{"type":7},{"type":0,"value":" seção"}]},"other":{"value":[{"type":0,"value":"A IA sugeriu "},{"type":7},{"type":0,"value":" seções"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.sortSkipped": "Manteve a organização original (sem organização por IA)",
    "import.timeline.review": "Pronto para você revisar",
    "import.timeline.importing": "Importação iniciada",
    "import.timeline.channel": [{"type":0,"value":"Criou "},{"type":1,"value":"name"}],
    "import.timeline.history": [{"type":1,"value":"name"},{"type":0,"value":": "},{"type":1,"value":"count"},{"type":0,"value":" mensagens lidas até agora"}],
    "import.timeline.files": [{"type":1,"value":"name"},{"type":0,"value":": "},{"type":1,"value":"count"},{"type":0,"value":" arquivos copiados até agora"}],
    "import.timeline.channelDone": [{"type":1,"value":"name"},{"type":0,"value":": "},{"type":1,"value":"count"},{"type":0,"value":" mensagens importadas"}],
    "import.timeline.page": [{"type":0,"value":"Importou a página "},{"type":1,"value":"title"}],
    "import.timeline.database": [{"type":0,"value":"Criou o banco de dados "},{"type":1,"value":"title"}],
    "import.timeline.rows": [{"type":1,"value":"title"},{"type":0,"value":": "},{"type":1,"value":"count"},{"type":0,"value":" linhas adicionadas"}],
    "import.timeline.canvas": [{"type":0,"value":"O canvas do Slack "},{"type":1,"value":"title"},{"type":0,"value":" virou uma página"}],
    "import.timeline.filesRepaired": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Links de arquivos corrigidos em "},{"type":7},{"type":0,"value":" mensagem"}]},"other":{"value":[{"type":0,"value":"Links de arquivos corrigidos em "},{"type":7},{"type":0,"value":" mensagens"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.slack.repairLinks": "Só trazer arquivos que ainda apontam para o Slack",
    "import.slack.repairLinks.note": "Nada novo é importado: mensagens que já estão aqui e ainda apontam para arquivos do Slack recebem esses arquivos (canvas viram páginas), e a linha do tempo diz por que algum não veio.",
    "import.timeline.repairing": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" mensagem ainda aponta para arquivos do Slack"}]},"other":{"value":[{"type":7},{"type":0,"value":" mensagens ainda apontam para arquivos do Slack"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.renamed": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Corrigiu o nome de "},{"type":7},{"type":0,"value":" pessoa que aparecia como o @usuário do Slack"}]},"other":{"value":[{"type":0,"value":"Corrigiu os nomes de "},{"type":7},{"type":0,"value":" pessoas que apareciam como o @usuário do Slack"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.fileNotFound": [{"type":1,"value":"name"},{"type":0,"value":": o Slack não tem mais este arquivo (apagado, ou este token não o vê)"}],
    "import.timeline.fileNoAccess": [{"type":1,"value":"name"},{"type":0,"value":": o Slack não entregou este arquivo (oculto pelos limites do plano, ou compartilhado de outro espaço)"}],
    "import.timeline.fileTooBig": [{"type":1,"value":"name"},{"type":0,"value":": maior que 1 GB, ficou como link do Slack"}],
    "import.timeline.canvasUnreadable": [{"type":1,"value":"name"},{"type":0,"value":": o Slack não entregou o conteúdo deste canvas, ficou como link do Slack"}],
    "import.timeline.fileFailed": [{"type":1,"value":"name"},{"type":0,"value":": a cópia falhou, ficou como link do Slack"}],
    "import.repairTitle": "Arquivos do Slack",
    "import.timeline.rateLimited": [{"type":0,"value":"A origem pediu para ir mais devagar: aguardando "},{"type":1,"value":"seconds"},{"type":0,"value":" s"}],
    "import.timeline.retrying": [{"type":0,"value":"A tentativa "},{"type":1,"value":"attempt"},{"type":0,"value":" falhou, tentando de novo: "},{"type":1,"value":"message"}],
    "import.timeline.done": "Importação concluída",
    "import.timeline.failed": [{"type":0,"value":"Parou: "},{"type":1,"value":"message"}],
    "import.timeline.cancelled": "Interrompida por você",
    "import.slack.person.invite": "Convidar para o Bundle",
    "import.slack.person.guest": [{"type":0,"value":"Convidar como convidado externo ("},{"type":1,"value":"org"},{"type":0,"value":")"}],
    "import.slack.person.otherCompany": "outra empresa",
    "import.slack.person.deactivated": "Manter como perfil desativado",
    "import.slack.inviteAll": "Convidar todos que faltam",
    "import.slack.external": [{"type":0,"value":"Externo · "},{"type":1,"value":"org"}],
    "import.slack.apps": "Conversas com apps",
    "import.slack.apps.body": "Desligadas por padrão. Cada uma que você marcar vem como um canal privado só seu (como #notion-dm), com as mensagens do app no nome dele.",
    "import.slack.allApps": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Importar a conversa com um app"}]},"other":{"value":[{"type":0,"value":"Importar todas as "},{"type":7},{"type":0,"value":" conversas com apps"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.invited": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Convidou "},{"type":7},{"type":0,"value":" pessoa (o histórico é dela ao entrar)"}]},"other":{"value":[{"type":0,"value":"Convidou "},{"type":7},{"type":0,"value":" pessoas (o histórico é delas ao entrar)"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.guests": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Convidou "},{"type":7},{"type":0,"value":" convidado externo"}]},"other":{"value":[{"type":0,"value":"Convidou "},{"type":7},{"type":0,"value":" convidados externos"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.timeline.deactivatedPeople": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Manteve "},{"type":7},{"type":0,"value":" perfil desativado"}]},"other":{"value":[{"type":0,"value":"Manteve "},{"type":7},{"type":0,"value":" perfis desativados"}]}},"offset":0,"pluralType":"cardinal"}],
    "import.rescan": "Ler de novo",
    "import.rescanFailed": "Não foi possível ler a origem de novo. Tente de novo.",
    "import.slack.sendInvites": "Enviar os convites por email agora",
    "import.slack.sendInvites.off": "Ninguém recebe email. As contas e os convites pendentes são criados mesmo assim; envie depois em Convites (Reenviar).",
    "import.slack.restrictExternal": "Pessoas de outras empresas só acessam os canais em que estavam",
    "newMessage.title": "Nova mensagem",
    "newMessage.to": "Para:",
    "newMessage.toPlaceholder": "Digite um nome",
    "newMessage.limit": [{"type":0,"value":"Conversas em grupo podem ter até "},{"type":1,"value":"max"},{"type":0,"value":" pessoas."}],
    "newMessage.existing": [{"type":0,"value":"Continue sua conversa com "},{"type":1,"value":"name"}],
    "newMessage.start": [{"type":0,"value":"Este é o começo da sua conversa com "},{"type":1,"value":"name"}],
    "newMessage.open": "Abrir conversa",
    "newMessage.recent": "Conversas recentes",
    "newMessage.noConversations": "Nenhuma conversa encontrada",
    "newMessage.failed": "Não foi possível iniciar a conversa. Tente novamente.",
    "newMessage.offline": "Para iniciar uma nova conversa é preciso estar conectado.",
    "sidebar.moreConversations": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Mais "},{"type":7},{"type":0,"value":" conversa…"}]},"other":{"value":[{"type":0,"value":"Mais "},{"type":7},{"type":0,"value":" conversas…"}]}},"offset":0,"pluralType":"cardinal"}],
    "dm.close": "Fechar conversa",
    "dm.addPeople": "Adicionar pessoas",
    "dm.addPeopleHint": "Adicionar pessoas inicia uma nova conversa. Esta continua como está.",
    "dm.convert": "Converter em canal privado",
    "dm.convertHint": "Todos desta conversa passam a ser membros do canal, e o histórico é mantido.",
    "dm.convertName": "Nome do canal",
    "dm.convertAction": "Converter",
    "mail.notify.title": "Novos e-mails",
    "mail.notify.enabled": "Notificar sobre novos e-mails",
    "mail.notify.priority": "Conversas prioritárias",
    "mail.notify.priorityHelp": "Respostas que as pessoas aguardam, conversas com estrela e remetentes que você marcou, de qualquer aba.",
    "mail.notify.tabsAlso": "Também tudo nestas abas",
    "mail.notify.tabs": "Somente para estas abas",
    "mail.notify.uncategorized": "Sem categoria",
    "mail.notify.help": "Spam nunca notifica. O modo Não perturbe também pausa o resto. Códigos de verificação sempre notificam.",
    "mail.settings.provider": [{"type":0,"value":"DNS na "},{"type":1,"value":"name"}],
    "mail.settings.providerUnknown": "Crie estes registros onde o DNS do seu domínio é gerenciado.",
    "mail.settings.openDns": "Abrir configurações de DNS",
    "mail.settings.zoneFile": "Baixar arquivo de zona",
    "mail.settings.zoneFile.help": "Um arquivo com todos os registros acima, para importar no seu provedor de DNS em vez de copiar um por um.",
    "mail.settings.zoneFile.cloudflare": "Na Cloudflare: DNS → Registros → Importar e exportar → Importar e escolha este arquivo. Depois apague os registros antigos que ele substitui: os outros MX (por exemplo route1/2/3.mx.cloudflare.net do Email Routing), o TXT de SPF antigo (o v=spf1 sem _spf.bundle.direct) e o _dmarc antigo.",
    "mail.settings.zoneFile.other": [{"type":0,"value":"Na "},{"type":1,"value":"name"},{"type":0,"value":": use a opção de importar da página de DNS e escolha este arquivo. Depois apague os registros antigos que ele substitui: outros MX, o TXT de SPF antigo e o _dmarc antigo."}],
    "mail.sync.title": "Importar e-mails",
    "mail.sync.help": "Traga seus e-mails para o Bundle e mantenha tudo sincronizado enquanto você muda os registros MX. Respostas a conversas antigas caem na conversa certa. E-mails importados nunca notificam ninguém.",
    "mail.sync.connectGoogle": "Conectar Google Workspace",
    "mail.sync.addImap": "Adicionar conta IMAP",
    "mail.sync.noMailboxes": "Crie uma caixa de e-mail primeiro: os e-mails importados vão para uma delas.",
    "mail.sync.connect": "Conectar",
    "mail.sync.google.title": "Google Workspace",
    "mail.sync.google.step1": "1. No Google Cloud, crie uma conta de serviço com uma chave JSON e ative a Gmail API, a Admin SDK API, a Groups Settings API e a Google Calendar API.",
    "mail.sync.google.step2": "2. No Google Admin console, vá em Segurança → Controles de API → Delegação em todo o domínio e adicione o ID do cliente da conta de serviço com estes escopos:",
    "mail.sync.google.scopes": "gmail.readonly, admin.directory.user.readonly, admin.directory.domain.readonly, admin.directory.group.readonly, apps.groups.settings, calendar.readonly",
    "mail.sync.google.copyScopes": "Copiar escopos",
    "mail.sync.google.step3": "3. Cole a chave aqui com o endereço de um superadministrador. Os e-mails de cada pessoa vão para a caixa com o mesmo nome, e uma caixa compartilhada pode ser lida por quem a delegação do Gmail permite (o gmail.readonly lista os delegados).",
    "mail.sync.google.bundleClient": [{"type":0,"value":"Ou autorize o ID do cliente do Bundle "},{"type":1,"value":"clientId"},{"type":0,"value":" com os mesmos escopos e deixe a chave em branco."}],
    "mail.sync.google.copyClientId": "Copiar ID do cliente",
    "mail.sync.google.adminEmail": "Endereço do superadministrador",
    "mail.sync.google.key": "Chave da conta de serviço (JSON)",
    "mail.sync.google.keyHelp": "Guardada criptografada. O Bundle só lê os e-mails.",
    "mail.sync.google.keyOptional": "Opcional com o ID do cliente do Bundle. Guardada criptografada. O Bundle só lê os e-mails.",
    "mail.sync.google.users": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" usuário"}]},"other":{"value":[{"type":7},{"type":0,"value":" usuários"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.dontImport": "Não importar",
    "mail.sync.google.mailboxFor": [{"type":0,"value":"Caixa de "},{"type":1,"value":"email"}],
    "mail.sync.imap.title": "Conta IMAP",
    "mail.sync.imap.into": "Importar para",
    "mail.sync.imap.username": "E-mail ou usuário",
    "mail.sync.imap.password": "Senha",
    "mail.sync.imap.passwordHelp": "A maioria dos provedores pede uma senha de app quando a verificação em duas etapas está ativa. Guardada criptografada.",
    "mail.sync.imap.appPassword": [{"type":0,"value":"Use uma senha de app: "},{"type":1,"value":"url"},{"type":0,"value":". Guardada criptografada."}],
    "mail.sync.imap.host": "Servidor IMAP",
    "mail.sync.imap.port": "Porta",
    "mail.sync.imap.security": "Segurança",
    "mail.sync.imap.security.tls": "SSL/TLS",
    "mail.sync.imap.security.starttls": "STARTTLS",
    "mail.sync.imap.security.none": "Nenhuma",
    "mail.sync.imap.folders": "Pastas para importar",
    "mail.sync.imap.folder": [{"type":1,"value":"path"},{"type":0,"value":" ("},{"type":1,"value":"count"},{"type":0,"value":")"}],
    "mail.sync.imap.check": "Verificar",
    "mail.sync.imap.start": "Começar importação",
    "mail.sync.imap.newPassword": "Nova senha",
    "mail.sync.imap.updatePassword": "Atualizar senha",
    "mail.sync.phase.connecting": "Conectando",
    "mail.sync.phase.listing": "Contando mensagens",
    "mail.sync.phase.importing": "Importando",
    "mail.sync.phase.syncing": "Sincronizando",
    "mail.sync.phase.paused": "Pausada",
    "mail.sync.phase.error": "Precisa de atenção",
    "mail.sync.into": [{"type":0,"value":"para "},{"type":1,"value":"address"}],
    "mail.sync.finding": "Procurando mensagens…",
    "mail.sync.counting": [{"type":6,"value":"total","options":{"one":{"value":[{"type":7},{"type":0,"value":" mensagem encontrada até agora"}]},"other":{"value":[{"type":7},{"type":0,"value":" mensagens encontradas até agora"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.counts": [{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"},{"type":0,"value":" mensagens · "},{"type":1,"value":"duplicates"},{"type":0,"value":" já estavam aqui · "},{"type":1,"value":"failed"},{"type":0,"value":" com falha"}],
    "mail.sync.accountCounts": [{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "mail.sync.lastSync": [{"type":0,"value":"verificado "},{"type":1,"value":"time"}],
    "mail.sync.pause": "Pausar",
    "mail.sync.resume": "Retomar",
    "mail.sync.remove": "Remover",
    "mail.sync.removeConfirm": "Parar de sincronizar? Os e-mails já importados ficam.",
    "mail.sync.refused": [{"type":1,"value":"detail"}],
    "mail.sync.forbidden": "Só administradores e membros da caixa podem fazer isso.",
    "mail.sync.failed": "Algo deu errado. Tente de novo.",
    "mail.sync.google.reviewTitle": "Escolha de quem importar os e-mails",
    "mail.sync.google.reviewHelp": "O Bundle encontrou estas pessoas no seu Google Workspace e sugeriu uma caixa para cada uma. Nada é importado até você começar.",
    "mail.sync.google.newMailbox": [{"type":0,"value":"Nova caixa "},{"type":1,"value":"address"}],
    "mail.sync.google.newMailboxHelp": "Uma caixa nova é da própria pessoa. Para quem ainda não entrou, ninguém consegue ler até ela entrar; aí a caixa passa a ser dela.",
    "mail.sync.google.start": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Importar "},{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":0,"value":"Importar "},{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.phase.review": "Aguardando você",
    "composer.command.appUsage": [{"type":1,"value":"usage"}],
    "composer.appCommand.failed": [{"type":0,"value":"Não foi possível executar "},{"type":1,"value":"command"},{"type":0,"value":". Tente de novo."}],
    "workflow.run.failed": [{"type":0,"value":"Não foi possível iniciar "},{"type":1,"value":"name"},{"type":0,"value":". Tente de novo."}],
    "workflow.menu.title": "Fluxos de trabalho",
    "workflow.menu.empty": "Ainda não há fluxos de trabalho neste canal.",
    "workflow.menu.badge": "Fluxo de trabalho",
    "composer.appAction.failed": "O app não respondeu. Tente de novo.",
    "composer.appCommand.running": [{"type":0,"value":"Executando "},{"type":1,"value":"command"},{"type":0,"value":"…"}],
    "message.ephemeral.onlyYou": "Visível apenas para você",
    "message.ephemeral.dismiss": "Dispensar",
    "appModal.error.required": "Preencha este campo obrigatório.",
    "appModal.error.tooShort": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Digite pelo menos "},{"type":7},{"type":0,"value":" caractere."}]},"other":{"value":[{"type":0,"value":"Digite pelo menos "},{"type":7},{"type":0,"value":" caracteres."}]}},"offset":0,"pluralType":"cardinal"}],
    "appModal.error.tooLong": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Use no máximo "},{"type":7},{"type":0,"value":" caractere."}]},"other":{"value":[{"type":0,"value":"Use no máximo "},{"type":7},{"type":0,"value":" caracteres."}]}},"offset":0,"pluralType":"cardinal"}],
    "appModal.error.tooMany": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Escolha até "},{"type":7},{"type":0,"value":" opção."}]},"other":{"value":[{"type":0,"value":"Escolha até "},{"type":7},{"type":0,"value":" opções."}]}},"offset":0,"pluralType":"cardinal"}],
    "appModal.appError": [{"type":1,"value":"text"}],
    "appModal.unreachable": "Tivemos problemas para conectar. Tentar de novo?",
    "appModal.cancel": "Cancelar",
    "appModal.submit": "Enviar",
    "appModal.back": "Voltar",
    "appModal.optional": "(opcional)",
    "blockKit.select.placeholder": "Selecione uma opção",
    "blockKit.multiSelect.placeholder": "Selecione opções",
    "blockKit.users.placeholder": "Selecione uma pessoa",
    "blockKit.multiUsers.placeholder": "Selecione pessoas",
    "blockKit.conversations.placeholder": "Selecione uma conversa",
    "blockKit.channels.placeholder": "Selecione um canal",
    "blockKit.date.placeholder": "Selecione uma data",
    "blockKit.time.placeholder": "Selecione um horário",
    "blockKit.overflow.label": "Mais opções",
    "blockKit.search": "Buscar",
    "blockKit.remove": [{"type":0,"value":"Remover "},{"type":1,"value":"name"}],
    "blockKit.selected": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" selecionado"}]},"other":{"value":[{"type":7},{"type":0,"value":" selecionados"}]}},"offset":0,"pluralType":"cardinal"}],
    "integrations.apps.title": "Apps",
    "integrations.apps.body": "Apps têm um usuário bot e um token para a Web API, podem adicionar comandos de barra e botões e podem ser instalados em outros workspaces com OAuth.",
    "integrations.apps.empty": "Nenhum app ainda.",
    "integrations.apps.adminsOnly": "Só proprietários e administradores do workspace podem criar apps.",
    "integrations.app.create": "Criar app",
    "integrations.app.edit": "Editar app",
    "integrations.app.save": "Salvar",
    "integrations.app.cancel": "Cancelar",
    "integrations.app.name": "Nome",
    "integrations.app.namePlaceholder": "Por exemplo: Deployer",
    "integrations.app.description": "Descrição",
    "integrations.app.scopes": "Permissões (escopos)",
    "integrations.app.redirectUrls": "URLs de redirecionamento OAuth",
    "integrations.app.redirectUrlsHelp": "Uma por linha. Necessárias para instalar o app em outros workspaces.",
    "integrations.app.interactivityUrl": "URL de interatividade",
    "integrations.app.interactivityHelp": "Cliques em botões são enviados para cá como POSTs assinados.",
    "integrations.app.commands": "Comandos de barra",
    "integrations.app.addCommand": "Adicionar comando",
    "integrations.app.removeCommand": "Remover comando",
    "integrations.app.command": "Comando",
    "integrations.app.commandUrl": "URL da requisição",
    "integrations.app.commandDescription": "Descrição curta",
    "integrations.app.commandHint": "Dica de uso",
    "integrations.app.nameEmpty": "Dê um nome ao app.",
    "integrations.app.commandInvalid": [{"type":1,"value":"command"},{"type":0,"value":": use uma barra e até 31 letras minúsculas, dígitos, - ou _."}],
    "integrations.app.commandReserved": [{"type":1,"value":"command"},{"type":0,"value":" é um comando nativo."}],
    "integrations.app.commandTaken": [{"type":1,"value":"command"},{"type":0,"value":" já está em uso."}],
    "integrations.app.commandIncomplete": "Cada comando precisa de uma URL e de uma descrição.",
    "integrations.app.urlInvalid": "Use URLs completas começando com https://.",
    "integrations.app.saveFailed": "Não foi possível salvar o app.",
    "integrations.app.failed": "Algo deu errado. Tente de novo.",
    "integrations.app.external": "Instalado de outro workspace",
    "integrations.app.meta": [{"type":1,"value":"scopes"},{"type":0,"value":" · "},{"type":1,"value":"commands"}],
    "integrations.app.commandCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" comando"}]},"other":{"value":[{"type":7},{"type":0,"value":" comandos"}]}},"offset":0,"pluralType":"cardinal"}],
    "integrations.app.scopeCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" escopo"}]},"other":{"value":[{"type":7},{"type":0,"value":" escopos"}]}},"offset":0,"pluralType":"cardinal"}],
    "integrations.app.more": "Mais ações",
    "integrations.app.showSigningSecret": "Mostrar segredo de assinatura",
    "integrations.app.rotateBotToken": "Gerar novo token do bot",
    "integrations.app.rotateClientSecret": "Gerar novo client secret",
    "integrations.app.rotateSigningSecret": "Gerar novo segredo de assinatura",
    "integrations.app.remove": "Remover",
    "integrations.app.removeTitle": "Remover app?",
    "integrations.app.removeBody": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” perde o acesso a este workspace e seus tokens param de funcionar."}],
    "integrations.app.credentialsTitle": "Credenciais do app",
    "integrations.app.credentialsBody": "Copie agora — os tokens e o client secret não serão mostrados de novo. Gere novos se vazarem.",
    "integrations.app.secretTitle": "Nova credencial",
    "integrations.app.secretBody": "Copie agora. A anterior parou de funcionar.",
    "integrations.app.signingTitle": "Segredo de assinatura",
    "integrations.app.signingBody": "Verifique o cabeçalho X-Bundle-Signature das requisições do Bundle com este segredo.",
    "integrations.app.botToken": "Token do bot",
    "integrations.app.clientId": "Client ID",
    "integrations.app.clientSecret": "Client secret",
    "integrations.app.signingSecret": "Segredo de assinatura",
    "integrations.app.copy": "Copiar",
    "integrations.app.copied": "Copiado",
    "integrations.app.done": "Concluído",
    "integrations.scope.chatWrite": "Enviar mensagens como o app",
    "integrations.scope.channelsRead": "Ver a lista de canais",
    "integrations.scope.channelsHistory": "Ler mensagens dos canais em que está",
    "integrations.scope.usersRead": "Ver as pessoas do workspace",
    "integrations.scope.reactionsWrite": "Adicionar reações com emoji",
    "integrations.scope.commands": "Adicionar comandos de barra",
    "integrations.outgoing.title": "Webhooks de saída",
    "integrations.outgoing.body": "Envie novas mensagens de canais escolhidos, ou que comecem com uma palavra-chave, para uma URL. Uma resposta com texto é publicada de volta.",
    "integrations.outgoing.empty": "Nenhum webhook de saída ainda.",
    "integrations.outgoing.add": "Adicionar webhook de saída",
    "integrations.outgoing.edit": "Editar webhook de saída",
    "integrations.outgoing.channels": "Canais",
    "integrations.outgoing.channelsHelp": "Nenhum selecionado: todos os canais públicos (aí é preciso uma palavra-chave).",
    "integrations.outgoing.triggerWords": "Palavras-chave",
    "integrations.outgoing.triggerHelp": "Separadas por vírgula. Só mensagens que começam com uma delas são enviadas.",
    "integrations.outgoing.url": "URL",
    "integrations.outgoing.needsChannelOrTrigger": "Escolha um canal ou adicione uma palavra-chave.",
    "integrations.outgoing.meta": [{"type":1,"value":"where"},{"type":0,"value":" · "},{"type":1,"value":"url"}],
    "integrations.outgoing.allPublic": "Todos os canais públicos",
    "integrations.outgoing.triggers": [{"type":0,"value":"Palavras-chave: "},{"type":1,"value":"words"}],
    "integrations.outgoing.lastError": [{"type":0,"value":"A última entrega falhou: "},{"type":1,"value":"error"}],
    "integrations.outgoing.signingSecret": "Segredo de assinatura",
    "integrations.outgoing.regenerate": "Gerar novo segredo",
    "integrations.outgoing.removeTitle": "Remover webhook de saída?",
    "integrations.outgoing.removeBody": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” deixará de receber mensagens."}],
    "oauth.title": [{"type":1,"value":"app"},{"type":0,"value":" quer acessar um workspace do Bundle"}],
    "oauth.madeBy": [{"type":0,"value":"Criado em "},{"type":1,"value":"workspace"}],
    "oauth.workspace": "Instalar em",
    "oauth.scopesTitle": "Ele poderá:",
    "oauth.noScopes": "Instalar um usuário bot (sem outras permissões)",
    "oauth.allow": "Permitir",
    "oauth.cancel": "Cancelar",
    "oauth.noWorkspaces": "É preciso ser proprietário ou administrador de um workspace para instalar apps.",
    "oauth.failed": "Este link de instalação não é válido. Peça um novo ao desenvolvedor do app.",
    "oauth.approveFailed": "Não foi possível instalar o app. Tente de novo.",
    "oauth.loading": "Carregando…",
    "settings.nav.userGroups": "Grupos de usuários",
    "userGroups.problem.nameMissing": "Dê um nome ao grupo.",
    "userGroups.problem.nameTooLong": "Use no máximo 80 caracteres no nome.",
    "userGroups.problem.descriptionTooLong": "Use no máximo 250 caracteres na descrição.",
    "userGroups.problem.handleTaken": "Uma pessoa ou outro grupo já usa esse identificador.",
    "userGroups.failed": "Não foi possível salvar o grupo de usuários.",
    "userGroups.intro": "Mencione uma equipe inteira de uma vez, como @design. Os membros de um grupo entram nos canais padrão dele.",
    "userGroups.create": "Criar grupo de usuários",
    "userGroups.edit": "Editar grupo de usuários",
    "userGroups.tab.active": "Ativos",
    "userGroups.tab.disabled": "Desativados",
    "userGroups.search": "Buscar grupos de usuários",
    "userGroups.empty": "Ainda não há grupos de usuários.",
    "userGroups.emptyDisabled": "Nenhum grupo desativado.",
    "userGroups.emptySearch": "Nenhum grupo corresponde à busca.",
    "userGroups.memberCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" membro"}]},"other":{"value":[{"type":7},{"type":0,"value":" membros"}]}},"offset":0,"pluralType":"cardinal"}],
    "userGroups.field.name": "Nome",
    "userGroups.field.namePlaceholder": "ex.: Equipe de design",
    "userGroups.field.handle": "Identificador",
    "userGroups.field.handleHelp": "As pessoas mencionam o grupo com ele, como @design.",
    "userGroups.field.description": "Descrição (opcional)",
    "userGroups.field.members": "Membros",
    "userGroups.field.membersSearch": "Adicionar pessoas",
    "userGroups.field.channels": "Canais padrão",
    "userGroups.field.channelsHelp": "Quem for adicionado ao grupo entra nesses canais.",
    "userGroups.disable": "Desativar grupo",
    "userGroups.enable": "Reativar grupo",
    "userGroups.disabledBadge": "Desativado",
    "userGroups.mine": "Você é membro",
    "userGroups.policy.label": "Quem pode gerenciar grupos de usuários",
    "userGroups.policy.everyone": "Todos, exceto convidados",
    "userGroups.policy.admins": "Somente proprietários e administradores",
    "userGroups.card.members": "Membros",
    "userGroups.card.channels": "Canais padrão",
    "userGroups.card.join": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Entrar em "},{"type":7},{"type":0,"value":" canal padrão"}]},"other":{"value":[{"type":0,"value":"Entrar em "},{"type":7},{"type":0,"value":" canais padrão"}]}},"offset":0,"pluralType":"cardinal"}],
    "userGroups.card.disabled": "Este grupo está desativado e não pode ser mencionado.",
    "userGroups.card.noMembers": "Ainda sem membros.",
    "userGroups.unknown": "Este grupo não está disponível.",
    "composer.group.members": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" membro"}]},"other":{"value":[{"type":7},{"type":0,"value":" membros"}]}},"offset":0,"pluralType":"cardinal"}],
    "profile.userGroups": "Grupos de usuários",
    "userGroups.actions": [{"type":0,"value":"Mais ações para "},{"type":1,"value":"name"}],
    "userGroups.field.channelsSearch": "Adicionar canais",
    "userGroups.field.noMatches": "Nenhum resultado",
    "userGroups.cardTitle": [{"type":0,"value":"Grupo de usuários "},{"type":1,"value":"name"}],
    "message.unfurl.remove": "Remover prévia",
    "message.unfurl.label": [{"type":0,"value":"Prévia do link: "},{"type":1,"value":"title"}],
    "message.unfurl.play": [{"type":0,"value":"Reproduzir "},{"type":1,"value":"title"}],
    "blockKit.typeMore": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Digite mais "},{"type":7},{"type":0,"value":" caractere"}]},"other":{"value":[{"type":0,"value":"Digite mais "},{"type":7},{"type":0,"value":" caracteres"}]}},"offset":0,"pluralType":"cardinal"}],
    "blockKit.searchFailed": "Não foi possível carregar as opções",
    "blockKit.noMatches": "Nenhum resultado",
    "blockKit.showMore": "Mostrar mais",
    "appHome.tab": "Início",
    "appHome.messages": "Mensagens",
    "appHome.empty": [{"type":1,"value":"app"},{"type":0,"value":" ainda não configurou a aba Início."}],
    "appHome.loading": "Carregando Início",
    "integrations.app.optionsUrl": "URL de carregamento de opções",
    "integrations.app.optionsHelp": "Menus com opções do seu app (external_select) consultam aqui enquanto a pessoa digita.",
    "integrations.app.eventsUrl": "URL de eventos",
    "integrations.app.eventsHelp": "O Bundle verifica esta URL com um desafio url_verification ao salvar e depois envia app_home_opened e os eventos assinados como JSON assinado.",
    "integrations.scope.groupsRead": "Ver os canais privados em que está",
    "integrations.scope.groupsHistory": "Ler mensagens nos canais privados em que está",
    "integrations.scope.imHistory": "Ler as próprias mensagens diretas",
    "integrations.scope.mpimHistory": "Ler mensagens nas DMs em grupo em que está",
    "integrations.scope.appMentionsRead": "Ver mensagens que o mencionam",
    "integrations.scope.reactionsRead": "Ver reações com emoji",
    "integrations.app.events": "Eventos do bot",
    "integrations.app.eventsSubscribeHelp": "Enviados para a URL de eventos nas conversas em que o app está. Assinar adiciona a permissão necessária.",
    "integrations.app.eventsNeedUrl": "Adicione uma URL de eventos para assinar eventos.",
    "integrations.app.eventsUrlFailed": "A URL de eventos não respondeu ao desafio url_verification. Ela deve responder com o valor do desafio.",
    "integrations.app.eventsLoopWarning": "O Bundle pausou os eventos deste app por um minuto porque ele continuava respondendo às próprias mensagens. Ignore eventos cujo bot_id seja o id de usuário do seu bot.",
    "integrations.app.workflowSteps": "Etapas de fluxo de trabalho",
    "integrations.app.workflowStepsHelp": "Etapas que as pessoas podem adicionar a fluxos de trabalho no Workflow Builder. Quando uma delas é executada, o Bundle envia um evento function_executed assinado para a URL de eventos.",
    "integrations.app.addStep": "Adicionar etapa",
    "integrations.app.removeStep": "Remover etapa",
    "integrations.app.stepCallbackId": "Callback ID",
    "integrations.app.stepTitle": "Título",
    "integrations.app.stepDescription": "Descrição",
    "integrations.app.stepInputs": "Entradas",
    "integrations.app.stepOutputs": "Saídas",
    "integrations.app.addStepInput": "Adicionar entrada",
    "integrations.app.addStepOutput": "Adicionar saída",
    "integrations.app.stepParamName": "Nome",
    "integrations.app.stepParamLabel": "Rótulo",
    "integrations.app.stepParamType": "Tipo",
    "integrations.app.stepParamRequired": "Obrigatório",
    "integrations.app.removeParam": "Remover",
    "integrations.app.stepIncomplete": "Cada etapa de fluxo precisa de um callback ID (letras, números, _, - ou .) e de um título, e cada entrada de um rótulo. Nomes de entradas e saídas usam letras minúsculas, números e _.",
    "integrations.app.stepDuplicate": [{"type":1,"value":"callbackId"},{"type":0,"value":" é usado por mais de uma etapa."}],
    "integrations.app.stepDuplicateParam": [{"type":1,"value":"callbackId"},{"type":0,"value":": “"},{"type":1,"value":"name"},{"type":0,"value":"” é usado mais de uma vez."}],
    "integrations.event.messageChannels": "Mensagens em canais públicos",
    "integrations.event.messageGroups": "Mensagens em canais privados",
    "integrations.event.messageIm": "Mensagens diretas com o app",
    "integrations.event.messageMpim": "Mensagens em DMs em grupo",
    "integrations.event.appMention": "Mensagens que mencionam o app",
    "integrations.event.reactionAdded": "Reação adicionada",
    "integrations.event.reactionRemoved": "Reação removida",
    "integrations.event.memberJoinedChannel": "Alguém entrou em um canal",
    "integrations.event.memberLeftChannel": "Alguém saiu de um canal",
    "integrations.event.channelCreated": "Canal público criado",
    "integrations.event.channelRename": "Canal público renomeado",
    "nav.workflows": "Fluxos de trabalho",
    "workflow.builder.title": "Criador de fluxos de trabalho",
    "workflow.list.title": "Fluxos de trabalho que você gerencia",
    "workflow.list.body": "Automatize tarefas de rotina: um gatilho inicia o fluxo de trabalho, e as etapas rodam em ordem.",
    "workflow.list.new": "Novo fluxo de trabalho",
    "workflow.list.error": "Não foi possível carregar os fluxos de trabalho.",
    "workflow.list.empty.title": "Nenhum fluxo de trabalho ainda",
    "workflow.list.empty.body": "Crie um para enviar mensagens, coletar respostas com um formulário ou dar boas-vindas a novos membros.",
    "workflow.list.empty.cantCreate": "Só proprietários e administradores do workspace podem criar fluxos de trabalho aqui.",
    "workflow.list.edited": [{"type":0,"value":"Editado em "},{"type":1,"value":"when"}],
    "workflow.status.published": "Publicado",
    "workflow.status.changed": "Alterações não publicadas",
    "workflow.status.draft": "Rascunho",
    "workflow.creators.title": "Quem pode criar fluxos de trabalho",
    "workflow.creators.everyone": "Todos, menos convidados",
    "workflow.creators.admins": "Somente proprietários e administradores",
    "workflow.editor.untitled": "Fluxo de trabalho sem título",
    "workflow.editor.back": "Todos os fluxos",
    "workflow.tab.build": "Etapas",
    "workflow.tab.activity": "Atividade",
    "workflow.action.save": "Salvar",
    "workflow.action.test": "Testar",
    "workflow.action.publish": "Publicar",
    "workflow.action.publishChanges": "Publicar alterações",
    "workflow.action.unpublish": "Despublicar",
    "workflow.details.icon": "Ícone",
    "workflow.details.icon.remove": "Remover ícone",
    "workflow.details.name": "Nome",
    "workflow.details.name.placeholder": "ex.: Pedir folga",
    "workflow.details.description": "Descrição (opcional)",
    "workflow.section.trigger": "Iniciar o fluxo de trabalho…",
    "workflow.section.steps": "Depois, fazer isto",
    "workflow.steps.empty": "Adicione a primeira etapa.",
    "workflow.steps.add": "Adicionar etapa",
    "workflow.trigger.label": "Gatilho",
    "workflow.trigger.link": "Por um link em um canal",
    "workflow.trigger.memberJoined": "Quando alguém entra em um canal",
    "workflow.trigger.reaction": "Quando alguém reage com um emoji",
    "workflow.trigger.schedule": "Em um horário programado",
    "workflow.trigger.webhook": "Por um webhook",
    "workflow.trigger.link.help": "Membros do canal o executam pelo menu de fluxos de trabalho do canal ou digitando / na caixa de mensagem.",
    "workflow.trigger.memberJoined.help": "Roda para cada pessoa que entra no canal.",
    "workflow.trigger.reaction.help": "Roda quando alguém adiciona este emoji a uma mensagem no canal.",
    "workflow.trigger.schedule.help": "Roda neste horário, no fuso horário escolhido.",
    "workflow.trigger.webhook.help": "Outro app o inicia enviando uma requisição POST com estas variáveis. A URL aparece uma vez, ao publicar.",
    "workflow.trigger.channel": "Canal",
    "workflow.trigger.emoji": "Emoji",
    "workflow.trigger.emoji.help": "Um emoji como ✅, ou o :nome: de um emoji personalizado",
    "workflow.channel.choose": "Escolha um canal",
    "workflow.person.choose": "Escolha uma pessoa",
    "workflow.variable.choose": "Escolha uma variável",
    "workflow.variable.insert": "Inserir variável",
    "workflow.schedule.date": "Começa em",
    "workflow.schedule.time": "Horário",
    "workflow.schedule.zone": "Fuso horário",
    "workflow.schedule.repeat": "Repetir",
    "workflow.schedule.repeat.none": "Não repetir",
    "workflow.schedule.repeat.daily": "Todos os dias",
    "workflow.schedule.repeat.weekdays": "Todos os dias úteis (seg–sex)",
    "workflow.schedule.repeat.weekly": "Toda semana",
    "workflow.schedule.repeat.monthly": "Todo mês",
    "workflow.schedule.days": "Dias da semana",
    "workflow.webhook.variables": "Variáveis",
    "workflow.webhook.key": "Chave",
    "workflow.webhook.type": "Tipo",
    "workflow.webhook.add": "Adicionar variável",
    "workflow.webhook.remove": "Remover variável",
    "workflow.webhook.once": "Copie esta URL agora: ela não será mostrada de novo. Qualquer pessoa com ela pode iniciar este fluxo de trabalho.",
    "workflow.webhook.done": "Pronto",
    "workflow.webhook.copy": "Copiar URL",
    "workflow.webhook.hidden": "A URL do webhook foi mostrada quando foi criada. Crie uma nova se a perdeu (a antiga para de funcionar).",
    "workflow.webhook.regenerate": "Nova URL",
    "workflow.varType.text": "Texto",
    "workflow.varType.number": "Número",
    "workflow.varType.user": "Pessoa",
    "workflow.varType.channel": "Canal",
    "workflow.varType.message": "Mensagem",
    "workflow.varType.date": "Data",
    "workflow.varType.time": "Horário",
    "workflow.varType.page": "Página",
    "workflow.varType.row": "Linha",
    "workflow.step.sendMessage": "Enviar uma mensagem",
    "workflow.step.form": "Coletar informações em um formulário",
    "workflow.step.addReaction": "Adicionar uma reação",
    "workflow.step.createPage": "Criar uma página",
    "workflow.step.createRow": "Adicionar uma linha a um banco de dados",
    "workflow.step.addToChannel": "Adicionar alguém a um canal",
    "workflow.step.delay": "Aguardar",
    "workflow.step.appStep": "Executar uma etapa de app",
    "workflow.step.moveUp": "Mover para cima",
    "workflow.step.moveDown": "Mover para baixo",
    "workflow.step.delete": "Excluir etapa",
    "workflow.step.edit": "Editar",
    "workflow.step.done": "Pronto",
    "workflow.step.incomplete": "Preencha os campos obrigatórios desta etapa antes de salvar.",
    "workflow.message.to": "Enviar para",
    "workflow.message.to.runner": "A pessoa que usou este fluxo de trabalho",
    "workflow.message.to.channel": "Um canal",
    "workflow.message.to.user": "Uma pessoa",
    "workflow.message.to.variable": "Uma pessoa ou canal de uma variável",
    "workflow.message.text": "Mensagem",
    "workflow.message.placeholder": "Escreva uma mensagem…",
    "workflow.form.title": "Título do formulário",
    "workflow.form.submit": "Botão de envio",
    "workflow.form.question": "Pergunta",
    "workflow.form.fieldLabel": "Pergunta",
    "workflow.form.fieldKind": "Tipo de resposta",
    "workflow.form.kind.text": "Resposta curta",
    "workflow.form.kind.paragraph": "Parágrafo",
    "workflow.form.kind.number": "Número",
    "workflow.form.kind.select": "Lista suspensa",
    "workflow.form.kind.user": "Pessoa",
    "workflow.form.kind.channel": "Canal",
    "workflow.form.kind.date": "Data",
    "workflow.form.required": "Obrigatória",
    "workflow.form.fieldId": [{"type":0,"value":"Variável: "},{"type":1,"value":"id"}],
    "workflow.form.option": [{"type":0,"value":"Opção "},{"type":1,"value":"n"}],
    "workflow.form.options": "Opções",
    "workflow.form.options.help": "Uma por linha (até 20).",
    "workflow.form.addField": "Adicionar pergunta",
    "workflow.form.removeField": "Remover pergunta",
    "workflow.reaction.message": "Mensagem para reagir",
    "workflow.reaction.emoji": "Emoji",
    "workflow.page.title": "Título da página",
    "workflow.page.text": "Texto da página (opcional)",
    "workflow.row.database": "Banco de dados",
    "workflow.row.choose": "Escolha um banco de dados",
    "workflow.row.title": "Título da linha",
    "workflow.row.untitled": "Sem título",
    "workflow.addToChannel.channel": "Canal",
    "workflow.addToChannel.user": "Pessoa",
    "workflow.delay.count": "Aguardar por",
    "workflow.delay.unit": "Unidade",
    "workflow.delay.minutes": "Minutos",
    "workflow.delay.hours": "Horas",
    "workflow.delay.days": "Dias",
    "workflow.app.title": "Nome da etapa",
    "workflow.app.appId": "ID do app",
    "workflow.app.callbackId": "Callback ID",
    "workflow.app.inputs": "Entradas",
    "workflow.app.inputName": "Nome da entrada",
    "workflow.app.inputValue": "Valor",
    "workflow.app.addInput": "Adicionar entrada",
    "workflow.app.outputs": "Saídas",
    "workflow.app.outputName": "Nome da saída",
    "workflow.app.outputType": "Tipo da saída",
    "workflow.app.addOutput": "Adicionar saída",
    "workflow.app.remove": "Remover",
    "workflow.app.chooseApp": "App",
    "workflow.app.chooseAppPlaceholder": "Escolha um app",
    "workflow.app.chooseStep": "Etapa",
    "workflow.app.chooseStepPlaceholder": "Escolha uma etapa",
    "workflow.app.noApps": "Nenhum app instalado aqui oferece etapas de fluxo ainda. Os apps as adicionam em Configurações → Apps.",
    "workflow.app.noInputs": "Esta etapa não recebe entradas.",
    "workflow.app.inputRequired": [{"type":1,"value":"label"},{"type":0,"value":" (obrigatório)"}],
    "workflow.app.outputsHelp": "O app devolve estes valores para as próximas etapas usarem.",
    "workflow.app.issue.appMissing": "Este app não está mais instalado neste workspace.",
    "workflow.app.issue.stepMissing": "O app não oferece mais esta etapa.",
    "workflow.app.issue.requiredInput": [{"type":0,"value":"Preencha “"},{"type":1,"value":"field"},{"type":0,"value":"”."}],
    "workflow.condition.add": "Só executar esta etapa se…",
    "workflow.condition.title": "Só executar esta etapa se",
    "workflow.condition.summary": "Só roda quando a condição é atendida",
    "workflow.condition.remove": "Remover condição",
    "workflow.condition.value": "Variável",
    "workflow.condition.op": "Comparação",
    "workflow.condition.compare": "Valor",
    "workflow.condition.op.is": "é",
    "workflow.condition.op.isNot": "não é",
    "workflow.condition.op.contains": "contém",
    "workflow.condition.op.isEmpty": "está vazio",
    "workflow.condition.op.isNotEmpty": "não está vazio",
    "workflow.condition.op.greaterThan": "é maior que",
    "workflow.condition.op.lessThan": "é menor que",
    "workflow.var.trigger.user": "Pessoa que usou este fluxo de trabalho",
    "workflow.var.trigger.joined": "Pessoa que entrou",
    "workflow.var.trigger.reactor": "Pessoa que reagiu",
    "workflow.var.trigger.channel": "Canal onde foi usado",
    "workflow.var.trigger.message": "Mensagem que recebeu a reação",
    "workflow.var.trigger.messageText": "Texto da mensagem",
    "workflow.var.trigger.messageAuthor": "Autor da mensagem",
    "workflow.var.trigger.emoji": "Emoji usado",
    "workflow.var.trigger.time": "Hora em que começou",
    "workflow.var.output.submitter": "Pessoa que enviou",
    "workflow.var.output.message": "Mensagem enviada",
    "workflow.var.output.channel": "Canal para onde foi",
    "workflow.var.output.page": "Página criada",
    "workflow.var.output.row": "Linha criada",
    "workflow.problem.noName": "Dê um nome ao fluxo de trabalho.",
    "workflow.problem.noSteps": "Adicione pelo menos uma etapa.",
    "workflow.problem.tooManySteps": "Um fluxo de trabalho pode ter até 30 etapas.",
    "workflow.problem.noChannel": "Escolha um canal.",
    "workflow.problem.noEmoji": "Escolha um emoji.",
    "workflow.problem.badTimeZone": "Escolha um fuso horário válido.",
    "workflow.problem.scheduleInPast": "Este horário já passou.",
    "workflow.problem.duplicateVariable": [{"type":0,"value":"A variável "},{"type":1,"value":"key"},{"type":0,"value":" aparece duas vezes."}],
    "workflow.problem.duplicateStep": "Duas etapas têm o mesmo id.",
    "workflow.problem.emptyText": "Escreva a mensagem.",
    "workflow.problem.unknownVariable": [{"type":0,"value":"Usa uma variável que não está disponível nesta etapa ("},{"type":1,"value":"ref"},{"type":0,"value":")."}],
    "workflow.problem.noRunner": "Este gatilho não tem uma pessoa que usou o fluxo; envie para outro lugar.",
    "workflow.problem.formNeedsLink": "Formulários só funcionam em fluxos iniciados por um link.",
    "workflow.problem.duplicateField": [{"type":0,"value":"Duas perguntas usam a variável "},{"type":1,"value":"field"},{"type":0,"value":"."}],
    "workflow.problem.noOptions": [{"type":0,"value":"Adicione opções à lista suspensa ("},{"type":1,"value":"field"},{"type":0,"value":")."}],
    "workflow.problem.notAMessage": "Escolha uma variável de mensagem.",
    "workflow.problem.notAUser": "Escolha uma variável de pessoa.",
    "workflow.problem.noDatabase": "Escolha um banco de dados.",
    "workflow.problem.noApp": "Escolha um app.",
    "workflow.managers.title": "Gerentes do fluxo de trabalho",
    "workflow.managers.body": "Gerentes podem editar, publicar e ver a atividade deste fluxo de trabalho.",
    "workflow.managers.creator": [{"type":1,"value":"name"},{"type":0,"value":" (criador)"}],
    "workflow.managers.add": "Adicionar gerente",
    "workflow.managers.remove": [{"type":0,"value":"Remover "},{"type":1,"value":"name"}],
    "workflow.delete.action": "Excluir fluxo de trabalho",
    "workflow.delete.confirm": "Excluir este fluxo de trabalho e sua atividade? Não dá para desfazer.",
    "workflow.leave.title": "Descartar alterações?",
    "workflow.leave.body": "Suas alterações neste fluxo de trabalho não foram salvas.",
    "workflow.leave.stay": "Continuar editando",
    "workflow.leave.discard": "Descartar",
    "workflow.activity.title": "Atividade",
    "workflow.activity.refresh": "Atualizar",
    "workflow.activity.empty": "Nenhuma execução ainda.",
    "workflow.activity.error": "Não foi possível carregar a atividade.",
    "workflow.run.status.running": "Rodando",
    "workflow.run.status.waiting": "Aguardando",
    "workflow.run.status.completed": "Concluído",
    "workflow.run.status.failed": "Falhou",
    "workflow.run.status.cancelled": "Cancelado",
    "workflow.run.step.running": "Rodando",
    "workflow.run.step.waiting": "Aguardando",
    "workflow.run.step.done": "Feito",
    "workflow.run.step.skipped": "Pulado",
    "workflow.run.step.failed": "Falhou",
    "workflow.run.test": "Teste",
    "workflow.run.by": [{"type":1,"value":"name"},{"type":0,"value":" · "},{"type":1,"value":"when"}],
    "workflow.run.version": [{"type":0,"value":"Versão "},{"type":1,"value":"version"}],
    "workflow.run.attempts": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" tentativa"}]},"other":{"value":[{"type":7},{"type":0,"value":" tentativas"}]}},"offset":0,"pluralType":"cardinal"}],
    "workflow.menu.run": "Executar",
    "workflow.menu.manage": "Gerenciar fluxos",
    "workflow.notice.saved": "Salvo.",
    "workflow.notice.saveFailed": "Não foi possível salvar o fluxo de trabalho. Confira as etapas e tente de novo.",
    "workflow.notice.published": "Publicado.",
    "workflow.notice.publishFailed": "Não foi possível publicar. Você precisa estar em todos os canais que o fluxo usa.",
    "workflow.notice.unpublished": "Despublicado: o gatilho está desligado.",
    "workflow.notice.failed": "Algo deu errado. Tente de novo.",
    "workflow.notice.testStarted": "Teste iniciado. Veja em Atividade.",
    "workflow.notice.testFailed": "Não foi possível iniciar o teste.",
    "workflow.notice.deleted": "Fluxo de trabalho excluído.",
    "workflow.notice.cantCreate": "Só proprietários e administradores do workspace podem criar fluxos de trabalho aqui.",
    "moderation.report.action": "Denunciar mensagem",
    "moderation.block.action": [{"type":0,"value":"Bloquear @"},{"type":1,"value":"name"}],
    "moderation.profile.block": "Bloquear",
    "moderation.profile.unblock": "Desbloquear",
    "moderation.report.title": "Denunciar mensagem",
    "moderation.report.reason.spam": "Spam",
    "moderation.report.reason.harassment": "Assédio ou bullying",
    "moderation.report.reason.inappropriate": "Conteúdo impróprio",
    "moderation.report.reason.other": "Outro motivo",
    "moderation.report.note.label": "Adicionar uma observação (opcional)",
    "moderation.report.note.placeholder": "Algo que os administradores do espaço de trabalho devem saber",
    "moderation.report.submit": "Denunciar",
    "moderation.report.done": "Obrigado pela denúncia. Os administradores do espaço de trabalho foram avisados.",
    "moderation.report.failed": "Não foi possível enviar a denúncia. Tente de novo.",
    "moderation.block.confirm.title": [{"type":0,"value":"Bloquear @"},{"type":1,"value":"name"},{"type":0,"value":"?"}],
    "moderation.block.confirm.body": "Você não vai receber notificações dessa pessoa, ela não poderá enviar mensagens diretas para você e as mensagens dela ficarão ocultas.",
    "moderation.block.confirm.action": "Bloquear",
    "moderation.block.done": [{"type":0,"value":"@"},{"type":1,"value":"name"},{"type":0,"value":" foi bloqueado"}],
    "moderation.unblock.done": [{"type":0,"value":"@"},{"type":1,"value":"name"},{"type":0,"value":" foi desbloqueado"}],
    "moderation.block.failed": "Não foi possível atualizar suas pessoas bloqueadas. Tente de novo.",
    "moderation.collapsed.text": "Mensagem de alguém que você bloqueou",
    "moderation.collapsed.show": "Mostrar",
    "moderation.composer.blocked": [{"type":0,"value":"Você bloqueou @"},{"type":1,"value":"name"}],
    "moderation.composer.unblock": "Desbloquear",
    "moderation.error.blocked": "Você não pode enviar mensagens para essa pessoa.",
    "settings.nav.privacy": "Privacidade",
    "moderation.blockedPeople.title": "Pessoas bloqueadas",
    "moderation.blockedPeople.help": "Pessoas que você bloqueia não podem enviar mensagens diretas para você, você não recebe notificações delas e as mensagens delas ficam ocultas. Elas não são avisadas.",
    "moderation.blockedPeople.empty": "Você não bloqueou ninguém.",
    "moderation.blockedPeople.unblock": "Desbloquear",
    "settings.nav.reports": "Denúncias",
    "moderation.reports.title": "Denúncias",
    "moderation.reports.help": "Mensagens denunciadas neste espaço de trabalho. Analise cada uma em até 24 horas: apague a mensagem ou descarte a denúncia.",
    "moderation.reports.empty": "Nenhuma denúncia aberta.",
    "moderation.reports.reportedBy": [{"type":0,"value":"Denunciada por "},{"type":1,"value":"name"}],
    "moderation.reports.author": [{"type":0,"value":"De "},{"type":1,"value":"name"}],
    "moderation.reports.in": [{"type":0,"value":"em "},{"type":1,"value":"channel"}],
    "moderation.reports.reason": [{"type":0,"value":"Motivo: "},{"type":1,"value":"reason"}],
    "moderation.reports.note": [{"type":0,"value":"Observação: "},{"type":1,"value":"note"}],
    "moderation.reports.deleteMessage": "Apagar mensagem",
    "moderation.reports.dismiss": "Descartar",
    "moderation.reports.deleted": "Mensagem apagada e denúncia resolvida.",
    "moderation.reports.dismissed": "Denúncia descartada.",
    "moderation.reports.failed": "Não foi possível resolver a denúncia. Tente de novo.",
    "moderation.reports.loadFailed": "Não foi possível carregar as denúncias.",
    "moderation.reports.directMessage": "uma mensagem direta",
    "mail.sync.google.optionalScopes": "Os quatro últimos são opcionais: trazem os domínios do Workspace, os grupos (importados como aliases), quem pode enviar para eles e as agendas de todos.",
    "mail.sync.google.noDomains": "nenhum ainda",
    "mail.sync.google.missingScopes": [{"type":0,"value":"Ainda não autorizados: "},{"type":1,"value":"scopes"},{"type":0,"value":". Adicione-os no Google Admin → Segurança → Controles de API → Delegação em todo o domínio para o ID do cliente "},{"type":1,"value":"clientId"},{"type":0,"value":". Até lá essa parte é pulada; o resto continua importando."}],
    "mail.sync.google.missingScopesOwn": [{"type":0,"value":"Ainda não autorizados: "},{"type":1,"value":"scopes"},{"type":0,"value":". Adicione-os no Google Admin → Segurança → Controles de API → Delegação em todo o domínio para o ID do cliente da sua conta de serviço. Até lá essa parte é pulada; o resto continua importando."}],
    "mail.sync.google.syncNow": "Sincronizar agora",
    "mail.sync.google.domainsTitle": "Domínios",
    "mail.sync.google.domainsHelp": "Escolha quais domínios do Google Workspace entram no Bundle. Os marcados são adicionados em Configurações → E-mail (pendentes até os registros DNS estarem no lugar) e seus usuários, aliases e grupos (como aliases) são importados. Desmarcar um para de importar dele; nada é apagado.",
    "mail.sync.google.domainsProposed": "Sugestão: o domínio principal e seus aliases. Salve para confirmar.",
    "mail.sync.google.domainPrimary": "Principal",
    "mail.sync.google.domainSecondary": "Secundário",
    "mail.sync.google.domainAliasOf": [{"type":0,"value":"Alias de "},{"type":1,"value":"domain"}],
    "mail.sync.google.importDomain": "Importar para o Bundle",
    "mail.sync.google.saveDomains": "Salvar domínios",
    "mail.sync.google.aliases": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" alias"}]},"other":{"value":[{"type":7},{"type":0,"value":" aliases"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.skippedDomains": [{"type":0,"value":"Não importados (domínio não adicionado): "},{"type":1,"value":"domains"}],
    "mail.thread.via": [{"type":0,"value":"via "},{"type":1,"value":"address"}],
    "mail.invite.organizer": "Organizador",
    "mail.invite.organizerTime": [{"type":1,"value":"time"},{"type":0,"value":" em "},{"type":1,"value":"city"},{"type":0,"value":" (organizador)"}],
    "mail.invite.guestsWithYou": [{"type":1,"value":"names"},{"type":0,"value":" e você"}],
    "mail.invite.guestsMore": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"e mais "},{"type":7}]},"other":{"value":[{"type":0,"value":"e mais "},{"type":7}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.invite.join": "Entrar na reunião",
    "mail.invite.inYourCalendar": "Na sua agenda",
    "mail.invite.noConflicts": "Sem conflitos",
    "mail.invite.conflict": [{"type":0,"value":"Conflita com "},{"type":1,"value":"title"},{"type":0,"value":", "},{"type":1,"value":"time"}],
    "mail.invite.propose": "Propor novo horário",
    "mail.invite.more": "Mais opções do convite",
    "mail.invite.openCalendar": "Abrir na Agenda",
    "mail.invite.download": "Baixar invite.ics",
    "mail.invite.answered.accepted": "Você vai",
    "mail.invite.answered.declined": "Você não vai",
    "mail.invite.answered.tentative": "Talvez você vá",
    "mail.invite.sentTo": [{"type":0,"value":"· enviado para "},{"type":1,"value":"address"}],
    "mail.invite.change": "Alterar",
    "mail.invite.answerKept": [{"type":0,"value":"Sua resposta ("},{"type":1,"value":"answer"},{"type":0,"value":") foi mantida. Responda de novo se o novo horário não der."}],
    "mail.invite.cancelled": "O organizador cancelou este evento.",
    "mail.invite.removed": "Removido da sua agenda.",
    "mail.invite.superseded": "Este convite está desatualizado: o organizador enviou um mais novo.",
    "mail.invite.answerFailed": "Não foi possível enviar sua resposta. Tente de novo.",
    "mail.invite.replyNotSetUp": [{"type":0,"value":"Ainda não dá para enviar respostas ao organizador: o envio por "},{"type":1,"value":"domain"},{"type":0,"value":" não está configurado. Um administrador pode concluir em Configurações → E-mail."}],
    "mail.invite.proposeSubject": [{"type":0,"value":"Novo horário proposto: "},{"type":1,"value":"title"}],
    "mail.invite.proposeText": [{"type":1,"value":"time"},{"type":0,"value":" não dá para mim. Podemos achar outro horário?"}],
    "mail.settings.tab.groups": "Aliases",
    "mail.settings.groups": "Aliases",
    "mail.settings.groupsHelp": "Um alias entrega cada mensagem a todos os membros: caixas daqui ou endereços de fora. Os membros podem enviar como o alias.",
    "mail.settings.groupsEmpty": "Nenhum alias ainda.",
    "mail.settings.groupNew": "Novo alias",
    "mail.settings.groupAddress": "Endereço do alias",
    "mail.settings.groupName": "Nome",
    "mail.settings.groupWhoCanPost": "Quem pode enviar para ele",
    "mail.settings.groupPost.anyone": "Qualquer pessoa (público)",
    "mail.settings.groupPost.organization": "Só pessoas da organização",
    "mail.settings.groupPost.members": "Só membros do alias",
    "mail.settings.groupMembers": "Membros",
    "mail.settings.groupMembersCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" membro"}]},"other":{"value":[{"type":7},{"type":0,"value":" membros"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.settings.groupAddMailbox": "Adicionar uma caixa",
    "mail.settings.groupAddExternal": "Endereço de fora",
    "mail.settings.groupAddExternalButton": "Adicionar",
    "mail.settings.groupOutside": "De fora",
    "mail.settings.groupImported": "Importado do Google",
    "mail.settings.groupEdited": "Editado no Bundle",
    "mail.settings.groupSave": "Salvar",
    "mail.settings.groupEdit": "Editar",
    "mail.settings.groupDelete": "Excluir",
    "mail.settings.groupDeleteConfirm": [{"type":0,"value":"Excluir "},{"type":1,"value":"address"},{"type":0,"value":"? E-mails enviados para ele vão voltar."}],
    "mail.settings.suggested": "Encontrados na importação do Google Workspace",
    "mail.settings.suggestedAdd": "Adicionar",
    "mail.settings.suggestedAlias": [{"type":0,"value":"Alias de "},{"type":1,"value":"domain"}],
    "mail.sync.google.domainsList": [{"type":0,"value":"Domínios: "},{"type":1,"value":"domains"}],
    "mail.sync.google.groupsCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" alias compartilhado"}]},"other":{"value":[{"type":7},{"type":0,"value":" aliases compartilhados"}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.nav.features": "Recursos",
    "shell.view.huddles": "Meet",
    "nav.huddles": "Meet",
    "settings.nav.huddles": "Meet",
    "huddles.title": "Meet",
    "huddles.new": "Nova reunião",
    "huddles.all": "Todas as reuniões",
    "huddles.start": "Iniciar reunião",
    "huddles.start.hint": "Chame pessoas agora",
    "huddles.getLink": "Criar um link para compartilhar",
    "huddles.getLink.hint": [{"type":0,"value":"Para depois, ou para pessoas de fora de "},{"type":1,"value":"workspace"}],
    "huddles.schedule": "Agendar",
    "huddles.schedule.hint": "Escolha o dia e a hora",
    "huddles.join.placeholder": "Cole um link ou código",
    "huddles.join.action": "Entrar",
    "huddles.join.invalid": "Isso não é um link ou código de reunião.",
    "huddles.section.live": "Ao vivo",
    "huddles.section.upcoming": "Próximas",
    "huddles.section.recent": "Recentes",
    "huddles.section.links": "Meus links",
    "huddles.empty.live": "Ninguém está em uma reunião agora.",
    "huddles.empty.upcoming": "Nada agendado.",
    "huddles.empty.recent": "As reuniões de que você participou aparecem aqui, com as notas, a transcrição e o chat.",
    "huddles.empty.links": "Os links que você cria ficam aqui até você revogá-los.",
    "huddles.people": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddles.outside": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" de fora"}]},"other":{"value":[{"type":7},{"type":0,"value":" de fora"}]}},"offset":0,"pluralType":"cardinal"}],
    "huddles.linkOf": [{"type":0,"value":"Link de "},{"type":1,"value":"name"}],
    "huddles.untitled": "Reunião",
    "huddles.join": "Entrar",
    "huddles.open": "Abrir",
    "huddles.revoke": "Revogar",
    "huddles.revoke.confirm": "Revogar este link? Ninguém mais consegue entrar por ele.",
    "huddles.chip.notes": "Notas",
    "huddles.chip.transcript": "Transcrição",
    "huddles.chip.chat": "Chat",
    "huddles.link.ready": "Seu link está pronto",
    "huddles.link.name": "Nome",
    "huddles.link.making": "Criando seu link…",
    "huddles.link.untilRevoked": "Funciona até você revogá-lo em Meus links.",
    "huddles.link.error": "Não foi possível criar o link. Tente de novo.",
    "huddles.link.startNow": "Começar agora",
    "huddles.link.done": "Concluir",
    "huddles.access.label": "Quem pode entrar",
    "huddles.access.ask": "Pedir para entrar",
    "huddles.access.ask.hint": [{"type":0,"value":"Pessoas de "},{"type":1,"value":"workspace"},{"type":0,"value":" e quem você convidar entram direto. As outras pedem, e alguém na reunião deixa entrar."}],
    "huddles.access.open": "Aberto",
    "huddles.access.open.hint": "Qualquer pessoa com o link entra direto.",
    "huddles.access.workspace": [{"type":0,"value":"Só pessoas de "},{"type":1,"value":"workspace"}],
    "huddles.access.workspace.hint": "Elas entram com a conta. Ninguém mais pode pedir.",
    "huddles.schedule.title": "Agendar reunião",
    "huddles.schedule.date": "Data",
    "huddles.schedule.time": "Hora",
    "huddles.schedule.invite": [{"type":0,"value":"Convidar pessoas de "},{"type":1,"value":"workspace"}],
    "huddles.schedule.notice": "Elas vão encontrar no Meet, em Próximas.",
    "huddles.schedule.save": "Agendar",
    "huddles.schedule.past": "Escolha um horário que ainda não passou.",
    "huddles.start.title": "Iniciar reunião",
    "huddles.start.who": "Adicionar pessoas ou um canal",
    "huddles.start.whoPeople": "Adicionar pessoas",
    "huddles.start.nobody": "Ninguém adicionado ainda: você recebe um link para compartilhar.",
    "huddles.start.chatOff": "As pessoas que você adicionar recebem um link de reunião. Ela aparece no Meet delas, em Ao vivo.",
    "huddles.start.action": "Começar",
    "huddles.start.error": "Não foi possível iniciar a reunião. Tente de novo.",
    "huddles.loadError": "Não foi possível carregar suas reuniões.",
    "huddles.record.openInChat": "Abrir no Chat",
    "huddles.record.again": "Reunir de novo",
    "huddles.record.attendees": "Quem participou",
    "huddles.record.noChat": "Ninguém escreveu no chat da reunião.",
    "huddles.record.noNotes": "Sem notas para esta reunião.",
    "huddles.record.recording": "Gravação",
    "huddles.record.recordedBy": [{"type":0,"value":"Gravado por "},{"type":1,"value":"name"}],
    "huddles.record.error": "Não foi possível carregar esta reunião.",
    "settings.huddles.links": "Links para compartilhar",
    "settings.huddles.links.hint": [{"type":0,"value":"Membros podem criar links de reunião para pessoas de dentro e de fora de "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.huddles.transcribe": "Transcrever reuniões",
    "settings.huddles.transcribe.hint": [{"type":0,"value":"Toda reunião em "},{"type":1,"value":"workspace"},{"type":0,"value":" é transcrita enquanto as pessoas estão com o microfone ligado, e a transcrição fica salva para todos que participaram. As anotações de IA da reunião são feitas a partir dela. Desativado: as legendas continuam funcionando para quem as ativar, e não são salvas."}],
    "settings.huddles.outside": [{"type":0,"value":"Pessoas de fora de "},{"type":1,"value":"workspace"}],
    "settings.huddles.outside.link": "Podem entrar por um link",
    "settings.huddles.outside.link.hint": "O Quem pode entrar de cada link decide.",
    "settings.huddles.outside.ask": "Sempre pedem para entrar",
    "settings.huddles.outside.ask.hint": "Alguém na reunião deixa entrar, mesmo em links abertos.",
    "settings.huddles.outside.none": "Não podem entrar",
    "settings.huddles.outside.none.hint": [{"type":0,"value":"Os links só funcionam para pessoas de "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.huddles.default": "Quem pode entrar em links novos",
    "settings.huddles.revokeAll": "Revogar todos os links",
    "settings.huddles.revokeAll.hint": [{"type":0,"value":"Todos os links de reunião de "},{"type":1,"value":"workspace"},{"type":0,"value":" param de funcionar. Quem entrou de fora por um deles sai da reunião."}],
    "settings.huddles.revokeAll.confirm": [{"type":0,"value":"Revogar todos os links de reunião de "},{"type":1,"value":"workspace"},{"type":0,"value":"?"}],
    "settings.huddles.revoked": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" link revogado"}]},"other":{"value":[{"type":7},{"type":0,"value":" links revogados"}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.huddles.chatOff": "O Meet funciona com o Chat desligado: as pessoas iniciam reuniões pela área Meet.",
    "meeting.page.restricted": "Só pessoas do workspace podem entrar nesta reunião.",
    "meeting.page.signIn": "Entre com sua conta para participar",
    "features.title": "Recursos",
    "features.intro": "Escolha quais partes do Bundle as pessoas deste espaço de trabalho podem usar. Desativar um recurso o esconde para todos e o bloqueia em todos os apps. Nada é apagado: ative de novo e tudo volta ao lugar.",
    "features.chat.title": "Chat",
    "features.chat.hint": "Canais, mensagens diretas, conversas em thread e conversas com agentes.",
    "features.mail.title": "E-mail",
    "features.mail.hint": "Caixas de entrada e envio pelos seus domínios. Os e-mails que chegarem enquanto estiver desativado são guardados e aparecem quando voltar.",
    "features.calendar.title": "Agenda",
    "features.calendar.hint": "Eventos, convites, páginas de agendamento e sincronização de agenda.",
    "features.contacts.title": "Contatos",
    "features.contacts.hint": "Pessoas com quem você troca e-mails, clientes e sua equipe, sincronizados com celulares e Macs.",
    "features.docs.title": "Documentos",
    "features.docs.hint": "Páginas, bancos de dados, quadros de projeto e modelos.",
    "features.huddles.title": "Meet",
    "features.huddles.hint": "Chamadas de voz e vídeo, links de reunião e notas das reuniões.",
    "features.needsParent": [{"type":0,"value":"Precisa de "},{"type":1,"value":"area"},{"type":0,"value":" ativado"}],
    "features.lastOne": "Pelo menos um recurso precisa ficar ativado.",
    "features.adminsOnly": "Só proprietários e administradores do espaço de trabalho podem alterar os recursos.",
    "features.turnedOff": [{"type":1,"value":"area"},{"type":0,"value":" desativado"}],
    "features.turnedOn": [{"type":1,"value":"area"},{"type":0,"value":" ativado"}],
    "features.disabled.title": [{"type":1,"value":"area"},{"type":0,"value":" está desativado"}],
    "features.disabled.body": [{"type":0,"value":"Um administrador desativou "},{"type":1,"value":"area"},{"type":0,"value":" neste espaço de trabalho. Fale com um proprietário ou administrador se precisar."}],
    "features.error": "Não foi possível atualizar os recursos. Tente de novo.",
    "features.adminAccess.title": "Quando um recurso está desativado, proprietários e administradores",
    "features.adminAccess.none": "Também perdem o acesso",
    "features.adminAccess.read": "Ainda podem ver",
    "features.adminAccess.full": "Continuam usando",
    "features.adminAccess.hint": "Os demais perdem os recursos desativados. Manter o acesso de proprietários e administradores ajuda a preparar tudo antes de ativar para todos.",
    "features.readOnly": [{"type":1,"value":"area"},{"type":0,"value":" está desativado neste espaço de trabalho. Você pode ver, mas não alterar nada."}],
    "mail.sync.google.what": "O que importar",
    "mail.sync.google.whatMail": "E-mail",
    "mail.sync.google.messages": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" mensagem"}]},"other":{"value":[{"type":7},{"type":0,"value":" mensagens"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.calendarNew": "Novo",
    "mail.sync.google.calendarHelp": "A agenda de cada pessoa: eventos do último ano e tudo o que vem pela frente, eventos recorrentes, convidados e links do Meet. Ninguém recebe convite nem e-mail.",
    "mail.sync.google.calendarScopeTitle": "A agenda precisa de mais uma permissão",
    "mail.sync.google.calendarScope": [{"type":0,"value":"No Google Admin → Segurança → Controles de API → Delegação em todo o domínio, adicione este escopo ao ID do cliente do Bundle "},{"type":1,"value":"clientId"},{"type":0,"value":". Enquanto isso, o e-mail continua importando."}],
    "mail.sync.google.calendarScopeOwn": "No Google Admin → Segurança → Controles de API → Delegação em todo o domínio, adicione este escopo ao ID do cliente da sua conta de serviço. Enquanto isso, o e-mail continua importando.",
    "mail.sync.google.copyScope": "Copiar escopo",
    "mail.sync.google.checkAgain": "Verificar de novo",
    "mail.sync.calendar.label": "Agenda",
    "mail.sync.calendar.waiting": "aguardando",
    "mail.sync.calendar.listing": "contando eventos…",
    "mail.sync.calendar.importing": [{"type":6,"value":"total","options":{"one":{"value":[{"type":0,"value":"importando "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":7},{"type":0,"value":" evento"}]},"other":{"value":[{"type":0,"value":"importando "},{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":7},{"type":0,"value":" eventos"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.calendar.calendars": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" agenda"}]},"other":{"value":[{"type":7},{"type":0,"value":" agendas"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.calendar.events": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" evento"}]},"other":{"value":[{"type":7},{"type":0,"value":" eventos"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.readersDelegates": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Delegação do Gmail: "},{"type":7},{"type":0,"value":" pessoa pode ler"}]},"other":{"value":[{"type":0,"value":"Delegação do Gmail: "},{"type":7},{"type":0,"value":" pessoas podem ler"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.readersGroup": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"O Grupo do Google dela: "},{"type":7},{"type":0,"value":" pessoa pode ler"}]},"other":{"value":[{"type":0,"value":"O Grupo do Google dela: "},{"type":7},{"type":0,"value":" pessoas podem ler"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.readersPending": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Mais "},{"type":7},{"type":0,"value":" recebe acesso ao entrar no Bundle"}]},"other":{"value":[{"type":0,"value":"Mais "},{"type":7},{"type":0,"value":" recebem acesso ao entrar no Bundle"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.sync.google.noDelegates": "O Google não lista delegados para ela, então só administradores podem lê-la. Adicione leitores em Configurações → E-mail.",
    "mail.sync.google.delegatesUnreadable": "O Google não listou os delegados; quem pode ler ficou como estava.",
    "mail.settings.memberFromGoogle": "Do Google",
    "mail.settings.noDelegates": "O Google não lista delegados para esta caixa: só as pessoas marcadas aqui podem lê-la.",
    "mail.settings.googleReadersPending": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" delegado do Gmail recebe acesso ao entrar no Bundle."}]},"other":{"value":[{"type":7},{"type":0,"value":" delegados do Gmail recebem acesso ao entrar no Bundle."}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.nav.navigation": "Navegação",
    "settings.navigation.customizeTabs": "Personalizar abas",
    "settings.navigation.description": "Escolha o que fica na barra inferior do app do Bundle no celular. O resto aparece no topo do Início. Fica salvo na sua conta, então todo celular em que você entrar fica igual.",
    "settings.navigation.rowFooter": "Escolha o que fica na barra inferior. Fica salvo na sua conta.",
    "settings.navigation.default": "Padrão",
    "settings.navigation.custom": "Personalizado",
    "settings.navigation.preview": [{"type":0,"value":"Prévia · "},{"type":1,"value":"workspace"}],
    "settings.navigation.tabBar": "Barra de abas",
    "settings.navigation.tabBarCount": [{"type":1,"value":"count"},{"type":0,"value":" de "},{"type":1,"value":"max"}],
    "settings.navigation.tabBarFooter": [{"type":0,"value":"Início e Atividade sempre ficam. Cabem até mais "},{"type":1,"value":"max"},{"type":0,"value":" entre elas."}],
    "settings.navigation.alwaysFirst": "Sempre primeiro",
    "settings.navigation.alwaysLast": "Sempre último",
    "settings.navigation.onHome": "No Início",
    "settings.navigation.onHomeFooter": "Estes aparecem no topo do Início.",
    "settings.navigation.onHomeFooterFull": "Estes aparecem no topo do Início. Adicionar um com a barra cheia move a última aba da barra para cá.",
    "settings.navigation.noRoom": "Sem espaço na barra de abas",
    "settings.navigation.off": [{"type":0,"value":"Desativado em "},{"type":1,"value":"workspace"}],
    "settings.navigation.offRow": "Desativado por um admin",
    "settings.navigation.offShort": "Desativado",
    "settings.navigation.offFooter": [{"type":0,"value":"Um admin desativou estes em "},{"type":1,"value":"workspace"},{"type":0,"value":". Eles mantêm o lugar nos seus outros espaços de trabalho."}],
    "settings.navigation.remove": "Remover",
    "settings.navigation.removeLabel": [{"type":0,"value":"Remover "},{"type":1,"value":"area"},{"type":0,"value":" da barra de abas"}],
    "settings.navigation.add": "Adicionar à barra",
    "settings.navigation.addLabel": [{"type":0,"value":"Adicionar "},{"type":1,"value":"area"},{"type":0,"value":" à barra de abas"}],
    "settings.navigation.moveUp": [{"type":0,"value":"Mover "},{"type":1,"value":"area"},{"type":0,"value":" para cima"}],
    "settings.navigation.moveDown": [{"type":0,"value":"Mover "},{"type":1,"value":"area"},{"type":0,"value":" para baixo"}],
    "settings.navigation.drag": [{"type":0,"value":"Arraste para reordenar "},{"type":1,"value":"area"}],
    "settings.navigation.saveNote": "As mudanças são salvas na hora. No computador, a barra lateral lista todas as áreas.",
    "settings.navigation.reset": "Restaurar padrão",
    "settings.navigation.resetTitle": "Restaurar suas abas?",
    "settings.navigation.resetBody": "Sua barra inferior volta à ordem padrão do Bundle em todo celular que você usa.",
    "settings.navigation.resetConfirm": "Restaurar",
    "settings.navigation.saveFailed": "Não foi possível salvar suas abas. Verifique sua conexão e tente de novo.",
    "settings.navigation.loading": "Carregando suas abas…",
    "settings.navigation.loadFailedTitle": "Não foi possível carregar suas abas",
    "settings.navigation.loadFailedBody": "Verifique sua conexão e tente de novo. Até lá, sua barra inferior fica na ordem padrão do Bundle.",
    "settings.navigation.retry": "Tentar de novo",
    "drive.role.viewer": "Leitor",
    "drive.role.commenter": "Comentarista",
    "drive.role.editor": "Editor",
    "drive.role.owner": "Proprietário",
    "drive.move.sameFolder": "Já está nesta pasta",
    "drive.move.intoItself": "Uma pasta não pode ficar dentro dela mesma",
    "drive.title": "Arquivos",
    "files.picker.signIn": "Abra o Bundle e entre para usar seus arquivos aqui",
    "files.picker.offline": "Não foi possível acessar o Bundle. Mostrando o que foi carregado por último.",
    "drive.new": "Novo",
    "drive.new.folder": "Nova pasta",
    "drive.new.fileUpload": "Upload de arquivo",
    "drive.new.folderUpload": "Upload de pasta",
    "drive.new.page": "Página",
    "drive.new.database": "Banco de dados",
    "drive.new.untitled": "Sem título",
    "drive.view.my": "Meus arquivos",
    "drive.view.shared": "Compartilhados comigo",
    "drive.view.recent": "Recentes",
    "drive.view.starred": "Com estrela",
    "drive.view.trash": "Lixeira",
    "drive.view.conversations": "De conversas",
    "drive.search": "Pesquisar em Arquivos",
    "drive.searchResults": [{"type":0,"value":"Resultados para “"},{"type":1,"value":"q"},{"type":0,"value":"”"}],
    "drive.upload": "Enviar",
    "drive.layout": "Layout",
    "drive.layout.list": "Visualização em lista",
    "drive.layout.grid": "Visualização em grade",
    "drive.col.name": "Nome",
    "drive.col.owner": "Proprietário",
    "drive.col.modified": "Última modificação",
    "drive.col.size": "Tamanho",
    "drive.col.actions": "Ações",
    "drive.owner.me": "eu",
    "drive.modifiedBy": [{"type":1,"value":"date"},{"type":0,"value":" · "},{"type":1,"value":"name"}],
    "drive.section.folders": "Pastas",
    "drive.section.files": "Arquivos",
    "drive.filter.type": "Tipo",
    "drive.filter.people": "Pessoas",
    "drive.filter.modified": "Modificado",
    "drive.filter.source": "Origem",
    "drive.filter.any": "Qualquer",
    "drive.filter.clear": "Limpar filtros",
    "drive.type.folder": "Pastas",
    "drive.type.document": "Documentos",
    "drive.type.spreadsheet": "Planilhas",
    "drive.type.presentation": "Apresentações",
    "drive.type.pdf": "PDFs",
    "drive.type.image": "Fotos e imagens",
    "drive.type.video": "Vídeos",
    "drive.type.audio": "Áudio",
    "drive.type.archive": "Arquivos compactados",
    "drive.type.page": "Páginas e bancos de dados",
    "drive.type.other": "Outros",
    "drive.people.me": "Meus",
    "drive.people.notMe": "De outras pessoas",
    "drive.modified.today": "Hoje",
    "drive.modified.week": "Últimos 7 dias",
    "drive.modified.month": "Últimos 30 dias",
    "drive.modified.year": "Últimos 12 meses",
    "drive.source.files": "Enviados para Arquivos",
    "drive.source.chat": "Compartilhados no chat",
    "drive.source.mail": "Anexos de e-mail",
    "drive.source.pages": "Páginas e bancos de dados",
    "drive.sort": [{"type":0,"value":"Ordenar: "},{"type":1,"value":"by"}],
    "drive.sort.name": "Nome",
    "drive.sort.modified": "Última modificação",
    "drive.sort.viewed": "Aberto por mim",
    "drive.sort.size": "Tamanho",
    "drive.sort.shared": "Data de compartilhamento",
    "drive.sort.asc": "Crescente",
    "drive.sort.desc": "Decrescente",
    "drive.action.open": "Abrir",
    "drive.action.share": "Compartilhar",
    "drive.action.copyLink": "Copiar link",
    "drive.action.rename": "Renomear",
    "drive.action.move": "Mover",
    "drive.action.copy": "Fazer uma cópia",
    "drive.action.star": "Adicionar às com estrela",
    "drive.action.unstar": "Remover das com estrela",
    "drive.action.versions": "Gerenciar versões",
    "drive.action.download": "Baixar",
    "drive.action.trash": "Mover para a lixeira",
    "drive.action.details": "Ver detalhes",
    "drive.action.restore": "Restaurar",
    "drive.action.deleteForever": "Excluir permanentemente",
    "drive.action.emptyTrash": "Esvaziar lixeira",
    "drive.action.more": "Mais ações",
    "drive.selected": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" selecionado"}]},"other":{"value":[{"type":7},{"type":0,"value":" selecionados"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.clearSelection": "Limpar seleção",
    "drive.details": "Detalhes",
    "drive.details.activity": "Atividade",
    "drive.details.access": "Quem tem acesso",
    "drive.details.manage": "Gerenciar acesso",
    "drive.details.type": "Tipo",
    "drive.details.size": "Tamanho",
    "drive.details.location": "Local",
    "drive.details.owner": "Proprietário",
    "drive.details.modified": "Modificado",
    "drive.details.created": "Criado",
    "drive.details.versions": "Versões",
    "drive.details.sharedIn": "Compartilhado em",
    "drive.details.close": "Fechar detalhes",
    "drive.details.empty": "Selecione um arquivo ou pasta para ver os detalhes.",
    "drive.details.onlyOwner": "Só o proprietário",
    "drive.details.modifiedLine": [{"type":1,"value":"name"},{"type":0,"value":" modificou · "},{"type":1,"value":"date"}],
    "drive.details.createdLine": [{"type":1,"value":"name"},{"type":0,"value":" criou · "},{"type":1,"value":"date"}],
    "drive.details.viewedLine": [{"type":0,"value":"Você abriu · "},{"type":1,"value":"date"}],
    "drive.kind.folder": "Pasta",
    "drive.kind.page": "Página",
    "drive.kind.database": "Banco de dados",
    "drive.kind.shortcut": "Atalho",
    "drive.breadcrumb": "Trilha de navegação",
    "drive.shared": "Compartilhado",
    "drive.folderMenu": "Ações da pasta",
    "drive.storage": "Armazenamento",
    "drive.storage.used": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"quota"},{"type":0,"value":" usados · workspace"}],
    "drive.storage.meter": [{"type":1,"value":"percent"},{"type":0,"value":"% usado"}],
    "drive.storage.manage": "Gerenciar armazenamento",
    "drive.storage.warning": [{"type":0,"value":"O armazenamento do workspace está "},{"type":1,"value":"percent"},{"type":0,"value":"% cheio."}],
    "drive.storage.warningBody": [{"type":0,"value":"Envios e sincronização param em "},{"type":1,"value":"quota"},{"type":0,"value":". Esvazie a lixeira ou peça mais espaço a um administrador."}],
    "drive.storage.full": "O armazenamento do workspace está cheio.",
    "drive.storage.fullNotice": "O armazenamento do workspace está cheio: os envios para Arquivos estão pausados.",
    "drive.storage.mine.files": "Seus arquivos",
    "drive.storage.mine.attachments": "Seus anexos em conversas",
    "drive.storage.mine.versions": "Versões anteriores",
    "drive.storage.mine.trash": "Lixeira",
    "drive.drop": [{"type":0,"value":"Solte arquivos para enviá-los para “"},{"type":1,"value":"folder"},{"type":0,"value":"”"}],
    "drive.drop.hint": "As pastas mantêm a estrutura.",
    "drive.uploads.title": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Enviando "},{"type":7},{"type":0,"value":" item"}]},"other":{"value":[{"type":0,"value":"Enviando "},{"type":7},{"type":0,"value":" itens"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.uploads.finished": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" envio concluído"}]},"other":{"value":[{"type":7},{"type":0,"value":" envios concluídos"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.uploads.collapse": "Recolher",
    "drive.uploads.expand": "Expandir",
    "drive.uploads.close": "Fechar",
    "drive.uploads.instant": "Já está no Bundle · instantâneo",
    "drive.uploads.done": "Concluído",
    "drive.uploads.failed": "Falhou",
    "drive.uploads.canceled": "Cancelado",
    "drive.uploads.waiting": "Aguardando",
    "drive.uploads.percent": [{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "drive.uploads.folderCount": [{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "drive.uploads.cancel": "Cancelar envio",
    "drive.uploads.retry": "Tentar novamente",
    "drive.uploads.resume": "Arquivos grandes continuam de onde pararam se a conexão cair ou você fechar a aba.",
    "drive.upload.tooBig": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" arquivo tem mais de 5 TB e não foi enviado"}]},"other":{"value":[{"type":7},{"type":0,"value":" arquivos têm mais de 5 TB e não foram enviados"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.conflict.title": "Opções de envio",
    "drive.conflict.body": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” já existe nesta pasta. Substituir por uma nova versão ou manter os dois?"}]},"other":{"value":[{"type":7},{"type":0,"value":" itens já existem nesta pasta. Substituir por novas versões ou manter todos os itens separados?"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.conflict.replace": "Substituir arquivo existente",
    "drive.conflict.keep": "Manter todos os itens separados",
    "drive.conflict.upload": "Enviar",
    "drive.name.rename": "Renomear",
    "drive.name.label": "Nome",
    "drive.name.create": "Criar",
    "drive.name.ok": "OK",
    "drive.name.invalid": "Use um nome com 1 a 255 caracteres, sem “/”.",
    "drive.name.untitledFolder": "Pasta sem título",
    "drive.move.title": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Mover “"},{"type":1,"value":"name"},{"type":0,"value":"”"}]},"other":{"value":[{"type":0,"value":"Mover "},{"type":7},{"type":0,"value":" itens"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.move.here": "Mover para cá",
    "drive.move.back": "Voltar",
    "drive.move.empty": "Nenhuma pasta aqui",
    "drive.move.noAccess": "Você não pode adicionar itens a esta pasta",
    "drive.move.current": "Local atual",
    "drive.notice.trashed": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Movido para a lixeira"}]},"other":{"value":[{"type":7},{"type":0,"value":" itens movidos para a lixeira"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.notice.restored": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Restaurado"}]},"other":{"value":[{"type":7},{"type":0,"value":" itens restaurados"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.notice.copied": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Cópia criada"}]},"other":{"value":[{"type":7},{"type":0,"value":" cópias criadas"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.notice.moved": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Movido"}]},"other":{"value":[{"type":7},{"type":0,"value":" itens movidos"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.notice.versionRestored": "Versão restaurada",
    "drive.notice.ownerChanged": "Propriedade transferida",
    "drive.notice.linkCopied": "Link copiado",
    "drive.error.notFound": "Este item não existe ou você não tem acesso.",
    "drive.error.conflict": "Alguém alterou este item. Mostrando a versão mais recente.",
    "drive.error.offline": "Você está offline. Tente de novo quando estiver conectado.",
    "drive.error.failed": "Algo deu errado. Tente de novo.",
    "drive.preview.close": "Fechar visualização",
    "drive.preview.noPreview.title": "Nenhuma visualização disponível",
    "drive.preview.noPreview.body": [{"type":0,"value":"Não é possível visualizar “"},{"type":1,"value":"name"},{"type":0,"value":"” ("},{"type":1,"value":"size"},{"type":0,"value":"). Baixe-o ou abra-o com um app no seu computador."}],
    "drive.versions.title": "Gerenciar versões",
    "drive.versions.hint": "Versões anteriores ficam guardadas por 30 dias ou até 100 versões. Use Manter para sempre para guardar uma.",
    "drive.versions.upload": "Enviar nova versão",
    "drive.versions.current": "Versão atual",
    "drive.versions.number": [{"type":0,"value":"Versão "},{"type":1,"value":"n"}],
    "drive.versions.keepForever": "Manter para sempre",
    "drive.versions.unkeep": "Não manter para sempre",
    "drive.versions.kept": "Mantida para sempre",
    "drive.versions.restore": "Restaurar esta versão",
    "drive.versions.delete": "Excluir",
    "drive.versions.actions": "Ações da versão",
    "drive.versions.open": "Abrir",
    "drive.versions.device": [{"type":0,"value":"de "},{"type":1,"value":"device"}],
    "drive.share.title": [{"type":0,"value":"Compartilhar “"},{"type":1,"value":"name"},{"type":0,"value":"”"}],
    "drive.share.add": "Adicionar pessoas, grupos ou canais",
    "drive.share.people": "Pessoas com acesso",
    "drive.share.you": [{"type":1,"value":"name"},{"type":0,"value":" (você)"}],
    "drive.share.group": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Grupo de usuários · "},{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":0,"value":"Grupo de usuários · "},{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.share.channel": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Membros do canal · "},{"type":7},{"type":0,"value":" pessoa"}]},"other":{"value":[{"type":0,"value":"Membros do canal · "},{"type":7},{"type":0,"value":" pessoas"}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.share.workspace": [{"type":0,"value":"Todos em "},{"type":1,"value":"workspace"}],
    "drive.share.workspaceHint": "Membros do workspace (sem convidados)",
    "drive.share.inherited": [{"type":0,"value":"De “"},{"type":1,"value":"folder"},{"type":0,"value":"”"}],
    "drive.share.transfer": "Transferir propriedade",
    "drive.share.remove": "Remover acesso",
    "drive.share.general": "Acesso geral",
    "drive.share.restricted": "Restrito",
    "drive.share.restrictedHint": "Só pessoas com acesso podem abrir com o link.",
    "drive.share.anyoneAt": [{"type":0,"value":"Qualquer pessoa em "},{"type":1,"value":"workspace"},{"type":0,"value":" com o link"}],
    "drive.share.anyoneHint": "Membros do workspace com o link têm acesso. Convidados não.",
    "drive.share.copyLink": "Copiar link",
    "drive.share.done": "Concluído",
    "drive.share.addRole": "Papel para novas pessoas",
    "drive.share.noResults": "Nenhum resultado",
    "drive.share.readOnly": "Só editores podem alterar quem tem acesso.",
    "drive.share.change": [{"type":0,"value":"Alterar acesso de "},{"type":1,"value":"name"}],
    "drive.share.anyone": "Qualquer pessoa com o link",
    "drive.share.anyoneLinkHint": "Qualquer pessoa na internet com o link pode ver",
    "drive.share.blocked.off": "Desativado por um admin",
    "drive.share.blocked.admins": "Só admins podem fazer isso",
    "drive.share.anyoneRoleNote": [{"type":0,"value":"Membros de "},{"type":1,"value":"workspace"},{"type":0,"value":" que abrirem o link têm acesso de "},{"type":1,"value":"role"},{"type":0,"value":". As demais pessoas só podem ver e baixar."}],
    "drive.empty.my.title": "Um lugar para todos os seus arquivos",
    "drive.empty.my.body": "Arraste arquivos ou pastas para cá, ou use o botão Novo. Arquivos compartilhados no chat, e-mail e documentos aparecem em Recentes.",
    "drive.empty.upload": "Enviar arquivos",
    "drive.empty.shared.title": "Nada compartilhado com você ainda",
    "drive.empty.shared.body": "Arquivos, pastas, páginas e bancos de dados que compartilham com você, ou que postam onde você está, aparecem aqui.",
    "drive.empty.recent.title": "Nenhum arquivo recente",
    "drive.empty.recent.body": "Arquivos que você abre, edita ou compartilha aparecem aqui.",
    "drive.empty.starred.title": "Nenhum arquivo com estrela",
    "drive.empty.starred.body": "Adicione estrelas ao que você quer encontrar facilmente depois.",
    "drive.empty.trash.title": "A lixeira está vazia",
    "drive.empty.trash.body": "Itens na lixeira são excluídos permanentemente após 30 dias.",
    "drive.empty.conversations.title": "Nenhum arquivo de conversas",
    "drive.empty.conversations.body": "Arquivos que você compartilha no chat, e-mail e páginas aparecem aqui.",
    "drive.empty.folder.title": "Esta pasta está vazia",
    "drive.empty.folder.body": "Arraste arquivos para cá ou use o botão Novo.",
    "drive.empty.search.title": [{"type":0,"value":"Nenhum resultado para “"},{"type":1,"value":"q"},{"type":0,"value":"”"}],
    "drive.empty.search.body": "Tente outras palavras ou remova filtros. A pesquisa considera nomes, proprietários e onde os arquivos foram compartilhados.",
    "drive.empty.filtered.title": "Nada corresponde a esses filtros",
    "drive.trash.banner": "Itens na lixeira são excluídos permanentemente após 30 dias.",
    "drive.trash.confirmTitle": "Excluir permanentemente?",
    "drive.trash.confirmBody": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” será excluído permanentemente. Não é possível desfazer."}]},"other":{"value":[{"type":7},{"type":0,"value":" itens serão excluídos permanentemente. Não é possível desfazer."}]}},"offset":0,"pluralType":"cardinal"}],
    "drive.trash.emptyTitle": "Esvaziar a lixeira?",
    "drive.trash.emptyBody": "Todos os itens da lixeira serão excluídos permanentemente. Não é possível desfazer.",
    "drive.cancel": "Cancelar",
    "drive.failed": "Não foi possível carregar Arquivos.",
    "drive.retry": "Tentar novamente",
    "drive.from.dm": "Mensagem direta",
    "drive.from.mail": "E-mail",
    "drive.from.page": "Página",
    "drive.from.row": "Linha de banco de dados",
    "drive.sharedIn": [{"type":0,"value":"Compartilhado em "},{"type":1,"value":"where"}],
    "drive.attachment": "Anexo",
    "files.share.anyone": "Qualquer pessoa com o link",
    "files.share.anyoneHint": "Qualquer pessoa na internet com o link pode ver",
    "files.share.workspaceHint": "Qualquer pessoa deste workspace com o link",
    "files.share.anyoneNote": [{"type":0,"value":"Membros de "},{"type":1,"value":"workspace"},{"type":0,"value":" que abrirem o link recebem "},{"type":1,"value":"role"},{"type":0,"value":". Os demais só podem ver e baixar."}],
    "files.share.blockedOff": "Seu administrador desativou os links públicos",
    "files.share.blockedAdmins": "Só proprietários e administradores podem compartilhar com qualquer pessoa",
    "files.upload.photos": "Fotos e vídeos",
    "files.offline": "Mostrando o que está salvo neste dispositivo",
    "sync.files.entry": "Sincronizar com este computador",
    "sync.files.entryOn": "Sincronizando com este computador",
    "sync.files.getApp": "Baixar o app para computador",
    "sync.setup.windowTitle": "Configurar a sincronização do Bundle Files",
    "sync.setup.title": "Sincronize seus arquivos com este computador",
    "sync.setup.subtitle": "As pastas de Meus arquivos ficam sincronizadas entre o Bundle e uma pasta neste computador. Você pode mudar isso depois em Preferências.",
    "sync.mode.label": "Como seus arquivos devem ser sincronizados?",
    "sync.mode.mirror": "Espelhar arquivos",
    "sync.mode.mirrorBody": "Cada arquivo fica na nuvem e neste computador, numa pasta que você escolhe. Tudo funciona off-line.",
    "sync.mode.stream": "Fazer streaming de arquivos",
    "sync.mode.streamBody": "Os arquivos ficam na nuvem e são baixados quando você os abre. Deixe qualquer arquivo ou pasta disponível off-line. Quase não usa espaço em disco.",
    "sync.mode.streamRecommended": "Fazer streaming de arquivos (recomendado)",
    "sync.mode.streamOff": [{"type":0,"value":"Fazer streaming de arquivos · "},{"type":1,"value":"reason"}],
    "sync.mode.streamOff.unsupportedOs": "Requer macOS 26 ou posterior",
    "sync.mode.streamOff.notVerified": "Em breve no Windows",
    "sync.mode.streamOff.unsigned": "Indisponível nesta versão",
    "sync.location": "Local",
    "sync.location.change": "Alterar…",
    "sync.location.hint": "Escolha uma pasta vazia ou uma nova.",
    "sync.location.streamHint": "O macOS define o local dos arquivos em streaming. Ele aparece no Finder em Locais.",
    "sync.folders.title": "Pastas a sincronizar",
    "sync.folders.hint": "Pastas desmarcadas ficam só na web. Pastas novas são sincronizadas automaticamente.",
    "sync.folders.loose": "Arquivos fora de pastas",
    "sync.folders.empty": "Ainda não há pastas em Meus arquivos. Tudo o que você adicionar será sincronizado.",
    "sync.folders.failed": "Não foi possível carregar suas pastas.",
    "sync.folders.expand": [{"type":0,"value":"Mostrar pastas em "},{"type":1,"value":"name"}],
    "sync.folders.collapse": [{"type":0,"value":"Ocultar pastas em "},{"type":1,"value":"name"}],
    "sync.setup.start": "Começar a sincronizar",
    "sync.setup.failed": "Não foi possível começar a sincronizar. Verifique a pasta e tente de novo.",
    "sync.setup.folderNotEmpty": "Esta pasta não está vazia. Escolha uma pasta vazia ou nova para o Bundle.",
    "sync.cancel": "Cancelar",
    "sync.save": "Salvar",
    "sync.status.off": "A sincronização está desativada",
    "sync.status.offBody": "Configure a sincronização para manter uma pasta neste computador atualizada.",
    "sync.status.starting": "Iniciando…",
    "sync.status.idle": "Tudo sincronizado",
    "sync.status.lastSynced": [{"type":0,"value":"Última sincronização: "},{"type":1,"value":"time"}],
    "sync.status.syncing": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Sincronizando "},{"type":7},{"type":0,"value":" arquivo"}]},"other":{"value":[{"type":0,"value":"Sincronizando "},{"type":7},{"type":0,"value":" arquivos"}]}},"offset":0,"pluralType":"cardinal"}],
    "sync.status.left": [{"type":0,"value":"Faltam "},{"type":1,"value":"size"}],
    "sync.status.paused": "Sincronização pausada",
    "sync.status.pausedUntil": [{"type":0,"value":"Pausada até "},{"type":1,"value":"time"}],
    "sync.status.pausedBody": "As alterações ficam guardadas e serão sincronizadas quando você retomar.",
    "sync.status.offline": "Você está off-line",
    "sync.status.offlineBody": "As alterações serão sincronizadas quando você voltar a ficar on-line.",
    "sync.status.offlineBodyStream": "Os arquivos que você deixou disponíveis off-line continuam abrindo. As alterações serão sincronizadas quando você voltar a ficar on-line.",
    "sync.status.error": "Não foi possível sincronizar alguns arquivos",
    "sync.status.errorBody": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" erro"}]},"other":{"value":[{"type":7},{"type":0,"value":" erros"}]}},"offset":0,"pluralType":"cardinal"}],
    "sync.progress": "Progresso da sincronização",
    "sync.pause": "Pausar a sincronização",
    "sync.pause.hour": "Pausar por 1 hora",
    "sync.pause.tomorrow": [{"type":0,"value":"Pausar até amanhã ("},{"type":1,"value":"time"},{"type":0,"value":")"}],
    "sync.pause.manual": "Pausar até eu retomar",
    "sync.resume": "Retomar",
    "sync.menu": "Configurações",
    "sync.menu.preferences": "Preferências…",
    "sync.menu.quit": "Sair do Bundle",
    "sync.openFolder": "Abrir pasta",
    "sync.openBundle": "Abrir o Bundle",
    "sync.setUp": "Configurar a sincronização",
    "sync.activity": "Atividade",
    "sync.activity.empty": "Os arquivos que você adicionar, alterar ou excluir aparecem aqui.",
    "sync.activity.uploaded": "Enviado",
    "sync.activity.downloaded": "Baixado",
    "sync.activity.newVersion": "Atualizado",
    "sync.activity.newVersionBy": [{"type":0,"value":"Atualizado por "},{"type":1,"value":"name"}],
    "sync.activity.conflict": "Conflito · as duas cópias mantidas",
    "sync.activity.trashed": "Movido para a lixeira",
    "sync.activity.moved": "Movido",
    "sync.activity.created": "Adicionado",
    "sync.activity.error": "Não foi possível sincronizar",
    "sync.transfer.up": [{"type":0,"value":"Enviando · "},{"type":1,"value":"percent"},{"type":0,"value":"% de "},{"type":1,"value":"size"}],
    "sync.transfer.down": [{"type":0,"value":"Baixando · "},{"type":1,"value":"percent"},{"type":0,"value":"% de "},{"type":1,"value":"size"}],
    "sync.errors": "Erros",
    "sync.conflict.banner": [{"type":0,"value":"1 conflito: “"},{"type":1,"value":"name"},{"type":0,"value":"” mudou aqui e na web. As duas cópias foram mantidas."}],
    "sync.conflict.bannerMany": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" conflito: um arquivo mudou aqui e na web. As duas cópias foram mantidas."}]},"other":{"value":[{"type":7},{"type":0,"value":" conflitos: arquivos mudaram aqui e na web. As duas cópias de cada um foram mantidas."}]}},"offset":0,"pluralType":"cardinal"}],
    "sync.conflict.review": "Revisar",
    "sync.conflict.title": [{"type":0,"value":"“"},{"type":1,"value":"name"},{"type":0,"value":"” foi alterado em dois lugares"}],
    "sync.conflict.body": "Ele foi alterado neste computador e no Bundle desde a última sincronização. O Bundle manteve os dois, então nada se perdeu.",
    "sync.conflict.bodyBy": [{"type":1,"value":"name"},{"type":0,"value":" salvou uma versão no Bundle enquanto você o alterava aqui. O Bundle manteve os dois, então nada se perdeu."}],
    "sync.conflict.mine": "Este computador",
    "sync.conflict.theirs": "Bundle",
    "sync.conflict.theirsBy": [{"type":0,"value":"Bundle ("},{"type":1,"value":"name"},{"type":0,"value":")"}],
    "sync.conflict.savedAs": [{"type":0,"value":"Salvo como “"},{"type":1,"value":"name"},{"type":0,"value":"”"}],
    "sync.conflict.keptAs": [{"type":0,"value":"Mantido como “"},{"type":1,"value":"name"},{"type":0,"value":"”"}],
    "sync.conflict.useMine": "Usar a minha",
    "sync.conflict.useTheirs": "Usar a do Bundle",
    "sync.conflict.keepBoth": "Manter as duas",
    "sync.conflict.note": "“Usar a minha” salva sua cópia como a versão mais recente (a outra fica no histórico de versões). “Usar a do Bundle” move sua cópia para a lixeira.",
    "sync.conflict.failed": "Não foi possível resolver o conflito. Tente de novo.",
    "sync.prefs.windowTitle": "Bundle Files — Preferências",
    "sync.prefs.nav": "Preferências",
    "sync.prefs.myFiles": "Meus arquivos",
    "sync.prefs.general": "Geral",
    "sync.prefs.conflicts": "Conflitos",
    "sync.prefs.foldersNote": "As pastas removidas da sincronização vão para a lixeira deste computador. Na web, continuam onde estão.",
    "sync.prefs.foldersStream": "No streaming, todas as pastas de Meus arquivos aparecem neste computador, e só é baixado o que você abre.",
    "sync.prefs.toStreamTitle": "Mudar para streaming de arquivos?",
    "sync.prefs.toStreamBody": [{"type":0,"value":"Seus arquivos vão ficar na nuvem e ser baixados quando você os abrir. Os arquivos que já estão em "},{"type":1,"value":"path"},{"type":0,"value":" continuam neste computador como arquivos comuns, mas não serão mais sincronizados. Você pode excluí-los depois de conferir que está tudo no Bundle."}],
    "sync.prefs.toStreamConfirm": "Fazer streaming",
    "sync.prefs.toMirrorTitle": "Mudar para espelhamento de arquivos?",
    "sync.prefs.toMirrorBody": [{"type":0,"value":"O Bundle vai terminar de enviar suas alterações e depois baixar uma cópia de cada arquivo de Meus arquivos para uma pasta Bundle na sua pasta pessoal. Isso usa espaço em disco para todos eles. O local de streaming "},{"type":1,"value":"path"},{"type":0,"value":" é removido deste computador."}],
    "sync.prefs.toMirrorConfirm": "Espelhar arquivos",
    "sync.prefs.modeFailed": "Não foi possível mudar a forma de sincronização. Tente novamente.",
    "sync.prefs.saved": "Salvo",
    "sync.prefs.launchAtLogin": "Abrir o Bundle ao iniciar a sessão",
    "sync.prefs.bandwidth": "Largura de banda",
    "sync.prefs.uploadLimit": "Limite de envio",
    "sync.prefs.downloadLimit": "Limite de download",
    "sync.prefs.noLimit": "Sem limite",
    "sync.prefs.kbps": [{"type":1,"value":"value"},{"type":0,"value":" KB/s"}],
    "sync.prefs.mbps": [{"type":1,"value":"value"},{"type":0,"value":" MB/s"}],
    "sync.prefs.disconnect": "Desconectar",
    "sync.prefs.disconnectTitle": "Parar de sincronizar esta pasta?",
    "sync.prefs.disconnectBody": [{"type":0,"value":"Os arquivos que já estão neste computador continuam em "},{"type":1,"value":"path"},{"type":0,"value":", mas as alterações não serão mais sincronizadas. Seus arquivos no Bundle não são afetados."}],
    "sync.prefs.disconnectBodyStream": [{"type":1,"value":"path"},{"type":0,"value":" é removido deste computador, inclusive os arquivos que você deixou disponíveis off-line. Seus arquivos no Bundle não são afetados."}],
    "sync.prefs.noConflicts": "Nenhum conflito. Quando um arquivo muda aqui e no Bundle ao mesmo tempo, ele aparece aqui.",
    "sync.prefs.failed": "Não foi possível salvar. Tente de novo.",
    "sync.unavailable": "A sincronização de arquivos funciona no app do Bundle para computador.",
    "shell.view.calendar": "Agenda",
    "shell.view.contacts": "Contatos",
    "booking.pages": "Páginas de agendamento",
    "booking.paused": "Pausada",
    "booking.copyLink": "Copiar link",
    "booking.copyLinkTo": [{"type":0,"value":"Copiar link de "},{"type":1,"value":"title"}],
    "booking.moreFor": [{"type":0,"value":"Mais opções de "},{"type":1,"value":"title"}],
    "booking.linkCopied": "Link copiado",
    "booking.saveFailed": "Não foi possível salvar a página de agendamento. Tente de novo.",
    "booking.deleteFailed": "Não foi possível excluir a página de agendamento. Tente de novo.",
    "booking.create.button": "Criar",
    "booking.create.event": "Evento",
    "booking.create.page": "Página de agendamento",
    "booking.create.pageHelp": "Um link para as pessoas agendarem um horário com você",
    "booking.empty.title": "Nenhuma página de agendamento ainda",
    "booking.empty.body": "Deixe as pessoas agendarem um horário com você: crie uma página de agendamento e compartilhe o link.",
    "booking.menu.open": "Abrir página de agendamento",
    "booking.menu.edit": "Editar",
    "booking.menu.pause": "Pausar agendamentos",
    "booking.menu.resume": "Retomar agendamentos",
    "booking.menu.reset": "Redefinir link…",
    "booking.menu.resetShort": "Redefinir link",
    "booking.menu.delete": "Excluir…",
    "booking.menu.deleteShort": "Excluir",
    "booking.reset.title": "Redefinir o link?",
    "booking.reset.body": "A página ganha um novo link e o antigo para de funcionar. Os agendamentos já feitos continuam na sua agenda.",
    "booking.delete.title": [{"type":0,"value":"Excluir "},{"type":1,"value":"title"},{"type":0,"value":"?"}],
    "booking.delete.body": "O link para de funcionar. Os agendamentos já feitos continuam na sua agenda.",
    "booking.location.bundleMeeting": "Reunião do Bundle",
    "booking.location.inPerson": "Presencial",
    "booking.location.phone": "Ligação",
    "booking.location.none": "Nenhum",
    "booking.color.gray": "Cinza",
    "booking.color.brown": "Marrom",
    "booking.color.orange": "Laranja",
    "booking.color.yellow": "Amarelo",
    "booking.color.green": "Verde",
    "booking.color.blue": "Azul",
    "booking.color.purple": "Roxo",
    "booking.color.pink": "Rosa",
    "booking.color.red": "Vermelho",
    "booking.zone.label": "Fuso horário",
    "booking.zone.detected": "Detectado",
    "booking.editor.newTitle": "Nova página de agendamento",
    "booking.editor.editTitle": "Página de agendamento",
    "booking.editor.close": "Fechar editor",
    "booking.editor.title": "Título",
    "booking.editor.titlePlaceholder": "Adicionar título",
    "booking.editor.duration": "Duração do agendamento",
    "booking.editor.general": "Disponibilidade geral",
    "booking.editor.generalHelp": "Horários em que você atende por esta página. Eventos ocupados na sua agenda continuam bloqueando.",
    "booking.editor.repeatsWeekly": "Repete toda semana, no fuso",
    "booking.editor.unavailable": "Indisponível",
    "booking.editor.from": "Início",
    "booking.editor.to": "Fim",
    "booking.editor.removePeriod": "Remover período",
    "booking.editor.addPeriod": "Adicionar período",
    "booking.editor.addAnotherPeriod": "Adicionar outro período",
    "booking.editor.copyToAll": "Copiar horários para todos os dias",
    "booking.editor.overlap": "Os horários se sobrepõem",
    "booking.editor.endBeforeStart": "O fim precisa ser depois do início",
    "booking.editor.noHours": "Adicione pelo menos um período com tempo para um agendamento.",
    "booking.editor.window": "Janela de agendamento",
    "booking.editor.maxAhead": "Antecedência máxima (dias)",
    "booking.editor.daysSuffix": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" dia de antecedência"}]},"other":{"value":[{"type":7},{"type":0,"value":" dias de antecedência"}]}},"offset":0,"pluralType":"cardinal"}],
    "booking.editor.noLimit": "Sem limite",
    "booking.editor.minNotice": "Antecedência mínima",
    "booking.editor.noNotice": "Sem mínimo",
    "booking.editor.dateHours": "Horários em datas específicas",
    "booking.editor.dateHoursHelp": "Mude seus horários em uma data ou marque-a como indisponível.",
    "booking.editor.addDate": "Alterar horários de uma data",
    "booking.editor.removeDate": "Remover data",
    "booking.editor.appointment": "Configurações dos agendamentos",
    "booking.editor.buffer": "Intervalo entre reuniões",
    "booking.editor.noBuffer": "Sem intervalo",
    "booking.editor.minutesLong": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" minuto"}]},"other":{"value":[{"type":7},{"type":0,"value":" minutos"}]}},"offset":0,"pluralType":"cardinal"}],
    "booking.editor.hoursLong": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" hora"}]},"other":{"value":[{"type":7},{"type":0,"value":" horas"}]}},"offset":0,"pluralType":"cardinal"}],
    "booking.editor.maxPerDay": "Máximo de agendamentos por dia",
    "booking.editor.guestsCanInvite": "Convidados podem convidar outras pessoas",
    "booking.editor.calendars": "Agendas",
    "booking.editor.checkCalendars": "Verificar minhas agendas para disponibilidade",
    "booking.editor.location": "Local",
    "booking.editor.meetingHelp": "Cada agendamento ganha seu próprio link de reunião. Convidados sem Bundle pedem para entrar; você os admite.",
    "booking.editor.address": "Endereço",
    "booking.editor.phone": "Telefone",
    "booking.editor.phoneHelp": "Deixe vazio para pedir o número ao convidado.",
    "booking.editor.description": "Descrição",
    "booking.editor.form": "Formulário de agendamento",
    "booking.editor.formHelp": "Nome, sobrenome e e-mail são sempre pedidos.",
    "booking.editor.question": "Pergunta",
    "booking.editor.required": "Obrigatória",
    "booking.editor.removeQuestion": "Remover pergunta",
    "booking.editor.addQuestion": "Adicionar pergunta",
    "booking.editor.verifyEmail": "Verificar o e-mail dos convidados com um código",
    "booking.editor.reminders": "Lembretes",
    "booking.editor.remindersHelp": "Enviados por e-mail aos convidados antes do agendamento.",
    "booking.editor.addReminder": "Adicionar lembrete",
    "booking.editor.removeReminder": "Remover lembrete",
    "booking.editor.color": "Cor",
    "booking.editor.previewHelp": "Prévia: o que os convidados podem agendar, com seus eventos",
    "booking.event.booked": "Agendado pela sua página de agendamento",
    "booking.event.bookedVia": [{"type":0,"value":"Agendado pela sua página de agendamento "},{"type":1,"value":"page"}],
    "booking.event.cancel": "Cancelar agendamento",
    "booking.event.showAs": "Mostrar como",
    "booking.event.showAsBusy": "Ocupado",
    "booking.event.showAsFree": "Livre",
    "booking.public.poweredBy": "Agendamento pelo Bundle",
    "booking.public.notFound": "Este link de agendamento não funciona mais. Peça um novo.",
    "booking.public.loadFailed": "Não foi possível carregar os horários. Verifique sua conexão e tente de novo.",
    "booking.public.paused": "Esta página não está aceitando agendamentos no momento.",
    "booking.public.appointments": [{"type":0,"value":"Agendamentos de "},{"type":1,"value":"duration"}],
    "booking.public.meetingLater": "Reunião do Bundle — link na confirmação",
    "booking.public.phoneYou": "Ligação — você informa seu número",
    "booking.public.select": "Escolha um horário",
    "booking.public.prevWeek": "Semana anterior",
    "booking.public.nextWeek": "Próxima semana",
    "booking.public.jumpNext": "Ir para a próxima data disponível",
    "booking.public.noTimes": "Sem horários",
    "booking.public.noTimesWeek": "Sem horários disponíveis nesta semana.",
    "booking.public.dayNoTimes": [{"type":1,"value":"day"},{"type":0,"value":", sem horários"}],
    "booking.public.next": "Avançar",
    "booking.public.back": "Voltar",
    "booking.public.formTitle": "Agendar um horário",
    "booking.public.with": [{"type":1,"value":"title"},{"type":0,"value":" com "},{"type":1,"value":"name"}],
    "booking.public.firstName": "Nome",
    "booking.public.lastName": "Sobrenome",
    "booking.public.email": "E-mail",
    "booking.public.emailHelp": "O convite e os links para reagendar ou cancelar vão para este e-mail.",
    "booking.public.emailInvalid": "Digite um e-mail válido",
    "booking.public.required": "Obrigatório",
    "booking.public.optional": [{"type":1,"value":"label"},{"type":0,"value":" (opcional)"}],
    "booking.public.code": "Código de verificação",
    "booking.public.codeHelp": [{"type":0,"value":"Enviamos um código para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "booking.public.badCode": "Esse código não funcionou. Confira e tente de novo.",
    "booking.public.consent": [{"type":0,"value":"Ao agendar, você compartilha esses dados com "},{"type":1,"value":"name"},{"type":0,"value":"."}],
    "booking.public.sendCode": "Enviar código",
    "booking.public.book": "Agendar",
    "booking.public.taken": "Esse horário acabou de ser ocupado. Escolha outro.",
    "booking.public.bookFailed": "Não foi possível agendar. Tente de novo.",
    "booking.public.booked": "Agendado",
    "booking.public.sentTo": [{"type":0,"value":"Enviamos o convite para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "booking.public.reschedule": "Reagendar",
    "booking.public.cancel": "Cancelar agendamento",
    "booking.public.linksInEmail": "Os mesmos links para reagendar e cancelar estão no e-mail.",
    "booking.manage.title": "Seu agendamento",
    "booking.manage.notFound": "Este link de agendamento não funciona.",
    "booking.manage.join": "Entrar na reunião",
    "booking.manage.pickNew": "Escolha um novo horário",
    "booking.manage.moveTo": [{"type":0,"value":"Mudar para "},{"type":1,"value":"when"}],
    "booking.manage.keep": "Manter",
    "booking.manage.cancelTitle": "Cancelar este agendamento?",
    "booking.manage.cancelBody": [{"type":1,"value":"name"},{"type":0,"value":" recebe um e-mail e o evento sai da agenda. O link da reunião para de funcionar."}],
    "booking.manage.reason": "Motivo (opcional)",
    "booking.manage.cancelled": "Este agendamento foi cancelado",
    "booking.manage.ended": "Este agendamento já terminou",
    "booking.manage.bookAgain": "Agendar outro horário",
    "settings.nav.billing": "Cobrança",
    "billing.section.plan": "Plano",
    "billing.section.usage": "Uso",
    "billing.section.admins": "Quem gerencia a cobrança",
    "billing.plan.trial": "Teste do Starter",
    "billing.plan.starter": "Starter",
    "billing.plan.none": "Sem plano",
    "billing.plan.founding": "Fundador",
    "billing.founding": "Espaço fundador",
    "billing.founding.body": [{"type":1,"value":"ws"},{"type":0,"value":" está aqui desde o começo, então não tem limite de membros nem de armazenamento, e nada a pagar. Obrigado."}],
    "billing.trial.chip": [{"type":6,"value":"n","options":{"one":{"value":[{"type":0,"value":"Falta "},{"type":7},{"type":0,"value":" dia"}]},"other":{"value":[{"type":0,"value":"Faltam "},{"type":7},{"type":0,"value":" dias"}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.trial.body": [{"type":0,"value":"Seu teste gratuito termina em "},{"type":1,"value":"date"},{"type":0,"value":". Assine antes disso para manter tudo como está. Você só precisa de um cartão quando assinar."}],
    "billing.trial.day": [{"type":0,"value":"Dia "},{"type":1,"value":"day"},{"type":0,"value":" de "},{"type":1,"value":"total"}],
    "billing.trial.member": [{"type":1,"value":"ws"},{"type":0,"value":" está testando o Starter. O teste termina em "},{"type":1,"value":"date"},{"type":0,"value":"."}],
    "billing.active.member": [{"type":1,"value":"ws"},{"type":0,"value":" está no plano Starter."}],
    "billing.choosePlan": "Escolher plano",
    "billing.whatsIncluded": "O que está incluído",
    "billing.subscribe": "Assinar",
    "billing.manage": "Gerenciar cobrança",
    "billing.updateCard": "Atualizar forma de pagamento",
    "billing.chip.active": "Ativo",
    "billing.chip.trialCard": "Teste · cartão cadastrado",
    "billing.chip.ending": "Cancelado",
    "billing.chip.readOnly": "Somente leitura",
    "billing.pastDue.title": "Falha no pagamento",
    "billing.price.perMonth": "/mês",
    "billing.price.annual": [{"type":0,"value":"/mês, cobrado anualmente ("},{"type":1,"value":"total"},{"type":0,"value":" por ano)"}],
    "billing.price.monthly": "/mês, cobrado mensalmente",
    "billing.kv.nextPayment": "Próximo pagamento",
    "billing.kv.trialEnds": "Fim do teste",
    "billing.kv.firstPayment": "Primeiro pagamento",
    "billing.kv.amountOn": [{"type":1,"value":"amount"},{"type":0,"value":" em "},{"type":1,"value":"date"}],
    "billing.kv.endsOn": "Termina em",
    "billing.kv.paymentDue": "Pagamento pendente",
    "billing.kv.updateBy": [{"type":1,"value":"amount"},{"type":0,"value":" · atualize até "},{"type":1,"value":"date"}],
    "billing.kv.storage": "Armazenamento extra",
    "billing.kv.storageValue": [{"type":1,"value":"n"},{"type":0,"value":" × 50 GB"}],
    "billing.kv.invoices": "Faturas",
    "billing.viewInvoices": "Ver faturas",
    "billing.portalFoot": "Troque o cartão, baixe faturas ou cancele na Stripe. Você volta para cá quando terminar.",
    "billing.annual.title": [{"type":0,"value":"Pague por ano e economize "},{"type":1,"value":"amount"},{"type":0,"value":"."}],
    "billing.annual.body": [{"type":0,"value":"No plano anual são "},{"type":1,"value":"annual"},{"type":0,"value":" por mês em vez de "},{"type":1,"value":"monthly"},{"type":0,"value":"."}],
    "billing.switchAnnual": "Mudar para anual",
    "billing.pastDue.banner.title": "Não conseguimos cobrar seu cartão.",
    "billing.pastDue.banner.until": [{"type":0,"value":"Atualize a forma de pagamento até "},{"type":1,"value":"date"},{"type":0,"value":" para manter "},{"type":1,"value":"ws"},{"type":0,"value":" funcionando. Depois disso, fica somente leitura."}],
    "billing.pastDue.banner.body": [{"type":0,"value":"Atualize a forma de pagamento para manter "},{"type":1,"value":"ws"},{"type":0,"value":" funcionando."}],
    "billing.readOnly": [{"type":1,"value":"ws"},{"type":0,"value":" está somente leitura"}],
    "billing.readOnly.trialEnded": [{"type":0,"value":"O teste terminou em "},{"type":1,"value":"date"},{"type":0,"value":"."}],
    "billing.readOnly.ended": "A assinatura terminou.",
    "billing.readOnly.page": "Todos ainda podem ler e exportar, mas ninguém pode enviar, fazer upload ou editar até você assinar.",
    "billing.locked.body": [{"type":0,"value":"Suas mensagens, e-mails, documentos e arquivos estão seguros. Guardamos tudo até "},{"type":1,"value":"date"},{"type":0,"value":" (90 dias). Assine antes disso e tudo volta a funcionar."}],
    "billing.locked.bodyNoDate": "Suas mensagens, e-mails, documentos e arquivos ficam guardados por 90 dias. Assine antes disso e tudo volta a funcionar.",
    "billing.native.attention": [{"type":0,"value":"O plano de "},{"type":1,"value":"ws"},{"type":0,"value":" precisa de atenção. Gerencie no Bundle pela web."}],
    "billing.native.askAdmins": [{"type":0,"value":"Fale com "},{"type":1,"value":"names"},{"type":0,"value":" sobre o plano."}],
    "billing.native.composer": [{"type":0,"value":"Fale com "},{"type":1,"value":"names"},{"type":0,"value":" sobre o plano. Você ainda pode ler e pesquisar tudo."}],
    "billing.native.trialMember": [{"type":0,"value":"Depois disso, "},{"type":1,"value":"ws"},{"type":0,"value":" fica somente leitura. Fale com "},{"type":1,"value":"names"},{"type":0,"value":" sobre o plano."}],
    "billing.native.lockedBody": [{"type":0,"value":"Suas mensagens, e-mails, documentos e arquivos estão seguros. Guardamos tudo até "},{"type":1,"value":"date"},{"type":0,"value":" (90 dias)."}],
    "billing.native.lockedBodyNoDate": "Suas mensagens, e-mails, documentos e arquivos ficam guardados por 90 dias.",
    "billing.native.inviteOver": [{"type":0,"value":"O Starter comporta "},{"type":1,"value":"limit"},{"type":0,"value":" membros e "},{"type":1,"value":"ws"},{"type":0,"value":" tem "},{"type":1,"value":"members"},{"type":0,"value":", então remova "},{"type":1,"value":"remove"},{"type":0,"value":" destes."}],
    "billing.native.inviteFullAdmin": "Para convidar alguém, remova um membro em Membros.",
    "billing.exportData": "Exportar dados",
    "billing.askAdmins": [{"type":0,"value":"Peça para "},{"type":1,"value":"names"},{"type":0,"value":" assinar."}],
    "billing.anAdmin": "um proprietário ou administrador",
    "billing.trial.banner.title": [{"type":6,"value":"n","options":{"one":{"value":[{"type":0,"value":"Seu teste termina amanhã."}]},"other":{"value":[{"type":0,"value":"Seu teste termina em "},{"type":7},{"type":0,"value":" dias."}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.trial.banner.info": [{"type":0,"value":"Assine para manter "},{"type":1,"value":"ws"},{"type":0,"value":" funcionando depois de "},{"type":1,"value":"date"},{"type":0,"value":"."}],
    "billing.trial.banner.warning": [{"type":0,"value":"Depois de "},{"type":1,"value":"date"},{"type":0,"value":", "},{"type":1,"value":"ws"},{"type":0,"value":" fica somente leitura até alguém assinar."}],
    "billing.trial.banner.danger": "Assine hoje para que todos continuem enviando mensagens e e-mails.",
    "billing.trial.banner.member": [{"type":0,"value":"Depois disso, "},{"type":1,"value":"ws"},{"type":0,"value":" fica somente leitura. Peça para "},{"type":1,"value":"names"},{"type":0,"value":" assinar."}],
    "billing.composer.title": "Você não pode enviar mensagens agora",
    "billing.composer.admin": "Assine para voltar a enviar, fazer upload e editar.",
    "billing.composer.member": [{"type":0,"value":"Peça para "},{"type":1,"value":"names"},{"type":0,"value":" assinar. Você ainda pode ler e pesquisar tudo."}],
    "billing.picker.title": "Assinar o Starter",
    "billing.cycle.annual": [{"type":0,"value":"Anual · economize "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "billing.cycle.monthly": "Mensal",
    "billing.picker.billedYearly": [{"type":0,"value":"Cobrado "},{"type":1,"value":"amount"},{"type":0,"value":" uma vez por ano"}],
    "billing.picker.billedMonthly": "Cobrado todo mês. Cancele quando quiser.",
    "billing.picker.inc.members": [{"type":0,"value":"Até "},{"type":1,"value":"n"},{"type":0,"value":" membros"}],
    "billing.picker.inc.storage": [{"type":1,"value":"gb"},{"type":0,"value":" GB de armazenamento compartilhado pelo espaço"}],
    "billing.picker.inc.domain": "E-mail no seu próprio domínio",
    "billing.picker.inc.apps": "Chat, Meet, e-mail, agenda, documentos e arquivos",
    "billing.picker.storage.label": "Armazenamento extra",
    "billing.picker.storage.hint": [{"type":0,"value":"50 GB por "},{"type":1,"value":"price"},{"type":0,"value":"/mês cada. Altere depois em Cobrança."}],
    "billing.picker.storage.none": "Nenhum",
    "billing.picker.storage.option": [{"type":0,"value":"+"},{"type":1,"value":"gb"},{"type":0,"value":" GB"}],
    "billing.picker.dueToday": "Total hoje",
    "billing.picker.trialKept": [{"type":0,"value":"Seu teste continua. A primeira cobrança de "},{"type":1,"value":"amount"},{"type":0,"value":" será em "},{"type":1,"value":"date"},{"type":0,"value":"."}],
    "billing.continue": "Continuar para o pagamento",
    "billing.picker.foot": "Você paga na página segura da Stripe e depois volta para o Bundle. Mais impostos, quando houver.",
    "billing.picker.pro": [{"type":0,"value":"Mais de "},{"type":1,"value":"n"},{"type":0,"value":" pessoas? O Pro está chegando."}],
    "billing.contactPro": "Fale com a gente",
    "billing.confirm.title": "Confirmando seu pagamento com a Stripe…",
    "billing.confirm.hint": "Isso costuma levar alguns segundos. Você pode continuar trabalhando.",
    "billing.confirm.done": "Você está no Starter. Obrigado por assinar.",
    "billing.confirm.slow": "A Stripe ainda não confirmou o pagamento. Esta página atualiza quando confirmar.",
    "billing.usage.members": "Membros",
    "billing.usage.storage": "Armazenamento",
    "billing.usage.membersLeft": [{"type":6,"value":"n","options":{"one":{"value":[{"type":0,"value":"Resta "},{"type":7},{"type":0,"value":" vaga."}]},"other":{"value":[{"type":0,"value":"Restam "},{"type":7},{"type":0,"value":" vagas."}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.usage.membersFull": [{"type":0,"value":"O Starter comporta "},{"type":1,"value":"limit"},{"type":0,"value":" membros. Remova alguém ou fale com a gente sobre o Pro."}],
    "billing.usage.pending": [{"type":6,"value":"n","options":{"one":{"value":[{"type":0,"value":"Inclui "},{"type":7},{"type":0,"value":" convite pendente."}]},"other":{"value":[{"type":0,"value":"Inclui "},{"type":7},{"type":0,"value":" convites pendentes."}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.usage.storageShared": "Compartilhado por todo o espaço.",
    "billing.usage.storageAddons": [{"type":1,"value":"base"},{"type":0,"value":" com o Starter + "},{"type":1,"value":"extra"},{"type":0,"value":" em adicionais."}],
    "billing.pro.title": [{"type":0,"value":"Precisa de mais de "},{"type":1,"value":"n"},{"type":0,"value":" membros?"}],
    "billing.pro.hint": "Um plano Pro por pessoa está chegando.",
    "billing.adminsOnly": "Somente proprietários e administradores podem gerenciar a cobrança.",
    "billing.messageAdmin": "Mensagem",
    "billing.invite.over.title": [{"type":6,"value":"left","options":{"one":{"value":[{"type":0,"value":"Só cabe mais "},{"type":7},{"type":0,"value":" pessoa."}]},"other":{"value":[{"type":0,"value":"Só cabem mais "},{"type":7},{"type":0,"value":" pessoas."}]}},"offset":0,"pluralType":"cardinal"}],
    "billing.invite.over.body": [{"type":0,"value":"O Starter comporta "},{"type":1,"value":"limit"},{"type":0,"value":" membros e "},{"type":1,"value":"ws"},{"type":0,"value":" tem "},{"type":1,"value":"members"},{"type":0,"value":", então remova "},{"type":1,"value":"remove"},{"type":0,"value":" destes ou fale com a gente sobre o Pro."}],
    "billing.invite.full.title": [{"type":1,"value":"ws"},{"type":0,"value":" tem "},{"type":1,"value":"members"},{"type":0,"value":" de "},{"type":1,"value":"limit"},{"type":0,"value":" membros."}],
    "billing.invite.full.admin": "Para convidar alguém, remova um membro em Membros ou fale com a gente sobre o Pro.",
    "billing.invite.full.memberTitle": [{"type":1,"value":"ws"},{"type":0,"value":" está cheio."}],
    "billing.invite.full.member": [{"type":0,"value":"O Starter comporta "},{"type":1,"value":"limit"},{"type":0,"value":" membros. Peça para "},{"type":1,"value":"names"},{"type":0,"value":" abrir espaço."}],
    "billing.fault.required": [{"type":1,"value":"ws"},{"type":0,"value":" está somente leitura, então isso não foi enviado."}],
    "billing.fault.members": [{"type":1,"value":"ws"},{"type":0,"value":" atingiu o limite de membros."}],
    "billing.addStorage": "Adicionar armazenamento",
    "billing.storageFull.title": [{"type":1,"value":"ws"},{"type":0,"value":" está sem espaço de armazenamento"}],
    "billing.storageFull.usage": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"pool"},{"type":0,"value":" usados."}],
    "billing.storageFull.addStorage": "Esse envio não foi concluído. Adicione armazenamento para continuar enviando ou exclua arquivos de que não precisa mais.",
    "billing.storageFull.choosePlan": "Esse envio não foi concluído. Escolha um plano com mais armazenamento ou exclua arquivos de que não precisa mais.",
    "billing.storageFull.contact": [{"type":0,"value":"Esse envio não foi concluído. "},{"type":1,"value":"ws"},{"type":0,"value":" já tem todos os complementos de armazenamento: fale com a gente para ter mais ou exclua arquivos de que não precisa mais."}],
    "billing.storageFull.web": "Esse envio não foi concluído. Gerencie o armazenamento na web ou exclua arquivos de que não precisa mais.",
    "billing.storageFull.store": [{"type":0,"value":"Esse envio não foi concluído. Adicione armazenamento à assinatura da "},{"type":1,"value":"store"},{"type":0,"value":" ou exclua arquivos de que não precisa mais."}],
    "billing.storageFull.member": [{"type":0,"value":"Esse envio não foi concluído. Peça para "},{"type":1,"value":"names"},{"type":0,"value":" adicionar armazenamento ou exclua arquivos de que não precisa mais."}],
    "billing.storageFull.notNow": "Agora não",
    "billing.storageWarn.title": [{"type":1,"value":"ws"},{"type":0,"value":" já usou "},{"type":1,"value":"percent"},{"type":0,"value":"% do armazenamento"}],
    "billing.storageWarn.fullTitle": [{"type":1,"value":"ws"},{"type":0,"value":" está sem espaço de armazenamento"}],
    "billing.storageWarn.addStorage": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"pool"},{"type":0,"value":" usados. Adicione armazenamento para continuar enviando ou exclua arquivos de que não precisa mais."}],
    "billing.storageWarn.choosePlan": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"pool"},{"type":0,"value":" usados. Escolha um plano com mais armazenamento ou exclua arquivos de que não precisa mais."}],
    "billing.storageWarn.contact": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"pool"},{"type":0,"value":" usados. "},{"type":1,"value":"ws"},{"type":0,"value":" já tem todos os complementos de armazenamento: fale com a gente para ter mais ou exclua arquivos de que não precisa mais."}],
    "billing.storageWarn.store": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"pool"},{"type":0,"value":" usados. Adicione armazenamento à assinatura da "},{"type":1,"value":"store"},{"type":0,"value":" ou exclua arquivos de que não precisa mais."}],
    "billing.storageWarn.member": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"pool"},{"type":0,"value":" usados. Peça para "},{"type":1,"value":"names"},{"type":0,"value":" adicionar armazenamento ou exclua arquivos de que não precisa mais."}],
    "billing.usage.storageLow": "O espaço está acabando. Adicione armazenamento ou exclua arquivos de que não precisa mais.",
    "billing.usage.storageOut": "Sem espaço. Adicione armazenamento ou exclua arquivos de que não precisa mais.",
    "billing.usage.storageLowMember": "O espaço está acabando. Exclua arquivos de que não precisa mais ou peça a um proprietário ou administrador para adicionar armazenamento.",
    "billing.usage.storageOutMember": "Sem espaço. Exclua arquivos de que não precisa mais ou peça a um proprietário ou administrador para adicionar armazenamento.",
    "billing.native.storageWarning": [{"type":1,"value":"used"},{"type":0,"value":" de "},{"type":1,"value":"pool"},{"type":0,"value":" usados. Gerencie o armazenamento no Bundle pela web ou exclua arquivos de que não precisa mais."}],
    "billing.native.storageLow": "O espaço está acabando. Gerencie o armazenamento no Bundle pela web ou exclua arquivos de que não precisa mais.",
    "billing.native.storageOut": "Sem espaço. Gerencie o armazenamento no Bundle pela web ou exclua arquivos de que não precisa mais.",
    "billing.error.unavailable": "A cobrança não está disponível agora. Tente mais tarde.",
    "billing.error.network": "Você está offline. Tente de novo quando estiver conectado.",
    "billing.error.generic": "Algo deu errado. Tente de novo.",
    "billing.usage.countRule": "Convites pendentes contam; convidados externos não.",
    "support.botName": "Suporte",
    "support.help.button": "Ajuda",
    "support.help.center": "Central de ajuda",
    "support.help.whatsNew": "Novidades",
    "support.help.shortcuts": "Atalhos de teclado",
    "support.help.ask": "Falar com o Suporte",
    "support.help.askHint": "Responde na hora",
    "support.help.askFailed": "Não foi possível abrir o Suporte. Tente de novo em instantes.",
    "support.help.feedback": "Enviar feedback…",
    "support.help.section": "Ajuda e feedback",
    "support.help.version": [{"type":0,"value":"Bundle "},{"type":1,"value":"version"}],
    "support.kind.bug": "Bug",
    "support.kind.idea": "Ideia",
    "support.kind.question": "Pergunta",
    "support.kind.label": "Tipo",
    "support.form.title": "Enviar feedback",
    "support.form.subtitle": "Abre uma conversa na sua DM com o Suporte. O time do Bundle também vê; seu workspace não.",
    "support.form.bug.label": "O que deu errado?",
    "support.form.bug.placeholder": "O que você fez, o que aconteceu e o que esperava?",
    "support.form.idea.label": "O que deixaria o Bundle melhor?",
    "support.form.idea.placeholder": "Descreva a ideia e o problema que ela resolve para você.",
    "support.form.question.label": "O que você quer saber?",
    "support.form.question.placeholder": "Pergunte qualquer coisa sobre o Bundle. O Suporte responde na sua DM.",
    "support.form.addScreenshot": "Adicionar captura de tela",
    "support.form.chooseFile": "Escolher arquivo",
    "support.form.lastScreenshot": "Usar a última captura",
    "support.form.choosePhoto": "Escolher das Fotos…",
    "support.form.removeScreenshot": "Remover captura de tela",
    "support.form.screenshotSize": [{"type":0,"value":"Captura de tela · "},{"type":1,"value":"size"}],
    "support.form.diagnostics": "Incluir diagnóstico",
    "support.form.whatsIncluded": "O que é enviado",
    "support.form.hideIncluded": "Ocultar o que é enviado",
    "support.form.send": "Enviar",
    "support.form.cancel": "Cancelar",
    "support.form.tooShort": [{"type":0,"value":"Escreva pelo menos "},{"type":1,"value":"min"},{"type":0,"value":" caracteres."}],
    "support.form.tooLong": [{"type":0,"value":"Use menos de "},{"type":1,"value":"max"},{"type":0,"value":" caracteres."}],
    "support.form.notImage": "Escolha uma imagem.",
    "support.form.tooBig": [{"type":0,"value":"Imagens podem ter até "},{"type":1,"value":"mb"},{"type":0,"value":" MB."}],
    "support.form.rateLimited": [{"type":0,"value":"Você enviou bastante feedback recentemente. Poderá enviar mais às "},{"type":1,"value":"time"},{"type":0,"value":". Seu texto continua aqui."}],
    "support.form.error": "Não foi possível enviar seu feedback. Verifique sua conexão e tente de novo.",
    "support.form.tryAgain": "Tentar de novo",
    "support.sent": "Enviado ao Suporte.",
    "support.sentVote": "Enviado ao Suporte. Alguém já relatou isso, então contamos seu voto.",
    "support.open": "Abrir",
    "support.diag.app": "App",
    "support.diag.language": "Idioma",
    "support.diag.screen": "Tela",
    "support.diag.connection": "Conexão",
    "support.dm.notice": "As mensagens aqui são compartilhadas com o time do Bundle, não com o seu workspace.",
    "support.dm.subtitle": "Responde na hora. O time do Bundle entra quando ele não consegue.",
    "support.mention.hint": "Agente de ajuda do Bundle",
    "settings.nav.calendar": "Agenda",
    "calendar.meetSwap.prompt.which": "Quais eventos mover",
    "calendar.meetSwap.confirm.link": "Cada evento ganha seu próprio link, como no Meet. O link do Google Meet sai do local, da descrição e da videochamada.",
    "calendar.meetSwap.confirm.google": "Os eventos do Google Agenda são alterados lá também, para que a cópia de todos fique igual.",
    "calendar.meetSwap.confirm.left": "Ficam como estão: eventos que outra pessoa organiza e eventos passados.",
    "calendar.meetSwap.movedQuiet": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" evento movido para o Bundle."}]},"other":{"value":[{"type":7},{"type":0,"value":" eventos movidos para o Bundle."}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.failed": "Não foi possível mover os eventos. Tente de novo.",
    "calendar.meetSwap.busy": "Outra mudança ainda está em andamento.",
    "calendar.meetSwap.settings.restoring": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Voltando o link do Google Meet em "},{"type":7},{"type":0,"value":" evento"}]},"other":{"value":[{"type":0,"value":"Voltando os links do Google Meet em "},{"type":7},{"type":0,"value":" eventos"}]}},"offset":0,"pluralType":"cardinal"}],
    "calendar.meetSwap.settings.scopeBody": "Um administrador precisa permitir que o Bundle edite agendas no Google Admin Console.",
    "calendar.meetSwap.settings.showEvents": "Mostrar eventos",
    "calendar.meetSwap.policy.details": "Ver detalhes",
    "calendar.meetSwap.policy.hideDetails": "Ocultar detalhes",
    "calendar.meetSwap.policy.memberRow": [{"type":1,"value":"done"},{"type":0,"value":" de "},{"type":1,"value":"total"},{"type":0,"value":" eventos · "},{"type":1,"value":"skipped"},{"type":0,"value":" ignorados"}],
    "calendar.meetSwap.policy.restoring": "Voltando os links do Google Meet dos membros",
    "calendar.meetSwap.policy.scopeTitle": "Eventos do Google Agenda estão aguardando.",
    "calendar.meetSwap.policy.scopeBody": "Permita que o Bundle edite agendas no Google Admin Console, e eles serão movidos sozinhos.",
    "calendar.meetSwap.policy.setup": "Configurar agora",
    "calendar.meetSwap.policy.existing": "Eventos existentes com Google Meet",
    "calendar.meetSwap.policy.outside": [{"type":0,"value":"Eventos organizados fora de "},{"type":1,"value":"workspace"},{"type":0,"value":" nunca são alterados. Cada pessoa recebe um aviso na Atividade com o que foi movido."}],
    "calendar.meetSwap.policy.turnOn": "Ativar",
    "calendar.meetSwap.policy.restoreConfirm": "Voltar para os links do Google Meet para todos? Os convidados recebem outra atualização.",
    "calendar.meetSwap.policy.failed": "Não foi possível alterar a configuração. Tente de novo.",
    "getApp.banner.desktop": "O Bundle funciona melhor no app para computador.",
    "getApp.openInApp": "Abrir no app",
    "getApp.download.mac": "Baixar para Mac",
    "getApp.download.windows": "Baixar para Windows",
    "getApp.download.linux": "Baixar para Linux",
    "getApp.mobile.title": "Bundle",
    "getApp.mobile.message": "E-mail, chat e chamadas funcionam melhor no app.",
    "getApp.store.appStore": "Grátis na App Store",
    "getApp.store.testflight": "Beta grátis no TestFlight",
    "getApp.store.play": "Grátis no Google Play",
    "getApp.store.apk": "Download direto (.apk)",
    "getApp.action.get": "Obter",
    "getApp.action.install": "Instalar",
    "getApp.action.download": "Baixar",
    "getApp.menu.desktop": "Baixar o app para computador",
    "getApp.menu.mobile": "Baixar o app para celular",
    "getApp.menu.any": "Baixar os apps",
    "getApp.dismiss": "Agora não",
    "getApp.handoff.title": "Abrindo o Bundle…",
    "getApp.handoff.body": "Se nada acontecer, clique em Abrir o Bundle.",
    "getApp.handoff.open": "Abrir o Bundle",
    "getApp.handoff.browser": "Continuar no navegador",
    "getApp.handoff.noApp": "Não tem o app?",
    "getApp.handoff.allDownloads": "Ver todos os downloads",
    "billing.store.choosePlan": "Escolher um plano",
    "billing.store.pickerTitle": "Assinar o Starter",
    "billing.store.cycle.yearly": [{"type":0,"value":"Anual · economize "},{"type":1,"value":"percent"},{"type":0,"value":"%"}],
    "billing.store.cycle.monthly": "Mensal",
    "billing.store.price.perYear": [{"type":1,"value":"price"},{"type":0,"value":"/ano"}],
    "billing.store.price.perMonth": [{"type":1,"value":"price"},{"type":0,"value":"/mês"}],
    "billing.store.priceSource.appStore": "Preço da App Store, na sua moeda.",
    "billing.store.priceSource.googlePlay": "Preço do Google Play, na sua moeda.",
    "billing.store.storage.label": "Armazenamento extra",
    "billing.store.storage.value": [{"type":0,"value":"+"},{"type":1,"value":"gb"},{"type":0,"value":" GB"}],
    "billing.store.storage.none": "Nenhum",
    "billing.store.storage.hint": "O Starter inclui 30 GB compartilhados por todos. Cada etapa adiciona 50 GB.",
    "billing.store.storage.less": "Menos armazenamento",
    "billing.store.storage.more": "Mais armazenamento",
    "billing.store.billedToday": "Cobrado hoje",
    "billing.store.trialEnds": "Seu teste gratuito termina quando você assinar.",
    "billing.store.subscribe.appStore": "Assinar com a Apple",
    "billing.store.subscribe.googlePlay": "Assinar com o Google",
    "billing.store.period.month": "mês",
    "billing.store.period.year": "ano",
    "billing.store.legal.appStore": [{"type":0,"value":"Renova automaticamente por "},{"type":1,"value":"price"},{"type":0,"value":" por "},{"type":1,"value":"period"},{"type":0,"value":" até você cancelar. O pagamento é cobrado na sua Conta Apple quando você confirma. Cancele pelo menos 24 horas antes da renovação em Ajustes → Conta Apple → Assinaturas."}],
    "billing.store.legal.googlePlay": [{"type":0,"value":"Renova automaticamente por "},{"type":1,"value":"price"},{"type":0,"value":" por "},{"type":1,"value":"period"},{"type":0,"value":" até você cancelar. Cobrado na sua conta do Google Play. Cancele quando quiser em Google Play → Pagamentos e assinaturas."}],
    "billing.store.terms": "Termos de Uso",
    "billing.store.privacy": "Política de Privacidade",
    "billing.store.restore": "Restaurar compras",
    "billing.store.restored": "Compras restauradas.",
    "billing.store.restoreNone": "Nenhuma assinatura para restaurar nesta conta.",
    "billing.store.confirming": "Confirmando…",
    "billing.store.pending.appStore": [{"type":0,"value":"Compra pendente. Vamos mudar "},{"type":1,"value":"ws"},{"type":0,"value":" para o Starter assim que a App Store aprovar o pagamento."}],
    "billing.store.pending.googlePlay": [{"type":0,"value":"Compra pendente. Vamos mudar "},{"type":1,"value":"ws"},{"type":0,"value":" para o Starter assim que o Google Play confirmar o pagamento."}],
    "billing.store.success": [{"type":1,"value":"ws"},{"type":0,"value":" está no Starter. Obrigado por assinar."}],
    "billing.store.failed.appStore": "A App Store não conseguiu concluir a compra. Você não foi cobrado. Tente de novo.",
    "billing.store.failed.googlePlay": "O Google Play não conseguiu concluir a compra. Você não foi cobrado. Tente de novo.",
    "billing.store.slow": "Sua compra foi concluída, mas o Bundle ainda não a confirmou. Esta página se atualiza sozinha. Se não atualizar, toque em Restaurar compras.",
    "billing.store.already": [{"type":1,"value":"ws"},{"type":0,"value":" já tem uma assinatura. Nada foi cobrado."}],
    "billing.store.accountInUse.appStore": "Esta Conta Apple já paga outro workspace. Use outra Conta Apple ou assine pelo Bundle na web.",
    "billing.store.accountInUse.googlePlay": "Esta conta Google já paga outro workspace. Use outra conta Google ou assine pelo Bundle na web.",
    "billing.store.unavailable": "Compras não estão disponíveis agora. Tente mais tarde.",
    "billing.store.billedThrough": "Cobrado via",
    "billing.store.name.appStore": "App Store",
    "billing.store.name.googlePlay": "Google Play",
    "billing.store.name.stripe": "Cartão",
    "billing.store.subscribedBy": "Assinado por",
    "billing.store.you": "Você",
    "billing.store.manage.appStore": "Gerenciar na App Store",
    "billing.store.manage.googlePlay": "Gerenciar no Google Play",
    "billing.store.manageHint.appStore": "Mude o plano, o armazenamento extra ou cancele na App Store.",
    "billing.store.manageHint.googlePlay": "Mude o plano, o armazenamento extra ou cancele no Google Play.",
    "billing.store.elsewhere.appStore": [{"type":0,"value":"Esta assinatura é gerenciada na App Store por "},{"type":1,"value":"name"},{"type":0,"value":". Mude ou cancele por lá, no iPhone, iPad ou Mac dessa pessoa."}],
    "billing.store.elsewhere.googlePlay": [{"type":0,"value":"Esta assinatura é gerenciada no Google Play por "},{"type":1,"value":"name"},{"type":0,"value":". Mude ou cancele por lá, no celular ou tablet Android dessa pessoa."}],
    "billing.store.card": "Cobrado no cartão. Mude o plano, o cartão ou as faturas pelo Bundle na web ou no desktop.",
    "settings.section.profile": "Perfil e status",
    "settings.section.account": "Conta e acesso",
    "settings.section.notifications": "Notificações",
    "settings.section.appearance": "Aparência",
    "settings.section.mail": "E-mail",
    "settings.section.calendar": "Agenda e reuniões",
    "settings.section.sidebar": "Barra lateral e abas",
    "settings.section.tabs": "Abas",
    "settings.section.privacy": "Privacidade e dados",
    "settings.section.general": "Geral",
    "settings.section.people": "Pessoas",
    "settings.section.billing": "Plano e cobrança",
    "settings.section.features": "Recursos e apps",
    "settings.section.domains": "E-mail e domínios",
    "settings.section.huddles": "Meet",
    "settings.section.import": "Importar e exportar",
    "settings.section.workspace": "Espaço de trabalho",
    "settings.section.device": "Sons e vibração",
    "settings.section.sync": "Sincronização no computador",
    "settings.section.help": "Ajuda e sobre",
    "settings.section.profile.desc": [{"type":0,"value":"Como as pessoas veem você em "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.section.account.desc": "Como você entra no Bundle. Os endereços de onde você envia e-mail ficam em E-mail.",
    "settings.section.notifications.desc": "Tudo o que pode te avisar, num lugar só. Fica salvo na sua conta e vale em todos os aparelhos.",
    "settings.section.appearance.desc": "Tema, cor de destaque e idioma. Fica salvo na sua conta.",
    "settings.section.mail.desc": "Os endereços de onde você envia, suas assinaturas e as contas que você traz.",
    "settings.section.calendar.desc": "Videochamadas nos seus eventos e suas páginas de agendamento.",
    "settings.section.sidebar.desc": "O que fica nas suas abas e na barra inferior do celular.",
    "settings.section.privacy.desc": "Pessoas que você bloqueou, uma cópia dos seus dados e a exclusão da sua conta.",
    "settings.section.general.desc": [{"type":0,"value":"Nome, ícone, link e domínios de e-mail de "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.section.people.desc": "Membros, convites, convidados e agentes, e grupos de usuários.",
    "settings.section.billing.desc": "Plano, uso e faturas.",
    "settings.section.features.desc": "Ligue ou desligue partes do Bundle e conecte apps.",
    "settings.section.domains.desc": [{"type":0,"value":"Domínios, caixas, roteamento e abas da caixa de entrada para todos em "},{"type":1,"value":"workspace"},{"type":0,"value":"."}],
    "settings.section.huddles.desc": "Links de reunião, anotações e pessoas de fora.",
    "settings.section.import.desc": "Traga coisas do Slack e do Google Drive, exporte o espaço e revise denúncias.",
    "settings.section.workspace.desc": "Só proprietários e administradores podem mudar isso.",
    "settings.section.device.desc": "Só neste aparelho.",
    "settings.section.sync.desc": "Pastas neste computador que ficam iguais a Arquivos.",
    "settings.section.help.desc": "Ajuda, novidades, feedback e a versão que você usa.",
    "settings.search.profile": "foto, avatar, nome, nome de exibição, cargo, pronomes, telefone, status, fuso horário, link",
    "settings.search.account": "e-mail, acesso, entrar, login, Google, Apple, senha, senhas de app, sessões, aparelhos, sair, excluir conta",
    "settings.search.notifications": "pausar, horário silencioso, não perturbe, menções, mensagens diretas, conversas, canais, meet, reuniões, chamadas, huddles, lembretes, novo e-mail, abas de e-mail, som, banners, push",
    "settings.search.appearance": "tema, modo escuro, modo claro, cor de destaque, cor, idioma, language, Português, English",
    "settings.search.mail": "caixa, apelido, enviar como, responder de, endereço padrão, assinatura, importar e-mail, Gmail, IMAP, grupos",
    "settings.search.calendar": "videochamadas, Google Meet, Zoom, links de reunião, páginas de agendamento, sincronizar celular, CalDAV",
    "settings.search.sidebar": "abas, barra inferior, navegação, personalizar abas, barra lateral",
    "settings.search.privacy": "pessoas bloqueadas, bloquear, exportar meus dados, baixar dados, excluir conta, importar do Slack",
    "settings.search.general": "nome do espaço, ícone, link, URL, domínios de e-mail, prévias de links, compartilhamento, excluir espaço",
    "settings.search.people": "membros, convidar, convites, convidados, agentes, bots, grupos de usuários, funções, administradores, desativar",
    "settings.search.billing": "plano, cobrança, faturas, cartão, pagamento, armazenamento, assinatura",
    "settings.search.features": "recursos, desligar chat, e-mail, agenda, contatos, documentos, integrações, apps, webhooks, comandos, figurinhas, GIFs",
    "settings.search.domains": "domínios, DNS, MX, SPF, DKIM, caixas, apelidos, roteamento, abas da caixa de entrada, Enviado com o Bundle, rodapé",
    "settings.search.huddles": "meet, reuniões, chamadas, huddles, links de reunião, transcrições, gravações, anotações, pessoas de fora, política de videochamadas",
    "settings.search.import": "importar do Slack, sincronizar Slack, Google Drive, exportar espaço, denúncias, mensagens denunciadas",
    "settings.search.workspace": "espaço de trabalho, plano, administradores, proprietários",
    "settings.search.device": "som, vibração, som de notificação, permitir notificações, banners",
    "settings.search.sync": "sincronização, pastas, abrir ao iniciar, banda, conflitos",
    "settings.search.help": "ajuda, novidades, feedback, análise de uso, versão, sobre, termos, política de privacidade",
    "settings.searchPlaceholder": "Buscar nas configurações",
    "settings.searchEmpty": [{"type":0,"value":"Nenhuma configuração corresponde a “"},{"type":1,"value":"query"},{"type":0,"value":"”."}],
    "settings.adminChip": "Admin",
    "settings.group.device.browser": "Este navegador",
    "settings.group.device.mac": "Este Mac",
    "settings.group.device.computer": "Este computador",
    "settings.group.device.iphone": "Este iPhone",
    "settings.group.device.ipad": "Este iPad",
    "settings.group.device.phone": "Este celular",
    "settings.group.device.tablet": "Este tablet",
    "settings.hub.group.general": "Geral",
    "settings.hub.group.people": "Pessoas",
    "settings.hub.group.whatsOn": "O que está ligado",
    "settings.hub.group.mail": "E-mail",
    "settings.hub.group.planData": "Plano e dados",
    "settings.hub.name": "Nome, ícone e link",
    "settings.hub.linkPreviews": "Prévias de links",
    "settings.hub.members": "Membros",
    "settings.hub.invitations": "Convites",
    "settings.hub.guests": "Convidados e agentes",
    "settings.hub.userGroups": "Grupos de usuários",
    "settings.hub.features": "Recursos",
    "settings.hub.huddles": "Meet",
    "settings.hub.apps": "Apps e integrações",
    "settings.hub.domains": "Domínios e caixas",
    "settings.hub.sentWithBundle": "“Enviado com o Bundle”",
    "settings.hub.billing": "Plano e cobrança",
    "settings.hub.pendingCount": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" pendente"}]},"other":{"value":[{"type":7},{"type":0,"value":" pendentes"}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.hub.import": "Importar e exportar",
    "settings.hub.reports": "Denúncias",
    "settings.hub.role.admin": "Você é administrador",
    "settings.hub.role.owner": "Você é proprietário",
    "settings.hub.role.member": "Membro",
    "settings.hub.role.guest": "Convidado",
    "settings.profileCard.sub": "Perfil e status",
    "settings.saved.check": "Salvo",
    "settings.notifications.deviceOnly": "Só neste aparelho",
    "settings.notifications.alwaysCodes": "Códigos de verificação sempre avisam, com um botão Copiar. Spam nunca avisa.",
    "settings.notifications.on": "As notificações estão ligadas",
    "settings.notifications.quietSummary": [{"type":0,"value":"Horário silencioso "},{"type":1,"value":"days"},{"type":0,"value":", das "},{"type":1,"value":"from"},{"type":0,"value":" às "},{"type":1,"value":"to"}],
    "settings.notifications.noQuiet": "Sem horário silencioso",
    "settings.notifications.quietHours": "Horário silencioso",
    "settings.notifications.pause": "Pausar…",
    "settings.notifications.unavailable": "Indisponível aqui",
    "settings.notifications.blockedShort": "Bloqueadas",
    "settings.notifications.allowed": "Permitidas · Desligar",
    "settings.notifications.allowedHelp": "Os banners aparecem quando o Bundle não está na frente.",
    "settings.notifications.banners": "Notificações neste aparelho",
    "settings.notifications.soundOff": "Desligado",
    "mail.notify.tabsNone": "Nenhuma",
    "settings.help.title": "Ajuda",
    "settings.help.foot": "Falar com o suporte e Enviar feedback ficam no menu Ajuda (?).",
    "settings.help.open": "Abrir",
    "settings.help.about": "Sobre",
    "settings.help.version": "Versão",
    "settings.sync.unavailable": "Esta versão do app não sincroniza pastas.",
    "settings.sync.on": "A sincronização está ligada",
    "settings.sync.off": "A sincronização está desligada",
    "settings.sync.body": "Escolha pastas, abrir ao iniciar, banda e conflitos no painel de sincronização.",
    "settings.meta.mailboxes": [{"type":6,"value":"count","options":{"one":{"value":[{"type":7},{"type":0,"value":" conta"}]},"other":{"value":[{"type":7},{"type":0,"value":" contas"}]}},"offset":0,"pluralType":"cardinal"}],
    "mail.settings.addresses": "Endereços de onde você envia",
    "mail.settings.addressesFoot": "Você ainda pode escolher outro endereço em De ao escrever.",
    "mail.settings.addressShared": [{"type":0,"value":"Compartilhada · "},{"type":1,"value":"name"}],
    "mail.settings.addressDefault": "Padrão",
    "mail.settings.addressGroup": [{"type":0,"value":"Grupo · "},{"type":1,"value":"name"}],
    "mail.settings.sending": "Envio e respostas",
    "mail.settings.defaultFrom": "Enviar novas mensagens de",
    "mail.settings.replyFrom": "Ao responder uma mensagem",
    "mail.settings.replyFrom.same": "Responder do mesmo endereço para o qual a mensagem foi enviada",
    "mail.settings.replyFrom.default": "Sempre responder do endereço padrão",
    "mail.settings.sendingFailed": "Não foi possível salvar. Tente de novo.",
    "settings.appearance.accent": "Cor de destaque",
    "settings.appearance.accent.indigo": "Índigo",
    "settings.appearance.accent.teal": "Verde-azulado",
    "settings.appearance.accent.orange": "Laranja",
    "settings.appearance.accent.purple": "Roxo",
    "settings.notifications.paused": "Pausadas",
    "settings.device.allowed": "Permitidas",
    "settings.device.notAllowed": "Não permitidas",
    "settings.device.previews": "Mostrar texto da mensagem",
    "settings.device.systemHint": "Sons, banners e prévias das mensagens do Bundle são definidos no app Ajustes deste aparelho.",
    "settings.device.openSystem": "Abrir ajustes do aparelho",
    "settings.appearance.languageSystem": "O Bundle usa o idioma escolhido para ele no app Ajustes deste aparelho.",
    "settings.workspace.admins": "Proprietários e administradores",
    "settings.workspace.message": "Mensagem",
    "settings.workspace.adminsFoot": "Peça a uma dessas pessoas para mudar as configurações do workspace ou o plano.",
    "settings.workspace.messageAdmin": "Enviar mensagem",
    "settings.workspace.readOnly": "Só proprietários e administradores podem mudar as configurações do espaço de trabalho. Peça ajuda a um deles.",
    "settings.notifications.onShort": "Ativadas",
    "settings.device.haptics": "Vibração",
    "settings.device.hapticsHint": "Vibrações leves quando você salva uma alteração, liga ou desliga algo, ou toca e segura.",
    "auth.error.challengeExpired": "Isso demorou demais. Entre de novo.",
    "auth.error.passkey": "O login com chave de acesso não funcionou. Tente de novo ou entre de outro jeito.",
    "accountSecurity.emails.title": "Endereços de e-mail",
    "accountSecurity.emails.add": "Adicionar e-mail",
    "accountSecurity.emails.foot": "Um novo endereço recebe um código antes de poder ser usado.",
    "accountSecurity.emails.primary": "Principal",
    "accountSecurity.emails.verified": "Verificado",
    "accountSecurity.emails.pending": "Aguardando código",
    "accountSecurity.emails.primaryHint": "E-mails de login e da conta vão para cá",
    "accountSecurity.emails.secondaryHint": "Também pode entrar",
    "accountSecurity.emails.makePrimary": "Tornar principal",
    "accountSecurity.emails.remove": "Remover",
    "accountSecurity.emails.enterCode": "Digitar código",
    "accountSecurity.emails.addTitle": "Adicionar um endereço de e-mail",
    "accountSecurity.emails.addBody": "Você pode entrar com qualquer um dos seus endereços. Enviaremos um código de 6 dígitos para o novo.",
    "accountSecurity.emails.sendCode": "Enviar código",
    "accountSecurity.emails.verifyTitle": "Digite o código",
    "accountSecurity.emails.verifyBody": [{"type":0,"value":"Enviamos um código de 6 dígitos para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "accountSecurity.emails.removeTitle": [{"type":0,"value":"Remover "},{"type":1,"value":"email"},{"type":0,"value":"?"}],
    "accountSecurity.emails.removeBody": "Você não poderá mais entrar com este endereço.",
    "accountSecurity.emails.primaryTitle": [{"type":0,"value":"Tornar "},{"type":1,"value":"email"},{"type":0,"value":" seu endereço principal?"}],
    "accountSecurity.emails.primaryBody": "Os e-mails de login e da conta irão para lá. Enviaremos ao endereço antigo um link para desfazer.",
    "accountSecurity.password.title": "Senha",
    "accountSecurity.password.on": "Entre com seu e-mail e senha",
    "accountSecurity.password.off": "Não definida. Você entra com um código ou de outro jeito.",
    "accountSecurity.password.set": "Definir senha",
    "accountSecurity.password.change": "Alterar senha",
    "accountSecurity.password.remove": "Remover senha",
    "accountSecurity.password.current": "Senha atual",
    "accountSecurity.password.removeBody": "Você vai entrar com um código por e-mail ou de outro jeito.",
    "accountSecurity.passkeys.title": "Chaves de acesso",
    "accountSecurity.passkeys.body": "Entre com sua digital, rosto ou bloqueio de tela.",
    "accountSecurity.passkeys.add": "Adicionar chave de acesso",
    "accountSecurity.passkeys.unnamed": "Chave de acesso",
    "accountSecurity.passkeys.used": [{"type":0,"value":"Adicionada "},{"type":1,"value":"added"},{"type":0,"value":" · Último uso "},{"type":1,"value":"used"}],
    "accountSecurity.passkeys.unused": [{"type":0,"value":"Adicionada "},{"type":1,"value":"added"},{"type":0,"value":" · Ainda não usada"}],
    "accountSecurity.passkeys.rename": "Renomear",
    "accountSecurity.passkeys.renameTitle": "Renomear chave de acesso",
    "accountSecurity.passkeys.name": "Nome",
    "accountSecurity.passkeys.deleteTitle": "Excluir esta chave de acesso?",
    "accountSecurity.passkeys.deleteBody": "Você não poderá mais entrar com ela. Remova-a também do seu gerenciador de senhas.",
    "accountSecurity.passkeys.cancelled": "A chave de acesso não foi criada.",
    "accountSecurity.twoStep.title": "Verificação em duas etapas",
    "accountSecurity.twoStep.on": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Ativada · App autenticador · "},{"type":7},{"type":0,"value":" código de backup restante"}]},"other":{"value":[{"type":0,"value":"Ativada · App autenticador · "},{"type":7},{"type":0,"value":" códigos de backup restantes"}]}},"offset":0,"pluralType":"cardinal"}],
    "accountSecurity.twoStep.off": "Pedir um código do app autenticador ao entrar.",
    "accountSecurity.twoStep.setUp": "Configurar",
    "accountSecurity.twoStep.turnOff": "Desativar",
    "accountSecurity.twoStep.newCodes": "Novos códigos de backup",
    "accountSecurity.twoStep.setupBody": "Adicione o Bundle ao app autenticador deste celular e digite o código de 6 dígitos que ele mostrar.",
    "accountSecurity.twoStep.openApp": "Abrir app autenticador",
    "accountSecurity.twoStep.copyKey": "Copiar chave de configuração",
    "accountSecurity.twoStep.keyCopied": "Chave de configuração copiada",
    "accountSecurity.twoStep.keyLabel": "Chave de configuração",
    "accountSecurity.twoStep.noApp": "Nenhum app autenticador encontrado. Copie a chave de configuração para um.",
    "accountSecurity.twoStep.backupTitle": "Salve seus códigos de backup",
    "accountSecurity.twoStep.backupBody": "Cada código funciona uma vez se você não puder usar o app autenticador. Eles só aparecem agora.",
    "accountSecurity.twoStep.copyCodes": "Copiar códigos",
    "accountSecurity.twoStep.shareCodes": "Compartilhar",
    "accountSecurity.twoStep.codesCopied": "Códigos de backup copiados",
    "accountSecurity.twoStep.shareTitle": "Códigos de backup do Bundle",
    "accountSecurity.twoStep.done": "Concluir",
    "accountSecurity.twoStep.offTitle": "Desativar a verificação em duas etapas?",
    "accountSecurity.twoStep.offBody": "Para entrar, bastará sua senha, um código por e-mail ou uma conta vinculada.",
    "accountSecurity.stepUp.title": "Confirme que é você",
    "accountSecurity.stepUp.passwordBody": "Digite sua senha atual.",
    "accountSecurity.stepUp.codeBody": [{"type":0,"value":"Enviamos um código de 6 dígitos para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "accountSecurity.stepUp.codeLabel": "Código",
    "accountSecurity.stepUp.confirm": "Confirmar",
    "accountSecurity.sessions.place": [{"type":1,"value":"place"},{"type":0,"value":" · "},{"type":1,"value":"activity"}],
    "accountSecurity.error.wrongPassword": "Essa senha está incorreta.",
    "accountSecurity.error.locked": "Muitas tentativas. Tente de novo em 15 minutos.",
    "accountSecurity.error.invalidCode": "Esse código está incorreto ou expirou.",
    "accountSecurity.error.passwordTooLong": "Use no máximo 128 caracteres.",
    "accountSecurity.error.passwordContainsEmail": "Não use seu endereço de e-mail na senha.",
    "accountSecurity.error.passwordLeaked": "Essa senha apareceu em um vazamento de dados. Escolha outra.",
    "accountSecurity.error.lastMethod": "Esta é sua única forma de entrar. Adicione outra antes.",
    "accountSecurity.error.emailInUse": "Esse endereço pertence a outra conta do Bundle.",
    "accountSecurity.error.signInAgain": "Saia e entre de novo, depois tente outra vez.",
    "accountSecurity.error.failed": "Algo deu errado. Tente de novo.",
    "settings.signIn.emails.title": "Endereços de e-mail",
    "settings.signIn.emails.add": "Adicionar e-mail",
    "settings.signIn.emails.foot": "Um novo endereço recebe um código antes de poder ser usado.",
    "settings.signIn.emails.primary": "Principal",
    "settings.signIn.emails.verified": "Verificado",
    "settings.signIn.emails.pending": "Aguardando código",
    "settings.signIn.emails.primarySub": "Os e-mails de login e da conta vão para cá",
    "settings.signIn.emails.secondarySub": "Também pode entrar",
    "settings.signIn.emails.pendingSub": "Digite o código que enviamos para começar a usá-lo",
    "settings.signIn.emails.verify": "Verificar",
    "settings.signIn.emails.makePrimary": "Tornar principal",
    "settings.signIn.emails.remove": "Remover",
    "settings.signIn.emails.addTitle": "Adicionar um endereço de e-mail",
    "settings.signIn.emails.addBody": "Você também poderá entrar com ele. Vamos enviar um código de 6 dígitos para ele.",
    "settings.signIn.emails.addLabel": "Endereço de e-mail",
    "settings.signIn.emails.sendCode": "Enviar código",
    "settings.signIn.emails.codeTitle": "Confira seu e-mail",
    "settings.signIn.emails.codeBody": [{"type":0,"value":"Enviamos um código de 6 dígitos para "},{"type":1,"value":"email"},{"type":0,"value":". Ele expira em 10 minutos."}],
    "settings.signIn.emails.codeLabel": "Código",
    "settings.signIn.emails.resend": "Enviar outro código",
    "settings.signIn.emails.changeEmail": "Usar outro e-mail",
    "settings.signIn.emails.removeTitle": [{"type":0,"value":"Remover "},{"type":1,"value":"email"},{"type":0,"value":"?"}],
    "settings.signIn.emails.removeBody": "Você não poderá mais entrar com este endereço.",
    "settings.signIn.emails.primaryTitle": [{"type":0,"value":"Tornar "},{"type":1,"value":"email"},{"type":0,"value":" seu endereço principal?"}],
    "settings.signIn.emails.primaryBody": [{"type":0,"value":"Os e-mails de login e da conta irão para "},{"type":1,"value":"email"},{"type":0,"value":". Vamos enviar a "},{"type":1,"value":"old"},{"type":0,"value":" um link para desfazer isso por 7 dias, e "},{"type":1,"value":"old"},{"type":0,"value":" continua podendo entrar."}],
    "settings.signIn.emails.primaryChanged": [{"type":1,"value":"email"},{"type":0,"value":" agora é seu endereço principal. Enviamos a "},{"type":1,"value":"old"},{"type":0,"value":" um link para desfazer isso por 7 dias."}],
    "settings.signIn.methods.title": "Senha e login",
    "settings.signIn.password.label": "Senha",
    "settings.signIn.password.subOn": "Entre com seu e-mail e senha",
    "settings.signIn.password.subOff": "Não definida. Você entra com um código enviado por e-mail.",
    "settings.signIn.password.set": "Definir senha",
    "settings.signIn.password.change": "Alterar senha",
    "settings.signIn.password.remove": "Remover",
    "settings.signIn.password.setTitle": "Definir uma senha",
    "settings.signIn.password.changeTitle": "Alterar sua senha",
    "settings.signIn.password.removeTitle": "Remover sua senha?",
    "settings.signIn.password.removeBody": "Você vai entrar com um código por e-mail, uma chave de acesso ou uma conta vinculada.",
    "settings.signIn.password.new": "Nova senha",
    "settings.signIn.password.save": "Salvar senha",
    "settings.signIn.password.removeConfirm": "Remover senha",
    "settings.signIn.password.signedOut": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"Senha salva. Encerramos a sessão em "},{"type":7},{"type":0,"value":" outro dispositivo."}]},"other":{"value":[{"type":0,"value":"Senha salva. Encerramos a sessão em "},{"type":7},{"type":0,"value":" outros dispositivos."}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.signIn.proof.passwordLabel": "Senha atual",
    "settings.signIn.proof.passwordBody": "Digite sua senha para continuar.",
    "settings.signIn.proof.codeBody": [{"type":0,"value":"Para continuar, vamos enviar um código de 6 dígitos para "},{"type":1,"value":"email"},{"type":0,"value":"."}],
    "settings.signIn.proof.sendCode": "Enviar código por e-mail",
    "settings.signIn.proof.codeSent": [{"type":0,"value":"Enviamos um código de 6 dígitos para "},{"type":1,"value":"email"},{"type":0,"value":". Ele expira em 10 minutos."}],
    "settings.signIn.proof.codeLabel": "Código do seu e-mail",
    "settings.signIn.proof.resend": "Enviar outro código",
    "settings.signIn.continue": "Continuar",
    "settings.signIn.passkeys.label": "Chaves de acesso",
    "settings.signIn.passkeys.sub": "Entre com Face ID, Touch ID ou uma chave de segurança",
    "settings.signIn.passkeys.add": "Adicionar chave de acesso",
    "settings.signIn.passkeys.unnamed": "Chave de acesso",
    "settings.signIn.passkeys.meta": [{"type":0,"value":"Adicionada "},{"type":1,"value":"created"},{"type":0,"value":" · último uso "},{"type":1,"value":"used"}],
    "settings.signIn.passkeys.metaNever": [{"type":0,"value":"Adicionada "},{"type":1,"value":"created"},{"type":0,"value":" · ainda não usada"}],
    "settings.signIn.passkeys.rename": "Renomear",
    "settings.signIn.passkeys.delete": "Excluir",
    "settings.signIn.passkeys.addTitle": "Adicionar uma chave de acesso",
    "settings.signIn.passkeys.addBody": "Seu navegador ou dispositivo vai pedir para confirmar com Face ID, Touch ID, o bloqueio de tela ou uma chave de segurança.",
    "settings.signIn.passkeys.nameLabel": "Nome (opcional)",
    "settings.signIn.passkeys.namePlaceholder": "MacBook Touch ID",
    "settings.signIn.passkeys.renameTitle": "Renomear chave de acesso",
    "settings.signIn.passkeys.renameLabel": "Nome",
    "settings.signIn.passkeys.deleteTitle": "Excluir esta chave de acesso?",
    "settings.signIn.passkeys.deleteBody": [{"type":0,"value":"Você não poderá mais entrar com "},{"type":1,"value":"name"},{"type":0,"value":". Remova-a também do seu gerenciador de senhas."}],
    "settings.signIn.passkeys.only": "É sua única forma de entrar, então não pode ser excluída.",
    "settings.signIn.twoFactor.label": "Verificação em duas etapas",
    "settings.signIn.twoFactor.subOn": [{"type":6,"value":"count","options":{"one":{"value":[{"type":0,"value":"App autenticador · "},{"type":7},{"type":0,"value":" código de backup restante"}]},"other":{"value":[{"type":0,"value":"App autenticador · "},{"type":7},{"type":0,"value":" códigos de backup restantes"}]}},"offset":0,"pluralType":"cardinal"}],
    "settings.signIn.twoFactor.subOff": "Pedir um código de um app autenticador ao entrar",
    "settings.signIn.twoFactor.on": "Ativada",
    "settings.signIn.twoFactor.setUp": "Configurar",
    "settings.signIn.twoFactor.manage": "Gerenciar",
    "settings.signIn.twoFactor.newCodes": "Gerar novos códigos de backup",
    "settings.signIn.twoFactor.turnOff": "Desativar",
    "settings.signIn.twoFactor.setupTitle": "Configurar a verificação em duas etapas",
    "settings.signIn.twoFactor.scanBody": "Escaneie este QR code com um app autenticador, como Google Authenticator, 1Password ou Authy. Depois digite o código de 6 dígitos que ele mostrar.",
    "settings.signIn.twoFactor.qrLabel": "QR code para seu app autenticador",
    "settings.signIn.twoFactor.secretLabel": "Não consegue escanear? Digite esta chave",
    "settings.signIn.twoFactor.copyKey": "Copiar chave",
    "settings.signIn.twoFactor.codeLabel": "Código de 6 dígitos do app",
    "settings.signIn.twoFactor.verify": "Ativar",
    "settings.signIn.twoFactor.codesTitle": "Guarde seus códigos de backup",
    "settings.signIn.twoFactor.codesBody": "Use um quando não conseguir um código do app. Cada código funciona uma vez. Você não vai vê-los de novo.",
    "settings.signIn.twoFactor.copy": "Copiar",
    "settings.signIn.twoFactor.copied": "Copiado",
    "settings.signIn.twoFactor.download": "Baixar",
    "settings.signIn.twoFactor.done": "Concluído",
    "settings.signIn.twoFactor.fileHeading": "Códigos de backup do Bundle. Cada código funciona uma vez.",
    "settings.signIn.twoFactor.newCodesTitle": "Gerar novos códigos de backup",
    "settings.signIn.twoFactor.newCodesBody": "Seus códigos de backup antigos param de funcionar.",
    "settings.signIn.twoFactor.offTitle": "Desativar a verificação em duas etapas?",
    "settings.signIn.twoFactor.offBody": "O login não vai mais pedir um código do app autenticador, e seus códigos de backup param de funcionar.",
    "settings.signIn.error.wrongPassword": "Essa senha está incorreta.",
    "settings.signIn.error.locked": "Muitas tentativas. Tente de novo em 15 minutos.",
    "settings.signIn.error.invalidCode": "Esse código está incorreto ou expirou.",
    "settings.signIn.error.challengeExpired": "Demorou demais. Comece de novo.",
    "settings.signIn.error.passwordTooShort": "Use pelo menos 8 caracteres.",
    "settings.signIn.error.passwordTooLong": "Use no máximo 128 caracteres.",
    "settings.signIn.error.passwordContainsEmail": "Não use seu endereço de e-mail na senha.",
    "settings.signIn.error.passwordTooCommon": "Essa senha é muito comum. Escolha outra.",
    "settings.signIn.error.passwordLeaked": "Essa senha apareceu em um vazamento de dados. Escolha outra.",
    "settings.signIn.error.passwordExists": "Você já tem uma senha.",
    "settings.signIn.error.emailCodeRequired": "Digite o código do seu e-mail.",
    "settings.signIn.error.passwordRequired": "Digite sua senha atual.",
    "settings.signIn.error.lastMethod": "É sua única forma de entrar. Adicione outra antes.",
    "settings.signIn.error.emailInUse": "Esse endereço já é usado por outra conta.",
    "settings.signIn.error.invalidEmail": "Digite um endereço de e-mail válido.",
    "settings.signIn.error.signInAgain": "Por segurança, entre de novo e tente outra vez.",
    "settings.signIn.error.rateLimited": "Tentativas demais. Aguarde alguns minutos e tente de novo.",
    "settings.signIn.error.linkExpired": "Esse link expirou.",
    "account.undoEmail.working": "Restaurando seu e-mail de login…",
    "account.undoEmail.doneTitle": "Seu e-mail foi restaurado",
    "account.undoEmail.doneBody": [{"type":1,"value":"email"},{"type":0,"value":" voltou a ser seu e-mail de login. Encerramos todas as suas sessões, então entre de novo. Se não foi você quem fez a alteração, altere também sua senha."}],
    "account.undoEmail.signIn": "Entrar",
    "account.undoEmail.expiredTitle": "Este link expirou",
    "account.undoEmail.expiredBody": "Links para desfazer funcionam uma vez, por 7 dias. Entre e confira seus endereços de e-mail em Configurações › Conta e login, ou peça ajuda a um admin do workspace.",
    "account.undoEmail.failedTitle": "Não foi possível desfazer a alteração",
    "auth.signup.subtitle": "Comece com seu nome e e-mail de trabalho.",
    "auth.signup.haveAccount": "Já tem uma conta?",
    "auth.signup.newToBundle": "Novo no Bundle?",
    "auth.signup.secureSubtitle": "Opcional. Você sempre pode entrar com um código por e-mail.",
    "phone.verifyTitle": "Verifique seu telefone",
    "phone.verifyBody": "Se um dia você não conseguir acessar seu e-mail, poderá entrar com um código enviado para este número.",
    "phone.requiredTitle": "Adicione um número de telefone",
    "phone.requiredBody": "Seu e-mail está hospedado no Bundle. Se perder o acesso a ele, é pelo telefone que você volta a entrar.",
    "phone.country": "País",
    "phone.number": "Número de telefone",
    "phone.searchCountries": "Pesquisar países",
    "phone.fromGoogle": "Da sua Conta do Google",
    "phone.fromSlack": "Do Slack",
    "phone.importGoogle": "Usar o número da minha Conta do Google",
    "phone.sendCode": "Enviar código",
    "phone.otherNumber": "Usar outro número",
    "phone.skip": "Pular por enquanto",
    "phone.rates": "Podem ser cobradas tarifas de mensagens e dados.",
    "phone.codeTitle": "Digite o código",
    "phone.codeSentTo": [{"type":0,"value":"Enviamos por SMS um código de 6 dígitos para "},{"type":1,"value":"phone"},{"type":0,"value":"."}],
    "phone.calledTo": [{"type":0,"value":"Estamos ligando para "},{"type":1,"value":"phone"},{"type":0,"value":" para ler um código de 6 dígitos."}],
    "phone.codeLabel": "Código",
    "phone.verify": "Verificar",
    "phone.resendIn": [{"type":0,"value":"Reenviar código em "},{"type":1,"value":"time"}],
    "phone.resend": "Reenviar código",
    "phone.callMe": "Receber uma ligação",
    "phone.changeNumber": "Alterar número",
    "phone.cantGetCode": "Não recebeu o código?",
    "phone.textMe": "Receber código por SMS",
    "phone.textMeTo": [{"type":0,"value":"Para "},{"type":1,"value":"phone"}],
    "phone.signInTitle": "Confira seu telefone",
    "phone.signInBody": [{"type":0,"value":"Enviamos por SMS um código de 6 dígitos para "},{"type":1,"value":"phone"},{"type":0,"value":"."}],
    "phone.twoStepNext": "Se a verificação em duas etapas estiver ativada, o código do autenticador vem em seguida.",
    "phone.tryOther": "Tentar de outro jeito",
    "phone.twoStepTextMe": [{"type":0,"value":"Enviar código por SMS para "},{"type":1,"value":"phone"}],
    "phone.settingsRow": "Número de telefone",
    "phone.settingsVerified": "Verificado · permite entrar quando o e-mail não chega",
    "phone.settingsNone": "Adicione um número para entrar quando o e-mail não chegar.",
    "phone.settingsNote": "Para adicionar, alterar ou remover, pedimos sua senha ou um código por e-mail e depois um SMS para o novo número. Avisamos você por e-mail e notificação a cada mudança.",
    "phone.add": "Adicionar",
    "phone.change": "Alterar",
    "phone.remove": "Remover",
    "phone.removeTitle": "Remover seu número de telefone?",
    "phone.removeBody": [{"type":0,"value":"Você não poderá mais entrar com um SMS para "},{"type":1,"value":"phone"},{"type":0,"value":"."}],
    "phone.added": "Número de telefone adicionado",
    "phone.removed": "Número de telefone removido",
    "phone.error.invalidCode": "Esse código não está certo. Confira e tente de novo.",
    "phone.error.tooMany": "Muitas tentativas. Aguarde 15 minutos ou entre com seu e-mail.",
    "phone.error.inUse": "Este número já está em outra conta do Bundle. Use outro número.",
    "phone.error.invalidPhone": "Digite um número de telefone válido.",
    "phone.error.country": "Ainda não enviamos SMS para números desse país.",
    "phone.error.rateLimited": "Muitos códigos. Tente de novo mais tarde.",
    "phone.error.notSent": "Não conseguimos enviar o código. Tente de novo.",
    "phone.error.required": "Seu e-mail está hospedado no Bundle, então sua conta precisa de um número de telefone. Você pode alterá-lo.",
    "phone.error.alreadyUsed": "Você entrou com seu telefone. Use o app autenticador ou um código de backup.",
    "phone.error.usNotReady": "Ainda não é possível enviar SMS para números dos EUA.",
    "phone.error.caNotReady": "Ainda não é possível enviar SMS para números do Canadá.",
    "phone.noSmsTitle": "Não recebeu o SMS?",
    "phone.noSmsBody": [{"type":0,"value":"Pode levar um minuto. Você pode reenviar em "},{"type":1,"value":"time"},{"type":0,"value":" ou receber o código por ligação."}],
    "phone.call": "Receber ligação",
  },
};
